"use client";
var U8 = Object.defineProperty;
var lP = (e) => {
  throw TypeError(e);
};
var K8 = (e, t, n) => t in e ? U8(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var fa = (e, t, n) => K8(e, typeof t != "symbol" ? t + "" : t, n), cP = (e, t, n) => t.has(e) || lP("Cannot " + n);
var $r = (e, t, n) => (cP(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Bv = (e, t, n) => t.has(e) ? lP("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), as = (e, t, n, r) => (cP(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import { jsxs as me, jsx as E, Fragment as Ut } from "react/jsx-runtime";
import * as ee from "react";
import I, { forwardRef as $t, Fragment as fi, useMemo as Le, useState as Me, useCallback as Je, isValidElement as ut, createElement as Yl, useLayoutEffect as $i, useEffect as Qe, useRef as ft, cloneElement as _t, createContext as ht, useContext as Ve, useId as Vw, Component as Uw, useInsertionEffect as I$, Children as tr, memo as H8, Suspense as G8, PureComponent as hi, useImperativeHandle as Y8 } from "react";
import * as R$ from "react-dom";
import { flushSync as j$, createPortal as Kw } from "react-dom";
import { c as _o, g as Et } from "./_commonjsHelpers-DaMA6jEr.js";
const Hw = "-", q8 = (e) => {
  const t = Z8(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(Hw);
      return s[0] === "" && s.length !== 1 && s.shift(), L$(s, t) || X8(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = n[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, L$ = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? L$(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(Hw);
  return (a = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : a.classGroupId;
}, uP = /^\[(.+)\]$/, X8 = (e) => {
  if (uP.test(e)) {
    const t = uP.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Z8 = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Q8(Object.entries(e.classGroups), n).forEach(([o, a]) => {
    a0(a, r, o, t);
  }), r;
}, a0 = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : fP(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (J8(i)) {
        a0(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, a]) => {
      a0(a, fP(t, o), n, r);
    });
  });
}, fP = (e, t) => {
  let n = e;
  return t.split(Hw).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, J8 = (e) => e.isThemeGetter, Q8 = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, s]) => [t + a, s])) : o);
  return [n, i];
}) : e, eK = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, a) => {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let a = n.get(o);
      if (a !== void 0)
        return a;
      if ((a = r.get(o)) !== void 0)
        return i(o, a), a;
    },
    set(o, a) {
      n.has(o) ? n.set(o, a) : i(o, a);
    }
  };
}, B$ = "!", tK = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length, a = (s) => {
    const l = [];
    let c = 0, f = 0, d;
    for (let y = 0; y < s.length; y++) {
      let x = s[y];
      if (c === 0) {
        if (x === i && (r || s.slice(y, y + o) === t)) {
          l.push(s.slice(f, y)), f = y + o;
          continue;
        }
        if (x === "/") {
          d = y;
          continue;
        }
      }
      x === "[" ? c++ : x === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(f), m = p.startsWith(B$), g = m ? p.substring(1) : p, v = d && d > f ? d - f : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: g,
      maybePostfixModifierPosition: v
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: a
  }) : a;
}, nK = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, rK = (e) => ({
  cache: eK(e.cacheSize),
  parseClassName: tK(e),
  ...q8(e)
}), iK = /\s+/, oK = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = [], a = e.trim().split(iK);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: f,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: m
    } = n(c);
    let g = !!m, v = r(g ? p.substring(0, m) : p);
    if (!v) {
      if (!g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (v = r(p), !v) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const y = nK(f).join(":"), x = d ? y + B$ : y, w = x + v;
    if (o.includes(w))
      continue;
    o.push(w);
    const S = i(v, g);
    for (let A = 0; A < S.length; ++A) {
      const _ = S[A];
      o.push(x + _);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function aK() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = F$(t)) && (r && (r += " "), r += n);
  return r;
}
const F$ = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = F$(e[r])) && (n && (n += " "), n += t);
  return n;
};
function sK(e, ...t) {
  let n, r, i, o = a;
  function a(l) {
    const c = t.reduce((f, d) => d(f), e());
    return n = rK(c), r = n.cache.get, i = n.cache.set, o = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const f = oK(l, n);
    return i(l, f), f;
  }
  return function() {
    return o(aK.apply(null, arguments));
  };
}
const Wt = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, W$ = /^\[(?:([a-z-]+):)?(.+)\]$/i, lK = /^\d+\/\d+$/, cK = /* @__PURE__ */ new Set(["px", "full", "screen"]), uK = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, fK = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, dK = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, hK = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, pK = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, yo = (e) => Fl(e) || cK.has(e) || lK.test(e), da = (e) => kc(e, "length", _K), Fl = (e) => !!e && !Number.isNaN(Number(e)), Fv = (e) => kc(e, "number", Fl), yu = (e) => !!e && Number.isInteger(Number(e)), mK = (e) => e.endsWith("%") && Fl(e.slice(0, -1)), Xe = (e) => W$.test(e), ha = (e) => uK.test(e), gK = /* @__PURE__ */ new Set(["length", "size", "percentage"]), yK = (e) => kc(e, gK, z$), vK = (e) => kc(e, "position", z$), bK = /* @__PURE__ */ new Set(["image", "url"]), xK = (e) => kc(e, bK, OK), wK = (e) => kc(e, "", SK), vu = () => !0, kc = (e, t, n) => {
  const r = W$.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, _K = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  fK.test(e) && !dK.test(e)
), z$ = () => !1, SK = (e) => hK.test(e), OK = (e) => pK.test(e), AK = () => {
  const e = Wt("colors"), t = Wt("spacing"), n = Wt("blur"), r = Wt("brightness"), i = Wt("borderColor"), o = Wt("borderRadius"), a = Wt("borderSpacing"), s = Wt("borderWidth"), l = Wt("contrast"), c = Wt("grayscale"), f = Wt("hueRotate"), d = Wt("invert"), p = Wt("gap"), m = Wt("gradientColorStops"), g = Wt("gradientColorStopPositions"), v = Wt("inset"), y = Wt("margin"), x = Wt("opacity"), w = Wt("padding"), S = Wt("saturate"), A = Wt("scale"), _ = Wt("sepia"), O = Wt("skew"), T = Wt("space"), C = Wt("translate"), k = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], N = () => ["auto", Xe, t], $ = () => [Xe, t], B = () => ["", yo, da], L = () => ["auto", Fl, Xe], F = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], W = () => ["solid", "dashed", "dotted", "double", "none"], z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], V = () => ["", "0", Xe], U = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Y = () => [Fl, Xe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [vu],
      spacing: [yo, da],
      blur: ["none", "", ha, Xe],
      brightness: Y(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ha, Xe],
      borderSpacing: $(),
      borderWidth: B(),
      contrast: Y(),
      grayscale: V(),
      hueRotate: Y(),
      invert: V(),
      gap: $(),
      gradientColorStops: [e],
      gradientColorStopPositions: [mK, da],
      inset: N(),
      margin: N(),
      opacity: Y(),
      padding: $(),
      saturate: Y(),
      scale: Y(),
      sepia: V(),
      skew: Y(),
      space: $(),
      translate: $()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Xe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ha]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": U()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": U()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...F(), Xe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: k()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": k()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": k()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", yu, Xe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: N()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Xe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: V()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: V()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", yu, Xe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [vu]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", yu, Xe]
        }, Xe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": L()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": L()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [vu]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [yu, Xe]
        }, Xe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": L()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": L()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Xe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Xe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...G()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...G(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [T]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [T]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Xe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Xe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Xe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [ha]
        }, ha]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Xe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Xe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Xe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Xe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ha, da]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Fv]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [vu]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Xe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Fl, Fv]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", yo, Xe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Xe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Xe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [x]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [x]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...W(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", yo, da]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", yo, Xe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: $()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Xe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Xe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [x]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...F(), vK]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", yK]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, xK]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [x]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...W(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [x]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: W()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...W()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [yo, Xe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [yo, da]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: B()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [x]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [yo, da]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ha, wK]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [vu]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [x]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ha, Xe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [x]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Xe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Y()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Xe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Y()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Xe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [A]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [A]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [A]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [yu, Xe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [C]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [C]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Xe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Xe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": $()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": $()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": $()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": $()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": $()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": $()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": $()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": $()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": $()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": $()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": $()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": $()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": $()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": $()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": $()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": $()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": $()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": $()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Xe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [yo, da, Fv]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, PK = /* @__PURE__ */ sK(AK);
function V$(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = V$(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Ye() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = V$(e)) && (r && (r += " "), r += t);
  return r;
}
const H = (...e) => PK(Ye(...e)), sf = (...e) => (...t) => e.forEach((n) => n == null ? void 0 : n(...t)), Xm = (e) => {
  const t = {
    0: "gap-0",
    xxs: "gap-1",
    xs: "gap-2",
    sm: "gap-3",
    md: "gap-4",
    lg: "gap-5",
    xl: "gap-6",
    "2xl": "gap-8"
  };
  return t[e] || t.md;
}, TK = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  7: "grid-cols-7",
  8: "grid-cols-8",
  9: "grid-cols-9",
  10: "grid-cols-10",
  11: "grid-cols-11",
  12: "grid-cols-12"
}, CK = () => {
  var i, o;
  const e = ((o = (i = window.navigator) == null ? void 0 : i.userAgentData) == null ? void 0 : o.platform) || window.navigator.platform, t = [
    "macOS",
    "Macintosh",
    "MacIntel",
    "MacPPC",
    "Mac68K"
  ], n = ["Win32", "Win64", "Windows", "WinCE"];
  let r = "null";
  return t.includes(e) ? r = "Mac OS" : n.includes(e) && (r = "Windows"), r;
}, EK = (e) => e < 1024 ? `${e} bytes` : e < 1024 * 1024 ? `${(e / 1024).toFixed(2)} KB` : e < 1024 * 1024 * 1024 ? `${(e / (1024 * 1024)).toFixed(2)} MB` : `${(e / (1024 * 1024 * 1024)).toFixed(2)} GB`, Iu = {
  set: (e, t) => {
    if (!(typeof window > "u"))
      try {
        localStorage.setItem(e, JSON.stringify(t));
      } catch (n) {
        console.error(n);
      }
  },
  get: (e) => {
    if (typeof window > "u")
      return null;
    try {
      const t = localStorage.getItem(e);
      return t ? JSON.parse(t) : null;
    } catch (t) {
      return console.error(t), null;
    }
  },
  remove: (e) => {
    if (!(typeof window > "u"))
      try {
        localStorage.removeItem(e);
      } catch (t) {
        console.error(t);
      }
  }
}, Qn = $t(
  (e, t) => {
    const {
      variant: n = "primary",
      // primary, secondary, outline, ghost, link
      size: r = "md",
      // xs, sm, md, lg
      type: i = "button",
      tag: o = "button",
      className: a,
      children: s,
      disabled: l = !1,
      destructive: c = !1,
      // true, false
      icon: f = null,
      // icon component
      iconPosition: d = "left",
      // left, right,
      loading: p = !1,
      ...m
    } = e, g = "outline outline-1 border-none cursor-pointer transition-colors duration-300 ease-in-out text-xs font-semibold focus:ring-2 focus:ring-toggle-on focus:ring-offset-2 disabled:text-text-disabled", v = p ? "opacity-50 disabled:cursor-not-allowed" : "", y = {
      primary: "text-text-on-color bg-button-primary hover:bg-button-primary-hover outline-button-primary hover:outline-button-primary-hover disabled:bg-button-disabled disabled:outline-button-disabled",
      secondary: "text-text-on-color bg-button-secondary hover:bg-button-secondary-hover outline-button-secondary hover:outline-button-secondary-hover disabled:bg-button-disabled disabled:outline-button-disabled",
      outline: "text-button-tertiary-color outline-border-subtle bg-button-tertiary hover:bg-button-tertiary-hover hover:outline-border-subtle disabled:bg-button-tertiary disabled:outline-border-disabled",
      ghost: "text-text-primary bg-transparent outline-transparent hover:bg-button-tertiary-hover",
      link: "outline-none text-link-primary bg-transparent hover:text-link-primary-hover hover:underline p-0 border-0 leading-none"
    }[n], x = c && !l ? {
      primary: "bg-button-danger hover:bg-button-danger-hover outline-button-danger hover:outline-button-danger-hover",
      secondary: "bg-button-danger hover:bg-button-danger-hover outline-button-danger hover:outline-button-danger-hover",
      outline: "text-button-danger outline outline-1 outline-button-danger hover:outline-button-danger bg-button-tertiary hover:bg-field-background-error",
      ghost: "text-button-danger hover:bg-field-background-error",
      link: "text-button-danger hover:text-button-danger-secondary"
    }[n] : "", w = {
      xs: "p-1 rounded [&>svg]:size-4",
      sm: "p-2 rounded [&>svg]:size-4 gap-0.5",
      md: "p-2.5 rounded-md text-sm [&>svg]:size-5 gap-1",
      lg: "p-3 rounded-lg text-base [&>svg]:size-6 gap-1"
    }[r];
    let S, A = null, _ = "";
    return f && (_ = "flex items-center justify-center", d === "left" ? S = f : A = f), /* @__PURE__ */ me(
      o,
      {
        ref: t,
        type: i,
        className: H(
          _,
          g,
          w,
          y,
          x,
          v,
          {
            "cursor-default": l
          },
          a
        ),
        disabled: l,
        ...m,
        children: [
          /* @__PURE__ */ E(fi, { children: S }, "left-icon"),
          s ? /* @__PURE__ */ E("span", { className: "px-1", children: s }) : null,
          /* @__PURE__ */ E(fi, { children: A }, "right-icon")
        ]
      }
    );
  }
);
Qn.displayName = "Button";
const kK = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let no = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e));
  for (; e--; )
    t += kK[n[e] & 63];
  return t;
};
const Ma = $t(
  ({
    children: e = null,
    tag: t = "label",
    size: n = "sm",
    // xs, sm, md
    className: r = "",
    variant: i = "neutral",
    // neutral, help, error, disabled
    required: o = !1,
    ...a
  }, s) => {
    const l = "font-medium text-field-label flex items-center gap-0.5", c = {
      xs: "text-xs [&>*]:text-xs [&>svg]:h-3 [&>svg]:w-3",
      sm: "text-sm [&>*]:text-sm [&>svg]:h-4 [&>svg]:w-4",
      md: "text-base [&>*]:text-base [&>svg]:h-5 [&>svg]:w-5"
    }, f = {
      neutral: "text-field-label [&>*]:text-field-label",
      help: "text-field-helper [&>*]:text-field-helper",
      error: "text-support-error [&>*]:text-support-error",
      disabled: "text-field-color-disabled disabled cursor-not-allowed [&>*]:text-field-color-disabled"
    };
    if (!e)
      return null;
    let d = "";
    return o && (d = "after:content-['*'] after:text-field-required after:ml-0.5"), /* @__PURE__ */ E(
      t,
      {
        ref: s,
        className: H(
          l,
          c[n],
          f[i],
          d,
          r
        ),
        ...a,
        children: e
      }
    );
  }
);
Ma.displayName = "Label";
const MK = ({
  label: e,
  switchId: t,
  disabled: n = !1,
  children: r,
  size: i
}) => {
  const o = {
    sm: "text-sm leading-5 font-medium",
    md: "text-base leading-6 font-medium"
  }, a = {
    sm: "text-xs leading-4 font-normal",
    md: "text-sm leading-5 font-normal"
  }, s = {
    sm: "space-y-0.5",
    md: "space-y-1"
  };
  if (ut(e))
    return /* @__PURE__ */ me(
      "div",
      {
        className: H("inline-flex items-center gap-3", "items-start"),
        children: [
          r,
          e
        ]
      }
    );
  const c = () => {
    const { heading: p = "", description: m = "" } = e || {};
    return /* @__PURE__ */ me("div", { className: H("space-y-0.5", s[i]), children: [
      p && /* @__PURE__ */ E(
        Ma,
        {
          tag: "p",
          className: H("m-0", o[i]),
          ...n && { variant: "disabled" },
          children: p
        }
      ),
      m && /* @__PURE__ */ E(
        Ma,
        {
          tag: "p",
          variant: "help",
          className: H(
            "text-xs font-normal leading-5 m-0",
            a[i]
          ),
          ...n && { variant: "disabled" },
          children: m
        }
      )
    ] });
  }, f = !(e != null && e.heading) && !(e != null && e.description), d = !(e != null && e.heading) || !(e != null && e.description) ? "items-center" : "items-start";
  return f ? r : /* @__PURE__ */ me("div", { className: H("inline-flex", d, "gap-3"), children: [
    r,
    /* @__PURE__ */ E(
      "label",
      {
        htmlFor: t,
        className: H(!n && "cursor-pointer"),
        children: c()
      }
    )
  ] });
}, NK = ({
  id: e,
  onChange: t,
  value: n,
  defaultValue: r = !1,
  size: i = "sm",
  disabled: o = !1,
  label: a = { heading: "", description: "" },
  name: s,
  className: l,
  ...c
}, f) => {
  const d = i === "lg" ? "md" : i, p = Le(() => typeof n < "u", [n]), m = Le(() => e || `switch-${no()}`, []), [g, v] = Me(r), y = "primary", x = Je(
    () => p ? n : g,
    [p, n, g]
  ), w = (C) => {
    if (o)
      return;
    const k = C.target.checked;
    p || v(k), typeof t == "function" && t(k);
  }, S = {
    primary: {
      input: "bg-toggle-off checked:bg-toggle-on focus:ring focus:ring-toggle-on focus:ring-offset-4 border border-solid border-toggle-off-border checked:border-toggle-on-border shadow-toggleContainer focus:outline-none checked:focus:border-toggle-on-border focus:border-toggle-off-border",
      toggleDial: "bg-toggle-dial-background shadow-toggleDial"
    }
  }, A = {
    primary: {
      input: "group-hover/switch:bg-toggle-off-hover checked:group-hover/switch:bg-toggle-on-hover checked:group-hover/switch:border-toggle-on-border"
    }
  }, _ = {
    md: {
      container: "w-11 h-6",
      toggleDial: "size-4 peer-checked:translate-x-5"
    },
    sm: {
      container: "w-10 h-5",
      toggleDial: "size-3 peer-checked:translate-x-5"
    }
  }, O = {
    md: "group-hover/switch:size-5 group-focus-within/switch:size-5 group-focus-within/switch:left-0.5 group-hover/switch:left-0.5",
    sm: "group-hover/switch:size-4 group-focus-within/switch:size-4 group-focus-within/switch:left-0.5 group-hover/switch:left-0.5"
  }, T = {
    input: "bg-toggle-off-disabled disabled:border-transparent shadow-none disabled:cursor-not-allowed checked:disabled:bg-toggle-on-disabled",
    toggleDial: "peer-disabled:cursor-not-allowed"
  };
  return /* @__PURE__ */ E(
    MK,
    {
      label: a,
      switchId: m,
      disabled: o,
      size: d,
      children: /* @__PURE__ */ me(
        "div",
        {
          className: H(
            "relative group/switch inline-block cursor-pointer rounded-full shrink-0",
            _[d].container,
            l
          ),
          children: [
            /* @__PURE__ */ E(
              "input",
              {
                ref: f,
                id: m,
                type: "checkbox",
                className: H(
                  "peer appearance-none absolute rounded-full cursor-pointer transition-colors duration-300 h-full w-full  before:content-[''] checked:before:content-[''] m-0 checked:[background-image:none]",
                  S[y].input,
                  o && T.input,
                  !o && A[y].input
                ),
                checked: x(),
                onChange: w,
                disabled: o,
                name: s,
                ...c
              }
            ),
            /* @__PURE__ */ E(
              "label",
              {
                htmlFor: m,
                className: H(
                  "peer/toggle-dial bg-white border rounded-full absolute cursor-pointer shadow-md before:content[''] before:transition-opacity before:opacity-0 hover:before:opacity-10 before:hidden border-none transition-all duration-300 top-2/4 left-1 -translate-y-2/4 before:w-10 before:h-10 before:rounded-full before:absolute before:top-2/4 before:left-2/4 before:-translate-y-2/4 before:-translate-x-2/4",
                  _[d].toggleDial,
                  S[y].toggleDial,
                  o && T.toggleDial,
                  !o && O[d]
                )
              }
            )
          ]
        }
      )
    }
  );
}, U$ = $t(NK);
U$.displayName = "Switch";
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $K = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), K$ = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var DK = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IK = $t(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: o,
    iconNode: a,
    ...s
  }, l) => Yl(
    "svg",
    {
      ref: l,
      ...DK,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: K$("lucide", i),
      ...s
    },
    [
      ...a.map(([c, f]) => Yl(c, f)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rn = (e, t) => {
  const n = $t(
    ({ className: r, ...i }, o) => Yl(IK, {
      ref: o,
      iconNode: t,
      className: K$(`lucide-${$K(e)}`, r),
      ...i
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const od = rn("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gw = rn("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H$ = rn("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yw = rn("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RK = rn("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jK = rn("CloudUpload", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m16 16-4-4-4 4", key: "119tzi" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LK = rn("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BK = rn("File", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FK = rn("ImageOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s0 = rn("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WK = rn("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G$ = rn("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zK = rn("PanelLeftClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VK = rn("PanelLeftOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y$ = rn("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q$ = rn("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UK = rn("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KK = rn("Trash", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HK = rn("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dP = rn("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GK = rn("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Na = rn("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), YK = ({
  id: e,
  label: t,
  defaultChecked: n = !1,
  checked: r,
  onChange: i,
  indeterminate: o,
  disabled: a,
  size: s = "md",
  className: l,
  ...c
}, f) => {
  var O, T;
  const d = Le(() => e || `checkbox-${no()}`, [e]), p = Le(
    () => typeof r < "u",
    [r]
  ), [m, g] = Me(n || !1), v = "primary", y = {
    sm: {
      checkbox: "size-4 rounded gap-1",
      icon: "size-3",
      text: "text-sm",
      // text class for sm
      description: "text-xs",
      gap: "gap-0.5"
    },
    md: {
      checkbox: "size-5 rounded gap-1",
      icon: "size-4",
      text: "text-base",
      // text class for md
      description: "text-sm",
      gap: "gap-1"
    }
  }, x = {
    primary: {
      checkbox: "border-border-strong hover:border-border-interactive checked:border-border-interactive bg-white checked:bg-toggle-on checked:hover:bg-toggle-on-hover checked:hover:border-toggle-on-hover focus:ring-2 focus:ring-offset-4 focus:ring-focus",
      icon: "text-white"
    }
  }, w = {
    checkbox: "cursor-not-allowed disabled:bg-white checked:disabled:bg-white disabled:border-border-disabled checked:disabled:border-border-disabled",
    icon: "cursor-not-allowed peer-disabled:text-border-disabled"
  }, S = Je(
    () => p ? r : m,
    [p, r, m]
  ), A = (C) => {
    if (a)
      return;
    const k = C.target.checked;
    p || g(k), typeof i == "function" && i(k);
  }, _ = Je(() => ut(t) ? t : !(t != null && t.heading) && !(t != null && t.description) ? null : /* @__PURE__ */ me("div", { className: y[s].gap, children: [
    (t == null ? void 0 : t.heading) && /* @__PURE__ */ E(
      "p",
      {
        className: H(
          "text-text-primary font-medium leading-4 m-0",
          y[s].text,
          y[s].gap,
          a && "text-text-disabled"
        ),
        children: t == null ? void 0 : t.heading
      }
    ),
    (t == null ? void 0 : t.description) && /* @__PURE__ */ E(
      "p",
      {
        className: H(
          "text-text-secondary font-normal leading-5 m-0",
          y[s].description,
          a && "text-text-disabled"
        ),
        children: t == null ? void 0 : t.description
      }
    )
  ] }), [t, s, a]);
  return /* @__PURE__ */ me(
    "div",
    {
      className: H(
        "inline-flex items-center justify-center gap-2",
        !!t && "items-start",
        a && "cursor-not-allowed"
      ),
      children: [
        /* @__PURE__ */ me(
          "label",
          {
            className: H(
              "relative flex items-center justify-center rounded-full p-0.5",
              !a && "cursor-pointer"
            ),
            htmlFor: d,
            children: [
              /* @__PURE__ */ E(
                "input",
                {
                  ref: f,
                  id: d,
                  type: "checkbox",
                  className: H(
                    "peer relative cursor-pointer appearance-none transition-all m-0 before:content-[''] checked:before:content-[''] checked:before:hidden before:hidden !border-1.5 border-solid",
                    x[v].checkbox,
                    y[s].checkbox,
                    a && w.checkbox,
                    l
                  ),
                  checked: S(),
                  onChange: A,
                  disabled: a,
                  ...c
                }
              ),
              /* @__PURE__ */ E(
                "span",
                {
                  className: H(
                    "pointer-events-none inline-flex items-center absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100",
                    x[v].icon,
                    a && w.icon
                  ),
                  children: o ? /* @__PURE__ */ E(G$, { className: H((O = y[s]) == null ? void 0 : O.icon) }) : /* @__PURE__ */ E(od, { className: H((T = y[s]) == null ? void 0 : T.icon) })
                }
              )
            ]
          }
        ),
        !!t && /* @__PURE__ */ E(
          "label",
          {
            className: H(
              "cursor-pointer",
              a && "cursor-not-allowed"
            ),
            htmlFor: d,
            children: _()
          }
        )
      ]
    }
  );
}, qw = $t(YK);
qw.displayName = "Checkbox";
const hP = {
  primary: {
    checkbox: "border-border-strong hover:border-border-interactive checked:border-border-interactive bg-white checked:bg-toggle-on checked:hover:bg-toggle-on-hover checked:hover:border-toggle-on-hover focus:ring-2 focus:ring-offset-4 focus:ring-focus",
    icon: "text-white"
  }
}, pP = {
  checkbox: "disabled:bg-white checked:disabled:bg-white disabled:border-border-disabled checked:disabled:border-border-disabled cursor-not-allowed",
  icon: "peer-disabled:text-border-disabled cursor-not-allowed"
}, qK = {
  sm: "text-sm leading-5",
  md: "text-base leading-6"
}, Wv = {
  sm: {
    checkbox: "size-4",
    icon: "size-1.5",
    info: "size-4"
  },
  md: {
    checkbox: "size-5",
    icon: "size-2",
    info: "size-5"
  }
}, mP = {
  sm: {
    switch: "mt-1",
    radio: "mt-0.5"
  },
  md: {
    switch: "mt-0.5",
    radio: "mt-px"
  }
}, XK = {
  xs: "py-1 px-1 text-sm gap-0.5 [&>svg]:size-4",
  sm: "py-1 px-1.5 text-base gap-1 [&>svg]:size-4",
  md: "py-2 px-2.5 text-base gap-1 [&>svg]:size-5",
  lg: "py-2.5 px-3 text-base gap-1 [&>svg]:size-6"
}, ZK = "border-0 border-r border-border-subtle border-solid", JK = "bg-background-primary text-primary cursor-pointer flex items-center justify-center", QK = "hover:bg-button-tertiary-hover", eH = "focus:outline-none";
function Zm() {
  return typeof window < "u";
}
function za(e) {
  return X$(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Sr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ro(e) {
  var t;
  return (t = (X$(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function X$(e) {
  return Zm() ? e instanceof Node || e instanceof Sr(e).Node : !1;
}
function Ct(e) {
  return Zm() ? e instanceof Element || e instanceof Sr(e).Element : !1;
}
function hn(e) {
  return Zm() ? e instanceof HTMLElement || e instanceof Sr(e).HTMLElement : !1;
}
function l0(e) {
  return !Zm() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Sr(e).ShadowRoot;
}
function ad(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = Vr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function tH(e) {
  return ["table", "td", "th"].includes(za(e));
}
function Jm(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Xw(e) {
  const t = Qm(), n = Ct(e) ? Vr(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function nH(e) {
  let t = Lo(e);
  for (; hn(t) && !$a(t); ) {
    if (Xw(t))
      return t;
    if (Jm(t))
      return null;
    t = Lo(t);
  }
  return null;
}
function Qm() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function $a(e) {
  return ["html", "body", "#document"].includes(za(e));
}
function Vr(e) {
  return Sr(e).getComputedStyle(e);
}
function eg(e) {
  return Ct(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Lo(e) {
  if (za(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    l0(e) && e.host || // Fallback.
    ro(e)
  );
  return l0(t) ? t.host : t;
}
function Z$(e) {
  const t = Lo(e);
  return $a(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : hn(t) && ad(t) ? t : Z$(t);
}
function Pa(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Z$(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Sr(i);
  if (o) {
    const s = c0(a);
    return t.concat(a, a.visualViewport || [], ad(i) ? i : [], s && n ? Pa(s) : []);
  }
  return t.concat(i, Pa(i, [], n));
}
function c0(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ai(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function dn(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && l0(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function J$() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Q$() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function eD(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : u0() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Zw(e) {
  return rH() ? !1 : !u0() && e.width === 0 && e.height === 0 || u0() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Jw() {
  return /apple/i.test(navigator.vendor);
}
function u0() {
  const e = /android/i;
  return e.test(J$()) || e.test(Q$());
}
function tD() {
  return J$().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function rH() {
  return Q$().includes("jsdom/");
}
function lf(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function iH(e) {
  return "nativeEvent" in e;
}
function oH(e) {
  return e.matches("html,body");
}
function Vn(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function zv(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function So(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const aH = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Qw(e) {
  return hn(e) && e.matches(aH);
}
function zn(e) {
  e.preventDefault(), e.stopPropagation();
}
function f0(e) {
  return e ? e.getAttribute("role") === "combobox" && Qw(e) : !1;
}
const Da = Math.min, Lr = Math.max, up = Math.round, Cl = Math.floor, Ki = (e) => ({
  x: e,
  y: e
}), sH = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lH = {
  start: "end",
  end: "start"
};
function d0(e, t, n) {
  return Lr(e, Da(t, n));
}
function Mc(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ia(e) {
  return e.split("-")[0];
}
function Nc(e) {
  return e.split("-")[1];
}
function nD(e) {
  return e === "x" ? "y" : "x";
}
function e1(e) {
  return e === "y" ? "height" : "width";
}
function Ds(e) {
  return ["top", "bottom"].includes(Ia(e)) ? "y" : "x";
}
function t1(e) {
  return nD(Ds(e));
}
function cH(e, t, n) {
  n === void 0 && (n = !1);
  const r = Nc(e), i = t1(e), o = e1(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = fp(a)), [a, fp(a)];
}
function uH(e) {
  const t = fp(e);
  return [h0(e), t, h0(t)];
}
function h0(e) {
  return e.replace(/start|end/g, (t) => lH[t]);
}
function fH(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function dH(e, t, n, r) {
  const i = Nc(e);
  let o = fH(Ia(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(h0)))), o;
}
function fp(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sH[t]);
}
function hH(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function rD(e) {
  return typeof e != "number" ? hH(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function dp(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var pH = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], hp = /* @__PURE__ */ pH.join(","), iD = typeof Element > "u", ql = iD ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, pp = !iD && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, mp = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), o = i === "" || i === "true", a = o || n && t && e(t.parentNode);
  return a;
}, mH = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, gH = function(t, n, r) {
  if (mp(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(hp));
  return n && ql.call(t, hp) && i.unshift(t), i = i.filter(r), i;
}, yH = function e(t, n, r) {
  for (var i = [], o = Array.from(t); o.length; ) {
    var a = o.shift();
    if (!mp(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = e(l, !0, r);
        r.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var f = ql.call(a, hp);
        f && r.filter(a) && (n || !t.includes(a)) && i.push(a);
        var d = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), p = !mp(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (d && p) {
          var m = e(d === !0 ? a.children : d.children, !0, r);
          r.flatten ? i.push.apply(i, m) : i.push({
            scopeParent: a,
            candidates: m
          });
        } else
          o.unshift.apply(o, a.children);
      }
  }
  return i;
}, oD = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, aD = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || mH(t)) && !oD(t) ? 0 : t.tabIndex;
}, vH = function(t, n) {
  var r = aD(t);
  return r < 0 && n && !oD(t) ? 0 : r;
}, bH = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, sD = function(t) {
  return t.tagName === "INPUT";
}, xH = function(t) {
  return sD(t) && t.type === "hidden";
}, wH = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, _H = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, SH = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || pp(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var o = _H(i, t.form);
  return !o || o === t;
}, OH = function(t) {
  return sD(t) && t.type === "radio";
}, AH = function(t) {
  return OH(t) && !SH(t);
}, PH = function(t) {
  var n, r = t && pp(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (r && r !== t) {
    var a, s, l;
    for (o = !!((a = i) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !o && i; ) {
      var c, f, d;
      r = pp(i), i = (c = r) === null || c === void 0 ? void 0 : c.host, o = !!((f = i) !== null && f !== void 0 && (d = f.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return o;
}, gP = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, TH = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var o = ql.call(t, "details>summary:first-of-type"), a = o ? t.parentElement : t;
  if (ql.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = pp(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return gP(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (PH(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return gP(t);
  return !1;
}, CH = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return ql.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, EH = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  mp(n) || xH(n) || TH(n, t) || // For a details element with a summary, the summary element gets the focus
  wH(n) || CH(n));
}, p0 = function(t, n) {
  return !(AH(n) || aD(n) < 0 || !EH(t, n));
}, kH = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, MH = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, o) {
    var a = !!i.scopeParent, s = a ? i.scopeParent : i, l = vH(s, a), c = a ? e(i.candidates) : s;
    l === 0 ? a ? n.push.apply(n, c) : n.push(s) : r.push({
      documentOrder: o,
      tabIndex: l,
      item: i,
      isScope: a,
      content: c
    });
  }), r.sort(bH).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, tg = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = yH([t], n.includeContainer, {
    filter: p0.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: kH
  }) : r = gH(t, n.includeContainer, p0.bind(null, n)), MH(r);
}, NH = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ql.call(t, hp) === !1 ? !1 : p0(n, t);
};
function yP(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = Ds(t), a = t1(t), s = e1(a), l = Ia(t), c = o === "y", f = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, p = r[s] / 2 - i[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: f,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Nc(t)) {
    case "start":
      m[a] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      m[a] += p * (n && c ? -1 : 1);
      break;
  }
  return m;
}
const $H = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: f,
    y: d
  } = yP(c, r, l), p = r, m = {}, g = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: y,
      fn: x
    } = s[v], {
      x: w,
      y: S,
      data: A,
      reset: _
    } = await x({
      x: f,
      y: d,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: m,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = w ?? f, d = S ?? d, m = {
      ...m,
      [y]: {
        ...m[y],
        ...A
      }
    }, _ && g <= 50 && (g++, typeof _ == "object" && (_.placement && (p = _.placement), _.rects && (c = _.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : _.rects), {
      x: f,
      y: d
    } = yP(c, p, l)), v = -1);
  }
  return {
    x: f,
    y: d,
    placement: p,
    strategy: i,
    middlewareData: m
  };
};
async function n1(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = Mc(t, e), g = rD(m), y = s[p ? d === "floating" ? "reference" : "floating" : d], x = dp(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(y))) == null || n ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: l
  })), w = d === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), A = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = dp(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: S,
    strategy: l
  }) : w);
  return {
    top: (x.top - _.top + g.top) / A.y,
    bottom: (_.bottom - x.bottom + g.bottom) / A.y,
    left: (x.left - _.left + g.left) / A.x,
    right: (_.right - x.right + g.right) / A.x
  };
}
const DH = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: f = 0
    } = Mc(e, t) || {};
    if (c == null)
      return {};
    const d = rD(f), p = {
      x: n,
      y: r
    }, m = t1(i), g = e1(m), v = await a.getDimensions(c), y = m === "y", x = y ? "top" : "left", w = y ? "bottom" : "right", S = y ? "clientHeight" : "clientWidth", A = o.reference[g] + o.reference[m] - p[m] - o.floating[g], _ = p[m] - o.reference[m], O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let T = O ? O[S] : 0;
    (!T || !await (a.isElement == null ? void 0 : a.isElement(O))) && (T = s.floating[S] || o.floating[g]);
    const C = A / 2 - _ / 2, k = T / 2 - v[g] / 2 - 1, D = Da(d[x], k), N = Da(d[w], k), $ = D, B = T - v[g] - N, L = T / 2 - v[g] / 2 + C, F = d0($, L, B), W = !l.arrow && Nc(i) != null && L !== F && o.reference[g] / 2 - (L < $ ? D : N) - v[g] / 2 < 0, z = W ? L < $ ? L - $ : L - B : 0;
    return {
      [m]: p[m] + z,
      data: {
        [m]: F,
        centerOffset: L - F - z,
        ...W && {
          alignmentOffset: z
        }
      },
      reset: W
    };
  }
}), IH = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: f = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...y
      } = Mc(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const x = Ia(i), w = Ds(s), S = Ia(s) === s, A = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), _ = p || (S || !v ? [fp(s)] : uH(s)), O = g !== "none";
      !p && O && _.push(...dH(s, v, g, A));
      const T = [s, ..._], C = await n1(t, y), k = [];
      let D = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (f && k.push(C[x]), d) {
        const L = cH(i, a, A);
        k.push(C[L[0]], C[L[1]]);
      }
      if (D = [...D, {
        placement: i,
        overflows: k
      }], !k.every((L) => L <= 0)) {
        var N, $;
        const L = (((N = o.flip) == null ? void 0 : N.index) || 0) + 1, F = T[L];
        if (F)
          return {
            data: {
              index: L,
              overflows: D
            },
            reset: {
              placement: F
            }
          };
        let W = ($ = D.filter((z) => z.overflows[0] <= 0).sort((z, G) => z.overflows[1] - G.overflows[1])[0]) == null ? void 0 : $.placement;
        if (!W)
          switch (m) {
            case "bestFit": {
              var B;
              const z = (B = D.filter((G) => {
                if (O) {
                  const V = Ds(G.placement);
                  return V === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  V === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((V) => V > 0).reduce((V, U) => V + U, 0)]).sort((G, V) => G[1] - V[1])[0]) == null ? void 0 : B[0];
              z && (W = z);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (i !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
async function RH(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Ia(n), s = Nc(n), l = Ds(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, f = o && l ? -1 : 1, d = Mc(t, e);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof g == "number" && (m = s === "end" ? g * -1 : g), l ? {
    x: m * f,
    y: p * c
  } : {
    x: p * c,
    y: m * f
  };
}
const jH = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, l = await RH(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, LH = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x,
              y: w
            } = y;
            return {
              x,
              y: w
            };
          }
        },
        ...l
      } = Mc(e, t), c = {
        x: n,
        y: r
      }, f = await n1(t, l), d = Ds(Ia(i)), p = nD(d);
      let m = c[p], g = c[d];
      if (o) {
        const y = p === "y" ? "top" : "left", x = p === "y" ? "bottom" : "right", w = m + f[y], S = m - f[x];
        m = d0(w, m, S);
      }
      if (a) {
        const y = d === "y" ? "top" : "left", x = d === "y" ? "bottom" : "right", w = g + f[y], S = g - f[x];
        g = d0(w, g, S);
      }
      const v = s.fn({
        ...t,
        [p]: m,
        [d]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [p]: o,
            [d]: a
          }
        }
      };
    }
  };
}, BH = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = Mc(e, t), f = await n1(t, c), d = Ia(i), p = Nc(i), m = Ds(i) === "y", {
        width: g,
        height: v
      } = o.floating;
      let y, x;
      d === "top" || d === "bottom" ? (y = d, x = p === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (x = d, y = p === "end" ? "top" : "bottom");
      const w = v - f.top - f.bottom, S = g - f.left - f.right, A = Da(v - f[y], w), _ = Da(g - f[x], S), O = !t.middlewareData.shift;
      let T = A, C = _;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (C = S), (r = t.middlewareData.shift) != null && r.enabled.y && (T = w), O && !p) {
        const D = Lr(f.left, 0), N = Lr(f.right, 0), $ = Lr(f.top, 0), B = Lr(f.bottom, 0);
        m ? C = g - 2 * (D !== 0 || N !== 0 ? D + N : Lr(f.left, f.right)) : T = v - 2 * ($ !== 0 || B !== 0 ? $ + B : Lr(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: C,
        availableHeight: T
      });
      const k = await a.getDimensions(s.floating);
      return g !== k.width || v !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function lD(e) {
  const t = Vr(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = hn(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = up(n) !== o || up(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function r1(e) {
  return Ct(e) ? e : e.contextElement;
}
function Wl(e) {
  const t = r1(e);
  if (!hn(t))
    return Ki(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = lD(t);
  let a = (o ? up(n.width) : n.width) / r, s = (o ? up(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const FH = /* @__PURE__ */ Ki(0);
function cD(e) {
  const t = Sr(e);
  return !Qm() || !t.visualViewport ? FH : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function WH(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Sr(e) ? !1 : t;
}
function Is(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = r1(e);
  let a = Ki(1);
  t && (r ? Ct(r) && (a = Wl(r)) : a = Wl(e));
  const s = WH(o, n, r) ? cD(o) : Ki(0);
  let l = (i.left + s.x) / a.x, c = (i.top + s.y) / a.y, f = i.width / a.x, d = i.height / a.y;
  if (o) {
    const p = Sr(o), m = r && Ct(r) ? Sr(r) : r;
    let g = p, v = c0(g);
    for (; v && r && m !== g; ) {
      const y = Wl(v), x = v.getBoundingClientRect(), w = Vr(v), S = x.left + (v.clientLeft + parseFloat(w.paddingLeft)) * y.x, A = x.top + (v.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, c *= y.y, f *= y.x, d *= y.y, l += S, c += A, g = Sr(v), v = c0(g);
    }
  }
  return dp({
    width: f,
    height: d,
    x: l,
    y: c
  });
}
function i1(e, t) {
  const n = eg(e).scrollLeft;
  return t ? t.left + n : Is(ro(e)).left + n;
}
function uD(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    i1(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function zH(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = ro(r), s = t ? Jm(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ki(1);
  const f = Ki(0), d = hn(r);
  if ((d || !d && !o) && ((za(r) !== "body" || ad(a)) && (l = eg(r)), hn(r))) {
    const m = Is(r);
    c = Wl(r), f.x = m.x + r.clientLeft, f.y = m.y + r.clientTop;
  }
  const p = a && !d && !o ? uD(a, l, !0) : Ki(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + f.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + f.y + p.y
  };
}
function VH(e) {
  return Array.from(e.getClientRects());
}
function UH(e) {
  const t = ro(e), n = eg(e), r = e.ownerDocument.body, i = Lr(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Lr(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + i1(e);
  const s = -n.scrollTop;
  return Vr(r).direction === "rtl" && (a += Lr(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function KH(e, t) {
  const n = Sr(e), r = ro(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const c = Qm();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function HH(e, t) {
  const n = Is(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = hn(e) ? Wl(e) : Ki(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, l = i * o.x, c = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function vP(e, t, n) {
  let r;
  if (t === "viewport")
    r = KH(e, n);
  else if (t === "document")
    r = UH(ro(e));
  else if (Ct(t))
    r = HH(t, n);
  else {
    const i = cD(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return dp(r);
}
function fD(e, t) {
  const n = Lo(e);
  return n === t || !Ct(n) || $a(n) ? !1 : Vr(n).position === "fixed" || fD(n, t);
}
function GH(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Pa(e, [], !1).filter((s) => Ct(s) && za(s) !== "body"), i = null;
  const o = Vr(e).position === "fixed";
  let a = o ? Lo(e) : e;
  for (; Ct(a) && !$a(a); ) {
    const s = Vr(a), l = Xw(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ad(a) && !l && fD(e, a)) ? r = r.filter((f) => f !== a) : i = s, a = Lo(a);
  }
  return t.set(e, r), r;
}
function YH(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? Jm(t) ? [] : GH(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, f) => {
    const d = vP(t, f, i);
    return c.top = Lr(d.top, c.top), c.right = Da(d.right, c.right), c.bottom = Da(d.bottom, c.bottom), c.left = Lr(d.left, c.left), c;
  }, vP(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function qH(e) {
  const {
    width: t,
    height: n
  } = lD(e);
  return {
    width: t,
    height: n
  };
}
function XH(e, t, n) {
  const r = hn(t), i = ro(t), o = n === "fixed", a = Is(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ki(0);
  if (r || !r && !o)
    if ((za(t) !== "body" || ad(i)) && (s = eg(t)), r) {
      const p = Is(t, !0, o, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else i && (l.x = i1(i));
  const c = i && !r && !o ? uD(i, s) : Ki(0), f = a.left + s.scrollLeft - l.x - c.x, d = a.top + s.scrollTop - l.y - c.y;
  return {
    x: f,
    y: d,
    width: a.width,
    height: a.height
  };
}
function Vv(e) {
  return Vr(e).position === "static";
}
function bP(e, t) {
  if (!hn(e) || Vr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ro(e) === n && (n = n.ownerDocument.body), n;
}
function dD(e, t) {
  const n = Sr(e);
  if (Jm(e))
    return n;
  if (!hn(e)) {
    let i = Lo(e);
    for (; i && !$a(i); ) {
      if (Ct(i) && !Vv(i))
        return i;
      i = Lo(i);
    }
    return n;
  }
  let r = bP(e, t);
  for (; r && tH(r) && Vv(r); )
    r = bP(r, t);
  return r && $a(r) && Vv(r) && !Xw(r) ? n : r || nH(e) || n;
}
const ZH = async function(e) {
  const t = this.getOffsetParent || dD, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: XH(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function JH(e) {
  return Vr(e).direction === "rtl";
}
const QH = {
  convertOffsetParentRelativeRectToViewportRelativeRect: zH,
  getDocumentElement: ro,
  getClippingRect: YH,
  getOffsetParent: dD,
  getElementRects: ZH,
  getClientRects: VH,
  getDimensions: qH,
  getScale: Wl,
  isElement: Ct,
  isRTL: JH
};
function eG(e, t) {
  let n = null, r;
  const i = ro(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const {
      left: c,
      top: f,
      width: d,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !d || !p)
      return;
    const m = Cl(f), g = Cl(i.clientWidth - (c + d)), v = Cl(i.clientHeight - (f + p)), y = Cl(c), w = {
      rootMargin: -m + "px " + -g + "px " + -v + "px " + -y + "px",
      threshold: Lr(0, Da(1, l)) || 1
    };
    let S = !0;
    function A(_) {
      const O = _[0].intersectionRatio;
      if (O !== l) {
        if (!S)
          return a();
        O ? a(!1, O) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(A, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(A, w);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function ng(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = r1(e), f = i || o ? [...c ? Pa(c) : [], ...Pa(t)] : [];
  f.forEach((x) => {
    i && x.addEventListener("scroll", n, {
      passive: !0
    }), o && x.addEventListener("resize", n);
  });
  const d = c && s ? eG(c, n) : null;
  let p = -1, m = null;
  a && (m = new ResizeObserver((x) => {
    let [w] = x;
    w && w.target === c && m && (m.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), c && !l && m.observe(c), m.observe(t));
  let g, v = l ? Is(e) : null;
  l && y();
  function y() {
    const x = Is(e);
    v && (x.x !== v.x || x.y !== v.y || x.width !== v.width || x.height !== v.height) && n(), v = x, g = requestAnimationFrame(y);
  }
  return n(), () => {
    var x;
    f.forEach((w) => {
      i && w.removeEventListener("scroll", n), o && w.removeEventListener("resize", n);
    }), d == null || d(), (x = m) == null || x.disconnect(), m = null, l && cancelAnimationFrame(g);
  };
}
const tG = jH, nG = LH, rG = IH, iG = BH, xP = DH, oG = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: QH,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return $H(e, t, {
    ...i,
    platform: o
  });
};
var tp = typeof document < "u" ? $i : Qe;
function gp(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!gp(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !gp(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function hD(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function wP(e, t) {
  const n = hD(e);
  return Math.round(t * n) / n;
}
function Uv(e) {
  const t = ee.useRef(e);
  return tp(() => {
    t.current = e;
  }), t;
}
function aG(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [f, d] = ee.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = ee.useState(r);
  gp(p, r) || m(r);
  const [g, v] = ee.useState(null), [y, x] = ee.useState(null), w = ee.useCallback((G) => {
    G !== O.current && (O.current = G, v(G));
  }, []), S = ee.useCallback((G) => {
    G !== T.current && (T.current = G, x(G));
  }, []), A = o || g, _ = a || y, O = ee.useRef(null), T = ee.useRef(null), C = ee.useRef(f), k = l != null, D = Uv(l), N = Uv(i), $ = Uv(c), B = ee.useCallback(() => {
    if (!O.current || !T.current)
      return;
    const G = {
      placement: t,
      strategy: n,
      middleware: p
    };
    N.current && (G.platform = N.current), oG(O.current, T.current, G).then((V) => {
      const U = {
        ...V,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: $.current !== !1
      };
      L.current && !gp(C.current, U) && (C.current = U, R$.flushSync(() => {
        d(U);
      }));
    });
  }, [p, t, n, N, $]);
  tp(() => {
    c === !1 && C.current.isPositioned && (C.current.isPositioned = !1, d((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [c]);
  const L = ee.useRef(!1);
  tp(() => (L.current = !0, () => {
    L.current = !1;
  }), []), tp(() => {
    if (A && (O.current = A), _ && (T.current = _), A && _) {
      if (D.current)
        return D.current(A, _, B);
      B();
    }
  }, [A, _, B, D, k]);
  const F = ee.useMemo(() => ({
    reference: O,
    floating: T,
    setReference: w,
    setFloating: S
  }), [w, S]), W = ee.useMemo(() => ({
    reference: A,
    floating: _
  }), [A, _]), z = ee.useMemo(() => {
    const G = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return G;
    const V = wP(W.floating, f.x), U = wP(W.floating, f.y);
    return s ? {
      ...G,
      transform: "translate(" + V + "px, " + U + "px)",
      ...hD(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: V,
      top: U
    };
  }, [n, s, W.floating, f.x, f.y]);
  return ee.useMemo(() => ({
    ...f,
    update: B,
    refs: F,
    elements: W,
    floatingStyles: z
  }), [f, B, F, W, z]);
}
const sG = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? xP({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? xP({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, rg = (e, t) => ({
  ...tG(e),
  options: [e, t]
}), pD = (e, t) => ({
  ...nG(e),
  options: [e, t]
}), ig = (e, t) => ({
  ...rG(e),
  options: [e, t]
}), mD = (e, t) => ({
  ...iG(e),
  options: [e, t]
}), lG = (e, t) => ({
  ...sG(e),
  options: [e, t]
}), gD = {
  ...ee
}, cG = gD.useInsertionEffect, uG = cG || ((e) => e());
function kn(e) {
  const t = ee.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return uG(() => {
    t.current = e;
  }), ee.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const o1 = "ArrowUp", sd = "ArrowDown", Ta = "ArrowLeft", Ca = "ArrowRight";
function Oh(e, t, n) {
  return Math.floor(e / t) !== n;
}
function zu(e, t) {
  return t < 0 || t >= e.current.length;
}
function Kv(e, t) {
  return Xn(e, {
    disabledIndices: t
  });
}
function _P(e, t) {
  return Xn(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function Xn(e, t) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: i,
    amount: o = 1
  } = t === void 0 ? {} : t;
  const a = e.current;
  let s = n;
  do
    s += r ? -o : o;
  while (s >= 0 && s <= a.length - 1 && np(a, s, i));
  return s;
}
function fG(e, t) {
  let {
    event: n,
    orientation: r,
    loop: i,
    rtl: o,
    cols: a,
    disabledIndices: s,
    minIndex: l,
    maxIndex: c,
    prevIndex: f,
    stopEvent: d = !1
  } = t, p = f;
  if (n.key === o1) {
    if (d && zn(n), f === -1)
      p = c;
    else if (p = Xn(e, {
      startingIndex: p,
      amount: a,
      decrement: !0,
      disabledIndices: s
    }), i && (f - a < l || p < 0)) {
      const m = f % a, g = c % a, v = c - (g - m);
      g === m ? p = c : p = g > m ? v : v - a;
    }
    zu(e, p) && (p = f);
  }
  if (n.key === sd && (d && zn(n), f === -1 ? p = l : (p = Xn(e, {
    startingIndex: f,
    amount: a,
    disabledIndices: s
  }), i && f + a > c && (p = Xn(e, {
    startingIndex: f % a - a,
    amount: a,
    disabledIndices: s
  }))), zu(e, p) && (p = f)), r === "both") {
    const m = Cl(f / a);
    n.key === (o ? Ta : Ca) && (d && zn(n), f % a !== a - 1 ? (p = Xn(e, {
      startingIndex: f,
      disabledIndices: s
    }), i && Oh(p, a, m) && (p = Xn(e, {
      startingIndex: f - f % a - 1,
      disabledIndices: s
    }))) : i && (p = Xn(e, {
      startingIndex: f - f % a - 1,
      disabledIndices: s
    })), Oh(p, a, m) && (p = f)), n.key === (o ? Ca : Ta) && (d && zn(n), f % a !== 0 ? (p = Xn(e, {
      startingIndex: f,
      decrement: !0,
      disabledIndices: s
    }), i && Oh(p, a, m) && (p = Xn(e, {
      startingIndex: f + (a - f % a),
      decrement: !0,
      disabledIndices: s
    }))) : i && (p = Xn(e, {
      startingIndex: f + (a - f % a),
      decrement: !0,
      disabledIndices: s
    })), Oh(p, a, m) && (p = f));
    const g = Cl(c / a) === m;
    zu(e, p) && (i && g ? p = n.key === (o ? Ca : Ta) ? c : Xn(e, {
      startingIndex: f - f % a - 1,
      disabledIndices: s
    }) : p = f);
  }
  return p;
}
function dG(e, t, n) {
  const r = [];
  let i = 0;
  return e.forEach((o, a) => {
    let {
      width: s,
      height: l
    } = o;
    if (s > t && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + a + " is greater than grid columns");
    let c = !1;
    for (n && (i = 0); !c; ) {
      const f = [];
      for (let d = 0; d < s; d++)
        for (let p = 0; p < l; p++)
          f.push(i + d + p * t);
      i % t + s <= t && f.every((d) => r[d] == null) ? (f.forEach((d) => {
        r[d] = a;
      }), c = !0) : i++;
    }
  }), [...r];
}
function hG(e, t, n, r, i) {
  if (e === -1) return -1;
  const o = n.indexOf(e), a = t[e];
  switch (i) {
    case "tl":
      return o;
    case "tr":
      return a ? o + a.width - 1 : o;
    case "bl":
      return a ? o + (a.height - 1) * r : o;
    case "br":
      return n.lastIndexOf(e);
  }
}
function pG(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function np(e, t, n) {
  if (n)
    return n.includes(t);
  const r = e[t];
  return r == null || r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true";
}
var Mt = typeof document < "u" ? $i : Qe;
function cf() {
  return cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cf.apply(this, arguments);
}
let SP = !1, mG = 0;
const OP = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + mG++
);
function gG() {
  const [e, t] = ee.useState(() => SP ? OP() : void 0);
  return Mt(() => {
    e == null && t(OP());
  }, []), ee.useEffect(() => {
    SP = !0;
  }, []), e;
}
const yG = gD.useId, og = yG || gG;
let uf;
process.env.NODE_ENV !== "production" && (uf = /* @__PURE__ */ new Set());
function rp() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((e = uf) != null && e.has(i))) {
    var o;
    (o = uf) == null || o.add(i), console.warn(i);
  }
}
function vG() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((e = uf) != null && e.has(i))) {
    var o;
    (o = uf) == null || o.add(i), console.error(i);
  }
}
const bG = /* @__PURE__ */ ee.forwardRef(function(t, n) {
  const {
    context: {
      placement: r,
      elements: {
        floating: i
      },
      middlewareData: {
        arrow: o,
        shift: a
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: f = 0,
    staticOffset: d,
    stroke: p,
    d: m,
    style: {
      transform: g,
      ...v
    } = {},
    ...y
  } = t;
  process.env.NODE_ENV !== "production" && (n || rp("The `ref` prop is required for `FloatingArrow`."));
  const x = og(), [w, S] = ee.useState(!1);
  if (Mt(() => {
    if (!i) return;
    Vr(i).direction === "rtl" && S(!0);
  }, [i]), !i)
    return null;
  const [A, _] = r.split("-"), O = A === "top" || A === "bottom";
  let T = d;
  (O && a != null && a.x || !O && a != null && a.y) && (T = null);
  const C = f * 2, k = C / 2, D = s / 2 * (c / -8 + 1), N = l / 2 * c / 4, $ = !!m, B = T && _ === "end" ? "bottom" : "top";
  let L = T && _ === "end" ? "right" : "left";
  T && w && (L = _ === "end" ? "left" : "right");
  const F = (o == null ? void 0 : o.x) != null ? T || o.x : "", W = (o == null ? void 0 : o.y) != null ? T || o.y : "", z = m || "M0,0" + (" H" + s) + (" L" + (s - D) + "," + (l - N)) + (" Q" + s / 2 + "," + l + " " + D + "," + (l - N)) + " Z", G = {
    top: $ ? "rotate(180deg)" : "",
    left: $ ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: $ ? "" : "rotate(180deg)",
    right: $ ? "rotate(-90deg)" : "rotate(90deg)"
  }[A];
  return /* @__PURE__ */ ee.createElement("svg", cf({}, y, {
    "aria-hidden": !0,
    ref: n,
    width: $ ? s : s + C,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [L]: F,
      [B]: W,
      [A]: O || $ ? "100%" : "calc(100% - " + C / 2 + "px)",
      transform: [G, g].filter((V) => !!V).join(" "),
      ...v
    }
  }), C > 0 && /* @__PURE__ */ ee.createElement("path", {
    clipPath: "url(#" + x + ")",
    fill: "none",
    stroke: p,
    strokeWidth: C + (m ? 0 : 1),
    d: z
  }), /* @__PURE__ */ ee.createElement("path", {
    stroke: C && !m ? y.fill : "none",
    d: z
  }), /* @__PURE__ */ ee.createElement("clipPath", {
    id: x
  }, /* @__PURE__ */ ee.createElement("rect", {
    x: -k,
    y: k * ($ ? -1 : 1),
    width: s + C,
    height: s
  })));
});
function xG() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((i) => i(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((i) => i !== n)) || []);
    }
  };
}
const wG = /* @__PURE__ */ ee.createContext(null), _G = /* @__PURE__ */ ee.createContext(null), ag = () => {
  var e;
  return ((e = ee.useContext(wG)) == null ? void 0 : e.id) || null;
}, ld = () => ee.useContext(_G);
function Rs(e) {
  return "data-floating-ui-" + e;
}
function Kn(e) {
  const t = ft(e);
  return Mt(() => {
    t.current = e;
  }), t;
}
const AP = /* @__PURE__ */ Rs("safe-polygon");
function Hv(e, t, n) {
  return n && !lf(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function SG(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    events: o,
    elements: a
  } = e, {
    enabled: s = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: f = !1,
    restMs: d = 0,
    move: p = !0
  } = t, m = ld(), g = ag(), v = Kn(c), y = Kn(l), x = Kn(n), w = ee.useRef(), S = ee.useRef(-1), A = ee.useRef(), _ = ee.useRef(-1), O = ee.useRef(!0), T = ee.useRef(!1), C = ee.useRef(() => {
  }), k = ee.useRef(!1), D = ee.useCallback(() => {
    var z;
    const G = (z = i.current.openEvent) == null ? void 0 : z.type;
    return (G == null ? void 0 : G.includes("mouse")) && G !== "mousedown";
  }, [i]);
  ee.useEffect(() => {
    if (!s) return;
    function z(G) {
      let {
        open: V
      } = G;
      V || (clearTimeout(S.current), clearTimeout(_.current), O.current = !0, k.current = !1);
    }
    return o.on("openchange", z), () => {
      o.off("openchange", z);
    };
  }, [s, o]), ee.useEffect(() => {
    if (!s || !v.current || !n) return;
    function z(V) {
      D() && r(!1, V, "hover");
    }
    const G = Vn(a.floating).documentElement;
    return G.addEventListener("mouseleave", z), () => {
      G.removeEventListener("mouseleave", z);
    };
  }, [a.floating, n, r, s, v, D]);
  const N = ee.useCallback(function(z, G, V) {
    G === void 0 && (G = !0), V === void 0 && (V = "hover");
    const U = Hv(y.current, "close", w.current);
    U && !A.current ? (clearTimeout(S.current), S.current = window.setTimeout(() => r(!1, z, V), U)) : G && (clearTimeout(S.current), r(!1, z, V));
  }, [y, r]), $ = kn(() => {
    C.current(), A.current = void 0;
  }), B = kn(() => {
    if (T.current) {
      const z = Vn(a.floating).body;
      z.style.pointerEvents = "", z.removeAttribute(AP), T.current = !1;
    }
  }), L = kn(() => i.current.openEvent ? ["click", "mousedown"].includes(i.current.openEvent.type) : !1);
  ee.useEffect(() => {
    if (!s) return;
    function z(Y) {
      if (clearTimeout(S.current), O.current = !1, f && !lf(w.current) || d > 0 && !Hv(y.current, "open"))
        return;
      const te = Hv(y.current, "open", w.current);
      te ? S.current = window.setTimeout(() => {
        x.current || r(!0, Y, "hover");
      }, te) : n || r(!0, Y, "hover");
    }
    function G(Y) {
      if (L()) return;
      C.current();
      const te = Vn(a.floating);
      if (clearTimeout(_.current), k.current = !1, v.current && i.current.floatingContext) {
        n || clearTimeout(S.current), A.current = v.current({
          ...i.current.floatingContext,
          tree: m,
          x: Y.clientX,
          y: Y.clientY,
          onClose() {
            B(), $(), L() || N(Y, !0, "safe-polygon");
          }
        });
        const re = A.current;
        te.addEventListener("mousemove", re), C.current = () => {
          te.removeEventListener("mousemove", re);
        };
        return;
      }
      (w.current === "touch" ? !dn(a.floating, Y.relatedTarget) : !0) && N(Y);
    }
    function V(Y) {
      L() || i.current.floatingContext && (v.current == null || v.current({
        ...i.current.floatingContext,
        tree: m,
        x: Y.clientX,
        y: Y.clientY,
        onClose() {
          B(), $(), L() || N(Y);
        }
      })(Y));
    }
    if (Ct(a.domReference)) {
      var U;
      const Y = a.domReference;
      return n && Y.addEventListener("mouseleave", V), (U = a.floating) == null || U.addEventListener("mouseleave", V), p && Y.addEventListener("mousemove", z, {
        once: !0
      }), Y.addEventListener("mouseenter", z), Y.addEventListener("mouseleave", G), () => {
        var te;
        n && Y.removeEventListener("mouseleave", V), (te = a.floating) == null || te.removeEventListener("mouseleave", V), p && Y.removeEventListener("mousemove", z), Y.removeEventListener("mouseenter", z), Y.removeEventListener("mouseleave", G);
      };
    }
  }, [a, s, e, f, d, p, N, $, B, r, n, x, m, y, v, i, L]), Mt(() => {
    var z;
    if (s && n && (z = v.current) != null && z.__options.blockPointerEvents && D()) {
      T.current = !0;
      const V = a.floating;
      if (Ct(a.domReference) && V) {
        var G;
        const U = Vn(a.floating).body;
        U.setAttribute(AP, "");
        const Y = a.domReference, te = m == null || (G = m.nodesRef.current.find((ne) => ne.id === g)) == null || (G = G.context) == null ? void 0 : G.elements.floating;
        return te && (te.style.pointerEvents = ""), U.style.pointerEvents = "none", Y.style.pointerEvents = "auto", V.style.pointerEvents = "auto", () => {
          U.style.pointerEvents = "", Y.style.pointerEvents = "", V.style.pointerEvents = "";
        };
      }
    }
  }, [s, n, g, a, m, v, D]), Mt(() => {
    n || (w.current = void 0, k.current = !1, $(), B());
  }, [n, $, B]), ee.useEffect(() => () => {
    $(), clearTimeout(S.current), clearTimeout(_.current), B();
  }, [s, a.domReference, $, B]);
  const F = ee.useMemo(() => {
    function z(G) {
      w.current = G.pointerType;
    }
    return {
      onPointerDown: z,
      onPointerEnter: z,
      onMouseMove(G) {
        const {
          nativeEvent: V
        } = G;
        function U() {
          !O.current && !x.current && r(!0, V, "hover");
        }
        f && !lf(w.current) || n || d === 0 || k.current && G.movementX ** 2 + G.movementY ** 2 < 2 || (clearTimeout(_.current), w.current === "touch" ? U() : (k.current = !0, _.current = window.setTimeout(U, d)));
      }
    };
  }, [f, r, n, x, d]), W = ee.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(S.current);
    },
    onMouseLeave(z) {
      L() || N(z.nativeEvent, !1);
    }
  }), [N, L]);
  return ee.useMemo(() => s ? {
    reference: F,
    floating: W
  } : {}, [s, F, W]);
}
let PP = 0;
function va(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: i = !1
  } = t;
  r && cancelAnimationFrame(PP);
  const o = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  i ? o() : PP = requestAnimationFrame(o);
}
function OG(e, t) {
  var n;
  let r = [], i = (n = e.find((o) => o.id === t)) == null ? void 0 : n.parentId;
  for (; i; ) {
    const o = e.find((a) => a.id === i);
    i = o == null ? void 0 : o.parentId, o && (r = r.concat(o));
  }
  return r;
}
function Ts(e, t) {
  let n = e.filter((i) => {
    var o;
    return i.parentId === t && ((o = i.context) == null ? void 0 : o.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((i) => {
      var o;
      return (o = r) == null ? void 0 : o.some((a) => {
        var s;
        return i.parentId === a.id && ((s = i.context) == null ? void 0 : s.open);
      });
    }), n = n.concat(r);
  return n;
}
function AG(e, t) {
  let n, r = -1;
  function i(o, a) {
    a > r && (n = o, r = a), Ts(e, o).forEach((l) => {
      i(l.id, a + 1);
    });
  }
  return i(t, 0), e.find((o) => o.id === n);
}
let vl = /* @__PURE__ */ new WeakMap(), Ah = /* @__PURE__ */ new WeakSet(), Ph = {}, Gv = 0;
const PG = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, yD = (e) => e && (e.host || yD(e.parentNode)), TG = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = yD(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function CG(e, t, n, r) {
  const i = "data-floating-ui-inert", o = r ? "inert" : n ? "aria-hidden" : null, a = TG(t, e), s = /* @__PURE__ */ new Set(), l = new Set(a), c = [];
  Ph[i] || (Ph[i] = /* @__PURE__ */ new WeakMap());
  const f = Ph[i];
  a.forEach(d), p(t), s.clear();
  function d(m) {
    !m || s.has(m) || (s.add(m), m.parentNode && d(m.parentNode));
  }
  function p(m) {
    !m || l.has(m) || [].forEach.call(m.children, (g) => {
      if (za(g) !== "script")
        if (s.has(g))
          p(g);
        else {
          const v = o ? g.getAttribute(o) : null, y = v !== null && v !== "false", x = (vl.get(g) || 0) + 1, w = (f.get(g) || 0) + 1;
          vl.set(g, x), f.set(g, w), c.push(g), x === 1 && y && Ah.add(g), w === 1 && g.setAttribute(i, ""), !y && o && g.setAttribute(o, "true");
        }
    });
  }
  return Gv++, () => {
    c.forEach((m) => {
      const g = (vl.get(m) || 0) - 1, v = (f.get(m) || 0) - 1;
      vl.set(m, g), f.set(m, v), g || (!Ah.has(m) && o && m.removeAttribute(o), Ah.delete(m)), v || m.removeAttribute(i);
    }), Gv--, Gv || (vl = /* @__PURE__ */ new WeakMap(), vl = /* @__PURE__ */ new WeakMap(), Ah = /* @__PURE__ */ new WeakSet(), Ph = {});
  };
}
function TP(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = Vn(e[0]).body;
  return CG(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const ff = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function vD(e, t) {
  const n = tg(e, ff());
  t === "prev" && n.reverse();
  const r = n.indexOf(Ai(Vn(e)));
  return n.slice(r + 1)[0];
}
function bD() {
  return vD(document.body, "next");
}
function xD() {
  return vD(document.body, "prev");
}
function Vu(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !dn(n, r);
}
function EG(e) {
  tg(e, ff()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function CP(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const sg = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let kG;
function EP(e) {
  e.key === "Tab" && (e.target, clearTimeout(kG));
}
const yp = /* @__PURE__ */ ee.forwardRef(function(t, n) {
  const [r, i] = ee.useState();
  Mt(() => (Jw() && i("button"), document.addEventListener("keydown", EP), () => {
    document.removeEventListener("keydown", EP);
  }), []);
  const o = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Rs("focus-guard")]: "",
    style: sg
  };
  return /* @__PURE__ */ ee.createElement("span", cf({}, t, o));
}), wD = /* @__PURE__ */ ee.createContext(null), kP = /* @__PURE__ */ Rs("portal");
function MG(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = og(), i = _D(), [o, a] = ee.useState(null), s = ee.useRef(null);
  return Mt(() => () => {
    o == null || o.remove(), queueMicrotask(() => {
      s.current = null;
    });
  }, [o]), Mt(() => {
    if (!r || s.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = r, c.setAttribute(kP, ""), l.appendChild(c), s.current = c, a(c);
  }, [t, r]), Mt(() => {
    if (n === null || !r || s.current) return;
    let l = n || (i == null ? void 0 : i.portalNode);
    l && !Ct(l) && (l = l.current), l = l || document.body;
    let c = null;
    t && (c = document.createElement("div"), c.id = t, l.appendChild(c));
    const f = document.createElement("div");
    f.id = r, f.setAttribute(kP, ""), l = c || l, l.appendChild(f), s.current = f, a(f);
  }, [t, n, r, i]), o;
}
function lg(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: i = !0
  } = e, o = MG({
    id: n,
    root: r
  }), [a, s] = ee.useState(null), l = ee.useRef(null), c = ee.useRef(null), f = ee.useRef(null), d = ee.useRef(null), p = a == null ? void 0 : a.modal, m = a == null ? void 0 : a.open, g = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && // Don't render if unmount is transitioning.
    a.open && i && !!(r || o)
  );
  return ee.useEffect(() => {
    if (!o || !i || p)
      return;
    function v(y) {
      o && Vu(y) && (y.type === "focusin" ? CP : EG)(o);
    }
    return o.addEventListener("focusin", v, !0), o.addEventListener("focusout", v, !0), () => {
      o.removeEventListener("focusin", v, !0), o.removeEventListener("focusout", v, !0);
    };
  }, [o, i, p]), ee.useEffect(() => {
    o && (m || CP(o));
  }, [m, o]), /* @__PURE__ */ ee.createElement(wD.Provider, {
    value: ee.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: f,
      afterInsideRef: d,
      portalNode: o,
      setFocusManagerState: s
    }), [i, o])
  }, g && o && /* @__PURE__ */ ee.createElement(yp, {
    "data-type": "outside",
    ref: l,
    onFocus: (v) => {
      if (Vu(v, o)) {
        var y;
        (y = f.current) == null || y.focus();
      } else {
        const x = xD() || (a == null ? void 0 : a.refs.domReference.current);
        x == null || x.focus();
      }
    }
  }), g && o && /* @__PURE__ */ ee.createElement("span", {
    "aria-owns": o.id,
    style: sg
  }), o && /* @__PURE__ */ R$.createPortal(t, o), g && o && /* @__PURE__ */ ee.createElement(yp, {
    "data-type": "outside",
    ref: c,
    onFocus: (v) => {
      if (Vu(v, o)) {
        var y;
        (y = d.current) == null || y.focus();
      } else {
        const x = bD() || (a == null ? void 0 : a.refs.domReference.current);
        x == null || x.focus(), a != null && a.closeOnFocusOut && (a == null || a.onOpenChange(!1, v.nativeEvent, "focus-out"));
      }
    }
  }));
}
const _D = () => ee.useContext(wD), m0 = "data-floating-ui-focusable";
function SD(e) {
  return e ? e.hasAttribute(m0) ? e : e.querySelector("[" + m0 + "]") || e : null;
}
const MP = 20;
let ds = [];
function Yv(e) {
  ds = ds.filter((n) => n.isConnected);
  let t = e;
  if (!(!t || za(t) === "body")) {
    if (!NH(t, ff())) {
      const n = tg(t, ff())[0];
      n && (t = n);
    }
    ds.push(t), ds.length > MP && (ds = ds.slice(-MP));
  }
}
function NP() {
  return ds.slice().reverse().find((e) => e.isConnected);
}
const NG = /* @__PURE__ */ ee.forwardRef(function(t, n) {
  return /* @__PURE__ */ ee.createElement("button", cf({}, t, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: sg
  }));
});
function $G(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: i = ["content"],
    guards: o = !0,
    initialFocus: a = 0,
    returnFocus: s = !0,
    restoreFocus: l = !1,
    modal: c = !0,
    visuallyHiddenDismiss: f = !1,
    closeOnFocusOut: d = !0
  } = e, {
    open: p,
    refs: m,
    nodeId: g,
    onOpenChange: v,
    events: y,
    dataRef: x,
    floatingId: w,
    elements: {
      domReference: S,
      floating: A
    }
  } = t, _ = typeof a == "number" && a < 0, O = f0(S) && _, T = PG() ? o : !0, C = Kn(i), k = Kn(a), D = Kn(s), N = ld(), $ = _D(), B = ee.useRef(null), L = ee.useRef(null), F = ee.useRef(!1), W = ee.useRef(!1), z = ee.useRef(-1), G = $ != null, V = SD(A), U = kn(function(re) {
    return re === void 0 && (re = V), re ? tg(re, ff()) : [];
  }), Y = kn((re) => {
    const ue = U(re);
    return C.current.map((ae) => S && ae === "reference" ? S : V && ae === "floating" ? V : ue).filter(Boolean).flat();
  });
  ee.useEffect(() => {
    if (r || !c) return;
    function re(ae) {
      if (ae.key === "Tab") {
        dn(V, Ai(Vn(V))) && U().length === 0 && !O && zn(ae);
        const le = Y(), ie = So(ae);
        C.current[0] === "reference" && ie === S && (zn(ae), ae.shiftKey ? va(le[le.length - 1]) : va(le[1])), C.current[1] === "floating" && ie === V && ae.shiftKey && (zn(ae), va(le[0]));
      }
    }
    const ue = Vn(V);
    return ue.addEventListener("keydown", re), () => {
      ue.removeEventListener("keydown", re);
    };
  }, [r, S, V, c, C, O, U, Y]), ee.useEffect(() => {
    if (r || !A) return;
    function re(ue) {
      const ae = So(ue), ie = U().indexOf(ae);
      ie !== -1 && (z.current = ie);
    }
    return A.addEventListener("focusin", re), () => {
      A.removeEventListener("focusin", re);
    };
  }, [r, A, U]), ee.useEffect(() => {
    if (r || !d) return;
    function re() {
      W.current = !0, setTimeout(() => {
        W.current = !1;
      });
    }
    function ue(ae) {
      const le = ae.relatedTarget;
      queueMicrotask(() => {
        const ie = !(dn(S, le) || dn(A, le) || dn(le, A) || dn($ == null ? void 0 : $.portalNode, le) || le != null && le.hasAttribute(Rs("focus-guard")) || N && (Ts(N.nodesRef.current, g).find((Q) => {
          var fe, ve;
          return dn((fe = Q.context) == null ? void 0 : fe.elements.floating, le) || dn((ve = Q.context) == null ? void 0 : ve.elements.domReference, le);
        }) || OG(N.nodesRef.current, g).find((Q) => {
          var fe, ve;
          return ((fe = Q.context) == null ? void 0 : fe.elements.floating) === le || ((ve = Q.context) == null ? void 0 : ve.elements.domReference) === le;
        })));
        if (l && ie && Ai(Vn(V)) === Vn(V).body) {
          hn(V) && V.focus();
          const Q = z.current, fe = U(), ve = fe[Q] || fe[fe.length - 1] || V;
          hn(ve) && ve.focus();
        }
        (O || !c) && le && ie && !W.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        le !== NP() && (F.current = !0, v(!1, ae, "focus-out"));
      });
    }
    if (A && hn(S))
      return S.addEventListener("focusout", ue), S.addEventListener("pointerdown", re), A.addEventListener("focusout", ue), () => {
        S.removeEventListener("focusout", ue), S.removeEventListener("pointerdown", re), A.removeEventListener("focusout", ue);
      };
  }, [r, S, A, V, c, g, N, $, v, d, l, U, O]), ee.useEffect(() => {
    var re;
    if (r) return;
    const ue = Array.from(($ == null || (re = $.portalNode) == null ? void 0 : re.querySelectorAll("[" + Rs("portal") + "]")) || []);
    if (A) {
      const ae = [A, ...ue, B.current, L.current, C.current.includes("reference") || O ? S : null].filter((ie) => ie != null), le = c || O ? TP(ae, T, !T) : TP(ae);
      return () => {
        le();
      };
    }
  }, [r, S, A, c, C, $, O, T]), Mt(() => {
    if (r || !hn(V)) return;
    const re = Vn(V), ue = Ai(re);
    queueMicrotask(() => {
      const ae = Y(V), le = k.current, ie = (typeof le == "number" ? ae[le] : le.current) || V, Q = dn(V, ue);
      !_ && !Q && p && va(ie, {
        preventScroll: ie === V
      });
    });
  }, [r, p, V, _, Y, k]), Mt(() => {
    if (r || !V) return;
    let re = !1;
    const ue = Vn(V), ae = Ai(ue);
    let ie = x.current.openEvent;
    Yv(ae);
    function Q(X) {
      let {
        open: Fe,
        reason: pe,
        event: Be,
        nested: rt
      } = X;
      Fe && (ie = Be), pe === "escape-key" && m.domReference.current && Yv(m.domReference.current), pe === "hover" && Be.type === "mouseleave" && (F.current = !0), pe === "outside-press" && (rt ? (F.current = !1, re = !0) : F.current = !(eD(Be) || Zw(Be)));
    }
    y.on("openchange", Q);
    const fe = ue.createElement("span");
    fe.setAttribute("tabindex", "-1"), fe.setAttribute("aria-hidden", "true"), Object.assign(fe.style, sg), G && S && S.insertAdjacentElement("afterend", fe);
    function ve() {
      return typeof D.current == "boolean" ? NP() || fe : D.current.current || fe;
    }
    return () => {
      y.off("openchange", Q);
      const X = Ai(ue), Fe = dn(A, X) || N && Ts(N.nodesRef.current, g).some((rt) => {
        var at;
        return dn((at = rt.context) == null ? void 0 : at.elements.floating, X);
      });
      (Fe || ie && ["click", "mousedown"].includes(ie.type)) && m.domReference.current && Yv(m.domReference.current);
      const Be = ve();
      queueMicrotask(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        D.current && !F.current && hn(Be) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(Be !== X && X !== ue.body) || Fe) && Be.focus({
          preventScroll: re
        }), fe.remove();
      });
    };
  }, [r, A, V, D, x, m, y, N, g, G, S]), ee.useEffect(() => {
    queueMicrotask(() => {
      F.current = !1;
    });
  }, [r]), Mt(() => {
    if (!r && $)
      return $.setFocusManagerState({
        modal: c,
        closeOnFocusOut: d,
        open: p,
        onOpenChange: v,
        refs: m
      }), () => {
        $.setFocusManagerState(null);
      };
  }, [r, $, c, p, v, m, d]), Mt(() => {
    if (r || !V || typeof MutationObserver != "function" || _) return;
    const re = () => {
      const ae = V.getAttribute("tabindex"), le = U(), ie = Ai(Vn(A)), Q = le.indexOf(ie);
      Q !== -1 && (z.current = Q), C.current.includes("floating") || ie !== m.domReference.current && le.length === 0 ? ae !== "0" && V.setAttribute("tabindex", "0") : ae !== "-1" && V.setAttribute("tabindex", "-1");
    };
    re();
    const ue = new MutationObserver(re);
    return ue.observe(V, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      ue.disconnect();
    };
  }, [r, A, V, m, C, U, _]);
  function te(re) {
    return r || !f || !c ? null : /* @__PURE__ */ ee.createElement(NG, {
      ref: re === "start" ? B : L,
      onClick: (ue) => v(!1, ue.nativeEvent)
    }, typeof f == "string" ? f : "Dismiss");
  }
  const ne = !r && T && (c ? !O : !0) && (G || c);
  return /* @__PURE__ */ ee.createElement(ee.Fragment, null, ne && /* @__PURE__ */ ee.createElement(yp, {
    "data-type": "inside",
    ref: $ == null ? void 0 : $.beforeInsideRef,
    onFocus: (re) => {
      if (c) {
        const ae = Y();
        va(i[0] === "reference" ? ae[0] : ae[ae.length - 1]);
      } else if ($ != null && $.preserveTabOrder && $.portalNode)
        if (F.current = !1, Vu(re, $.portalNode)) {
          const ae = bD() || S;
          ae == null || ae.focus();
        } else {
          var ue;
          (ue = $.beforeOutsideRef.current) == null || ue.focus();
        }
    }
  }), !O && te("start"), n, te("end"), ne && /* @__PURE__ */ ee.createElement(yp, {
    "data-type": "inside",
    ref: $ == null ? void 0 : $.afterInsideRef,
    onFocus: (re) => {
      if (c)
        va(Y()[0]);
      else if ($ != null && $.preserveTabOrder && $.portalNode)
        if (d && (F.current = !0), Vu(re, $.portalNode)) {
          const ae = xD() || S;
          ae == null || ae.focus();
        } else {
          var ue;
          (ue = $.afterOutsideRef.current) == null || ue.focus();
        }
    }
  }));
}
function $P(e) {
  return hn(e.target) && e.target.tagName === "BUTTON";
}
function DP(e) {
  return Qw(e);
}
function a1(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: o
    }
  } = e, {
    enabled: a = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: f = !0,
    stickIfOpen: d = !0
  } = t, p = ee.useRef(), m = ee.useRef(!1), g = ee.useMemo(() => ({
    onPointerDown(v) {
      p.current = v.pointerType;
    },
    onMouseDown(v) {
      const y = p.current;
      v.button === 0 && s !== "click" && (lf(y, !0) && c || (n && l && (!(i.current.openEvent && d) || i.current.openEvent.type === "mousedown") ? r(!1, v.nativeEvent, "click") : (v.preventDefault(), r(!0, v.nativeEvent, "click"))));
    },
    onClick(v) {
      const y = p.current;
      if (s === "mousedown" && p.current) {
        p.current = void 0;
        return;
      }
      lf(y, !0) && c || (n && l && (!(i.current.openEvent && d) || i.current.openEvent.type === "click") ? r(!1, v.nativeEvent, "click") : r(!0, v.nativeEvent, "click"));
    },
    onKeyDown(v) {
      p.current = void 0, !(v.defaultPrevented || !f || $P(v)) && (v.key === " " && !DP(o) && (v.preventDefault(), m.current = !0), v.key === "Enter" && r(!(n && l), v.nativeEvent, "click"));
    },
    onKeyUp(v) {
      v.defaultPrevented || !f || $P(v) || DP(o) || v.key === " " && m.current && (m.current = !1, r(!(n && l), v.nativeEvent, "click"));
    }
  }), [i, o, s, c, f, r, n, d, l]);
  return ee.useMemo(() => a ? {
    reference: g
  } : {}, [a, g]);
}
const DG = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, IG = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, IP = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function cg(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: i,
    dataRef: o
  } = e, {
    enabled: a = !0,
    escapeKey: s = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: f = !1,
    referencePressEvent: d = "pointerdown",
    ancestorScroll: p = !1,
    bubbles: m,
    capture: g
  } = t, v = ld(), y = kn(typeof l == "function" ? l : () => !1), x = typeof l == "function" ? y : l, w = ee.useRef(!1), S = ee.useRef(!1), {
    escapeKey: A,
    outsidePress: _
  } = IP(m), {
    escapeKey: O,
    outsidePress: T
  } = IP(g), C = ee.useRef(!1), k = kn((F) => {
    var W;
    if (!n || !a || !s || F.key !== "Escape" || C.current)
      return;
    const z = (W = o.current.floatingContext) == null ? void 0 : W.nodeId, G = v ? Ts(v.nodesRef.current, z) : [];
    if (!A && (F.stopPropagation(), G.length > 0)) {
      let V = !0;
      if (G.forEach((U) => {
        var Y;
        if ((Y = U.context) != null && Y.open && !U.context.dataRef.current.__escapeKeyBubbles) {
          V = !1;
          return;
        }
      }), !V)
        return;
    }
    r(!1, iH(F) ? F.nativeEvent : F, "escape-key");
  }), D = kn((F) => {
    var W;
    const z = () => {
      var G;
      k(F), (G = So(F)) == null || G.removeEventListener("keydown", z);
    };
    (W = So(F)) == null || W.addEventListener("keydown", z);
  }), N = kn((F) => {
    var W;
    const z = w.current;
    w.current = !1;
    const G = S.current;
    if (S.current = !1, c === "click" && G || z || typeof x == "function" && !x(F))
      return;
    const V = So(F), U = "[" + Rs("inert") + "]", Y = Vn(i.floating).querySelectorAll(U);
    let te = Ct(V) ? V : null;
    for (; te && !$a(te); ) {
      const ae = Lo(te);
      if ($a(ae) || !Ct(ae))
        break;
      te = ae;
    }
    if (Y.length && Ct(V) && !oH(V) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !dn(V, i.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(Y).every((ae) => !dn(te, ae)))
      return;
    if (hn(V) && L) {
      const ae = V.clientWidth > 0 && V.scrollWidth > V.clientWidth, le = V.clientHeight > 0 && V.scrollHeight > V.clientHeight;
      let ie = le && F.offsetX > V.clientWidth;
      if (le && Vr(V).direction === "rtl" && (ie = F.offsetX <= V.offsetWidth - V.clientWidth), ie || ae && F.offsetY > V.clientHeight)
        return;
    }
    const ne = (W = o.current.floatingContext) == null ? void 0 : W.nodeId, re = v && Ts(v.nodesRef.current, ne).some((ae) => {
      var le;
      return zv(F, (le = ae.context) == null ? void 0 : le.elements.floating);
    });
    if (zv(F, i.floating) || zv(F, i.domReference) || re)
      return;
    const ue = v ? Ts(v.nodesRef.current, ne) : [];
    if (ue.length > 0) {
      let ae = !0;
      if (ue.forEach((le) => {
        var ie;
        if ((ie = le.context) != null && ie.open && !le.context.dataRef.current.__outsidePressBubbles) {
          ae = !1;
          return;
        }
      }), !ae)
        return;
    }
    r(!1, F, "outside-press");
  }), $ = kn((F) => {
    var W;
    const z = () => {
      var G;
      N(F), (G = So(F)) == null || G.removeEventListener(c, z);
    };
    (W = So(F)) == null || W.addEventListener(c, z);
  });
  ee.useEffect(() => {
    if (!n || !a)
      return;
    o.current.__escapeKeyBubbles = A, o.current.__outsidePressBubbles = _;
    let F = -1;
    function W(Y) {
      r(!1, Y, "ancestor-scroll");
    }
    function z() {
      window.clearTimeout(F), C.current = !0;
    }
    function G() {
      F = window.setTimeout(
        () => {
          C.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Qm() ? 5 : 0
      );
    }
    const V = Vn(i.floating);
    s && (V.addEventListener("keydown", O ? D : k, O), V.addEventListener("compositionstart", z), V.addEventListener("compositionend", G)), x && V.addEventListener(c, T ? $ : N, T);
    let U = [];
    return p && (Ct(i.domReference) && (U = Pa(i.domReference)), Ct(i.floating) && (U = U.concat(Pa(i.floating))), !Ct(i.reference) && i.reference && i.reference.contextElement && (U = U.concat(Pa(i.reference.contextElement)))), U = U.filter((Y) => {
      var te;
      return Y !== ((te = V.defaultView) == null ? void 0 : te.visualViewport);
    }), U.forEach((Y) => {
      Y.addEventListener("scroll", W, {
        passive: !0
      });
    }), () => {
      s && (V.removeEventListener("keydown", O ? D : k, O), V.removeEventListener("compositionstart", z), V.removeEventListener("compositionend", G)), x && V.removeEventListener(c, T ? $ : N, T), U.forEach((Y) => {
        Y.removeEventListener("scroll", W);
      }), window.clearTimeout(F);
    };
  }, [o, i, s, x, c, n, r, p, a, A, _, k, O, D, N, T, $]), ee.useEffect(() => {
    w.current = !1;
  }, [x, c]);
  const B = ee.useMemo(() => ({
    onKeyDown: k,
    [DG[d]]: (F) => {
      f && r(!1, F.nativeEvent, "reference-press");
    }
  }), [k, r, f, d]), L = ee.useMemo(() => ({
    onKeyDown: k,
    onMouseDown() {
      S.current = !0;
    },
    onMouseUp() {
      S.current = !0;
    },
    [IG[c]]: () => {
      w.current = !0;
    }
  }), [k, c]);
  return ee.useMemo(() => a ? {
    reference: B,
    floating: L
  } : {}, [a, B, L]);
}
function RG(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, i = og(), o = ee.useRef({}), [a] = ee.useState(() => xG()), s = ag() != null;
  if (process.env.NODE_ENV !== "production") {
    const m = r.reference;
    m && !Ct(m) && vG("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = ee.useState(r.reference), f = kn((m, g, v) => {
    o.current.openEvent = m ? g : void 0, a.emit("openchange", {
      open: m,
      event: g,
      reason: v,
      nested: s
    }), n == null || n(m, g, v);
  }), d = ee.useMemo(() => ({
    setPositionReference: c
  }), []), p = ee.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return ee.useMemo(() => ({
    dataRef: o,
    open: t,
    onOpenChange: f,
    elements: p,
    events: a,
    floatingId: i,
    refs: d
  }), [t, f, p, a, i, d]);
}
function ug(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = RG({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, i = r.elements, [o, a] = ee.useState(null), [s, l] = ee.useState(null), f = (i == null ? void 0 : i.domReference) || o, d = ee.useRef(null), p = ld();
  Mt(() => {
    f && (d.current = f);
  }, [f]);
  const m = aG({
    ...e,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), g = ee.useCallback((S) => {
    const A = Ct(S) ? {
      getBoundingClientRect: () => S.getBoundingClientRect(),
      contextElement: S
    } : S;
    l(A), m.refs.setReference(A);
  }, [m.refs]), v = ee.useCallback((S) => {
    (Ct(S) || S === null) && (d.current = S, a(S)), (Ct(m.refs.reference.current) || m.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    S !== null && !Ct(S)) && m.refs.setReference(S);
  }, [m.refs]), y = ee.useMemo(() => ({
    ...m.refs,
    setReference: v,
    setPositionReference: g,
    domReference: d
  }), [m.refs, v, g]), x = ee.useMemo(() => ({
    ...m.elements,
    domReference: f
  }), [m.elements, f]), w = ee.useMemo(() => ({
    ...m,
    ...r,
    refs: y,
    elements: x,
    nodeId: t
  }), [m, y, x, t, r]);
  return Mt(() => {
    r.dataRef.current.floatingContext = w;
    const S = p == null ? void 0 : p.nodesRef.current.find((A) => A.id === t);
    S && (S.context = w);
  }), ee.useMemo(() => ({
    ...m,
    context: w,
    refs: y,
    elements: x
  }), [m, y, x, w]);
}
function jG(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: i,
    dataRef: o,
    elements: a
  } = e, {
    enabled: s = !0,
    visibleOnly: l = !0
  } = t, c = ee.useRef(!1), f = ee.useRef(), d = ee.useRef(!0);
  ee.useEffect(() => {
    if (!s) return;
    const m = Sr(a.domReference);
    function g() {
      !n && hn(a.domReference) && a.domReference === Ai(Vn(a.domReference)) && (c.current = !0);
    }
    function v() {
      d.current = !0;
    }
    return m.addEventListener("blur", g), m.addEventListener("keydown", v, !0), () => {
      m.removeEventListener("blur", g), m.removeEventListener("keydown", v, !0);
    };
  }, [a.domReference, n, s]), ee.useEffect(() => {
    if (!s) return;
    function m(g) {
      let {
        reason: v
      } = g;
      (v === "reference-press" || v === "escape-key") && (c.current = !0);
    }
    return i.on("openchange", m), () => {
      i.off("openchange", m);
    };
  }, [i, s]), ee.useEffect(() => () => {
    clearTimeout(f.current);
  }, []);
  const p = ee.useMemo(() => ({
    onPointerDown(m) {
      Zw(m.nativeEvent) || (d.current = !1);
    },
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(m) {
      if (c.current) return;
      const g = So(m.nativeEvent);
      if (l && Ct(g))
        try {
          if (Jw() && tD()) throw Error();
          if (!g.matches(":focus-visible")) return;
        } catch {
          if (!d.current && !Qw(g))
            return;
        }
      r(!0, m.nativeEvent, "focus");
    },
    onBlur(m) {
      c.current = !1;
      const g = m.relatedTarget, v = m.nativeEvent, y = Ct(g) && g.hasAttribute(Rs("focus-guard")) && g.getAttribute("data-type") === "outside";
      f.current = window.setTimeout(() => {
        var x;
        const w = Ai(a.domReference ? a.domReference.ownerDocument : document);
        !g && w === a.domReference || dn((x = o.current.floatingContext) == null ? void 0 : x.refs.floating.current, w) || dn(a.domReference, w) || y || r(!1, v, "focus");
      });
    }
  }), [o, a.domReference, r, l]);
  return ee.useMemo(() => s ? {
    reference: p
  } : {}, [s, p]);
}
const RP = "active", jP = "selected";
function qv(e, t, n) {
  const r = /* @__PURE__ */ new Map(), i = n === "item";
  let o = e;
  if (i && e) {
    const {
      [RP]: a,
      [jP]: s,
      ...l
    } = e;
    o = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [m0]: ""
    },
    ...o,
    ...t.map((a) => {
      const s = a ? a[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((a, s) => (s && Object.entries(s).forEach((l) => {
      let [c, f] = l;
      if (!(i && [RP, jP].includes(c)))
        if (c.indexOf("on") === 0) {
          if (r.has(c) || r.set(c, []), typeof f == "function") {
            var d;
            (d = r.get(c)) == null || d.push(f), a[c] = function() {
              for (var p, m = arguments.length, g = new Array(m), v = 0; v < m; v++)
                g[v] = arguments[v];
              return (p = r.get(c)) == null ? void 0 : p.map((y) => y(...g)).find((y) => y !== void 0);
            };
          }
        } else
          a[c] = f;
    }), a), {})
  };
}
function fg(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), n = e.map((s) => s == null ? void 0 : s.floating), r = e.map((s) => s == null ? void 0 : s.item), i = ee.useCallback(
    (s) => qv(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), o = ee.useCallback(
    (s) => qv(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = ee.useCallback(
    (s) => qv(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return ee.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: o,
    getItemProps: a
  }), [i, o, a]);
}
let LP = !1;
function dg(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function BP(e, t) {
  return dg(t, e === o1 || e === sd, e === Ta || e === Ca);
}
function Xv(e, t, n) {
  return dg(t, e === sd, n ? e === Ta : e === Ca) || e === "Enter" || e === " " || e === "";
}
function LG(e, t, n) {
  return dg(t, n ? e === Ta : e === Ca, e === sd);
}
function FP(e, t, n) {
  return dg(t, n ? e === Ca : e === Ta, e === o1);
}
function BG(e, t) {
  const {
    open: n,
    onOpenChange: r,
    elements: i
  } = e, {
    listRef: o,
    activeIndex: a,
    onNavigate: s = () => {
    },
    enabled: l = !0,
    selectedIndex: c = null,
    allowEscape: f = !1,
    loop: d = !1,
    nested: p = !1,
    rtl: m = !1,
    virtual: g = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: y = !0,
    openOnArrowKeyDown: x = !0,
    disabledIndices: w = void 0,
    orientation: S = "vertical",
    cols: A = 1,
    scrollItemIntoView: _ = !0,
    virtualItemRef: O,
    itemSizes: T,
    dense: C = !1
  } = t;
  process.env.NODE_ENV !== "production" && (f && (d || rp("`useListNavigation` looping must be enabled to allow escaping."), g || rp("`useListNavigation` must be virtual to allow escaping.")), S === "vertical" && A > 1 && rp("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const k = SD(i.floating), D = Kn(k), N = ag(), $ = ld(), B = kn(s), L = f0(i.domReference), F = ee.useRef(v), W = ee.useRef(c ?? -1), z = ee.useRef(null), G = ee.useRef(!0), V = ee.useRef(B), U = ee.useRef(!!i.floating), Y = ee.useRef(n), te = ee.useRef(!1), ne = ee.useRef(!1), re = Kn(w), ue = Kn(n), ae = Kn(_), le = Kn(c), [ie, Q] = ee.useState(), [fe, ve] = ee.useState(), X = kn(function($e, st, Oe) {
    Oe === void 0 && (Oe = !1);
    function He(pt) {
      g ? (Q(pt.id), $ == null || $.events.emit("virtualfocus", pt), O && (O.current = pt)) : va(pt, {
        preventScroll: !0,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: tD() && Jw() ? LP || te.current : !1
      });
    }
    const Xt = $e.current[st.current];
    Xt && He(Xt), requestAnimationFrame(() => {
      const pt = $e.current[st.current] || Xt;
      if (!pt) return;
      Xt || He(pt);
      const Qt = ae.current;
      Qt && pe && (Oe || !G.current) && (pt.scrollIntoView == null || pt.scrollIntoView(typeof Qt == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : Qt));
    });
  });
  Mt(() => {
    document.createElement("div").focus({
      get preventScroll() {
        return LP = !0, !1;
      }
    });
  }, []), Mt(() => {
    l && (n && i.floating ? F.current && c != null && (ne.current = !0, W.current = c, B(c)) : U.current && (W.current = -1, V.current(null)));
  }, [l, n, i.floating, c, B]), Mt(() => {
    if (l && n && i.floating)
      if (a == null) {
        if (te.current = !1, le.current != null)
          return;
        if (U.current && (W.current = -1, X(o, W)), (!Y.current || !U.current) && F.current && (z.current != null || F.current === !0 && z.current == null)) {
          let $e = 0;
          const st = () => {
            o.current[0] == null ? ($e < 2 && ($e ? requestAnimationFrame : queueMicrotask)(st), $e++) : (W.current = z.current == null || Xv(z.current, S, m) || p ? Kv(o, re.current) : _P(o, re.current), z.current = null, B(W.current));
          };
          st();
        }
      } else zu(o, a) || (W.current = a, X(o, W, ne.current), ne.current = !1);
  }, [l, n, i.floating, a, le, p, o, S, m, B, X, re]), Mt(() => {
    var $e;
    if (!l || i.floating || !$ || g || !U.current)
      return;
    const st = $.nodesRef.current, Oe = ($e = st.find((pt) => pt.id === N)) == null || ($e = $e.context) == null ? void 0 : $e.elements.floating, He = Ai(Vn(i.floating)), Xt = st.some((pt) => pt.context && dn(pt.context.elements.floating, He));
    Oe && !Xt && G.current && Oe.focus({
      preventScroll: !0
    });
  }, [l, i.floating, $, N, g]), Mt(() => {
    if (!l || !$ || !g || N) return;
    function $e(st) {
      ve(st.id), O && (O.current = st);
    }
    return $.events.on("virtualfocus", $e), () => {
      $.events.off("virtualfocus", $e);
    };
  }, [l, $, g, N, O]), Mt(() => {
    V.current = B, U.current = !!i.floating;
  }), Mt(() => {
    n || (z.current = null);
  }, [n]), Mt(() => {
    Y.current = n;
  }, [n]);
  const Fe = a != null, pe = ee.useMemo(() => {
    function $e(Oe) {
      if (!n) return;
      const He = o.current.indexOf(Oe);
      He !== -1 && B(He);
    }
    return {
      onFocus(Oe) {
        let {
          currentTarget: He
        } = Oe;
        $e(He);
      },
      onClick: (Oe) => {
        let {
          currentTarget: He
        } = Oe;
        return He.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...y && {
        onMouseMove(Oe) {
          let {
            currentTarget: He
          } = Oe;
          $e(He);
        },
        onPointerLeave(Oe) {
          let {
            pointerType: He
          } = Oe;
          !G.current || He === "touch" || (W.current = -1, X(o, W), B(null), g || va(D.current, {
            preventScroll: !0
          }));
        }
      }
    };
  }, [n, D, X, y, o, B, g]), Be = kn(($e) => {
    if (G.current = !1, te.current = !0, $e.which === 229 || !ue.current && $e.currentTarget === D.current)
      return;
    if (p && FP($e.key, S, m)) {
      zn($e), r(!1, $e.nativeEvent, "list-navigation"), hn(i.domReference) && (g ? $ == null || $.events.emit("virtualfocus", i.domReference) : i.domReference.focus());
      return;
    }
    const st = W.current, Oe = Kv(o, w), He = _P(o, w);
    if (L || ($e.key === "Home" && (zn($e), W.current = Oe, B(W.current)), $e.key === "End" && (zn($e), W.current = He, B(W.current))), A > 1) {
      const Xt = T || Array.from({
        length: o.current.length
      }, () => ({
        width: 1,
        height: 1
      })), pt = dG(Xt, A, C), Qt = pt.findIndex((gn) => gn != null && !np(o.current, gn, w)), Hr = pt.reduce((gn, pr, tt) => pr != null && !np(o.current, pr, w) ? tt : gn, -1), Pn = pt[fG({
        current: pt.map((gn) => gn != null ? o.current[gn] : null)
      }, {
        event: $e,
        orientation: S,
        loop: d,
        rtl: m,
        cols: A,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: pG([...w || o.current.map((gn, pr) => np(o.current, pr) ? pr : void 0), void 0], pt),
        minIndex: Qt,
        maxIndex: Hr,
        prevIndex: hG(
          W.current > He ? Oe : W.current,
          Xt,
          pt,
          A,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          $e.key === sd ? "bl" : $e.key === (m ? Ta : Ca) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Pn != null && (W.current = Pn, B(W.current)), S === "both")
        return;
    }
    if (BP($e.key, S)) {
      if (zn($e), n && !g && Ai($e.currentTarget.ownerDocument) === $e.currentTarget) {
        W.current = Xv($e.key, S, m) ? Oe : He, B(W.current);
        return;
      }
      Xv($e.key, S, m) ? d ? W.current = st >= He ? f && st !== o.current.length ? -1 : Oe : Xn(o, {
        startingIndex: st,
        disabledIndices: w
      }) : W.current = Math.min(He, Xn(o, {
        startingIndex: st,
        disabledIndices: w
      })) : d ? W.current = st <= Oe ? f && st !== -1 ? o.current.length : He : Xn(o, {
        startingIndex: st,
        decrement: !0,
        disabledIndices: w
      }) : W.current = Math.max(Oe, Xn(o, {
        startingIndex: st,
        decrement: !0,
        disabledIndices: w
      })), zu(o, W.current) ? B(null) : B(W.current);
    }
  }), rt = ee.useMemo(() => g && n && Fe && {
    "aria-activedescendant": fe || ie
  }, [g, n, Fe, fe, ie]), at = ee.useMemo(() => ({
    "aria-orientation": S === "both" ? void 0 : S,
    ...!f0(i.domReference) && rt,
    onKeyDown: Be,
    onPointerMove() {
      G.current = !0;
    }
  }), [rt, Be, i.domReference, S]), Gn = ee.useMemo(() => {
    function $e(Oe) {
      v === "auto" && eD(Oe.nativeEvent) && (F.current = !0);
    }
    function st(Oe) {
      F.current = v, v === "auto" && Zw(Oe.nativeEvent) && (F.current = !0);
    }
    return {
      ...rt,
      onKeyDown(Oe) {
        G.current = !1;
        const He = Oe.key.startsWith("Arrow"), Xt = ["Home", "End"].includes(Oe.key), pt = He || Xt, Qt = LG(Oe.key, S, m), Hr = FP(Oe.key, S, m), Pn = BP(Oe.key, S), gn = (p ? Qt : Pn) || Oe.key === "Enter" || Oe.key.trim() === "";
        if (g && n) {
          const St = $ == null ? void 0 : $.nodesRef.current.find((Gr) => Gr.parentId == null), In = $ && St ? AG($.nodesRef.current, St.id) : null;
          if (pt && In && O) {
            const Gr = new KeyboardEvent("keydown", {
              key: Oe.key,
              bubbles: !0
            });
            if (Qt || Hr) {
              var pr, tt;
              const ao = ((pr = In.context) == null ? void 0 : pr.elements.domReference) === Oe.currentTarget, cn = Hr && !ao ? (tt = In.context) == null ? void 0 : tt.elements.domReference : Qt ? o.current.find((Pr) => (Pr == null ? void 0 : Pr.id) === ie) : null;
              cn && (zn(Oe), cn.dispatchEvent(Gr), ve(void 0));
            }
            if ((Pn || Xt) && In.context && In.context.open && In.parentId && Oe.currentTarget !== In.context.elements.domReference) {
              var Ht;
              zn(Oe), (Ht = In.context.elements.domReference) == null || Ht.dispatchEvent(Gr);
              return;
            }
          }
          return Be(Oe);
        }
        if (!(!n && !x && He)) {
          if (gn && (z.current = p && Pn ? null : Oe.key), p) {
            Qt && (zn(Oe), n ? (W.current = Kv(o, re.current), B(W.current)) : r(!0, Oe.nativeEvent, "list-navigation"));
            return;
          }
          Pn && (c != null && (W.current = c), zn(Oe), !n && x ? r(!0, Oe.nativeEvent, "list-navigation") : Be(Oe), n && B(W.current));
        }
      },
      onFocus() {
        n && !g && B(null);
      },
      onPointerDown: st,
      onMouseDown: $e,
      onClick: $e
    };
  }, [ie, rt, Be, re, v, o, p, B, r, n, x, S, m, c, $, g, O]);
  return ee.useMemo(() => l ? {
    reference: Gn,
    floating: at,
    item: pe
  } : {}, [l, Gn, at, pe]);
}
const FG = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function s1(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: r,
    floatingId: i
  } = e, {
    enabled: o = !0,
    role: a = "dialog"
  } = t, s = (n = FG.get(a)) != null ? n : a, l = og(), f = ag() != null, d = ee.useMemo(() => s === "tooltip" || a === "label" ? {
    ["aria-" + (a === "label" ? "labelledby" : "describedby")]: r ? i : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": s === "alertdialog" ? "dialog" : s,
    "aria-controls": r ? i : void 0,
    ...s === "listbox" && {
      role: "combobox"
    },
    ...s === "menu" && {
      id: l
    },
    ...s === "menu" && f && {
      role: "menuitem"
    },
    ...a === "select" && {
      "aria-autocomplete": "none"
    },
    ...a === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [s, i, f, r, l, a]), p = ee.useMemo(() => {
    const g = {
      id: i,
      ...s && {
        role: s
      }
    };
    return s === "tooltip" || a === "label" ? g : {
      ...g,
      ...s === "menu" && {
        "aria-labelledby": l
      }
    };
  }, [s, i, l, a]), m = ee.useCallback((g) => {
    let {
      active: v,
      selected: y
    } = g;
    const x = {
      role: "option",
      ...v && {
        id: i + "-option"
      }
    };
    switch (a) {
      case "select":
        return {
          ...x,
          "aria-selected": v && y
        };
      case "combobox":
        return {
          ...x,
          ...v && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [i, a]);
  return ee.useMemo(() => o ? {
    reference: d,
    floating: p,
    item: m
  } : {}, [o, d, p, m]);
}
const WP = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase());
function bl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function WG(e, t) {
  const [n, r] = ee.useState(e);
  return e && !n && r(!0), ee.useEffect(() => {
    if (!e && n) {
      const i = setTimeout(() => r(!1), t);
      return () => clearTimeout(i);
    }
  }, [e, n, t]), n;
}
function zG(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    elements: {
      floating: r
    }
  } = e, {
    duration: i = 250
  } = t, a = (typeof i == "number" ? i : i.close) || 0, [s, l] = ee.useState("unmounted"), c = WG(n, a);
  return !c && s === "close" && l("unmounted"), Mt(() => {
    if (r) {
      if (n) {
        l("initial");
        const f = requestAnimationFrame(() => {
          l("open");
        });
        return () => {
          cancelAnimationFrame(f);
        };
      }
      l("close");
    }
  }, [n, r]), {
    isMounted: c,
    status: s
  };
}
function OD(e, t) {
  t === void 0 && (t = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: r,
    close: i,
    common: o,
    duration: a = 250
  } = t, s = e.placement, l = s.split("-")[0], c = ee.useMemo(() => ({
    side: l,
    placement: s
  }), [l, s]), f = typeof a == "number", d = (f ? a : a.open) || 0, p = (f ? a : a.close) || 0, [m, g] = ee.useState(() => ({
    ...bl(o, c),
    ...bl(n, c)
  })), {
    isMounted: v,
    status: y
  } = zG(e, {
    duration: a
  }), x = Kn(n), w = Kn(r), S = Kn(i), A = Kn(o);
  return Mt(() => {
    const _ = bl(x.current, c), O = bl(S.current, c), T = bl(A.current, c), C = bl(w.current, c) || Object.keys(_).reduce((k, D) => (k[D] = "", k), {});
    if (y === "initial" && g((k) => ({
      transitionProperty: k.transitionProperty,
      ...T,
      ..._
    })), y === "open" && g({
      transitionProperty: Object.keys(C).map(WP).join(","),
      transitionDuration: d + "ms",
      ...T,
      ...C
    }), y === "close") {
      const k = O || _;
      g({
        transitionProperty: Object.keys(k).map(WP).join(","),
        transitionDuration: p + "ms",
        ...T,
        ...k
      });
    }
  }, [p, S, x, w, A, d, y, c]), {
    isMounted: v,
    styles: m
  };
}
function VG(e, t) {
  var n;
  const {
    open: r,
    dataRef: i
  } = e, {
    listRef: o,
    activeIndex: a,
    onMatch: s,
    onTypingChange: l,
    enabled: c = !0,
    findMatch: f = null,
    resetMs: d = 750,
    ignoreKeys: p = [],
    selectedIndex: m = null
  } = t, g = ee.useRef(), v = ee.useRef(""), y = ee.useRef((n = m ?? a) != null ? n : -1), x = ee.useRef(null), w = kn(s), S = kn(l), A = Kn(f), _ = Kn(p);
  Mt(() => {
    r && (clearTimeout(g.current), x.current = null, v.current = "");
  }, [r]), Mt(() => {
    if (r && v.current === "") {
      var D;
      y.current = (D = m ?? a) != null ? D : -1;
    }
  }, [r, m, a]);
  const O = kn((D) => {
    D ? i.current.typing || (i.current.typing = D, S(D)) : i.current.typing && (i.current.typing = D, S(D));
  }), T = kn((D) => {
    function N(W, z, G) {
      const V = A.current ? A.current(z, G) : z.find((U) => (U == null ? void 0 : U.toLocaleLowerCase().indexOf(G.toLocaleLowerCase())) === 0);
      return V ? W.indexOf(V) : -1;
    }
    const $ = o.current;
    if (v.current.length > 0 && v.current[0] !== " " && (N($, $, v.current) === -1 ? O(!1) : D.key === " " && zn(D)), $ == null || _.current.includes(D.key) || // Character key.
    D.key.length !== 1 || // Modifier key.
    D.ctrlKey || D.metaKey || D.altKey)
      return;
    r && D.key !== " " && (zn(D), O(!0)), $.every((W) => {
      var z, G;
      return W ? ((z = W[0]) == null ? void 0 : z.toLocaleLowerCase()) !== ((G = W[1]) == null ? void 0 : G.toLocaleLowerCase()) : !0;
    }) && v.current === D.key && (v.current = "", y.current = x.current), v.current += D.key, clearTimeout(g.current), g.current = setTimeout(() => {
      v.current = "", y.current = x.current, O(!1);
    }, d);
    const L = y.current, F = N($, [...$.slice((L || 0) + 1), ...$.slice(0, (L || 0) + 1)], v.current);
    F !== -1 ? (w(F), x.current = F) : D.key !== " " && (v.current = "", O(!1));
  }), C = ee.useMemo(() => ({
    onKeyDown: T
  }), [T]), k = ee.useMemo(() => ({
    onKeyDown: T,
    onKeyUp(D) {
      D.key === " " && O(!1);
    }
  }), [T, O]);
  return ee.useMemo(() => c ? {
    reference: C,
    floating: k
  } : {}, [c, C, k]);
}
function zP(e, t) {
  const [n, r] = e;
  let i = !1;
  const o = t.length;
  for (let a = 0, s = o - 1; a < o; s = a++) {
    const [l, c] = t[a] || [0, 0], [f, d] = t[s] || [0, 0];
    c >= r != d >= r && n <= (f - l) * (r - c) / (d - c) + l && (i = !i);
  }
  return i;
}
function UG(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function KG(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: r = !0
  } = e;
  let i, o = !1, a = null, s = null, l = performance.now();
  function c(d, p) {
    const m = performance.now(), g = m - l;
    if (a === null || s === null || g === 0)
      return a = d, s = p, l = m, null;
    const v = d - a, y = p - s, w = Math.sqrt(v * v + y * y) / g;
    return a = d, s = p, l = m, w;
  }
  const f = (d) => {
    let {
      x: p,
      y: m,
      placement: g,
      elements: v,
      onClose: y,
      nodeId: x,
      tree: w
    } = d;
    return function(A) {
      function _() {
        clearTimeout(i), y();
      }
      if (clearTimeout(i), !v.domReference || !v.floating || g == null || p == null || m == null)
        return;
      const {
        clientX: O,
        clientY: T
      } = A, C = [O, T], k = So(A), D = A.type === "mouseleave", N = dn(v.floating, k), $ = dn(v.domReference, k), B = v.domReference.getBoundingClientRect(), L = v.floating.getBoundingClientRect(), F = g.split("-")[0], W = p > L.right - L.width / 2, z = m > L.bottom - L.height / 2, G = UG(C, B), V = L.width > B.width, U = L.height > B.height, Y = (V ? B : L).left, te = (V ? B : L).right, ne = (U ? B : L).top, re = (U ? B : L).bottom;
      if (N && (o = !0, !D))
        return;
      if ($ && (o = !1), $ && !D) {
        o = !0;
        return;
      }
      if (D && Ct(A.relatedTarget) && dn(v.floating, A.relatedTarget) || w && Ts(w.nodesRef.current, x).some((le) => {
        let {
          context: ie
        } = le;
        return ie == null ? void 0 : ie.open;
      }))
        return;
      if (F === "top" && m >= B.bottom - 1 || F === "bottom" && m <= B.top + 1 || F === "left" && p >= B.right - 1 || F === "right" && p <= B.left + 1)
        return _();
      let ue = [];
      switch (F) {
        case "top":
          ue = [[Y, B.top + 1], [Y, L.bottom - 1], [te, L.bottom - 1], [te, B.top + 1]];
          break;
        case "bottom":
          ue = [[Y, L.top + 1], [Y, B.bottom - 1], [te, B.bottom - 1], [te, L.top + 1]];
          break;
        case "left":
          ue = [[L.right - 1, re], [L.right - 1, ne], [B.left + 1, ne], [B.left + 1, re]];
          break;
        case "right":
          ue = [[B.right - 1, re], [B.right - 1, ne], [L.left + 1, ne], [L.left + 1, re]];
          break;
      }
      function ae(le) {
        let [ie, Q] = le;
        switch (F) {
          case "top": {
            const fe = [V ? ie + t / 2 : W ? ie + t * 4 : ie - t * 4, Q + t + 1], ve = [V ? ie - t / 2 : W ? ie + t * 4 : ie - t * 4, Q + t + 1], X = [[L.left, W || V ? L.bottom - t : L.top], [L.right, W ? V ? L.bottom - t : L.top : L.bottom - t]];
            return [fe, ve, ...X];
          }
          case "bottom": {
            const fe = [V ? ie + t / 2 : W ? ie + t * 4 : ie - t * 4, Q - t], ve = [V ? ie - t / 2 : W ? ie + t * 4 : ie - t * 4, Q - t], X = [[L.left, W || V ? L.top + t : L.bottom], [L.right, W ? V ? L.top + t : L.bottom : L.top + t]];
            return [fe, ve, ...X];
          }
          case "left": {
            const fe = [ie + t + 1, U ? Q + t / 2 : z ? Q + t * 4 : Q - t * 4], ve = [ie + t + 1, U ? Q - t / 2 : z ? Q + t * 4 : Q - t * 4];
            return [...[[z || U ? L.right - t : L.left, L.top], [z ? U ? L.right - t : L.left : L.right - t, L.bottom]], fe, ve];
          }
          case "right": {
            const fe = [ie - t, U ? Q + t / 2 : z ? Q + t * 4 : Q - t * 4], ve = [ie - t, U ? Q - t / 2 : z ? Q + t * 4 : Q - t * 4], X = [[z || U ? L.left + t : L.right, L.top], [z ? U ? L.left + t : L.right : L.left + t, L.bottom]];
            return [fe, ve, ...X];
          }
        }
      }
      if (!zP([O, T], ue)) {
        if (o && !G)
          return _();
        if (!D && r) {
          const le = c(A.clientX, A.clientY);
          if (le !== null && le < 0.1)
            return _();
        }
        zP([O, T], ae([p, m])) ? !o && r && (i = window.setTimeout(_, 40)) : _();
      }
    };
  };
  return f.__options = {
    blockPointerEvents: n
  }, f;
}
const cd = "light", AD = "neutral", HG = "button", GG = ({
  theme: e = cd,
  variant: t = AD
}) => {
  let n = e === "light" ? "text-icon-secondary" : "text-icon-inverse";
  return n = {
    info: e === "light" ? "text-support-info" : "text-support-info-inverse",
    success: e === "light" ? "text-support-success" : "text-support-success-inverse",
    warning: e === "light" ? "text-support-warning" : "text-support-warning-inverse",
    error: e === "light" ? "text-support-error" : "text-support-error-inverse"
  }[t] || n, n;
}, vp = ({
  icon: e,
  theme: t = cd,
  variant: n = AD
}) => {
  var a;
  const r = "[&>svg]:h-5 [&>svg]:w-5", i = GG({ theme: t, variant: n });
  if (e && ut(e))
    return _t(e, {
      className: H(
        r,
        i,
        ((a = e == null ? void 0 : e.props) == null ? void 0 : a.className) ?? ""
      )
    });
  const o = {
    neutral: /* @__PURE__ */ E(s0, { className: H(r, i) }),
    info: /* @__PURE__ */ E(s0, { className: H(r, i) }),
    success: /* @__PURE__ */ E(od, { className: H(r, i) }),
    warning: /* @__PURE__ */ E(HK, { className: H(r, i) }),
    error: /* @__PURE__ */ E(UK, { className: H(r, i) })
  };
  return o[n] || o.neutral;
}, g0 = ({
  actionType: e = HG,
  onAction: t = () => {
  },
  actionLabel: n = "",
  theme: r = cd
}) => {
  const i = "focus:ring-0 focus:ring-offset-0 ring-offset-0 focus:outline-none";
  let o = "text-button-primary border-button-primary hover:border-button-primary hover:text-button-primary-hover";
  switch (r === "dark" && (o = "text-text-inverse border-text-inverse hover:border-text-inverse hover:text-text-inverse"), e) {
    case "button":
      return /* @__PURE__ */ E(
        Qn,
        {
          variant: "outline",
          size: "xs",
          onClick: t,
          className: H(
            "rounded",
            i,
            o,
            r === "dark" ? "bg-transparent hover:bg-transparent" : "bg-white hover:bg-white"
          ),
          children: n
        }
      );
    case "link":
      return /* @__PURE__ */ E(
        Qn,
        {
          variant: "link",
          size: "xs",
          onClick: t,
          className: H(i, o),
          children: n
        }
      );
    default:
      return null;
  }
}, bp = ({
  theme: e = cd,
  title: t = "",
  inline: n = !1
}) => t ? /* @__PURE__ */ E(
  "span",
  {
    className: H(
      "block",
      {
        light: "text-text-primary",
        dark: "text-text-inverse"
      }[e],
      "text-sm leading-5 font-semibold",
      n ? "inline" : "block"
    ),
    children: t
  }
) : null, xp = ({
  theme: e = cd,
  content: t = "",
  inline: n = !1
}) => t ? /* @__PURE__ */ E(
  "span",
  {
    className: H(
      {
        light: "text-text-primary",
        dark: "text-text-inverse"
      }[e],
      "block text-sm [&_*]:text-sm leading-5 [&_*]:leading-5 font-normal",
      n ? "inline" : "block"
    ),
    children: t
  }
) : null, y0 = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, l1 = ({
  variant: e = "dark",
  // 'light' | 'dark';
  placement: t = "bottom",
  //  | 'top' | 'top-start' | 'top-end' | 'right' | 'right-start' | 'right-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end';
  title: n = "",
  content: r,
  arrow: i = !1,
  open: o,
  setOpen: a,
  children: s,
  className: l,
  tooltipPortalRoot: c,
  // Root element where the dropdown will be rendered.
  tooltipPortalId: f,
  // Id of the dropdown portal where the dropdown will be rendered.
  boundary: d = "clippingAncestors",
  strategy: p = "fixed",
  // 'fixed' | 'absolute';
  offset: m = 8,
  // Offset option or number value. Default is 8.
  triggers: g = ["hover", "focus"],
  // 'click' | 'hover' | 'focus';
  interactive: v = !1
}) => {
  const y = Le(
    () => typeof o == "boolean" && typeof a == "function",
    [o, a]
  ), [x, w] = Me(!1), S = ft(null), { refs: A, floatingStyles: _, context: O } = ug({
    open: y ? o : x,
    onOpenChange: y ? a : w,
    placement: t,
    strategy: p,
    middleware: [
      rg(m),
      ig({ boundary: d }),
      // Ensure this is correctly cast
      pD({ boundary: d }),
      // Ensure this is correctly cast
      lG({ element: S })
    ],
    whileElementsMounted: ng
  }), T = a1(O, {
    enabled: !y && g.includes("click")
  }), C = SG(O, {
    move: !1,
    enabled: !y && g.includes("hover"),
    ...v && { handleClose: KG() }
  }), k = jG(O, {
    enabled: !y && g.includes("focus")
  }), D = cg(O), N = s1(O, { role: "tooltip" }), { getReferenceProps: $, getFloatingProps: B } = fg([
    T,
    C,
    k,
    D,
    N
  ]), { isMounted: L, styles: F } = OD(O, {
    duration: 150,
    initial: { opacity: 0 },
    open: { opacity: 1 },
    close: { opacity: 0 }
  }), W = "absolute z-20 py-2 px-3 rounded-md text-xs leading-4 shadow-soft-shadow-lg", z = {
    light: "bg-tooltip-background-light text-text-primary",
    dark: "bg-tooltip-background-dark text-text-on-color"
  }[e], G = e === "dark" ? "text-tooltip-background-dark" : "text-tooltip-background-light";
  return /* @__PURE__ */ me(fi, { children: [
    ut(s) && /* @__PURE__ */ E(fi, { children: _t(s, {
      ref: y0(
        s.ref,
        A.setReference
      ),
      className: H(s.props.className),
      ...$()
    }) }, "tooltip-reference"),
    /* @__PURE__ */ E(lg, { id: f, root: c, children: L && /* @__PURE__ */ me(
      "div",
      {
        className: H(
          W,
          z,
          "max-w-80 w-fit",
          l
        ),
        ref: A.setFloating,
        style: {
          ..._,
          ...F
        },
        ...B(),
        children: [
          /* @__PURE__ */ me("div", { children: [
            !!n && /* @__PURE__ */ E(
              "span",
              {
                className: "font-semibold",
                children: n
              },
              "tooltip-title"
            ),
            !!r && /* @__PURE__ */ E(
              "div",
              {
                className: "font-normal",
                children: r
              },
              "tooltip-content"
            )
          ] }),
          i && /* @__PURE__ */ E(
            bG,
            {
              ref: S,
              context: O,
              className: H("fill-current", G)
            }
          )
        ]
      }
    ) })
  ] });
};
l1.displayName = "Tooltip";
const PD = ht({}), TD = () => Ve(PD), CD = ({
  children: e,
  name: t,
  style: n = "simple",
  size: r = "md",
  value: i,
  defaultValue: o,
  by: a = "id",
  as: s = "div",
  onChange: l,
  className: c,
  disableGroup: f = !1,
  vertical: d = !1,
  columns: p = 4,
  multiSelection: m = !1,
  gapClassName: g = "gap-2"
}) => {
  const v = Le(() => typeof i < "u", [i]), y = Le(
    () => t || `radio-button-group-${no()}`,
    [t]
  );
  let x;
  v ? x = i : m ? x = o ?? [] : x = o;
  const [w, S] = Me(x), A = Je(
    (T) => {
      if (m)
        S((C) => {
          const k = Array.isArray(C) && typeof T == "string" && C.includes(T);
          let D;
          return k ? D = C.filter(
            (N) => N !== T
          ) : D = [
            ...Array.isArray(C) ? C : [],
            ...typeof T == "string" ? [T] : []
          ], typeof l == "function" && l(D), D;
        });
      else {
        if (v || S(T), typeof l != "function")
          return;
        l(T);
      }
    },
    [l]
  );
  c = H(
    "grid grid-cols-4",
    TK[p],
    g,
    n === "tile" && "gap-0",
    d && "grid-cols-1",
    c
  );
  const _ = H(
    n === "tile" ? "border border-border-subtle border-solid rounded-md shadow-sm" : "gap-6",
    c
  ), O = () => /* @__PURE__ */ E(
    PD.Provider,
    {
      value: {
        name: y,
        value: v ? i : w,
        by: a,
        onChange: A,
        isControlled: v,
        disableAll: f,
        style: n,
        columns: p,
        multiSelection: m,
        size: r
      },
      children: I.Children.map(e, (T) => ut(T) ? T : null)
    }
  );
  return /* @__PURE__ */ E(Ut, { children: n === "tile" ? /* @__PURE__ */ E("div", { className: _, children: O() }) : /* @__PURE__ */ E(s, { ...s === fi ? {} : { className: c }, children: O() }) });
};
CD.displayName = "RadioButton.Group";
const YG = ({
  id: e,
  label: t,
  value: n,
  children: r,
  disabled: i,
  icon: o = null,
  inlineIcon: a = !1,
  hideSelection: s = !1,
  reversePosition: l = !1,
  borderOn: c = !1,
  borderOnActive: f = !0,
  badgeItem: d = null,
  useSwitch: p = !1,
  info: m = void 0,
  minWidth: g = !0,
  ...v
}, y) => {
  var G, V;
  const { buttonWrapperClasses: x, ...w } = v, S = TD(), {
    name: A,
    value: _,
    by: O,
    onChange: T,
    disableAll: C,
    checked: k,
    multiSelection: D,
    size: N = "md"
    // Default size to 'md' if not provided
  } = S, $ = "primary", B = Le(() => e || `radio-button-${no()}`, [e]), L = Le(
    () => C || i,
    [C, i]
  ), F = Le(() => D ? Array.isArray(_) && _.includes(n) : typeof k < "u" ? k : typeof _ != typeof n ? !1 : typeof _ == "string" ? _ === n : Array.isArray(_) ? _.includes(n) : _[O] === n[O], [_, n, k]), W = Je(() => ut(t) ? t : t != null && t.heading ? /* @__PURE__ */ me(
    "div",
    {
      className: H(
        !a && "space-y-1.5 mt-[2px]",
        l && (p ? "ml-10" : "ml-4"),
        a && "flex gap-2",
        a && !t.description && "items-center"
      ),
      children: [
        o && /* @__PURE__ */ E(Ut, { children: o }),
        /* @__PURE__ */ me("div", { className: H("space-y-1.5"), children: [
          /* @__PURE__ */ E(
            "p",
            {
              className: H(
                "text-text-primary font-medium m-0",
                qK[N],
                i && "text-text-disabled cursor-not-allowed"
              ),
              children: t.heading
            }
          ),
          t.description && /* @__PURE__ */ E("p", { className: "text-text-tertiary text-sm font-normal leading-5 m-0", children: t.description })
        ] })
      ]
    }
  ) : null, [t]);
  if (S.style === "tile")
    return /* @__PURE__ */ E(
      qG,
      {
        id: e,
        label: t,
        value: n,
        disabled: i,
        size: N,
        children: r
      }
    );
  const z = () => {
    L || (D ? p && T(n, !F) : T(n));
  };
  return /* @__PURE__ */ me(
    "label",
    {
      className: H(
        "inline-flex items-center relative cursor-pointer transition-all duration-300",
        !!t && "items-start justify-between",
        g && "min-w-[180px]",
        c && "border border-border-subtle border-solid rounded-md shadow-sm hover:ring-2 hover:ring-border-interactive",
        f && c && F && "ring-2 ring-border-interactive",
        N === "sm" ? "px-3 py-3" : "px-4 py-4",
        "pr-12",
        L && "cursor-not-allowed opacity-40",
        x
      ),
      htmlFor: B,
      onClick: z,
      children: [
        !!t && /* @__PURE__ */ E(
          "label",
          {
            className: H(
              "cursor-pointer",
              L && "cursor-not-allowed"
            ),
            htmlFor: B,
            children: W()
          }
        ),
        !!m && /* @__PURE__ */ E("div", { className: "absolute mr-0.5 bottom-1.5 right-3", children: /* @__PURE__ */ E(l1, { title: m == null ? void 0 : m.heading, content: m == null ? void 0 : m.description, children: /* @__PURE__ */ E(
          s0,
          {
            className: H(
              "text-text-primary",
              (G = Wv[N]) == null ? void 0 : G.info
            )
          }
        ) }) }),
        /* @__PURE__ */ me(
          "label",
          {
            className: H(
              "absolute mr-0.5 right-3 flex items-center cursor-pointer rounded-full gap-2",
              l && "left-0",
              L && "cursor-not-allowed",
              a && "mr-3",
              p ? mP[N].switch : mP[N].radio
            ),
            onClick: z,
            children: [
              !!d && d,
              !s && (p ? /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(
                U$,
                {
                  defaultValue: !1,
                  size: N,
                  onChange: () => {
                    D ? T(n, !F) : T(n);
                  },
                  checked: F,
                  ...w,
                  "aria-label": (t == null ? void 0 : t.heading) ?? "Switch"
                }
              ) }) : /* @__PURE__ */ me("span", { className: "relative p-0.5", children: [
                /* @__PURE__ */ E(
                  "input",
                  {
                    ref: y,
                    id: B,
                    type: D ? "checkbox" : "radio",
                    className: H(
                      "peer flex relative cursor-pointer appearance-none transition-all m-0 before:content-[''] checked:before:content-[''] checked:before:hidden before:hidden !border-1.5 border-solid",
                      !D && "rounded-full",
                      hP[$].checkbox,
                      Wv[N].checkbox,
                      L && pP.checkbox
                    ),
                    name: A,
                    value: n,
                    onChange: (U) => T(U.target.value),
                    checked: F,
                    disabled: L,
                    ...w
                  }
                ),
                /* @__PURE__ */ E(
                  "span",
                  {
                    className: H(
                      "inline-flex items-center absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100",
                      hP[$].icon,
                      L && pP.icon
                    ),
                    children: D ? /* @__PURE__ */ E(
                      od,
                      {
                        className: N === "sm" ? "size-3" : "size-4"
                      }
                    ) : /* @__PURE__ */ E(
                      "div",
                      {
                        className: H(
                          "rounded-full bg-current",
                          N === "sm" && "mt-[0.5px]",
                          (V = Wv[N]) == null ? void 0 : V.icon
                        )
                      }
                    )
                  }
                )
              ] }))
            ]
          }
        )
      ]
    }
  );
}, v0 = $t(YG);
v0.displayName = "RadioButton.Button";
const qG = ({
  id: e,
  children: t,
  value: n,
  disabled: r,
  size: i = "md",
  ...o
}) => {
  const a = TD(), {
    name: s,
    value: l,
    by: c,
    onChange: f,
    disableAll: d,
    checked: p
  } = a || {}, m = Le(() => e || `radio-button-${no()}`, [e]), g = Le(
    () => d || r,
    [d, r]
  ), v = Le(() => typeof p < "u" ? p : typeof l != typeof n ? !1 : typeof l == "string" ? l === n : Array.isArray(l) ? l.includes(n) : l && c ? l[c] === n[c] : !1, [l, n, p, c]), y = () => {
    f && f(n);
  }, w = H(
    JK,
    QK,
    eH,
    g ? "text-text-disabled cursor-not-allowed" : "",
    XK[i],
    ZK
  );
  return /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ me(
    "button",
    {
      type: "button",
      id: m,
      "aria-label": "Radio Button",
      className: H(
        w,
        "first:rounded-tl first:rounded-bl first:border-0 first:border-r first:border-border-subtle last:rounded-tr last:rounded-br last:border-0",
        v && "bg-button-disabled"
      ),
      onClick: y,
      disabled: g,
      ...o,
      children: [
        /* @__PURE__ */ E(
          "input",
          {
            type: "hidden",
            value: n,
            name: s,
            checked: v,
            onChange: (S) => f == null ? void 0 : f(S.target.value)
          }
        ),
        t
      ]
    }
  ) });
}, _Ee = Object.assign(v0, {
  Group: CD,
  Button: v0
}), hg = $t(
  ({
    label: e = "",
    size: t = "sm",
    // xxs, xs, sm, md, lg
    className: n = "",
    type: r = "pill",
    // pill, rounded
    variant: i = "neutral",
    // neutral, red, yellow, green, blue, inverse
    icon: o = null,
    disabled: a = !1,
    onClose: s = () => {
    },
    closable: l = !1,
    onMouseDown: c = () => {
    }
  }, f) => {
    const d = "font-medium border-badge-border-gray flex items-center justify-center border border-solid box-border max-w-full", p = {
      xxs: "py-0.5 px-0.5 text-xs h-4",
      xs: "py-0.5 px-1 text-xs h-5",
      sm: "py-1 px-1.5 text-xs h-6",
      md: "py-1 px-1.5 text-sm h-7",
      lg: "py-1 px-1.5 text-base h-8"
    }, m = {
      pill: "rounded-full",
      rounded: "rounded"
    }, g = {
      neutral: "bg-badge-background-gray hover:bg-badge-hover-gray text-badge-color-gray border-badge-border-gray",
      red: "bg-badge-background-red hover:bg-badge-hover-red text-badge-color-red border-badge-border-red",
      yellow: "bg-badge-background-yellow hover:bg-badge-hover-yellow text-badge-color-yellow border-badge-border-yellow",
      green: "bg-badge-background-green hover:bg-badge-hover-green text-badge-color-green border-badge-border-green",
      blue: "bg-badge-background-sky hover:bg-badge-hover-sky text-badge-color-sky border-badge-border-sky",
      inverse: "bg-background-inverse hover:bg-badge-hover-inverse text-text-inverse border-background-inverse",
      disabled: "bg-badge-background-disabled hover:bg-badge-hover-disabled text-badge-color-disabled border-badge-border-disabled disabled cursor-not-allowed"
    };
    let v = "", y = "group relative justify-center flex items-center cursor-pointer";
    const x = {
      xxs: "[&>svg]:size-3",
      xs: "[&>svg]:size-3",
      sm: "[&>svg]:size-3",
      md: "[&>svg]:size-4",
      lg: "[&>svg]:size-5"
    };
    return a ? (v = g.disabled, y += " cursor-not-allowed disabled") : v = g[i], e ? /* @__PURE__ */ me(
      "span",
      {
        className: H(
          d,
          p[t],
          m[r],
          "gap-0.5",
          v,
          n
        ),
        ref: f,
        children: [
          o ? /* @__PURE__ */ E(
            "span",
            {
              className: H(
                "justify-center flex items-center",
                x[t]
              ),
              children: o
            }
          ) : null,
          /* @__PURE__ */ E("span", { className: "px-1 truncate", children: e }),
          l && /* @__PURE__ */ me(
            "span",
            {
              className: H(y, x[t]),
              onMouseDown: c,
              role: "button",
              tabIndex: 0,
              ...!a && {
                onClick: s
              },
              children: [
                /* @__PURE__ */ E("span", { className: "sr-only", children: `Remove ${e}` }),
                /* @__PURE__ */ E(Na, {}),
                /* @__PURE__ */ E("span", { className: "absolute -inset-1" })
              ]
            }
          )
        ]
      }
    ) : null;
  }
);
hg.displayName = "Badge";
const XG = ({
  id: e,
  defaultValue: t = "",
  value: n,
  size: r = "sm",
  // sm, md, lg
  className: i = "",
  disabled: o = !1,
  onChange: a = () => {
  },
  error: s = !1,
  onError: l = () => {
  },
  ...c
}, f) => {
  const d = Le(() => e || `input-textarea-${no()}`, [e]), p = Le(() => typeof n < "u", [n]), [m, g] = Me(t), v = Je(
    () => p ? n : m,
    [p, n, m]
  ), y = (T) => {
    if (o)
      return;
    const C = T.target.value;
    p || g(C), typeof a == "function" && a(C);
  }, x = "py-2 rounded border border-solid border-border-subtle bg-field-secondary-background font-normal placeholder-text-tertiary text-text-primary focus:outline-none", w = {
    sm: "px-3 rounded text-xs",
    md: "px-3 rounded-md text-sm",
    lg: "px-4 rounded-lg text-base"
  }, S = o ? "hover:border-border-disabled" : "hover:border-border-strong", A = "focus:border-focus-border focus:ring-2 focus:ring-toggle-on focus:ring-offset-2", _ = s ? "focus:border-focus-error-border focus:ring-field-color-error border-focus-error-border" : "";
  return /* @__PURE__ */ E(
    "textarea",
    {
      ref: f,
      id: d,
      className: H(
        x,
        o ? "border-border-disabled bg-field-background-disabled cursor-not-allowed text-text-disabled" : "",
        w[r],
        A,
        S,
        _,
        i
      ),
      disabled: o,
      onChange: y,
      onInvalid: l,
      value: v(),
      ...c
    }
  );
}, ZG = $t(XG);
ZG.displayName = "TextArea";
const SEe = $t(
  ({
    variant: e = "primary",
    size: t = "md",
    border: n = "subtle",
    src: r,
    alt: i,
    children: o,
    className: a,
    ...s
  }, l) => {
    const [c, f] = Me(!1), d = r && n === "none" ? "subtle" : n, p = "rounded-full overflow-hidden flex items-center justify-center", m = {
      white: "text-text-primary bg-background-primary",
      gray: "text-text-primary bg-background-secondary",
      primary: "text-text-on-color bg-background-brand",
      "primary-light": "text-text-primary bg-brand-background-50",
      dark: "text-text-on-color bg-button-secondary"
    }[e], g = {
      xxs: "size-5 [&>svg]:size-3 text-xs",
      xs: "size-6 [&>svg]:size-4 text-sm",
      sm: "size-8 [&>svg]:size-5 text-base",
      md: "size-10 [&>svg]:size-6 text-lg",
      lg: "size-12 [&>svg]:size-12 text-lg"
    }[t], v = {
      none: "",
      subtle: "ring-1 ring-border-transparent-subtle",
      ring: "ring ring-border-subtle"
    }[d], y = r ? "object-cover object-center" : "", x = () => {
      var _, O, T;
      if (r && c) {
        if (i && typeof i == "string")
          return (_ = i == null ? void 0 : i[0]) == null ? void 0 : _.toUpperCase();
        if (o && typeof o == "string")
          return (O = o == null ? void 0 : o[0]) == null ? void 0 : O.toUpperCase();
        if (!o && !i)
          return /* @__PURE__ */ E(GK, {});
      }
      return o ? typeof o == "string" ? (T = o == null ? void 0 : o[0]) == null ? void 0 : T.toUpperCase() : o : null;
    }, w = () => {
      f(!0);
    }, S = !r || c, A = S ? "div" : "img";
    return Qe(() => {
      f(!1);
    }, [r]), /* @__PURE__ */ E(
      A,
      {
        ref: l,
        className: H(
          p,
          S && m,
          g,
          v,
          y,
          a
        ),
        ...S ? { children: x() } : { src: r, alt: i, onError: w },
        ...s
      }
    );
  }
), JG = ({
  id: e,
  type: t = "text",
  defaultValue: n = "",
  value: r,
  size: i = "sm",
  // sm, md, lg
  className: o = "",
  disabled: a = !1,
  onChange: s = () => {
  },
  error: l = !1,
  onError: c = () => {
  },
  prefix: f = null,
  suffix: d = null,
  label: p = "",
  ...m
}, g) => {
  const v = ft(null), y = Le(() => e || `input-${t}-${no()}`, [e]), x = Le(() => typeof r < "u", [r]), [w, S] = Me(n), [A, _] = Me(null), O = Je(
    () => x ? r : w,
    [x, r, w]
  ), T = (ie) => {
    if (a)
      return;
    let Q;
    t === "file" ? (Q = ie.target.files, Q && Q.length > 0 ? _(Q[0].name) : _(null)) : Q = ie.target.value, !x && t !== "file" && S(Q), typeof s == "function" && s(Q);
  }, C = () => {
    _(null), v.current && (v.current.value = ""), s(null);
  }, k = "bg-field-secondary-background font-normal placeholder-text-tertiary text-text-primary w-full outline outline-1 outline-border-subtle border-none transition-[color,box-shadow,outline] duration-200", D = {
    xs: "px-2 py-1 rounded",
    sm: "p-3 py-2 rounded",
    md: "p-3.5 py-2.5 rounded-md",
    lg: "p-4 py-3 rounded-lg"
  }, N = {
    xs: "text-xs font-medium",
    sm: "text-sm font-medium",
    md: "text-sm font-medium",
    lg: "text-base font-medium"
  }, $ = {
    xs: "text-xs",
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  }, B = {
    sm: f ? "pl-8" : "",
    md: f ? "pl-9" : "",
    lg: f ? "pl-10" : ""
  }, L = {
    sm: d ? "pr-8" : "",
    md: d ? "pr-9" : "",
    lg: d ? "pr-10" : ""
  }, F = a ? "hover:outline-border-disabled" : "hover:outline-border-strong", W = "focus:outline-focus-border focus:ring-2 focus:ring-toggle-on focus:ring-offset-2", z = l ? "focus:outline-focus-error-border focus:ring-field-color-error outline-focus-error-border" : "", G = l ? "focus:outline-focus-error-border focus:ring-field-color-error outline-focus-error-border" : "", V = a ? "outline-border-disabled bg-field-background-disabled cursor-not-allowed text-text-disabled" : "", U = a ? "outline-border-disabled cursor-not-allowed text-text-disabled file:text-text-tertiary" : "", Y = "font-normal placeholder-text-tertiary text-text-primary pointer-events-none absolute inset-y-0 flex flex-1 items-center [&>svg]:h-4 [&>svg]:w-4", te = a ? "font-normal placeholder-text-tertiary text-icon-disabled pointer-events-none absolute inset-y-0 flex flex-1 items-center" : "font-normal placeholder-text-tertiary text-field-placeholder pointer-events-none absolute inset-y-0 flex flex-1 items-center", ne = {
    xs: "[&>svg]:size-4",
    sm: "[&>svg]:size-4",
    md: "[&>svg]:size-5",
    lg: "[&>svg]:size-6"
  }, re = () => f ? /* @__PURE__ */ E("div", { className: H(Y, "left-0 pl-3", $[i]), children: f }) : null, ue = () => t === "file" ? A ? /* @__PURE__ */ E(
    "div",
    {
      className: H(
        te,
        "right-0 pr-3 cursor-pointer z-20 pointer-events-auto",
        ne[i]
      ),
      onClick: C,
      role: "button",
      tabIndex: 0,
      onKeyDown: (ie) => {
        (ie.key === "Enter" || ie.key === " ") && C();
      },
      children: /* @__PURE__ */ E(Na, {})
    }
  ) : /* @__PURE__ */ E(
    "div",
    {
      className: H(
        te,
        "right-0 pr-3",
        ne[i]
      ),
      children: /* @__PURE__ */ E(dP, {})
    }
  ) : d ? /* @__PURE__ */ E("div", { className: H(Y, "right-0 pr-3", $[i]), children: d }) : null, ae = Le(() => p ? /* @__PURE__ */ E(
    Ma,
    {
      className: H(N[i]),
      htmlFor: y,
      ...(m == null ? void 0 : m.required) && { required: !0 },
      children: p
    }
  ) : null, [p, i, y]), le = A ? "file:border-0 file:bg-transparent pr-10" : "text-text-tertiary file:border-0 file:bg-transparent pr-10";
  return t === "file" ? /* @__PURE__ */ me("div", { className: "flex flex-col items-start gap-1.5 [&_*]:box-border box-border", children: [
    ae,
    /* @__PURE__ */ me(
      "div",
      {
        className: H(
          "w-full relative flex focus-within:z-10",
          o
        ),
        children: [
          /* @__PURE__ */ E(
            "input",
            {
              ref: y0(v, g),
              id: y,
              type: "file",
              className: H(
                k,
                U,
                D[i],
                $[i],
                W,
                F,
                G,
                le
              ),
              disabled: a,
              onChange: T,
              onInvalid: c,
              ...m
            }
          ),
          /* @__PURE__ */ E(
            "div",
            {
              className: H(
                te,
                "right-0 pr-3",
                ne[i]
              ),
              children: /* @__PURE__ */ E(dP, {})
            }
          )
        ]
      }
    )
  ] }) : /* @__PURE__ */ me("div", { className: "flex flex-col items-start gap-1.5 [&_*]:box-border box-border", children: [
    ae,
    /* @__PURE__ */ me(
      "div",
      {
        className: H(
          "w-full relative flex focus-within:z-10",
          o
        ),
        children: [
          re(),
          /* @__PURE__ */ E(
            "input",
            {
              ref: y0(v, g),
              id: y,
              type: t,
              className: H(
                k,
                V,
                D[i],
                $[i],
                B[i],
                L[i],
                W,
                F,
                z
              ),
              disabled: a,
              onChange: T,
              onInvalid: c,
              value: O(),
              ...m
            }
          ),
          ue()
        ]
      }
    )
  ] });
}, QG = $t(JG);
QG.displayName = "Input";
const OEe = ({
  title: e = "",
  description: t = "",
  icon: n = null,
  iconPosition: r = "right",
  // left, right
  tag: i = "h2",
  // h1, h2, h3, h4, h5, h6
  size: o = "sm",
  // xs, sm, md, lg
  className: a = ""
}) => {
  const s = {
    xs: "gap-1 [&>svg]:size-3.5",
    sm: "gap-1 [&>svg]:size-4",
    md: "gap-1.5 [&>svg]:size-5",
    lg: "gap-1.5 [&>svg]:size-5"
  };
  if (!e)
    return null;
  const l = () => /* @__PURE__ */ E(i, { className: H("font-semibold p-0 m-0", {
    xs: "text-base [&>*]:text-base gap-1",
    sm: "text-lg [&>*]:text-lg gap-1",
    md: "text-xl [&>*]:text-xl gap-1.5",
    lg: "text-2xl [&>*]:text-2xl gap-1.5"
  }[o]), children: e }), c = () => /* @__PURE__ */ E(
    "p",
    {
      className: H(
        "text-text-secondary font-normal my-0",
        {
          xs: "text-sm",
          sm: "text-sm",
          md: "text-base",
          lg: "text-base"
        }[o]
      ),
      children: t
    }
  );
  return t ? /* @__PURE__ */ me("div", { className: a, children: [
    /* @__PURE__ */ me("div", { children: [
      n && r === "left" && /* @__PURE__ */ me("div", { className: H("flex items-center", s[o]), children: [
        n,
        l()
      ] }),
      n && r === "right" && /* @__PURE__ */ me("div", { className: H("flex items-center", s[o]), children: [
        l(),
        n
      ] }),
      !n && l()
    ] }),
    c()
  ] }) : /* @__PURE__ */ me("div", { className: a, children: [
    n && r === "left" && /* @__PURE__ */ me("div", { className: H("flex items-center", s[o]), children: [
      n,
      l()
    ] }),
    n && r === "right" && /* @__PURE__ */ me("div", { className: H("flex items-center", s[o]), children: [
      l(),
      n
    ] }),
    !n && l()
  ] });
}, ED = ({
  variant: e = "primary",
  // primary, secondary
  size: t = "md",
  // sm, md, lg, xl,
  icon: n = null,
  className: r = ""
}) => {
  const i = {
    primary: "text-brand-primary-600",
    secondary: "text-background-primary"
  }[e], o = {
    sm: "[&>svg]:size-4",
    md: "[&>svg]:size-5",
    lg: "[&>svg]:size-6",
    xl: "[&>svg]:size-8"
  }[t];
  return /* @__PURE__ */ E(
    "span",
    {
      className: H("flex", o, i, r),
      children: n || /* @__PURE__ */ E(WK, { className: "animate-spin shrink-0" })
    }
  );
}, AEe = ({
  progress: e = 0,
  // 0-100
  speed: t = 200,
  className: n = ""
}) => {
  let r = e;
  e < 0 && (r = 0), e > 100 && (r = 100);
  const i = `translateX(-${100 - r}%)`, o = `h-2 rounded-full bg-background-brand absolute left-0 top-0 w-full bottom-0 origin-left transition-transform duration-${t} ease-linear`;
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "h-2 rounded-full bg-misc-progress-background overflow-hidden relative",
        n
      ),
      role: "progressbar",
      "aria-valuenow": r,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-label": "Progress Bar",
      children: /* @__PURE__ */ E(
        "div",
        {
          className: o,
          style: {
            transform: i
          }
        }
      )
    }
  );
}, kD = ht({
  activeItem: null,
  onChange: () => {
  },
  size: "md",
  iconPosition: "left"
}), eY = ({
  children: e,
  activeItem: t = null,
  onChange: n,
  className: r,
  size: i = "md",
  iconPosition: o = "left"
}) => {
  const a = Je(
    (l) => {
      n && n(l);
    },
    [n]
  ), s = H(
    "box-border flex border border-border-subtle border-solid rounded",
    r
  );
  return /* @__PURE__ */ E("div", { className: s, children: /* @__PURE__ */ E(
    kD.Provider,
    {
      value: {
        activeItem: t,
        onChange: a,
        size: i,
        iconPosition: o
      },
      children: I.Children.map(e, (l, c) => {
        if (!ut(l))
          return null;
        const f = c === 0, d = c === I.Children.count(e) - 1;
        return I.cloneElement(l, {
          ...l.props,
          index: c,
          isFirstChild: f,
          isLastChild: d
        });
      })
    }
  ) });
}, tY = ({
  slug: e,
  text: t,
  icon: n,
  className: r,
  disabled: i = !1,
  isFirstChild: o,
  isLastChild: a,
  ...s
}, l) => {
  const c = I.useContext(kD);
  if (!c)
    throw new Error("Button should be used inside Button Group");
  const { activeItem: f, onChange: d, size: p, iconPosition: m } = c, g = {
    xs: "py-1 px-1 text-sm gap-0.5 [&>svg]:size-4",
    sm: "py-2 px-2 text-base gap-1 [&>svg]:size-4",
    md: "py-2.5 px-2.5 text-base gap-1 [&>svg]:size-5"
  }, v = "bg-background-primary text-primary cursor-pointer flex items-center justify-center", y = "hover:bg-button-tertiary-hover", x = "focus:outline-none", w = i ? "text-text-disabled cursor-not-allowed" : "", S = o ? "rounded-tl rounded-bl border-0 border-r border-border-subtle" : "", A = a ? "rounded-tr rounded-br border-0" : "", _ = "border-0 border-r border-border-subtle border-solid", O = f === e ? "bg-button-disabled" : "", T = H(
    v,
    y,
    x,
    w,
    g[p],
    _,
    O,
    S,
    A,
    r
  );
  return /* @__PURE__ */ me(
    "button",
    {
      ref: l,
      className: T,
      disabled: i,
      onClick: (k) => {
        d({ event: k, value: { slug: e, text: t } });
      },
      ...s,
      children: [
        m === "left" && n && /* @__PURE__ */ E("span", { className: "mr-1", children: n }),
        t,
        m === "right" && n && /* @__PURE__ */ E("span", { className: "ml-1", children: n })
      ]
    }
  );
}, MD = $t(tY);
MD.displayName = "Button";
const PEe = {
  Group: eY,
  Button: MD
}, VP = /* @__PURE__ */ new Set();
function pg(e, t, n) {
  e || VP.has(t) || (console.warn(t), VP.add(t));
}
function nY(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && pg(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? e : (t.has(i) || t.set(i, e(i)), t.get(i))
  });
}
function mg(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const b0 = (e) => Array.isArray(e);
function ND(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function df(e) {
  return typeof e == "string" || Array.isArray(e);
}
function UP(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function c1(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = UP(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = UP(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
function gg(e, t, n) {
  const r = e.getProps();
  return c1(r, t, n !== void 0 ? n : r.custom, e);
}
const u1 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], f1 = ["initial", ...u1], ud = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Ks = new Set(ud), Hi = (e) => e * 1e3, ko = (e) => e / 1e3, rY = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, iY = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), oY = {
  type: "keyframes",
  duration: 0.8
}, aY = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, sY = (e, { keyframes: t }) => t.length > 2 ? oY : Ks.has(e) ? e.startsWith("scale") ? iY(t[1]) : rY : aY;
function d1(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const lY = {
  skipAnimations: !1,
  useManualTiming: !1
}, cY = (e) => e !== null;
function yg(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(cY), o = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !o || r === void 0 ? i[o] : r;
}
const Hn = (e) => e;
function uY(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(c) {
    o.has(c) && (l.schedule(c), e()), c(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, f = !1, d = !1) => {
      const m = d && r ? t : n;
      return f && o.add(c), m.has(c) || m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, r) {
        i = !0;
        return;
      }
      r = !0, [t, n] = [n, t], n.clear(), t.forEach(s), r = !1, i && (i = !1, l.process(c));
    }
  };
  return l;
}
const Th = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], fY = 40;
function $D(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, a = Th.reduce((x, w) => (x[w] = uY(o), x), {}), { read: s, resolveKeyframes: l, update: c, preRender: f, render: d, postRender: p } = a, m = () => {
    const x = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(x - i.timestamp, fY), 1), i.timestamp = x, i.isProcessing = !0, s.process(i), l.process(i), c.process(i), f.process(i), d.process(i), p.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, g = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: Th.reduce((x, w) => {
    const S = a[w];
    return x[w] = (A, _ = !1, O = !1) => (n || g(), S.schedule(A, _, O)), x;
  }, {}), cancel: (x) => {
    for (let w = 0; w < Th.length; w++)
      a[Th[w]].cancel(x);
  }, state: i, steps: a };
}
const { schedule: Pt, cancel: Ra, state: Fn, steps: Zv } = $D(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Hn, !0), DD = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, dY = 1e-7, hY = 12;
function pY(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = DD(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > dY && ++s < hY);
  return a;
}
function fd(e, t, n, r) {
  if (e === t && n === r)
    return Hn;
  const i = (o) => pY(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : DD(i(o), t, r);
}
const ID = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, RD = (e) => (t) => 1 - e(1 - t), jD = /* @__PURE__ */ fd(0.33, 1.53, 0.69, 0.99), h1 = /* @__PURE__ */ RD(jD), LD = /* @__PURE__ */ ID(h1), BD = (e) => (e *= 2) < 1 ? 0.5 * h1(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), p1 = (e) => 1 - Math.sin(Math.acos(e)), FD = RD(p1), WD = ID(p1), zD = (e) => /^0[^.\s]+$/u.test(e);
function mY(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || zD(e) : !0;
}
let $c = Hn, Bo = Hn;
process.env.NODE_ENV !== "production" && ($c = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Bo = (e, t) => {
  if (!e)
    throw new Error(t);
});
const VD = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), UD = (e) => (t) => typeof t == "string" && t.startsWith(e), KD = /* @__PURE__ */ UD("--"), gY = /* @__PURE__ */ UD("var(--"), m1 = (e) => gY(e) ? yY.test(e.split("/*")[0].trim()) : !1, yY = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, vY = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function bY(e) {
  const t = vY.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const xY = 4;
function HD(e, t, n = 1) {
  Bo(n <= xY, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, i] = bY(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const a = o.trim();
    return VD(a) ? parseFloat(a) : a;
  }
  return m1(i) ? HD(i, t, n + 1) : i;
}
const ja = (e, t, n) => n > t ? t : n < e ? e : n, Dc = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, hf = {
  ...Dc,
  transform: (e) => ja(0, 1, e)
}, Ch = {
  ...Dc,
  default: 1
}, dd = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ga = /* @__PURE__ */ dd("deg"), Gi = /* @__PURE__ */ dd("%"), je = /* @__PURE__ */ dd("px"), wY = /* @__PURE__ */ dd("vh"), _Y = /* @__PURE__ */ dd("vw"), KP = {
  ...Gi,
  parse: (e) => Gi.parse(e) / 100,
  transform: (e) => Gi.transform(e * 100)
}, SY = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), HP = (e) => e === Dc || e === je, GP = (e, t) => parseFloat(e.split(", ")[t]), YP = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return GP(i[1], t);
  {
    const o = r.match(/^matrix\((.+)\)$/u);
    return o ? GP(o[1], e) : 0;
  }
}, OY = /* @__PURE__ */ new Set(["x", "y", "z"]), AY = ud.filter((e) => !OY.has(e));
function PY(e) {
  const t = [];
  return AY.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Xl = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: YP(4, 13),
  y: YP(5, 14)
};
Xl.translateX = Xl.x;
Xl.translateY = Xl.y;
const GD = (e) => (t) => t.test(e), TY = {
  test: (e) => e === "auto",
  parse: (e) => e
}, YD = [Dc, je, Gi, ga, _Y, wY, TY], qP = (e) => YD.find(GD(e)), Cs = /* @__PURE__ */ new Set();
let x0 = !1, w0 = !1;
function qD() {
  if (w0) {
    const e = Array.from(Cs).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = PY(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, a]) => {
        var s;
        (s = r.getValue(o)) === null || s === void 0 || s.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  w0 = !1, x0 = !1, Cs.forEach((e) => e.complete()), Cs.clear();
}
function XD() {
  Cs.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (w0 = !0);
  });
}
function CY() {
  XD(), qD();
}
class g1 {
  constructor(t, n, r, i, o, a = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = a;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Cs.add(this), x0 || (x0 = !0, Pt.read(XD), Pt.resolveKeyframes(qD))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    for (let o = 0; o < t.length; o++)
      if (t[o] === null)
        if (o === 0) {
          const a = i == null ? void 0 : i.get(), s = t[t.length - 1];
          if (a !== void 0)
            t[0] = a;
          else if (r && n) {
            const l = r.readValue(n, s);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = s), i && a === void 0 && i.set(t[0]);
        } else
          t[o] = t[o - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Cs.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Cs.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Uu = (e) => Math.round(e * 1e5) / 1e5, y1 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function EY(e) {
  return e == null;
}
const kY = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, v1 = (e, t) => (n) => !!(typeof n == "string" && kY.test(n) && n.startsWith(e) || t && !EY(n) && Object.prototype.hasOwnProperty.call(n, t)), ZD = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, a, s] = r.match(y1);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, MY = (e) => ja(0, 255, e), Jv = {
  ...Dc,
  transform: (e) => Math.round(MY(e))
}, xs = {
  test: /* @__PURE__ */ v1("rgb", "red"),
  parse: /* @__PURE__ */ ZD("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Jv.transform(e) + ", " + Jv.transform(t) + ", " + Jv.transform(n) + ", " + Uu(hf.transform(r)) + ")"
};
function NY(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const _0 = {
  test: /* @__PURE__ */ v1("#"),
  parse: NY,
  transform: xs.transform
}, El = {
  test: /* @__PURE__ */ v1("hsl", "hue"),
  parse: /* @__PURE__ */ ZD("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Gi.transform(Uu(t)) + ", " + Gi.transform(Uu(n)) + ", " + Uu(hf.transform(r)) + ")"
}, Zn = {
  test: (e) => xs.test(e) || _0.test(e) || El.test(e),
  parse: (e) => xs.test(e) ? xs.parse(e) : El.test(e) ? El.parse(e) : _0.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? xs.transform(e) : El.transform(e)
}, $Y = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function DY(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(y1)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match($Y)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const JD = "number", QD = "color", IY = "var", RY = "var(", XP = "${}", jY = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function pf(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const s = t.replace(jY, (l) => (Zn.test(l) ? (r.color.push(o), i.push(QD), n.push(Zn.parse(l))) : l.startsWith(RY) ? (r.var.push(o), i.push(IY), n.push(l)) : (r.number.push(o), i.push(JD), n.push(parseFloat(l))), ++o, XP)).split(XP);
  return { values: n, split: s, indexes: r, types: i };
}
function eI(e) {
  return pf(e).values;
}
function tI(e) {
  const { split: t, types: n } = pf(e), r = t.length;
  return (i) => {
    let o = "";
    for (let a = 0; a < r; a++)
      if (o += t[a], i[a] !== void 0) {
        const s = n[a];
        s === JD ? o += Uu(i[a]) : s === QD ? o += Zn.transform(i[a]) : o += i[a];
      }
    return o;
  };
}
const LY = (e) => typeof e == "number" ? 0 : e;
function BY(e) {
  const t = eI(e);
  return tI(e)(t.map(LY));
}
const La = {
  test: DY,
  parse: eI,
  createTransformer: tI,
  getAnimatableNone: BY
}, FY = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function WY(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(y1) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = FY.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const zY = /\b([a-z-]*)\(.*?\)/gu, S0 = {
  ...La,
  getAnimatableNone: (e) => {
    const t = e.match(zY);
    return t ? t.map(WY).join(" ") : e;
  }
}, VY = {
  // Border props
  borderWidth: je,
  borderTopWidth: je,
  borderRightWidth: je,
  borderBottomWidth: je,
  borderLeftWidth: je,
  borderRadius: je,
  radius: je,
  borderTopLeftRadius: je,
  borderTopRightRadius: je,
  borderBottomRightRadius: je,
  borderBottomLeftRadius: je,
  // Positioning props
  width: je,
  maxWidth: je,
  height: je,
  maxHeight: je,
  top: je,
  right: je,
  bottom: je,
  left: je,
  // Spacing props
  padding: je,
  paddingTop: je,
  paddingRight: je,
  paddingBottom: je,
  paddingLeft: je,
  margin: je,
  marginTop: je,
  marginRight: je,
  marginBottom: je,
  marginLeft: je,
  // Misc
  backgroundPositionX: je,
  backgroundPositionY: je
}, UY = {
  rotate: ga,
  rotateX: ga,
  rotateY: ga,
  rotateZ: ga,
  scale: Ch,
  scaleX: Ch,
  scaleY: Ch,
  scaleZ: Ch,
  skew: ga,
  skewX: ga,
  skewY: ga,
  distance: je,
  translateX: je,
  translateY: je,
  translateZ: je,
  x: je,
  y: je,
  z: je,
  perspective: je,
  transformPerspective: je,
  opacity: hf,
  originX: KP,
  originY: KP,
  originZ: je
}, ZP = {
  ...Dc,
  transform: Math.round
}, b1 = {
  ...VY,
  ...UY,
  zIndex: ZP,
  size: je,
  // SVG
  fillOpacity: hf,
  strokeOpacity: hf,
  numOctaves: ZP
}, KY = {
  ...b1,
  // Color props
  color: Zn,
  backgroundColor: Zn,
  outlineColor: Zn,
  fill: Zn,
  stroke: Zn,
  // Border props
  borderColor: Zn,
  borderTopColor: Zn,
  borderRightColor: Zn,
  borderBottomColor: Zn,
  borderLeftColor: Zn,
  filter: S0,
  WebkitFilter: S0
}, x1 = (e) => KY[e];
function nI(e, t) {
  let n = x1(e);
  return n !== S0 && (n = La), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const HY = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function GY(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !HY.has(o) && pf(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = nI(n, i);
}
class rI extends g1 {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let c = t[l];
      if (typeof c == "string" && (c = c.trim(), m1(c))) {
        const f = HD(c, n.current);
        f !== void 0 && (t[l] = f), l === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !SY.has(r) || t.length !== 2)
      return;
    const [i, o] = t, a = qP(i), s = qP(o);
    if (a !== s)
      if (HP(a) && HP(s))
        for (let l = 0; l < t.length; l++) {
          const c = t[l];
          typeof c == "string" && (t[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      mY(t[i]) && r.push(i);
    r.length && GY(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Xl[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const o = n.getValue(r);
    o && o.jump(this.measuredOrigin, !1);
    const a = i.length - 1, s = i[a];
    i[a] = Xl[r](n.measureViewportBox(), window.getComputedStyle(n.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function w1(e) {
  return typeof e == "function";
}
let ip;
function YY() {
  ip = void 0;
}
const Yi = {
  now: () => (ip === void 0 && Yi.set(Fn.isProcessing || lY.useManualTiming ? Fn.timestamp : performance.now()), ip),
  set: (e) => {
    ip = e, queueMicrotask(YY);
  }
}, JP = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(La.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function qY(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function XY(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], a = JP(i, t), s = JP(o, t);
  return $c(a === s, `You are trying to animate ${t} from "${i}" to "${o}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${o} via the \`style\` property.`), !a || !s ? !1 : qY(e) || (n === "spring" || w1(n)) && r;
}
const ZY = 40;
class iI {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: a = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = Yi.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: a,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > ZY ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && CY(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = Yi.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: o, delay: a, onComplete: s, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !XY(t, r, i, o))
      if (a)
        this.options.duration = 0;
      else {
        l == null || l(yg(t, this.options, n)), s == null || s(), this.resolveFinishedPromise();
        return;
      }
    const f = this.initPlayback(t, n);
    f !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...f
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function oI(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const JY = 5;
function aI(e, t, n) {
  const r = Math.max(t - JY, 0);
  return oI(n - e(r), t - r);
}
const Qv = 1e-3, QY = 0.01, QP = 10, eq = 0.05, tq = 1;
function nq({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, o;
  $c(e <= Hi(QP), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = ja(eq, tq, a), e = ja(QY, QP, ko(e)), a < 1 ? (i = (c) => {
    const f = c * a, d = f * e, p = f - n, m = O0(c, a), g = Math.exp(-d);
    return Qv - p / m * g;
  }, o = (c) => {
    const d = c * a * e, p = d * n + n, m = Math.pow(a, 2) * Math.pow(c, 2) * e, g = Math.exp(-d), v = O0(Math.pow(c, 2), a);
    return (-i(c) + Qv > 0 ? -1 : 1) * ((p - m) * g) / v;
  }) : (i = (c) => {
    const f = Math.exp(-c * e), d = (c - n) * e + 1;
    return -Qv + f * d;
  }, o = (c) => {
    const f = Math.exp(-c * e), d = (n - c) * (e * e);
    return f * d;
  });
  const s = 5 / e, l = iq(i, o, s);
  if (e = Hi(e), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: a * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const rq = 12;
function iq(e, t, n) {
  let r = n;
  for (let i = 1; i < rq; i++)
    r = r - e(r) / t(r);
  return r;
}
function O0(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const oq = ["duration", "bounce"], aq = ["stiffness", "damping", "mass"];
function eT(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function sq(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!eT(e, aq) && eT(e, oq)) {
    const n = nq(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function sI({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const i = e[0], o = e[e.length - 1], a = { done: !1, value: i }, { stiffness: s, damping: l, mass: c, duration: f, velocity: d, isResolvedFromDuration: p } = sq({
    ...r,
    velocity: -ko(r.velocity || 0)
  }), m = d || 0, g = l / (2 * Math.sqrt(s * c)), v = o - i, y = ko(Math.sqrt(s / c)), x = Math.abs(v) < 5;
  n || (n = x ? 0.01 : 2), t || (t = x ? 5e-3 : 0.5);
  let w;
  if (g < 1) {
    const S = O0(y, g);
    w = (A) => {
      const _ = Math.exp(-g * y * A);
      return o - _ * ((m + g * y * v) / S * Math.sin(S * A) + v * Math.cos(S * A));
    };
  } else if (g === 1)
    w = (S) => o - Math.exp(-y * S) * (v + (m + y * v) * S);
  else {
    const S = y * Math.sqrt(g * g - 1);
    w = (A) => {
      const _ = Math.exp(-g * y * A), O = Math.min(S * A, 300);
      return o - _ * ((m + g * y * v) * Math.sinh(O) + S * v * Math.cosh(O)) / S;
    };
  }
  return {
    calculatedDuration: p && f || null,
    next: (S) => {
      const A = w(S);
      if (p)
        a.done = S >= f;
      else {
        let _ = 0;
        g < 1 && (_ = S === 0 ? Hi(m) : aI(w, S, A));
        const O = Math.abs(_) <= n, T = Math.abs(o - A) <= t;
        a.done = O && T;
      }
      return a.value = a.done ? o : A, a;
    }
  };
}
function tT({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: a, min: s, max: l, restDelta: c = 0.5, restSpeed: f }) {
  const d = e[0], p = {
    done: !1,
    value: d
  }, m = (C) => s !== void 0 && C < s || l !== void 0 && C > l, g = (C) => s === void 0 ? l : l === void 0 || Math.abs(s - C) < Math.abs(l - C) ? s : l;
  let v = n * t;
  const y = d + v, x = a === void 0 ? y : a(y);
  x !== y && (v = x - d);
  const w = (C) => -v * Math.exp(-C / r), S = (C) => x + w(C), A = (C) => {
    const k = w(C), D = S(C);
    p.done = Math.abs(k) <= c, p.value = p.done ? x : D;
  };
  let _, O;
  const T = (C) => {
    m(p.value) && (_ = C, O = sI({
      keyframes: [p.value, g(p.value)],
      velocity: aI(S, C, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: c,
      restSpeed: f
    }));
  };
  return T(0), {
    calculatedDuration: null,
    next: (C) => {
      let k = !1;
      return !O && _ === void 0 && (k = !0, A(C), T(C)), _ !== void 0 && C >= _ ? O.next(C - _) : (!k && A(C), p);
    }
  };
}
const lq = /* @__PURE__ */ fd(0.42, 0, 1, 1), cq = /* @__PURE__ */ fd(0, 0, 0.58, 1), lI = /* @__PURE__ */ fd(0.42, 0, 0.58, 1), uq = (e) => Array.isArray(e) && typeof e[0] != "number", _1 = (e) => Array.isArray(e) && typeof e[0] == "number", nT = {
  linear: Hn,
  easeIn: lq,
  easeInOut: lI,
  easeOut: cq,
  circIn: p1,
  circInOut: WD,
  circOut: FD,
  backIn: h1,
  backInOut: LD,
  backOut: jD,
  anticipate: BD
}, rT = (e) => {
  if (_1(e)) {
    Bo(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, i] = e;
    return fd(t, n, r, i);
  } else if (typeof e == "string")
    return Bo(nT[e] !== void 0, `Invalid easing type '${e}'`), nT[e];
  return e;
}, fq = (e, t) => (n) => t(e(n)), Mo = (...e) => e.reduce(fq), Zl = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Jt = (e, t, n) => e + (t - e) * n;
function eb(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function dq({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = eb(l, s, e + 1 / 3), o = eb(l, s, e), a = eb(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function wp(e, t) {
  return (n) => n > 0 ? t : e;
}
const tb = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, hq = [_0, xs, El], pq = (e) => hq.find((t) => t.test(e));
function iT(e) {
  const t = pq(e);
  if ($c(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === El && (n = dq(n)), n;
}
const oT = (e, t) => {
  const n = iT(e), r = iT(t);
  if (!n || !r)
    return wp(e, t);
  const i = { ...n };
  return (o) => (i.red = tb(n.red, r.red, o), i.green = tb(n.green, r.green, o), i.blue = tb(n.blue, r.blue, o), i.alpha = Jt(n.alpha, r.alpha, o), xs.transform(i));
}, A0 = /* @__PURE__ */ new Set(["none", "hidden"]);
function mq(e, t) {
  return A0.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function gq(e, t) {
  return (n) => Jt(e, t, n);
}
function S1(e) {
  return typeof e == "number" ? gq : typeof e == "string" ? m1(e) ? wp : Zn.test(e) ? oT : bq : Array.isArray(e) ? cI : typeof e == "object" ? Zn.test(e) ? oT : yq : wp;
}
function cI(e, t) {
  const n = [...e], r = n.length, i = e.map((o, a) => S1(o)(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}
function yq(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = S1(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function vq(e, t) {
  var n;
  const r = [], i = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const a = t.types[o], s = e.indexes[a][i[a]], l = (n = e.values[s]) !== null && n !== void 0 ? n : 0;
    r[o] = l, i[a]++;
  }
  return r;
}
const bq = (e, t) => {
  const n = La.createTransformer(t), r = pf(e), i = pf(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? A0.has(e) && !i.values.length || A0.has(t) && !r.values.length ? mq(e, t) : Mo(cI(vq(r, i), i.values), n) : ($c(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), wp(e, t));
};
function uI(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Jt(e, t, n) : S1(e)(e, t);
}
function xq(e, t, n) {
  const r = [], i = n || uI, o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] || Hn : t;
      s = Mo(l, s);
    }
    r.push(s);
  }
  return r;
}
function wq(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (Bo(o === t.length, "Both input and output ranges must be the same length"), o === 1)
    return () => t[0];
  if (o === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = xq(t, r, i), s = a.length, l = (c) => {
    let f = 0;
    if (s > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const d = Zl(e[f], e[f + 1], c);
    return a[f](d);
  };
  return n ? (c) => l(ja(e[0], e[o - 1], c)) : l;
}
function _q(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = Zl(0, t, r);
    e.push(Jt(n, 1, i));
  }
}
function Sq(e) {
  const t = [0];
  return _q(t, e.length - 1), t;
}
function Oq(e, t) {
  return e.map((n) => n * t);
}
function Aq(e, t) {
  return e.map(() => t || lI).splice(0, e.length - 1);
}
function _p({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = uq(r) ? r.map(rT) : rT(r), o = {
    done: !1,
    value: t[0]
  }, a = Oq(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Sq(t),
    e
  ), s = wq(a, t, {
    ease: Array.isArray(i) ? i : Aq(t, i)
  });
  return {
    calculatedDuration: e,
    next: (l) => (o.value = s(l), o.done = l >= e, o)
  };
}
const aT = 2e4;
function Pq(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < aT; )
    t += n, r = e.next(t);
  return t >= aT ? 1 / 0 : t;
}
const Tq = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Pt.update(t, !0),
    stop: () => Ra(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Fn.isProcessing ? Fn.timestamp : Yi.now()
  };
}, Cq = {
  decay: tT,
  inertia: tT,
  tween: _p,
  keyframes: _p,
  spring: sI
}, Eq = (e) => e / 100;
class O1 extends iI {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: i, keyframes: o } = this.options, a = (i == null ? void 0 : i.KeyframeResolver) || g1, s = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new a(o, s, n, r, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: a = 0 } = this.options, s = w1(n) ? n : Cq[n] || _p;
    let l, c;
    s !== _p && typeof t[0] != "number" && (process.env.NODE_ENV !== "production" && Bo(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = Mo(Eq, uI(t[0], t[1])), t = [0, 100]);
    const f = s({ ...this.options, keyframes: t });
    o === "mirror" && (c = s({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -a
    })), f.calculatedDuration === null && (f.calculatedDuration = Pq(f));
    const { calculatedDuration: d } = f, p = d + i, m = p * (r + 1) - i;
    return {
      generator: f,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: p,
      totalDuration: m
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: C } = this.options;
      return { done: !0, value: C[C.length - 1] };
    }
    const { finalKeyframe: i, generator: o, mirroredGenerator: a, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: c, totalDuration: f, resolvedDuration: d } = r;
    if (this.startTime === null)
      return o.next(0);
    const { delay: p, repeat: m, repeatType: g, repeatDelay: v, onUpdate: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - f / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const x = this.currentTime - p * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? x < 0 : x > f;
    this.currentTime = Math.max(x, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = f);
    let S = this.currentTime, A = o;
    if (m) {
      const C = Math.min(this.currentTime, f) / d;
      let k = Math.floor(C), D = C % 1;
      !D && C >= 1 && (D = 1), D === 1 && k--, k = Math.min(k, m + 1), !!(k % 2) && (g === "reverse" ? (D = 1 - D, v && (D -= v / d)) : g === "mirror" && (A = a)), S = ja(0, 1, D) * d;
    }
    const _ = w ? { done: !1, value: l[0] } : A.next(S);
    s && (_.value = s(_.value));
    let { done: O } = _;
    !w && c !== null && (O = this.speed >= 0 ? this.currentTime >= f : this.currentTime <= 0);
    const T = this.holdTime === null && (this.state === "finished" || this.state === "running" && O);
    return T && i !== void 0 && (_.value = yg(l, this.options, i)), y && y(_.value), T && this.finish(), _;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? ko(t.calculatedDuration) : 0;
  }
  get time() {
    return ko(this.currentTime);
  }
  set time(t) {
    t = Hi(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = ko(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = Tq, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const kq = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Mq = 10, Nq = (e, t) => {
  let n = "";
  const r = Math.max(Math.round(t / Mq), 2);
  for (let i = 0; i < r; i++)
    n += e(Zl(0, r - 1, i)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function A1(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const $q = {
  linearEasing: void 0
};
function Dq(e, t) {
  const n = A1(e);
  return () => {
    var r;
    return (r = $q[t]) !== null && r !== void 0 ? r : n();
  };
}
const Sp = /* @__PURE__ */ Dq(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function fI(e) {
  return !!(typeof e == "function" && Sp() || !e || typeof e == "string" && (e in P0 || Sp()) || _1(e) || Array.isArray(e) && e.every(fI));
}
const Ru = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, P0 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Ru([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Ru([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Ru([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Ru([0.33, 1.53, 0.69, 0.99])
};
function dI(e, t) {
  if (e)
    return typeof e == "function" && Sp() ? Nq(e, t) : _1(e) ? Ru(e) : Array.isArray(e) ? e.map((n) => dI(n, t) || P0.easeOut) : P0[e];
}
function Iq(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: a = "loop", ease: s = "easeInOut", times: l } = {}) {
  const c = { [t]: n };
  l && (c.offset = l);
  const f = dI(s, i);
  return Array.isArray(f) && (c.easing = f), e.animate(c, {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
function sT(e, t) {
  e.timeline = t, e.onfinish = null;
}
const Rq = /* @__PURE__ */ A1(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Op = 10, jq = 2e4;
function Lq(e) {
  return w1(e.type) || e.type === "spring" || !fI(e.ease);
}
function Bq(e, t) {
  const n = new O1({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const i = [];
  let o = 0;
  for (; !r.done && o < jq; )
    r = n.sample(o), i.push(r.value), o += Op;
  return {
    times: void 0,
    keyframes: i,
    duration: o - Op,
    ease: "linear"
  };
}
const hI = {
  anticipate: BD,
  backInOut: LD,
  circInOut: WD
};
function Fq(e) {
  return e in hI;
}
class lT extends iI {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: i, keyframes: o } = this.options;
    this.resolver = new rI(o, (a, s) => this.onKeyframesResolved(a, s), n, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    var r;
    let { duration: i = 300, times: o, ease: a, type: s, motionValue: l, name: c, startTime: f } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (typeof a == "string" && Sp() && Fq(a) && (a = hI[a]), Lq(this.options)) {
      const { onComplete: p, onUpdate: m, motionValue: g, element: v, ...y } = this.options, x = Bq(t, y);
      t = x.keyframes, t.length === 1 && (t[1] = t[0]), i = x.duration, o = x.times, a = x.ease, s = "keyframes";
    }
    const d = Iq(l.owner.current, c, t, { ...this.options, duration: i, times: o, ease: a });
    return d.startTime = f ?? this.calcStartTime(), this.pendingTimeline ? (sT(d, this.pendingTimeline), this.pendingTimeline = void 0) : d.onfinish = () => {
      const { onComplete: p } = this.options;
      l.set(yg(t, this.options, n)), p && p(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: d,
      duration: i,
      times: o,
      type: s,
      ease: a,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return ko(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return ko(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = Hi(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return Hn;
      const { animation: r } = n;
      sT(r, t);
    }
    return Hn;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: i, type: o, ease: a, times: s } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: f, onComplete: d, element: p, ...m } = this.options, g = new O1({
        ...m,
        keyframes: r,
        duration: i,
        type: o,
        ease: a,
        times: s,
        isGenerator: !0
      }), v = Hi(this.time);
      c.setWithVelocity(g.sample(v - Op).value, g.sample(v).value, Op);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: o, damping: a, type: s } = t;
    return Rq() && r && kq.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !i && o !== "mirror" && a !== 0 && s !== "inertia";
  }
}
const Wq = A1(() => window.ScrollTimeline !== void 0);
class zq {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t, n) {
    const r = this.animations.map((i) => Wq() && i.attachTimeline ? i.attachTimeline(t) : n(i));
    return () => {
      r.forEach((i, o) => {
        i && i(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function Vq({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: o, repeatType: a, repeatDelay: s, from: l, elapsed: c, ...f }) {
  return !!Object.keys(f).length;
}
const P1 = (e, t, n, r = {}, i, o) => (a) => {
  const s = d1(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - Hi(l);
  let f = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -c,
    onUpdate: (p) => {
      t.set(p), s.onUpdate && s.onUpdate(p);
    },
    onComplete: () => {
      a(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  Vq(s) || (f = {
    ...f,
    ...sY(e, f)
  }), f.duration && (f.duration = Hi(f.duration)), f.repeatDelay && (f.repeatDelay = Hi(f.repeatDelay)), f.from !== void 0 && (f.keyframes[0] = f.from);
  let d = !1;
  if ((f.type === !1 || f.duration === 0 && !f.repeatDelay) && (f.duration = 0, f.delay === 0 && (d = !0)), d && !o && t.get() !== void 0) {
    const p = yg(f.keyframes, s);
    if (p !== void 0)
      return Pt.update(() => {
        f.onUpdate(p), f.onComplete();
      }), new zq([]);
  }
  return !o && lT.supports(f) ? new lT(f) : new O1(f);
}, Uq = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), Kq = (e) => b0(e) ? e[e.length - 1] || 0 : e;
function T1(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function C1(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class E1 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return T1(this.subscriptions, t), () => C1(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const a = this.subscriptions[o];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const cT = 30, Hq = (e) => !isNaN(parseFloat(e));
class Gq {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.11.17", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const o = Yi.now();
      this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Yi.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = Hq(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && pg(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new E1());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Pt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Yi.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > cT)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, cT);
    return oI(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function mf(e, t) {
  return new Gq(e, t);
}
function Yq(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, mf(n));
}
function qq(e, t) {
  const n = gg(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const a in o) {
    const s = Kq(o[a]);
    Yq(e, a, s);
  }
}
const k1 = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Xq = "framerAppearId", pI = "data-" + k1(Xq);
function mI(e) {
  return e.props[pI];
}
const nr = (e) => !!(e && e.getVelocity);
function Zq(e) {
  return !!(nr(e) && e.add);
}
function T0(e, t) {
  const n = e.getValue("willChange");
  if (Zq(n))
    return n.add(t);
}
function Jq({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function gI(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  var o;
  let { transition: a = e.getDefaultTransition(), transitionEnd: s, ...l } = t;
  r && (a = r);
  const c = [], f = i && e.animationState && e.animationState.getState()[i];
  for (const d in l) {
    const p = e.getValue(d, (o = e.latestValues[d]) !== null && o !== void 0 ? o : null), m = l[d];
    if (m === void 0 || f && Jq(f, d))
      continue;
    const g = {
      delay: n,
      ...d1(a || {}, d)
    };
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const x = mI(e);
      if (x) {
        const w = window.MotionHandoffAnimation(x, d, Pt);
        w !== null && (g.startTime = w, v = !0);
      }
    }
    T0(e, d), p.start(P1(d, p, m, e.shouldReduceMotion && Ks.has(d) ? { type: !1 } : g, e, v));
    const y = p.animation;
    y && c.push(y);
  }
  return s && Promise.all(c).then(() => {
    Pt.update(() => {
      s && qq(e, s);
    });
  }), c;
}
function C0(e, t, n = {}) {
  var r;
  const i = gg(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (o = n.transitionOverride);
  const a = i ? () => Promise.all(gI(e, i, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: f = 0, staggerChildren: d, staggerDirection: p } = o;
    return Qq(e, t, f + c, d, p, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [c, f] = l === "beforeChildren" ? [a, s] : [s, a];
    return c().then(() => f());
  } else
    return Promise.all([a(), s(n.delay)]);
}
function Qq(e, t, n = 0, r = 0, i = 1, o) {
  const a = [], s = (e.variantChildren.size - 1) * r, l = i === 1 ? (c = 0) => c * r : (c = 0) => s - c * r;
  return Array.from(e.variantChildren).sort(e9).forEach((c, f) => {
    c.notify("AnimationStart", t), a.push(C0(c, t, {
      ...o,
      delay: n + l(f)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function e9(e, t) {
  return e.sortNodePosition(t);
}
function t9(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => C0(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = C0(e, t, n);
  else {
    const i = typeof t == "function" ? gg(e, t, n.custom) : t;
    r = Promise.all(gI(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const n9 = f1.length;
function yI(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? yI(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < n9; n++) {
    const r = f1[n], i = e.props[r];
    (df(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const r9 = [...u1].reverse(), i9 = u1.length;
function o9(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => t9(e, n, r)));
}
function a9(e) {
  let t = o9(e), n = uT(), r = !0;
  const i = (l) => (c, f) => {
    var d;
    const p = gg(e, f, l === "exit" ? (d = e.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (p) {
      const { transition: m, transitionEnd: g, ...v } = p;
      c = { ...c, ...v, ...g };
    }
    return c;
  };
  function o(l) {
    t = l(e);
  }
  function a(l) {
    const { props: c } = e, f = yI(e.parent) || {}, d = [], p = /* @__PURE__ */ new Set();
    let m = {}, g = 1 / 0;
    for (let y = 0; y < i9; y++) {
      const x = r9[y], w = n[x], S = c[x] !== void 0 ? c[x] : f[x], A = df(S), _ = x === l ? w.isActive : null;
      _ === !1 && (g = y);
      let O = S === f[x] && S !== c[x] && A;
      if (O && r && e.manuallyAnimateOnMount && (O = !1), w.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && _ === null || // If we didn't and don't have any defined prop for this animation type
      !S && !w.prevProp || // Or if the prop doesn't define an animation
      mg(S) || typeof S == "boolean")
        continue;
      const T = s9(w.prevProp, S);
      let C = T || // If we're making this variant active, we want to always make it active
      x === l && w.isActive && !O && A || // If we removed a higher-priority variant (i is in reverse order)
      y > g && A, k = !1;
      const D = Array.isArray(S) ? S : [S];
      let N = D.reduce(i(x), {});
      _ === !1 && (N = {});
      const { prevResolvedValues: $ = {} } = w, B = {
        ...$,
        ...N
      }, L = (z) => {
        C = !0, p.has(z) && (k = !0, p.delete(z)), w.needsAnimating[z] = !0;
        const G = e.getValue(z);
        G && (G.liveStyle = !1);
      };
      for (const z in B) {
        const G = N[z], V = $[z];
        if (m.hasOwnProperty(z))
          continue;
        let U = !1;
        b0(G) && b0(V) ? U = !ND(G, V) : U = G !== V, U ? G != null ? L(z) : p.add(z) : G !== void 0 && p.has(z) ? L(z) : w.protectedKeys[z] = !0;
      }
      w.prevProp = S, w.prevResolvedValues = N, w.isActive && (m = { ...m, ...N }), r && e.blockInitialAnimation && (C = !1), C && (!(O && T) || k) && d.push(...D.map((z) => ({
        animation: z,
        options: { type: x }
      })));
    }
    if (p.size) {
      const y = {};
      p.forEach((x) => {
        const w = e.getBaseTarget(x), S = e.getValue(x);
        S && (S.liveStyle = !0), y[x] = w ?? null;
      }), d.push({ animation: y });
    }
    let v = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (v = !1), r = !1, v ? t(d) : Promise.resolve();
  }
  function s(l, c) {
    var f;
    if (n[l].isActive === c)
      return Promise.resolve();
    (f = e.variantChildren) === null || f === void 0 || f.forEach((p) => {
      var m;
      return (m = p.animationState) === null || m === void 0 ? void 0 : m.setActive(l, c);
    }), n[l].isActive = c;
    const d = a(l);
    for (const p in n)
      n[p].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: a,
    setActive: s,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = uT(), r = !0;
    }
  };
}
function s9(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !ND(t, e) : !1;
}
function ss(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function uT() {
  return {
    animate: ss(!0),
    whileInView: ss(),
    whileHover: ss(),
    whileTap: ss(),
    whileDrag: ss(),
    whileFocus: ss(),
    exit: ss()
  };
}
class Va {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class l9 extends Va {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = a9(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    mg(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let c9 = 0;
class u9 extends Va {
  constructor() {
    super(...arguments), this.id = c9++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const f9 = {
  animation: {
    Feature: l9
  },
  exit: {
    Feature: u9
  }
}, vI = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function vg(e, t = "page") {
  return {
    point: {
      x: e[`${t}X`],
      y: e[`${t}Y`]
    }
  };
}
const d9 = (e) => (t) => vI(t) && e(t, vg(t));
function Oo(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function No(e, t, n, r) {
  return Oo(e, t, d9(n), r);
}
const fT = (e, t) => Math.abs(e - t);
function h9(e, t) {
  const n = fT(e.x, t.x), r = fT(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class bI {
  constructor(t, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: o = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = rb(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, m = h9(d.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !m)
        return;
      const { point: g } = d, { timestamp: v } = Fn;
      this.history.push({ ...g, timestamp: v });
      const { onStart: y, onMove: x } = this.handlers;
      p || (y && y(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, p) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = nb(p, this.transformPagePoint), Pt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, p) => {
      this.end();
      const { onEnd: m, onSessionEnd: g, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = rb(d.type === "pointercancel" ? this.lastMoveEventInfo : nb(p, this.transformPagePoint), this.history);
      this.startEvent && m && m(d, y), g && g(d, y);
    }, !vI(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const a = vg(t), s = nb(a, this.transformPagePoint), { point: l } = s, { timestamp: c } = Fn;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: f } = n;
    f && f(t, rb(s, this.history)), this.removeListeners = Mo(No(this.contextWindow, "pointermove", this.handlePointerMove), No(this.contextWindow, "pointerup", this.handlePointerUp), No(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ra(this.updatePoint);
  }
}
function nb(e, t) {
  return t ? { point: t(e.point) } : e;
}
function dT(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function rb({ point: e }, t) {
  return {
    point: e,
    delta: dT(e, xI(t)),
    offset: dT(e, p9(t)),
    velocity: m9(t, 0.1)
  };
}
function p9(e) {
  return e[0];
}
function xI(e) {
  return e[e.length - 1];
}
function m9(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = xI(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > Hi(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const o = ko(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function wI(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const hT = wI("dragHorizontal"), pT = wI("dragVertical");
function _I(e) {
  let t = !1;
  if (e === "y")
    t = pT();
  else if (e === "x")
    t = hT();
  else {
    const n = hT(), r = pT();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function SI() {
  const e = _I(!0);
  return e ? (e(), !1) : !0;
}
function kl(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
const OI = 1e-4, g9 = 1 - OI, y9 = 1 + OI, AI = 0.01, v9 = 0 - AI, b9 = 0 + AI;
function Ur(e) {
  return e.max - e.min;
}
function x9(e, t, n) {
  return Math.abs(e - t) <= n;
}
function mT(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Jt(t.min, t.max, e.origin), e.scale = Ur(n) / Ur(t), e.translate = Jt(n.min, n.max, e.origin) - e.originPoint, (e.scale >= g9 && e.scale <= y9 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= v9 && e.translate <= b9 || isNaN(e.translate)) && (e.translate = 0);
}
function Ku(e, t, n, r) {
  mT(e.x, t.x, n.x, r ? r.originX : void 0), mT(e.y, t.y, n.y, r ? r.originY : void 0);
}
function gT(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Ur(t);
}
function w9(e, t, n) {
  gT(e.x, t.x, n.x), gT(e.y, t.y, n.y);
}
function yT(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Ur(t);
}
function Hu(e, t, n) {
  yT(e.x, t.x, n.x), yT(e.y, t.y, n.y);
}
function _9(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Jt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Jt(n, e, r.max) : Math.min(e, n)), e;
}
function vT(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function S9(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: vT(e.x, n, i),
    y: vT(e.y, t, r)
  };
}
function bT(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function O9(e, t) {
  return {
    x: bT(e.x, t.x),
    y: bT(e.y, t.y)
  };
}
function A9(e, t) {
  let n = 0.5;
  const r = Ur(e), i = Ur(t);
  return i > r ? n = Zl(t.min, t.max - r, e.min) : r > i && (n = Zl(e.min, e.max - i, t.min)), ja(0, 1, n);
}
function P9(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const E0 = 0.35;
function T9(e = E0) {
  return e === !1 ? e = 0 : e === !0 && (e = E0), {
    x: xT(e, "left", "right"),
    y: xT(e, "top", "bottom")
  };
}
function xT(e, t, n) {
  return {
    min: wT(e, t),
    max: wT(e, n)
  };
}
function wT(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const _T = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Ml = () => ({
  x: _T(),
  y: _T()
}), ST = () => ({ min: 0, max: 0 }), sn = () => ({
  x: ST(),
  y: ST()
});
function si(e) {
  return [e("x"), e("y")];
}
function PI({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function C9({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function E9(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function ib(e) {
  return e === void 0 || e === 1;
}
function k0({ scale: e, scaleX: t, scaleY: n }) {
  return !ib(e) || !ib(t) || !ib(n);
}
function hs(e) {
  return k0(e) || TI(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function TI(e) {
  return OT(e.x) || OT(e.y);
}
function OT(e) {
  return e && e !== "0%";
}
function Ap(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function AT(e, t, n, r, i) {
  return i !== void 0 && (e = Ap(e, i, r)), Ap(e, n, r) + t;
}
function M0(e, t = 0, n = 1, r, i) {
  e.min = AT(e.min, t, n, r, i), e.max = AT(e.max, t, n, r, i);
}
function CI(e, { x: t, y: n }) {
  M0(e.x, t.translate, t.scale, t.originPoint), M0(e.y, n.translate, n.scale, n.originPoint);
}
const PT = 0.999999999999, TT = 1.0000000000001;
function k9(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, a;
  for (let s = 0; s < i; s++) {
    o = n[s], a = o.projectionDelta;
    const { visualElement: l } = o.options;
    l && l.props.style && l.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && $l(e, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, CI(e, a)), r && hs(o.latestValues) && $l(e, o.latestValues));
  }
  t.x < TT && t.x > PT && (t.x = 1), t.y < TT && t.y > PT && (t.y = 1);
}
function Nl(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function CT(e, t, n, r, i = 0.5) {
  const o = Jt(e.min, e.max, i);
  M0(e, t, n, o, r);
}
function $l(e, t) {
  CT(e.x, t.x, t.scaleX, t.scale, t.originX), CT(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function EI(e, t) {
  return PI(E9(e.getBoundingClientRect(), t));
}
function M9(e, t, n) {
  const r = EI(e, n), { scroll: i } = t;
  return i && (Nl(r.x, i.offset.x), Nl(r.y, i.offset.y)), r;
}
const kI = ({ current: e }) => e ? e.ownerDocument.defaultView : null, N9 = /* @__PURE__ */ new WeakMap();
class $9 {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = sn(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (f) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(vg(f, "page").point);
    }, o = (f, d) => {
      const { drag: p, dragPropagation: m, onDragStart: g } = this.getProps();
      if (p && !m && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = _I(p), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), si((y) => {
        let x = this.getAxisMotionValue(y).get() || 0;
        if (Gi.test(x)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const S = w.layout.layoutBox[y];
            S && (x = Ur(S) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[y] = x;
      }), g && Pt.postRender(() => g(f, d)), T0(this.visualElement, "transform");
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, a = (f, d) => {
      const { dragPropagation: p, dragDirectionLock: m, onDirectionLock: g, onDrag: v } = this.getProps();
      if (!p && !this.openGlobalLock)
        return;
      const { offset: y } = d;
      if (m && this.currentDirection === null) {
        this.currentDirection = D9(y), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, y), this.updateAxis("y", d.point, y), this.visualElement.render(), v && v(f, d);
    }, s = (f, d) => this.stop(f, d), l = () => si((f) => {
      var d;
      return this.getAnimationState(f) === "paused" && ((d = this.getAxisMotionValue(f).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new bI(t, {
      onSessionStart: i,
      onStart: o,
      onMove: a,
      onSessionEnd: s,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: kI(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: o } = this.getProps();
    o && Pt.postRender(() => o(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !Eh(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = _9(a, this.constraints[t], this.elastic[t])), o.set(a);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, o = this.constraints;
    n && kl(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = S9(i.layoutBox, n) : this.constraints = !1, this.elastic = T9(r), o !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && si((a) => {
      this.constraints !== !1 && this.getAxisMotionValue(a) && (this.constraints[a] = P9(i.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !kl(t))
      return !1;
    const r = t.current;
    Bo(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = M9(r, i.root, this.visualElement.getTransformPagePoint());
    let a = O9(i.layout.layoutBox, o);
    if (n) {
      const s = n(C9(a));
      this.hasMutatedConstraints = !!s, s && (a = PI(s));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: a, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = si((f) => {
      if (!Eh(f, n, this.currentDirection))
        return;
      let d = l && l[f] || {};
      a && (d = { min: 0, max: 0 });
      const p = i ? 200 : 1e6, m = i ? 40 : 1e7, g = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: p,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...d
      };
      return this.startAxisValueAnimation(f, g);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return T0(this.visualElement, t), r.start(P1(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    si((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    si((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    si((n) => {
      const { drag: r } = this.getProps();
      if (!Eh(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: a, max: s } = i.layout.layoutBox[n];
        o.set(t[n] - Jt(a, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!kl(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    si((a) => {
      const s = this.getAxisMotionValue(a);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[a] = A9({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), si((a) => {
      if (!Eh(a, t, null))
        return;
      const s = this.getAxisMotionValue(a), { min: l, max: c } = this.constraints[a];
      s.set(Jt(l, c, i[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    N9.set(this.visualElement, this);
    const t = this.visualElement.current, n = No(t, "pointerdown", (l) => {
      const { drag: c, dragListener: f = !0 } = this.getProps();
      c && f && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      kl(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Pt.read(r);
    const a = Oo(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (si((f) => {
        const d = this.getAxisMotionValue(f);
        d && (this.originPoint[f] += l[f].translate, d.set(d.get() + l[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), o(), s && s();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: a = E0, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: a,
      dragMomentum: s
    };
  }
}
function Eh(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function D9(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class I9 extends Va {
  constructor(t) {
    super(t), this.removeGroupControls = Hn, this.removeListeners = Hn, this.controls = new $9(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Hn;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const ET = (e) => (t, n) => {
  e && Pt.postRender(() => e(t, n));
};
class R9 extends Va {
  constructor() {
    super(...arguments), this.removePointerDownListener = Hn;
  }
  onPointerDown(t) {
    this.session = new bI(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: kI(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: ET(t),
      onStart: ET(n),
      onMove: r,
      onEnd: (o, a) => {
        delete this.session, i && Pt.postRender(() => i(o, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = No(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const bg = ht(null);
function j9() {
  const e = Ve(bg);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, i = Vw();
  Qe(() => r(i), []);
  const o = Je(() => n && n(i), [i, n]);
  return !t && n ? [!1, o] : [!0];
}
const gf = ht({}), MI = ht({}), op = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function kT(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const bu = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (je.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = kT(e, t.target.x), r = kT(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, L9 = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = La.parse(e);
    if (i.length > 5)
      return r;
    const o = La.createTransformer(e), a = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * t.x, l = n.y.scale * t.y;
    i[0 + a] /= s, i[1 + a] /= l;
    const c = Jt(s, l, 0.5);
    return typeof i[2 + a] == "number" && (i[2 + a] /= c), typeof i[3 + a] == "number" && (i[3 + a] /= c), o(i);
  }
}, Pp = {};
function B9(e) {
  Object.assign(Pp, e);
}
const { schedule: M1, cancel: TEe } = $D(queueMicrotask, !1);
class F9 extends Uw {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    B9(W9), o && (n.group && n.group.add(o), r && r.register && i && r.register(o), o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), op.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, a = r.projection;
    return a && (a.isPresent = o, i || t.layoutDependency !== n || n === void 0 ? a.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? a.promote() : a.relegate() || Pt.postRender(() => {
      const s = a.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), M1.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function NI(e) {
  const [t, n] = j9(), r = Ve(gf);
  return E(F9, { ...e, layoutGroup: r, switchLayoutGroup: Ve(MI), isPresent: t, safeToRemove: n });
}
const W9 = {
  borderRadius: {
    ...bu,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: bu,
  borderTopRightRadius: bu,
  borderBottomLeftRadius: bu,
  borderBottomRightRadius: bu,
  boxShadow: L9
}, $I = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], z9 = $I.length, MT = (e) => typeof e == "string" ? parseFloat(e) : e, NT = (e) => typeof e == "number" || je.test(e);
function V9(e, t, n, r, i, o) {
  i ? (e.opacity = Jt(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    U9(r)
  ), e.opacityExit = Jt(t.opacity !== void 0 ? t.opacity : 1, 0, K9(r))) : o && (e.opacity = Jt(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let a = 0; a < z9; a++) {
    const s = `border${$I[a]}Radius`;
    let l = $T(t, s), c = $T(n, s);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || NT(l) === NT(c) ? (e[s] = Math.max(Jt(MT(l), MT(c), r), 0), (Gi.test(c) || Gi.test(l)) && (e[s] += "%")) : e[s] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = Jt(t.rotate || 0, n.rotate || 0, r));
}
function $T(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const U9 = /* @__PURE__ */ DI(0, 0.5, FD), K9 = /* @__PURE__ */ DI(0.5, 0.95, Hn);
function DI(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(Zl(e, t, r));
}
function DT(e, t) {
  e.min = t.min, e.max = t.max;
}
function ri(e, t) {
  DT(e.x, t.x), DT(e.y, t.y);
}
function IT(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function RT(e, t, n, r, i) {
  return e -= t, e = Ap(e, 1 / n, r), i !== void 0 && (e = Ap(e, 1 / i, r)), e;
}
function H9(e, t = 0, n = 1, r = 0.5, i, o = e, a = e) {
  if (Gi.test(t) && (t = parseFloat(t), t = Jt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let s = Jt(o.min, o.max, r);
  e === o && (s -= t), e.min = RT(e.min, t, n, s, i), e.max = RT(e.max, t, n, s, i);
}
function jT(e, t, [n, r, i], o, a) {
  H9(e, t[n], t[r], t[i], t.scale, o, a);
}
const G9 = ["x", "scaleX", "originX"], Y9 = ["y", "scaleY", "originY"];
function LT(e, t, n, r) {
  jT(e.x, t, G9, n ? n.x : void 0, r ? r.x : void 0), jT(e.y, t, Y9, n ? n.y : void 0, r ? r.y : void 0);
}
function BT(e) {
  return e.translate === 0 && e.scale === 1;
}
function II(e) {
  return BT(e.x) && BT(e.y);
}
function FT(e, t) {
  return e.min === t.min && e.max === t.max;
}
function q9(e, t) {
  return FT(e.x, t.x) && FT(e.y, t.y);
}
function WT(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function RI(e, t) {
  return WT(e.x, t.x) && WT(e.y, t.y);
}
function zT(e) {
  return Ur(e.x) / Ur(e.y);
}
function VT(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class X9 {
  constructor() {
    this.members = [];
  }
  add(t) {
    T1(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (C1(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        r = o;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Z9(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, a = (n == null ? void 0 : n.z) || 0;
  if ((i || o || a) && (r = `translate3d(${i}px, ${o}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: f, rotateX: d, rotateY: p, skewX: m, skewY: g } = n;
    c && (r = `perspective(${c}px) ${r}`), f && (r += `rotate(${f}deg) `), d && (r += `rotateX(${d}deg) `), p && (r += `rotateY(${p}deg) `), m && (r += `skewX(${m}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const J9 = (e, t) => e.depth - t.depth;
class Q9 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    T1(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    C1(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(J9), this.isDirty = !1, this.children.forEach(t);
  }
}
function ap(e) {
  const t = nr(e) ? e.get() : e;
  return Uq(t) ? t.toValue() : t;
}
function e7(e, t) {
  const n = Yi.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (Ra(r), e(o - t));
  };
  return Pt.read(r, !0), () => Ra(r);
}
function t7(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function n7(e, t, n) {
  const r = nr(e) ? e : mf(e);
  return r.start(P1("", r, t, n)), r.animation;
}
const ps = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, ju = typeof window < "u" && window.MotionDebug !== void 0, ob = ["", "X", "Y", "Z"], r7 = { visibility: "hidden" }, UT = 1e3;
let i7 = 0;
function ab(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function jI(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = mI(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Pt, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && jI(r);
}
function LI({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(a = {}, s = t == null ? void 0 : t()) {
      this.id = i7++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, ju && (ps.totalNodes = ps.resolvedTargetDeltas = ps.recalculatedProjection = 0), this.nodes.forEach(s7), this.nodes.forEach(d7), this.nodes.forEach(h7), this.nodes.forEach(l7), ju && window.MotionDebug.record(ps);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Q9());
    }
    addEventListener(a, s) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new E1()), this.eventHandlers.get(a).add(s);
    }
    notifyListeners(a, ...s) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...s);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, s = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = t7(a), this.instance = a;
      const { layoutId: l, layout: c, visualElement: f } = this.options;
      if (f && !f.current && f.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), s && (c || l) && (this.isLayoutDirty = !0), e) {
        let d;
        const p = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = e7(p, 250), op.hasAnimatedSinceResize && (op.hasAnimatedSinceResize = !1, this.nodes.forEach(HT));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && f && (l || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: p, hasRelativeTargetChanged: m, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || f.getDefaultTransition() || v7, { onLayoutAnimationStart: y, onLayoutAnimationComplete: x } = f.getProps(), w = !this.targetLayout || !RI(this.targetLayout, g) || m, S = !p && m;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || S || p && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, S);
          const A = {
            ...d1(v, "layout"),
            onPlay: y,
            onComplete: x
          };
          (f.shouldReduceMotion || this.options.layoutRoot) && (A.delay = 0, A.type = !1), this.startAnimation(A);
        } else
          p || HT(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ra(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(p7), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && jI(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const d = this.path[f];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(KT);
        return;
      }
      this.isUpdating || this.nodes.forEach(u7), this.isUpdating = !1, this.nodes.forEach(f7), this.nodes.forEach(o7), this.nodes.forEach(a7), this.clearAllSnapshots();
      const s = Yi.now();
      Fn.delta = ja(0, 1e3 / 60, s - Fn.timestamp), Fn.timestamp = s, Fn.isProcessing = !0, Zv.update.process(Fn), Zv.preRender.process(Fn), Zv.render.process(Fn), Fn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, M1.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(c7), this.sharedNodes.forEach(m7);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Pt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Pt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = sn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (s = !1), s) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !II(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, f = c !== this.prevTransformTemplateValue;
      a && (s || hs(this.latestValues) || f) && (i(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return a && (l = this.removeTransform(l)), b7(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var a;
      const { visualElement: s } = this.options;
      if (!s)
        return sn();
      const l = s.measureViewportBox();
      if (!(((a = this.scroll) === null || a === void 0 ? void 0 : a.wasRoot) || this.path.some(x7))) {
        const { scroll: f } = this.root;
        f && (Nl(l.x, f.offset.x), Nl(l.y, f.offset.y));
      }
      return l;
    }
    removeElementScroll(a) {
      var s;
      const l = sn();
      if (ri(l, a), !((s = this.scroll) === null || s === void 0) && s.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c], { scroll: d, options: p } = f;
        f !== this.root && d && p.layoutScroll && (d.wasRoot && ri(l, a), Nl(l.x, d.offset.x), Nl(l.y, d.offset.y));
      }
      return l;
    }
    applyTransform(a, s = !1) {
      const l = sn();
      ri(l, a);
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        !s && f.options.layoutScroll && f.scroll && f !== f.root && $l(l, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), hs(f.latestValues) && $l(l, f.latestValues);
      }
      return hs(this.latestValues) && $l(l, this.latestValues), l;
    }
    removeTransform(a) {
      const s = sn();
      ri(s, a);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !hs(c.latestValues))
          continue;
        k0(c.latestValues) && c.updateSnapshot();
        const f = sn(), d = c.measurePageBox();
        ri(f, d), LT(s, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, f);
      }
      return hs(this.latestValues) && LT(s, this.latestValues), s;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Fn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var s;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(a || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: p } = this.options;
      if (!(!this.layout || !(d || p))) {
        if (this.resolvedRelativeTargetAt = Fn.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = sn(), this.relativeTargetOrigin = sn(), Hu(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), ri(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = sn(), this.targetWithTransforms = sn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), w9(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : ri(this.target, this.layout.layoutBox), CI(this.target, this.targetDelta)) : ri(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const m = this.getClosestProjectingParent();
            m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = sn(), this.relativeTargetOrigin = sn(), Hu(this.relativeTargetOrigin, this.target, m.target), ri(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          ju && ps.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || k0(this.parent.latestValues) || TI(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const s = this.getLead(), l = !!this.resumingFrom || this !== s;
      let c = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === Fn.timestamp && (c = !1), c)
        return;
      const { layout: f, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(f || d))
        return;
      ri(this.layoutCorrected, this.layout.layoutBox);
      const p = this.treeScale.x, m = this.treeScale.y;
      k9(this.layoutCorrected, this.treeScale, this.path, l), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = sn());
      const { target: g } = s;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (IT(this.prevProjectionDelta.x, this.projectionDelta.x), IT(this.prevProjectionDelta.y, this.projectionDelta.y)), Ku(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== p || this.treeScale.y !== m || !VT(this.projectionDelta.x, this.prevProjectionDelta.x) || !VT(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g)), ju && ps.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      var s;
      if ((s = this.options.visualElement) === null || s === void 0 || s.scheduleRender(), a) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Ml(), this.projectionDelta = Ml(), this.projectionDeltaWithTransform = Ml();
    }
    setAnimationOrigin(a, s = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, f = { ...this.latestValues }, d = Ml();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const p = sn(), m = l ? l.source : void 0, g = this.layout ? this.layout.source : void 0, v = m !== g, y = this.getStack(), x = !y || y.members.length <= 1, w = !!(v && !x && this.options.crossfade === !0 && !this.path.some(y7));
      this.animationProgress = 0;
      let S;
      this.mixTargetDelta = (A) => {
        const _ = A / 1e3;
        GT(d.x, a.x, _), GT(d.y, a.y, _), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Hu(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), g7(this.relativeTarget, this.relativeTargetOrigin, p, _), S && q9(this.relativeTarget, S) && (this.isProjectionDirty = !1), S || (S = sn()), ri(S, this.relativeTarget)), v && (this.animationValues = f, V9(f, c, this.latestValues, _, w, x)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = _;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ra(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Pt.update(() => {
        op.hasAnimatedSinceResize = !0, this.currentAnimation = n7(0, UT, {
          ...a,
          onUpdate: (s) => {
            this.mixTargetDelta(s), a.onUpdate && a.onUpdate(s);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(UT), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: s, target: l, layout: c, latestValues: f } = a;
      if (!(!s || !l || !c)) {
        if (this !== a && this.layout && c && BI(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || sn();
          const d = Ur(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + d;
          const p = Ur(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + p;
        }
        ri(s, l), $l(s, f), Ku(this.projectionDeltaWithTransform, this.layoutCorrected, s, f);
      }
    }
    registerSharedNode(a, s) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new X9()), this.sharedNodes.get(a).add(s);
      const c = s.options.initialPromotionConfig;
      s.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: s, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let s = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const c = {};
      l.z && ab("z", a, c, this.animationValues);
      for (let f = 0; f < ob.length; f++)
        ab(`rotate${ob[f]}`, a, c, this.animationValues), ab(`skew${ob[f]}`, a, c, this.animationValues);
      a.render();
      for (const f in c)
        a.setStaticValue(f, c[f]), this.animationValues && (this.animationValues[f] = c[f]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var s, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return r7;
      const c = {
        visibility: ""
      }, f = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = ap(a == null ? void 0 : a.pointerEvents) || "", c.transform = f ? f(this.latestValues, "") : "none", c;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const v = {};
        return this.options.layoutId && (v.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, v.pointerEvents = ap(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !hs(this.latestValues) && (v.transform = f ? f({}, "") : "none", this.hasProjected = !1), v;
      }
      const p = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), c.transform = Z9(this.projectionDeltaWithTransform, this.treeScale, p), f && (c.transform = f(p, c.transform));
      const { x: m, y: g } = this.projectionDelta;
      c.transformOrigin = `${m.origin * 100}% ${g.origin * 100}% 0`, d.animationValues ? c.opacity = d === this ? (l = (s = p.opacity) !== null && s !== void 0 ? s : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : c.opacity = d === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const v in Pp) {
        if (p[v] === void 0)
          continue;
        const { correct: y, applyTo: x } = Pp[v], w = c.transform === "none" ? p[v] : y(p[v], d);
        if (x) {
          const S = x.length;
          for (let A = 0; A < S; A++)
            c[x[A]] = w;
        } else
          c[v] = w;
      }
      return this.options.layoutId && (c.pointerEvents = d === this ? ap(a == null ? void 0 : a.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var s;
        return (s = a.currentAnimation) === null || s === void 0 ? void 0 : s.stop();
      }), this.root.nodes.forEach(KT), this.root.sharedNodes.clear();
    }
  };
}
function o7(e) {
  e.updateLayout();
}
function a7(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: o } = e.options, a = n.source !== e.layout.source;
    o === "size" ? si((d) => {
      const p = a ? n.measuredBox[d] : n.layoutBox[d], m = Ur(p);
      p.min = r[d].min, p.max = p.min + m;
    }) : BI(o, n.layoutBox, r) && si((d) => {
      const p = a ? n.measuredBox[d] : n.layoutBox[d], m = Ur(r[d]);
      p.max = p.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + m);
    });
    const s = Ml();
    Ku(s, r, n.layoutBox);
    const l = Ml();
    a ? Ku(l, e.applyTransform(i, !0), n.measuredBox) : Ku(l, r, n.layoutBox);
    const c = !II(s);
    let f = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: p, layout: m } = d;
        if (p && m) {
          const g = sn();
          Hu(g, n.layoutBox, p.layoutBox);
          const v = sn();
          Hu(v, r, m.layoutBox), RI(g, v) || (f = !0), d.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = g, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function s7(e) {
  ju && ps.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function l7(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function c7(e) {
  e.clearSnapshot();
}
function KT(e) {
  e.clearMeasurements();
}
function u7(e) {
  e.isLayoutDirty = !1;
}
function f7(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function HT(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function d7(e) {
  e.resolveTargetDelta();
}
function h7(e) {
  e.calcProjection();
}
function p7(e) {
  e.resetSkewAndRotation();
}
function m7(e) {
  e.removeLeadSnapshot();
}
function GT(e, t, n) {
  e.translate = Jt(t.translate, 0, n), e.scale = Jt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function YT(e, t, n, r) {
  e.min = Jt(t.min, n.min, r), e.max = Jt(t.max, n.max, r);
}
function g7(e, t, n, r) {
  YT(e.x, t.x, n.x, r), YT(e.y, t.y, n.y, r);
}
function y7(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const v7 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, qT = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), XT = qT("applewebkit/") && !qT("chrome/") ? Math.round : Hn;
function ZT(e) {
  e.min = XT(e.min), e.max = XT(e.max);
}
function b7(e) {
  ZT(e.x), ZT(e.y);
}
function BI(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !x9(zT(t), zT(n), 0.2);
}
function x7(e) {
  var t;
  return e !== e.root && ((t = e.scroll) === null || t === void 0 ? void 0 : t.wasRoot);
}
const w7 = LI({
  attachResizeListener: (e, t) => Oo(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), sb = {
  current: void 0
}, FI = LI({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!sb.current) {
      const e = new w7({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), sb.current = e;
    }
    return sb.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), _7 = {
  pan: {
    Feature: R9
  },
  drag: {
    Feature: I9,
    ProjectionNode: FI,
    MeasureLayout: NI
  }
};
function JT(e, t) {
  const n = t ? "pointerenter" : "pointerleave", r = t ? "onHoverStart" : "onHoverEnd", i = (o, a) => {
    if (o.pointerType === "touch" || SI())
      return;
    const s = e.getProps();
    e.animationState && s.whileHover && e.animationState.setActive("whileHover", t);
    const l = s[r];
    l && Pt.postRender(() => l(o, a));
  };
  return No(e.current, n, i, {
    passive: !e.getProps()[r]
  });
}
class S7 extends Va {
  mount() {
    this.unmount = Mo(JT(this.node, !0), JT(this.node, !1));
  }
  unmount() {
  }
}
class O7 extends Va {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Mo(Oo(this.node.current, "focus", () => this.onFocus()), Oo(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const WI = (e, t) => t ? e === t ? !0 : WI(e, t.parentElement) : !1;
function lb(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, vg(n));
}
class A7 extends Va {
  constructor() {
    super(...arguments), this.removeStartListeners = Hn, this.removeEndListeners = Hn, this.removeAccessibleListeners = Hn, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), o = No(window, "pointerup", (s, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: f, globalTapTarget: d } = this.node.getProps(), p = !d && !WI(this.node.current, s.target) ? f : c;
        p && Pt.update(() => p(s, l));
      }, {
        passive: !(r.onTap || r.onPointerUp)
      }), a = No(window, "pointercancel", (s, l) => this.cancelPress(s, l), {
        passive: !(r.onTapCancel || r.onPointerCancel)
      });
      this.removeEndListeners = Mo(o, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (o) => {
        if (o.key !== "Enter" || this.isPressing)
          return;
        const a = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || lb("up", (l, c) => {
            const { onTap: f } = this.node.getProps();
            f && Pt.postRender(() => f(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Oo(this.node.current, "keyup", a), lb("down", (s, l) => {
          this.startPress(s, l);
        });
      }, n = Oo(this.node.current, "keydown", t), r = () => {
        this.isPressing && lb("cancel", (o, a) => this.cancelPress(o, a));
      }, i = Oo(this.node.current, "blur", r);
      this.removeAccessibleListeners = Mo(n, i);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && Pt.postRender(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !SI();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && Pt.postRender(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = No(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(t.onTapStart || t.onPointerStart)
    }), r = Oo(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Mo(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const N0 = /* @__PURE__ */ new WeakMap(), cb = /* @__PURE__ */ new WeakMap(), P7 = (e) => {
  const t = N0.get(e.target);
  t && t(e);
}, T7 = (e) => {
  e.forEach(P7);
};
function C7({ root: e, ...t }) {
  const n = e || document;
  cb.has(n) || cb.set(n, {});
  const r = cb.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(T7, { root: e, ...t })), r[i];
}
function E7(e, t, n) {
  const r = C7(t);
  return N0.set(e, n), r.observe(e), () => {
    N0.delete(e), r.unobserve(e);
  };
}
const k7 = {
  some: 0,
  all: 1
};
class M7 extends Va {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : k7[i]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, o && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: f, onViewportLeave: d } = this.node.getProps(), p = c ? f : d;
      p && p(l);
    };
    return E7(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(N7(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function N7({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const $7 = {
  inView: {
    Feature: M7
  },
  tap: {
    Feature: A7
  },
  focus: {
    Feature: O7
  },
  hover: {
    Feature: S7
  }
}, D7 = {
  layout: {
    ProjectionNode: FI,
    MeasureLayout: NI
  }
}, N1 = ht({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), xg = ht({}), $1 = typeof window < "u", D1 = $1 ? $i : Qe, zI = ht({ strict: !1 });
function I7(e, t, n, r, i) {
  var o, a;
  const { visualElement: s } = Ve(xg), l = Ve(zI), c = Ve(bg), f = Ve(N1).reducedMotion, d = ft();
  r = r || l.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: f
  }));
  const p = d.current, m = Ve(MI);
  p && !p.projection && i && (p.type === "html" || p.type === "svg") && R7(d.current, n, i, m);
  const g = ft(!1);
  I$(() => {
    p && g.current && p.update(n, c);
  });
  const v = n[pI], y = ft(!!v && !(!((o = window.MotionHandoffIsComplete) === null || o === void 0) && o.call(window, v)) && ((a = window.MotionHasOptimisedAnimation) === null || a === void 0 ? void 0 : a.call(window, v)));
  return D1(() => {
    p && (g.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), M1.render(p.render), y.current && p.animationState && p.animationState.animateChanges());
  }), Qe(() => {
    p && (!y.current && p.animationState && p.animationState.animateChanges(), y.current && (queueMicrotask(() => {
      var x;
      (x = window.MotionHandoffMarkAsComplete) === null || x === void 0 || x.call(window, v);
    }), y.current = !1));
  }), p;
}
function R7(e, t, n, r) {
  const { layoutId: i, layout: o, drag: a, dragConstraints: s, layoutScroll: l, layoutRoot: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : VI(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!a || s && kl(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function VI(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : VI(e.parent);
}
function j7(e, t, n) {
  return Je(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : kl(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function wg(e) {
  return mg(e.animate) || f1.some((t) => df(e[t]));
}
function UI(e) {
  return !!(wg(e) || e.variants);
}
function L7(e, t) {
  if (wg(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || df(n) ? n : void 0,
      animate: df(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function B7(e) {
  const { initial: t, animate: n } = L7(e, Ve(xg));
  return Le(() => ({ initial: t, animate: n }), [QT(t), QT(n)]);
}
function QT(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const eC = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Jl = {};
for (const e in eC)
  Jl[e] = {
    isEnabled: (t) => eC[e].some((n) => !!t[n])
  };
function F7(e) {
  for (const t in e)
    Jl[t] = {
      ...Jl[t],
      ...e[t]
    };
}
const W7 = Symbol.for("motionComponentSymbol");
function z7({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && F7(e);
  function o(s, l) {
    let c;
    const f = {
      ...Ve(N1),
      ...s,
      layoutId: V7(s)
    }, { isStatic: d } = f, p = B7(s), m = r(s, d);
    if (!d && $1) {
      U7(f, e);
      const g = K7(f);
      c = g.MeasureLayout, p.visualElement = I7(i, m, f, t, g.ProjectionNode);
    }
    return me(xg.Provider, { value: p, children: [c && p.visualElement ? E(c, { visualElement: p.visualElement, ...f }) : null, n(i, s, j7(m, p.visualElement, l), m, d, p.visualElement)] });
  }
  const a = $t(o);
  return a[W7] = i, a;
}
function V7({ layoutId: e }) {
  const t = Ve(gf).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function U7(e, t) {
  const n = Ve(zI).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? $c(!1, r) : Bo(!1, r);
  }
}
function K7(e) {
  const { drag: t, layout: n } = Jl;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const H7 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function I1(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(H7.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function KI(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const o in n)
    e.style.setProperty(o, n[o]);
}
const HI = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function GI(e, t, n, r) {
  KI(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(HI.has(i) ? i : k1(i), t.attrs[i]);
}
function YI(e, { layout: t, layoutId: n }) {
  return Ks.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Pp[e] || e === "opacity");
}
function R1(e, t, n) {
  var r;
  const { style: i } = e, o = {};
  for (const a in i)
    (nr(i[a]) || t.style && nr(t.style[a]) || YI(a, e) || ((r = n == null ? void 0 : n.getValue(a)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (o[a] = i[a]);
  return o;
}
function qI(e, t, n) {
  const r = R1(e, t, n);
  for (const i in e)
    if (nr(e[i]) || nr(t[i])) {
      const o = ud.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
function j1(e) {
  const t = ft(null);
  return t.current === null && (t.current = e()), t.current;
}
function G7({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, i, o) {
  const a = {
    latestValues: Y7(r, i, o, e),
    renderState: t()
  };
  return n && (a.mount = (s) => n(r, s, a)), a;
}
const XI = (e) => (t, n) => {
  const r = Ve(xg), i = Ve(bg), o = () => G7(e, t, r, i);
  return n ? o() : j1(o);
};
function Y7(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const p in o)
    i[p] = ap(o[p]);
  let { initial: a, animate: s } = e;
  const l = wg(e), c = UI(e);
  t && c && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || a === !1;
  const d = f ? s : a;
  if (d && typeof d != "boolean" && !mg(d)) {
    const p = Array.isArray(d) ? d : [d];
    for (let m = 0; m < p.length; m++) {
      const g = c1(e, p[m]);
      if (g) {
        const { transitionEnd: v, transition: y, ...x } = g;
        for (const w in x) {
          let S = x[w];
          if (Array.isArray(S)) {
            const A = f ? S.length - 1 : 0;
            S = S[A];
          }
          S !== null && (i[w] = S);
        }
        for (const w in v)
          i[w] = v[w];
      }
    }
  }
  return i;
}
const L1 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), ZI = () => ({
  ...L1(),
  attrs: {}
}), JI = (e, t) => t && typeof e == "number" ? t.transform(e) : e, q7 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, X7 = ud.length;
function Z7(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < X7; o++) {
    const a = ud[o], s = e[a];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (a.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const c = JI(s, b1[a]);
      if (!l) {
        i = !1;
        const f = q7[a] || a;
        r += `${f}(${c}) `;
      }
      n && (t[a] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function B1(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let a = !1, s = !1;
  for (const l in t) {
    const c = t[l];
    if (Ks.has(l)) {
      a = !0;
      continue;
    } else if (KD(l)) {
      i[l] = c;
      continue;
    } else {
      const f = JI(c, b1[l]);
      l.startsWith("origin") ? (s = !0, o[l] = f) : r[l] = f;
    }
  }
  if (t.transform || (a || n ? r.transform = Z7(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: c = "50%", originZ: f = 0 } = o;
    r.transformOrigin = `${l} ${c} ${f}`;
  }
}
function tC(e, t, n) {
  return typeof e == "string" ? e : je.transform(t + n * e);
}
function J7(e, t, n) {
  const r = tC(t, e.x, e.width), i = tC(n, e.y, e.height);
  return `${r} ${i}`;
}
const Q7 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, eX = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function tX(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? Q7 : eX;
  e[o.offset] = je.transform(-r);
  const a = je.transform(t), s = je.transform(n);
  e[o.array] = `${a} ${s}`;
}
function F1(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: o,
  pathLength: a,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, f, d) {
  if (B1(e, c, d), f) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: m, dimensions: g } = e;
  p.transform && (g && (m.transform = p.transform), delete p.transform), g && (i !== void 0 || o !== void 0 || m.transform) && (m.transformOrigin = J7(g, i !== void 0 ? i : 0.5, o !== void 0 ? o : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), a !== void 0 && tX(p, a, s, l, !1);
}
const W1 = (e) => typeof e == "string" && e.toLowerCase() === "svg", nX = {
  useVisualState: XI({
    scrapeMotionValuesFromProps: qI,
    createRenderState: ZI,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      Pt.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), Pt.render(() => {
        F1(n, r, W1(t.tagName), e.transformTemplate), GI(t, n);
      });
    }
  })
}, rX = {
  useVisualState: XI({
    scrapeMotionValuesFromProps: R1,
    createRenderState: L1
  })
};
function QI(e, t, n) {
  for (const r in t)
    !nr(t[r]) && !YI(r, n) && (e[r] = t[r]);
}
function iX({ transformTemplate: e }, t) {
  return Le(() => {
    const n = L1();
    return B1(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function oX(e, t) {
  const n = e.style || {}, r = {};
  return QI(r, n, e), Object.assign(r, iX(e, t)), r;
}
function aX(e, t) {
  const n = {}, r = oX(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const sX = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Tp(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || sX.has(e);
}
let eR = (e) => !Tp(e);
function lX(e) {
  e && (eR = (t) => t.startsWith("on") ? !Tp(t) : e(t));
}
try {
  lX(require("@emotion/is-prop-valid").default);
} catch {
}
function cX(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (eR(i) || n === !0 && Tp(i) || !t && !Tp(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function uX(e, t, n, r) {
  const i = Le(() => {
    const o = ZI();
    return F1(o, t, W1(r), e.transformTemplate), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    QI(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
function fX(e = !1) {
  return (n, r, i, { latestValues: o }, a) => {
    const l = (I1(n) ? uX : aX)(r, o, a, n), c = cX(r, typeof n == "string", e), f = n !== fi ? { ...c, ...l, ref: i } : {}, { children: d } = r, p = Le(() => nr(d) ? d.get() : d, [d]);
    return Yl(n, {
      ...f,
      children: p
    });
  };
}
function dX(e, t) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const a = {
      ...I1(r) ? nX : rX,
      preloadedFeatures: e,
      useRender: fX(i),
      createVisualElement: t,
      Component: r
    };
    return z7(a);
  };
}
const $0 = { current: null }, tR = { current: !1 };
function hX() {
  if (tR.current = !0, !!$1)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => $0.current = e.matches;
      e.addListener(t), t();
    } else
      $0.current = !1;
}
function pX(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if (nr(i))
      e.addValue(r, i), process.env.NODE_ENV === "development" && pg(i.version === "11.11.17", `Attempting to mix Motion versions ${i.version} with 11.11.17 may not work as expected.`);
    else if (nr(o))
      e.addValue(r, mf(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(i) : a.hasAnimated || a.set(i);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, mf(a !== void 0 ? a : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const nC = /* @__PURE__ */ new WeakMap(), mX = [...YD, Zn, La], gX = (e) => mX.find(GD(e)), rC = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class yX {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: o, visualState: a }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = g1, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = Yi.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Pt.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = a;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!o, this.isControllingVariants = wg(n), this.isVariantNode = UI(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in d) {
      const m = d[p];
      l[p] !== void 0 && nr(m) && m.set(l[p], !1);
    }
  }
  mount(t) {
    this.current = t, nC.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), tR.current || hX(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : $0.current, process.env.NODE_ENV !== "production" && pg(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    nC.delete(this.current), this.projection && this.projection.unmount(), Ra(this.notifyUpdate), Ra(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Ks.has(t), i = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && Pt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o(), a && a(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Jl) {
      const n = Jl[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : sn();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < rC.length; r++) {
      const i = rC[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, a = t[o];
      a && (this.propEventSubscriptions[i] = this.on(i, a));
    }
    this.prevMotionValues = pX(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = mf(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let i = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return i != null && (typeof i == "string" && (VD(i) || zD(i)) ? i = parseFloat(i) : !gX(i) && La.test(n) && (i = nI(t, n)), this.setBaseTarget(t, nr(i) ? i.get() : i)), nr(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let i;
    if (typeof r == "string" || typeof r == "object") {
      const a = c1(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      a && (i = a[t]);
    }
    if (r && i !== void 0)
      return i;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !nr(o) ? o : this.initialValues[t] !== void 0 && i === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new E1()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class nR extends yX {
  constructor() {
    super(...arguments), this.KeyframeResolver = rI;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
}
function vX(e) {
  return window.getComputedStyle(e);
}
class bX extends nR {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = KI;
  }
  readValueFromInstance(t, n) {
    if (Ks.has(n)) {
      const r = x1(n);
      return r && r.default || 0;
    } else {
      const r = vX(t), i = (KD(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return EI(t, n);
  }
  build(t, n, r) {
    B1(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return R1(t, n, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    nr(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class xX extends nR {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = sn;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Ks.has(n)) {
      const r = x1(n);
      return r && r.default || 0;
    }
    return n = HI.has(n) ? n : k1(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return qI(t, n, r);
  }
  build(t, n, r) {
    F1(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, i) {
    GI(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = W1(t.tagName), super.mount(t);
  }
}
const wX = (e, t) => I1(e) ? new xX(t) : new bX(t, {
  allowProjection: e !== fi
}), _X = /* @__PURE__ */ dX({
  ...f9,
  ...$7,
  ..._7,
  ...D7
}, wX), ui = /* @__PURE__ */ nY(_X);
class SX extends ee.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function OX({ children: e, isPresent: t }) {
  const n = Vw(), r = ft(null), i = ft({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: o } = Ve(N1);
  return I$(() => {
    const { width: a, height: s, top: l, left: c } = i.current;
    if (t || !r.current || !a || !s)
      return;
    r.current.dataset.motionPopId = n;
    const f = document.createElement("style");
    return o && (f.nonce = o), document.head.appendChild(f), f.sheet && f.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${s}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(f);
    };
  }, [t]), E(SX, { isPresent: t, childRef: r, sizeRef: i, children: ee.cloneElement(e, { ref: r }) });
}
const AX = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: o, mode: a }) => {
  const s = j1(PX), l = Vw(), c = Je((d) => {
    s.set(d, !0);
    for (const p of s.values())
      if (!p)
        return;
    r && r();
  }, [s, r]), f = Le(
    () => ({
      id: l,
      initial: t,
      isPresent: n,
      custom: i,
      onExitComplete: c,
      register: (d) => (s.set(d, !1), () => s.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    o ? [Math.random(), c] : [n, c]
  );
  return Le(() => {
    s.forEach((d, p) => s.set(p, !1));
  }, [n]), ee.useEffect(() => {
    !n && !s.size && r && r();
  }, [n]), a === "popLayout" && (e = E(OX, { isPresent: n, children: e })), E(bg.Provider, { value: f, children: e });
};
function PX() {
  return /* @__PURE__ */ new Map();
}
const kh = (e) => e.key || "";
function iC(e) {
  const t = [];
  return tr.forEach(e, (n) => {
    ut(n) && t.push(n);
  }), t;
}
const Hs = ({ children: e, exitBeforeEnter: t, custom: n, initial: r = !0, onExitComplete: i, presenceAffectsLayout: o = !0, mode: a = "sync" }) => {
  Bo(!t, "Replace exitBeforeEnter with mode='wait'");
  const s = Le(() => iC(e), [e]), l = s.map(kh), c = ft(!0), f = ft(s), d = j1(() => /* @__PURE__ */ new Map()), [p, m] = Me(s), [g, v] = Me(s);
  D1(() => {
    c.current = !1, f.current = s;
    for (let w = 0; w < g.length; w++) {
      const S = kh(g[w]);
      l.includes(S) ? d.delete(S) : d.get(S) !== !0 && d.set(S, !1);
    }
  }, [g, l.length, l.join("-")]);
  const y = [];
  if (s !== p) {
    let w = [...s];
    for (let S = 0; S < g.length; S++) {
      const A = g[S], _ = kh(A);
      l.includes(_) || (w.splice(S, 0, A), y.push(A));
    }
    a === "wait" && y.length && (w = y), v(iC(w)), m(s);
    return;
  }
  process.env.NODE_ENV !== "production" && a === "wait" && g.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: x } = Ve(gf);
  return E(Ut, { children: g.map((w) => {
    const S = kh(w), A = s === g || l.includes(S), _ = () => {
      if (d.has(S))
        d.set(S, !0);
      else
        return;
      let O = !0;
      d.forEach((T) => {
        T || (O = !1);
      }), O && (x == null || x(), v(f.current), i && i());
    };
    return E(AX, { isPresent: A, initial: !c.current || r ? void 0 : !1, custom: A ? void 0 : n, presenceAffectsLayout: o, mode: a, onExitComplete: A ? void 0 : _, children: w }, S);
  }) });
}, TX = ht(null);
function CX() {
  const e = ft(!1);
  return D1(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function EX() {
  const e = CX(), [t, n] = Me(0), r = Je(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Je(() => Pt.postRender(r), [r]), t];
}
const kX = (e) => !e.isLayoutDirty && e.willUpdate(!1);
function oC() {
  const e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new WeakMap(), n = () => e.forEach(kX);
  return {
    add: (r) => {
      e.add(r), t.set(r, r.addEventListener("willUpdate", n));
    },
    remove: (r) => {
      e.delete(r);
      const i = t.get(r);
      i && (i(), t.delete(r)), n();
    },
    dirty: n
  };
}
const rR = (e) => e === !0, MX = (e) => rR(e === !0) || e === "id", NX = ({ children: e, id: t, inherit: n = !0 }) => {
  const r = Ve(gf), i = Ve(TX), [o, a] = EX(), s = ft(null), l = r.id || i;
  s.current === null && (MX(n) && l && (t = t ? l + "-" + t : l), s.current = {
    id: t,
    group: rR(n) && r.group || oC()
  });
  const c = Le(() => ({ ...s.current, forceRender: o }), [a]);
  return E(gf.Provider, { value: c, children: e });
}, iR = ht({}), oR = () => Ve(iR), aR = ht(null), $X = () => Ve(aR), sR = ({
  children: e,
  activeItem: t = null,
  // The currently active item in the group.
  onChange: n,
  // Callback when the active item changes.
  className: r,
  // Additional class names for styling.
  size: i = "sm",
  // Size of the tabs in the group ('xs', 'sm', 'md', 'lg').
  orientation: o = "horizontal",
  // Orientation of the tabs ('horizontal', 'vertical').
  variant: a = "pill",
  // Style variant of the tabs ('pill', 'rounded', 'underline').
  iconPosition: s = "left",
  // Position of the icon in the tab ('left' or 'right').
  width: l = "full"
  // Width of the tabs ('auto' or 'full').
}) => {
  const c = no(), f = oR(), d = (f == null ? void 0 : f.activeItem) || t, p = Je(
    (O, T) => {
      n && n({ event: O, value: T });
    },
    [n]
  );
  let m = "rounded-full", g = "p-1", v, y = "ring-1 ring-tab-border";
  o === "vertical" ? v = "gap-0.5" : (a === "rounded" || a === "pill") && (i === "xs" || i === "sm" ? v = "gap-0.5" : (i === "md" || i === "lg") && (v = "gap-1")), a === "rounded" || o === "vertical" ? m = "rounded-md" : a === "underline" && (m = "rounded-none", g = "p-0", y = "border-t-0 border-r-0 border-l-0 border-b border-solid border-tab-border", i === "xs" ? v = "gap-0" : i === "sm" ? v = "gap-2.5" : (i === "md" || i === "lg") && (v = "gap-3"));
  const _ = H(
    `box-border [&>*]:box-border flex items-center ${l === "full" ? "w-full" : ""} ${o === "vertical" ? "flex-col" : ""}`,
    m,
    g,
    v,
    y,
    a !== "underline" ? "bg-tab-background" : "",
    r
  );
  return /* @__PURE__ */ E("div", { className: _, children: /* @__PURE__ */ E(
    aR.Provider,
    {
      value: {
        activeItem: d,
        onChange: p,
        size: i,
        variant: a,
        orientation: o,
        iconPosition: s,
        width: l
      },
      children: /* @__PURE__ */ E(NX, { id: c, children: I.Children.map(e, (O) => ut(O) ? I.cloneElement(O) : null) })
    }
  ) });
};
sR.displayName = "Tabs.Group";
const lR = $t(
  ({
    slug: e,
    text: t,
    icon: n,
    className: r,
    disabled: i = !1,
    badge: o = null,
    ...a
  }, s) => {
    const l = $X();
    if (!l)
      throw new Error("Tab should be used inside Tabs Group");
    const {
      activeItem: c,
      onChange: f,
      size: d,
      variant: p,
      orientation: m,
      iconPosition: g,
      width: v
    } = l, y = {
      xs: "px-1.5 py-0.5 text-xs [&_svg]:size-3",
      sm: p === "underline" ? "py-1.5 text-sm [&_svg]:size-4" : "px-3 py-1.5 text-sm [&_svg]:size-4",
      md: p === "underline" ? "py-2 text-base [&_svg]:size-5" : "px-3.5 py-1.5 text-base [&_svg]:size-5",
      lg: p === "underline" ? "p-2.5 text-lg [&_svg]:size-6" : "px-3.5 py-1.5 text-lg [&_svg]:size-6"
    }[d], S = H(
      "relative border-none bg-transparent text-text-secondary cursor-pointer flex items-center justify-center transition-[box-shadow,color,background-color] duration-200",
      v === "full" ? "flex-1" : "",
      m === "vertical" ? "w-full justify-between" : ""
    ), A = "border-none";
    let _ = "rounded-full";
    p === "rounded" ? _ = "rounded-md" : p === "underline" && (_ = "rounded-none");
    const D = H(
      S,
      A,
      _,
      "hover:text-text-primary group",
      "focus:outline-none",
      y,
      c === e ? "bg-background-primary text-text-primary shadow-sm" : "",
      i ? "text-text-disabled cursor-not-allowed hover:text-text-disabled" : "",
      r
    ), N = H(
      "flex items-center gap-1 group-hover:text-text-primary",
      i && "group-hover:text-text-disabled"
    ), $ = (B) => {
      f(B, { slug: e, text: t });
    };
    return /* @__PURE__ */ me(
      ui.button,
      {
        ref: s,
        className: D,
        disabled: i,
        onClick: $,
        ...a,
        layoutRoot: !0,
        children: [
          c === e && p === "underline" && /* @__PURE__ */ E(
            ui.span,
            {
              layoutId: "underline",
              layoutDependency: c,
              className: "absolute right-0 left-0 -bottom-px h-px bg-border-interactive"
            }
          ),
          /* @__PURE__ */ me("span", { className: N, children: [
            g === "left" && n && /* @__PURE__ */ E("span", { className: "mr-1 contents center-center transition duration-150", children: n }),
            t,
            g === "right" && n && /* @__PURE__ */ E("span", { className: "ml-1 contents center-center transition duration-150", children: n })
          ] }),
          o && ut(o) && o
        ]
      }
    );
  }
);
lR.displayName = "Tabs.Tab";
const z1 = ({ activeItem: e, children: t }) => /* @__PURE__ */ E(iR.Provider, { value: { activeItem: e }, children: t }), cR = ({ slug: e, children: t }) => {
  const n = oR();
  if (!n)
    throw new Error("TabPanel should be used inside Tabs");
  return e === n.activeItem ? /* @__PURE__ */ E(Ut, { children: t }) : null;
};
cR.displayName = "Tabs.Panel";
z1.Group = sR;
z1.Tab = lR;
z1.Panel = cR;
const Pi = {
  sm: {
    icon: "[&>svg]:size-4",
    searchIcon: "[&>svg]:size-4",
    selectButton: "px-2.5 py-2 rounded text-sm font-medium leading-4 min-h-[2rem]",
    multiSelect: "pl-2 pr-2 py-1.5",
    displaySelected: "text-sm font-normal",
    dropdown: "rounded-md",
    dropdownItemsWrapper: "p-1.5",
    searchbarWrapper: "p-3 flex items-center gap-0.5",
    searchbar: "font-medium text-sm",
    searchbarIcon: "[&>svg]:size-4",
    label: "text-sm font-medium"
  },
  md: {
    icon: "[&>svg]:size-5",
    searchIcon: "[&>svg]:size-5",
    selectButton: "px-3.5 py-2.5 rounded-md text-xs font-medium leading-4 min-h-[2.5rem]",
    multiSelect: "pl-2 pr-2.5 py-2",
    displaySelected: "text-sm font-normal",
    dropdown: "rounded-lg",
    dropdownItemsWrapper: "p-2",
    searchbarWrapper: "p-2.5 flex items-center gap-1",
    searchbar: "font-medium text-sm",
    searchbarIcon: "[&>svg]:size-5",
    label: "text-sm font-medium"
  },
  lg: {
    icon: "[&>svg]:size-6",
    searchIcon: "[&>svg]:size-5",
    selectButton: "px-4 py-3 rounded-lg text-sm font-medium leading-5 min-h-[3rem]",
    multiSelect: "pl-2.5 pr-3 py-2.5",
    displaySelected: "text-base font-normal",
    dropdown: "rounded-lg",
    dropdownItemsWrapper: "p-2",
    searchbarWrapper: "p-2.5 flex items-center gap-1",
    searchbar: "font-medium text-sm",
    searchbarIcon: "[&>svg]:size-5",
    label: "text-base font-medium"
  }
}, Mh = {
  selectButton: "group disabled:outline-field-border-disabled [&:hover:has(:disabled)]:outline-field-border-disabled disabled:cursor-default",
  icon: "group-disabled:text-icon-disabled",
  text: "group-disabled:text-field-color-disabled"
}, uR = ht(
  {}
), V1 = () => Ve(uR);
function fR({
  children: e,
  icon: t = null,
  // Icon to show in the select button.
  placeholder: n = "Select an option",
  // Placeholder text.
  optionIcon: r = null,
  // Icon to show in the selected option.
  displayBy: i = "name",
  // Used to display the value. Default is 'name'.
  label: o,
  // Label for the select component.
  className: a,
  ...s
}) {
  var k, D;
  const {
    sizeValue: l,
    getReferenceProps: c,
    getValues: f,
    selectId: d,
    refs: p,
    isOpen: m,
    multiple: g,
    combobox: v,
    setSelected: y,
    onChange: x,
    isControlled: w,
    disabled: S,
    by: A
  } = V1(), _ = {
    sm: "xs",
    md: "sm",
    lg: "md"
  }[l], O = Je(() => {
    if (t)
      return t;
    const N = "text-field-placeholder " + Mh.icon;
    return v ? /* @__PURE__ */ E(RK, { className: N }) : /* @__PURE__ */ E(Gw, { className: N });
  }, [t]), T = Je(() => {
    const N = f();
    if (!N)
      return null;
    if (typeof e == "function") {
      const B = {
        value: N,
        ...g ? {
          onClose: C(
            N
          )
        } : {}
      };
      return e(B);
    }
    if (g)
      return N.map(
        (B, L) => {
          var F;
          return /* @__PURE__ */ E(
            hg,
            {
              className: "cursor-default",
              icon: r,
              type: "rounded",
              size: _,
              onMouseDown: C(B),
              label: typeof B == "object" ? (F = B[i]) == null ? void 0 : F.toString() : B.toString(),
              closable: !0,
              disabled: S
            },
            L
          );
        }
      );
    let $ = typeof N == "object" ? N[i] : N;
    return ut(e) && ($ = e), /* @__PURE__ */ E(
      "span",
      {
        className: H(
          "truncate",
          Pi[l].displaySelected,
          Mh.text
        ),
        children: $
      }
    );
  }, [f, S]), C = (N) => ($) => {
    $ == null || $.preventDefault(), $ == null || $.stopPropagation();
    const B = [
      ...f() ?? []
    ], L = B.findIndex((F) => F !== null && N !== null && typeof F == "object" ? F[A] === N[A] : F === N);
    L !== -1 && (B.splice(L, 1), w || y(B), typeof x == "function" && x(B));
  };
  return /* @__PURE__ */ me("div", { className: "flex flex-col items-start gap-1.5 [&_*]:box-border box-border", children: [
    !!o && /* @__PURE__ */ E(
      "label",
      {
        className: H(
          (k = Pi[l]) == null ? void 0 : k.label,
          "text-field-label"
        ),
        htmlFor: d,
        children: o
      }
    ),
    /* @__PURE__ */ me(
      "button",
      {
        id: d,
        ref: p.setReference,
        className: H(
          "flex items-center justify-between w-full box-border transition-[outline,background-color,color,box-shadow] duration-200 bg-white",
          "outline outline-1 outline-field-border border-none cursor-pointer",
          !m && "focus:ring-2 focus:ring-offset-4 focus:outline-focus-border focus:ring-focus [&:hover:not(:focus):not(:disabled)]:outline-border-strong",
          Pi[l].selectButton,
          g && Pi[l].multiSelect,
          Mh.selectButton,
          a
        ),
        tabIndex: 0,
        disabled: S,
        ...s,
        ...c(),
        children: [
          /* @__PURE__ */ me(
            "div",
            {
              className: H(
                "flex-1 grid items-center justify-start gap-1.5 overflow-hidden",
                f() && "flex flex-wrap"
              ),
              children: [
                T(),
                (g ? !((D = f()) != null && D.length) : !f()) && /* @__PURE__ */ E(
                  "div",
                  {
                    className: H(
                      "[grid-area:1/1/2/3] text-field-input px-1",
                      Pi[l].displaySelected,
                      Mh.text
                    ),
                    children: n
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ E(
            "div",
            {
              className: H(
                "flex items-center [&>svg]:shrink-0",
                Pi[l].icon
              ),
              children: O()
            }
          )
        ]
      }
    )
  ] });
}
function dR({
  children: e,
  searchBy: t = "name",
  // Used to identify searched value using the key. Default is 'id'.
  searchPlaceholder: n = "Search...",
  // Placeholder text for search box.
  className: r
  // Additional class name for the dropdown.
}) {
  const {
    isOpen: i,
    context: o,
    refs: a,
    combobox: s,
    floatingStyles: l,
    getFloatingProps: c,
    sizeValue: f,
    setSearchKeyword: d,
    setActiveIndex: p,
    setSelectedIndex: m,
    value: g,
    selected: v,
    getValues: y,
    searchKeyword: x,
    listContentRef: w,
    by: S
  } = V1(), A = Le(() => {
    const T = y();
    let C = -1;
    return T && (C = tr.toArray(e).findIndex(
      (k) => ut(k) ? typeof k.props.value == "object" ? k.props.value[S] === T[S] : k.props.value === T : !1
    )), C;
  }, [g, v, e]);
  $i(() => {
    p(A), m(A);
  }, []);
  const _ = Le(() => tr.map(e, (T, C) => {
    if (!ut(T))
      return null;
    if (x) {
      const k = T.props.value;
      if (typeof k == "object") {
        if (k[t].toLowerCase().indexOf(x.toLowerCase()) === -1)
          return null;
      } else if (k.toLowerCase().indexOf(x.toLowerCase()) === -1)
        return null;
    }
    return _t(T, {
      ...T.props,
      index: C
    });
  }), [x, g, v, e]), O = tr.count(_);
  return Qe(() => {
    w.current = [], tr.forEach(e, (T) => {
      if (ut(T) && T.props.value) {
        if (x) {
          const C = T.props.value;
          if (typeof C == "object") {
            if (C[t].toLowerCase().indexOf(x.toLowerCase()) === -1)
              return;
          } else if (C.toLowerCase().indexOf(x.toLowerCase()) === -1)
            return;
        }
        w.current.push(
          typeof T.props.value == "object" ? T.props.value[t || S] : T.props.value
        );
      }
    });
  }, [x]), /* @__PURE__ */ E(Ut, { children: i && /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E($G, { context: o, modal: !1, children: /* @__PURE__ */ me(
    "div",
    {
      ref: a.setFloating,
      className: H(
        "box-border [&_*]:box-border w-full bg-white outline-none shadow-lg outline outline-1 outline-border-subtle",
        s && "grid grid-cols-1 grid-rows-[auto_1fr] divide-y divide-x-0 divide-solid divide-border-subtle",
        Pi[f].dropdown,
        !s && "h-auto",
        s ? "overflow-hidden" : "overflow-y-auto",
        r
      ),
      style: {
        ...l
      },
      ...c(),
      children: [
        s && /* @__PURE__ */ me(
          "div",
          {
            className: H(
              Pi[f].searchbarWrapper
            ),
            children: [
              /* @__PURE__ */ E(
                q$,
                {
                  className: H(
                    "text-icon-secondary shrink-0",
                    Pi[f].searchbarIcon
                  )
                }
              ),
              /* @__PURE__ */ E(
                "input",
                {
                  className: H(
                    "px-1 w-full placeholder:text-field-placeholder border-0 focus:outline-none focus:shadow-none",
                    Pi[f].searchbar
                  ),
                  type: "search",
                  name: "keyword",
                  placeholder: n,
                  onChange: (T) => d(T.target.value),
                  autoComplete: "off"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ me(
          "div",
          {
            className: H(
              "overflow-y-auto",
              !s && "w-full h-full",
              Pi[f].dropdownItemsWrapper
            ),
            children: [
              !!O && _,
              !O && /* @__PURE__ */ E("div", { className: "p-2 text-center text-base font-medium text-field-placeholder", children: "No items found" })
            ]
          }
        )
      ]
    }
  ) }) }) });
}
function hR({ children: e, root: t, id: n }) {
  return /* @__PURE__ */ E(lg, { id: n, root: t, children: e });
}
function pR({
  value: e,
  selected: t,
  children: n,
  className: r,
  ...i
}) {
  const {
    sizeValue: o,
    getItemProps: a,
    onKeyDownItem: s,
    onClickItem: l,
    activeIndex: c,
    selectedIndex: f,
    updateListRef: d,
    getValues: p,
    by: m,
    multiple: g
  } = V1(), { index: v } = i, y = {
    sm: "py-1.5 px-2 text-sm font-normal",
    md: "p-2 text-sm font-normal",
    lg: "p-2 text-base font-normal"
  }, x = {
    sm: "size-4",
    md: "size-4",
    lg: "size-5"
  }, w = Le(() => {
    if (!g)
      return !1;
    const A = p();
    return A ? A.some((_) => _ !== null && e !== null && typeof _ == "object" ? _[m] === e[m] : _ === e) : !1;
  }, [e, p]), S = Le(() => typeof t == "boolean" ? t : g ? w : v === f, [w, f, t]);
  return /* @__PURE__ */ me(
    "div",
    {
      className: H(
        "w-full flex items-center justify-between text-text-primary hover:bg-button-tertiary-hover rounded-md transition-all duration-150 cursor-pointer focus:outline-none focus-within:outline-none outline-none",
        y[o],
        v === c && "bg-button-tertiary-hover",
        r
      ),
      ref: (A) => {
        d(v, A);
      },
      role: "option",
      tabIndex: v === c ? 0 : -1,
      "aria-selected": S && v === c,
      ...a({
        // Handle pointer select.
        onClick() {
          l(v, e);
        },
        // Handle keyboard select.
        onKeyDown(A) {
          s(A, v, e);
        }
      }),
      children: [
        /* @__PURE__ */ E("span", { className: "w-full truncate", children: n }),
        S && /* @__PURE__ */ E(
          od,
          {
            className: H(
              "text-icon-on-color-disabled",
              x[o]
            )
          }
        )
      ]
    }
  );
}
const _g = ({
  id: e,
  size: t = "md",
  // sm, md, lg
  value: n,
  // Value of the select (for controlled component).
  defaultValue: r,
  // Default value of the select (for uncontrolled component).
  onChange: i,
  // Callback function to handle the change event.
  by: o = "id",
  // Used to identify the select component. Default is 'id'.
  children: a,
  multiple: s = !1,
  // If true, it will allow multiple selection.
  combobox: l = !1,
  // If true, it will show a search box.
  disabled: c = !1
  // If true, it will disable the select component.
}) => {
  const f = Le(() => e || `select-${no()}`, [e]), d = Le(() => typeof n < "u", [n]), [p, m] = Me(r), [g, v] = Me(""), y = Je(() => d ? n : p, [d, n, p]), [x, w] = Me(!1), [S, A] = Me(null), [_, O] = Me(null), T = {
    sm: l ? 256 : 172,
    md: l ? 256 : 216,
    lg: l ? 256 : 216
  }, { refs: C, floatingStyles: k, context: D } = ug({
    placement: "bottom-start",
    open: x,
    onOpenChange: w,
    whileElementsMounted: ng,
    middleware: [
      rg(5),
      ig({ padding: 10 }),
      mD({
        apply({ rects: le, elements: ie, availableHeight: Q }) {
          Object.assign(ie.floating.style, {
            maxHeight: `min(${Q}px, ${T[t]}px)`,
            maxWidth: `${le.reference.width}px`
          });
        },
        padding: 10
      })
    ]
  }), N = ft([]), $ = ft([]), B = ft(!1), L = a1(D, { event: "mousedown" }), F = cg(D), W = s1(D, { role: "listbox" }), z = BG(D, {
    listRef: N,
    activeIndex: S,
    selectedIndex: _,
    onNavigate: A,
    // This is a large list, allow looping.
    loop: !0
  }), G = VG(D, {
    listRef: $,
    activeIndex: S,
    selectedIndex: _,
    onMatch: x ? A : O,
    onTypingChange(le) {
      B.current = le;
    }
  }), { getReferenceProps: V, getFloatingProps: U, getItemProps: Y } = fg([
    F,
    W,
    z,
    L,
    ...l ? [] : [G]
  ]), te = (le, ie) => {
    const Q = [
      ...y() ?? []
    ];
    Q.findIndex((ve) => ve !== null && ie !== null && typeof ve == "object" ? ve[o] === ie[o] : ve === ie) === -1 && (Q.push(ie), d || m(Q), O(le), C.reference.current.focus(), w(!1), v(""), typeof i == "function" && i(Q));
  }, ne = (le, ie) => {
    if (s)
      return te(le, ie);
    O(le), d || m(ie), C.reference.current.focus(), w(!1), v(""), typeof i == "function" && i(ie);
  }, re = Je((le, ie) => {
    N.current[le] = ie;
  }, []), ue = (le, ie) => {
    ne(le, ie);
  }, ae = (le, ie, Q) => {
    le.key === "Enter" && (le.preventDefault(), ne(ie, Q)), le.key === " " && !B.current && (le.preventDefault(), ne(ie, Q));
  };
  return /* @__PURE__ */ E(
    uR.Provider,
    {
      value: {
        selectedIndex: _,
        setSelectedIndex: O,
        activeIndex: S,
        setActiveIndex: A,
        selected: p,
        setSelected: m,
        handleSelect: ne,
        combobox: l,
        sizeValue: t,
        multiple: s,
        onChange: i,
        isTypingRef: B,
        getItemProps: Y,
        onClickItem: ue,
        onKeyDownItem: ae,
        getValues: y,
        selectId: f,
        getReferenceProps: V,
        isOpen: x,
        value: n,
        updateListRef: re,
        refs: C,
        listContentRef: $,
        by: o,
        getFloatingProps: U,
        floatingStyles: k,
        context: D,
        searchKeyword: g,
        setSearchKeyword: v,
        disabled: c,
        isControlled: d
      },
      children: a
    }
  );
};
hR.displayName = "Select.Portal";
fR.displayName = "Select.Button";
dR.displayName = "Select.Options";
pR.displayName = "Select.Option";
_g.Portal = hR;
_g.Button = fR;
_g.Options = dR;
_g.Option = pR;
let DX = 1;
var br, Fi;
class IX {
  constructor() {
    Bv(this, br);
    Bv(this, Fi);
    as(this, br, []), as(this, Fi, []);
  }
  // Subscriber pattern.
  subscribe(t) {
    return $r(this, Fi).push(t), () => {
      as(this, Fi, $r(this, Fi).filter(
        (n) => n !== t
      ));
    };
  }
  // Publish a new toast.
  publish(t) {
    $r(this, Fi).forEach((n) => n(t));
  }
  // Add a new toast.
  add(t) {
    $r(this, br).push(t), this.publish(t);
  }
  // Remove a toast.
  remove(t) {
    return as(this, br, $r(this, br).filter((n) => n.id !== t)), t;
  }
  // Create a new toast.
  create(t) {
    const {
      id: n = void 0,
      message: r = "",
      jsx: i = void 0,
      ...o
    } = t;
    if (!r && typeof i != "function")
      return;
    const a = typeof n == "number" ? n : DX++;
    return $r(this, br).find((l) => l.id === a) && as(this, br, $r(this, br).map((l) => l.id === a ? (this.publish({
      ...l,
      title: r,
      jsx: i,
      ...o
    }), { ...l, title: r, jsx: i, ...o }) : l)), this.add({ id: a, title: r, jsx: i, ...o }), a;
  }
  // Update a toast.
  update(t, n) {
    const { render: r = void 0 } = n;
    let i = n;
    switch (typeof r) {
      case "function":
        i = {
          jsx: r,
          ...n
        };
        break;
      case "string":
        i = {
          title: r,
          ...n
        };
        break;
    }
    as(this, br, $r(this, br).map((o) => o.id === t ? (this.publish({ ...o, ...i }), { ...o, ...i }) : o));
  }
  // Dismiss toast.
  dismiss(t) {
    return t || $r(this, br).forEach(
      (n) => $r(this, Fi).forEach(
        (r) => r({ id: n.id, dismiss: !0 })
      )
    ), $r(this, Fi).forEach(
      (n) => n({ id: t, dismiss: !0 })
    ), t;
  }
  // History of toasts.
  history() {
    return $r(this, br);
  }
  // Types of toasts.
  // Default toast.
  default(t = "", n = {}) {
    return this.create({ message: t, type: "neutral", ...n });
  }
  // Success toast.
  success(t = "", n = {}) {
    return this.create({ message: t, type: "success", ...n });
  }
  // Error toast.
  error(t = "", n = {}) {
    return this.create({ message: t, type: "error", ...n });
  }
  // Warning toast.
  warning(t = "", n = {}) {
    return this.create({ message: t, type: "warning", ...n });
  }
  // Info toast
  info(t = "", n = {}) {
    return this.create({ message: t, type: "info", ...n });
  }
  // Custom toast.
  custom(t, n = {}) {
    return this.create({
      jsx: t,
      type: "custom",
      ...n
    });
  }
}
br = new WeakMap(), Fi = new WeakMap();
const Cn = new IX(), RX = (e, t) => Cn.default(e, t), EEe = Object.seal(
  Object.assign(
    RX,
    {
      success: Cn.success.bind(Cn),
      error: Cn.error.bind(Cn),
      warning: Cn.warning.bind(Cn),
      info: Cn.info.bind(Cn),
      custom: Cn.custom.bind(Cn),
      dismiss: Cn.dismiss.bind(Cn),
      update: Cn.update.bind(Cn)
    },
    {
      getHistory: Cn.history.bind(Cn)
    }
  )
);
let aC = !1;
const jX = (e) => H8((n) => {
  const r = n.singleTon;
  return aC && r ? null : (aC = !0, /* @__PURE__ */ E(e, { ...n }));
}), sC = {
  "top-left": "top-0 bottom-0 left-0 justify-start items-start",
  "top-right": "top-0 bottom-0 right-0 justify-start items-end",
  "bottom-left": "top-0 bottom-0 left-0 justify-end items-start",
  "bottom-right": "top-0 bottom-0 right-0 justify-end items-end"
}, lC = {
  stack: "w-[22.5rem]",
  inline: "lg:w-[47.5rem] w-full"
}, Nh = {
  light: {
    neutral: "border-alert-border-neutral bg-alert-background-neutral",
    custom: "border-alert-border-neutral bg-alert-background-neutral",
    info: "border-alert-border-info bg-alert-background-info",
    success: "border-alert-border-green bg-alert-background-green",
    warning: "border-alert-border-warning bg-alert-background-warning",
    error: "border-alert-border-danger bg-alert-background-danger"
  },
  dark: "bg-background-inverse border-background-inverse"
}, $h = {
  light: "text-icon-secondary",
  dark: "text-icon-inverse"
}, LX = ({
  position: e = "top-right",
  // top-right/top-left/bottom-right/bottom-left
  design: t = "stack",
  // stack/inline
  theme: n = "light",
  // light/dark
  className: r = "",
  autoDismiss: i = !0,
  // Auto dismiss the toast after a certain time.
  dismissAfter: o = 5e3
  // Time in milliseconds after which the toast will be dismissed.
}) => {
  const [a, s] = Me([]);
  Qe(() => {
    Cn.subscribe((c) => {
      if (c != null && c.dismiss) {
        s(
          (f) => f.map(
            (d) => d.id === c.id ? { ...d, dismiss: !0 } : d
          )
        );
        return;
      }
      setTimeout(() => {
        j$(
          () => s((f) => f.findIndex(
            (p) => p.id === c.id
          ) !== -1 ? f.map((p) => p.id === c.id ? { ...p, ...c } : p) : [...f, c])
        );
      });
    });
  }, []);
  const l = (c) => {
    s((f) => f.filter((d) => d.id !== c));
  };
  return /* @__PURE__ */ E(
    "ul",
    {
      className: H(
        "fixed flex flex-col list-none z-20 p-10 pointer-events-none [&>li]:pointer-events-auto gap-3",
        sC[e] ?? sC["top-right"],
        r
      ),
      children: /* @__PURE__ */ E(Hs, { initial: !1, children: a.map((c) => /* @__PURE__ */ E(
        ui.li,
        {
          initial: { opacity: 0, y: 50, scale: 0.7 },
          animate: { opacity: 1, y: 0, scale: 1 },
          exit: {
            opacity: 0,
            scale: 0.6,
            transition: { duration: 0.15 }
          },
          layoutId: `toast-${c.id}`,
          children: /* @__PURE__ */ E(
            BX,
            {
              toastItem: c,
              title: c.title,
              content: c == null ? void 0 : c.description,
              icon: (c == null ? void 0 : c.icon) ?? void 0,
              design: (c == null ? void 0 : c.design) ?? t,
              autoDismiss: (c == null ? void 0 : c.autoDismiss) ?? i,
              dismissAfter: (c == null ? void 0 : c.dismissAfter) ?? o,
              removeToast: l,
              variant: c.type,
              theme: (c == null ? void 0 : c.theme) ?? n
            }
          )
        },
        c.id
      )) })
    }
  );
}, BX = ({
  toastItem: e,
  title: t = "",
  content: n = "",
  autoDismiss: r = !0,
  dismissAfter: i = 5e3,
  theme: o = "light",
  // light/dark
  design: a = "stack",
  // inline/stack
  icon: s,
  variant: l = "neutral",
  // neutral/info/success/warning/danger
  removeToast: c
  // Function to remove the toast.
}) => {
  var w, S, A, _, O, T, C;
  const f = ft(0), d = ft(0), p = ft(), m = (k, D = i) => {
    if (!(!r || i < 0))
      return f.current = (/* @__PURE__ */ new Date()).getTime(), setTimeout(() => {
        typeof c == "function" && c(k.id);
      }, D);
  }, g = () => {
    clearTimeout(p.current), d.current = (/* @__PURE__ */ new Date()).getTime();
  }, v = () => {
    p.current = m(
      e,
      i - (d.current - f.current)
    );
  };
  Qe(() => {
    const k = i;
    return p.current = m(e, k), () => {
      clearTimeout(p.current);
    };
  }, []), Qe(() => {
    !(e != null && e.dismiss) || typeof c != "function" || c(e.id);
  }, [e]);
  const y = () => {
    var k, D;
    typeof c == "function" && ((D = (k = e == null ? void 0 : e.action) == null ? void 0 : k.onClick) == null || D.call(k, () => c(e.id)));
  };
  let x = null;
  return a === "stack" && (x = /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex items-center justify-start p-4 gap-2 relative border border-solid rounded-md shadow-lg",
        o === "dark" ? Nh.dark : (w = Nh.light) == null ? void 0 : w[l],
        lC.stack
      ),
      onMouseEnter: g,
      onMouseLeave: v,
      children: e.type !== "custom" ? /* @__PURE__ */ me(Ut, { children: [
        /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: vp({ variant: l, icon: s, theme: o }) }),
        /* @__PURE__ */ me("div", { className: "flex flex-col items-start justify-start gap-0.5 mr-6", children: [
          bp({ title: t, theme: o }),
          xp({ content: n, theme: o }),
          ((S = e == null ? void 0 : e.action) == null ? void 0 : S.label) && typeof ((A = e == null ? void 0 : e.action) == null ? void 0 : A.onClick) == "function" && /* eslint-disable */
          /* @__PURE__ */ E("div", { className: "mt-2.5", children: g0({
            actionLabel: (_ = e == null ? void 0 : e.action) == null ? void 0 : _.label,
            actionType: ((O = e == null ? void 0 : e.action) == null ? void 0 : O.type) ?? "button",
            onAction: y,
            theme: o
          }) })
        ] }),
        /* @__PURE__ */ E("div", { className: "absolute right-4 top-4 [&_svg]:size-5", children: /* @__PURE__ */ E(
          "button",
          {
            className: H(
              "bg-transparent m-0 p-0 border-none focus:outline-none active:outline-none cursor-pointer",
              $h[o] ?? $h.light
            ),
            onClick: () => {
              typeof c == "function" && c(e.id);
            },
            children: /* @__PURE__ */ E(Na, {})
          }
        ) })
      ] }) : (T = e == null ? void 0 : e.jsx) == null ? void 0 : T.call(e, {
        close: () => c(e.id),
        action: e != null && e.action ? { ...e == null ? void 0 : e.action, onClick: y } : null
      })
    }
  )), a === "inline" && (x = /* @__PURE__ */ me(
    "div",
    {
      className: H(
        "flex items-center justify-start p-3 gap-2 relative border border-solid rounded-md shadow-lg",
        o === "dark" ? Nh.dark : (C = Nh.light) == null ? void 0 : C[l],
        lC.inline
      ),
      children: [
        /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: vp({ variant: l, icon: s, theme: o }) }),
        /* @__PURE__ */ me("div", { className: "flex items-start justify-start gap-1 mr-10 [&>span:first-child]:shrink-0", children: [
          bp({ title: t, theme: o }),
          xp({ content: n, theme: o })
        ] }),
        /* @__PURE__ */ E("div", { className: "absolute right-3 top-3 [&_svg]:size-5", children: /* @__PURE__ */ E(
          "button",
          {
            className: H(
              "bg-transparent m-0 p-0 border-none focus:outline-none active:outline-none cursor-pointer",
              $h[o] ?? $h.light
            ),
            onClick: () => c(e.id),
            children: /* @__PURE__ */ E(Na, {})
          }
        ) })
      ]
    }
  )), x;
}, kEe = jX(LX), FX = {
  sm: {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6",
    7: "grid-cols-7",
    8: "grid-cols-8",
    9: "grid-cols-9",
    10: "grid-cols-10",
    11: "grid-cols-11",
    12: "grid-cols-12"
  },
  md: {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6",
    7: "md:grid-cols-7",
    8: "md:grid-cols-8",
    9: "md:grid-cols-9",
    10: "md:grid-cols-10",
    11: "md:grid-cols-11",
    12: "md:grid-cols-12"
  },
  lg: {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6",
    7: "lg:grid-cols-7",
    8: "lg:grid-cols-8",
    9: "lg:grid-cols-9",
    10: "lg:grid-cols-10",
    11: "lg:grid-cols-11",
    12: "lg:grid-cols-12"
  }
}, mR = {
  sm: {
    xs: "gap-2",
    sm: "gap-4",
    md: "gap-5",
    lg: "gap-6",
    xl: "gap-6",
    "2xl": "gap-8"
  },
  md: {
    xs: "md:gap-2",
    sm: "md:gap-4",
    md: "md:gap-5",
    lg: "md:gap-6",
    xl: "md:gap-6",
    "2xl": "md:gap-8"
  },
  lg: {
    xs: "lg:gap-2",
    sm: "lg:gap-4",
    md: "lg:gap-5",
    lg: "lg:gap-6",
    xl: "lg:gap-6",
    "2xl": "lg:gap-8"
  }
}, gR = {
  sm: {
    xs: "gap-x-2",
    sm: "gap-x-4",
    md: "gap-x-5",
    lg: "gap-x-6",
    xl: "gap-x-6",
    "2xl": "gap-x-8"
  },
  md: {
    xs: "md:gap-x-2",
    sm: "md:gap-x-4",
    md: "md:gap-x-5",
    lg: "md:gap-x-6",
    xl: "md:gap-x-6",
    "2xl": "md:gap-x-8"
  },
  lg: {
    xs: "lg:gap-x-2",
    sm: "lg:gap-x-4",
    md: "lg:gap-x-5",
    lg: "lg:gap-x-6",
    xl: "lg:gap-x-6",
    "2xl": "lg:gap-x-8"
  }
}, yR = {
  sm: {
    xs: "gap-y-2",
    sm: "gap-y-4",
    md: "gap-y-5",
    lg: "gap-y-6",
    xl: "gap-y-6",
    "2xl": "gap-y-8"
  },
  md: {
    xs: "md:gap-y-2",
    sm: "md:gap-y-4",
    md: "md:gap-y-5",
    lg: "md:gap-y-6",
    xl: "md:gap-y-6",
    "2xl": "md:gap-y-8"
  },
  lg: {
    xs: "lg:gap-y-2",
    sm: "lg:gap-y-4",
    md: "lg:gap-y-5",
    lg: "lg:gap-y-6",
    xl: "lg:gap-y-6",
    "2xl": "lg:gap-y-8"
  }
}, WX = {
  sm: {
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
    4: "col-span-4",
    5: "col-span-5",
    6: "col-span-6",
    7: "col-span-7",
    8: "col-span-8",
    9: "col-span-9",
    10: "col-span-10",
    11: "col-span-11",
    12: "col-span-12"
  },
  md: {
    1: "md:col-span-1",
    2: "md:col-span-2",
    3: "md:col-span-3",
    4: "md:col-span-4",
    5: "md:col-span-5",
    6: "md:col-span-6",
    7: "md:col-span-7",
    8: "md:col-span-8",
    9: "md:col-span-9",
    10: "md:col-span-10",
    11: "md:col-span-11",
    12: "md:col-span-12"
  },
  lg: {
    1: "lg:col-span-1",
    2: "lg:col-span-2",
    3: "lg:col-span-3",
    4: "lg:col-span-4",
    5: "lg:col-span-5",
    6: "lg:col-span-6",
    7: "lg:col-span-7",
    8: "lg:col-span-8",
    9: "lg:col-span-9",
    10: "lg:col-span-10",
    11: "lg:col-span-11",
    12: "lg:col-span-12"
  }
}, zX = {
  sm: {
    1: "col-start-1",
    2: "col-start-2",
    3: "col-start-3",
    4: "col-start-4",
    5: "col-start-5",
    6: "col-start-6",
    7: "col-start-7",
    8: "col-start-8",
    9: "col-start-9",
    10: "col-start-10",
    11: "col-start-11",
    12: "col-start-12"
  },
  md: {
    1: "md:col-start-1",
    2: "md:col-start-2",
    3: "md:col-start-3",
    4: "md:col-start-4",
    5: "md:col-start-5",
    6: "md:col-start-6",
    7: "md:col-start-7",
    8: "md:col-start-8",
    9: "md:col-start-9",
    10: "md:col-start-10",
    11: "md:col-start-11",
    12: "md:col-start-12"
  },
  lg: {
    1: "lg:col-start-1",
    2: "lg:col-start-2",
    3: "lg:col-start-3",
    4: "lg:col-start-4",
    5: "lg:col-start-5",
    6: "lg:col-start-6",
    7: "lg:col-start-7",
    8: "lg:col-start-8",
    9: "lg:col-start-9",
    10: "lg:col-start-10",
    11: "lg:col-start-11",
    12: "lg:col-start-12"
  }
}, VX = {
  sm: {
    row: "grid-flow-row",
    column: "grid-flow-col",
    "row-dense": "grid-flow-row-dense",
    "column-dense": "grid-flow-col-dense"
  },
  md: {
    row: "md:grid-flow-row",
    column: "md:grid-flow-col",
    "row-dense": "md:grid-flow-row-dense",
    "column-dense": "md:grid-flow-col-dense"
  },
  lg: {
    row: "lg:grid-flow-row",
    column: "lg:grid-flow-col",
    "row-dense": "lg:grid-flow-row-dense",
    "column-dense": "lg:grid-flow-col-dense"
  }
}, vR = {
  sm: {
    normal: "justify-normal",
    start: "justify-start",
    end: "justify-end",
    center: "justify-center",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly",
    stretch: "justify-stretch"
  },
  md: {
    normal: "md:justify-normal",
    start: "md:justify-start",
    end: "md:justify-end",
    center: "md:justify-center",
    between: "md:justify-between",
    around: "md:justify-around",
    evenly: "md:justify-evenly",
    stretch: "md:justify-stretch"
  },
  lg: {
    normal: "lg:justify-normal",
    start: "lg:justify-start",
    end: "lg:justify-end",
    center: "lg:justify-center",
    between: "lg:justify-between",
    around: "lg:justify-around",
    evenly: "lg:justify-evenly",
    stretch: "lg:justify-stretch"
  }
}, bR = {
  sm: {
    start: "items-start",
    end: "items-end",
    center: "items-center",
    baseline: "items-baseline",
    stretch: "items-stretch"
  },
  md: {
    start: "md:items-start",
    end: "md:items-end",
    center: "md:items-center",
    baseline: "md:items-baseline",
    stretch: "md:items-stretch"
  },
  lg: {
    start: "lg:items-start",
    end: "lg:items-end",
    center: "lg:items-center",
    baseline: "lg:items-baseline",
    stretch: "lg:items-stretch"
  }
}, xR = {
  sm: {
    start: "self-start",
    end: "self-end",
    center: "self-center",
    baseline: "self-baseline",
    stretch: "self-stretch"
  },
  md: {
    start: "md:self-start",
    end: "md:self-end",
    center: "md:self-center",
    baseline: "md:self-baseline",
    stretch: "md:self-stretch"
  },
  lg: {
    start: "lg:self-start",
    end: "lg:self-end",
    center: "lg:self-center",
    baseline: "lg:self-baseline",
    stretch: "lg:self-stretch"
  }
}, wR = {
  sm: {
    auto: "justify-self-auto",
    start: "justify-self-start",
    end: "justify-self-end",
    center: "justify-self-center",
    baseline: "justify-self-baseline",
    stretch: "justify-self-stretch"
  },
  md: {
    auto: "md:justify-self-auto",
    start: "md:justify-self-start",
    end: "md:justify-self-end",
    center: "md:justify-self-center",
    baseline: "md:justify-self-baseline",
    stretch: "md:justify-self-stretch"
  },
  lg: {
    auto: "lg:justify-self-auto",
    start: "lg:justify-self-start",
    end: "lg:justify-self-end",
    center: "lg:justify-self-center",
    baseline: "lg:justify-self-baseline",
    stretch: "lg:justify-self-stretch"
  }
}, UX = {
  sm: {
    row: "flex-row",
    "row-reverse": "flex-row-reverse",
    column: "flex-col",
    "column-reverse": "flex-col-reverse"
  },
  md: {
    row: "md:flex-row",
    "row-reverse": "md:flex-row-reverse",
    column: "md:flex-col",
    "column-reverse": "md:flex-col-reverse"
  },
  lg: {
    row: "lg:flex-row",
    "row-reverse": "lg:flex-row-reverse",
    column: "lg:flex-col",
    "column-reverse": "lg:flex-col-reverse"
  }
}, KX = {
  sm: {
    wrap: "flex-wrap",
    "wrap-reverse": "flex-wrap-reverse",
    nowrap: "flex-nowrap"
  },
  md: {
    wrap: "md:flex-wrap",
    "wrap-reverse": "md:flex-wrap-reverse",
    nowrap: "md:flex-nowrap"
  },
  lg: {
    wrap: "lg:flex-wrap",
    "wrap-reverse": "lg:flex-wrap-reverse",
    nowrap: "lg:flex-nowrap"
  }
}, HX = {
  sm: {
    1: "w-full",
    2: "w-1/2",
    3: "w-1/3",
    4: "w-1/4",
    5: "w-1/5",
    6: "w-1/6",
    7: "w-1/7",
    8: "w-1/8",
    9: "w-1/9",
    10: "w-1/10",
    11: "w-1/11",
    12: "w-1/12"
  },
  md: {
    1: "md:w-full",
    2: "md:w-1/2",
    3: "md:w-1/3",
    4: "md:w-1/4",
    5: "md:w-1/5",
    6: "md:w-1/6",
    7: "md:w-1/7",
    8: "md:w-1/8",
    9: "md:w-1/9",
    10: "md:w-1/10",
    11: "md:w-1/11",
    12: "md:w-1/12"
  },
  lg: {
    1: "lg:w-full",
    2: "lg:w-1/2",
    3: "lg:w-1/3",
    4: "lg:w-1/4",
    5: "lg:w-1/5",
    6: "lg:w-1/6",
    7: "lg:w-1/7",
    8: "lg:w-1/8",
    9: "lg:w-1/9",
    10: "lg:w-1/10",
    11: "lg:w-1/11",
    12: "lg:w-1/12"
  }
}, GX = {
  sm: {
    1: "order-1",
    2: "order-2",
    3: "order-3",
    4: "order-4",
    5: "order-5",
    6: "order-6",
    7: "order-7",
    8: "order-8",
    9: "order-9",
    10: "order-10",
    11: "order-11",
    12: "order-12",
    first: "order-first",
    last: "order-last",
    none: "order-none"
  },
  md: {
    1: "md:order-1",
    2: "md:order-2",
    3: "md:order-3",
    4: "md:order-4",
    5: "md:order-5",
    6: "md:order-6",
    7: "md:order-7",
    8: "md:order-8",
    9: "md:order-9",
    10: "md:order-10",
    11: "md:order-11",
    12: "md:order-12",
    first: "md:order-first",
    last: "md:order-last",
    none: "md:order-none"
  },
  lg: {
    1: "lg:order-1",
    2: "lg:order-2",
    3: "lg:order-3",
    4: "lg:order-4",
    5: "lg:order-5",
    6: "lg:order-6",
    7: "lg:order-7",
    8: "lg:order-8",
    9: "lg:order-9",
    10: "lg:order-10",
    11: "lg:order-11",
    12: "lg:order-12",
    first: "lg:order-first",
    last: "lg:order-last",
    none: "lg:order-none"
  }
}, YX = {
  sm: {
    0: "grow-0",
    1: "grow"
  },
  md: {
    0: "md:grow-0",
    1: "md:grow"
  },
  lg: {
    0: "lg:grow-0",
    1: "lg:grow"
  }
}, qX = {
  sm: {
    0: "shrink-0",
    1: "shrink"
  },
  md: {
    0: "md:shrink-0",
    1: "md:shrink"
  },
  lg: {
    0: "lg:shrink-0",
    1: "lg:shrink"
  }
}, Yt = (e, t, n, r = "sm") => {
  var o, a, s, l, c;
  const i = [];
  switch (typeof e) {
    case "object":
      for (const [d, p] of Object.entries(e))
        t[d] && i.push(
          ((o = t == null ? void 0 : t[d]) == null ? void 0 : o[p]) ?? ((a = t == null ? void 0 : t[d]) == null ? void 0 : a[n == null ? void 0 : n[d]]) ?? ""
        );
      break;
    case "string":
    case "number":
      const f = r;
      i.push(
        ((s = t == null ? void 0 : t[f]) == null ? void 0 : s[e]) ?? ((l = t == null ? void 0 : t[f]) == null ? void 0 : l[n == null ? void 0 : n[f]]) ?? ""
      );
      break;
    default:
      if (e === void 0)
        break;
      i.push(
        ((c = t == null ? void 0 : t[r]) == null ? void 0 : c[n]) ?? ""
      );
      break;
  }
  return i.join(" ");
}, Cp = ({
  className: e,
  cols: t,
  gap: n,
  gapX: r,
  gapY: i,
  align: o,
  justify: a,
  gridFlow: s,
  colsSubGrid: l = !1,
  rowsSubGrid: c = !1,
  autoRows: f = !1,
  autoCols: d = !1,
  children: p,
  ...m
}) => {
  const g = Yt(t, FX, 1), v = Yt(n, mR, "sm"), y = Yt(r, gR, ""), x = Yt(i, yR, ""), w = Yt(o, bR, ""), S = Yt(a, vR, ""), A = Yt(s, VX, "");
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "grid",
        {
          "grid-cols-subgrid": l,
          "grid-rows-subgrid": c,
          "auto-cols-auto": d,
          "auto-rows-auto": f
        },
        g,
        v,
        y,
        x,
        w,
        S,
        A,
        e
      ),
      ...m,
      children: p
    }
  );
}, XX = ({
  className: e,
  children: t,
  colSpan: n,
  colStart: r,
  alignSelf: i,
  justifySelf: o,
  ...a
}) => {
  const s = Yt(n, WX, 0), l = Yt(
    r,
    zX,
    0
  ), c = Yt(
    i,
    xR,
    ""
  ), f = Yt(
    o,
    wR,
    ""
  );
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        s,
        l,
        c,
        f,
        e
      ),
      ...a,
      children: t
    }
  );
};
Cp.Item = XX;
const D0 = ht({}), ZX = () => Ve(D0), _R = ({
  containerType: e = "flex",
  // flex, (grid - functionality not implemented)
  gap: t = "sm",
  // xs, sm, md, lg, xl, 2xl
  gapX: n,
  gapY: r,
  direction: i,
  // row, row-reverse, column, column reverse
  justify: o,
  // justify-content (normal, start, end, center, between, around, evenly, stretch)
  align: a,
  // align-items (start, end, center, baseline, stretch)
  wrap: s,
  // nowrap, wrap, wrap-reverse
  cols: l,
  className: c,
  children: f,
  ...d
}) => {
  if (e === "grid")
    return /* @__PURE__ */ E(
      D0.Provider,
      {
        value: {
          containerType: e
        },
        children: /* @__PURE__ */ E(
          Cp,
          {
            className: c,
            gap: t,
            gapX: n,
            gapY: r,
            cols: l,
            children: f,
            align: a,
            justify: o,
            ...d
          }
        )
      }
    );
  const p = Yt(s, KX, ""), m = Yt(t, mR, "sm"), g = Yt(n, gR, ""), v = Yt(r, yR, ""), y = Yt(
    i,
    UX,
    ""
  ), x = Yt(
    o,
    vR,
    ""
  ), w = Yt(a, bR, ""), S = H(
    "flex",
    p,
    m,
    g,
    v,
    y,
    x,
    w,
    c
  ), A = () => e === "flex" ? /* @__PURE__ */ E("div", { className: S, children: f }) : /* @__PURE__ */ E(
    Cp,
    {
      className: c,
      gap: t,
      gapX: n,
      gapY: r,
      cols: l,
      children: f,
      align: a,
      justify: o,
      ...d
    }
  );
  return /* @__PURE__ */ E(
    D0.Provider,
    {
      value: {
        containerType: e,
        cols: l
      },
      children: A()
    }
  );
}, SR = ({
  grow: e,
  shrink: t,
  order: n,
  alignSelf: r,
  justifySelf: i,
  className: o,
  children: a,
  ...s
}) => {
  const { containerType: l, cols: c } = ZX();
  if (l === "grid")
    return /* @__PURE__ */ E(
      Cp.Item,
      {
        className: o,
        alignSelf: r,
        justifySelf: i,
        children: a,
        ...s
      }
    );
  const f = Yt(
    r,
    xR,
    ""
  ), d = Yt(
    i,
    wR,
    ""
  ), p = Yt(e, YX, 0), m = Yt(t, qX, 0), g = Yt(n, GX, 0), v = Yt(c, HX, 1);
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "box-border",
        p,
        m,
        g,
        f,
        d,
        v,
        o
      ),
      children: a
    }
  );
};
_R.Item = SR;
_R.displayName = "Container";
SR.displayName = "Container.Item";
const MEe = ({
  design: e = "inline",
  // stack/inline
  theme: t = "light",
  // light/dark
  variant: n = "neutral",
  className: r = "",
  title: i = "",
  content: o = "",
  icon: a = null,
  onClose: s,
  action: l = {
    label: "",
    onClick: () => {
    },
    type: "link"
  }
}) => {
  var m, g;
  const c = () => {
    typeof s == "function" && s();
  }, f = {
    light: {
      neutral: "ring-alert-border-neutral bg-alert-background-neutral",
      custom: "ring-alert-border-neutral bg-alert-background-neutral",
      info: "ring-alert-border-info bg-alert-background-info",
      success: "ring-alert-border-green bg-alert-background-green",
      warning: "ring-alert-border-warning bg-alert-background-warning",
      error: "ring-alert-border-danger bg-alert-background-danger"
    },
    dark: "bg-background-inverse ring-background-inverse"
  }, d = {
    light: "text-icon-secondary",
    dark: "text-icon-inverse"
  }, p = () => {
    var v;
    (v = l == null ? void 0 : l.onClick) == null || v.call(l, c);
  };
  return e === "stack" ? /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex items-center justify-start p-4 gap-2 relative ring-1 rounded-md shadow-lg",
        t === "dark" ? f.dark : (m = f.light) == null ? void 0 : m[n],
        r
      ),
      children: /* @__PURE__ */ me(Ut, { children: [
        /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: vp({ variant: n, icon: a, theme: t }) }),
        /* @__PURE__ */ me("div", { className: "flex flex-col items-start justify-start gap-0.5 mr-7", children: [
          bp({ title: i, theme: t }),
          xp({ content: o, theme: t }),
          (l == null ? void 0 : l.label) && typeof (l == null ? void 0 : l.onClick) == "function" && /* @__PURE__ */ E("div", { className: "mt-2.5", children: g0({
            actionLabel: l == null ? void 0 : l.label,
            actionType: (l == null ? void 0 : l.type) ?? "button",
            onAction: p,
            theme: t
          }) })
        ] }),
        /* @__PURE__ */ E("div", { className: "absolute right-4 top-4 [&_svg]:size-5", children: /* @__PURE__ */ E(
          "button",
          {
            className: H(
              "bg-transparent m-0 p-0 border-none focus:outline-none active:outline-none cursor-pointer",
              d[t] ?? d.light
            ),
            onClick: () => c(),
            "aria-label": "Close alert",
            children: /* @__PURE__ */ E(Na, {})
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ me(
    "div",
    {
      className: H(
        "flex items-center justify-between p-3 gap-2 relative ring-1 rounded-lg shadow-lg",
        t === "dark" ? f.dark : (g = f.light) == null ? void 0 : g[n],
        r
      ),
      children: [
        /* @__PURE__ */ me("div", { className: "flex items-center justify-start gap-2", children: [
          /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: vp({ variant: n, icon: a, theme: t }) }),
          /* @__PURE__ */ me("p", { className: "content-start space-x-1 my-0 mr-10 px-1", children: [
            bp({ title: i, theme: t, inline: !0 }),
            xp({ content: o, theme: t, inline: !0 })
          ] })
        ] }),
        /* @__PURE__ */ me("div", { className: "flex h-full justify-start gap-4 [&_svg]:size-4", children: [
          (l == null ? void 0 : l.label) && typeof (l == null ? void 0 : l.onClick) == "function" && /* @__PURE__ */ E("div", { className: "self-center flex h-5", children: g0({
            actionLabel: l == null ? void 0 : l.label,
            actionType: (l == null ? void 0 : l.type) ?? "button",
            onAction: p,
            theme: t
          }) }),
          typeof s == "function" && /* @__PURE__ */ E(
            "button",
            {
              className: H(
                "self-start bg-transparent m-0 border-none p-0.5 focus:outline-none active:outline-none cursor-pointer size-5",
                d[t] ?? d.light
              ),
              onClick: () => c(),
              "aria-label": "Close alert",
              children: /* @__PURE__ */ E(Na, {})
            }
          )
        ] })
      ]
    }
  );
};
function JX(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var QX = JX(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const OR = ht(null);
function eZ(e, t) {
  return { getTheme: function() {
    return t ?? null;
  } };
}
function Kr() {
  const e = Ve(OR);
  return e == null && QX(8), e;
}
function tZ({ defaultSelection: e }) {
  const [t] = Kr();
  return Qe(() => {
    t.focus(() => {
      const n = document.activeElement, r = t.getRootElement();
      r === null || n !== null && r.contains(n) || r.focus({ preventScroll: !0 });
    }, { defaultSelection: e });
  }, [e, t]), null;
}
function nZ(e) {
  return {};
}
const U1 = {}, rZ = {}, Es = {}, zl = {}, I0 = {}, Vl = {}, K1 = {}, R0 = {}, yf = {}, vf = {}, ws = {}, H1 = {}, G1 = {}, AR = {}, Y1 = {}, iZ = {}, q1 = {}, oZ = {}, PR = {}, TR = {}, bf = {}, aZ = {}, X1 = {}, CR = {}, ER = {}, kR = {}, MR = {}, NR = {}, sZ = {}, lZ = {}, Z1 = {}, J1 = {}, j0 = {}, cZ = {}, uZ = {}, Dh = {}, Ih = {}, fZ = {}, dZ = {}, hZ = {}, Di = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, pZ = Di && "documentMode" in document ? document.documentMode : null, xi = Di && /Mac|iPod|iPhone|iPad/.test(navigator.platform), Ea = Di && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Ep = !(!Di || !("InputEvent" in window) || pZ) && "getTargetRanges" in new window.InputEvent("input"), Q1 = Di && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), Sg = Di && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, mZ = Di && /Android/.test(navigator.userAgent), $R = Di && /^(?=.*Chrome).*/i.test(navigator.userAgent), gZ = Di && mZ && $R, e_ = Di && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !$R, hd = 1, Ua = 3, js = 0, DR = 1, Ql = 2, yZ = 0, vZ = 1, bZ = 2, kp = 4, Mp = 8, t_ = 128, xZ = 112 | (3 | kp | Mp) | t_, n_ = 1, r_ = 2, i_ = 3, o_ = 4, a_ = 5, s_ = 6, Og = Q1 || Sg || e_ ? " " : "​", Fo = `

`, wZ = Ea ? " " : Og, IR = "֑-߿יִ-﷽ﹰ-ﻼ", RR = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", _Z = new RegExp("^[^" + RR + "]*[" + IR + "]"), SZ = new RegExp("^[^" + IR + "]*[" + RR + "]"), $o = { bold: 1, code: 16, highlight: t_, italic: 2, strikethrough: kp, subscript: 32, superscript: 64, underline: Mp }, OZ = { directionless: 1, unmergeable: 2 }, cC = { center: r_, end: s_, justify: o_, left: n_, right: i_, start: a_ }, AZ = { [r_]: "center", [s_]: "end", [o_]: "justify", [n_]: "left", [i_]: "right", [a_]: "start" }, PZ = { normal: 0, segmented: 2, token: 1 }, TZ = { [yZ]: "normal", [bZ]: "segmented", [vZ]: "token" };
function CZ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _e = CZ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function Np(...e) {
  const t = [];
  for (const n of e) if (n && typeof n == "string") for (const [r] of n.matchAll(/\S+/g)) t.push(r);
  return t;
}
const EZ = 100;
let L0 = !1, l_ = 0;
function kZ(e) {
  l_ = e.timeStamp;
}
function ub(e, t, n) {
  return t.__lexicalLineBreak === e || e[`__lexicalKey_${n._key}`] !== void 0;
}
function MZ(e, t, n) {
  const r = eo(n._window);
  let i = null, o = null;
  r !== null && r.anchorNode === e && (i = r.anchorOffset, o = r.focusOffset);
  const a = e.nodeValue;
  a !== null && d_(t, a, i, o, !1);
}
function NZ(e, t, n) {
  if (we(e)) {
    const r = e.anchor.getNode();
    if (r.is(n) && e.format !== r.getFormat()) return !1;
  }
  return t.nodeType === Ua && n.isAttached();
}
function jR(e, t, n) {
  L0 = !0;
  const r = performance.now() - l_ > EZ;
  try {
    Br(e, () => {
      const i = ke() || function(p) {
        return p.getEditorState().read(() => {
          const m = ke();
          return m !== null ? m.clone() : null;
        });
      }(e), o = /* @__PURE__ */ new Map(), a = e.getRootElement(), s = e._editorState, l = e._blockCursorElement;
      let c = !1, f = "";
      for (let p = 0; p < t.length; p++) {
        const m = t[p], g = m.type, v = m.target;
        let y = Tg(v, s);
        if (!(y === null && v !== a || Kt(y))) {
          if (g === "characterData") r && Se(y) && NZ(i, v, y) && MZ(v, y, e);
          else if (g === "childList") {
            c = !0;
            const x = m.addedNodes;
            for (let A = 0; A < x.length; A++) {
              const _ = x[A], O = zR(_), T = _.parentNode;
              if (T != null && _ !== l && O === null && (_.nodeName !== "BR" || !ub(_, T, e))) {
                if (Ea) {
                  const C = _.innerText || _.nodeValue;
                  C && (f += C);
                }
                T.removeChild(_);
              }
            }
            const w = m.removedNodes, S = w.length;
            if (S > 0) {
              let A = 0;
              for (let _ = 0; _ < S; _++) {
                const O = w[_];
                (O.nodeName === "BR" && ub(O, v, e) || l === O) && (v.appendChild(O), A++);
              }
              S !== A && (v === a && (y = UR(s)), o.set(v, y));
            }
          }
        }
      }
      if (o.size > 0) for (const [p, m] of o) if (ye(m)) {
        const g = m.getChildrenKeys();
        let v = p.firstChild;
        for (let y = 0; y < g.length; y++) {
          const x = g[y], w = e.getElementByKey(x);
          w !== null && (v == null ? (p.appendChild(w), v = w) : v !== w && p.replaceChild(w, v), v = v.nextSibling);
        }
      } else Se(m) && m.markDirty();
      const d = n.takeRecords();
      if (d.length > 0) {
        for (let p = 0; p < d.length; p++) {
          const m = d[p], g = m.addedNodes, v = m.target;
          for (let y = 0; y < g.length; y++) {
            const x = g[y], w = x.parentNode;
            w == null || x.nodeName !== "BR" || ub(x, v, e) || w.removeChild(x);
          }
        }
        n.takeRecords();
      }
      i !== null && (c && (i.dirty = !0, Wo(i)), Ea && YR(e) && i.insertRawText(f));
    });
  } finally {
    L0 = !1;
  }
}
function LR(e) {
  const t = e._observer;
  t !== null && jR(e, t.takeRecords(), t);
}
function BR(e) {
  (function(t) {
    l_ === 0 && kg(t).addEventListener("textInput", kZ, !0);
  })(e), e._observer = new MutationObserver((t, n) => {
    jR(e, t, n);
  });
}
function uC(e, t) {
  const n = e.__mode, r = e.__format, i = e.__style, o = t.__mode, a = t.__format, s = t.__style;
  return !(n !== null && n !== o || r !== null && r !== a || i !== null && i !== s);
}
function fC(e, t) {
  const n = e.mergeWithSibling(t), r = pn()._normalizedNodes;
  return r.add(e.__key), r.add(t.__key), n;
}
function dC(e) {
  let t, n, r = e;
  if (r.__text !== "" || !r.isSimpleText() || r.isUnmergeable()) {
    for (; (t = r.getPreviousSibling()) !== null && Se(t) && t.isSimpleText() && !t.isUnmergeable(); ) {
      if (t.__text !== "") {
        if (uC(t, r)) {
          r = fC(t, r);
          break;
        }
        break;
      }
      t.remove();
    }
    for (; (n = r.getNextSibling()) !== null && Se(n) && n.isSimpleText() && !n.isUnmergeable(); ) {
      if (n.__text !== "") {
        if (uC(r, n)) {
          r = fC(r, n);
          break;
        }
        break;
      }
      n.remove();
    }
  } else r.remove();
}
function $Z(e) {
  return hC(e.anchor), hC(e.focus), e;
}
function hC(e) {
  for (; e.type === "element"; ) {
    const t = e.getNode(), n = e.offset;
    let r, i;
    if (n === t.getChildrenSize() ? (r = t.getChildAtIndex(n - 1), i = !0) : (r = t.getChildAtIndex(n), i = !1), Se(r)) {
      e.set(r.__key, i ? r.getTextContentSize() : 0, "text");
      break;
    }
    if (!ye(r)) break;
    e.set(r.__key, i ? r.getChildrenSize() : 0, "element");
  }
}
let DZ = 1;
const IZ = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
};
function FR(e) {
  const t = document.activeElement;
  if (t === null) return !1;
  const n = t.nodeName;
  return Kt(Tg(e)) && (n === "INPUT" || n === "TEXTAREA" || t.contentEditable === "true" && Pg(t) == null);
}
function Ag(e, t, n) {
  const r = e.getRootElement();
  try {
    return r !== null && r.contains(t) && r.contains(n) && t !== null && !FR(t) && WR(t) === e;
  } catch {
    return !1;
  }
}
function c_(e) {
  return e instanceof Lg;
}
function WR(e) {
  let t = e;
  for (; t != null; ) {
    const n = Pg(t);
    if (c_(n)) return n;
    t = Eg(t);
  }
  return null;
}
function Pg(e) {
  return e ? e.__lexicalEditor : null;
}
function Al(e) {
  return e.isToken() || e.isSegmented();
}
function RZ(e) {
  return e.nodeType === Ua;
}
function $p(e) {
  let t = e;
  for (; t != null; ) {
    if (RZ(t)) return t;
    t = t.firstChild;
  }
  return null;
}
function B0(e, t, n) {
  const r = $o[t];
  if (n !== null && (e & r) == (n & r)) return e;
  let i = e ^ r;
  return t === "subscript" ? i &= ~$o.superscript : t === "superscript" && (i &= ~$o.subscript), i;
}
function jZ(e, t) {
  if (t != null) return void (e.__key = t);
  xr(), y2();
  const n = pn(), r = Go(), i = "" + DZ++;
  r._nodeMap.set(i, e), ye(e) ? n._dirtyElements.set(i, !0) : n._dirtyLeaves.add(i), n._cloneNotNeeded.add(i), n._dirtyType = DR, e.__key = i;
}
function ks(e) {
  const t = e.getParent();
  if (t !== null) {
    const n = e.getWritable(), r = t.getWritable(), i = e.getPreviousSibling(), o = e.getNextSibling();
    if (i === null) if (o !== null) {
      const a = o.getWritable();
      r.__first = o.__key, a.__prev = null;
    } else r.__first = null;
    else {
      const a = i.getWritable();
      if (o !== null) {
        const s = o.getWritable();
        s.__prev = a.__key, a.__next = s.__key;
      } else a.__next = null;
      n.__prev = null;
    }
    if (o === null) if (i !== null) {
      const a = i.getWritable();
      r.__last = i.__key, a.__next = null;
    } else r.__last = null;
    else {
      const a = o.getWritable();
      if (i !== null) {
        const s = i.getWritable();
        s.__next = a.__key, a.__prev = s.__key;
      } else a.__prev = null;
      n.__next = null;
    }
    r.__size--, n.__parent = null;
  }
}
function Dp(e) {
  y2();
  const t = e.getLatest(), n = t.__parent, r = Go(), i = pn(), o = r._nodeMap, a = i._dirtyElements;
  n !== null && function(l, c, f) {
    let d = l;
    for (; d !== null; ) {
      if (f.has(d)) return;
      const p = c.get(d);
      if (p === void 0) break;
      f.set(d, !1), d = p.__parent;
    }
  }(n, o, a);
  const s = t.__key;
  i._dirtyType = DR, ye(e) ? a.set(s, !0) : i._dirtyLeaves.add(s);
}
function Un(e) {
  xr();
  const t = pn(), n = t._compositionKey;
  if (e !== n) {
    if (t._compositionKey = e, n !== null) {
      const r = Mn(n);
      r !== null && r.getWritable();
    }
    if (e !== null) {
      const r = Mn(e);
      r !== null && r.getWritable();
    }
  }
}
function _a() {
  return yd() ? null : pn()._compositionKey;
}
function Mn(e, t) {
  const n = (t || Go())._nodeMap.get(e);
  return n === void 0 ? null : n;
}
function zR(e, t) {
  const n = e[`__lexicalKey_${pn()._key}`];
  return n !== void 0 ? Mn(n, t) : null;
}
function Tg(e, t) {
  let n = e;
  for (; n != null; ) {
    const r = zR(n, t);
    if (r !== null) return r;
    n = Eg(n);
  }
  return null;
}
function VR(e) {
  const t = e._decorators, n = Object.assign({}, t);
  return e._pendingDecorators = n, n;
}
function pC(e) {
  return e.read(() => rr().getTextContent());
}
function rr() {
  return UR(Go());
}
function UR(e) {
  return e._nodeMap.get("root");
}
function Wo(e) {
  xr();
  const t = Go();
  e !== null && (e.dirty = !0, e.setCachedNodes(null)), t._selection = e;
}
function Dl(e) {
  const t = pn(), n = function(r, i) {
    let o = r;
    for (; o != null; ) {
      const a = o[`__lexicalKey_${i._key}`];
      if (a !== void 0) return a;
      o = Eg(o);
    }
    return null;
  }(e, t);
  return n === null ? e === t.getRootElement() ? Mn("root") : null : Mn(n);
}
function mC(e, t) {
  return t ? e.getTextContentSize() : 0;
}
function KR(e) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(e);
}
function u_(e) {
  const t = [];
  let n = e;
  for (; n !== null; ) t.push(n), n = n._parentEditor;
  return t;
}
function HR() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function GR(e) {
  return e.nodeType === Ua ? e.nodeValue : null;
}
function f_(e, t, n) {
  const r = eo(t._window);
  if (r === null) return;
  const i = r.anchorNode;
  let { anchorOffset: o, focusOffset: a } = r;
  if (i !== null) {
    let s = GR(i);
    const l = Tg(i);
    if (s !== null && Se(l)) {
      if (s === Og && n) {
        const c = n.length;
        s = n, o = c, a = c;
      }
      s !== null && d_(l, s, o, a, e);
    }
  }
}
function d_(e, t, n, r, i) {
  let o = e;
  if (o.isAttached() && (i || !o.isDirty())) {
    const a = o.isComposing();
    let s = t;
    (a || i) && t[t.length - 1] === Og && (s = t.slice(0, -1));
    const l = o.getTextContent();
    if (i || s !== l) {
      if (s === "") {
        if (Un(null), Q1 || Sg || e_) o.remove();
        else {
          const v = pn();
          setTimeout(() => {
            v.update(() => {
              o.isAttached() && o.remove();
            });
          }, 20);
        }
        return;
      }
      const c = o.getParent(), f = Ig(), d = o.getTextContentSize(), p = _a(), m = o.getKey();
      if (o.isToken() || p !== null && m === p && !a || we(f) && (c !== null && !c.canInsertTextBefore() && f.anchor.offset === 0 || f.anchor.key === e.__key && f.anchor.offset === 0 && !o.canInsertTextBefore() && !a || f.focus.key === e.__key && f.focus.offset === d && !o.canInsertTextAfter() && !a)) return void o.markDirty();
      const g = ke();
      if (!we(g) || n === null || r === null) return void o.setTextContent(s);
      if (g.setTextNodeRange(o, n, o, r), o.isSegmented()) {
        const v = Wn(o.getTextContent());
        o.replace(v), o = v;
      }
      o.setTextContent(s);
    }
  }
}
function LZ(e, t) {
  if (t.isSegmented()) return !0;
  if (!e.isCollapsed()) return !1;
  const n = e.anchor.offset, r = t.getParentOrThrow(), i = t.isToken();
  return n === 0 ? !t.canInsertTextBefore() || !r.canInsertTextBefore() && !t.isComposing() || i || function(o) {
    const a = o.getPreviousSibling();
    return (Se(a) || ye(a) && a.isInline()) && !a.canInsertTextAfter();
  }(t) : n === t.getTextContentSize() && (!t.canInsertTextAfter() || !r.canInsertTextAfter() && !t.isComposing() || i);
}
function gC(e) {
  return e === "ArrowLeft";
}
function yC(e) {
  return e === "ArrowRight";
}
function Lu(e, t) {
  return xi ? e : t;
}
function vC(e) {
  return e === "Enter";
}
function xu(e) {
  return e === "Backspace";
}
function wu(e) {
  return e === "Delete";
}
function bC(e, t, n) {
  return e.toLowerCase() === "a" && Lu(t, n);
}
function BZ() {
  const e = rr();
  Wo($Z(e.select(0, e.getChildrenSize())));
}
function Gu(e, t) {
  e.__lexicalClassNameCache === void 0 && (e.__lexicalClassNameCache = {});
  const n = e.__lexicalClassNameCache, r = n[t];
  if (r !== void 0) return r;
  const i = e[t];
  if (typeof i == "string") {
    const o = Np(i);
    return n[t] = o, o;
  }
  return i;
}
function h_(e, t, n, r, i) {
  if (n.size === 0) return;
  const o = r.__type, a = r.__key, s = t.get(o);
  s === void 0 && _e(33, o);
  const l = s.klass;
  let c = e.get(l);
  c === void 0 && (c = /* @__PURE__ */ new Map(), e.set(l, c));
  const f = c.get(a), d = f === "destroyed" && i === "created";
  (f === void 0 || d) && c.set(a, d ? "updated" : i);
}
function xC(e, t, n) {
  const r = e.getParent();
  let i = n, o = e;
  return r !== null && (t && n === 0 ? (i = o.getIndexWithinParent(), o = r) : t || n !== o.getChildrenSize() || (i = o.getIndexWithinParent() + 1, o = r)), o.getChildAtIndex(t ? i - 1 : i);
}
function F0(e, t) {
  const n = e.offset;
  if (e.type === "element")
    return xC(e.getNode(), t, n);
  {
    const r = e.getNode();
    if (t && n === 0 || !t && n === r.getTextContentSize()) {
      const i = t ? r.getPreviousSibling() : r.getNextSibling();
      return i === null ? xC(r.getParentOrThrow(), t, r.getIndexWithinParent() + (t ? 0 : 1)) : i;
    }
  }
  return null;
}
function YR(e) {
  const t = kg(e).event, n = t && t.inputType;
  return n === "insertFromPaste" || n === "insertFromPasteAsQuotation";
}
function Ae(e, t, n) {
  return x2(e, t, n);
}
function Cg(e) {
  return !cr(e) && !e.isLastChild() && !e.isInline();
}
function Ip(e, t) {
  const n = e._keyToDOMMap.get(t);
  return n === void 0 && _e(75, t), n;
}
function Eg(e) {
  const t = e.assignedSlot || e.parentElement;
  return t !== null && t.nodeType === 11 ? t.host : t;
}
function W0(e, t) {
  let n = e.getParent();
  for (; n !== null; ) {
    if (n.is(t)) return !0;
    n = n.getParent();
  }
  return !1;
}
function kg(e) {
  const t = e._window;
  return t === null && _e(78), t;
}
function FZ(e) {
  let t = e.getParentOrThrow();
  for (; t !== null; ) {
    if (pd(t)) return t;
    t = t.getParentOrThrow();
  }
  return t;
}
function pd(e) {
  return cr(e) || ye(e) && e.isShadowRoot();
}
function Mg(e) {
  const t = pn(), n = e.constructor.getType(), r = t._nodes.get(n);
  r === void 0 && _e(97);
  const i = r.replace;
  if (i !== null) {
    const o = i(e);
    return o instanceof e.constructor || _e(98), o;
  }
  return e;
}
function fb(e, t) {
  !cr(e.getParent()) || ye(t) || Kt(t) || _e(99);
}
function db(e) {
  return (Kt(e) || ye(e) && !e.canBeEmpty()) && !e.isInline();
}
function p_(e, t, n) {
  n.style.removeProperty("caret-color"), t._blockCursorElement = null;
  const r = e.parentElement;
  r !== null && r.removeChild(e);
}
function WZ(e, t, n) {
  let r = e._blockCursorElement;
  if (we(n) && n.isCollapsed() && n.anchor.type === "element" && t.contains(document.activeElement)) {
    const i = n.anchor, o = i.getNode(), a = i.offset;
    let s = !1, l = null;
    if (a === o.getChildrenSize())
      db(o.getChildAtIndex(a - 1)) && (s = !0);
    else {
      const c = o.getChildAtIndex(a);
      if (db(c)) {
        const f = c.getPreviousSibling();
        (f === null || db(f)) && (s = !0, l = e.getElementByKey(c.__key));
      }
    }
    if (s) {
      const c = e.getElementByKey(o.__key);
      return r === null && (e._blockCursorElement = r = function(f) {
        const d = f.theme, p = document.createElement("div");
        p.contentEditable = "false", p.setAttribute("data-lexical-cursor", "true");
        let m = d.blockCursor;
        if (m !== void 0) {
          if (typeof m == "string") {
            const g = Np(m);
            m = d.blockCursor = g;
          }
          m !== void 0 && p.classList.add(...m);
        }
        return p;
      }(e._config)), t.style.caretColor = "transparent", void (l === null ? c.appendChild(r) : c.insertBefore(r, l));
    }
  }
  r !== null && p_(r, e, t);
}
function eo(e) {
  return Di ? (e || window).getSelection() : null;
}
function m_(e) {
  return e.nodeType === 1;
}
function zZ(e) {
  const t = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var|#text)$/, "i");
  return e.nodeName.match(t) !== null;
}
function wC(e) {
  const t = new RegExp(/^(address|article|aside|blockquote|canvas|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hr|li|main|nav|noscript|ol|p|pre|section|table|td|tfoot|ul|video)$/, "i");
  return e.nodeName.match(t) !== null;
}
function Pl(e) {
  if (cr(e) || Kt(e) && !e.isInline()) return !0;
  if (!ye(e) || pd(e)) return !1;
  const t = e.getFirstChild(), n = t === null || Xu(t) || Se(t) || t.isInline();
  return !e.isInline() && e.canBeEmpty() !== !1 && n;
}
function hb(e, t) {
  let n = e;
  for (; n !== null && n.getParent() !== null && !t(n); ) n = n.getParentOrThrow();
  return t(n) ? n : null;
}
const _C = /* @__PURE__ */ new WeakMap(), VZ = /* @__PURE__ */ new Map();
function UZ(e) {
  if (!e._readOnly && e.isEmpty()) return VZ;
  e._readOnly || _e(192);
  let t = _C.get(e);
  if (!t) {
    t = /* @__PURE__ */ new Map(), _C.set(e, t);
    for (const [n, r] of e._nodeMap) {
      const i = r.__type;
      let o = t.get(i);
      o || (o = /* @__PURE__ */ new Map(), t.set(i, o)), o.set(n, r);
    }
  }
  return t;
}
function qR(e) {
  const t = e.constructor.clone(e);
  return t.afterCloneFrom(e), t;
}
function XR(e, t, n, r, i, o) {
  let a = e.getFirstChild();
  for (; a !== null; ) {
    const s = a.__key;
    a.__parent === t && (ye(a) && XR(a, s, n, r, i, o), n.has(s) || o.delete(s), i.push(s)), a = a.getNextSibling();
  }
}
let Ba, hr, xf, Ng, z0, V0, Ls, Ei, U0, wf, xn = "", lr = "", Bi = null, wi = "", wo = "", ZR = !1, _f = !1, sp = null;
function Rp(e, t) {
  const n = Ls.get(e);
  if (t !== null) {
    const r = G0(e);
    r.parentNode === t && t.removeChild(r);
  }
  if (Ei.has(e) || hr._keyToDOMMap.delete(e), ye(n)) {
    const r = Lp(n, Ls);
    K0(r, 0, r.length - 1, null);
  }
  n !== void 0 && h_(wf, xf, Ng, n, "destroyed");
}
function K0(e, t, n, r) {
  let i = t;
  for (; i <= n; ++i) {
    const o = e[i];
    o !== void 0 && Rp(o, r);
  }
}
function ls(e, t) {
  e.setProperty("text-align", t);
}
const KZ = "40px";
function JR(e, t) {
  const n = Ba.theme.indent;
  if (typeof n == "string") {
    const i = e.classList.contains(n);
    t > 0 && !i ? e.classList.add(n) : t < 1 && i && e.classList.remove(n);
  }
  const r = getComputedStyle(e).getPropertyValue("--lexical-indent-base-value") || KZ;
  e.style.setProperty("padding-inline-start", t === 0 ? "" : `calc(${t} * ${r})`);
}
function QR(e, t) {
  const n = e.style;
  t === 0 ? ls(n, "") : t === n_ ? ls(n, "left") : t === r_ ? ls(n, "center") : t === i_ ? ls(n, "right") : t === o_ ? ls(n, "justify") : t === a_ ? ls(n, "start") : t === s_ && ls(n, "end");
}
function jp(e, t, n) {
  const r = Ei.get(e);
  r === void 0 && _e(60);
  const i = r.createDOM(Ba, hr);
  if (function(o, a, s) {
    const l = s._keyToDOMMap;
    a["__lexicalKey_" + s._key] = o, l.set(o, a);
  }(e, i, hr), Se(r) ? i.setAttribute("data-lexical-text", "true") : Kt(r) && i.setAttribute("data-lexical-decorator", "true"), ye(r)) {
    const o = r.__indent, a = r.__size;
    if (o !== 0 && JR(i, o), a !== 0) {
      const l = a - 1;
      (function(c, f, d, p) {
        const m = lr;
        lr = "", H0(c, d, 0, f, p, null), t2(d, p), lr = m;
      })(Lp(r, Ei), l, r, i);
    }
    const s = r.__format;
    s !== 0 && QR(i, s), r.isInline() || e2(null, r, i), Cg(r) && (xn += Fo, wo += Fo);
  } else {
    const o = r.getTextContent();
    if (Kt(r)) {
      const a = r.decorate(hr, Ba);
      a !== null && n2(e, a), i.contentEditable = "false";
    } else Se(r) && (r.isDirectionless() || (lr += o));
    xn += o, wo += o;
  }
  if (t !== null) if (n != null) t.insertBefore(i, n);
  else {
    const o = t.__lexicalLineBreak;
    o != null ? t.insertBefore(i, o) : t.appendChild(i);
  }
  return h_(wf, xf, Ng, r, "created"), i;
}
function H0(e, t, n, r, i, o) {
  const a = xn;
  xn = "";
  let s = n;
  for (; s <= r; ++s) {
    jp(e[s], i, o);
    const l = Ei.get(e[s]);
    l !== null && Se(l) && (Bi === null && (Bi = l.getFormat()), wi === "" && (wi = l.getStyle()));
  }
  Cg(t) && (xn += Fo), i.__lexicalTextContent = xn, xn = a + xn;
}
function SC(e, t) {
  const n = t.get(e);
  return Xu(n) || Kt(n) && n.isInline();
}
function e2(e, t, n) {
  const r = e !== null && (e.__size === 0 || SC(e.__last, Ls)), i = t.__size === 0 || SC(t.__last, Ei);
  if (r) {
    if (!i) {
      const o = n.__lexicalLineBreak;
      if (o != null) try {
        n.removeChild(o);
      } catch (a) {
        if (typeof a == "object" && a != null) {
          const s = `${a.toString()} Parent: ${n.tagName}, child: ${o.tagName}.`;
          throw new Error(s);
        }
        throw a;
      }
      n.__lexicalLineBreak = null;
    }
  } else if (i) {
    const o = document.createElement("br");
    n.__lexicalLineBreak = o, n.appendChild(o);
  }
}
function t2(e, t) {
  const n = t.__lexicalDirTextContent, r = t.__lexicalDir;
  if (n !== lr || r !== sp) {
    const o = lr === "", a = o ? sp : (i = lr, _Z.test(i) ? "rtl" : SZ.test(i) ? "ltr" : null);
    if (a !== r) {
      const s = t.classList, l = Ba.theme;
      let c = r !== null ? l[r] : void 0, f = a !== null ? l[a] : void 0;
      if (c !== void 0) {
        if (typeof c == "string") {
          const d = Np(c);
          c = l[r] = d;
        }
        s.remove(...c);
      }
      if (a === null || o && a === "ltr") t.removeAttribute("dir");
      else {
        if (f !== void 0) {
          if (typeof f == "string") {
            const d = Np(f);
            f = l[a] = d;
          }
          f !== void 0 && s.add(...f);
        }
        t.dir = a;
      }
      _f || (e.getWritable().__dir = a);
    }
    sp = a, t.__lexicalDirTextContent = lr, t.__lexicalDir = a;
  }
  var i;
}
function HZ(e, t, n) {
  const r = lr;
  var i;
  lr = "", Bi = null, wi = "", function(o, a, s) {
    const l = xn, c = o.__size, f = a.__size;
    if (xn = "", c === 1 && f === 1) {
      const d = o.__first, p = a.__first;
      if (d === p) Bu(d, s);
      else {
        const g = G0(d), v = jp(p, null, null);
        try {
          s.replaceChild(v, g);
        } catch (y) {
          if (typeof y == "object" && y != null) {
            const x = `${y.toString()} Parent: ${s.tagName}, new child: {tag: ${v.tagName} key: ${p}}, old child: {tag: ${g.tagName}, key: ${d}}.`;
            throw new Error(x);
          }
          throw y;
        }
        Rp(d, null);
      }
      const m = Ei.get(p);
      Se(m) && (Bi === null && (Bi = m.getFormat()), wi === "" && (wi = m.getStyle()));
    } else {
      const d = Lp(o, Ls), p = Lp(a, Ei);
      if (c === 0) f !== 0 && H0(p, a, 0, f - 1, s, null);
      else if (f === 0) {
        if (c !== 0) {
          const m = s.__lexicalLineBreak == null;
          K0(d, 0, c - 1, m ? null : s), m && (s.textContent = "");
        }
      } else (function(m, g, v, y, x, w) {
        const S = y - 1, A = x - 1;
        let _, O, T = (D = w, D.firstChild), C = 0, k = 0;
        for (var D; C <= S && k <= A; ) {
          const B = g[C], L = v[k];
          if (B === L) T = pb(Bu(L, w)), C++, k++;
          else {
            _ === void 0 && (_ = new Set(g)), O === void 0 && (O = new Set(v));
            const W = O.has(B), z = _.has(L);
            if (W) if (z) {
              const G = Ip(hr, L);
              G === T ? T = pb(Bu(L, w)) : (T != null ? w.insertBefore(G, T) : w.appendChild(G), Bu(L, w)), C++, k++;
            } else jp(L, w, T), k++;
            else T = pb(G0(B)), Rp(B, w), C++;
          }
          const F = Ei.get(L);
          F !== null && Se(F) && (Bi === null && (Bi = F.getFormat()), wi === "" && (wi = F.getStyle()));
        }
        const N = C > S, $ = k > A;
        if (N && !$) {
          const B = v[A + 1];
          H0(v, m, k, A, w, B === void 0 ? null : hr.getElementByKey(B));
        } else $ && !N && K0(g, C, S, w);
      })(a, d, p, c, f, s);
    }
    Cg(a) && (xn += Fo), s.__lexicalTextContent = xn, xn = l + xn;
  }(e, t, n), t2(t, n), ex(i = t) && Bi != null && Bi !== i.__textFormat && !_f && (i.setTextFormat(Bi), i.setTextStyle(wi)), function(o) {
    ex(o) && wi !== "" && wi !== o.__textStyle && !_f && o.setTextStyle(wi);
  }(t), lr = r;
}
function Lp(e, t) {
  const n = [];
  let r = e.__first;
  for (; r !== null; ) {
    const i = t.get(r);
    i === void 0 && _e(101), n.push(r), r = i.__next;
  }
  return n;
}
function Bu(e, t) {
  const n = Ls.get(e);
  let r = Ei.get(e);
  n !== void 0 && r !== void 0 || _e(61);
  const i = ZR || V0.has(e) || z0.has(e), o = Ip(hr, e);
  if (n === r && !i) {
    if (ye(n)) {
      const a = o.__lexicalTextContent;
      a !== void 0 && (xn += a, wo += a);
      const s = o.__lexicalDirTextContent;
      s !== void 0 && (lr += s);
    } else {
      const a = n.getTextContent();
      Se(n) && !n.isDirectionless() && (lr += a), wo += a, xn += a;
    }
    return o;
  }
  if (n !== r && i && h_(wf, xf, Ng, r, "updated"), r.updateDOM(n, o, Ba)) {
    const a = jp(e, null, null);
    return t === null && _e(62), t.replaceChild(a, o), Rp(e, null), a;
  }
  if (ye(n) && ye(r)) {
    const a = r.__indent;
    a !== n.__indent && JR(o, a);
    const s = r.__format;
    s !== n.__format && QR(o, s), i && (HZ(n, r, o), cr(r) || r.isInline() || e2(n, r, o)), Cg(r) && (xn += Fo, wo += Fo);
  } else {
    const a = r.getTextContent();
    if (Kt(r)) {
      const s = r.decorate(hr, Ba);
      s !== null && n2(e, s);
    } else Se(r) && !r.isDirectionless() && (lr += a);
    xn += a, wo += a;
  }
  if (!_f && cr(r) && r.__cachedText !== wo) {
    const a = r.getWritable();
    a.__cachedText = wo, r = a;
  }
  return o;
}
function n2(e, t) {
  let n = hr._pendingDecorators;
  const r = hr._decorators;
  if (n === null) {
    if (r[e] === t) return;
    n = VR(hr);
  }
  n[e] = t;
}
function pb(e) {
  let t = e.nextSibling;
  return t !== null && t === hr._blockCursorElement && (t = t.nextSibling), t;
}
function GZ(e, t, n, r, i, o) {
  xn = "", wo = "", lr = "", ZR = r === Ql, sp = null, hr = n, Ba = n._config, xf = n._nodes, Ng = hr._listeners.mutation, z0 = i, V0 = o, Ls = e._nodeMap, Ei = t._nodeMap, _f = t._readOnly, U0 = new Map(n._keyToDOMMap);
  const a = /* @__PURE__ */ new Map();
  return wf = a, Bu("root", null), hr = void 0, xf = void 0, z0 = void 0, V0 = void 0, Ls = void 0, Ei = void 0, Ba = void 0, U0 = void 0, wf = void 0, a;
}
function G0(e) {
  const t = U0.get(e);
  return t === void 0 && _e(75, e), t;
}
const vo = Object.freeze({}), Y0 = 30, q0 = [["keydown", function(e, t) {
  if (Yu = e.timeStamp, r2 = e.key, t.isComposing()) return;
  const { key: n, shiftKey: r, ctrlKey: i, metaKey: o, altKey: a } = e;
  Ae(t, AR, e) || n != null && (function(s, l, c, f) {
    return yC(s) && !l && !f && !c;
  }(n, i, a, o) ? Ae(t, Y1, e) : function(s, l, c, f, d) {
    return yC(s) && !f && !c && (l || d);
  }(n, i, r, a, o) ? Ae(t, iZ, e) : function(s, l, c, f) {
    return gC(s) && !l && !f && !c;
  }(n, i, a, o) ? Ae(t, q1, e) : function(s, l, c, f, d) {
    return gC(s) && !f && !c && (l || d);
  }(n, i, r, a, o) ? Ae(t, oZ, e) : /* @__PURE__ */ function(s, l, c) {
    return /* @__PURE__ */ function(f) {
      return f === "ArrowUp";
    }(s) && !l && !c;
  }(n, i, o) ? Ae(t, PR, e) : /* @__PURE__ */ function(s, l, c) {
    return /* @__PURE__ */ function(f) {
      return f === "ArrowDown";
    }(s) && !l && !c;
  }(n, i, o) ? Ae(t, TR, e) : function(s, l) {
    return vC(s) && l;
  }(n, r) ? (qu = !0, Ae(t, bf, e)) : /* @__PURE__ */ function(s) {
    return s === " ";
  }(n) ? Ae(t, aZ, e) : function(s, l) {
    return xi && l && s.toLowerCase() === "o";
  }(n, i) ? (e.preventDefault(), qu = !0, Ae(t, zl, !0)) : function(s, l) {
    return vC(s) && !l;
  }(n, r) ? (qu = !1, Ae(t, bf, e)) : function(s, l, c, f) {
    return xi ? !l && !c && (xu(s) || s.toLowerCase() === "h" && f) : !(f || l || c) && xu(s);
  }(n, a, o, i) ? xu(n) ? Ae(t, X1, e) : (e.preventDefault(), Ae(t, Es, !0)) : /* @__PURE__ */ function(s) {
    return s === "Escape";
  }(n) ? Ae(t, CR, e) : function(s, l, c, f, d) {
    return xi ? !(c || f || d) && (wu(s) || s.toLowerCase() === "d" && l) : !(l || f || d) && wu(s);
  }(n, i, r, a, o) ? wu(n) ? Ae(t, ER, e) : (e.preventDefault(), Ae(t, Es, !1)) : function(s, l, c) {
    return xu(s) && (xi ? l : c);
  }(n, a, i) ? (e.preventDefault(), Ae(t, yf, !0)) : function(s, l, c) {
    return wu(s) && (xi ? l : c);
  }(n, a, i) ? (e.preventDefault(), Ae(t, yf, !1)) : function(s, l) {
    return xi && l && xu(s);
  }(n, o) ? (e.preventDefault(), Ae(t, vf, !0)) : function(s, l) {
    return xi && l && wu(s);
  }(n, o) ? (e.preventDefault(), Ae(t, vf, !1)) : function(s, l, c, f) {
    return s.toLowerCase() === "b" && !l && Lu(c, f);
  }(n, a, o, i) ? (e.preventDefault(), Ae(t, ws, "bold")) : function(s, l, c, f) {
    return s.toLowerCase() === "u" && !l && Lu(c, f);
  }(n, a, o, i) ? (e.preventDefault(), Ae(t, ws, "underline")) : function(s, l, c, f) {
    return s.toLowerCase() === "i" && !l && Lu(c, f);
  }(n, a, o, i) ? (e.preventDefault(), Ae(t, ws, "italic")) : /* @__PURE__ */ function(s, l, c, f) {
    return s === "Tab" && !l && !c && !f;
  }(n, a, i, o) ? Ae(t, kR, e) : function(s, l, c, f) {
    return s.toLowerCase() === "z" && !l && Lu(c, f);
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, H1, void 0)) : function(s, l, c, f) {
    return xi ? s.toLowerCase() === "z" && c && l : s.toLowerCase() === "y" && f || s.toLowerCase() === "z" && f && l;
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, G1, void 0)) : Dg(t._editorState._selection) ? function(s, l, c, f) {
    return !l && s.toLowerCase() === "c" && (xi ? c : f);
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, Z1, e)) : function(s, l, c, f) {
    return !l && s.toLowerCase() === "x" && (xi ? c : f);
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, J1, e)) : bC(n, o, i) && (e.preventDefault(), Ae(t, j0, e)) : !Ea && bC(n, o, i) && (e.preventDefault(), Ae(t, j0, e)), /* @__PURE__ */ function(s, l, c, f) {
    return s || l || c || f;
  }(i, r, a, o) && Ae(t, hZ, e));
}], ["pointerdown", function(e, t) {
  const n = e.target, r = e.pointerType;
  n instanceof Node && r !== "touch" && Br(t, () => {
    Kt(Tg(n)) || (Z0 = !0);
  });
}], ["compositionstart", function(e, t) {
  Br(t, () => {
    const n = ke();
    if (we(n) && !t.isComposing()) {
      const r = n.anchor, i = n.anchor.getNode();
      Un(r.key), (e.timeStamp < Yu + Y0 || r.type === "element" || !n.isCollapsed() || i.getFormat() !== n.format || Se(i) && i.getStyle() !== n.style) && Ae(t, Vl, wZ);
    }
  });
}], ["compositionend", function(e, t) {
  Ea ? _u = !0 : Br(t, () => {
    mb(t, e.data);
  });
}], ["input", function(e, t) {
  e.stopPropagation(), Br(t, () => {
    const n = ke(), r = e.data, i = s2(e);
    if (r != null && we(n) && a2(n, i, r, e.timeStamp, !1)) {
      _u && (mb(t, r), _u = !1);
      const o = n.anchor.getNode(), a = eo(t._window);
      if (a === null) return;
      const s = n.isBackward(), l = s ? n.anchor.offset : n.focus.offset, c = s ? n.focus.offset : n.anchor.offset;
      Ep && !n.isCollapsed() && Se(o) && a.anchorNode !== null && o.getTextContent().slice(0, l) + r + o.getTextContent().slice(l + c) === GR(a.anchorNode) || Ae(t, Vl, r);
      const f = r.length;
      Ea && f > 1 && e.inputType === "insertCompositionText" && !t.isComposing() && (n.anchor.offset -= f), Q1 || Sg || e_ || !t.isComposing() || (Yu = 0, Un(null));
    } else
      f_(!1, t, r !== null ? r : void 0), _u && (mb(t, r || void 0), _u = !1);
    xr(), LR(pn());
  }), Tl = null;
}], ["click", function(e, t) {
  Br(t, () => {
    const n = ke(), r = eo(t._window), i = Ig();
    if (r) {
      if (we(n)) {
        const o = n.anchor, a = o.getNode();
        o.type === "element" && o.offset === 0 && n.isCollapsed() && !cr(a) && rr().getChildrenSize() === 1 && a.getTopLevelElementOrThrow().isEmpty() && i !== null && n.is(i) ? (r.removeAllRanges(), n.dirty = !0) : e.detail === 3 && !n.isCollapsed() && a !== n.focus.getNode() && (ye(a) ? a.select(0) : a.getParentOrThrow().select(0));
      } else if (e.pointerType === "touch") {
        const o = r.anchorNode;
        if (o !== null) {
          const a = o.nodeType;
          (a === hd || a === Ua) && Wo(v_(i, r, t, e));
        }
      }
    }
    Ae(t, rZ, e);
  });
}], ["cut", vo], ["copy", vo], ["dragstart", vo], ["dragover", vo], ["dragend", vo], ["paste", vo], ["focus", vo], ["blur", vo], ["drop", vo]];
Ep && q0.push(["beforeinput", (e, t) => function(n, r) {
  const i = n.inputType, o = s2(n);
  i === "deleteCompositionText" || Ea && YR(r) || i !== "insertCompositionText" && Br(r, () => {
    const a = ke();
    if (i === "deleteContentBackward") {
      if (a === null) {
        const m = Ig();
        if (!we(m)) return;
        Wo(m.clone());
      }
      if (we(a)) {
        const m = a.anchor.key === a.focus.key;
        if (s = n.timeStamp, r2 === "MediaLast" && s < Yu + Y0 && r.isComposing() && m) {
          if (Un(null), Yu = 0, setTimeout(() => {
            Br(r, () => {
              Un(null);
            });
          }, Y0), we(a)) {
            const g = a.anchor.getNode();
            g.markDirty(), a.format = g.getFormat(), Se(g) || _e(142), a.style = g.getStyle();
          }
        } else {
          Un(null), n.preventDefault();
          const g = a.anchor.getNode().getTextContent(), v = a.anchor.offset === 0 && a.focus.offset === g.length;
          gZ && m && !v || Ae(r, Es, !0);
        }
        return;
      }
    }
    var s;
    if (!we(a)) return;
    const l = n.data;
    Tl !== null && f_(!1, r, Tl), a.dirty && Tl === null || !a.isCollapsed() || cr(a.anchor.getNode()) || o === null || a.applyDOMRange(o), Tl = null;
    const c = a.anchor, f = a.focus, d = c.getNode(), p = f.getNode();
    if (i !== "insertText" && i !== "insertTranspose") switch (n.preventDefault(), i) {
      case "insertFromYank":
      case "insertFromDrop":
      case "insertReplacementText":
        Ae(r, Vl, n);
        break;
      case "insertFromComposition":
        Un(null), Ae(r, Vl, n);
        break;
      case "insertLineBreak":
        Un(null), Ae(r, zl, !1);
        break;
      case "insertParagraph":
        Un(null), qu && !Sg ? (qu = !1, Ae(r, zl, !1)) : Ae(r, I0, void 0);
        break;
      case "insertFromPaste":
      case "insertFromPasteAsQuotation":
        Ae(r, K1, n);
        break;
      case "deleteByComposition":
        (function(m, g) {
          return m !== g || ye(m) || ye(g) || !m.isToken() || !g.isToken();
        })(d, p) && Ae(r, R0, n);
        break;
      case "deleteByDrag":
      case "deleteByCut":
        Ae(r, R0, n);
        break;
      case "deleteContent":
        Ae(r, Es, !1);
        break;
      case "deleteWordBackward":
        Ae(r, yf, !0);
        break;
      case "deleteWordForward":
        Ae(r, yf, !1);
        break;
      case "deleteHardLineBackward":
      case "deleteSoftLineBackward":
        Ae(r, vf, !0);
        break;
      case "deleteContentForward":
      case "deleteHardLineForward":
      case "deleteSoftLineForward":
        Ae(r, vf, !1);
        break;
      case "formatStrikeThrough":
        Ae(r, ws, "strikethrough");
        break;
      case "formatBold":
        Ae(r, ws, "bold");
        break;
      case "formatItalic":
        Ae(r, ws, "italic");
        break;
      case "formatUnderline":
        Ae(r, ws, "underline");
        break;
      case "historyUndo":
        Ae(r, H1, void 0);
        break;
      case "historyRedo":
        Ae(r, G1, void 0);
    }
    else {
      if (l === `
`) n.preventDefault(), Ae(r, zl, !1);
      else if (l === Fo) n.preventDefault(), Ae(r, I0, void 0);
      else if (l == null && n.dataTransfer) {
        const m = n.dataTransfer.getData("text/plain");
        n.preventDefault(), a.insertRawText(m);
      } else l != null && a2(a, o, l, n.timeStamp, !0) ? (n.preventDefault(), Ae(r, Vl, l)) : Tl = l;
      i2 = n.timeStamp;
    }
  });
}(e, t)]);
let Yu = 0, r2 = null, i2 = 0, Tl = null;
const Bp = /* @__PURE__ */ new WeakMap();
let X0 = !1, Z0 = !1, qu = !1, _u = !1, o2 = [0, "", 0, "root", 0];
function a2(e, t, n, r, i) {
  const o = e.anchor, a = e.focus, s = o.getNode(), l = pn(), c = eo(l._window), f = c !== null ? c.anchorNode : null, d = o.key, p = l.getElementByKey(d), m = n.length;
  return d !== a.key || !Se(s) || (!i && (!Ep || i2 < r + 50) || s.isDirty() && m < 2 || KR(n)) && o.offset !== a.offset && !s.isComposing() || Al(s) || s.isDirty() && m > 1 || (i || !Ep) && p !== null && !s.isComposing() && f !== $p(p) || c !== null && t !== null && (!t.collapsed || t.startContainer !== c.anchorNode || t.startOffset !== c.anchorOffset) || s.getFormat() !== e.format || s.getStyle() !== e.style || LZ(e, s);
}
function OC(e, t) {
  return e !== null && e.nodeValue !== null && e.nodeType === Ua && t !== 0 && t !== e.nodeValue.length;
}
function AC(e, t, n) {
  const { anchorNode: r, anchorOffset: i, focusNode: o, focusOffset: a } = e;
  X0 && (X0 = !1, OC(r, i) && OC(o, a)) || Br(t, () => {
    if (!n) return void Wo(null);
    if (!Ag(t, r, o)) return;
    const s = ke();
    if (we(s)) {
      const l = s.anchor, c = l.getNode();
      if (s.isCollapsed()) {
        e.type === "Range" && e.anchorNode === e.focusNode && (s.dirty = !0);
        const f = kg(t).event, d = f ? f.timeStamp : performance.now(), [p, m, g, v, y] = o2, x = rr(), w = t.isComposing() === !1 && x.getTextContent() === "";
        if (d < y + 200 && l.offset === g && l.key === v) s.format = p, s.style = m;
        else if (l.type === "text") Se(c) || _e(141), s.format = c.getFormat(), s.style = c.getStyle();
        else if (l.type === "element" && !w) {
          const S = l.getNode();
          s.style = "", S instanceof Rc && S.getChildrenSize() === 0 ? (s.format = S.getTextFormat(), s.style = S.getTextStyle()) : s.format = 0;
        }
      } else {
        const f = l.key, d = s.focus.key, p = s.getNodes(), m = p.length, g = s.isBackward(), v = g ? a : i, y = g ? i : a, x = g ? d : f, w = g ? f : d;
        let S = xZ, A = !1;
        for (let _ = 0; _ < m; _++) {
          const O = p[_], T = O.getTextContentSize();
          if (Se(O) && T !== 0 && !(_ === 0 && O.__key === x && v === T || _ === m - 1 && O.__key === w && y === 0) && (A = !0, S &= O.getFormat(), S === 0)) break;
        }
        s.format = A ? S : 0;
      }
    }
    Ae(t, U1, void 0);
  });
}
function s2(e) {
  if (!e.getTargetRanges) return null;
  const t = e.getTargetRanges();
  return t.length === 0 ? null : t[0];
}
function mb(e, t) {
  const n = e._compositionKey;
  if (Un(null), n !== null && t != null) {
    if (t === "") {
      const r = Mn(n), i = $p(e.getElementByKey(n));
      return void (i !== null && i.nodeValue !== null && Se(r) && d_(r, i.nodeValue, null, null, !0));
    }
    if (t[t.length - 1] === `
`) {
      const r = ke();
      if (we(r)) {
        const i = r.focus;
        return r.anchor.set(i.key, i.offset, i.type), void Ae(e, bf, null);
      }
    }
  }
  f_(!0, e, t);
}
function l2(e) {
  let t = e.__lexicalEventHandles;
  return t === void 0 && (t = [], e.__lexicalEventHandles = t), t;
}
const Ul = /* @__PURE__ */ new Map();
function c2(e) {
  const t = e.target, n = eo(t == null ? null : t.nodeType === 9 ? t.defaultView : t.ownerDocument.defaultView);
  if (n === null) return;
  const r = WR(n.anchorNode);
  if (r === null) return;
  Z0 && (Z0 = !1, Br(r, () => {
    const c = Ig(), f = n.anchorNode;
    if (f === null) return;
    const d = f.nodeType;
    d !== hd && d !== Ua || Wo(v_(c, n, r, e));
  }));
  const i = u_(r), o = i[i.length - 1], a = o._key, s = Ul.get(a), l = s || o;
  l !== r && AC(n, l, !1), AC(n, r, !0), r !== o ? Ul.set(a, r) : s && Ul.delete(a);
}
function PC(e) {
  e._lexicalHandled = !0;
}
function TC(e) {
  return e._lexicalHandled === !0;
}
function YZ(e) {
  const t = e.ownerDocument, n = Bp.get(t);
  n === void 0 && _e(162);
  const r = n - 1;
  r >= 0 || _e(164), Bp.set(t, r), r === 0 && t.removeEventListener("selectionchange", c2);
  const i = Pg(e);
  c_(i) ? (function(a) {
    if (a._parentEditor !== null) {
      const s = u_(a), l = s[s.length - 1]._key;
      Ul.get(l) === a && Ul.delete(l);
    } else Ul.delete(a._key);
  }(i), e.__lexicalEditor = null) : i && _e(198);
  const o = l2(e);
  for (let a = 0; a < o.length; a++) o[a]();
  e.__lexicalEventHandles = [];
}
function J0(e, t, n) {
  xr();
  const r = e.__key, i = e.getParent();
  if (i === null) return;
  const o = function(s) {
    const l = ke();
    if (!we(l) || !ye(s)) return l;
    const { anchor: c, focus: f } = l, d = c.getNode(), p = f.getNode();
    return W0(d, s) && c.set(s.__key, 0, "element"), W0(p, s) && f.set(s.__key, 0, "element"), l;
  }(e);
  let a = !1;
  if (we(o) && t) {
    const s = o.anchor, l = o.focus;
    s.key === r && (Wp(s, e, i, e.getPreviousSibling(), e.getNextSibling()), a = !0), l.key === r && (Wp(l, e, i, e.getPreviousSibling(), e.getNextSibling()), a = !0);
  } else Dg(o) && t && e.isSelected() && e.selectPrevious();
  if (we(o) && t && !a) {
    const s = e.getIndexWithinParent();
    ks(e), Fp(o, i, s, -1);
  } else ks(e);
  n || pd(i) || i.canBeEmpty() || !i.isEmpty() || J0(i, t), t && cr(i) && i.isEmpty() && i.selectEnd();
}
class $g {
  static getType() {
    _e(64, this.name);
  }
  static clone(t) {
    _e(65, this.name);
  }
  afterCloneFrom(t) {
    this.__parent = t.__parent, this.__next = t.__next, this.__prev = t.__prev;
  }
  constructor(t) {
    this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, jZ(this, t);
  }
  getType() {
    return this.__type;
  }
  isInline() {
    _e(137, this.constructor.name);
  }
  isAttached() {
    let t = this.__key;
    for (; t !== null; ) {
      if (t === "root") return !0;
      const n = Mn(t);
      if (n === null) break;
      t = n.__parent;
    }
    return !1;
  }
  isSelected(t) {
    const n = t || ke();
    if (n == null) return !1;
    const r = n.getNodes().some((i) => i.__key === this.__key);
    if (Se(this)) return r;
    if (we(n) && n.anchor.type === "element" && n.focus.type === "element") {
      if (n.isCollapsed()) return !1;
      const i = this.getParent();
      if (Kt(this) && this.isInline() && i) {
        const o = n.isBackward() ? n.focus : n.anchor, a = o.getNode();
        if (o.offset === a.getChildrenSize() && a.is(i) && a.getLastChildOrThrow().is(this)) return !1;
      }
    }
    return r;
  }
  getKey() {
    return this.__key;
  }
  getIndexWithinParent() {
    const t = this.getParent();
    if (t === null) return -1;
    let n = t.getFirstChild(), r = 0;
    for (; n !== null; ) {
      if (this.is(n)) return r;
      r++, n = n.getNextSibling();
    }
    return -1;
  }
  getParent() {
    const t = this.getLatest().__parent;
    return t === null ? null : Mn(t);
  }
  getParentOrThrow() {
    const t = this.getParent();
    return t === null && _e(66, this.__key), t;
  }
  getTopLevelElement() {
    let t = this;
    for (; t !== null; ) {
      const n = t.getParent();
      if (pd(n)) return ye(t) || t === this && Kt(t) || _e(194), t;
      t = n;
    }
    return null;
  }
  getTopLevelElementOrThrow() {
    const t = this.getTopLevelElement();
    return t === null && _e(67, this.__key), t;
  }
  getParents() {
    const t = [];
    let n = this.getParent();
    for (; n !== null; ) t.push(n), n = n.getParent();
    return t;
  }
  getParentKeys() {
    const t = [];
    let n = this.getParent();
    for (; n !== null; ) t.push(n.__key), n = n.getParent();
    return t;
  }
  getPreviousSibling() {
    const t = this.getLatest().__prev;
    return t === null ? null : Mn(t);
  }
  getPreviousSiblings() {
    const t = [], n = this.getParent();
    if (n === null) return t;
    let r = n.getFirstChild();
    for (; r !== null && !r.is(this); ) t.push(r), r = r.getNextSibling();
    return t;
  }
  getNextSibling() {
    const t = this.getLatest().__next;
    return t === null ? null : Mn(t);
  }
  getNextSiblings() {
    const t = [];
    let n = this.getNextSibling();
    for (; n !== null; ) t.push(n), n = n.getNextSibling();
    return t;
  }
  getCommonAncestor(t) {
    const n = this.getParents(), r = t.getParents();
    ye(this) && n.unshift(this), ye(t) && r.unshift(t);
    const i = n.length, o = r.length;
    if (i === 0 || o === 0 || n[i - 1] !== r[o - 1]) return null;
    const a = new Set(r);
    for (let s = 0; s < i; s++) {
      const l = n[s];
      if (a.has(l)) return l;
    }
    return null;
  }
  is(t) {
    return t != null && this.__key === t.__key;
  }
  isBefore(t) {
    if (this === t) return !1;
    if (t.isParentOf(this)) return !0;
    if (this.isParentOf(t)) return !1;
    const n = this.getCommonAncestor(t);
    let r = 0, i = 0, o = this;
    for (; ; ) {
      const a = o.getParentOrThrow();
      if (a === n) {
        r = o.getIndexWithinParent();
        break;
      }
      o = a;
    }
    for (o = t; ; ) {
      const a = o.getParentOrThrow();
      if (a === n) {
        i = o.getIndexWithinParent();
        break;
      }
      o = a;
    }
    return r < i;
  }
  isParentOf(t) {
    const n = this.__key;
    if (n === t.__key) return !1;
    let r = t;
    for (; r !== null; ) {
      if (r.__key === n) return !0;
      r = r.getParent();
    }
    return !1;
  }
  getNodesBetween(t) {
    const n = this.isBefore(t), r = [], i = /* @__PURE__ */ new Set();
    let o = this;
    for (; o !== null; ) {
      const a = o.__key;
      if (i.has(a) || (i.add(a), r.push(o)), o === t) break;
      const s = ye(o) ? n ? o.getFirstChild() : o.getLastChild() : null;
      if (s !== null) {
        o = s;
        continue;
      }
      const l = n ? o.getNextSibling() : o.getPreviousSibling();
      if (l !== null) {
        o = l;
        continue;
      }
      const c = o.getParentOrThrow();
      if (i.has(c.__key) || r.push(c), c === t) break;
      let f = null, d = c;
      do {
        if (d === null && _e(68), f = n ? d.getNextSibling() : d.getPreviousSibling(), d = d.getParent(), d === null) break;
        f !== null || i.has(d.__key) || r.push(d);
      } while (f === null);
      o = f;
    }
    return n || r.reverse(), r;
  }
  isDirty() {
    const t = pn()._dirtyLeaves;
    return t !== null && t.has(this.__key);
  }
  getLatest() {
    const t = Mn(this.__key);
    return t === null && _e(113), t;
  }
  getWritable() {
    xr();
    const t = Go(), n = pn(), r = t._nodeMap, i = this.__key, o = this.getLatest(), a = n._cloneNotNeeded, s = ke();
    if (s !== null && s.setCachedNodes(null), a.has(i)) return Dp(o), o;
    const l = qR(o);
    return a.add(i), Dp(l), r.set(i, l), l;
  }
  getTextContent() {
    return "";
  }
  getTextContentSize() {
    return this.getTextContent().length;
  }
  createDOM(t, n) {
    _e(70);
  }
  updateDOM(t, n, r) {
    _e(71);
  }
  exportDOM(t) {
    return { element: this.createDOM(t._config, t) };
  }
  exportJSON() {
    _e(72);
  }
  static importJSON(t) {
    _e(18, this.name);
  }
  static transform() {
    return null;
  }
  remove(t) {
    J0(this, !0, t);
  }
  replace(t, n) {
    xr();
    let r = ke();
    r !== null && (r = r.clone()), fb(this, t);
    const i = this.getLatest(), o = this.__key, a = t.__key, s = t.getWritable(), l = this.getParentOrThrow().getWritable(), c = l.__size;
    ks(s);
    const f = i.getPreviousSibling(), d = i.getNextSibling(), p = i.__prev, m = i.__next, g = i.__parent;
    if (J0(i, !1, !0), f === null ? l.__first = a : f.getWritable().__next = a, s.__prev = p, d === null ? l.__last = a : d.getWritable().__prev = a, s.__next = m, s.__parent = g, l.__size = c, n && (ye(this) && ye(s) || _e(139), this.getChildren().forEach((v) => {
      s.append(v);
    })), we(r)) {
      Wo(r);
      const v = r.anchor, y = r.focus;
      v.key === o && MC(v, s), y.key === o && MC(y, s);
    }
    return _a() === o && Un(a), s;
  }
  insertAfter(t, n = !0) {
    xr(), fb(this, t);
    const r = this.getWritable(), i = t.getWritable(), o = i.getParent(), a = ke();
    let s = !1, l = !1;
    if (o !== null) {
      const m = t.getIndexWithinParent();
      if (ks(i), we(a)) {
        const g = o.__key, v = a.anchor, y = a.focus;
        s = v.type === "element" && v.key === g && v.offset === m + 1, l = y.type === "element" && y.key === g && y.offset === m + 1;
      }
    }
    const c = this.getNextSibling(), f = this.getParentOrThrow().getWritable(), d = i.__key, p = r.__next;
    if (c === null ? f.__last = d : c.getWritable().__prev = d, f.__size++, r.__next = d, i.__next = p, i.__prev = r.__key, i.__parent = r.__parent, n && we(a)) {
      const m = this.getIndexWithinParent();
      Fp(a, f, m + 1);
      const g = f.__key;
      s && a.anchor.set(g, m + 2, "element"), l && a.focus.set(g, m + 2, "element");
    }
    return t;
  }
  insertBefore(t, n = !0) {
    xr(), fb(this, t);
    const r = this.getWritable(), i = t.getWritable(), o = i.__key;
    ks(i);
    const a = this.getPreviousSibling(), s = this.getParentOrThrow().getWritable(), l = r.__prev, c = this.getIndexWithinParent();
    a === null ? s.__first = o : a.getWritable().__next = o, s.__size++, r.__prev = o, i.__prev = l, i.__next = r.__key, i.__parent = r.__parent;
    const f = ke();
    return n && we(f) && Fp(f, this.getParentOrThrow(), c), t;
  }
  isParentRequired() {
    return !1;
  }
  createParentElementNode() {
    return Do();
  }
  selectStart() {
    return this.selectPrevious();
  }
  selectEnd() {
    return this.selectNext(0, 0);
  }
  selectPrevious(t, n) {
    xr();
    const r = this.getPreviousSibling(), i = this.getParentOrThrow();
    if (r === null) return i.select(0, 0);
    if (ye(r)) return r.select();
    if (!Se(r)) {
      const o = r.getIndexWithinParent() + 1;
      return i.select(o, o);
    }
    return r.select(t, n);
  }
  selectNext(t, n) {
    xr();
    const r = this.getNextSibling(), i = this.getParentOrThrow();
    if (r === null) return i.select();
    if (ye(r)) return r.select(0, 0);
    if (!Se(r)) {
      const o = r.getIndexWithinParent();
      return i.select(o, o);
    }
    return r.select(t, n);
  }
  markDirty() {
    this.getWritable();
  }
}
class md extends $g {
  static getType() {
    return "linebreak";
  }
  static clone(t) {
    return new md(t.__key);
  }
  constructor(t) {
    super(t);
  }
  getTextContent() {
    return `
`;
  }
  createDOM() {
    return document.createElement("br");
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { br: (t) => function(n) {
      const r = n.parentElement;
      if (r !== null && wC(r)) {
        const i = r.firstChild;
        if (i === n || i.nextSibling === n && Rh(i)) {
          const o = r.lastChild;
          if (o === n || o.previousSibling === n && Rh(o)) return !0;
        }
      }
      return !1;
    }(t) || function(n) {
      const r = n.parentElement;
      if (r !== null && wC(r)) {
        const i = r.firstChild;
        if (i === n || i.nextSibling === n && Rh(i)) return !1;
        const o = r.lastChild;
        if (o === n || o.previousSibling === n && Rh(o)) return !0;
      }
      return !1;
    }(t) ? null : { conversion: qZ, priority: 0 } };
  }
  static importJSON(t) {
    return Sf();
  }
  exportJSON() {
    return { type: "linebreak", version: 1 };
  }
}
function qZ(e) {
  return { node: Sf() };
}
function Sf() {
  return Mg(new md());
}
function Xu(e) {
  return e instanceof md;
}
function Rh(e) {
  return e.nodeType === Ua && /^( |\t|\r?\n)+$/.test(e.textContent || "");
}
function gb(e, t) {
  return 16 & t ? "code" : t & t_ ? "mark" : 32 & t ? "sub" : 64 & t ? "sup" : null;
}
function yb(e, t) {
  return 1 & t ? "strong" : 2 & t ? "em" : "span";
}
function u2(e, t, n, r, i) {
  const o = r.classList;
  let a = Gu(i, "base");
  a !== void 0 && o.add(...a), a = Gu(i, "underlineStrikethrough");
  let s = !1;
  const l = t & Mp && t & kp;
  a !== void 0 && (n & Mp && n & kp ? (s = !0, l || o.add(...a)) : l && o.remove(...a));
  for (const c in $o) {
    const f = $o[c];
    if (a = Gu(i, c), a !== void 0) if (n & f) {
      if (s && (c === "underline" || c === "strikethrough")) {
        t & f && o.remove(...a);
        continue;
      }
      t & f && (!l || c !== "underline") && c !== "strikethrough" || o.add(...a);
    } else t & f && o.remove(...a);
  }
}
function f2(e, t, n) {
  const r = t.firstChild, i = n.isComposing(), o = e + (i ? Og : "");
  if (r == null) t.textContent = o;
  else {
    const a = r.nodeValue;
    if (a !== o) if (i || Ea) {
      const [s, l, c] = function(f, d) {
        const p = f.length, m = d.length;
        let g = 0, v = 0;
        for (; g < p && g < m && f[g] === d[g]; ) g++;
        for (; v + g < p && v + g < m && f[p - v - 1] === d[m - v - 1]; ) v++;
        return [g, p - g - v, d.slice(g, m - v)];
      }(a, o);
      l !== 0 && r.deleteData(s, l), r.insertData(s, c);
    } else r.nodeValue = o;
  }
}
function CC(e, t, n, r, i, o) {
  f2(i, e, t);
  const a = o.theme.text;
  a !== void 0 && u2(0, 0, r, e, a);
}
function jh(e, t) {
  const n = document.createElement(t);
  return n.appendChild(e), n;
}
class Ic extends $g {
  static getType() {
    return "text";
  }
  static clone(t) {
    return new Ic(t.__text, t.__key);
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__format = t.__format, this.__style = t.__style, this.__mode = t.__mode, this.__detail = t.__detail;
  }
  constructor(t, n) {
    super(n), this.__text = t, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getDetail() {
    return this.getLatest().__detail;
  }
  getMode() {
    const t = this.getLatest();
    return TZ[t.__mode];
  }
  getStyle() {
    return this.getLatest().__style;
  }
  isToken() {
    return this.getLatest().__mode === 1;
  }
  isComposing() {
    return this.__key === _a();
  }
  isSegmented() {
    return this.getLatest().__mode === 2;
  }
  isDirectionless() {
    return !!(1 & this.getLatest().__detail);
  }
  isUnmergeable() {
    return !!(2 & this.getLatest().__detail);
  }
  hasFormat(t) {
    const n = $o[t];
    return !!(this.getFormat() & n);
  }
  isSimpleText() {
    return this.__type === "text" && this.__mode === 0;
  }
  getTextContent() {
    return this.getLatest().__text;
  }
  getFormatFlags(t, n) {
    return B0(this.getLatest().__format, t, n);
  }
  canHaveFormat() {
    return !0;
  }
  createDOM(t, n) {
    const r = this.__format, i = gb(0, r), o = yb(0, r), a = i === null ? o : i, s = document.createElement(a);
    let l = s;
    this.hasFormat("code") && s.setAttribute("spellcheck", "false"), i !== null && (l = document.createElement(o), s.appendChild(l)), CC(l, this, 0, r, this.__text, t);
    const c = this.__style;
    return c !== "" && (s.style.cssText = c), s;
  }
  updateDOM(t, n, r) {
    const i = this.__text, o = t.__format, a = this.__format, s = gb(0, o), l = gb(0, a), c = yb(0, o), f = yb(0, a);
    if ((s === null ? c : s) !== (l === null ? f : l)) return !0;
    if (s === l && c !== f) {
      const v = n.firstChild;
      v == null && _e(48);
      const y = document.createElement(f);
      return CC(y, this, 0, a, i, r), n.replaceChild(y, v), !1;
    }
    let d = n;
    l !== null && s !== null && (d = n.firstChild, d == null && _e(49)), f2(i, d, this);
    const p = r.theme.text;
    p !== void 0 && o !== a && u2(0, o, a, d, p);
    const m = t.__style, g = this.__style;
    return m !== g && (n.style.cssText = g), !1;
  }
  static importDOM() {
    return { "#text": () => ({ conversion: QZ, priority: 0 }), b: () => ({ conversion: ZZ, priority: 0 }), code: () => ({ conversion: pa, priority: 0 }), em: () => ({ conversion: pa, priority: 0 }), i: () => ({ conversion: pa, priority: 0 }), s: () => ({ conversion: pa, priority: 0 }), span: () => ({ conversion: XZ, priority: 0 }), strong: () => ({ conversion: pa, priority: 0 }), sub: () => ({ conversion: pa, priority: 0 }), sup: () => ({ conversion: pa, priority: 0 }), u: () => ({ conversion: pa, priority: 0 }) };
  }
  static importJSON(t) {
    const n = Wn(t.text);
    return n.setFormat(t.format), n.setDetail(t.detail), n.setMode(t.mode), n.setStyle(t.style), n;
  }
  exportDOM(t) {
    let { element: n } = super.exportDOM(t);
    return n !== null && m_(n) || _e(132), n.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (n = jh(n, "b")), this.hasFormat("italic") && (n = jh(n, "i")), this.hasFormat("strikethrough") && (n = jh(n, "s")), this.hasFormat("underline") && (n = jh(n, "u")), { element: n };
  }
  exportJSON() {
    return { detail: this.getDetail(), format: this.getFormat(), mode: this.getMode(), style: this.getStyle(), text: this.getTextContent(), type: "text", version: 1 };
  }
  selectionTransform(t, n) {
  }
  setFormat(t) {
    const n = this.getWritable();
    return n.__format = typeof t == "string" ? $o[t] : t, n;
  }
  setDetail(t) {
    const n = this.getWritable();
    return n.__detail = typeof t == "string" ? OZ[t] : t, n;
  }
  setStyle(t) {
    const n = this.getWritable();
    return n.__style = t, n;
  }
  toggleFormat(t) {
    const n = B0(this.getFormat(), t, null);
    return this.setFormat(n);
  }
  toggleDirectionless() {
    const t = this.getWritable();
    return t.__detail ^= 1, t;
  }
  toggleUnmergeable() {
    const t = this.getWritable();
    return t.__detail ^= 2, t;
  }
  setMode(t) {
    const n = PZ[t];
    if (this.__mode === n) return this;
    const r = this.getWritable();
    return r.__mode = n, r;
  }
  setTextContent(t) {
    if (this.__text === t) return this;
    const n = this.getWritable();
    return n.__text = t, n;
  }
  select(t, n) {
    xr();
    let r = t, i = n;
    const o = ke(), a = this.getTextContent(), s = this.__key;
    if (typeof a == "string") {
      const l = a.length;
      r === void 0 && (r = l), i === void 0 && (i = l);
    } else r = 0, i = 0;
    if (!we(o)) return g2(s, r, s, i, "text", "text");
    {
      const l = _a();
      l !== o.anchor.key && l !== o.focus.key || Un(s), o.setTextNodeRange(this, r, this, i);
    }
    return o;
  }
  selectStart() {
    return this.select(0, 0);
  }
  selectEnd() {
    const t = this.getTextContentSize();
    return this.select(t, t);
  }
  spliceText(t, n, r, i) {
    const o = this.getWritable(), a = o.__text, s = r.length;
    let l = t;
    l < 0 && (l = s + l, l < 0 && (l = 0));
    const c = ke();
    if (i && we(c)) {
      const d = t + s;
      c.setTextNodeRange(o, d, o, d);
    }
    const f = a.slice(0, l) + r + a.slice(l + n);
    return o.__text = f, o;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  splitText(...t) {
    xr();
    const n = this.getLatest(), r = n.getTextContent(), i = n.__key, o = _a(), a = new Set(t), s = [], l = r.length;
    let c = "";
    for (let _ = 0; _ < l; _++) c !== "" && a.has(_) && (s.push(c), c = ""), c += r[_];
    c !== "" && s.push(c);
    const f = s.length;
    if (f === 0) return [];
    if (s[0] === r) return [n];
    const d = s[0], p = n.getParent();
    let m;
    const g = n.getFormat(), v = n.getStyle(), y = n.__detail;
    let x = !1;
    n.isSegmented() ? (m = Wn(d), m.__format = g, m.__style = v, m.__detail = y, x = !0) : (m = n.getWritable(), m.__text = d);
    const w = ke(), S = [m];
    let A = d.length;
    for (let _ = 1; _ < f; _++) {
      const O = s[_], T = O.length, C = Wn(O).getWritable();
      C.__format = g, C.__style = v, C.__detail = y;
      const k = C.__key, D = A + T;
      if (we(w)) {
        const N = w.anchor, $ = w.focus;
        N.key === i && N.type === "text" && N.offset > A && N.offset <= D && (N.key = k, N.offset -= A, w.dirty = !0), $.key === i && $.type === "text" && $.offset > A && $.offset <= D && ($.key = k, $.offset -= A, w.dirty = !0);
      }
      o === i && Un(k), A = D, S.push(C);
    }
    if (p !== null) {
      (function(T) {
        const C = T.getPreviousSibling(), k = T.getNextSibling();
        C !== null && Dp(C), k !== null && Dp(k);
      })(this);
      const _ = p.getWritable(), O = this.getIndexWithinParent();
      x ? (_.splice(O, 0, S), this.remove()) : _.splice(O, 1, S), we(w) && Fp(w, p, O, f - 1);
    }
    return S;
  }
  mergeWithSibling(t) {
    const n = t === this.getPreviousSibling();
    n || t === this.getNextSibling() || _e(50);
    const r = this.__key, i = t.__key, o = this.__text, a = o.length;
    _a() === i && Un(r);
    const s = ke();
    if (we(s)) {
      const d = s.anchor, p = s.focus;
      d !== null && d.key === i && (LC(d, n, r, t, a), s.dirty = !0), p !== null && p.key === i && (LC(p, n, r, t, a), s.dirty = !0);
    }
    const l = t.__text, c = n ? l + o : o + l;
    this.setTextContent(c);
    const f = this.getWritable();
    return t.remove(), f;
  }
  isTextEntity() {
    return !1;
  }
}
function XZ(e) {
  return { forChild: g_(e.style), node: null };
}
function ZZ(e) {
  const t = e, n = t.style.fontWeight === "normal";
  return { forChild: g_(t.style, n ? void 0 : "bold"), node: null };
}
const EC = /* @__PURE__ */ new WeakMap();
function JZ(e) {
  return e.nodeName === "PRE" || e.nodeType === hd && e.style !== void 0 && e.style.whiteSpace !== void 0 && e.style.whiteSpace.startsWith("pre");
}
function QZ(e) {
  const t = e;
  e.parentElement === null && _e(129);
  let n = t.textContent || "";
  if (function(r) {
    let i, o = r.parentNode;
    const a = [r];
    for (; o !== null && (i = EC.get(o)) === void 0 && !JZ(o); ) a.push(o), o = o.parentNode;
    const s = i === void 0 ? o : i;
    for (let l = 0; l < a.length; l++) EC.set(a[l], s);
    return s;
  }(t) !== null) {
    const r = n.split(/(\r?\n|\t)/), i = [], o = r.length;
    for (let a = 0; a < o; a++) {
      const s = r[a];
      s === `
` || s === `\r
` ? i.push(Sf()) : s === "	" ? i.push(y_()) : s !== "" && i.push(Wn(s));
    }
    return { node: i };
  }
  if (n = n.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), n === "") return { node: null };
  if (n[0] === " ") {
    let r = t, i = !0;
    for (; r !== null && (r = kC(r, !1)) !== null; ) {
      const o = r.textContent || "";
      if (o.length > 0) {
        /[ \t\n]$/.test(o) && (n = n.slice(1)), i = !1;
        break;
      }
    }
    i && (n = n.slice(1));
  }
  if (n[n.length - 1] === " ") {
    let r = t, i = !0;
    for (; r !== null && (r = kC(r, !0)) !== null; )
      if ((r.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
        i = !1;
        break;
      }
    i && (n = n.slice(0, n.length - 1));
  }
  return n === "" ? { node: null } : { node: Wn(n) };
}
function kC(e, t) {
  let n = e;
  for (; ; ) {
    let r;
    for (; (r = t ? n.nextSibling : n.previousSibling) === null; ) {
      const o = n.parentElement;
      if (o === null) return null;
      n = o;
    }
    if (n = r, n.nodeType === hd) {
      const o = n.style.display;
      if (o === "" && !zZ(n) || o !== "" && !o.startsWith("inline")) return null;
    }
    let i = n;
    for (; (i = t ? n.firstChild : n.lastChild) !== null; ) n = i;
    if (n.nodeType === Ua) return n;
    if (n.nodeName === "BR") return null;
  }
}
const eJ = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
function pa(e) {
  const t = eJ[e.nodeName.toLowerCase()];
  return t === void 0 ? { node: null } : { forChild: g_(e.style, t), node: null };
}
function Wn(e = "") {
  return Mg(new Ic(e));
}
function Se(e) {
  return e instanceof Ic;
}
function g_(e, t) {
  const n = e.fontWeight, r = e.textDecoration.split(" "), i = n === "700" || n === "bold", o = r.includes("line-through"), a = e.fontStyle === "italic", s = r.includes("underline"), l = e.verticalAlign;
  return (c) => (Se(c) && (i && !c.hasFormat("bold") && c.toggleFormat("bold"), o && !c.hasFormat("strikethrough") && c.toggleFormat("strikethrough"), a && !c.hasFormat("italic") && c.toggleFormat("italic"), s && !c.hasFormat("underline") && c.toggleFormat("underline"), l !== "sub" || c.hasFormat("subscript") || c.toggleFormat("subscript"), l !== "super" || c.hasFormat("superscript") || c.toggleFormat("superscript"), t && !c.hasFormat(t) && c.toggleFormat(t)), c);
}
class gd extends Ic {
  static getType() {
    return "tab";
  }
  static clone(t) {
    return new gd(t.__key);
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__text = t.__text;
  }
  constructor(t) {
    super("	", t), this.__detail = 2;
  }
  static importDOM() {
    return null;
  }
  static importJSON(t) {
    const n = y_();
    return n.setFormat(t.format), n.setStyle(t.style), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "tab", version: 1 };
  }
  setTextContent(t) {
    _e(126);
  }
  setDetail(t) {
    _e(127);
  }
  setMode(t) {
    _e(128);
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
}
function y_() {
  return Mg(new gd());
}
function tJ(e) {
  return e instanceof gd;
}
class nJ {
  constructor(t, n, r) {
    this._selection = null, this.key = t, this.offset = n, this.type = r;
  }
  is(t) {
    return this.key === t.key && this.offset === t.offset && this.type === t.type;
  }
  isBefore(t) {
    let n = this.getNode(), r = t.getNode();
    const i = this.offset, o = t.offset;
    if (ye(n)) {
      const a = n.getDescendantByIndex(i);
      n = a ?? n;
    }
    if (ye(r)) {
      const a = r.getDescendantByIndex(o);
      r = a ?? r;
    }
    return n === r ? i < o : n.isBefore(r);
  }
  getNode() {
    const t = Mn(this.key);
    return t === null && _e(20), t;
  }
  set(t, n, r) {
    const i = this._selection, o = this.key;
    this.key = t, this.offset = n, this.type = r, yd() || (_a() === o && Un(t), i !== null && (i.setCachedNodes(null), i.dirty = !0));
  }
}
function Fa(e, t, n) {
  return new nJ(e, t, n);
}
function vb(e, t) {
  let n = t.__key, r = e.offset, i = "element";
  if (Se(t)) {
    i = "text";
    const o = t.getTextContentSize();
    r > o && (r = o);
  } else if (!ye(t)) {
    const o = t.getNextSibling();
    if (Se(o)) n = o.__key, r = 0, i = "text";
    else {
      const a = t.getParent();
      a && (n = a.__key, r = t.getIndexWithinParent() + 1);
    }
  }
  e.set(n, r, i);
}
function MC(e, t) {
  if (ye(t)) {
    const n = t.getLastDescendant();
    ye(n) || Se(n) ? vb(e, n) : vb(e, t);
  } else vb(e, t);
}
function ba(e, t, n, r) {
  e.key = t, e.offset = n, e.type = r;
}
let d2 = class h2 {
  constructor(t) {
    this._cachedNodes = null, this._nodes = t, this.dirty = !1;
  }
  getCachedNodes() {
    return this._cachedNodes;
  }
  setCachedNodes(t) {
    this._cachedNodes = t;
  }
  is(t) {
    if (!Dg(t)) return !1;
    const n = this._nodes, r = t._nodes;
    return n.size === r.size && Array.from(n).every((i) => r.has(i));
  }
  isCollapsed() {
    return !1;
  }
  isBackward() {
    return !1;
  }
  getStartEndPoints() {
    return null;
  }
  add(t) {
    this.dirty = !0, this._nodes.add(t), this._cachedNodes = null;
  }
  delete(t) {
    this.dirty = !0, this._nodes.delete(t), this._cachedNodes = null;
  }
  clear() {
    this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
  }
  has(t) {
    return this._nodes.has(t);
  }
  clone() {
    return new h2(new Set(this._nodes));
  }
  extract() {
    return this.getNodes();
  }
  insertRawText(t) {
  }
  insertText() {
  }
  insertNodes(t) {
    const n = this.getNodes(), r = n.length, i = n[r - 1];
    let o;
    if (Se(i)) o = i.select();
    else {
      const a = i.getIndexWithinParent() + 1;
      o = i.getParentOrThrow().select(a, a);
    }
    o.insertNodes(t);
    for (let a = 0; a < r; a++) n[a].remove();
  }
  getNodes() {
    const t = this._cachedNodes;
    if (t !== null) return t;
    const n = this._nodes, r = [];
    for (const i of n) {
      const o = Mn(i);
      o !== null && r.push(o);
    }
    return yd() || (this._cachedNodes = r), r;
  }
  getTextContent() {
    const t = this.getNodes();
    let n = "";
    for (let r = 0; r < t.length; r++) n += t[r].getTextContent();
    return n;
  }
};
function we(e) {
  return e instanceof Gs;
}
class Gs {
  constructor(t, n, r, i) {
    this.anchor = t, this.focus = n, t._selection = this, n._selection = this, this._cachedNodes = null, this.format = r, this.style = i, this.dirty = !1;
  }
  getCachedNodes() {
    return this._cachedNodes;
  }
  setCachedNodes(t) {
    this._cachedNodes = t;
  }
  is(t) {
    return !!we(t) && this.anchor.is(t.anchor) && this.focus.is(t.focus) && this.format === t.format && this.style === t.style;
  }
  isCollapsed() {
    return this.anchor.is(this.focus);
  }
  getNodes() {
    const t = this._cachedNodes;
    if (t !== null) return t;
    const n = this.anchor, r = this.focus, i = n.isBefore(r), o = i ? n : r, a = i ? r : n;
    let s = o.getNode(), l = a.getNode();
    const c = o.offset, f = a.offset;
    if (ye(s)) {
      const p = s.getDescendantByIndex(c);
      s = p ?? s;
    }
    if (ye(l)) {
      let p = l.getDescendantByIndex(f);
      p !== null && p !== s && l.getChildAtIndex(f) === p && (p = p.getPreviousSibling()), l = p ?? l;
    }
    let d;
    return d = s.is(l) ? ye(s) && s.getChildrenSize() > 0 ? [] : [s] : s.getNodesBetween(l), yd() || (this._cachedNodes = d), d;
  }
  setTextNodeRange(t, n, r, i) {
    ba(this.anchor, t.__key, n, "text"), ba(this.focus, r.__key, i, "text"), this._cachedNodes = null, this.dirty = !0;
  }
  getTextContent() {
    const t = this.getNodes();
    if (t.length === 0) return "";
    const n = t[0], r = t[t.length - 1], i = this.anchor, o = this.focus, a = i.isBefore(o), [s, l] = Q0(this);
    let c = "", f = !0;
    for (let d = 0; d < t.length; d++) {
      const p = t[d];
      if (ye(p) && !p.isInline()) f || (c += `
`), f = !p.isEmpty();
      else if (f = !1, Se(p)) {
        let m = p.getTextContent();
        p === n ? p === r ? i.type === "element" && o.type === "element" && o.offset !== i.offset || (m = s < l ? m.slice(s, l) : m.slice(l, s)) : m = a ? m.slice(s) : m.slice(l) : p === r && (m = a ? m.slice(0, l) : m.slice(0, s)), c += m;
      } else !Kt(p) && !Xu(p) || p === r && this.isCollapsed() || (c += p.getTextContent());
    }
    return c;
  }
  applyDOMRange(t) {
    const n = pn(), r = n.getEditorState()._selection, i = m2(t.startContainer, t.startOffset, t.endContainer, t.endOffset, n, r);
    if (i === null) return;
    const [o, a] = i;
    ba(this.anchor, o.key, o.offset, o.type), ba(this.focus, a.key, a.offset, a.type), this._cachedNodes = null;
  }
  clone() {
    const t = this.anchor, n = this.focus;
    return new Gs(Fa(t.key, t.offset, t.type), Fa(n.key, n.offset, n.type), this.format, this.style);
  }
  toggleFormat(t) {
    this.format = B0(this.format, t, null), this.dirty = !0;
  }
  setStyle(t) {
    this.style = t, this.dirty = !0;
  }
  hasFormat(t) {
    const n = $o[t];
    return !!(this.format & n);
  }
  insertRawText(t) {
    const n = t.split(/(\r?\n|\t)/), r = [], i = n.length;
    for (let o = 0; o < i; o++) {
      const a = n[o];
      a === `
` || a === `\r
` ? r.push(Sf()) : a === "	" ? r.push(y_()) : r.push(Wn(a));
    }
    this.insertNodes(r);
  }
  insertText(t) {
    const n = this.anchor, r = this.focus, i = this.format, o = this.style;
    let a = n, s = r;
    !this.isCollapsed() && r.isBefore(n) && (a = r, s = n), a.type === "element" && function(y, x, w, S) {
      const A = y.getNode(), _ = A.getChildAtIndex(y.offset), O = Wn(), T = cr(A) ? Do().append(O) : O;
      O.setFormat(w), O.setStyle(S), _ === null ? A.append(T) : _.insertBefore(T), y.is(x) && x.set(O.__key, 0, "text"), y.set(O.__key, 0, "text");
    }(a, s, i, o);
    const l = a.offset;
    let c = s.offset;
    const f = this.getNodes(), d = f.length;
    let p = f[0];
    Se(p) || _e(26);
    const m = p.getTextContent().length, g = p.getParentOrThrow();
    let v = f[d - 1];
    if (d === 1 && s.type === "element" && (c = m, s.set(a.key, c, "text")), this.isCollapsed() && l === m && (p.isSegmented() || p.isToken() || !p.canInsertTextAfter() || !g.canInsertTextAfter() && p.getNextSibling() === null)) {
      let y = p.getNextSibling();
      if (Se(y) && y.canInsertTextBefore() && !Al(y) || (y = Wn(), y.setFormat(i), y.setStyle(o), g.canInsertTextAfter() ? p.insertAfter(y) : g.insertAfter(y)), y.select(0, 0), p = y, t !== "") return void this.insertText(t);
    } else if (this.isCollapsed() && l === 0 && (p.isSegmented() || p.isToken() || !p.canInsertTextBefore() || !g.canInsertTextBefore() && p.getPreviousSibling() === null)) {
      let y = p.getPreviousSibling();
      if (Se(y) && !Al(y) || (y = Wn(), y.setFormat(i), g.canInsertTextBefore() ? p.insertBefore(y) : g.insertBefore(y)), y.select(), p = y, t !== "") return void this.insertText(t);
    } else if (p.isSegmented() && l !== m) {
      const y = Wn(p.getTextContent());
      y.setFormat(i), p.replace(y), p = y;
    } else if (!this.isCollapsed() && t !== "") {
      const y = v.getParent();
      if (!g.canInsertTextBefore() || !g.canInsertTextAfter() || ye(y) && (!y.canInsertTextBefore() || !y.canInsertTextAfter())) return this.insertText(""), p2(this.anchor, this.focus, null), void this.insertText(t);
    }
    if (d === 1) {
      if (p.isToken()) {
        const S = Wn(t);
        return S.select(), void p.replace(S);
      }
      const y = p.getFormat(), x = p.getStyle();
      if (l !== c || y === i && x === o) {
        if (tJ(p)) {
          const S = Wn(t);
          return S.setFormat(i), S.setStyle(o), S.select(), void p.replace(S);
        }
      } else {
        if (p.getTextContent() !== "") {
          const S = Wn(t);
          if (S.setFormat(i), S.setStyle(o), S.select(), l === 0) p.insertBefore(S, !1);
          else {
            const [A] = p.splitText(l);
            A.insertAfter(S, !1);
          }
          return void (S.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length));
        }
        p.setFormat(i), p.setStyle(o);
      }
      const w = c - l;
      p = p.spliceText(l, w, t, !0), p.getTextContent() === "" ? p.remove() : this.anchor.type === "text" && (p.isComposing() ? this.anchor.offset -= t.length : (this.format = y, this.style = x));
    } else {
      const y = /* @__PURE__ */ new Set([...p.getParentKeys(), ...v.getParentKeys()]), x = ye(p) ? p : p.getParentOrThrow();
      let w = ye(v) ? v : v.getParentOrThrow(), S = v;
      if (!x.is(w) && w.isInline()) do
        S = w, w = w.getParentOrThrow();
      while (w.isInline());
      if (s.type === "text" && (c !== 0 || v.getTextContent() === "") || s.type === "element" && v.getIndexWithinParent() < c) if (Se(v) && !v.isToken() && c !== v.getTextContentSize()) {
        if (v.isSegmented()) {
          const C = Wn(v.getTextContent());
          v.replace(C), v = C;
        }
        cr(s.getNode()) || s.type !== "text" || (v = v.spliceText(0, c, "")), y.add(v.__key);
      } else {
        const C = v.getParentOrThrow();
        C.canBeEmpty() || C.getChildrenSize() !== 1 ? v.remove() : C.remove();
      }
      else y.add(v.__key);
      const A = w.getChildren(), _ = new Set(f), O = x.is(w), T = x.isInline() && p.getNextSibling() === null ? x : p;
      for (let C = A.length - 1; C >= 0; C--) {
        const k = A[C];
        if (k.is(p) || ye(k) && k.isParentOf(p)) break;
        k.isAttached() && (!_.has(k) || k.is(S) ? O || T.insertAfter(k, !1) : k.remove());
      }
      if (!O) {
        let C = w, k = null;
        for (; C !== null; ) {
          const D = C.getChildren(), N = D.length;
          (N === 0 || D[N - 1].is(k)) && (y.delete(C.__key), k = C), C = C.getParent();
        }
      }
      if (p.isToken()) if (l === m) p.select();
      else {
        const C = Wn(t);
        C.select(), p.replace(C);
      }
      else p = p.spliceText(l, m - l, t, !0), p.getTextContent() === "" ? p.remove() : p.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length);
      for (let C = 1; C < d; C++) {
        const k = f[C], D = k.__key;
        y.has(D) || k.remove();
      }
    }
  }
  removeText() {
    this.insertText("");
  }
  formatText(t) {
    if (this.isCollapsed()) return this.toggleFormat(t), void Un(null);
    const n = this.getNodes(), r = [];
    for (const w of n) Se(w) && r.push(w);
    const i = r.length;
    if (i === 0) return this.toggleFormat(t), void Un(null);
    const o = this.anchor, a = this.focus, s = this.isBackward(), l = s ? a : o, c = s ? o : a;
    let f = 0, d = r[0], p = l.type === "element" ? 0 : l.offset;
    if (l.type === "text" && p === d.getTextContentSize() && (f = 1, d = r[1], p = 0), d == null) return;
    const m = d.getFormatFlags(t, null), g = i - 1;
    let v = r[g];
    const y = c.type === "text" ? c.offset : v.getTextContentSize();
    if (d.is(v)) {
      if (p === y) return;
      if (Al(d) || p === 0 && y === d.getTextContentSize()) d.setFormat(m);
      else {
        const w = d.splitText(p, y), S = p === 0 ? w[0] : w[1];
        S.setFormat(m), l.type === "text" && l.set(S.__key, 0, "text"), c.type === "text" && c.set(S.__key, y - p, "text");
      }
      return void (this.format = m);
    }
    p === 0 || Al(d) || ([, d] = d.splitText(p), p = 0), d.setFormat(m);
    const x = v.getFormatFlags(t, m);
    y > 0 && (y === v.getTextContentSize() || Al(v) || ([v] = v.splitText(y)), v.setFormat(x));
    for (let w = f + 1; w < g; w++) {
      const S = r[w], A = S.getFormatFlags(t, x);
      S.setFormat(A);
    }
    l.type === "text" && l.set(d.__key, p, "text"), c.type === "text" && c.set(v.__key, y, "text"), this.format = m | x;
  }
  insertNodes(t) {
    if (t.length === 0) return;
    if (this.anchor.key === "root") {
      this.insertParagraph();
      const m = ke();
      return we(m) || _e(134), m.insertNodes(t);
    }
    const n = hb((this.isBackward() ? this.focus : this.anchor).getNode(), Pl), r = t[t.length - 1];
    if ("__language" in n && ye(n)) {
      if ("__language" in t[0]) this.insertText(t[0].getTextContent());
      else {
        const m = bb(this);
        n.splice(m, 0, t), r.selectEnd();
      }
      return;
    }
    if (!t.some((m) => (ye(m) || Kt(m)) && !m.isInline())) {
      ye(n) || _e(135);
      const m = bb(this);
      return n.splice(m, 0, t), void r.selectEnd();
    }
    const i = function(m) {
      const g = Do();
      let v = null;
      for (let y = 0; y < m.length; y++) {
        const x = m[y], w = Xu(x);
        if (w || Kt(x) && x.isInline() || ye(x) && x.isInline() || Se(x) || x.isParentRequired()) {
          if (v === null && (v = x.createParentElementNode(), g.append(v), w)) continue;
          v !== null && v.append(x);
        } else g.append(x), v = null;
      }
      return g;
    }(t), o = i.getLastDescendant(), a = i.getChildren(), s = !ye(n) || !n.isEmpty() ? this.insertParagraph() : null, l = a[a.length - 1];
    let c = a[0];
    var f;
    ye(f = c) && Pl(f) && !f.isEmpty() && ye(n) && (!n.isEmpty() || n.canMergeWhenEmpty()) && (ye(n) || _e(135), n.append(...c.getChildren()), c = a[1]), c && function(m, g, v) {
      const y = g.getParentOrThrow().getLastChild();
      let x = g;
      const w = [g];
      for (; x !== y; ) x.getNextSibling() || _e(140), x = x.getNextSibling(), w.push(x);
      let S = m;
      for (const A of w) S = S.insertAfter(A);
    }(n, c);
    const d = hb(o, Pl);
    s && ye(d) && (s.canMergeWhenEmpty() || Pl(l)) && (d.append(...s.getChildren()), s.remove()), ye(n) && n.isEmpty() && n.remove(), o.selectEnd();
    const p = ye(n) ? n.getLastChild() : null;
    Xu(p) && d !== n && p.remove();
  }
  insertParagraph() {
    if (this.anchor.key === "root") {
      const a = Do();
      return rr().splice(this.anchor.offset, 0, [a]), a.select(), a;
    }
    const t = bb(this), n = hb(this.anchor.getNode(), Pl);
    ye(n) || _e(136);
    const r = n.getChildAtIndex(t), i = r ? [r, ...r.getNextSiblings()] : [], o = n.insertNewAfter(this, !1);
    return o ? (o.append(...i), o.selectStart(), o) : null;
  }
  insertLineBreak(t) {
    const n = Sf();
    if (this.insertNodes([n]), t) {
      const r = n.getParentOrThrow(), i = n.getIndexWithinParent();
      r.select(i, i);
    }
  }
  extract() {
    const t = this.getNodes(), n = t.length, r = n - 1, i = this.anchor, o = this.focus;
    let a = t[0], s = t[r];
    const [l, c] = Q0(this);
    if (n === 0) return [];
    if (n === 1) {
      if (Se(a) && !this.isCollapsed()) {
        const d = l > c ? c : l, p = l > c ? l : c, m = a.splitText(d, p), g = d === 0 ? m[0] : m[1];
        return g != null ? [g] : [];
      }
      return [a];
    }
    const f = i.isBefore(o);
    if (Se(a)) {
      const d = f ? l : c;
      d === a.getTextContentSize() ? t.shift() : d !== 0 && ([, a] = a.splitText(d), t[0] = a);
    }
    if (Se(s)) {
      const d = s.getTextContent().length, p = f ? c : l;
      p === 0 ? t.pop() : p !== d && ([s] = s.splitText(p), t[r] = s);
    }
    return t;
  }
  modify(t, n, r) {
    const i = this.focus, o = this.anchor, a = t === "move", s = F0(i, n);
    if (Kt(s) && !s.isIsolated()) {
      if (a && s.isKeyboardSelectable()) {
        const m = RC();
        return m.add(s.__key), void Wo(m);
      }
      const p = n ? s.getPreviousSibling() : s.getNextSibling();
      if (Se(p)) {
        const m = p.__key, g = n ? p.getTextContent().length : 0;
        return i.set(m, g, "text"), void (a && o.set(m, g, "text"));
      }
      {
        const m = s.getParentOrThrow();
        let g, v;
        return ye(p) ? (v = p.__key, g = n ? p.getChildrenSize() : 0) : (g = s.getIndexWithinParent(), v = m.__key, n || g++), i.set(v, g, "element"), void (a && o.set(v, g, "element"));
      }
    }
    const l = pn(), c = eo(l._window);
    if (!c) return;
    const f = l._blockCursorElement, d = l._rootElement;
    if (d === null || f === null || !ye(s) || s.isInline() || s.canBeEmpty() || p_(f, l, d), function(p, m, g, v) {
      p.modify(m, g, v);
    }(c, t, n ? "backward" : "forward", r), c.rangeCount > 0) {
      const p = c.getRangeAt(0), m = this.anchor.getNode(), g = cr(m) ? m : FZ(m);
      if (this.applyDOMRange(p), this.dirty = !0, !a) {
        const v = this.getNodes(), y = [];
        let x = !1;
        for (let w = 0; w < v.length; w++) {
          const S = v[w];
          W0(S, g) ? y.push(S) : x = !0;
        }
        if (x && y.length > 0) if (n) {
          const w = y[0];
          ye(w) ? w.selectStart() : w.getParentOrThrow().selectStart();
        } else {
          const w = y[y.length - 1];
          ye(w) ? w.selectEnd() : w.getParentOrThrow().selectEnd();
        }
        c.anchorNode === p.startContainer && c.anchorOffset === p.startOffset || function(w) {
          const S = w.focus, A = w.anchor, _ = A.key, O = A.offset, T = A.type;
          ba(A, S.key, S.offset, S.type), ba(S, _, O, T), w._cachedNodes = null;
        }(this);
      }
    }
  }
  forwardDeletion(t, n, r) {
    if (!r && (t.type === "element" && ye(n) && t.offset === n.getChildrenSize() || t.type === "text" && t.offset === n.getTextContentSize())) {
      const i = n.getParent(), o = n.getNextSibling() || (i === null ? null : i.getNextSibling());
      if (ye(o) && o.isShadowRoot()) return !0;
    }
    return !1;
  }
  deleteCharacter(t) {
    const n = this.isCollapsed();
    if (this.isCollapsed()) {
      const r = this.anchor;
      let i = r.getNode();
      if (this.forwardDeletion(r, i, t)) return;
      const o = this.focus, a = F0(o, t);
      if (Kt(a) && !a.isIsolated()) {
        if (a.isKeyboardSelectable() && ye(i) && i.getChildrenSize() === 0) {
          i.remove();
          const s = RC();
          s.add(a.__key), Wo(s);
        } else
          a.remove(), pn().dispatchCommand(U1, void 0);
        return;
      }
      if (!t && ye(a) && ye(i) && i.isEmpty()) return i.remove(), void a.selectStart();
      if (this.modify("extend", t, "character"), this.isCollapsed()) {
        if (t && r.offset === 0 && (r.type === "element" ? r.getNode() : r.getNode().getParentOrThrow()).collapseAtStart(this))
          return;
      } else {
        const s = o.type === "text" ? o.getNode() : null;
        if (i = r.type === "text" ? r.getNode() : null, s !== null && s.isSegmented()) {
          const l = o.offset, c = s.getTextContentSize();
          if (s.is(i) || t && l !== c || !t && l !== 0) return void $C(s, t, l);
        } else if (i !== null && i.isSegmented()) {
          const l = r.offset, c = i.getTextContentSize();
          if (i.is(s) || t && l !== 0 || !t && l !== c) return void $C(i, t, l);
        }
        (function(l, c) {
          const f = l.anchor, d = l.focus, p = f.getNode(), m = d.getNode();
          if (p === m && f.type === "text" && d.type === "text") {
            const g = f.offset, v = d.offset, y = g < v, x = y ? g : v, w = y ? v : g, S = w - 1;
            x !== S && (KR(p.getTextContent().slice(x, w)) || (c ? d.offset = S : f.offset = S));
          }
        })(this, t);
      }
    }
    if (this.removeText(), t && !n && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0) {
      const r = this.anchor.getNode();
      r.isEmpty() && cr(r.getParent()) && r.getIndexWithinParent() === 0 && r.collapseAtStart(this);
    }
  }
  deleteLine(t) {
    if (this.isCollapsed()) {
      const n = this.anchor.type === "element";
      if (n && this.insertText(" "), this.modify("extend", t, "lineboundary"), (t ? this.focus : this.anchor).offset === 0 && this.modify("extend", t, "character"), n) {
        const r = t ? this.anchor : this.focus;
        r.set(r.key, r.offset + 1, r.type);
      }
    }
    this.removeText();
  }
  deleteWord(t) {
    if (this.isCollapsed()) {
      const n = this.anchor, r = n.getNode();
      if (this.forwardDeletion(n, r, t)) return;
      this.modify("extend", t, "word");
    }
    this.removeText();
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  getStartEndPoints() {
    return [this.anchor, this.focus];
  }
}
function Dg(e) {
  return e instanceof d2;
}
function NC(e) {
  const t = e.offset;
  if (e.type === "text") return t;
  const n = e.getNode();
  return t === n.getChildrenSize() ? n.getTextContent().length : 0;
}
function Q0(e) {
  const t = e.getStartEndPoints();
  if (t === null) return [0, 0];
  const [n, r] = t;
  return n.type === "element" && r.type === "element" && n.key === r.key && n.offset === r.offset ? [0, 0] : [NC(n), NC(r)];
}
function $C(e, t, n) {
  const r = e, i = r.getTextContent().split(/(?=\s)/g), o = i.length;
  let a = 0, s = 0;
  for (let c = 0; c < o; c++) {
    const f = c === o - 1;
    if (s = a, a += i[c].length, t && a === n || a > n || f) {
      i.splice(c, 1), f && (s = void 0);
      break;
    }
  }
  const l = i.join("").trim();
  l === "" ? r.remove() : (r.setTextContent(l), r.select(s, s));
}
function DC(e, t, n, r) {
  let i, o = t;
  if (e.nodeType === hd) {
    let a = !1;
    const s = e.childNodes, l = s.length, c = r._blockCursorElement;
    o === l && (a = !0, o = l - 1);
    let f = s[o], d = !1;
    if (f === c) f = s[o + 1], d = !0;
    else if (c !== null) {
      const p = c.parentNode;
      e === p && t > Array.prototype.indexOf.call(p.children, c) && o--;
    }
    if (i = Dl(f), Se(i)) o = mC(i, a);
    else {
      let p = Dl(e);
      if (p === null) return null;
      if (ye(p)) {
        o = Math.min(p.getChildrenSize(), o);
        let m = p.getChildAtIndex(o);
        if (ye(m) && function(g, v, y) {
          const x = g.getParent();
          return y === null || x === null || !x.canBeEmpty() || x !== y.getNode();
        }(m, 0, n)) {
          const g = a ? m.getLastDescendant() : m.getFirstDescendant();
          g === null ? p = m : (m = g, p = ye(m) ? m : m.getParentOrThrow()), o = 0;
        }
        Se(m) ? (i = m, p = null, o = mC(m, a)) : m !== p && a && !d && o++;
      } else {
        const m = p.getIndexWithinParent();
        o = t === 0 && Kt(p) && Dl(e) === p ? m : m + 1, p = p.getParentOrThrow();
      }
      if (ye(p)) return Fa(p.__key, o, "element");
    }
  } else i = Dl(e);
  return Se(i) ? Fa(i.__key, o, "text") : null;
}
function IC(e, t, n) {
  const r = e.offset, i = e.getNode();
  if (r === 0) {
    const o = i.getPreviousSibling(), a = i.getParent();
    if (t) {
      if ((n || !t) && o === null && ye(a) && a.isInline()) {
        const s = a.getPreviousSibling();
        Se(s) && (e.key = s.__key, e.offset = s.getTextContent().length);
      }
    } else ye(o) && !n && o.isInline() ? (e.key = o.__key, e.offset = o.getChildrenSize(), e.type = "element") : Se(o) && (e.key = o.__key, e.offset = o.getTextContent().length);
  } else if (r === i.getTextContent().length) {
    const o = i.getNextSibling(), a = i.getParent();
    if (t && ye(o) && o.isInline()) e.key = o.__key, e.offset = 0, e.type = "element";
    else if ((n || t) && o === null && ye(a) && a.isInline() && !a.canInsertTextAfter()) {
      const s = a.getNextSibling();
      Se(s) && (e.key = s.__key, e.offset = 0);
    }
  }
}
function p2(e, t, n) {
  if (e.type === "text" && t.type === "text") {
    const r = e.isBefore(t), i = e.is(t);
    IC(e, r, i), IC(t, !r, i), i && (t.key = e.key, t.offset = e.offset, t.type = e.type);
    const o = pn();
    if (o.isComposing() && o._compositionKey !== e.key && we(n)) {
      const a = n.anchor, s = n.focus;
      ba(e, a.key, a.offset, a.type), ba(t, s.key, s.offset, s.type);
    }
  }
}
function m2(e, t, n, r, i, o) {
  if (e === null || n === null || !Ag(i, e, n)) return null;
  const a = DC(e, t, we(o) ? o.anchor : null, i);
  if (a === null) return null;
  const s = DC(n, r, we(o) ? o.focus : null, i);
  if (s === null) return null;
  if (a.type === "element" && s.type === "element") {
    const l = Dl(e), c = Dl(n);
    if (Kt(l) && Kt(c)) return null;
  }
  return p2(a, s, o), [a, s];
}
function g2(e, t, n, r, i, o) {
  const a = Go(), s = new Gs(Fa(e, t, i), Fa(n, r, o), 0, "");
  return s.dirty = !0, a._selection = s, s;
}
function RC() {
  return new d2(/* @__PURE__ */ new Set());
}
function v_(e, t, n, r) {
  const i = n._window;
  if (i === null) return null;
  const o = r || i.event, a = o ? o.type : void 0, s = a === "selectionchange", l = !L0 && (s || a === "beforeinput" || a === "compositionstart" || a === "compositionend" || a === "click" && o && o.detail === 3 || a === "drop" || a === void 0);
  let c, f, d, p;
  if (we(e) && !l) return e.clone();
  if (t === null) return null;
  if (c = t.anchorNode, f = t.focusNode, d = t.anchorOffset, p = t.focusOffset, s && we(e) && !Ag(n, c, f)) return e.clone();
  const m = m2(c, d, f, p, n, e);
  if (m === null) return null;
  const [g, v] = m;
  return new Gs(g, v, we(e) ? e.format : 0, we(e) ? e.style : "");
}
function ke() {
  return Go()._selection;
}
function Ig() {
  return pn()._editorState._selection;
}
function Fp(e, t, n, r = 1) {
  const i = e.anchor, o = e.focus, a = i.getNode(), s = o.getNode();
  if (!t.is(a) && !t.is(s)) return;
  const l = t.__key;
  if (e.isCollapsed()) {
    const c = i.offset;
    if (n <= c && r > 0 || n < c && r < 0) {
      const f = Math.max(0, c + r);
      i.set(l, f, "element"), o.set(l, f, "element"), jC(e);
    }
  } else {
    const c = e.isBackward(), f = c ? o : i, d = f.getNode(), p = c ? i : o, m = p.getNode();
    if (t.is(d)) {
      const g = f.offset;
      (n <= g && r > 0 || n < g && r < 0) && f.set(l, Math.max(0, g + r), "element");
    }
    if (t.is(m)) {
      const g = p.offset;
      (n <= g && r > 0 || n < g && r < 0) && p.set(l, Math.max(0, g + r), "element");
    }
  }
  jC(e);
}
function jC(e) {
  const t = e.anchor, n = t.offset, r = e.focus, i = r.offset, o = t.getNode(), a = r.getNode();
  if (e.isCollapsed()) {
    if (!ye(o)) return;
    const s = o.getChildrenSize(), l = n >= s, c = l ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n);
    if (Se(c)) {
      let f = 0;
      l && (f = c.getTextContentSize()), t.set(c.__key, f, "text"), r.set(c.__key, f, "text");
    }
  } else {
    if (ye(o)) {
      const s = o.getChildrenSize(), l = n >= s, c = l ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n);
      if (Se(c)) {
        let f = 0;
        l && (f = c.getTextContentSize()), t.set(c.__key, f, "text");
      }
    }
    if (ye(a)) {
      const s = a.getChildrenSize(), l = i >= s, c = l ? a.getChildAtIndex(s - 1) : a.getChildAtIndex(i);
      if (Se(c)) {
        let f = 0;
        l && (f = c.getTextContentSize()), r.set(c.__key, f, "text");
      }
    }
  }
}
function Wp(e, t, n, r, i) {
  let o = null, a = 0, s = null;
  r !== null ? (o = r.__key, Se(r) ? (a = r.getTextContentSize(), s = "text") : ye(r) && (a = r.getChildrenSize(), s = "element")) : i !== null && (o = i.__key, Se(i) ? s = "text" : ye(i) && (s = "element")), o !== null && s !== null ? e.set(o, a, s) : (a = t.getIndexWithinParent(), a === -1 && (a = n.getChildrenSize()), e.set(n.__key, a, "element"));
}
function LC(e, t, n, r, i) {
  e.type === "text" ? (e.key = n, t || (e.offset += i)) : e.offset > r.getIndexWithinParent() && (e.offset -= 1);
}
function rJ(e, t, n, r, i, o, a) {
  const s = r.anchorNode, l = r.focusNode, c = r.anchorOffset, f = r.focusOffset, d = document.activeElement;
  if (i.has("collaboration") && d !== o || d !== null && FR(d)) return;
  if (!we(t)) return void (e !== null && Ag(n, s, l) && r.removeAllRanges());
  const p = t.anchor, m = t.focus, g = p.key, v = m.key, y = Ip(n, g), x = Ip(n, v), w = p.offset, S = m.offset, A = t.format, _ = t.style, O = t.isCollapsed();
  let T = y, C = x, k = !1;
  if (p.type === "text") {
    T = $p(y);
    const F = p.getNode();
    k = F.getFormat() !== A || F.getStyle() !== _;
  } else we(e) && e.anchor.type === "text" && (k = !0);
  var D, N, $, B, L;
  if (m.type === "text" && (C = $p(x)), T !== null && C !== null && (O && (e === null || k || we(e) && (e.format !== A || e.style !== _)) && (D = A, N = _, $ = w, B = g, L = performance.now(), o2 = [D, N, $, B, L]), c !== w || f !== S || s !== T || l !== C || r.type === "Range" && O || (d !== null && o.contains(d) || o.focus({ preventScroll: !0 }), p.type === "element"))) {
    try {
      r.setBaseAndExtent(T, w, C, S);
    } catch {
    }
    if (!i.has("skip-scroll-into-view") && t.isCollapsed() && o !== null && o === document.activeElement) {
      const F = t instanceof Gs && t.anchor.type === "element" ? T.childNodes[w] || null : r.rangeCount > 0 ? r.getRangeAt(0) : null;
      if (F !== null) {
        let W;
        if (F instanceof Text) {
          const z = document.createRange();
          z.selectNode(F), W = z.getBoundingClientRect();
        } else W = F.getBoundingClientRect();
        (function(z, G, V) {
          const U = V.ownerDocument, Y = U.defaultView;
          if (Y === null) return;
          let { top: te, bottom: ne } = G, re = 0, ue = 0, ae = V;
          for (; ae !== null; ) {
            const le = ae === U.body;
            if (le) re = 0, ue = kg(z).innerHeight;
            else {
              const Q = ae.getBoundingClientRect();
              re = Q.top, ue = Q.bottom;
            }
            let ie = 0;
            if (te < re ? ie = -(re - te) : ne > ue && (ie = ne - ue), ie !== 0) if (le) Y.scrollBy(0, ie);
            else {
              const Q = ae.scrollTop;
              ae.scrollTop += ie;
              const fe = ae.scrollTop - Q;
              te -= fe, ne -= fe;
            }
            if (le) break;
            ae = Eg(ae);
          }
        })(n, W, o);
      }
    }
    X0 = !0;
  }
}
function bb(e) {
  let t = e;
  e.isCollapsed() || t.removeText();
  const n = ke();
  we(n) && (t = n), we(t) || _e(161);
  const r = t.anchor;
  let i = r.getNode(), o = r.offset;
  for (; !Pl(i); ) [i, o] = iJ(i, o);
  return o;
}
function iJ(e, t) {
  const n = e.getParent();
  if (!n) {
    const i = Do();
    return rr().append(i), i.select(), [rr(), 0];
  }
  if (Se(e)) {
    const i = e.splitText(t);
    if (i.length === 0) return [n, e.getIndexWithinParent()];
    const o = t === 0 ? 0 : 1;
    return [n, i[0].getIndexWithinParent() + o];
  }
  if (!ye(e) || t === 0) return [n, e.getIndexWithinParent()];
  const r = e.getChildAtIndex(t);
  if (r) {
    const i = new Gs(Fa(e.__key, t, "element"), Fa(e.__key, t, "element"), 0, ""), o = e.insertNewAfter(i);
    o && o.append(r, ...r.getNextSiblings());
  }
  return [n, e.getIndexWithinParent() + 1];
}
let Nn = null, $n = null, Or = !1, xb = !1, lp = 0;
const BC = { characterData: !0, childList: !0, subtree: !0 };
function yd() {
  return Or || Nn !== null && Nn._readOnly;
}
function xr() {
  Or && _e(13);
}
function y2() {
  lp > 99 && _e(14);
}
function Go() {
  return Nn === null && _e(195, v2()), Nn;
}
function pn() {
  return $n === null && _e(196, v2()), $n;
}
function v2() {
  let e = 0;
  const t = /* @__PURE__ */ new Set(), n = Lg.version;
  if (typeof window < "u") for (const i of document.querySelectorAll("[contenteditable]")) {
    const o = Pg(i);
    if (c_(o)) e++;
    else if (o) {
      let a = String(o.constructor.version || "<0.17.1");
      a === n && (a += " (separately built, likely a bundler configuration issue)"), t.add(a);
    }
  }
  let r = ` Detected on the page: ${e} compatible editor(s) with version ${n}`;
  return t.size && (r += ` and incompatible editors with versions ${Array.from(t).join(", ")}`), r;
}
function oJ() {
  return $n;
}
function FC(e, t, n) {
  const r = t.__type, i = function(s, l) {
    const c = s._nodes.get(l);
    return c === void 0 && _e(30, l), c;
  }(e, r);
  let o = n.get(r);
  o === void 0 && (o = Array.from(i.transforms), n.set(r, o));
  const a = o.length;
  for (let s = 0; s < a && (o[s](t), t.isAttached()); s++) ;
}
function WC(e, t) {
  return e !== void 0 && e.__key !== t && e.isAttached();
}
function b2(e, t) {
  const n = e.type, r = t.get(n);
  r === void 0 && _e(17, n);
  const i = r.klass;
  e.type !== i.getType() && _e(18, i.name);
  const o = i.importJSON(e), a = e.children;
  if (ye(o) && Array.isArray(a)) for (let s = 0; s < a.length; s++) {
    const l = b2(a[s], t);
    o.append(l);
  }
  return o;
}
function zC(e, t, n) {
  const r = Nn, i = Or, o = $n;
  Nn = t, Or = !0, $n = e;
  try {
    return n();
  } finally {
    Nn = r, Or = i, $n = o;
  }
}
function Sa(e, t) {
  const n = e._pendingEditorState, r = e._rootElement, i = e._headless || r === null;
  if (n === null) return;
  const o = e._editorState, a = o._selection, s = n._selection, l = e._dirtyType !== js, c = Nn, f = Or, d = $n, p = e._updating, m = e._observer;
  let g = null;
  if (e._pendingEditorState = null, e._editorState = n, !i && l && m !== null) {
    $n = e, Nn = n, Or = !1, e._updating = !0;
    try {
      const O = e._dirtyType, T = e._dirtyElements, C = e._dirtyLeaves;
      m.disconnect(), g = GZ(o, n, e, O, T, C);
    } catch (O) {
      if (O instanceof Error && e._onError(O), xb) throw O;
      return O2(e, null, r, n), BR(e), e._dirtyType = Ql, xb = !0, Sa(e, o), void (xb = !1);
    } finally {
      m.observe(r, BC), e._updating = p, Nn = c, Or = f, $n = d;
    }
  }
  n._readOnly || (n._readOnly = !0);
  const v = e._dirtyLeaves, y = e._dirtyElements, x = e._normalizedNodes, w = e._updateTags, S = e._deferred;
  l && (e._dirtyType = js, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements = /* @__PURE__ */ new Map(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set()), function(O, T) {
    const C = O._decorators;
    let k = O._pendingDecorators || C;
    const D = T._nodeMap;
    let N;
    for (N in k) D.has(N) || (k === C && (k = VR(O)), delete k[N]);
  }(e, n);
  const A = i ? null : eo(e._window);
  if (e._editable && A !== null && (l || s === null || s.dirty)) {
    $n = e, Nn = n;
    try {
      if (m !== null && m.disconnect(), l || s === null || s.dirty) {
        const O = e._blockCursorElement;
        O !== null && p_(O, e, r), rJ(a, s, e, A, w, r);
      }
      WZ(e, r, s), m !== null && m.observe(r, BC);
    } finally {
      $n = d, Nn = c;
    }
  }
  g !== null && function(O, T, C, k, D) {
    const N = Array.from(O._listeners.mutation), $ = N.length;
    for (let B = 0; B < $; B++) {
      const [L, F] = N[B], W = T.get(F);
      W !== void 0 && L(W, { dirtyLeaves: k, prevEditorState: D, updateTags: C });
    }
  }(e, g, w, v, o), we(s) || s === null || a !== null && a.is(s) || e.dispatchCommand(U1, void 0);
  const _ = e._pendingDecorators;
  _ !== null && (e._decorators = _, e._pendingDecorators = null, Zu("decorator", e, !0, _)), function(O, T, C) {
    const k = pC(T), D = pC(C);
    k !== D && Zu("textcontent", O, !0, D);
  }(e, t || o, n), Zu("update", e, !0, { dirtyElements: y, dirtyLeaves: v, editorState: n, normalizedNodes: x, prevEditorState: t || o, tags: w }), function(O, T) {
    if (O._deferred = [], T.length !== 0) {
      const C = O._updating;
      O._updating = !0;
      try {
        for (let k = 0; k < T.length; k++) T[k]();
      } finally {
        O._updating = C;
      }
    }
  }(e, S), function(O) {
    const T = O._updates;
    if (T.length !== 0) {
      const C = T.shift();
      if (C) {
        const [k, D] = C;
        w2(O, k, D);
      }
    }
  }(e);
}
function Zu(e, t, n, ...r) {
  const i = t._updating;
  t._updating = n;
  try {
    const o = Array.from(t._listeners[e]);
    for (let a = 0; a < o.length; a++) o[a].apply(null, r);
  } finally {
    t._updating = i;
  }
}
function x2(e, t, n) {
  if (e._updating === !1 || $n !== e) {
    let i = !1;
    return e.update(() => {
      i = x2(e, t, n);
    }), i;
  }
  const r = u_(e);
  for (let i = 4; i >= 0; i--) for (let o = 0; o < r.length; o++) {
    const a = r[o]._commands.get(t);
    if (a !== void 0) {
      const s = a[i];
      if (s !== void 0) {
        const l = Array.from(s), c = l.length;
        for (let f = 0; f < c; f++) if (l[f](n, e) === !0) return !0;
      }
    }
  }
  return !1;
}
function VC(e, t) {
  const n = e._updates;
  let r = t || !1;
  for (; n.length !== 0; ) {
    const i = n.shift();
    if (i) {
      const [o, a] = i;
      let s, l;
      if (a !== void 0) {
        if (s = a.onUpdate, l = a.tag, a.skipTransforms && (r = !0), a.discrete) {
          const c = e._pendingEditorState;
          c === null && _e(191), c._flushSync = !0;
        }
        s && e._deferred.push(s), l && e._updateTags.add(l);
      }
      o();
    }
  }
  return r;
}
function w2(e, t, n) {
  const r = e._updateTags;
  let i, o, a = !1, s = !1;
  n !== void 0 && (i = n.onUpdate, o = n.tag, o != null && r.add(o), a = n.skipTransforms || !1, s = n.discrete || !1), i && e._deferred.push(i);
  const l = e._editorState;
  let c = e._pendingEditorState, f = !1;
  (c === null || c._readOnly) && (c = e._pendingEditorState = new jg(new Map((c || l)._nodeMap)), f = !0), c._flushSync = s;
  const d = Nn, p = Or, m = $n, g = e._updating;
  Nn = c, Or = !1, e._updating = !0, $n = e;
  try {
    f && (e._headless ? l._selection !== null && (c._selection = l._selection.clone()) : c._selection = function(w) {
      const S = w.getEditorState()._selection, A = eo(w._window);
      return we(S) || S == null ? v_(S, A, w, null) : S.clone();
    }(e));
    const y = e._compositionKey;
    t(), a = VC(e, a), function(w, S) {
      const A = S.getEditorState()._selection, _ = w._selection;
      if (we(_)) {
        const O = _.anchor, T = _.focus;
        let C;
        if (O.type === "text" && (C = O.getNode(), C.selectionTransform(A, _)), T.type === "text") {
          const k = T.getNode();
          C !== k && k.selectionTransform(A, _);
        }
      }
    }(c, e), e._dirtyType !== js && (a ? function(w, S) {
      const A = S._dirtyLeaves, _ = w._nodeMap;
      for (const O of A) {
        const T = _.get(O);
        Se(T) && T.isAttached() && T.isSimpleText() && !T.isUnmergeable() && dC(T);
      }
    }(c, e) : function(w, S) {
      const A = S._dirtyLeaves, _ = S._dirtyElements, O = w._nodeMap, T = _a(), C = /* @__PURE__ */ new Map();
      let k = A, D = k.size, N = _, $ = N.size;
      for (; D > 0 || $ > 0; ) {
        if (D > 0) {
          S._dirtyLeaves = /* @__PURE__ */ new Set();
          for (const B of k) {
            const L = O.get(B);
            Se(L) && L.isAttached() && L.isSimpleText() && !L.isUnmergeable() && dC(L), L !== void 0 && WC(L, T) && FC(S, L, C), A.add(B);
          }
          if (k = S._dirtyLeaves, D = k.size, D > 0) {
            lp++;
            continue;
          }
        }
        S._dirtyLeaves = /* @__PURE__ */ new Set(), S._dirtyElements = /* @__PURE__ */ new Map();
        for (const B of N) {
          const L = B[0], F = B[1];
          if (L !== "root" && !F) continue;
          const W = O.get(L);
          W !== void 0 && WC(W, T) && FC(S, W, C), _.set(L, F);
        }
        k = S._dirtyLeaves, D = k.size, N = S._dirtyElements, $ = N.size, lp++;
      }
      S._dirtyLeaves = A, S._dirtyElements = _;
    }(c, e), VC(e), function(w, S, A, _) {
      const O = w._nodeMap, T = S._nodeMap, C = [];
      for (const [k] of _) {
        const D = T.get(k);
        D !== void 0 && (D.isAttached() || (ye(D) && XR(D, k, O, T, C, _), O.has(k) || _.delete(k), C.push(k)));
      }
      for (const k of C) T.delete(k);
      for (const k of A) {
        const D = T.get(k);
        D === void 0 || D.isAttached() || (O.has(k) || A.delete(k), T.delete(k));
      }
    }(l, c, e._dirtyLeaves, e._dirtyElements)), y !== e._compositionKey && (c._flushSync = !0);
    const x = c._selection;
    if (we(x)) {
      const w = c._nodeMap, S = x.anchor.key, A = x.focus.key;
      w.get(S) !== void 0 && w.get(A) !== void 0 || _e(19);
    } else Dg(x) && x._nodes.size === 0 && (c._selection = null);
  } catch (y) {
    return y instanceof Error && e._onError(y), e._pendingEditorState = l, e._dirtyType = Ql, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), void Sa(e);
  } finally {
    Nn = d, Or = p, $n = m, e._updating = g, lp = 0;
  }
  e._dirtyType !== js || function(y, x) {
    const w = x.getEditorState()._selection, S = y._selection;
    if (S !== null) {
      if (S.dirty || !S.is(w)) return !0;
    } else if (w !== null) return !0;
    return !1;
  }(c, e) ? c._flushSync ? (c._flushSync = !1, Sa(e)) : f && IZ(() => {
    Sa(e);
  }) : (c._flushSync = !1, f && (r.clear(), e._deferred = [], e._pendingEditorState = null));
}
function Br(e, t, n) {
  e._updating ? e._updates.push([t, n]) : w2(e, t, n);
}
class Rg extends $g {
  constructor(t) {
    super(t), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__style = "", this.__indent = 0, this.__dir = null;
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__first = t.__first, this.__last = t.__last, this.__size = t.__size, this.__indent = t.__indent, this.__format = t.__format, this.__style = t.__style, this.__dir = t.__dir;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getFormatType() {
    const t = this.getFormat();
    return AZ[t] || "";
  }
  getStyle() {
    return this.getLatest().__style;
  }
  getIndent() {
    return this.getLatest().__indent;
  }
  getChildren() {
    const t = [];
    let n = this.getFirstChild();
    for (; n !== null; ) t.push(n), n = n.getNextSibling();
    return t;
  }
  getChildrenKeys() {
    const t = [];
    let n = this.getFirstChild();
    for (; n !== null; ) t.push(n.__key), n = n.getNextSibling();
    return t;
  }
  getChildrenSize() {
    return this.getLatest().__size;
  }
  isEmpty() {
    return this.getChildrenSize() === 0;
  }
  isDirty() {
    const t = pn()._dirtyElements;
    return t !== null && t.has(this.__key);
  }
  isLastChild() {
    const t = this.getLatest(), n = this.getParentOrThrow().getLastChild();
    return n !== null && n.is(t);
  }
  getAllTextNodes() {
    const t = [];
    let n = this.getFirstChild();
    for (; n !== null; ) {
      if (Se(n) && t.push(n), ye(n)) {
        const r = n.getAllTextNodes();
        t.push(...r);
      }
      n = n.getNextSibling();
    }
    return t;
  }
  getFirstDescendant() {
    let t = this.getFirstChild();
    for (; ye(t); ) {
      const n = t.getFirstChild();
      if (n === null) break;
      t = n;
    }
    return t;
  }
  getLastDescendant() {
    let t = this.getLastChild();
    for (; ye(t); ) {
      const n = t.getLastChild();
      if (n === null) break;
      t = n;
    }
    return t;
  }
  getDescendantByIndex(t) {
    const n = this.getChildren(), r = n.length;
    if (t >= r) {
      const o = n[r - 1];
      return ye(o) && o.getLastDescendant() || o || null;
    }
    const i = n[t];
    return ye(i) && i.getFirstDescendant() || i || null;
  }
  getFirstChild() {
    const t = this.getLatest().__first;
    return t === null ? null : Mn(t);
  }
  getFirstChildOrThrow() {
    const t = this.getFirstChild();
    return t === null && _e(45, this.__key), t;
  }
  getLastChild() {
    const t = this.getLatest().__last;
    return t === null ? null : Mn(t);
  }
  getLastChildOrThrow() {
    const t = this.getLastChild();
    return t === null && _e(96, this.__key), t;
  }
  getChildAtIndex(t) {
    const n = this.getChildrenSize();
    let r, i;
    if (t < n / 2) {
      for (r = this.getFirstChild(), i = 0; r !== null && i <= t; ) {
        if (i === t) return r;
        r = r.getNextSibling(), i++;
      }
      return null;
    }
    for (r = this.getLastChild(), i = n - 1; r !== null && i >= t; ) {
      if (i === t) return r;
      r = r.getPreviousSibling(), i--;
    }
    return null;
  }
  getTextContent() {
    let t = "";
    const n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      const o = n[i];
      t += o.getTextContent(), ye(o) && i !== r - 1 && !o.isInline() && (t += Fo);
    }
    return t;
  }
  getTextContentSize() {
    let t = 0;
    const n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      const o = n[i];
      t += o.getTextContentSize(), ye(o) && i !== r - 1 && !o.isInline() && (t += Fo.length);
    }
    return t;
  }
  getDirection() {
    return this.getLatest().__dir;
  }
  hasFormat(t) {
    if (t !== "") {
      const n = cC[t];
      return !!(this.getFormat() & n);
    }
    return !1;
  }
  select(t, n) {
    xr();
    const r = ke();
    let i = t, o = n;
    const a = this.getChildrenSize();
    if (!this.canBeEmpty()) {
      if (t === 0 && n === 0) {
        const l = this.getFirstChild();
        if (Se(l) || ye(l)) return l.select(0, 0);
      } else if (!(t !== void 0 && t !== a || n !== void 0 && n !== a)) {
        const l = this.getLastChild();
        if (Se(l) || ye(l)) return l.select();
      }
    }
    i === void 0 && (i = a), o === void 0 && (o = a);
    const s = this.__key;
    return we(r) ? (r.anchor.set(s, i, "element"), r.focus.set(s, o, "element"), r.dirty = !0, r) : g2(s, i, s, o, "element", "element");
  }
  selectStart() {
    const t = this.getFirstDescendant();
    return t ? t.selectStart() : this.select();
  }
  selectEnd() {
    const t = this.getLastDescendant();
    return t ? t.selectEnd() : this.select();
  }
  clear() {
    const t = this.getWritable();
    return this.getChildren().forEach((n) => n.remove()), t;
  }
  append(...t) {
    return this.splice(this.getChildrenSize(), 0, t);
  }
  setDirection(t) {
    const n = this.getWritable();
    return n.__dir = t, n;
  }
  setFormat(t) {
    return this.getWritable().__format = t !== "" ? cC[t] : 0, this;
  }
  setStyle(t) {
    return this.getWritable().__style = t || "", this;
  }
  setIndent(t) {
    return this.getWritable().__indent = t, this;
  }
  splice(t, n, r) {
    const i = r.length, o = this.getChildrenSize(), a = this.getWritable(), s = a.__key, l = [], c = [], f = this.getChildAtIndex(t + n);
    let d = null, p = o - n + i;
    if (t !== 0) if (t === o) d = this.getLastChild();
    else {
      const g = this.getChildAtIndex(t);
      g !== null && (d = g.getPreviousSibling());
    }
    if (n > 0) {
      let g = d === null ? this.getFirstChild() : d.getNextSibling();
      for (let v = 0; v < n; v++) {
        g === null && _e(100);
        const y = g.getNextSibling(), x = g.__key;
        ks(g.getWritable()), c.push(x), g = y;
      }
    }
    let m = d;
    for (let g = 0; g < i; g++) {
      const v = r[g];
      m !== null && v.is(m) && (d = m = m.getPreviousSibling());
      const y = v.getWritable();
      y.__parent === s && p--, ks(y);
      const x = v.__key;
      if (m === null) a.__first = x, y.__prev = null;
      else {
        const w = m.getWritable();
        w.__next = x, y.__prev = w.__key;
      }
      v.__key === s && _e(76), y.__parent = s, l.push(x), m = v;
    }
    if (t + n === o)
      m !== null && (m.getWritable().__next = null, a.__last = m.__key);
    else if (f !== null) {
      const g = f.getWritable();
      if (m !== null) {
        const v = m.getWritable();
        g.__prev = m.__key, v.__next = f.__key;
      } else g.__prev = null;
    }
    if (a.__size = p, c.length) {
      const g = ke();
      if (we(g)) {
        const v = new Set(c), y = new Set(l), { anchor: x, focus: w } = g;
        UC(x, v, y) && Wp(x, x.getNode(), this, d, f), UC(w, v, y) && Wp(w, w.getNode(), this, d, f), p !== 0 || this.canBeEmpty() || pd(this) || this.remove();
      }
    }
    return a;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
  }
  insertNewAfter(t, n) {
    return null;
  }
  canIndent() {
    return !0;
  }
  collapseAtStart(t) {
    return !1;
  }
  excludeFromCopy(t) {
    return !1;
  }
  canReplaceWith(t) {
    return !0;
  }
  canInsertAfter(t) {
    return !0;
  }
  canBeEmpty() {
    return !0;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  isInline() {
    return !1;
  }
  isShadowRoot() {
    return !1;
  }
  canMergeWith(t) {
    return !1;
  }
  extractWithChild(t, n, r) {
    return !1;
  }
  canMergeWhenEmpty() {
    return !1;
  }
}
function ye(e) {
  return e instanceof Rg;
}
function UC(e, t, n) {
  let r = e.getNode();
  for (; r; ) {
    const i = r.__key;
    if (t.has(i) && !n.has(i)) return !0;
    r = r.getParent();
  }
  return !1;
}
class _2 extends $g {
  constructor(t) {
    super(t);
  }
  decorate(t, n) {
    _e(47);
  }
  isIsolated() {
    return !1;
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
}
function Kt(e) {
  return e instanceof _2;
}
class vd extends Rg {
  static getType() {
    return "root";
  }
  static clone() {
    return new vd();
  }
  constructor() {
    super("root"), this.__cachedText = null;
  }
  getTopLevelElementOrThrow() {
    _e(51);
  }
  getTextContent() {
    const t = this.__cachedText;
    return !yd() && pn()._dirtyType !== js || t === null ? super.getTextContent() : t;
  }
  remove() {
    _e(52);
  }
  replace(t) {
    _e(53);
  }
  insertBefore(t) {
    _e(54);
  }
  insertAfter(t) {
    _e(55);
  }
  updateDOM(t, n) {
    return !1;
  }
  append(...t) {
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      ye(r) || Kt(r) || _e(56);
    }
    return super.append(...t);
  }
  static importJSON(t) {
    const n = rr();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
  }
  collapseAtStart() {
    return !0;
  }
}
function cr(e) {
  return e instanceof vd;
}
function b_() {
  return new jg(/* @__PURE__ */ new Map([["root", new vd()]]));
}
function S2(e) {
  const t = e.exportJSON(), n = e.constructor;
  if (t.type !== n.getType() && _e(130, n.name), ye(e)) {
    const r = t.children;
    Array.isArray(r) || _e(59, n.name);
    const i = e.getChildren();
    for (let o = 0; o < i.length; o++) {
      const a = S2(i[o]);
      r.push(a);
    }
  }
  return t;
}
class jg {
  constructor(t, n) {
    this._nodeMap = t, this._selection = n || null, this._flushSync = !1, this._readOnly = !1;
  }
  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }
  read(t, n) {
    return zC(n && n.editor || null, this, t);
  }
  clone(t) {
    const n = new jg(this._nodeMap, t === void 0 ? this._selection : t);
    return n._readOnly = !0, n;
  }
  toJSON() {
    return zC(null, this, () => ({ root: S2(rr()) }));
  }
}
class aJ extends Rg {
  static getType() {
    return "artificial";
  }
  createDOM(t) {
    return document.createElement("div");
  }
}
class Rc extends Rg {
  constructor(t) {
    super(t), this.__textFormat = 0, this.__textStyle = "";
  }
  static getType() {
    return "paragraph";
  }
  getTextFormat() {
    return this.getLatest().__textFormat;
  }
  setTextFormat(t) {
    const n = this.getWritable();
    return n.__textFormat = t, n;
  }
  hasTextFormat(t) {
    const n = $o[t];
    return !!(this.getTextFormat() & n);
  }
  getTextStyle() {
    return this.getLatest().__textStyle;
  }
  setTextStyle(t) {
    const n = this.getWritable();
    return n.__textStyle = t, n;
  }
  static clone(t) {
    return new Rc(t.__key);
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__textFormat = t.__textFormat, this.__textStyle = t.__textStyle;
  }
  createDOM(t) {
    const n = document.createElement("p"), r = Gu(t.theme, "paragraph");
    return r !== void 0 && n.classList.add(...r), n;
  }
  updateDOM(t, n, r) {
    return !1;
  }
  static importDOM() {
    return { p: (t) => ({ conversion: sJ, priority: 0 }) };
  }
  exportDOM(t) {
    const { element: n } = super.exportDOM(t);
    if (n && m_(n)) {
      this.isEmpty() && n.append(document.createElement("br"));
      const r = this.getFormatType();
      n.style.textAlign = r;
      const i = this.getDirection();
      i && (n.dir = i);
      const o = this.getIndent();
      o > 0 && (n.style.textIndent = 20 * o + "px");
    }
    return { element: n };
  }
  static importJSON(t) {
    const n = Do();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n.setTextFormat(t.textFormat), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), textFormat: this.getTextFormat(), textStyle: this.getTextStyle(), type: "paragraph", version: 1 };
  }
  insertNewAfter(t, n) {
    const r = Do();
    r.setTextFormat(t.format), r.setTextStyle(t.style);
    const i = this.getDirection();
    return r.setDirection(i), r.setFormat(this.getFormatType()), r.setStyle(this.getTextStyle()), this.insertAfter(r, n), r;
  }
  collapseAtStart() {
    const t = this.getChildren();
    if (t.length === 0 || Se(t[0]) && t[0].getTextContent().trim() === "") {
      if (this.getNextSibling() !== null) return this.selectNext(), this.remove(), !0;
      if (this.getPreviousSibling() !== null) return this.selectPrevious(), this.remove(), !0;
    }
    return !1;
  }
}
function sJ(e) {
  const t = Do();
  if (e.style) {
    t.setFormat(e.style.textAlign);
    const n = parseInt(e.style.textIndent, 10) / 20;
    n > 0 && t.setIndent(n);
  }
  return { node: t };
}
function Do() {
  return Mg(new Rc());
}
function ex(e) {
  return e instanceof Rc;
}
const tn = 0, ec = 1;
function O2(e, t, n, r) {
  const i = e._keyToDOMMap;
  i.clear(), e._editorState = b_(), e._pendingEditorState = r, e._compositionKey = null, e._dirtyType = js, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set(), e._updates = [], e._blockCursorElement = null;
  const o = e._observer;
  o !== null && (o.disconnect(), e._observer = null), t !== null && (t.textContent = ""), n !== null && (n.textContent = "", i.set("root", n));
}
function lJ(e) {
  const t = e || {}, n = oJ(), r = t.theme || {}, i = e === void 0 ? n : t.parentEditor || null, o = t.disableEvents || !1, a = b_(), s = t.namespace || (i !== null ? i._config.namespace : HR()), l = t.editorState, c = [vd, Ic, md, gd, Rc, aJ, ...t.nodes || []], { onError: f, html: d } = t, p = t.editable === void 0 || t.editable;
  let m;
  if (e === void 0 && n !== null) m = n._nodes;
  else {
    m = /* @__PURE__ */ new Map();
    for (let v = 0; v < c.length; v++) {
      let y = c[v], x = null, w = null;
      if (typeof y != "function") {
        const O = y;
        y = O.replace, x = O.with, w = O.withKlass || null;
      }
      const S = y.getType(), A = y.transform(), _ = /* @__PURE__ */ new Set();
      A !== null && _.add(A), m.set(S, { exportDOM: d && d.export ? d.export.get(y) : void 0, klass: y, replace: x, replaceWithKlass: w, transforms: _ });
    }
  }
  const g = new Lg(a, i, m, { disableEvents: o, namespace: s, theme: r }, f || console.error, function(v, y) {
    const x = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Set(), S = (A) => {
      Object.keys(A).forEach((_) => {
        let O = x.get(_);
        O === void 0 && (O = [], x.set(_, O)), O.push(A[_]);
      });
    };
    return v.forEach((A) => {
      const _ = A.klass.importDOM;
      if (_ == null || w.has(_)) return;
      w.add(_);
      const O = _.call(A.klass);
      O !== null && S(O);
    }), y && S(y), x;
  }(m, d ? d.import : void 0), p);
  return l !== void 0 && (g._pendingEditorState = l, g._dirtyType = Ql), g;
}
class Lg {
  constructor(t, n, r, i, o, a, s) {
    this._parentEditor = n, this._rootElement = null, this._editorState = t, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = i, this._nodes = r, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = js, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = HR(), this._onError = o, this._htmlConversions = a, this._editable = s, this._headless = n !== null && n._headless, this._window = null, this._blockCursorElement = null;
  }
  isComposing() {
    return this._compositionKey != null;
  }
  registerUpdateListener(t) {
    const n = this._listeners.update;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerEditableListener(t) {
    const n = this._listeners.editable;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerDecoratorListener(t) {
    const n = this._listeners.decorator;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerTextContentListener(t) {
    const n = this._listeners.textcontent;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerRootListener(t) {
    const n = this._listeners.root;
    return t(this._rootElement, null), n.add(t), () => {
      t(null, this._rootElement), n.delete(t);
    };
  }
  registerCommand(t, n, r) {
    r === void 0 && _e(35);
    const i = this._commands;
    i.has(t) || i.set(t, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
    const o = i.get(t);
    o === void 0 && _e(36, String(t));
    const a = o[r];
    return a.add(n), () => {
      a.delete(n), o.every((s) => s.size === 0) && i.delete(t);
    };
  }
  registerMutationListener(t, n, r) {
    const i = this.resolveRegisteredNodeAfterReplacements(this.getRegisteredNode(t)).klass, o = this._listeners.mutation;
    o.set(n, i);
    const a = r && r.skipInitialization;
    return a === void 0 || a || this.initializeMutationListener(n, i), () => {
      o.delete(n);
    };
  }
  getRegisteredNode(t) {
    const n = this._nodes.get(t.getType());
    return n === void 0 && _e(37, t.name), n;
  }
  resolveRegisteredNodeAfterReplacements(t) {
    for (; t.replaceWithKlass; ) t = this.getRegisteredNode(t.replaceWithKlass);
    return t;
  }
  initializeMutationListener(t, n) {
    const r = this._editorState, i = UZ(r).get(n.getType());
    if (!i) return;
    const o = /* @__PURE__ */ new Map();
    for (const a of i.keys()) o.set(a, "created");
    o.size > 0 && t(o, { dirtyLeaves: /* @__PURE__ */ new Set(), prevEditorState: r, updateTags: /* @__PURE__ */ new Set(["registerMutationListener"]) });
  }
  registerNodeTransformToKlass(t, n) {
    const r = this.getRegisteredNode(t);
    return r.transforms.add(n), r;
  }
  registerNodeTransform(t, n) {
    const r = this.registerNodeTransformToKlass(t, n), i = [r], o = r.replaceWithKlass;
    if (o != null) {
      const l = this.registerNodeTransformToKlass(o, n);
      i.push(l);
    }
    var a, s;
    return a = this, s = t.getType(), Br(a, () => {
      const l = Go();
      if (l.isEmpty()) return;
      if (s === "root") return void rr().markDirty();
      const c = l._nodeMap;
      for (const [, f] of c) f.markDirty();
    }, a._pendingEditorState === null ? { tag: "history-merge" } : void 0), () => {
      i.forEach((l) => l.transforms.delete(n));
    };
  }
  hasNode(t) {
    return this._nodes.has(t.getType());
  }
  hasNodes(t) {
    return t.every(this.hasNode.bind(this));
  }
  dispatchCommand(t, n) {
    return Ae(this, t, n);
  }
  getDecorators() {
    return this._decorators;
  }
  getRootElement() {
    return this._rootElement;
  }
  getKey() {
    return this._key;
  }
  setRootElement(t) {
    const n = this._rootElement;
    if (t !== n) {
      const r = Gu(this._config.theme, "root"), i = this._pendingEditorState || this._editorState;
      if (this._rootElement = t, O2(this, n, t, i), n !== null && (this._config.disableEvents || YZ(n), r != null && n.classList.remove(...r)), t !== null) {
        const o = function(s) {
          const l = s.ownerDocument;
          return l && l.defaultView || null;
        }(t), a = t.style;
        a.userSelect = "text", a.whiteSpace = "pre-wrap", a.wordBreak = "break-word", t.setAttribute("data-lexical-editor", "true"), this._window = o, this._dirtyType = Ql, BR(this), this._updateTags.add("history-merge"), Sa(this), this._config.disableEvents || function(s, l) {
          const c = s.ownerDocument, f = Bp.get(c);
          (f === void 0 || f < 1) && c.addEventListener("selectionchange", c2), Bp.set(c, (f || 0) + 1), s.__lexicalEditor = l;
          const d = l2(s);
          for (let p = 0; p < q0.length; p++) {
            const [m, g] = q0[p], v = typeof g == "function" ? (y) => {
              TC(y) || (PC(y), (l.isEditable() || m === "click") && g(y, l));
            } : (y) => {
              if (TC(y)) return;
              PC(y);
              const x = l.isEditable();
              switch (m) {
                case "cut":
                  return x && Ae(l, J1, y);
                case "copy":
                  return Ae(l, Z1, y);
                case "paste":
                  return x && Ae(l, K1, y);
                case "dragstart":
                  return x && Ae(l, NR, y);
                case "dragover":
                  return x && Ae(l, sZ, y);
                case "dragend":
                  return x && Ae(l, lZ, y);
                case "focus":
                  return x && Ae(l, fZ, y);
                case "blur":
                  return x && Ae(l, dZ, y);
                case "drop":
                  return x && Ae(l, MR, y);
              }
            };
            s.addEventListener(m, v), d.push(() => {
              s.removeEventListener(m, v);
            });
          }
        }(t, this), r != null && t.classList.add(...r);
      } else this._editorState = i, this._pendingEditorState = null, this._window = null;
      Zu("root", this, !1, t, n);
    }
  }
  getElementByKey(t) {
    return this._keyToDOMMap.get(t) || null;
  }
  getEditorState() {
    return this._editorState;
  }
  setEditorState(t, n) {
    t.isEmpty() && _e(38), LR(this);
    const r = this._pendingEditorState, i = this._updateTags, o = n !== void 0 ? n.tag : null;
    r === null || r.isEmpty() || (o != null && i.add(o), Sa(this)), this._pendingEditorState = t, this._dirtyType = Ql, this._dirtyElements.set("root", !1), this._compositionKey = null, o != null && i.add(o), Sa(this);
  }
  parseEditorState(t, n) {
    return function(r, i, o) {
      const a = b_(), s = Nn, l = Or, c = $n, f = i._dirtyElements, d = i._dirtyLeaves, p = i._cloneNotNeeded, m = i._dirtyType;
      i._dirtyElements = /* @__PURE__ */ new Map(), i._dirtyLeaves = /* @__PURE__ */ new Set(), i._cloneNotNeeded = /* @__PURE__ */ new Set(), i._dirtyType = 0, Nn = a, Or = !1, $n = i;
      try {
        const g = i._nodes;
        b2(r.root, g), o && o(), a._readOnly = !0;
      } catch (g) {
        g instanceof Error && i._onError(g);
      } finally {
        i._dirtyElements = f, i._dirtyLeaves = d, i._cloneNotNeeded = p, i._dirtyType = m, Nn = s, Or = l, $n = c;
      }
      return a;
    }(typeof t == "string" ? JSON.parse(t) : t, this, n);
  }
  read(t) {
    return Sa(this), this.getEditorState().read(t, { editor: this });
  }
  update(t, n) {
    Br(this, t, n);
  }
  focus(t, n = {}) {
    const r = this._rootElement;
    r !== null && (r.setAttribute("autocapitalize", "off"), Br(this, () => {
      const i = ke(), o = rr();
      i !== null ? i.dirty = !0 : o.getChildrenSize() !== 0 && (n.defaultSelection === "rootStart" ? o.selectStart() : o.selectEnd());
    }, { onUpdate: () => {
      r.removeAttribute("autocapitalize"), t && t();
    }, tag: "focus" }), this._pendingEditorState === null && r.removeAttribute("autocapitalize"));
  }
  blur() {
    const t = this._rootElement;
    t !== null && t.blur();
    const n = eo(this._window);
    n !== null && n.removeAllRanges();
  }
  isEditable() {
    return this._editable;
  }
  setEditable(t) {
    this._editable !== t && (this._editable = t, Zu("editable", this, !0, t));
  }
  toJSON() {
    return { editorState: this._editorState.toJSON() };
  }
}
Lg.version = "0.17.1+prod.esm";
const A2 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, cJ = A2 ? $i : Qe, Lh = { tag: "history-merge" };
function uJ({ initialConfig: e, children: t }) {
  const n = Le(() => {
    const { theme: r, namespace: i, nodes: o, onError: a, editorState: s, html: l } = e, c = eZ(null, r), f = lJ({ editable: e.editable, html: l, namespace: i, nodes: o, onError: (d) => a(d, f), theme: r });
    return function(d, p) {
      if (p !== null) {
        if (p === void 0) d.update(() => {
          const m = rr();
          if (m.isEmpty()) {
            const g = Do();
            m.append(g);
            const v = A2 ? document.activeElement : null;
            (ke() !== null || v !== null && v === d.getRootElement()) && g.select();
          }
        }, Lh);
        else if (p !== null) switch (typeof p) {
          case "string": {
            const m = d.parseEditorState(p);
            d.setEditorState(m, Lh);
            break;
          }
          case "object":
            d.setEditorState(p, Lh);
            break;
          case "function":
            d.update(() => {
              rr().isEmpty() && p(d);
            }, Lh);
        }
      }
    }(f, s), [f, c];
  }, []);
  return cJ(() => {
    const r = e.editable, [i] = n;
    i.setEditable(r === void 0 || r);
  }, []), E(OR.Provider, { value: n, children: t });
}
const fJ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? $i : Qe;
function dJ(e) {
  return { initialValueFn: () => e.isEditable(), subscribe: (t) => e.registerEditableListener(t) };
}
function hJ() {
  return function(e) {
    const [t] = Kr(), n = Le(() => e(t), [t, e]), r = ft(n.initialValueFn()), [i, o] = Me(r.current);
    return fJ(() => {
      const { initialValueFn: a, subscribe: s } = n, l = a();
      return r.current !== l && (r.current = l, o(l)), s((c) => {
        r.current = c, o(c);
      });
    }, [n, e]), i;
  }(dJ);
}
function pJ() {
  return rr().getTextContent();
}
function mJ(e, t = !0) {
  if (e) return !1;
  let n = pJ();
  return t && (n = n.trim()), n === "";
}
function gJ(e) {
  if (!mJ(e, !1)) return !1;
  const t = rr().getChildren(), n = t.length;
  if (n > 1) return !1;
  for (let r = 0; r < n; r++) {
    const i = t[r];
    if (Kt(i)) return !1;
    if (ye(i)) {
      if (!ex(i) || i.__indent !== 0) return !1;
      const o = i.getChildren(), a = o.length;
      for (let s = 0; s < a; s++) {
        const l = o[r];
        if (!Se(l)) return !1;
      }
    }
  }
  return !0;
}
function P2(e) {
  return () => gJ(e);
}
function yJ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
yJ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function vJ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
vJ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function bJ(e, t) {
  const n = e.getStartEndPoints();
  if (t.isSelected(e) && !t.isSegmented() && !t.isToken() && n !== null) {
    const [r, i] = n, o = e.isBackward(), a = r.getNode(), s = i.getNode(), l = t.is(a), c = t.is(s);
    if (l || c) {
      const [f, d] = Q0(e), p = a.is(s), m = t.is(o ? s : a), g = t.is(o ? a : s);
      let v, y = 0;
      return p ? (y = f > d ? d : f, v = f > d ? f : d) : m ? (y = o ? d : f, v = void 0) : g && (y = 0, v = o ? f : d), t.__text = t.__text.slice(y, v), t;
    }
  }
  return t;
}
function KC(e, t) {
  const n = F0(e.focus, t);
  return Kt(n) && !n.isIsolated() || ye(n) && !n.isInline() && !n.canBeEmpty();
}
function xJ(e, t, n, r) {
  e.modify(t ? "extend" : "move", n, r);
}
function wJ(e) {
  const t = e.anchor.getNode();
  return (cr(t) ? t : t.getParentOrThrow()).getDirection() === "rtl";
}
function HC(e, t, n) {
  const r = wJ(e);
  xJ(e, t, n ? !r : r, "character");
}
function _J(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
_J(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const T2 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, SJ = T2 && "documentMode" in document ? document.documentMode : null;
!(!T2 || !("InputEvent" in window) || SJ) && "getTargetRanges" in new window.InputEvent("input");
function zo(...e) {
  return () => {
    for (let t = e.length - 1; t >= 0; t--) e[t]();
    e.length = 0;
  };
}
function OJ(e, t) {
  return e !== null && Object.getPrototypeOf(e).constructor.name === t.name;
}
function AJ(e) {
  const t = window.location.origin, n = (r) => {
    if (r.origin !== t) return;
    const i = e.getRootElement();
    if (document.activeElement !== i) return;
    const o = r.data;
    if (typeof o == "string") {
      let a;
      try {
        a = JSON.parse(o);
      } catch {
        return;
      }
      if (a && a.protocol === "nuanria_messaging" && a.type === "request") {
        const s = a.payload;
        if (s && s.functionId === "makeChanges") {
          const l = s.args;
          if (l) {
            const [c, f, d, p, m, g] = l;
            e.update(() => {
              const v = ke();
              if (we(v)) {
                const y = v.anchor;
                let x = y.getNode(), w = 0, S = 0;
                if (Se(x) && c >= 0 && f >= 0 && (w = c, S = c + f, v.setTextNodeRange(x, w, x, S)), w === S && d === "" || (v.insertRawText(d), x = y.getNode()), Se(x)) {
                  w = p, S = p + m;
                  const A = x.getTextContentSize();
                  w = w > A ? A : w, S = S > A ? A : S, v.setTextNodeRange(x, w, x, S);
                }
                r.stopImmediatePropagation();
              }
            });
          }
        }
      }
    }
  };
  return window.addEventListener("message", n, !0), () => {
    window.removeEventListener("message", n, !0);
  };
}
function PJ(e, t) {
  if (typeof document > "u" || typeof window > "u" && global.window === void 0) throw new Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  const n = document.createElement("div"), r = rr().getChildren();
  for (let i = 0; i < r.length; i++)
    C2(e, r[i], n, t);
  return n.innerHTML;
}
function C2(e, t, n, r = null) {
  let i = r === null || t.isSelected(r);
  const o = ye(t) && t.excludeFromCopy("html");
  let a = t;
  if (r !== null) {
    let m = qR(t);
    m = Se(m) && r !== null ? bJ(r, m) : m, a = m;
  }
  const s = ye(a) ? a.getChildren() : [], l = e._nodes.get(a.getType());
  let c;
  c = l && l.exportDOM !== void 0 ? l.exportDOM(e, a) : a.exportDOM(e);
  const { element: f, after: d } = c;
  if (!f) return !1;
  const p = document.createDocumentFragment();
  for (let m = 0; m < s.length; m++) {
    const g = s[m], v = C2(e, g, p, r);
    !i && ye(t) && v && t.extractWithChild(g, r, "html") && (i = !0);
  }
  if (i && !o) {
    if (m_(f) && f.append(p), n.append(f), d) {
      const m = d.call(a, f);
      m && f.replaceWith(m);
    }
  } else n.append(p);
  return i;
}
function TJ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var CJ = TJ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function EJ(e, t = ke()) {
  return t == null && CJ(166), we(t) && t.isCollapsed() || t.getNodes().length === 0 ? "" : PJ(e, t);
}
function GC(e, t) {
  const n = e.getData("text/plain") || e.getData("text/uri-list");
  n != null && t.insertRawText(n);
}
const jc = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, kJ = jc && "documentMode" in document ? document.documentMode : null, MJ = !(!jc || !("InputEvent" in window) || kJ) && "getTargetRanges" in new window.InputEvent("input"), NJ = jc && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), $J = jc && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, DJ = jc && /^(?=.*Chrome).*/i.test(navigator.userAgent), IJ = jc && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !DJ;
function YC(e, t) {
  t.update(() => {
    if (e !== null) {
      const n = OJ(e, KeyboardEvent) ? null : e.clipboardData, r = ke();
      if (r !== null && n != null) {
        e.preventDefault();
        const i = EJ(t);
        i !== null && n.setData("text/html", i), n.setData("text/plain", r.getTextContent());
      }
    }
  });
}
function RJ(e) {
  return zo(e.registerCommand(Es, (t) => {
    const n = ke();
    return !!we(n) && (n.deleteCharacter(t), !0);
  }, tn), e.registerCommand(yf, (t) => {
    const n = ke();
    return !!we(n) && (n.deleteWord(t), !0);
  }, tn), e.registerCommand(vf, (t) => {
    const n = ke();
    return !!we(n) && (n.deleteLine(t), !0);
  }, tn), e.registerCommand(Vl, (t) => {
    const n = ke();
    if (!we(n)) return !1;
    if (typeof t == "string") n.insertText(t);
    else {
      const r = t.dataTransfer;
      if (r != null) GC(r, n);
      else {
        const i = t.data;
        i && n.insertText(i);
      }
    }
    return !0;
  }, tn), e.registerCommand(R0, () => {
    const t = ke();
    return !!we(t) && (t.removeText(), !0);
  }, tn), e.registerCommand(zl, (t) => {
    const n = ke();
    return !!we(n) && (n.insertLineBreak(t), !0);
  }, tn), e.registerCommand(I0, () => {
    const t = ke();
    return !!we(t) && (t.insertLineBreak(), !0);
  }, tn), e.registerCommand(q1, (t) => {
    const n = ke();
    if (!we(n)) return !1;
    const r = t, i = r.shiftKey;
    return !!KC(n, !0) && (r.preventDefault(), HC(n, i, !0), !0);
  }, tn), e.registerCommand(Y1, (t) => {
    const n = ke();
    if (!we(n)) return !1;
    const r = t, i = r.shiftKey;
    return !!KC(n, !1) && (r.preventDefault(), HC(n, i, !1), !0);
  }, tn), e.registerCommand(X1, (t) => {
    const n = ke();
    return !!we(n) && (t.preventDefault(), e.dispatchCommand(Es, !0));
  }, tn), e.registerCommand(ER, (t) => {
    const n = ke();
    return !!we(n) && (t.preventDefault(), e.dispatchCommand(Es, !1));
  }, tn), e.registerCommand(bf, (t) => {
    const n = ke();
    if (!we(n)) return !1;
    if (t !== null) {
      if (($J || NJ || IJ) && MJ) return !1;
      t.preventDefault();
    }
    return e.dispatchCommand(zl, !1);
  }, tn), e.registerCommand(j0, () => (BZ(), !0), tn), e.registerCommand(Z1, (t) => {
    const n = ke();
    return !!we(n) && (YC(t, e), !0);
  }, tn), e.registerCommand(J1, (t) => {
    const n = ke();
    return !!we(n) && (function(r, i) {
      YC(r, i), i.update(() => {
        const o = ke();
        we(o) && o.removeText();
      });
    }(t, e), !0);
  }, tn), e.registerCommand(K1, (t) => {
    const n = ke();
    return !!we(n) && (function(r, i) {
      r.preventDefault(), i.update(() => {
        const o = ke(), { clipboardData: a } = r;
        a != null && we(o) && GC(a, o);
      }, { tag: "paste" });
    }(t, e), !0);
  }, tn), e.registerCommand(MR, (t) => {
    const n = ke();
    return !!we(n) && (t.preventDefault(), !0);
  }, tn), e.registerCommand(NR, (t) => {
    const n = ke();
    return !!we(n) && (t.preventDefault(), !0);
  }, tn));
}
const tx = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? $i : Qe;
function qC(e) {
  return e.getEditorState().read(P2(e.isComposing()));
}
function jJ({ contentEditable: e, placeholder: t = null, ErrorBoundary: n }) {
  const [r] = Kr(), i = function(o, a) {
    const [s, l] = Me(() => o.getDecorators());
    return tx(() => o.registerDecoratorListener((c) => {
      j$(() => {
        l(c);
      });
    }), [o]), Qe(() => {
      l(o.getDecorators());
    }, [o]), Le(() => {
      const c = [], f = Object.keys(s);
      for (let d = 0; d < f.length; d++) {
        const p = f[d], m = E(a, { onError: (v) => o._onError(v), children: E(G8, { fallback: null, children: s[p] }) }), g = o.getElementByKey(p);
        g !== null && c.push(Kw(m, g, p));
      }
      return c;
    }, [a, s, o]);
  }(r, n);
  return function(o) {
    tx(() => zo(RJ(o), AJ(o)), [o]);
  }(r), me(Ut, { children: [e, E(LJ, { content: t }), i] });
}
function LJ({ content: e }) {
  const [t] = Kr(), n = function(i) {
    const [o, a] = Me(() => qC(i));
    return tx(() => {
      function s() {
        const l = qC(i);
        a(l);
      }
      return s(), zo(i.registerUpdateListener(() => {
        s();
      }), i.registerEditableListener(() => {
        s();
      }));
    }, [i]), o;
  }(t), r = hJ();
  return n ? typeof e == "function" ? e(r) : e : null;
}
const E2 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? $i : Qe;
function BJ({ editor: e, ariaActiveDescendant: t, ariaAutoComplete: n, ariaControls: r, ariaDescribedBy: i, ariaExpanded: o, ariaLabel: a, ariaLabelledBy: s, ariaMultiline: l, ariaOwns: c, ariaRequired: f, autoCapitalize: d, className: p, id: m, role: g = "textbox", spellCheck: v = !0, style: y, tabIndex: x, "data-testid": w, ...S }, A) {
  const [_, O] = Me(e.isEditable()), T = Je((k) => {
    k && k.ownerDocument && k.ownerDocument.defaultView ? e.setRootElement(k) : e.setRootElement(null);
  }, [e]), C = Le(() => /* @__PURE__ */ function(...k) {
    return (D) => {
      k.forEach((N) => {
        typeof N == "function" ? N(D) : N != null && (N.current = D);
      });
    };
  }(A, T), [T, A]);
  return E2(() => (O(e.isEditable()), e.registerEditableListener((k) => {
    O(k);
  })), [e]), E("div", { ...S, "aria-activedescendant": _ ? t : void 0, "aria-autocomplete": _ ? n : "none", "aria-controls": _ ? r : void 0, "aria-describedby": i, "aria-expanded": _ && g === "combobox" ? !!o : void 0, "aria-label": a, "aria-labelledby": s, "aria-multiline": l, "aria-owns": _ ? c : void 0, "aria-readonly": !_ || void 0, "aria-required": f, autoCapitalize: d, className: p, contentEditable: _, "data-testid": w, id: m, ref: C, role: _ ? g : void 0, spellCheck: v, style: y, tabIndex: x });
}
const FJ = $t(BJ);
function XC(e) {
  return e.getEditorState().read(P2(e.isComposing()));
}
const WJ = $t(zJ);
function zJ(e, t) {
  const { placeholder: n, ...r } = e, [i] = Kr();
  return me(Ut, { children: [E(FJ, { editor: i, ...r, ref: t }), n != null && E(VJ, { editor: i, content: n })] });
}
function VJ({ content: e, editor: t }) {
  const n = function(a) {
    const [s, l] = Me(() => XC(a));
    return E2(() => {
      function c() {
        const f = XC(a);
        l(f);
      }
      return c(), zo(a.registerUpdateListener(() => {
        c();
      }), a.registerEditableListener(() => {
        c();
      }));
    }, [a]), s;
  }(t), [r, i] = Me(t.isEditable());
  if ($i(() => (i(t.isEditable()), t.registerEditableListener((a) => {
    i(a);
  })), [t]), !n) return null;
  let o = null;
  return typeof e == "function" ? o = e(r) : e !== null && (o = e), o === null ? null : E("div", { "aria-hidden": !0, children: o });
}
const Bh = 0, nx = 1, rx = 2, _i = 0, UJ = 1, ZC = 2, KJ = 3, HJ = 4;
function GJ(e, t, n, r, i) {
  if (e === null || n.size === 0 && r.size === 0 && !i) return _i;
  const o = t._selection, a = e._selection;
  if (i) return UJ;
  if (!(we(o) && we(a) && a.isCollapsed() && o.isCollapsed())) return _i;
  const s = function(x, w, S) {
    const A = x._nodeMap, _ = [];
    for (const O of w) {
      const T = A.get(O);
      T !== void 0 && _.push(T);
    }
    for (const [O, T] of S) {
      if (!T) continue;
      const C = A.get(O);
      C === void 0 || cr(C) || _.push(C);
    }
    return _;
  }(t, n, r);
  if (s.length === 0) return _i;
  if (s.length > 1) {
    const x = t._nodeMap, w = x.get(o.anchor.key), S = x.get(a.anchor.key);
    return w && S && !e._nodeMap.has(w.__key) && Se(w) && w.__text.length === 1 && o.anchor.offset === 1 ? ZC : _i;
  }
  const l = s[0], c = e._nodeMap.get(l.__key);
  if (!Se(c) || !Se(l) || c.__mode !== l.__mode) return _i;
  const f = c.__text, d = l.__text;
  if (f === d) return _i;
  const p = o.anchor, m = a.anchor;
  if (p.key !== m.key || p.type !== "text") return _i;
  const g = p.offset, v = m.offset, y = d.length - f.length;
  return y === 1 && v === g - 1 ? ZC : y === -1 && v === g + 1 ? KJ : y === -1 && v === g ? HJ : _i;
}
function YJ(e, t) {
  let n = Date.now(), r = _i;
  return (i, o, a, s, l, c) => {
    const f = Date.now();
    if (c.has("historic")) return r = _i, n = f, rx;
    const d = GJ(i, o, s, l, e.isComposing()), p = (() => {
      const m = a === null || a.editor === e, g = c.has("history-push");
      if (!g && m && c.has("history-merge")) return Bh;
      if (i === null) return nx;
      const v = o._selection;
      return s.size > 0 || l.size > 0 ? g === !1 && d !== _i && d === r && f < n + t && m || s.size === 1 && function(y, x, w) {
        const S = x._nodeMap.get(y), A = w._nodeMap.get(y), _ = x._selection, O = w._selection;
        return !(we(_) && we(O) && _.anchor.type === "element" && _.focus.type === "element" && O.anchor.type === "text" && O.focus.type === "text" || !Se(S) || !Se(A) || S.__parent !== A.__parent) && JSON.stringify(x.read(() => S.exportJSON())) === JSON.stringify(w.read(() => A.exportJSON()));
      }(Array.from(s)[0], i, o) ? Bh : nx : v !== null ? Bh : rx;
    })();
    return n = f, r = d, p;
  };
}
function JC(e) {
  e.undoStack = [], e.redoStack = [], e.current = null;
}
function qJ(e, t, n) {
  const r = YJ(e, n);
  return zo(e.registerCommand(H1, () => (function(o, a) {
    const s = a.redoStack, l = a.undoStack;
    if (l.length !== 0) {
      const c = a.current, f = l.pop();
      c !== null && (s.push(c), o.dispatchCommand(Dh, !0)), l.length === 0 && o.dispatchCommand(Ih, !1), a.current = f || null, f && f.editor.setEditorState(f.editorState, { tag: "historic" });
    }
  }(e, t), !0), tn), e.registerCommand(G1, () => (function(o, a) {
    const s = a.redoStack, l = a.undoStack;
    if (s.length !== 0) {
      const c = a.current;
      c !== null && (l.push(c), o.dispatchCommand(Ih, !0));
      const f = s.pop();
      s.length === 0 && o.dispatchCommand(Dh, !1), a.current = f || null, f && f.editor.setEditorState(f.editorState, { tag: "historic" });
    }
  }(e, t), !0), tn), e.registerCommand(cZ, () => (JC(t), !1), tn), e.registerCommand(uZ, () => (JC(t), e.dispatchCommand(Dh, !1), e.dispatchCommand(Ih, !1), !0), tn), e.registerUpdateListener(({ editorState: o, prevEditorState: a, dirtyLeaves: s, dirtyElements: l, tags: c }) => {
    const f = t.current, d = t.redoStack, p = t.undoStack, m = f === null ? null : f.editorState;
    if (f !== null && o === m) return;
    const g = r(a, o, f, s, l, c);
    if (g === nx) d.length !== 0 && (t.redoStack = [], e.dispatchCommand(Dh, !1)), f !== null && (p.push({ ...f }), e.dispatchCommand(Ih, !0));
    else if (g === rx) return;
    t.current = { editor: e, editorState: o };
  }));
}
function XJ() {
  return { current: null, redoStack: [], undoStack: [] };
}
function ZJ({ delay: e, externalHistoryState: t }) {
  const [n] = Kr();
  return function(r, i, o = 1e3) {
    const a = Le(() => i || XJ(), [i]);
    Qe(() => qJ(r, a, o), [o, r, a]);
  }(n, t, e), null;
}
function ix(e, t) {
  return ix = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, ix(e, t);
}
var QC = { error: null }, JJ = function(e) {
  var t, n;
  function r() {
    for (var o, a = arguments.length, s = new Array(a), l = 0; l < a; l++) s[l] = arguments[l];
    return (o = e.call.apply(e, [this].concat(s)) || this).state = QC, o.resetErrorBoundary = function() {
      for (var c, f = arguments.length, d = new Array(f), p = 0; p < f; p++) d[p] = arguments[p];
      o.props.onReset == null || (c = o.props).onReset.apply(c, d), o.reset();
    }, o;
  }
  n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, ix(t, n), r.getDerivedStateFromError = function(o) {
    return { error: o };
  };
  var i = r.prototype;
  return i.reset = function() {
    this.setState(QC);
  }, i.componentDidCatch = function(o, a) {
    var s, l;
    (s = (l = this.props).onError) == null || s.call(l, o, a);
  }, i.componentDidUpdate = function(o, a) {
    var s, l, c, f, d = this.state.error, p = this.props.resetKeys;
    d !== null && a.error !== null && ((c = o.resetKeys) === void 0 && (c = []), (f = p) === void 0 && (f = []), c.length !== f.length || c.some(function(m, g) {
      return !Object.is(m, f[g]);
    })) && ((s = (l = this.props).onResetKeysChange) == null || s.call(l, o.resetKeys, p), this.reset());
  }, i.render = function() {
    var o = this.state.error, a = this.props, s = a.fallbackRender, l = a.FallbackComponent, c = a.fallback;
    if (o !== null) {
      var f = { error: o, resetErrorBoundary: this.resetErrorBoundary };
      if (ee.isValidElement(c)) return c;
      if (typeof s == "function") return s(f);
      if (l) return ee.createElement(l, f);
      throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, r;
}(ee.Component);
function QJ({ children: e, onError: t }) {
  return E(JJ, { fallback: E("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" }, children: "An error was thrown." }), onError: t, children: e });
}
const eQ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? $i : Qe;
function tQ({ ignoreHistoryMergeTagChange: e = !0, ignoreSelectionChange: t = !1, onChange: n }) {
  const [r] = Kr();
  return eQ(() => {
    if (n) return r.registerUpdateListener(({ editorState: i, dirtyElements: o, dirtyLeaves: a, prevEditorState: s, tags: l }) => {
      t && o.size === 0 && a.size === 0 || e && l.has("history-merge") || s.isEmpty() || n(i, r, l);
    });
  }, [r, e, t, n]), null;
}
function nQ({ editorRef: e }) {
  const [t] = Kr();
  return ee.useEffect(() => {
    typeof e == "function" ? e(t) : typeof e == "object" && (e.current = t);
  }, [t]), null;
}
const rQ = "w-full [&>p]:w-full [&>p]:m-0", iQ = "focus-within:ring-2 focus-within:ring-offset-2 hover:outline-border-strong hover:focus-within:outline-focus-border focus-within:outline-focus-border focus-within:ring-focus transition-[color,outline,box-shadow] duration-150 ease-in-out outline outline-1 outline-field-border", oQ = "bg-field-secondary-background outline-field-border-disabled hover:outline-field-border-disabled [&_p]:text-badge-color-disabled cursor-not-allowed", aQ = {
  sm: "px-3 py-1.5 rounded [&_.editor-content>p]:text-xs [&_.editor-content>p]:font-normal [&_.pointer-events-none]:text-xs [&_.pointer-events-none]:font-normal [&_.editor-content>p]:content-center [&_.editor-content>p]:min-h-5",
  md: "px-3.5 py-2 rounded-md [&_.editor-content>p]:text-sm [&_.editor-content>p]:font-normal [&_.pointer-events-none]:text-sm [&_.pointer-events-none]:font-normal [&_.editor-content>p]:content-center [&_.editor-content>p]:min-h-6",
  lg: "px-4 py-2.5 rounded-md [&_.editor-content>p]:text-base [&_.editor-content>p]:font-normal [&_.pointer-events-none]:text-base [&_.pointer-events-none]:font-normal [&_.editor-content>p]:content-center [&_.editor-content>p]:min-h-7"
}, sQ = "absolute inset-x-0 top-full mt-2 mx-0 mb-0 w-full h-auto overflow-y-auto overflow-x-hidden z-10 bg-background-primary border border-solid border-border-subtle shadow-lg", lQ = {
  sm: "p-1.5 rounded-md max-h-[10.75rem]",
  md: "p-2 rounded-lg max-h-[13.5rem]",
  lg: "p-2 rounded-lg max-h-[13.5rem]"
}, cQ = "m-0 text-text-primary cursor-pointer", uQ = {
  sm: "p-1.5 rounded text-xs leading-5 font-normal",
  md: "p-2 rounded-md text-sm leading-6 font-normal",
  lg: "p-2 rounded-md text-base leading-6 font-normal"
}, fQ = "bg-button-tertiary-hover", eE = "startTransition", dQ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? $i : Qe, tE = (e) => {
  const t = document.getElementById("typeahead-menu");
  if (!t) return;
  const n = t.getBoundingClientRect();
  n.top + n.height > window.innerHeight && t.scrollIntoView({ block: "center" }), n.top < 0 && t.scrollIntoView({ block: "center" }), e.scrollIntoView({ block: "nearest" });
};
function nE(e, t) {
  const n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
  return n.top > r.top && n.top < r.bottom;
}
function hQ(e, t, n, r) {
  const [i] = Kr();
  Qe(() => {
    if (t != null && e != null) {
      const o = i.getRootElement(), a = o != null ? function(d, p) {
        let m = getComputedStyle(d);
        const g = m.position === "absolute", v = /(auto|scroll)/;
        if (m.position === "fixed") return document.body;
        for (let y = d; y = y.parentElement; ) if (m = getComputedStyle(y), (!g || m.position !== "static") && v.test(m.overflow + m.overflowY + m.overflowX)) return y;
        return document.body;
      }(o) : document.body;
      let s = !1, l = nE(t, a);
      const c = function() {
        s || (window.requestAnimationFrame(function() {
          n(), s = !1;
        }), s = !0);
        const d = nE(t, a);
        d !== l && (l = d, r != null && r(d));
      }, f = new ResizeObserver(n);
      return window.addEventListener("resize", n), document.addEventListener("scroll", c, { capture: !0, passive: !0 }), f.observe(t), () => {
        f.unobserve(t), window.removeEventListener("resize", n), document.removeEventListener("scroll", c, !0);
      };
    }
  }, [t, i, r, n, e]);
}
const rE = nZ();
function pQ({ close: e, editor: t, anchorElementRef: n, resolution: r, options: i, menuRenderFn: o, onSelectOption: a, shouldSplitNodeWithQuery: s = !1, commandPriority: l = ec }) {
  const [c, f] = Me(null), d = r.match && r.match.matchingString;
  Qe(() => {
    f(0);
  }, [d]);
  const p = Je((g) => {
    t.update(() => {
      const v = r.match != null && s ? function(y) {
        const x = ke();
        if (!we(x) || !x.isCollapsed()) return null;
        const w = x.anchor;
        if (w.type !== "text") return null;
        const S = w.getNode();
        if (!S.isSimpleText()) return null;
        const A = w.offset, _ = S.getTextContent().slice(0, A), O = y.replaceableString.length, T = A - function(k, D, N) {
          let $ = N;
          for (let B = $; B <= D.length; B++) k.substr(-B) === D.substr(0, B) && ($ = B);
          return $;
        }(_, y.matchingString, O);
        if (T < 0) return null;
        let C;
        return T === 0 ? [C] = S.splitText(A) : [, C] = S.splitText(T, A), C;
      }(r.match) : null;
      a(g, v, e, r.match ? r.match.matchingString : "");
    });
  }, [t, s, r.match, a, e]), m = Je((g) => {
    const v = t.getRootElement();
    v !== null && (v.setAttribute("aria-activedescendant", "typeahead-item-" + g), f(g));
  }, [t]);
  return Qe(() => () => {
    const g = t.getRootElement();
    g !== null && g.removeAttribute("aria-activedescendant");
  }, [t]), dQ(() => {
    i === null ? f(null) : c === null && m(0);
  }, [i, c, m]), Qe(() => zo(t.registerCommand(rE, ({ option: g }) => !(!g.ref || g.ref.current == null) && (tE(g.ref.current), !0), l)), [t, m, l]), Qe(() => zo(t.registerCommand(TR, (g) => {
    const v = g;
    if (i !== null && i.length && c !== null) {
      const y = c !== i.length - 1 ? c + 1 : 0;
      m(y);
      const x = i[y];
      x.ref != null && x.ref.current && t.dispatchCommand(rE, { index: y, option: x }), v.preventDefault(), v.stopImmediatePropagation();
    }
    return !0;
  }, l), t.registerCommand(PR, (g) => {
    const v = g;
    if (i !== null && i.length && c !== null) {
      const y = c !== 0 ? c - 1 : i.length - 1;
      m(y);
      const x = i[y];
      x.ref != null && x.ref.current && tE(x.ref.current), v.preventDefault(), v.stopImmediatePropagation();
    }
    return !0;
  }, l), t.registerCommand(CR, (g) => {
    const v = g;
    return v.preventDefault(), v.stopImmediatePropagation(), e(), !0;
  }, l), t.registerCommand(kR, (g) => {
    const v = g;
    return i !== null && c !== null && i[c] != null && (v.preventDefault(), v.stopImmediatePropagation(), p(i[c]), !0);
  }, l), t.registerCommand(bf, (g) => i !== null && c !== null && i[c] != null && (g !== null && (g.preventDefault(), g.stopImmediatePropagation()), p(i[c]), !0), l)), [p, e, t, i, c, m, l]), o(n, Le(() => ({ options: i, selectOptionAndCleanUp: p, selectedIndex: c, setHighlightedIndex: f }), [p, c, i]), r.match ? r.match.matchingString : "");
}
function mQ({ options: e, onQueryChange: t, onSelectOption: n, onOpen: r, onClose: i, menuRenderFn: o, triggerFn: a, anchorClassName: s, commandPriority: l = ec, parent: c }) {
  const [f] = Kr(), [d, p] = Me(null), m = function(y, x, w, S = document.body) {
    const [A] = Kr(), _ = ft(document.createElement("div")), O = Je(() => {
      _.current.style.top = _.current.style.bottom;
      const C = A.getRootElement(), k = _.current, D = k.firstChild;
      if (C !== null && y !== null) {
        const { left: N, top: $, width: B, height: L } = y.getRect(), F = _.current.offsetHeight;
        if (k.style.top = `${$ + window.pageYOffset + F + 3}px`, k.style.left = `${N + window.pageXOffset}px`, k.style.height = `${L}px`, k.style.width = `${B}px`, D !== null) {
          D.style.top = `${$}`;
          const W = D.getBoundingClientRect(), z = W.height, G = W.width, V = C.getBoundingClientRect();
          N + G > V.right && (k.style.left = `${V.right - G + window.pageXOffset}px`), ($ + z > window.innerHeight || $ + z > V.bottom) && $ - V.top > z + L && (k.style.top = $ - z + window.pageYOffset - L + "px");
        }
        k.isConnected || (w != null && (k.className = w), k.setAttribute("aria-label", "Typeahead menu"), k.setAttribute("id", "typeahead-menu"), k.setAttribute("role", "listbox"), k.style.display = "block", k.style.position = "absolute", S.append(k)), _.current = k, C.setAttribute("aria-controls", "typeahead-menu");
      }
    }, [A, y, w, S]);
    Qe(() => {
      const C = A.getRootElement();
      if (y !== null) return O(), () => {
        C !== null && C.removeAttribute("aria-controls");
        const k = _.current;
        k !== null && k.isConnected && k.remove();
      };
    }, [A, O, y]);
    const T = Je((C) => {
      y !== null && (C || x(null));
    }, [y, x]);
    return hQ(y, _.current, O, T), _;
  }(d, p, s, c), g = Je(() => {
    p(null), i != null && d !== null && i();
  }, [i, d]), v = Je((y) => {
    p(y), r != null && d === null && r(y);
  }, [r, d]);
  return Qe(() => {
    const y = f.registerUpdateListener(() => {
      f.getEditorState().read(() => {
        const x = f._window || window, w = x.document.createRange(), S = ke(), A = function(T) {
          let C = null;
          return T.getEditorState().read(() => {
            const k = ke();
            we(k) && (C = function(D) {
              const N = D.anchor;
              if (N.type !== "text") return null;
              const $ = N.getNode();
              if (!$.isSimpleText()) return null;
              const B = N.offset;
              return $.getTextContent().slice(0, B);
            }(k));
          }), C;
        }(f);
        if (!we(S) || !S.isCollapsed() || A === null || w === null) return void g();
        const _ = a(A, f);
        if (t(_ ? _.matchingString : null), _ !== null && !function(T, C) {
          return C === 0 && T.getEditorState().read(() => {
            const k = ke();
            if (we(k)) {
              const D = k.anchor.getNode().getPreviousSibling();
              return Se(D) && D.isTextEntity();
            }
            return !1;
          });
        }(f, _.leadOffset) && function(C, k, D) {
          const N = D.getSelection();
          if (N === null || !N.isCollapsed) return !1;
          const $ = N.anchorNode, B = C, L = N.anchorOffset;
          if ($ == null || L == null) return !1;
          try {
            k.setStart($, B), k.setEnd($, L);
          } catch {
            return !1;
          }
          return !0;
        }(_.leadOffset, w, x) !== null)
          return O = () => v({ getRect: () => w.getBoundingClientRect(), match: _ }), void (eE in I ? I[eE](O) : O());
        var O;
        g();
      });
    });
    return () => {
      y();
    };
  }, [f, a, t, d, g, v]), d === null || f === null ? null : E(pQ, { close: g, resolution: d, editor: f, anchorElementRef: m, options: e, menuRenderFn: o, shouldSplitNodeWithQuery: !0, onSelectOption: n, commandPriority: l });
}
const gQ = (e) => {
  switch (e) {
    case "sm":
      return "xs";
    case "md":
      return "sm";
    case "lg":
      return "md";
    default:
      return "sm";
  }
}, yQ = ({
  data: e,
  by: t,
  size: n,
  nodeKey: r
}) => {
  const [i] = Kr(), o = !i.isEditable(), a = (f) => {
    f.stopPropagation(), f.preventDefault(), !o && i.update(() => {
      const d = Mn(r);
      d && d.remove();
    });
  };
  let s = e;
  typeof e == "object" && (s = e[t]);
  const l = Je(
    (f) => {
      const d = Mn(r);
      if (!d || !d.isSelected())
        return !1;
      let p = !1;
      const m = d.getPreviousSibling();
      return ye(m) && (m.selectEnd(), p = !0), Se(m) && (m.select(), p = !0), Kt(m) && (m.selectNext(), p = !0), m === null && (d.selectPrevious(), p = !0), p && f.preventDefault(), p;
    },
    [r]
  ), c = Je(
    (f) => {
      const d = Mn(r);
      if (!d || !d.isSelected())
        return !1;
      let p = !1;
      const m = d.getNextSibling();
      return ye(m) && (m.selectStart(), p = !0), Se(m) && (m.select(0, 0), p = !0), Kt(m) && (m.selectPrevious(), p = !0), m === null && (d.selectNext(), p = !0), p && f.preventDefault(), p;
    },
    [r]
  );
  return Qe(() => {
    const f = zo(
      i.registerCommand(
        q1,
        l,
        ec
      ),
      i.registerCommand(
        Y1,
        c,
        ec
      )
    );
    return () => {
      f();
    };
  }, [i, l, c]), /* @__PURE__ */ E(
    hg,
    {
      className: "inline-flex mr-0.5",
      type: "rounded",
      size: gQ(n),
      label: s,
      icon: null,
      closable: !0,
      onClose: a,
      disabled: o
    }
  );
};
class tc extends _2 {
  constructor(n, r, i, o) {
    super(o);
    fa(this, "__data");
    fa(this, "__by");
    fa(this, "__size");
    this.__data = n, this.__by = r, this.__size = i;
  }
  static getType() {
    return "mention";
  }
  static clone(n) {
    return new tc(n.__data, n.__by, n.__size, n.__key);
  }
  static importJSON(n) {
    return k2(
      n.data,
      n.by,
      n.size
    );
  }
  createDOM() {
    return document.createElement("span");
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return { element: document.createElement("span") };
  }
  exportJSON() {
    return {
      type: tc.getType(),
      data: this.__data,
      by: this.__by,
      size: this.__size,
      version: 1
    };
  }
  decorate() {
    return /* @__PURE__ */ E(
      yQ,
      {
        data: this.__data,
        by: this.__by,
        size: this.__size,
        nodeKey: this.__key
      }
    );
  }
}
const k2 = (e, t, n) => new tc(e, t, n), vQ = (e) => e instanceof tc;
class bQ {
  constructor(t) {
    fa(this, "data");
    fa(this, "key");
    fa(this, "ref");
    fa(this, "setRefElement");
    this.initData = t, this.key = "", this.data = t, this.ref = { current: null }, this.setRefElement = (n) => {
      this.ref.current = n;
    };
  }
}
const wb = /* @__PURE__ */ new Map();
function xQ(e, t, n = "name") {
  const [r, i] = Me([]);
  return Qe(() => {
    if (t === null) {
      i([]);
      return;
    }
    const o = wb.get(t);
    if (o !== null) {
      if (o !== void 0) {
        i(o);
        return;
      }
      wb.set(t, null), wQ.search(
        e,
        t,
        (a) => {
          wb.set(t, a), i(a);
        },
        n
      );
    }
  }, [t]), r;
}
const wQ = {
  search(e, t, n, r) {
    setTimeout(() => {
      if (!Array.isArray(e))
        return [];
      const i = e.filter(
        (o) => {
          var s;
          if (typeof o == "string")
            return o.toLowerCase().includes(t.toLowerCase());
          const a = (s = o == null ? void 0 : o[r]) == null ? void 0 : s.toString();
          return a ? a.toLowerCase().includes(t.toLowerCase()) : !1;
        }
      );
      n(i);
    }, 500);
  }
}, zp = ({ size: e, className: t, children: n }) => /* @__PURE__ */ E(
  "ul",
  {
    role: "menu",
    className: H(
      sQ,
      lQ[e],
      t
    ),
    children: n
  }
);
zp.displayName = "EditorCombobox";
const M2 = $t(
  ({ size: e, children: t, selected: n = !1, className: r, ...i }, o) => /* @__PURE__ */ E(
    "li",
    {
      role: "option",
      ref: o,
      className: H(
        cQ,
        uQ[e],
        n && fQ,
        r
      ),
      ...i,
      children: t
    }
  )
);
M2.displayName = "EditorCombobox.Item";
zp.Item = M2;
const _Q = ({
  optionsArray: e,
  by: t = "name",
  size: n = "md",
  trigger: r = "@",
  // Default trigger value
  menuComponent: i = zp,
  menuItemComponent: o = zp.Item,
  autoSpace: a = !0
}) => {
  const s = ft(!1), l = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`, c = [r].join(""), f = "[^" + c + l + "\\s]", d = "(?:\\.[ |$]| |[" + l + "]|)", p = 75, m = new RegExp(
    `(^|\\s|\\()([${c}]((?:${f}${d}){0,${p}}))$`
  ), g = 50, v = new RegExp(
    `(^|\\s|\\()([${c}]((?:${f}){0,${g}}))$`
  ), y = (k) => {
    let D = m.exec(k);
    if (D === null && (D = v.exec(k)), D !== null) {
      const N = D[1], $ = D[3];
      if ($.length >= 0)
        return {
          leadOffset: D.index + N.length,
          matchingString: $,
          replaceableString: D[2]
        };
    }
    return null;
  }, [x] = Kr(), [w, S] = Me(null), A = xQ(e, w, t), _ = Je(
    (k, D, N) => {
      x.update(() => {
        const $ = k2(
          k.data,
          t,
          n
        );
        D && D.replace($), N();
      });
    },
    [x]
  ), O = Le(() => A.map((k) => new bQ(k)), [x, A]), T = Je(
    (k) => {
      if (!a)
        return !1;
      const { key: D, ctrlKey: N, metaKey: $ } = k;
      if (N || $ || D === " " || D.length > 1 || s.current)
        return s.current && (s.current = !1), !1;
      const B = ke(), { focus: L, anchor: F } = B, [W] = B.getNodes();
      if (!F || !L || (F == null ? void 0 : F.key) !== (L == null ? void 0 : L.key) || (F == null ? void 0 : F.offset) !== (L == null ? void 0 : L.offset) || !W)
        return !1;
      if (vQ(W)) {
        const z = Wn(" ");
        return W.insertAfter(z), !0;
      }
      return !1;
    },
    [x, r, a]
  ), C = Je(
    (k) => {
      const { key: D } = k;
      return D === "Backspace" ? (s.current = !0, !0) : !1;
    },
    [s]
  );
  return Qe(() => {
    if (x)
      return zo(
        x.registerCommand(
          AR,
          T,
          ec
        ),
        x.registerCommand(
          X1,
          C,
          ec
        )
      );
  }, [x, T]), /* @__PURE__ */ E(
    mQ,
    {
      onQueryChange: S,
      onSelectOption: _,
      triggerFn: y,
      options: O,
      menuRenderFn: (k, { selectedIndex: D, selectOptionAndCleanUp: N, setHighlightedIndex: $ }) => k.current && (O != null && O.length) ? /* @__PURE__ */ E(i, { size: n, children: O.map((B, L) => {
        var F;
        return /* @__PURE__ */ E(
          o,
          {
            ref: B.ref,
            size: n,
            selected: L === D,
            onMouseEnter: () => {
              $(L);
            },
            onClick: () => N(B),
            children: typeof B.data == "string" ? B.data : (F = B.data) == null ? void 0 : F[t]
          },
          L
        );
      }) }) : null
    }
  );
}, SQ = {
  ltr: "ltr",
  rtl: "rtl",
  paragraph: "editor-paragraph",
  quote: "editor-quote",
  heading: {
    h1: "editor-heading-h1",
    h2: "editor-heading-h2",
    h3: "editor-heading-h3",
    h4: "editor-heading-h4",
    h5: "editor-heading-h5",
    h6: "editor-heading-h6"
  },
  list: {
    nested: {
      listitem: "editor-nested-listitem"
    },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
    listitem: "editor-listItem",
    listitemChecked: "editor-listItemChecked",
    listitemUnchecked: "editor-listItemUnchecked"
  },
  hashtag: "editor-hashtag",
  image: "editor-image",
  link: "editor-link",
  text: {
    bold: "editor-textBold",
    code: "editor-textCode",
    italic: "editor-textItalic",
    strikethrough: "editor-textStrikethrough",
    subscript: "editor-textSubscript",
    superscript: "editor-textSuperscript",
    underline: "editor-textUnderline",
    underlineStrikethrough: "editor-textUnderlineStrikethrough"
  },
  code: "editor-code",
  codeHighlight: {
    atrule: "editor-tokenAttr",
    attr: "editor-tokenAttr",
    boolean: "editor-tokenProperty",
    builtin: "editor-tokenSelector",
    cdata: "editor-tokenComment",
    char: "editor-tokenSelector",
    class: "editor-tokenFunction",
    "class-name": "editor-tokenFunction",
    comment: "editor-tokenComment",
    constant: "editor-tokenProperty",
    deleted: "editor-tokenProperty",
    doctype: "editor-tokenComment",
    entity: "editor-tokenOperator",
    function: "editor-tokenFunction",
    important: "editor-tokenVariable",
    inserted: "editor-tokenSelector",
    keyword: "editor-tokenAttr",
    namespace: "editor-tokenVariable",
    number: "editor-tokenProperty",
    operator: "editor-tokenOperator",
    prolog: "editor-tokenComment",
    property: "editor-tokenProperty",
    punctuation: "editor-tokenPunctuation",
    regex: "editor-tokenVariable",
    selector: "editor-tokenSelector",
    string: "editor-tokenSelector",
    symbol: "editor-tokenProperty",
    tag: "editor-tokenProperty",
    url: "editor-tokenOperator",
    variable: "editor-tokenVariable"
  }
}, OQ = ({ content: e }) => /* @__PURE__ */ E(
  "div",
  {
    "aria-hidden": "true",
    className: "pointer-events-none absolute inset-0 flex items-center justify-start text-field-placeholder w-full",
    children: /* @__PURE__ */ E("span", { className: "truncate", children: e })
  }
);
function AQ(e) {
  console.error(e);
}
const PQ = `{
    "root": {
        "children": [
            {
                "children": [],
                "direction": null,
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1,
                "textFormat": 0,
                "textStyle": ""
            }
        ],
        "direction": null,
        "format": "",
        "indent": 0,
        "type": "root",
        "version": 1
    }
}`, TQ = $t(
  ({
    defaultValue: e = "",
    placeholder: t = "Press @ to view variable suggestions",
    onChange: n,
    size: r = "md",
    autoFocus: i = !1,
    options: o,
    by: a = "name",
    trigger: s = "@",
    menuComponent: l,
    menuItemComponent: c,
    className: f,
    wrapperClassName: d,
    disabled: p = !1,
    autoSpaceAfterMention: m = !1
  }, g) => {
    const v = {
      namespace: "Editor",
      editorTheme: SQ,
      onError: AQ,
      nodes: [tc],
      editorState: e || PQ,
      editable: !p
    }, y = (S, A) => {
      typeof n == "function" && n(S, A);
    };
    let x, w;
    return ut(l) && (x = l), ut(c) && (w = c), /* @__PURE__ */ E(
      "div",
      {
        className: H(
          "relative w-full",
          iQ,
          aQ[r],
          p && oQ,
          d
        ),
        children: /* @__PURE__ */ me(uJ, { initialConfig: v, children: [
          /* @__PURE__ */ E("div", { className: "relative w-full [&_p]:m-0", children: /* @__PURE__ */ E(
            jJ,
            {
              contentEditable: /* @__PURE__ */ E(
                WJ,
                {
                  className: H(
                    "editor-content focus-visible:outline-none outline-none",
                    rQ,
                    f
                  )
                }
              ),
              placeholder: /* @__PURE__ */ E(OQ, { content: t }),
              ErrorBoundary: QJ
            }
          ) }),
          /* @__PURE__ */ E(ZJ, {}),
          /* @__PURE__ */ E(
            _Q,
            {
              menuComponent: x,
              menuItemComponent: w,
              size: r,
              by: a,
              optionsArray: o,
              trigger: s,
              autoSpace: m
            }
          ),
          /* @__PURE__ */ E(
            tQ,
            {
              onChange: y,
              ignoreSelectionChange: !0
            }
          ),
          g && /* @__PURE__ */ E(nQ, { editorRef: g }),
          i && /* @__PURE__ */ E(tZ, {})
        ] })
      }
    );
  }
);
TQ.displayName = "EditorInput";
const CQ = (e, t, n, r) => {
  const i = `absolute rounded-full transition-colors duration-500 ${n[r].dot}`;
  return e === "dot" ? H(
    i,
    n[r].dot,
    t ? "bg-brand-primary-600" : "bg-text-tertiary"
  ) : e === "number" ? H(
    i,
    n[r].dot,
    t ? "text-brand-primary-600" : "text-text-tertiary",
    "flex items-center justify-center"
  ) : e === "icon" ? H(
    i,
    t ? "text-brand-primary-600" : "text-text-tertiary",
    "flex items-center justify-center"
  ) : "";
}, EQ = (e, t, n) => H(
  "relative flex items-center rounded-full justify-center transition-colors z-10 duration-500 ring-1",
  e ? "ring-brand-primary-600" : "ring-border-subtle",
  t[n].ring
), kQ = (e, t) => H(
  "rounded-full text-brand-primary-600 transition-colors duration-300",
  e[t].dot,
  e[t].ring
), MQ = {
  sm: {
    dot: "size-2.5",
    ring: "size-5",
    numberIcon: "size-5 text-tiny",
    icon: "size-5",
    label: "text-xs"
  },
  md: {
    dot: "size-3",
    ring: "size-6",
    numberIcon: "size-6 text-sm",
    icon: "size-6",
    label: "text-sm"
  },
  lg: {
    dot: "size-3.5",
    ring: "size-7",
    numberIcon: "size-7 text-md",
    icon: "size-7",
    label: "text-sm"
  }
}, NQ = ({
  variant: e = "dot",
  size: t = "sm",
  type: n = "inline",
  currentStep: r = 1,
  children: i,
  className: o,
  lineClassName: a = "min-w-10",
  ...s
}) => {
  const l = I.Children.count(i);
  r === -1 && (r = l + 1);
  const c = I.Children.map(i, (f, d) => {
    const p = d + 1 < r, m = d + 1 === r, g = d + 1 === l, v = {
      isCompleted: p,
      isCurrent: m,
      sizeClasses: MQ,
      size: t,
      variant: e,
      type: n,
      isLast: g,
      index: d,
      lineClassName: a
    };
    return /* @__PURE__ */ E(I.Fragment, { children: I.isValidElement(f) ? I.cloneElement(f, v) : f }, d);
  });
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex w-full",
        o,
        n === "inline" ? "items-center justify-between" : ""
      ),
      ...s,
      children: c
    }
  );
}, N2 = ({
  labelText: e = "",
  icon: t = /* @__PURE__ */ E(Y$, {}),
  isCurrent: n,
  isCompleted: r,
  className: i,
  type: o,
  variant: a,
  sizeClasses: s,
  size: l,
  isLast: c,
  index: f,
  lineClassName: d,
  ...p
}) => {
  const m = $Q(
    a,
    r,
    n,
    s,
    l,
    t,
    f
  ), g = {
    lg: "left-[calc(50%+14px)] right-[calc(-50%+14px)]",
    md: "left-[calc(50%+12px)] right-[calc(-50%+12px)]",
    sm: "left-[calc(50%+10px)] right-[calc(-50%+10px)]"
  }, v = {
    lg: "top-3.5",
    md: "top-3",
    sm: "top-2.5"
  }, y = () => {
    if (e) {
      const w = H(
        s[l].label,
        "text-text-tertiary",
        n ? "text-brand-primary-600" : "",
        "break-word",
        // max width for inline and stack
        o === "stack" ? "mt-2 transform max-w-xs" : "mx-2 max-w-32"
      );
      return /* @__PURE__ */ E("span", { className: w, children: e });
    }
    return null;
  }, x = () => {
    if (!c) {
      const w = H(
        "block",
        r ? "border-brand-primary-600" : "border-border-subtle",
        d
      );
      return o === "stack" ? /* @__PURE__ */ E(
        "div",
        {
          className: H(
            "relative",
            "flex",
            "border-solid",
            "border-y",
            "absolute",
            r ? "border-brand-primary-600" : "border-border-subtle",
            v[l],
            g[l]
          ),
          children: /* @__PURE__ */ E("span", { className: "block" })
        }
      ) : /* @__PURE__ */ E("div", { className: "flex-1", children: /* @__PURE__ */ E(
        "span",
        {
          className: H(
            "mr-2 border-y border-solid",
            !e && "ml-2",
            w
          )
        }
      ) });
    }
    return null;
  };
  return o === "stack" ? /* @__PURE__ */ me("div", { className: "relative flex-1 justify-center", children: [
    /* @__PURE__ */ me(
      "div",
      {
        className: H("flex items-center flex-col", i),
        ...p,
        children: [
          m,
          y()
        ]
      }
    ),
    x()
  ] }) : /* @__PURE__ */ me(Ut, { children: [
    /* @__PURE__ */ me("div", { className: H("flex items-center", i), ...p, children: [
      m,
      y()
    ] }),
    x()
  ] });
};
N2.displayName = "ProgressSteps.Step";
const $Q = (e, t, n, r, i, o, a) => {
  if (t)
    return /* @__PURE__ */ E(od, { className: kQ(r, i) });
  const s = EQ(!!n, r, i), l = CQ(
    e,
    n,
    r,
    i
  );
  let c = null;
  return e === "number" ? c = a + 1 : e === "icon" && o && (c = o), /* @__PURE__ */ E("span", { className: s, children: /* @__PURE__ */ E("span", { className: l, children: c }) });
};
NQ.Step = N2;
const NEe = ({
  variant: e = "rectangular",
  // rectangular, circular
  className: t,
  ...n
}) => {
  const r = {
    circular: "rounded-full bg-gray-200 ",
    rectangular: "rounded-md bg-gray-200"
  }[e], i = {
    circular: "size-10",
    rectangular: "w-96 h-3"
  }[e];
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        r,
        "animate-pulse",
        i,
        t
      ),
      ...n
    }
  );
}, $2 = ht({}), D2 = () => Ve($2), Ka = ({ size: e = "md", children: t, className: n }) => /* @__PURE__ */ E($2.Provider, { value: { size: e }, children: /* @__PURE__ */ E("div", { className: H("flex flex-col bg-background-primary p-2", n), children: t }) });
Ka.displayName = "Menu";
const I2 = ({
  heading: e,
  arrow: t = !1,
  showArrowOnHover: n = !1,
  // Prop to toggle hover-based arrow display
  open: r = !0,
  onClick: i,
  children: o,
  className: a
}) => {
  const [s, l] = Me(r), [c, f] = Me(!1), { size: d } = D2(), p = "text-text-primary bg-transparent cursor-pointer flex justify-between items-center gap-1", m = {
    sm: "text-xs",
    md: "text-sm"
  }[d ?? "md"], g = {
    sm: "size-4",
    md: "size-5"
  }[d ?? "md"], v = () => {
    l(!s), i && i(!s);
  }, y = {
    open: { rotate: 180 },
    closed: { rotate: 0 }
  }, x = {
    open: { height: "auto", opacity: 1 },
    closed: { height: 0, opacity: 0 }
  }, w = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
  }, S = () => n ? s || c ? "visible" : "hidden" : "visible";
  return /* @__PURE__ */ me("div", { children: [
    !!e && /* @__PURE__ */ me(
      "div",
      {
        role: "button",
        tabIndex: 0,
        onClick: v,
        onKeyDown: (A) => {
          (A.key === "Enter" || A.key === " ") && v();
        },
        onMouseEnter: () => n && f(!0),
        onMouseLeave: () => n && f(!1),
        className: H(
          p,
          m,
          e ? "p-1" : "p-0",
          a
        ),
        "aria-expanded": s,
        children: [
          /* @__PURE__ */ E("span", { className: "text-text-tertiary", children: e }),
          t && /* @__PURE__ */ E(
            ui.span,
            {
              className: "flex items-center text-border-strong",
              initial: "hidden",
              animate: S(),
              exit: "hidden",
              variants: w,
              transition: { duration: 0.15 },
              children: /* @__PURE__ */ E(
                ui.span,
                {
                  className: "inline-flex p-1",
                  variants: y,
                  animate: s ? "open" : "closed",
                  transition: { duration: 0.15 },
                  children: /* @__PURE__ */ E(
                    Gw,
                    {
                      className: H("shrink-0", g)
                    }
                  )
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ E(Hs, { initial: !1, children: s && /* @__PURE__ */ E(
      ui.ul,
      {
        role: "menu",
        variants: x,
        initial: "closed",
        animate: "open",
        exit: "closed",
        transition: { duration: 0.3, ease: "easeInOut" },
        className: "overflow flex gap-0.5 flex-col m-0 bg-white rounded p-0",
        children: o
      }
    ) })
  ] });
};
I2.displayName = "Menu.List";
const R2 = ({
  disabled: e = !1,
  active: t,
  onClick: n,
  children: r,
  className: i
}) => {
  const { size: o } = D2(), a = "flex p-1 gap-1 items-center bg-transparent border-none rounded text-text-secondary cursor-pointer m-0", s = {
    sm: "[&>svg]:size-4 [&>svg]:m-1 [&>*:not(svg)]:mx-1 [&>*:not(svg)]:my-0.5 text-sm",
    md: "[&>svg]:size-5 [&>svg]:m-1.5 [&>*:not(svg)]:m-1 text-base"
  }[o ?? "md"];
  return /* @__PURE__ */ E(
    "li",
    {
      role: "menuitem",
      tabIndex: 0,
      onClick: n,
      onKeyDown: (p) => {
        (p.key === "Enter" || p.key === " ") && (n == null || n());
      },
      className: H(
        a,
        s,
        "hover:bg-background-secondary hover:text-text-primary",
        e ? "text-text-disabled hover:text-text-disabled cursor-not-allowed hover:bg-transparent" : "",
        t ? "text-icon-primary [&>svg]:text-icon-interactive bg-background-secondary" : "",
        "transition-colors duration-300 ease-in-out",
        i
      ),
      children: r
    }
  );
};
R2.displayName = "Menu.Item";
const j2 = ({
  variant: e = "solid",
  className: t
}) => {
  const n = {
    solid: "border-solid",
    dashed: "border-dashed",
    dotted: "border-dotted",
    double: "border-double",
    hidden: "border-hidden",
    none: "border-none"
  }[e];
  return /* @__PURE__ */ E("li", { className: "m-0 p-0 list-none", role: "separator", "aria-hidden": "true", children: /* @__PURE__ */ E(
    "hr",
    {
      className: H(
        "w-full border-0 border-t border-border-subtle",
        n,
        t
      )
    }
  ) });
};
j2.displayName = "Menu.Separator";
Ka.List = I2;
Ka.Item = R2;
Ka.Separator = j2;
const L2 = ht({
  isCollapsed: !1,
  setIsCollapsed: () => {
  },
  collapsible: !0
}), B2 = ({
  children: e,
  className: t,
  onCollapseChange: n,
  collapsible: r = !0,
  borderOn: i = !0,
  ...o
}) => {
  const a = ft(null), [s, l] = Me(() => {
    const c = Iu.get("sidebar-collapsed"), f = window.innerWidth < 1280;
    return c || f;
  });
  return Qe(() => {
    n && n(s);
  }, [s, n]), Qe(() => {
    const c = () => {
      const f = window.innerWidth < 1280;
      if (!r)
        l(!1), Iu.remove("sidebar-collapsed");
      else if (f)
        l(!0), Iu.set("sidebar-collapsed", !0);
      else {
        const d = Iu.get("sidebar-collapsed");
        l(d || !1);
      }
    };
    return window.addEventListener("resize", c), c(), () => {
      window.removeEventListener("resize", c);
    };
  }, [r]), /* @__PURE__ */ E(
    L2.Provider,
    {
      value: { isCollapsed: s, setIsCollapsed: l, collapsible: r },
      children: /* @__PURE__ */ E(
        "div",
        {
          ref: a,
          className: H(
            "h-full overflow-auto w-72 px-4 py-4 gap-4 flex flex-col bg-background-primary",
            i && "border-0 border-r border-solid border-border-subtle",
            "transition-all duration-200",
            s && "w-16 px-2",
            t
          ),
          ...o,
          children: e
        }
      )
    }
  );
};
B2.displayName = "Sidebar";
const F2 = ({ children: e }) => /* @__PURE__ */ E("div", { className: "space-y-2", children: e });
F2.displayName = "Sidebar.Header";
const W2 = ({ children: e }) => /* @__PURE__ */ E("div", { className: H("space-y-4 grow items-start"), children: e });
W2.displayName = "Sidebar.Body";
const z2 = ({ children: e }) => {
  const { isCollapsed: t, setIsCollapsed: n, collapsible: r } = Ve(L2);
  return /* @__PURE__ */ me("div", { className: "space-y-4", children: [
    e,
    r && /* @__PURE__ */ E(
      "button",
      {
        className: H(
          "bg-transparent w-full border-0 p-0 m-0 flex items-center gap-2 text-base cursor-pointer",
          t && "justify-center"
        ),
        onClick: () => {
          n(!t), Iu.set("sidebar-collapsed", !t);
        },
        "aria-label": t ? "Expand sidebar" : "Collapse sidebar",
        children: t ? /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(l1, { title: "Expand", children: /* @__PURE__ */ E(VK, { className: "size-5" }) }) }) : /* @__PURE__ */ me(Ut, { children: [
          /* @__PURE__ */ E(zK, { className: "size-5" }),
          " Collapse"
        ] })
      }
    )
  ] });
};
z2.displayName = "Sidebar.Footer";
const V2 = ({ children: e, className: t }) => /* @__PURE__ */ E("div", { className: H("w-full", t), children: e });
V2.displayName = "Sidebar.Item";
const $Ee = Object.assign(B2, {
  Header: F2,
  Body: W2,
  Footer: z2,
  Item: V2
}), ox = {
  sm: {
    text: "text-sm",
    separator: "text-sm",
    separatorIconSize: 16
  },
  md: {
    text: "text-base",
    separator: "text-base",
    separatorIconSize: 18
  }
}, bd = ht({ sizes: ox.sm }), Ys = ({ children: e, size: t = "sm" }) => {
  const n = ox[t] || ox.sm;
  return /* @__PURE__ */ E(bd.Provider, { value: { sizes: n }, children: /* @__PURE__ */ E("nav", { className: "flex m-0", "aria-label": "Breadcrumb", children: /* @__PURE__ */ E("ul", { className: "m-0 inline-flex items-center space-x-1 md:space-x-1", children: e }) }) });
};
Ys.displayName = "Breadcrumb";
const U2 = ({ children: e }) => /* @__PURE__ */ E(Ut, { children: e });
U2.displayName = "Breadcrumb.List";
const K2 = ({ children: e }) => /* @__PURE__ */ E("li", { className: "m-0 inline-flex items-center gap-2", children: e });
K2.displayName = "Breadcrumb.Item";
const H2 = ({
  href: e,
  children: t,
  className: n,
  as: r = "a",
  ...i
}) => {
  const { sizes: o } = Ve(bd);
  return /* @__PURE__ */ E(
    r,
    {
      href: e,
      className: H(
        o.text,
        "px-1 font-medium no-underline text-text-tertiary hover:text-text-primary hover:underline",
        "focus:outline-none focus:ring-1 focus:ring-border-interactive focus:border-border-interactive focus:rounded-sm",
        "transition-all duration-200",
        n
      ),
      ...i,
      children: t
    }
  );
};
H2.displayName = "Breadcrumb.Link";
const G2 = ({ type: e }) => {
  const { sizes: t } = Ve(bd), n = {
    slash: /* @__PURE__ */ E("span", { className: H("mx-1", t.separator), children: "/" }),
    arrow: /* @__PURE__ */ E(Yw, { size: t.separatorIconSize })
  };
  return /* @__PURE__ */ E(
    "li",
    {
      role: "separator",
      className: "flex items-center text-text-tertiary mx-2 p-0 list-none",
      "aria-hidden": "true",
      children: n[e] || n.arrow
    }
  );
};
G2.displayName = "Breadcrumb.Separator";
const Y2 = () => {
  const { sizes: e } = Ve(bd);
  return /* @__PURE__ */ E(
    LK,
    {
      className: "mt-[2px] cursor-pointer text-text-tertiary hover:text-text-primary",
      size: e.separatorIconSize + 4
    }
  );
};
Y2.displayName = "Breadcrumb.Ellipsis";
const q2 = ({ children: e }) => {
  const { sizes: t } = Ve(bd);
  return /* @__PURE__ */ E("span", { className: H(t.text, "font-medium text-text-primary"), children: e });
};
q2.displayName = "Breadcrumb.Page";
Ys.List = U2;
Ys.Item = K2;
Ys.Link = H2;
Ys.Separator = G2;
Ys.Ellipsis = Y2;
Ys.Page = q2;
const X2 = ht({}), Bg = () => Ve(X2), Z2 = {
  open: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, J2 = { duration: 0.2 }, Yo = ({
  open: e,
  setOpen: t,
  children: n,
  trigger: r = null,
  className: i,
  exitOnClickOutside: o = !1,
  exitOnEsc: a = !0,
  design: s = "simple",
  scrollLock: l = !0
}) => {
  const c = e !== void 0 && t !== void 0, [f, d] = Me(!1), p = ft(null), m = ft(null), g = Le(
    () => c ? e : f,
    [e, f]
  ), v = Le(
    () => c ? t : d,
    [d, d]
  ), y = () => {
    g || v(!0);
  }, x = () => {
    g && v(!1);
  }, w = Je(() => {
    var _;
    return ut(r) ? _t(r, {
      onClick: sf(y, (_ = r == null ? void 0 : r.props) == null ? void 0 : _.onClick)
    }) : typeof r == "function" ? r({ onClick: y }) : null;
  }, [r, y, x]), S = (_) => {
    switch (_.key) {
      case "Escape":
        a && x();
        break;
    }
  }, A = (_) => {
    o && p.current && !p.current.contains(_.target) && x();
  };
  return Qe(() => (window.addEventListener("keydown", S), document.addEventListener("mousedown", A), () => {
    window.removeEventListener("keydown", S), document.removeEventListener("mousedown", A);
  }), [g]), Qe(() => {
    if (!l)
      return;
    const _ = document.querySelector("html");
    return g && _ && (_.style.overflow = "hidden"), () => {
      _ && (_.style.overflow = "");
    };
  }, [g]), /* @__PURE__ */ me(Ut, { children: [
    w(),
    /* @__PURE__ */ E(
      X2.Provider,
      {
        value: {
          open: g,
          setOpen: v,
          handleClose: x,
          design: s,
          dialogContainerRef: m,
          dialogRef: p
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            ref: m,
            className: H(
              "fixed z-999999 w-0 h-0 overflow-visible",
              i
            ),
            children: n
          }
        )
      }
    )
  ] });
};
Yo.displayName = "Dialog";
const Q2 = ({
  children: e,
  className: t
}) => {
  const { open: n, handleClose: r, dialogRef: i } = Bg();
  return /* @__PURE__ */ E(Hs, { children: n && /* @__PURE__ */ E(
    ui.div,
    {
      className: "fixed inset-0 overflow-y-auto",
      initial: "exit",
      animate: "open",
      exit: "exit",
      variants: Z2,
      role: "dialog",
      transition: J2,
      children: /* @__PURE__ */ E("div", { className: "flex items-center justify-center min-h-full", children: /* @__PURE__ */ E(
        "div",
        {
          ref: i,
          className: H(
            "flex flex-col gap-5 w-120 h-fit bg-background-primary border border-solid border-border-subtle rounded-xl shadow-soft-shadow-2xl my-5 overflow-hidden",
            t
          ),
          children: typeof e == "function" ? e({ close: r }) : e
        }
      ) })
    }
  ) });
};
Q2.displayName = "Dialog.Panel";
const ej = ({
  className: e,
  ...t
}) => {
  const { open: n, dialogContainerRef: r } = Bg();
  return r != null && r.current ? /* @__PURE__ */ E(Ut, { children: Kw(
    /* @__PURE__ */ E(Hs, { children: n && /* @__PURE__ */ E(
      ui.div,
      {
        className: H(
          "fixed inset-0 -z-10 bg-background-inverse/90",
          e
        ),
        ...t,
        initial: "exit",
        animate: "open",
        exit: "exit",
        variants: Z2,
        transition: J2
      }
    ) }),
    r.current
  ) }) : null;
};
ej.displayName = "Dialog.Backdrop";
const tj = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E("div", { className: H("space-y-2 px-5 pt-5 pb-1", t), ...n, children: e });
tj.displayName = "Dialog.Header";
const nj = ({
  children: e,
  as: t = "h3",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: H(
      "text-base font-semibold text-text-primary m-0 p-0",
      n
    ),
    ...r,
    children: e
  }
);
nj.displayName = "Dialog.Title";
const rj = ({
  children: e,
  as: t = "p",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: H(
      "text-sm font-normal text-text-secondary my-0 ml-0 mr-1 p-0",
      n
    ),
    ...r,
    children: e
  }
);
rj.displayName = "Dialog.Description";
const DQ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ E(
  "button",
  {
    className: H(
      "bg-transparent inline-flex justify-center items-center border-0 p-1 m-0 cursor-pointer focus:outline-none outline-none shadow-none",
      e
    ),
    "aria-label": "Close dialog",
    ...t,
    children: /* @__PURE__ */ E(Na, { className: "size-4 text-text-primary shrink-0" })
  }
), ij = ({
  children: e,
  as: t = fi,
  ...n
}) => {
  const { handleClose: r } = Bg();
  return e ? t === fi ? typeof e == "function" ? e({
    close: r
  }) : _t(e, {
    onClick: r
  }) : /* @__PURE__ */ E(t, { ...n, onClick: r, children: e }) : /* @__PURE__ */ E(DQ, { onClick: r, ...n });
};
ij.displayName = "Dialog.CloseButton";
const oj = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E("div", { className: H("px-5", t), ...n, children: e });
oj.displayName = "Dialog.Body";
const aj = ({
  children: e,
  className: t
}) => {
  const { design: n, handleClose: r } = Bg(), i = () => e ? typeof e == "function" ? e({ close: r }) : e : null;
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "p-4 flex justify-end gap-3",
        {
          "bg-background-secondary": n === "footer-divided"
        },
        t
      ),
      children: i()
    }
  );
};
aj.displayName = "Dialog.Footer";
Yo.Panel = Q2;
Yo.Title = nj;
Yo.Description = rj;
Yo.CloseButton = ij;
Yo.Header = tj;
Yo.Body = oj;
Yo.Footer = aj;
Yo.Backdrop = ej;
const xd = ({
  children: e,
  gap: t = "lg",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  "div",
  {
    className: H(
      "w-full box-border flex items-center justify-between bg-background-primary p-5 min-h-16",
      Xm(t),
      n
    ),
    ...r,
    children: e
  }
);
xd.displayName = "Topbar";
const sj = ({ gap: e = "sm", children: t, className: n }) => /* @__PURE__ */ E("div", { className: H("flex items-center", Xm(e), n), children: t });
sj.displayName = "Topbar.Left";
const lj = ({
  gap: e = "md",
  children: t,
  align: n = "center",
  className: r
}) => {
  const i = {
    left: "justify-start",
    center: "justify-center",
    right: "justify-end"
  }[n];
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex items-center grow",
        Xm(e),
        i,
        r
      ),
      children: t
    }
  );
};
lj.displayName = "Topbar.Middle";
const cj = ({ gap: e = "sm", children: t, className: n }) => /* @__PURE__ */ E("div", { className: H("flex items-center", Xm(e), n), children: t });
cj.displayName = "Topbar.Right";
const uj = ({ children: e, className: t }) => /* @__PURE__ */ E(
  "div",
  {
    className: H("flex items-center [&>svg]:block h-full", t),
    children: e
  }
);
uj.displayName = "Topbar.Item";
xd.Left = sj;
xd.Middle = lj;
xd.Right = cj;
xd.Item = uj;
var Vp = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Vp.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, f = "__lodash_placeholder__", d = 1, p = 2, m = 4, g = 1, v = 2, y = 1, x = 2, w = 4, S = 8, A = 16, _ = 32, O = 64, T = 128, C = 256, k = 512, D = 30, N = "...", $ = 800, B = 16, L = 1, F = 2, W = 3, z = 1 / 0, G = 9007199254740991, V = 17976931348623157e292, U = NaN, Y = 4294967295, te = Y - 1, ne = Y >>> 1, re = [
      ["ary", T],
      ["bind", y],
      ["bindKey", x],
      ["curry", S],
      ["curryRight", A],
      ["flip", k],
      ["partial", _],
      ["partialRight", O],
      ["rearg", C]
    ], ue = "[object Arguments]", ae = "[object Array]", le = "[object AsyncFunction]", ie = "[object Boolean]", Q = "[object Date]", fe = "[object DOMException]", ve = "[object Error]", X = "[object Function]", Fe = "[object GeneratorFunction]", pe = "[object Map]", Be = "[object Number]", rt = "[object Null]", at = "[object Object]", Gn = "[object Promise]", $e = "[object Proxy]", st = "[object RegExp]", Oe = "[object Set]", He = "[object String]", Xt = "[object Symbol]", pt = "[object Undefined]", Qt = "[object WeakMap]", Hr = "[object WeakSet]", Pn = "[object ArrayBuffer]", gn = "[object DataView]", pr = "[object Float32Array]", tt = "[object Float64Array]", Ht = "[object Int8Array]", St = "[object Int16Array]", In = "[object Int32Array]", Gr = "[object Uint8Array]", ao = "[object Uint8ClampedArray]", cn = "[object Uint16Array]", Pr = "[object Uint32Array]", un = /\b__p \+= '';/g, Yr = /\b(__p \+=) '' \+/g, gt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Dd = /&(?:amp|lt|gt|quot|#39);/g, Id = /[&<>"']/g, Py = RegExp(Dd.source), eu = RegExp(Id.source), tu = /<%-([\s\S]+?)%>/g, yz = /<%([\s\S]+?)%>/g, IS = /<%=([\s\S]+?)%>/g, vz = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bz = /^\w*$/, xz = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ty = /[\\^$.*+?()[\]{}|]/g, wz = RegExp(Ty.source), Cy = /^\s+/, _z = /\s/, Sz = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Oz = /\{\n\/\* \[wrapped with (.+)\] \*/, Az = /,? & /, Pz = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Tz = /[()=,{}\[\]\/\s]/, Cz = /\\(\\)?/g, Ez = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, RS = /\w*$/, kz = /^[-+]0x[0-9a-f]+$/i, Mz = /^0b[01]+$/i, Nz = /^\[object .+?Constructor\]$/, $z = /^0o[0-7]+$/i, Dz = /^(?:0|[1-9]\d*)$/, Iz = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Rd = /($^)/, Rz = /['\n\r\u2028\u2029\\]/g, jd = "\\ud800-\\udfff", jz = "\\u0300-\\u036f", Lz = "\\ufe20-\\ufe2f", Bz = "\\u20d0-\\u20ff", jS = jz + Lz + Bz, LS = "\\u2700-\\u27bf", BS = "a-z\\xdf-\\xf6\\xf8-\\xff", Fz = "\\xac\\xb1\\xd7\\xf7", Wz = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", zz = "\\u2000-\\u206f", Vz = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", FS = "A-Z\\xc0-\\xd6\\xd8-\\xde", WS = "\\ufe0e\\ufe0f", zS = Fz + Wz + zz + Vz, Ey = "['’]", Uz = "[" + jd + "]", VS = "[" + zS + "]", Ld = "[" + jS + "]", US = "\\d+", Kz = "[" + LS + "]", KS = "[" + BS + "]", HS = "[^" + jd + zS + US + LS + BS + FS + "]", ky = "\\ud83c[\\udffb-\\udfff]", Hz = "(?:" + Ld + "|" + ky + ")", GS = "[^" + jd + "]", My = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ny = "[\\ud800-\\udbff][\\udc00-\\udfff]", il = "[" + FS + "]", YS = "\\u200d", qS = "(?:" + KS + "|" + HS + ")", Gz = "(?:" + il + "|" + HS + ")", XS = "(?:" + Ey + "(?:d|ll|m|re|s|t|ve))?", ZS = "(?:" + Ey + "(?:D|LL|M|RE|S|T|VE))?", JS = Hz + "?", QS = "[" + WS + "]?", Yz = "(?:" + YS + "(?:" + [GS, My, Ny].join("|") + ")" + QS + JS + ")*", qz = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Xz = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", eO = QS + JS + Yz, Zz = "(?:" + [Kz, My, Ny].join("|") + ")" + eO, Jz = "(?:" + [GS + Ld + "?", Ld, My, Ny, Uz].join("|") + ")", Qz = RegExp(Ey, "g"), e5 = RegExp(Ld, "g"), $y = RegExp(ky + "(?=" + ky + ")|" + Jz + eO, "g"), t5 = RegExp([
      il + "?" + KS + "+" + XS + "(?=" + [VS, il, "$"].join("|") + ")",
      Gz + "+" + ZS + "(?=" + [VS, il + qS, "$"].join("|") + ")",
      il + "?" + qS + "+" + XS,
      il + "+" + ZS,
      Xz,
      qz,
      US,
      Zz
    ].join("|"), "g"), n5 = RegExp("[" + YS + jd + jS + WS + "]"), r5 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, i5 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], o5 = -1, Ft = {};
    Ft[pr] = Ft[tt] = Ft[Ht] = Ft[St] = Ft[In] = Ft[Gr] = Ft[ao] = Ft[cn] = Ft[Pr] = !0, Ft[ue] = Ft[ae] = Ft[Pn] = Ft[ie] = Ft[gn] = Ft[Q] = Ft[ve] = Ft[X] = Ft[pe] = Ft[Be] = Ft[at] = Ft[st] = Ft[Oe] = Ft[He] = Ft[Qt] = !1;
    var Dt = {};
    Dt[ue] = Dt[ae] = Dt[Pn] = Dt[gn] = Dt[ie] = Dt[Q] = Dt[pr] = Dt[tt] = Dt[Ht] = Dt[St] = Dt[In] = Dt[pe] = Dt[Be] = Dt[at] = Dt[st] = Dt[Oe] = Dt[He] = Dt[Xt] = Dt[Gr] = Dt[ao] = Dt[cn] = Dt[Pr] = !0, Dt[ve] = Dt[X] = Dt[Qt] = !1;
    var a5 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, s5 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, l5 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, c5 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, u5 = parseFloat, f5 = parseInt, tO = typeof _o == "object" && _o && _o.Object === Object && _o, d5 = typeof self == "object" && self && self.Object === Object && self, Rn = tO || d5 || Function("return this")(), Dy = t && !t.nodeType && t, Za = Dy && !0 && e && !e.nodeType && e, nO = Za && Za.exports === Dy, Iy = nO && tO.process, qr = function() {
      try {
        var Z = Za && Za.require && Za.require("util").types;
        return Z || Iy && Iy.binding && Iy.binding("util");
      } catch {
      }
    }(), rO = qr && qr.isArrayBuffer, iO = qr && qr.isDate, oO = qr && qr.isMap, aO = qr && qr.isRegExp, sO = qr && qr.isSet, lO = qr && qr.isTypedArray;
    function Tr(Z, ce, oe) {
      switch (oe.length) {
        case 0:
          return Z.call(ce);
        case 1:
          return Z.call(ce, oe[0]);
        case 2:
          return Z.call(ce, oe[0], oe[1]);
        case 3:
          return Z.call(ce, oe[0], oe[1], oe[2]);
      }
      return Z.apply(ce, oe);
    }
    function h5(Z, ce, oe, Pe) {
      for (var Ke = -1, mt = Z == null ? 0 : Z.length; ++Ke < mt; ) {
        var yn = Z[Ke];
        ce(Pe, yn, oe(yn), Z);
      }
      return Pe;
    }
    function Xr(Z, ce) {
      for (var oe = -1, Pe = Z == null ? 0 : Z.length; ++oe < Pe && ce(Z[oe], oe, Z) !== !1; )
        ;
      return Z;
    }
    function p5(Z, ce) {
      for (var oe = Z == null ? 0 : Z.length; oe-- && ce(Z[oe], oe, Z) !== !1; )
        ;
      return Z;
    }
    function cO(Z, ce) {
      for (var oe = -1, Pe = Z == null ? 0 : Z.length; ++oe < Pe; )
        if (!ce(Z[oe], oe, Z))
          return !1;
      return !0;
    }
    function na(Z, ce) {
      for (var oe = -1, Pe = Z == null ? 0 : Z.length, Ke = 0, mt = []; ++oe < Pe; ) {
        var yn = Z[oe];
        ce(yn, oe, Z) && (mt[Ke++] = yn);
      }
      return mt;
    }
    function Bd(Z, ce) {
      var oe = Z == null ? 0 : Z.length;
      return !!oe && ol(Z, ce, 0) > -1;
    }
    function Ry(Z, ce, oe) {
      for (var Pe = -1, Ke = Z == null ? 0 : Z.length; ++Pe < Ke; )
        if (oe(ce, Z[Pe]))
          return !0;
      return !1;
    }
    function Gt(Z, ce) {
      for (var oe = -1, Pe = Z == null ? 0 : Z.length, Ke = Array(Pe); ++oe < Pe; )
        Ke[oe] = ce(Z[oe], oe, Z);
      return Ke;
    }
    function ra(Z, ce) {
      for (var oe = -1, Pe = ce.length, Ke = Z.length; ++oe < Pe; )
        Z[Ke + oe] = ce[oe];
      return Z;
    }
    function jy(Z, ce, oe, Pe) {
      var Ke = -1, mt = Z == null ? 0 : Z.length;
      for (Pe && mt && (oe = Z[++Ke]); ++Ke < mt; )
        oe = ce(oe, Z[Ke], Ke, Z);
      return oe;
    }
    function m5(Z, ce, oe, Pe) {
      var Ke = Z == null ? 0 : Z.length;
      for (Pe && Ke && (oe = Z[--Ke]); Ke--; )
        oe = ce(oe, Z[Ke], Ke, Z);
      return oe;
    }
    function Ly(Z, ce) {
      for (var oe = -1, Pe = Z == null ? 0 : Z.length; ++oe < Pe; )
        if (ce(Z[oe], oe, Z))
          return !0;
      return !1;
    }
    var g5 = By("length");
    function y5(Z) {
      return Z.split("");
    }
    function v5(Z) {
      return Z.match(Pz) || [];
    }
    function uO(Z, ce, oe) {
      var Pe;
      return oe(Z, function(Ke, mt, yn) {
        if (ce(Ke, mt, yn))
          return Pe = mt, !1;
      }), Pe;
    }
    function Fd(Z, ce, oe, Pe) {
      for (var Ke = Z.length, mt = oe + (Pe ? 1 : -1); Pe ? mt-- : ++mt < Ke; )
        if (ce(Z[mt], mt, Z))
          return mt;
      return -1;
    }
    function ol(Z, ce, oe) {
      return ce === ce ? k5(Z, ce, oe) : Fd(Z, fO, oe);
    }
    function b5(Z, ce, oe, Pe) {
      for (var Ke = oe - 1, mt = Z.length; ++Ke < mt; )
        if (Pe(Z[Ke], ce))
          return Ke;
      return -1;
    }
    function fO(Z) {
      return Z !== Z;
    }
    function dO(Z, ce) {
      var oe = Z == null ? 0 : Z.length;
      return oe ? Wy(Z, ce) / oe : U;
    }
    function By(Z) {
      return function(ce) {
        return ce == null ? n : ce[Z];
      };
    }
    function Fy(Z) {
      return function(ce) {
        return Z == null ? n : Z[ce];
      };
    }
    function hO(Z, ce, oe, Pe, Ke) {
      return Ke(Z, function(mt, yn, kt) {
        oe = Pe ? (Pe = !1, mt) : ce(oe, mt, yn, kt);
      }), oe;
    }
    function x5(Z, ce) {
      var oe = Z.length;
      for (Z.sort(ce); oe--; )
        Z[oe] = Z[oe].value;
      return Z;
    }
    function Wy(Z, ce) {
      for (var oe, Pe = -1, Ke = Z.length; ++Pe < Ke; ) {
        var mt = ce(Z[Pe]);
        mt !== n && (oe = oe === n ? mt : oe + mt);
      }
      return oe;
    }
    function zy(Z, ce) {
      for (var oe = -1, Pe = Array(Z); ++oe < Z; )
        Pe[oe] = ce(oe);
      return Pe;
    }
    function w5(Z, ce) {
      return Gt(ce, function(oe) {
        return [oe, Z[oe]];
      });
    }
    function pO(Z) {
      return Z && Z.slice(0, vO(Z) + 1).replace(Cy, "");
    }
    function Cr(Z) {
      return function(ce) {
        return Z(ce);
      };
    }
    function Vy(Z, ce) {
      return Gt(ce, function(oe) {
        return Z[oe];
      });
    }
    function nu(Z, ce) {
      return Z.has(ce);
    }
    function mO(Z, ce) {
      for (var oe = -1, Pe = Z.length; ++oe < Pe && ol(ce, Z[oe], 0) > -1; )
        ;
      return oe;
    }
    function gO(Z, ce) {
      for (var oe = Z.length; oe-- && ol(ce, Z[oe], 0) > -1; )
        ;
      return oe;
    }
    function _5(Z, ce) {
      for (var oe = Z.length, Pe = 0; oe--; )
        Z[oe] === ce && ++Pe;
      return Pe;
    }
    var S5 = Fy(a5), O5 = Fy(s5);
    function A5(Z) {
      return "\\" + c5[Z];
    }
    function P5(Z, ce) {
      return Z == null ? n : Z[ce];
    }
    function al(Z) {
      return n5.test(Z);
    }
    function T5(Z) {
      return r5.test(Z);
    }
    function C5(Z) {
      for (var ce, oe = []; !(ce = Z.next()).done; )
        oe.push(ce.value);
      return oe;
    }
    function Uy(Z) {
      var ce = -1, oe = Array(Z.size);
      return Z.forEach(function(Pe, Ke) {
        oe[++ce] = [Ke, Pe];
      }), oe;
    }
    function yO(Z, ce) {
      return function(oe) {
        return Z(ce(oe));
      };
    }
    function ia(Z, ce) {
      for (var oe = -1, Pe = Z.length, Ke = 0, mt = []; ++oe < Pe; ) {
        var yn = Z[oe];
        (yn === ce || yn === f) && (Z[oe] = f, mt[Ke++] = oe);
      }
      return mt;
    }
    function Wd(Z) {
      var ce = -1, oe = Array(Z.size);
      return Z.forEach(function(Pe) {
        oe[++ce] = Pe;
      }), oe;
    }
    function E5(Z) {
      var ce = -1, oe = Array(Z.size);
      return Z.forEach(function(Pe) {
        oe[++ce] = [Pe, Pe];
      }), oe;
    }
    function k5(Z, ce, oe) {
      for (var Pe = oe - 1, Ke = Z.length; ++Pe < Ke; )
        if (Z[Pe] === ce)
          return Pe;
      return -1;
    }
    function M5(Z, ce, oe) {
      for (var Pe = oe + 1; Pe--; )
        if (Z[Pe] === ce)
          return Pe;
      return Pe;
    }
    function sl(Z) {
      return al(Z) ? $5(Z) : g5(Z);
    }
    function mi(Z) {
      return al(Z) ? D5(Z) : y5(Z);
    }
    function vO(Z) {
      for (var ce = Z.length; ce-- && _z.test(Z.charAt(ce)); )
        ;
      return ce;
    }
    var N5 = Fy(l5);
    function $5(Z) {
      for (var ce = $y.lastIndex = 0; $y.test(Z); )
        ++ce;
      return ce;
    }
    function D5(Z) {
      return Z.match($y) || [];
    }
    function I5(Z) {
      return Z.match(t5) || [];
    }
    var R5 = function Z(ce) {
      ce = ce == null ? Rn : ll.defaults(Rn.Object(), ce, ll.pick(Rn, i5));
      var oe = ce.Array, Pe = ce.Date, Ke = ce.Error, mt = ce.Function, yn = ce.Math, kt = ce.Object, Ky = ce.RegExp, j5 = ce.String, Zr = ce.TypeError, zd = oe.prototype, L5 = mt.prototype, cl = kt.prototype, Vd = ce["__core-js_shared__"], Ud = L5.toString, Ot = cl.hasOwnProperty, B5 = 0, bO = function() {
        var u = /[^.]+$/.exec(Vd && Vd.keys && Vd.keys.IE_PROTO || "");
        return u ? "Symbol(src)_1." + u : "";
      }(), Kd = cl.toString, F5 = Ud.call(kt), W5 = Rn._, z5 = Ky(
        "^" + Ud.call(Ot).replace(Ty, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Hd = nO ? ce.Buffer : n, oa = ce.Symbol, Gd = ce.Uint8Array, xO = Hd ? Hd.allocUnsafe : n, Yd = yO(kt.getPrototypeOf, kt), wO = kt.create, _O = cl.propertyIsEnumerable, qd = zd.splice, SO = oa ? oa.isConcatSpreadable : n, ru = oa ? oa.iterator : n, Ja = oa ? oa.toStringTag : n, Xd = function() {
        try {
          var u = rs(kt, "defineProperty");
          return u({}, "", {}), u;
        } catch {
        }
      }(), V5 = ce.clearTimeout !== Rn.clearTimeout && ce.clearTimeout, U5 = Pe && Pe.now !== Rn.Date.now && Pe.now, K5 = ce.setTimeout !== Rn.setTimeout && ce.setTimeout, Zd = yn.ceil, Jd = yn.floor, Hy = kt.getOwnPropertySymbols, H5 = Hd ? Hd.isBuffer : n, OO = ce.isFinite, G5 = zd.join, Y5 = yO(kt.keys, kt), vn = yn.max, Yn = yn.min, q5 = Pe.now, X5 = ce.parseInt, AO = yn.random, Z5 = zd.reverse, Gy = rs(ce, "DataView"), iu = rs(ce, "Map"), Yy = rs(ce, "Promise"), ul = rs(ce, "Set"), ou = rs(ce, "WeakMap"), au = rs(kt, "create"), Qd = ou && new ou(), fl = {}, J5 = is(Gy), Q5 = is(iu), e3 = is(Yy), t3 = is(ul), n3 = is(ou), eh = oa ? oa.prototype : n, su = eh ? eh.valueOf : n, PO = eh ? eh.toString : n;
      function R(u) {
        if (en(u) && !Ge(u) && !(u instanceof lt)) {
          if (u instanceof Jr)
            return u;
          if (Ot.call(u, "__wrapped__"))
            return TA(u);
        }
        return new Jr(u);
      }
      var dl = /* @__PURE__ */ function() {
        function u() {
        }
        return function(h) {
          if (!Zt(h))
            return {};
          if (wO)
            return wO(h);
          u.prototype = h;
          var b = new u();
          return u.prototype = n, b;
        };
      }();
      function th() {
      }
      function Jr(u, h) {
        this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!h, this.__index__ = 0, this.__values__ = n;
      }
      R.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: tu,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: yz,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: IS,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: R
        }
      }, R.prototype = th.prototype, R.prototype.constructor = R, Jr.prototype = dl(th.prototype), Jr.prototype.constructor = Jr;
      function lt(u) {
        this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Y, this.__views__ = [];
      }
      function r3() {
        var u = new lt(this.__wrapped__);
        return u.__actions__ = mr(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = mr(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = mr(this.__views__), u;
      }
      function i3() {
        if (this.__filtered__) {
          var u = new lt(this);
          u.__dir__ = -1, u.__filtered__ = !0;
        } else
          u = this.clone(), u.__dir__ *= -1;
        return u;
      }
      function o3() {
        var u = this.__wrapped__.value(), h = this.__dir__, b = Ge(u), P = h < 0, M = b ? u.length : 0, j = yV(0, M, this.__views__), K = j.start, q = j.end, J = q - K, de = P ? q : K - 1, he = this.__iteratees__, ge = he.length, xe = 0, Ce = Yn(J, this.__takeCount__);
        if (!b || !P && M == J && Ce == J)
          return XO(u, this.__actions__);
        var De = [];
        e:
          for (; J-- && xe < Ce; ) {
            de += h;
            for (var et = -1, Ie = u[de]; ++et < ge; ) {
              var it = he[et], ct = it.iteratee, Mr = it.type, ar = ct(Ie);
              if (Mr == F)
                Ie = ar;
              else if (!ar) {
                if (Mr == L)
                  continue e;
                break e;
              }
            }
            De[xe++] = Ie;
          }
        return De;
      }
      lt.prototype = dl(th.prototype), lt.prototype.constructor = lt;
      function Qa(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.clear(); ++h < b; ) {
          var P = u[h];
          this.set(P[0], P[1]);
        }
      }
      function a3() {
        this.__data__ = au ? au(null) : {}, this.size = 0;
      }
      function s3(u) {
        var h = this.has(u) && delete this.__data__[u];
        return this.size -= h ? 1 : 0, h;
      }
      function l3(u) {
        var h = this.__data__;
        if (au) {
          var b = h[u];
          return b === l ? n : b;
        }
        return Ot.call(h, u) ? h[u] : n;
      }
      function c3(u) {
        var h = this.__data__;
        return au ? h[u] !== n : Ot.call(h, u);
      }
      function u3(u, h) {
        var b = this.__data__;
        return this.size += this.has(u) ? 0 : 1, b[u] = au && h === n ? l : h, this;
      }
      Qa.prototype.clear = a3, Qa.prototype.delete = s3, Qa.prototype.get = l3, Qa.prototype.has = c3, Qa.prototype.set = u3;
      function so(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.clear(); ++h < b; ) {
          var P = u[h];
          this.set(P[0], P[1]);
        }
      }
      function f3() {
        this.__data__ = [], this.size = 0;
      }
      function d3(u) {
        var h = this.__data__, b = nh(h, u);
        if (b < 0)
          return !1;
        var P = h.length - 1;
        return b == P ? h.pop() : qd.call(h, b, 1), --this.size, !0;
      }
      function h3(u) {
        var h = this.__data__, b = nh(h, u);
        return b < 0 ? n : h[b][1];
      }
      function p3(u) {
        return nh(this.__data__, u) > -1;
      }
      function m3(u, h) {
        var b = this.__data__, P = nh(b, u);
        return P < 0 ? (++this.size, b.push([u, h])) : b[P][1] = h, this;
      }
      so.prototype.clear = f3, so.prototype.delete = d3, so.prototype.get = h3, so.prototype.has = p3, so.prototype.set = m3;
      function lo(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.clear(); ++h < b; ) {
          var P = u[h];
          this.set(P[0], P[1]);
        }
      }
      function g3() {
        this.size = 0, this.__data__ = {
          hash: new Qa(),
          map: new (iu || so)(),
          string: new Qa()
        };
      }
      function y3(u) {
        var h = ph(this, u).delete(u);
        return this.size -= h ? 1 : 0, h;
      }
      function v3(u) {
        return ph(this, u).get(u);
      }
      function b3(u) {
        return ph(this, u).has(u);
      }
      function x3(u, h) {
        var b = ph(this, u), P = b.size;
        return b.set(u, h), this.size += b.size == P ? 0 : 1, this;
      }
      lo.prototype.clear = g3, lo.prototype.delete = y3, lo.prototype.get = v3, lo.prototype.has = b3, lo.prototype.set = x3;
      function es(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.__data__ = new lo(); ++h < b; )
          this.add(u[h]);
      }
      function w3(u) {
        return this.__data__.set(u, l), this;
      }
      function _3(u) {
        return this.__data__.has(u);
      }
      es.prototype.add = es.prototype.push = w3, es.prototype.has = _3;
      function gi(u) {
        var h = this.__data__ = new so(u);
        this.size = h.size;
      }
      function S3() {
        this.__data__ = new so(), this.size = 0;
      }
      function O3(u) {
        var h = this.__data__, b = h.delete(u);
        return this.size = h.size, b;
      }
      function A3(u) {
        return this.__data__.get(u);
      }
      function P3(u) {
        return this.__data__.has(u);
      }
      function T3(u, h) {
        var b = this.__data__;
        if (b instanceof so) {
          var P = b.__data__;
          if (!iu || P.length < i - 1)
            return P.push([u, h]), this.size = ++b.size, this;
          b = this.__data__ = new lo(P);
        }
        return b.set(u, h), this.size = b.size, this;
      }
      gi.prototype.clear = S3, gi.prototype.delete = O3, gi.prototype.get = A3, gi.prototype.has = P3, gi.prototype.set = T3;
      function TO(u, h) {
        var b = Ge(u), P = !b && os(u), M = !b && !P && ua(u), j = !b && !P && !M && gl(u), K = b || P || M || j, q = K ? zy(u.length, j5) : [], J = q.length;
        for (var de in u)
          (h || Ot.call(u, de)) && !(K && // Safari 9 has enumerable `arguments.length` in strict mode.
          (de == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          M && (de == "offset" || de == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          j && (de == "buffer" || de == "byteLength" || de == "byteOffset") || // Skip index properties.
          ho(de, J))) && q.push(de);
        return q;
      }
      function CO(u) {
        var h = u.length;
        return h ? u[ov(0, h - 1)] : n;
      }
      function C3(u, h) {
        return mh(mr(u), ts(h, 0, u.length));
      }
      function E3(u) {
        return mh(mr(u));
      }
      function qy(u, h, b) {
        (b !== n && !yi(u[h], b) || b === n && !(h in u)) && co(u, h, b);
      }
      function lu(u, h, b) {
        var P = u[h];
        (!(Ot.call(u, h) && yi(P, b)) || b === n && !(h in u)) && co(u, h, b);
      }
      function nh(u, h) {
        for (var b = u.length; b--; )
          if (yi(u[b][0], h))
            return b;
        return -1;
      }
      function k3(u, h, b, P) {
        return aa(u, function(M, j, K) {
          h(P, M, b(M), K);
        }), P;
      }
      function EO(u, h) {
        return u && ji(h, Tn(h), u);
      }
      function M3(u, h) {
        return u && ji(h, yr(h), u);
      }
      function co(u, h, b) {
        h == "__proto__" && Xd ? Xd(u, h, {
          configurable: !0,
          enumerable: !0,
          value: b,
          writable: !0
        }) : u[h] = b;
      }
      function Xy(u, h) {
        for (var b = -1, P = h.length, M = oe(P), j = u == null; ++b < P; )
          M[b] = j ? n : kv(u, h[b]);
        return M;
      }
      function ts(u, h, b) {
        return u === u && (b !== n && (u = u <= b ? u : b), h !== n && (u = u >= h ? u : h)), u;
      }
      function Qr(u, h, b, P, M, j) {
        var K, q = h & d, J = h & p, de = h & m;
        if (b && (K = M ? b(u, P, M, j) : b(u)), K !== n)
          return K;
        if (!Zt(u))
          return u;
        var he = Ge(u);
        if (he) {
          if (K = bV(u), !q)
            return mr(u, K);
        } else {
          var ge = qn(u), xe = ge == X || ge == Fe;
          if (ua(u))
            return QO(u, q);
          if (ge == at || ge == ue || xe && !M) {
            if (K = J || xe ? {} : vA(u), !q)
              return J ? lV(u, M3(K, u)) : sV(u, EO(K, u));
          } else {
            if (!Dt[ge])
              return M ? u : {};
            K = xV(u, ge, q);
          }
        }
        j || (j = new gi());
        var Ce = j.get(u);
        if (Ce)
          return Ce;
        j.set(u, K), GA(u) ? u.forEach(function(Ie) {
          K.add(Qr(Ie, h, b, Ie, u, j));
        }) : KA(u) && u.forEach(function(Ie, it) {
          K.set(it, Qr(Ie, h, b, it, u, j));
        });
        var De = de ? J ? gv : mv : J ? yr : Tn, et = he ? n : De(u);
        return Xr(et || u, function(Ie, it) {
          et && (it = Ie, Ie = u[it]), lu(K, it, Qr(Ie, h, b, it, u, j));
        }), K;
      }
      function N3(u) {
        var h = Tn(u);
        return function(b) {
          return kO(b, u, h);
        };
      }
      function kO(u, h, b) {
        var P = b.length;
        if (u == null)
          return !P;
        for (u = kt(u); P--; ) {
          var M = b[P], j = h[M], K = u[M];
          if (K === n && !(M in u) || !j(K))
            return !1;
        }
        return !0;
      }
      function MO(u, h, b) {
        if (typeof u != "function")
          throw new Zr(a);
        return mu(function() {
          u.apply(n, b);
        }, h);
      }
      function cu(u, h, b, P) {
        var M = -1, j = Bd, K = !0, q = u.length, J = [], de = h.length;
        if (!q)
          return J;
        b && (h = Gt(h, Cr(b))), P ? (j = Ry, K = !1) : h.length >= i && (j = nu, K = !1, h = new es(h));
        e:
          for (; ++M < q; ) {
            var he = u[M], ge = b == null ? he : b(he);
            if (he = P || he !== 0 ? he : 0, K && ge === ge) {
              for (var xe = de; xe--; )
                if (h[xe] === ge)
                  continue e;
              J.push(he);
            } else j(h, ge, P) || J.push(he);
          }
        return J;
      }
      var aa = iA(Ri), NO = iA(Jy, !0);
      function $3(u, h) {
        var b = !0;
        return aa(u, function(P, M, j) {
          return b = !!h(P, M, j), b;
        }), b;
      }
      function rh(u, h, b) {
        for (var P = -1, M = u.length; ++P < M; ) {
          var j = u[P], K = h(j);
          if (K != null && (q === n ? K === K && !kr(K) : b(K, q)))
            var q = K, J = j;
        }
        return J;
      }
      function D3(u, h, b, P) {
        var M = u.length;
        for (b = qe(b), b < 0 && (b = -b > M ? 0 : M + b), P = P === n || P > M ? M : qe(P), P < 0 && (P += M), P = b > P ? 0 : qA(P); b < P; )
          u[b++] = h;
        return u;
      }
      function $O(u, h) {
        var b = [];
        return aa(u, function(P, M, j) {
          h(P, M, j) && b.push(P);
        }), b;
      }
      function jn(u, h, b, P, M) {
        var j = -1, K = u.length;
        for (b || (b = _V), M || (M = []); ++j < K; ) {
          var q = u[j];
          h > 0 && b(q) ? h > 1 ? jn(q, h - 1, b, P, M) : ra(M, q) : P || (M[M.length] = q);
        }
        return M;
      }
      var Zy = oA(), DO = oA(!0);
      function Ri(u, h) {
        return u && Zy(u, h, Tn);
      }
      function Jy(u, h) {
        return u && DO(u, h, Tn);
      }
      function ih(u, h) {
        return na(h, function(b) {
          return po(u[b]);
        });
      }
      function ns(u, h) {
        h = la(h, u);
        for (var b = 0, P = h.length; u != null && b < P; )
          u = u[Li(h[b++])];
        return b && b == P ? u : n;
      }
      function IO(u, h, b) {
        var P = h(u);
        return Ge(u) ? P : ra(P, b(u));
      }
      function ir(u) {
        return u == null ? u === n ? pt : rt : Ja && Ja in kt(u) ? gV(u) : EV(u);
      }
      function Qy(u, h) {
        return u > h;
      }
      function I3(u, h) {
        return u != null && Ot.call(u, h);
      }
      function R3(u, h) {
        return u != null && h in kt(u);
      }
      function j3(u, h, b) {
        return u >= Yn(h, b) && u < vn(h, b);
      }
      function ev(u, h, b) {
        for (var P = b ? Ry : Bd, M = u[0].length, j = u.length, K = j, q = oe(j), J = 1 / 0, de = []; K--; ) {
          var he = u[K];
          K && h && (he = Gt(he, Cr(h))), J = Yn(he.length, J), q[K] = !b && (h || M >= 120 && he.length >= 120) ? new es(K && he) : n;
        }
        he = u[0];
        var ge = -1, xe = q[0];
        e:
          for (; ++ge < M && de.length < J; ) {
            var Ce = he[ge], De = h ? h(Ce) : Ce;
            if (Ce = b || Ce !== 0 ? Ce : 0, !(xe ? nu(xe, De) : P(de, De, b))) {
              for (K = j; --K; ) {
                var et = q[K];
                if (!(et ? nu(et, De) : P(u[K], De, b)))
                  continue e;
              }
              xe && xe.push(De), de.push(Ce);
            }
          }
        return de;
      }
      function L3(u, h, b, P) {
        return Ri(u, function(M, j, K) {
          h(P, b(M), j, K);
        }), P;
      }
      function uu(u, h, b) {
        h = la(h, u), u = _A(u, h);
        var P = u == null ? u : u[Li(ti(h))];
        return P == null ? n : Tr(P, u, b);
      }
      function RO(u) {
        return en(u) && ir(u) == ue;
      }
      function B3(u) {
        return en(u) && ir(u) == Pn;
      }
      function F3(u) {
        return en(u) && ir(u) == Q;
      }
      function fu(u, h, b, P, M) {
        return u === h ? !0 : u == null || h == null || !en(u) && !en(h) ? u !== u && h !== h : W3(u, h, b, P, fu, M);
      }
      function W3(u, h, b, P, M, j) {
        var K = Ge(u), q = Ge(h), J = K ? ae : qn(u), de = q ? ae : qn(h);
        J = J == ue ? at : J, de = de == ue ? at : de;
        var he = J == at, ge = de == at, xe = J == de;
        if (xe && ua(u)) {
          if (!ua(h))
            return !1;
          K = !0, he = !1;
        }
        if (xe && !he)
          return j || (j = new gi()), K || gl(u) ? mA(u, h, b, P, M, j) : pV(u, h, J, b, P, M, j);
        if (!(b & g)) {
          var Ce = he && Ot.call(u, "__wrapped__"), De = ge && Ot.call(h, "__wrapped__");
          if (Ce || De) {
            var et = Ce ? u.value() : u, Ie = De ? h.value() : h;
            return j || (j = new gi()), M(et, Ie, b, P, j);
          }
        }
        return xe ? (j || (j = new gi()), mV(u, h, b, P, M, j)) : !1;
      }
      function z3(u) {
        return en(u) && qn(u) == pe;
      }
      function tv(u, h, b, P) {
        var M = b.length, j = M, K = !P;
        if (u == null)
          return !j;
        for (u = kt(u); M--; ) {
          var q = b[M];
          if (K && q[2] ? q[1] !== u[q[0]] : !(q[0] in u))
            return !1;
        }
        for (; ++M < j; ) {
          q = b[M];
          var J = q[0], de = u[J], he = q[1];
          if (K && q[2]) {
            if (de === n && !(J in u))
              return !1;
          } else {
            var ge = new gi();
            if (P)
              var xe = P(de, he, J, u, h, ge);
            if (!(xe === n ? fu(he, de, g | v, P, ge) : xe))
              return !1;
          }
        }
        return !0;
      }
      function jO(u) {
        if (!Zt(u) || OV(u))
          return !1;
        var h = po(u) ? z5 : Nz;
        return h.test(is(u));
      }
      function V3(u) {
        return en(u) && ir(u) == st;
      }
      function U3(u) {
        return en(u) && qn(u) == Oe;
      }
      function K3(u) {
        return en(u) && wh(u.length) && !!Ft[ir(u)];
      }
      function LO(u) {
        return typeof u == "function" ? u : u == null ? vr : typeof u == "object" ? Ge(u) ? WO(u[0], u[1]) : FO(u) : aP(u);
      }
      function nv(u) {
        if (!pu(u))
          return Y5(u);
        var h = [];
        for (var b in kt(u))
          Ot.call(u, b) && b != "constructor" && h.push(b);
        return h;
      }
      function H3(u) {
        if (!Zt(u))
          return CV(u);
        var h = pu(u), b = [];
        for (var P in u)
          P == "constructor" && (h || !Ot.call(u, P)) || b.push(P);
        return b;
      }
      function rv(u, h) {
        return u < h;
      }
      function BO(u, h) {
        var b = -1, P = gr(u) ? oe(u.length) : [];
        return aa(u, function(M, j, K) {
          P[++b] = h(M, j, K);
        }), P;
      }
      function FO(u) {
        var h = vv(u);
        return h.length == 1 && h[0][2] ? xA(h[0][0], h[0][1]) : function(b) {
          return b === u || tv(b, u, h);
        };
      }
      function WO(u, h) {
        return xv(u) && bA(h) ? xA(Li(u), h) : function(b) {
          var P = kv(b, u);
          return P === n && P === h ? Mv(b, u) : fu(h, P, g | v);
        };
      }
      function oh(u, h, b, P, M) {
        u !== h && Zy(h, function(j, K) {
          if (M || (M = new gi()), Zt(j))
            G3(u, h, K, b, oh, P, M);
          else {
            var q = P ? P(_v(u, K), j, K + "", u, h, M) : n;
            q === n && (q = j), qy(u, K, q);
          }
        }, yr);
      }
      function G3(u, h, b, P, M, j, K) {
        var q = _v(u, b), J = _v(h, b), de = K.get(J);
        if (de) {
          qy(u, b, de);
          return;
        }
        var he = j ? j(q, J, b + "", u, h, K) : n, ge = he === n;
        if (ge) {
          var xe = Ge(J), Ce = !xe && ua(J), De = !xe && !Ce && gl(J);
          he = J, xe || Ce || De ? Ge(q) ? he = q : on(q) ? he = mr(q) : Ce ? (ge = !1, he = QO(J, !0)) : De ? (ge = !1, he = eA(J, !0)) : he = [] : gu(J) || os(J) ? (he = q, os(q) ? he = XA(q) : (!Zt(q) || po(q)) && (he = vA(J))) : ge = !1;
        }
        ge && (K.set(J, he), M(he, J, P, j, K), K.delete(J)), qy(u, b, he);
      }
      function zO(u, h) {
        var b = u.length;
        if (b)
          return h += h < 0 ? b : 0, ho(h, b) ? u[h] : n;
      }
      function VO(u, h, b) {
        h.length ? h = Gt(h, function(j) {
          return Ge(j) ? function(K) {
            return ns(K, j.length === 1 ? j[0] : j);
          } : j;
        }) : h = [vr];
        var P = -1;
        h = Gt(h, Cr(Ne()));
        var M = BO(u, function(j, K, q) {
          var J = Gt(h, function(de) {
            return de(j);
          });
          return { criteria: J, index: ++P, value: j };
        });
        return x5(M, function(j, K) {
          return aV(j, K, b);
        });
      }
      function Y3(u, h) {
        return UO(u, h, function(b, P) {
          return Mv(u, P);
        });
      }
      function UO(u, h, b) {
        for (var P = -1, M = h.length, j = {}; ++P < M; ) {
          var K = h[P], q = ns(u, K);
          b(q, K) && du(j, la(K, u), q);
        }
        return j;
      }
      function q3(u) {
        return function(h) {
          return ns(h, u);
        };
      }
      function iv(u, h, b, P) {
        var M = P ? b5 : ol, j = -1, K = h.length, q = u;
        for (u === h && (h = mr(h)), b && (q = Gt(u, Cr(b))); ++j < K; )
          for (var J = 0, de = h[j], he = b ? b(de) : de; (J = M(q, he, J, P)) > -1; )
            q !== u && qd.call(q, J, 1), qd.call(u, J, 1);
        return u;
      }
      function KO(u, h) {
        for (var b = u ? h.length : 0, P = b - 1; b--; ) {
          var M = h[b];
          if (b == P || M !== j) {
            var j = M;
            ho(M) ? qd.call(u, M, 1) : lv(u, M);
          }
        }
        return u;
      }
      function ov(u, h) {
        return u + Jd(AO() * (h - u + 1));
      }
      function X3(u, h, b, P) {
        for (var M = -1, j = vn(Zd((h - u) / (b || 1)), 0), K = oe(j); j--; )
          K[P ? j : ++M] = u, u += b;
        return K;
      }
      function av(u, h) {
        var b = "";
        if (!u || h < 1 || h > G)
          return b;
        do
          h % 2 && (b += u), h = Jd(h / 2), h && (u += u);
        while (h);
        return b;
      }
      function nt(u, h) {
        return Sv(wA(u, h, vr), u + "");
      }
      function Z3(u) {
        return CO(yl(u));
      }
      function J3(u, h) {
        var b = yl(u);
        return mh(b, ts(h, 0, b.length));
      }
      function du(u, h, b, P) {
        if (!Zt(u))
          return u;
        h = la(h, u);
        for (var M = -1, j = h.length, K = j - 1, q = u; q != null && ++M < j; ) {
          var J = Li(h[M]), de = b;
          if (J === "__proto__" || J === "constructor" || J === "prototype")
            return u;
          if (M != K) {
            var he = q[J];
            de = P ? P(he, J, q) : n, de === n && (de = Zt(he) ? he : ho(h[M + 1]) ? [] : {});
          }
          lu(q, J, de), q = q[J];
        }
        return u;
      }
      var HO = Qd ? function(u, h) {
        return Qd.set(u, h), u;
      } : vr, Q3 = Xd ? function(u, h) {
        return Xd(u, "toString", {
          configurable: !0,
          enumerable: !1,
          value: $v(h),
          writable: !0
        });
      } : vr;
      function eV(u) {
        return mh(yl(u));
      }
      function ei(u, h, b) {
        var P = -1, M = u.length;
        h < 0 && (h = -h > M ? 0 : M + h), b = b > M ? M : b, b < 0 && (b += M), M = h > b ? 0 : b - h >>> 0, h >>>= 0;
        for (var j = oe(M); ++P < M; )
          j[P] = u[P + h];
        return j;
      }
      function tV(u, h) {
        var b;
        return aa(u, function(P, M, j) {
          return b = h(P, M, j), !b;
        }), !!b;
      }
      function ah(u, h, b) {
        var P = 0, M = u == null ? P : u.length;
        if (typeof h == "number" && h === h && M <= ne) {
          for (; P < M; ) {
            var j = P + M >>> 1, K = u[j];
            K !== null && !kr(K) && (b ? K <= h : K < h) ? P = j + 1 : M = j;
          }
          return M;
        }
        return sv(u, h, vr, b);
      }
      function sv(u, h, b, P) {
        var M = 0, j = u == null ? 0 : u.length;
        if (j === 0)
          return 0;
        h = b(h);
        for (var K = h !== h, q = h === null, J = kr(h), de = h === n; M < j; ) {
          var he = Jd((M + j) / 2), ge = b(u[he]), xe = ge !== n, Ce = ge === null, De = ge === ge, et = kr(ge);
          if (K)
            var Ie = P || De;
          else de ? Ie = De && (P || xe) : q ? Ie = De && xe && (P || !Ce) : J ? Ie = De && xe && !Ce && (P || !et) : Ce || et ? Ie = !1 : Ie = P ? ge <= h : ge < h;
          Ie ? M = he + 1 : j = he;
        }
        return Yn(j, te);
      }
      function GO(u, h) {
        for (var b = -1, P = u.length, M = 0, j = []; ++b < P; ) {
          var K = u[b], q = h ? h(K) : K;
          if (!b || !yi(q, J)) {
            var J = q;
            j[M++] = K === 0 ? 0 : K;
          }
        }
        return j;
      }
      function YO(u) {
        return typeof u == "number" ? u : kr(u) ? U : +u;
      }
      function Er(u) {
        if (typeof u == "string")
          return u;
        if (Ge(u))
          return Gt(u, Er) + "";
        if (kr(u))
          return PO ? PO.call(u) : "";
        var h = u + "";
        return h == "0" && 1 / u == -z ? "-0" : h;
      }
      function sa(u, h, b) {
        var P = -1, M = Bd, j = u.length, K = !0, q = [], J = q;
        if (b)
          K = !1, M = Ry;
        else if (j >= i) {
          var de = h ? null : dV(u);
          if (de)
            return Wd(de);
          K = !1, M = nu, J = new es();
        } else
          J = h ? [] : q;
        e:
          for (; ++P < j; ) {
            var he = u[P], ge = h ? h(he) : he;
            if (he = b || he !== 0 ? he : 0, K && ge === ge) {
              for (var xe = J.length; xe--; )
                if (J[xe] === ge)
                  continue e;
              h && J.push(ge), q.push(he);
            } else M(J, ge, b) || (J !== q && J.push(ge), q.push(he));
          }
        return q;
      }
      function lv(u, h) {
        return h = la(h, u), u = _A(u, h), u == null || delete u[Li(ti(h))];
      }
      function qO(u, h, b, P) {
        return du(u, h, b(ns(u, h)), P);
      }
      function sh(u, h, b, P) {
        for (var M = u.length, j = P ? M : -1; (P ? j-- : ++j < M) && h(u[j], j, u); )
          ;
        return b ? ei(u, P ? 0 : j, P ? j + 1 : M) : ei(u, P ? j + 1 : 0, P ? M : j);
      }
      function XO(u, h) {
        var b = u;
        return b instanceof lt && (b = b.value()), jy(h, function(P, M) {
          return M.func.apply(M.thisArg, ra([P], M.args));
        }, b);
      }
      function cv(u, h, b) {
        var P = u.length;
        if (P < 2)
          return P ? sa(u[0]) : [];
        for (var M = -1, j = oe(P); ++M < P; )
          for (var K = u[M], q = -1; ++q < P; )
            q != M && (j[M] = cu(j[M] || K, u[q], h, b));
        return sa(jn(j, 1), h, b);
      }
      function ZO(u, h, b) {
        for (var P = -1, M = u.length, j = h.length, K = {}; ++P < M; ) {
          var q = P < j ? h[P] : n;
          b(K, u[P], q);
        }
        return K;
      }
      function uv(u) {
        return on(u) ? u : [];
      }
      function fv(u) {
        return typeof u == "function" ? u : vr;
      }
      function la(u, h) {
        return Ge(u) ? u : xv(u, h) ? [u] : PA(yt(u));
      }
      var nV = nt;
      function ca(u, h, b) {
        var P = u.length;
        return b = b === n ? P : b, !h && b >= P ? u : ei(u, h, b);
      }
      var JO = V5 || function(u) {
        return Rn.clearTimeout(u);
      };
      function QO(u, h) {
        if (h)
          return u.slice();
        var b = u.length, P = xO ? xO(b) : new u.constructor(b);
        return u.copy(P), P;
      }
      function dv(u) {
        var h = new u.constructor(u.byteLength);
        return new Gd(h).set(new Gd(u)), h;
      }
      function rV(u, h) {
        var b = h ? dv(u.buffer) : u.buffer;
        return new u.constructor(b, u.byteOffset, u.byteLength);
      }
      function iV(u) {
        var h = new u.constructor(u.source, RS.exec(u));
        return h.lastIndex = u.lastIndex, h;
      }
      function oV(u) {
        return su ? kt(su.call(u)) : {};
      }
      function eA(u, h) {
        var b = h ? dv(u.buffer) : u.buffer;
        return new u.constructor(b, u.byteOffset, u.length);
      }
      function tA(u, h) {
        if (u !== h) {
          var b = u !== n, P = u === null, M = u === u, j = kr(u), K = h !== n, q = h === null, J = h === h, de = kr(h);
          if (!q && !de && !j && u > h || j && K && J && !q && !de || P && K && J || !b && J || !M)
            return 1;
          if (!P && !j && !de && u < h || de && b && M && !P && !j || q && b && M || !K && M || !J)
            return -1;
        }
        return 0;
      }
      function aV(u, h, b) {
        for (var P = -1, M = u.criteria, j = h.criteria, K = M.length, q = b.length; ++P < K; ) {
          var J = tA(M[P], j[P]);
          if (J) {
            if (P >= q)
              return J;
            var de = b[P];
            return J * (de == "desc" ? -1 : 1);
          }
        }
        return u.index - h.index;
      }
      function nA(u, h, b, P) {
        for (var M = -1, j = u.length, K = b.length, q = -1, J = h.length, de = vn(j - K, 0), he = oe(J + de), ge = !P; ++q < J; )
          he[q] = h[q];
        for (; ++M < K; )
          (ge || M < j) && (he[b[M]] = u[M]);
        for (; de--; )
          he[q++] = u[M++];
        return he;
      }
      function rA(u, h, b, P) {
        for (var M = -1, j = u.length, K = -1, q = b.length, J = -1, de = h.length, he = vn(j - q, 0), ge = oe(he + de), xe = !P; ++M < he; )
          ge[M] = u[M];
        for (var Ce = M; ++J < de; )
          ge[Ce + J] = h[J];
        for (; ++K < q; )
          (xe || M < j) && (ge[Ce + b[K]] = u[M++]);
        return ge;
      }
      function mr(u, h) {
        var b = -1, P = u.length;
        for (h || (h = oe(P)); ++b < P; )
          h[b] = u[b];
        return h;
      }
      function ji(u, h, b, P) {
        var M = !b;
        b || (b = {});
        for (var j = -1, K = h.length; ++j < K; ) {
          var q = h[j], J = P ? P(b[q], u[q], q, b, u) : n;
          J === n && (J = u[q]), M ? co(b, q, J) : lu(b, q, J);
        }
        return b;
      }
      function sV(u, h) {
        return ji(u, bv(u), h);
      }
      function lV(u, h) {
        return ji(u, gA(u), h);
      }
      function lh(u, h) {
        return function(b, P) {
          var M = Ge(b) ? h5 : k3, j = h ? h() : {};
          return M(b, u, Ne(P, 2), j);
        };
      }
      function hl(u) {
        return nt(function(h, b) {
          var P = -1, M = b.length, j = M > 1 ? b[M - 1] : n, K = M > 2 ? b[2] : n;
          for (j = u.length > 3 && typeof j == "function" ? (M--, j) : n, K && or(b[0], b[1], K) && (j = M < 3 ? n : j, M = 1), h = kt(h); ++P < M; ) {
            var q = b[P];
            q && u(h, q, P, j);
          }
          return h;
        });
      }
      function iA(u, h) {
        return function(b, P) {
          if (b == null)
            return b;
          if (!gr(b))
            return u(b, P);
          for (var M = b.length, j = h ? M : -1, K = kt(b); (h ? j-- : ++j < M) && P(K[j], j, K) !== !1; )
            ;
          return b;
        };
      }
      function oA(u) {
        return function(h, b, P) {
          for (var M = -1, j = kt(h), K = P(h), q = K.length; q--; ) {
            var J = K[u ? q : ++M];
            if (b(j[J], J, j) === !1)
              break;
          }
          return h;
        };
      }
      function cV(u, h, b) {
        var P = h & y, M = hu(u);
        function j() {
          var K = this && this !== Rn && this instanceof j ? M : u;
          return K.apply(P ? b : this, arguments);
        }
        return j;
      }
      function aA(u) {
        return function(h) {
          h = yt(h);
          var b = al(h) ? mi(h) : n, P = b ? b[0] : h.charAt(0), M = b ? ca(b, 1).join("") : h.slice(1);
          return P[u]() + M;
        };
      }
      function pl(u) {
        return function(h) {
          return jy(iP(rP(h).replace(Qz, "")), u, "");
        };
      }
      function hu(u) {
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return new u();
            case 1:
              return new u(h[0]);
            case 2:
              return new u(h[0], h[1]);
            case 3:
              return new u(h[0], h[1], h[2]);
            case 4:
              return new u(h[0], h[1], h[2], h[3]);
            case 5:
              return new u(h[0], h[1], h[2], h[3], h[4]);
            case 6:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5]);
            case 7:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5], h[6]);
          }
          var b = dl(u.prototype), P = u.apply(b, h);
          return Zt(P) ? P : b;
        };
      }
      function uV(u, h, b) {
        var P = hu(u);
        function M() {
          for (var j = arguments.length, K = oe(j), q = j, J = ml(M); q--; )
            K[q] = arguments[q];
          var de = j < 3 && K[0] !== J && K[j - 1] !== J ? [] : ia(K, J);
          if (j -= de.length, j < b)
            return fA(
              u,
              h,
              ch,
              M.placeholder,
              n,
              K,
              de,
              n,
              n,
              b - j
            );
          var he = this && this !== Rn && this instanceof M ? P : u;
          return Tr(he, this, K);
        }
        return M;
      }
      function sA(u) {
        return function(h, b, P) {
          var M = kt(h);
          if (!gr(h)) {
            var j = Ne(b, 3);
            h = Tn(h), b = function(q) {
              return j(M[q], q, M);
            };
          }
          var K = u(h, b, P);
          return K > -1 ? M[j ? h[K] : K] : n;
        };
      }
      function lA(u) {
        return fo(function(h) {
          var b = h.length, P = b, M = Jr.prototype.thru;
          for (u && h.reverse(); P--; ) {
            var j = h[P];
            if (typeof j != "function")
              throw new Zr(a);
            if (M && !K && hh(j) == "wrapper")
              var K = new Jr([], !0);
          }
          for (P = K ? P : b; ++P < b; ) {
            j = h[P];
            var q = hh(j), J = q == "wrapper" ? yv(j) : n;
            J && wv(J[0]) && J[1] == (T | S | _ | C) && !J[4].length && J[9] == 1 ? K = K[hh(J[0])].apply(K, J[3]) : K = j.length == 1 && wv(j) ? K[q]() : K.thru(j);
          }
          return function() {
            var de = arguments, he = de[0];
            if (K && de.length == 1 && Ge(he))
              return K.plant(he).value();
            for (var ge = 0, xe = b ? h[ge].apply(this, de) : he; ++ge < b; )
              xe = h[ge].call(this, xe);
            return xe;
          };
        });
      }
      function ch(u, h, b, P, M, j, K, q, J, de) {
        var he = h & T, ge = h & y, xe = h & x, Ce = h & (S | A), De = h & k, et = xe ? n : hu(u);
        function Ie() {
          for (var it = arguments.length, ct = oe(it), Mr = it; Mr--; )
            ct[Mr] = arguments[Mr];
          if (Ce)
            var ar = ml(Ie), Nr = _5(ct, ar);
          if (P && (ct = nA(ct, P, M, Ce)), j && (ct = rA(ct, j, K, Ce)), it -= Nr, Ce && it < de) {
            var an = ia(ct, ar);
            return fA(
              u,
              h,
              ch,
              Ie.placeholder,
              b,
              ct,
              an,
              q,
              J,
              de - it
            );
          }
          var vi = ge ? b : this, go = xe ? vi[u] : u;
          return it = ct.length, q ? ct = kV(ct, q) : De && it > 1 && ct.reverse(), he && J < it && (ct.length = J), this && this !== Rn && this instanceof Ie && (go = et || hu(go)), go.apply(vi, ct);
        }
        return Ie;
      }
      function cA(u, h) {
        return function(b, P) {
          return L3(b, u, h(P), {});
        };
      }
      function uh(u, h) {
        return function(b, P) {
          var M;
          if (b === n && P === n)
            return h;
          if (b !== n && (M = b), P !== n) {
            if (M === n)
              return P;
            typeof b == "string" || typeof P == "string" ? (b = Er(b), P = Er(P)) : (b = YO(b), P = YO(P)), M = u(b, P);
          }
          return M;
        };
      }
      function hv(u) {
        return fo(function(h) {
          return h = Gt(h, Cr(Ne())), nt(function(b) {
            var P = this;
            return u(h, function(M) {
              return Tr(M, P, b);
            });
          });
        });
      }
      function fh(u, h) {
        h = h === n ? " " : Er(h);
        var b = h.length;
        if (b < 2)
          return b ? av(h, u) : h;
        var P = av(h, Zd(u / sl(h)));
        return al(h) ? ca(mi(P), 0, u).join("") : P.slice(0, u);
      }
      function fV(u, h, b, P) {
        var M = h & y, j = hu(u);
        function K() {
          for (var q = -1, J = arguments.length, de = -1, he = P.length, ge = oe(he + J), xe = this && this !== Rn && this instanceof K ? j : u; ++de < he; )
            ge[de] = P[de];
          for (; J--; )
            ge[de++] = arguments[++q];
          return Tr(xe, M ? b : this, ge);
        }
        return K;
      }
      function uA(u) {
        return function(h, b, P) {
          return P && typeof P != "number" && or(h, b, P) && (b = P = n), h = mo(h), b === n ? (b = h, h = 0) : b = mo(b), P = P === n ? h < b ? 1 : -1 : mo(P), X3(h, b, P, u);
        };
      }
      function dh(u) {
        return function(h, b) {
          return typeof h == "string" && typeof b == "string" || (h = ni(h), b = ni(b)), u(h, b);
        };
      }
      function fA(u, h, b, P, M, j, K, q, J, de) {
        var he = h & S, ge = he ? K : n, xe = he ? n : K, Ce = he ? j : n, De = he ? n : j;
        h |= he ? _ : O, h &= ~(he ? O : _), h & w || (h &= ~(y | x));
        var et = [
          u,
          h,
          M,
          Ce,
          ge,
          De,
          xe,
          q,
          J,
          de
        ], Ie = b.apply(n, et);
        return wv(u) && SA(Ie, et), Ie.placeholder = P, OA(Ie, u, h);
      }
      function pv(u) {
        var h = yn[u];
        return function(b, P) {
          if (b = ni(b), P = P == null ? 0 : Yn(qe(P), 292), P && OO(b)) {
            var M = (yt(b) + "e").split("e"), j = h(M[0] + "e" + (+M[1] + P));
            return M = (yt(j) + "e").split("e"), +(M[0] + "e" + (+M[1] - P));
          }
          return h(b);
        };
      }
      var dV = ul && 1 / Wd(new ul([, -0]))[1] == z ? function(u) {
        return new ul(u);
      } : Rv;
      function dA(u) {
        return function(h) {
          var b = qn(h);
          return b == pe ? Uy(h) : b == Oe ? E5(h) : w5(h, u(h));
        };
      }
      function uo(u, h, b, P, M, j, K, q) {
        var J = h & x;
        if (!J && typeof u != "function")
          throw new Zr(a);
        var de = P ? P.length : 0;
        if (de || (h &= ~(_ | O), P = M = n), K = K === n ? K : vn(qe(K), 0), q = q === n ? q : qe(q), de -= M ? M.length : 0, h & O) {
          var he = P, ge = M;
          P = M = n;
        }
        var xe = J ? n : yv(u), Ce = [
          u,
          h,
          b,
          P,
          M,
          he,
          ge,
          j,
          K,
          q
        ];
        if (xe && TV(Ce, xe), u = Ce[0], h = Ce[1], b = Ce[2], P = Ce[3], M = Ce[4], q = Ce[9] = Ce[9] === n ? J ? 0 : u.length : vn(Ce[9] - de, 0), !q && h & (S | A) && (h &= ~(S | A)), !h || h == y)
          var De = cV(u, h, b);
        else h == S || h == A ? De = uV(u, h, q) : (h == _ || h == (y | _)) && !M.length ? De = fV(u, h, b, P) : De = ch.apply(n, Ce);
        var et = xe ? HO : SA;
        return OA(et(De, Ce), u, h);
      }
      function hA(u, h, b, P) {
        return u === n || yi(u, cl[b]) && !Ot.call(P, b) ? h : u;
      }
      function pA(u, h, b, P, M, j) {
        return Zt(u) && Zt(h) && (j.set(h, u), oh(u, h, n, pA, j), j.delete(h)), u;
      }
      function hV(u) {
        return gu(u) ? n : u;
      }
      function mA(u, h, b, P, M, j) {
        var K = b & g, q = u.length, J = h.length;
        if (q != J && !(K && J > q))
          return !1;
        var de = j.get(u), he = j.get(h);
        if (de && he)
          return de == h && he == u;
        var ge = -1, xe = !0, Ce = b & v ? new es() : n;
        for (j.set(u, h), j.set(h, u); ++ge < q; ) {
          var De = u[ge], et = h[ge];
          if (P)
            var Ie = K ? P(et, De, ge, h, u, j) : P(De, et, ge, u, h, j);
          if (Ie !== n) {
            if (Ie)
              continue;
            xe = !1;
            break;
          }
          if (Ce) {
            if (!Ly(h, function(it, ct) {
              if (!nu(Ce, ct) && (De === it || M(De, it, b, P, j)))
                return Ce.push(ct);
            })) {
              xe = !1;
              break;
            }
          } else if (!(De === et || M(De, et, b, P, j))) {
            xe = !1;
            break;
          }
        }
        return j.delete(u), j.delete(h), xe;
      }
      function pV(u, h, b, P, M, j, K) {
        switch (b) {
          case gn:
            if (u.byteLength != h.byteLength || u.byteOffset != h.byteOffset)
              return !1;
            u = u.buffer, h = h.buffer;
          case Pn:
            return !(u.byteLength != h.byteLength || !j(new Gd(u), new Gd(h)));
          case ie:
          case Q:
          case Be:
            return yi(+u, +h);
          case ve:
            return u.name == h.name && u.message == h.message;
          case st:
          case He:
            return u == h + "";
          case pe:
            var q = Uy;
          case Oe:
            var J = P & g;
            if (q || (q = Wd), u.size != h.size && !J)
              return !1;
            var de = K.get(u);
            if (de)
              return de == h;
            P |= v, K.set(u, h);
            var he = mA(q(u), q(h), P, M, j, K);
            return K.delete(u), he;
          case Xt:
            if (su)
              return su.call(u) == su.call(h);
        }
        return !1;
      }
      function mV(u, h, b, P, M, j) {
        var K = b & g, q = mv(u), J = q.length, de = mv(h), he = de.length;
        if (J != he && !K)
          return !1;
        for (var ge = J; ge--; ) {
          var xe = q[ge];
          if (!(K ? xe in h : Ot.call(h, xe)))
            return !1;
        }
        var Ce = j.get(u), De = j.get(h);
        if (Ce && De)
          return Ce == h && De == u;
        var et = !0;
        j.set(u, h), j.set(h, u);
        for (var Ie = K; ++ge < J; ) {
          xe = q[ge];
          var it = u[xe], ct = h[xe];
          if (P)
            var Mr = K ? P(ct, it, xe, h, u, j) : P(it, ct, xe, u, h, j);
          if (!(Mr === n ? it === ct || M(it, ct, b, P, j) : Mr)) {
            et = !1;
            break;
          }
          Ie || (Ie = xe == "constructor");
        }
        if (et && !Ie) {
          var ar = u.constructor, Nr = h.constructor;
          ar != Nr && "constructor" in u && "constructor" in h && !(typeof ar == "function" && ar instanceof ar && typeof Nr == "function" && Nr instanceof Nr) && (et = !1);
        }
        return j.delete(u), j.delete(h), et;
      }
      function fo(u) {
        return Sv(wA(u, n, kA), u + "");
      }
      function mv(u) {
        return IO(u, Tn, bv);
      }
      function gv(u) {
        return IO(u, yr, gA);
      }
      var yv = Qd ? function(u) {
        return Qd.get(u);
      } : Rv;
      function hh(u) {
        for (var h = u.name + "", b = fl[h], P = Ot.call(fl, h) ? b.length : 0; P--; ) {
          var M = b[P], j = M.func;
          if (j == null || j == u)
            return M.name;
        }
        return h;
      }
      function ml(u) {
        var h = Ot.call(R, "placeholder") ? R : u;
        return h.placeholder;
      }
      function Ne() {
        var u = R.iteratee || Dv;
        return u = u === Dv ? LO : u, arguments.length ? u(arguments[0], arguments[1]) : u;
      }
      function ph(u, h) {
        var b = u.__data__;
        return SV(h) ? b[typeof h == "string" ? "string" : "hash"] : b.map;
      }
      function vv(u) {
        for (var h = Tn(u), b = h.length; b--; ) {
          var P = h[b], M = u[P];
          h[b] = [P, M, bA(M)];
        }
        return h;
      }
      function rs(u, h) {
        var b = P5(u, h);
        return jO(b) ? b : n;
      }
      function gV(u) {
        var h = Ot.call(u, Ja), b = u[Ja];
        try {
          u[Ja] = n;
          var P = !0;
        } catch {
        }
        var M = Kd.call(u);
        return P && (h ? u[Ja] = b : delete u[Ja]), M;
      }
      var bv = Hy ? function(u) {
        return u == null ? [] : (u = kt(u), na(Hy(u), function(h) {
          return _O.call(u, h);
        }));
      } : jv, gA = Hy ? function(u) {
        for (var h = []; u; )
          ra(h, bv(u)), u = Yd(u);
        return h;
      } : jv, qn = ir;
      (Gy && qn(new Gy(new ArrayBuffer(1))) != gn || iu && qn(new iu()) != pe || Yy && qn(Yy.resolve()) != Gn || ul && qn(new ul()) != Oe || ou && qn(new ou()) != Qt) && (qn = function(u) {
        var h = ir(u), b = h == at ? u.constructor : n, P = b ? is(b) : "";
        if (P)
          switch (P) {
            case J5:
              return gn;
            case Q5:
              return pe;
            case e3:
              return Gn;
            case t3:
              return Oe;
            case n3:
              return Qt;
          }
        return h;
      });
      function yV(u, h, b) {
        for (var P = -1, M = b.length; ++P < M; ) {
          var j = b[P], K = j.size;
          switch (j.type) {
            case "drop":
              u += K;
              break;
            case "dropRight":
              h -= K;
              break;
            case "take":
              h = Yn(h, u + K);
              break;
            case "takeRight":
              u = vn(u, h - K);
              break;
          }
        }
        return { start: u, end: h };
      }
      function vV(u) {
        var h = u.match(Oz);
        return h ? h[1].split(Az) : [];
      }
      function yA(u, h, b) {
        h = la(h, u);
        for (var P = -1, M = h.length, j = !1; ++P < M; ) {
          var K = Li(h[P]);
          if (!(j = u != null && b(u, K)))
            break;
          u = u[K];
        }
        return j || ++P != M ? j : (M = u == null ? 0 : u.length, !!M && wh(M) && ho(K, M) && (Ge(u) || os(u)));
      }
      function bV(u) {
        var h = u.length, b = new u.constructor(h);
        return h && typeof u[0] == "string" && Ot.call(u, "index") && (b.index = u.index, b.input = u.input), b;
      }
      function vA(u) {
        return typeof u.constructor == "function" && !pu(u) ? dl(Yd(u)) : {};
      }
      function xV(u, h, b) {
        var P = u.constructor;
        switch (h) {
          case Pn:
            return dv(u);
          case ie:
          case Q:
            return new P(+u);
          case gn:
            return rV(u, b);
          case pr:
          case tt:
          case Ht:
          case St:
          case In:
          case Gr:
          case ao:
          case cn:
          case Pr:
            return eA(u, b);
          case pe:
            return new P();
          case Be:
          case He:
            return new P(u);
          case st:
            return iV(u);
          case Oe:
            return new P();
          case Xt:
            return oV(u);
        }
      }
      function wV(u, h) {
        var b = h.length;
        if (!b)
          return u;
        var P = b - 1;
        return h[P] = (b > 1 ? "& " : "") + h[P], h = h.join(b > 2 ? ", " : " "), u.replace(Sz, `{
/* [wrapped with ` + h + `] */
`);
      }
      function _V(u) {
        return Ge(u) || os(u) || !!(SO && u && u[SO]);
      }
      function ho(u, h) {
        var b = typeof u;
        return h = h ?? G, !!h && (b == "number" || b != "symbol" && Dz.test(u)) && u > -1 && u % 1 == 0 && u < h;
      }
      function or(u, h, b) {
        if (!Zt(b))
          return !1;
        var P = typeof h;
        return (P == "number" ? gr(b) && ho(h, b.length) : P == "string" && h in b) ? yi(b[h], u) : !1;
      }
      function xv(u, h) {
        if (Ge(u))
          return !1;
        var b = typeof u;
        return b == "number" || b == "symbol" || b == "boolean" || u == null || kr(u) ? !0 : bz.test(u) || !vz.test(u) || h != null && u in kt(h);
      }
      function SV(u) {
        var h = typeof u;
        return h == "string" || h == "number" || h == "symbol" || h == "boolean" ? u !== "__proto__" : u === null;
      }
      function wv(u) {
        var h = hh(u), b = R[h];
        if (typeof b != "function" || !(h in lt.prototype))
          return !1;
        if (u === b)
          return !0;
        var P = yv(b);
        return !!P && u === P[0];
      }
      function OV(u) {
        return !!bO && bO in u;
      }
      var AV = Vd ? po : Lv;
      function pu(u) {
        var h = u && u.constructor, b = typeof h == "function" && h.prototype || cl;
        return u === b;
      }
      function bA(u) {
        return u === u && !Zt(u);
      }
      function xA(u, h) {
        return function(b) {
          return b == null ? !1 : b[u] === h && (h !== n || u in kt(b));
        };
      }
      function PV(u) {
        var h = bh(u, function(P) {
          return b.size === c && b.clear(), P;
        }), b = h.cache;
        return h;
      }
      function TV(u, h) {
        var b = u[1], P = h[1], M = b | P, j = M < (y | x | T), K = P == T && b == S || P == T && b == C && u[7].length <= h[8] || P == (T | C) && h[7].length <= h[8] && b == S;
        if (!(j || K))
          return u;
        P & y && (u[2] = h[2], M |= b & y ? 0 : w);
        var q = h[3];
        if (q) {
          var J = u[3];
          u[3] = J ? nA(J, q, h[4]) : q, u[4] = J ? ia(u[3], f) : h[4];
        }
        return q = h[5], q && (J = u[5], u[5] = J ? rA(J, q, h[6]) : q, u[6] = J ? ia(u[5], f) : h[6]), q = h[7], q && (u[7] = q), P & T && (u[8] = u[8] == null ? h[8] : Yn(u[8], h[8])), u[9] == null && (u[9] = h[9]), u[0] = h[0], u[1] = M, u;
      }
      function CV(u) {
        var h = [];
        if (u != null)
          for (var b in kt(u))
            h.push(b);
        return h;
      }
      function EV(u) {
        return Kd.call(u);
      }
      function wA(u, h, b) {
        return h = vn(h === n ? u.length - 1 : h, 0), function() {
          for (var P = arguments, M = -1, j = vn(P.length - h, 0), K = oe(j); ++M < j; )
            K[M] = P[h + M];
          M = -1;
          for (var q = oe(h + 1); ++M < h; )
            q[M] = P[M];
          return q[h] = b(K), Tr(u, this, q);
        };
      }
      function _A(u, h) {
        return h.length < 2 ? u : ns(u, ei(h, 0, -1));
      }
      function kV(u, h) {
        for (var b = u.length, P = Yn(h.length, b), M = mr(u); P--; ) {
          var j = h[P];
          u[P] = ho(j, b) ? M[j] : n;
        }
        return u;
      }
      function _v(u, h) {
        if (!(h === "constructor" && typeof u[h] == "function") && h != "__proto__")
          return u[h];
      }
      var SA = AA(HO), mu = K5 || function(u, h) {
        return Rn.setTimeout(u, h);
      }, Sv = AA(Q3);
      function OA(u, h, b) {
        var P = h + "";
        return Sv(u, wV(P, MV(vV(P), b)));
      }
      function AA(u) {
        var h = 0, b = 0;
        return function() {
          var P = q5(), M = B - (P - b);
          if (b = P, M > 0) {
            if (++h >= $)
              return arguments[0];
          } else
            h = 0;
          return u.apply(n, arguments);
        };
      }
      function mh(u, h) {
        var b = -1, P = u.length, M = P - 1;
        for (h = h === n ? P : h; ++b < h; ) {
          var j = ov(b, M), K = u[j];
          u[j] = u[b], u[b] = K;
        }
        return u.length = h, u;
      }
      var PA = PV(function(u) {
        var h = [];
        return u.charCodeAt(0) === 46 && h.push(""), u.replace(xz, function(b, P, M, j) {
          h.push(M ? j.replace(Cz, "$1") : P || b);
        }), h;
      });
      function Li(u) {
        if (typeof u == "string" || kr(u))
          return u;
        var h = u + "";
        return h == "0" && 1 / u == -z ? "-0" : h;
      }
      function is(u) {
        if (u != null) {
          try {
            return Ud.call(u);
          } catch {
          }
          try {
            return u + "";
          } catch {
          }
        }
        return "";
      }
      function MV(u, h) {
        return Xr(re, function(b) {
          var P = "_." + b[0];
          h & b[1] && !Bd(u, P) && u.push(P);
        }), u.sort();
      }
      function TA(u) {
        if (u instanceof lt)
          return u.clone();
        var h = new Jr(u.__wrapped__, u.__chain__);
        return h.__actions__ = mr(u.__actions__), h.__index__ = u.__index__, h.__values__ = u.__values__, h;
      }
      function NV(u, h, b) {
        (b ? or(u, h, b) : h === n) ? h = 1 : h = vn(qe(h), 0);
        var P = u == null ? 0 : u.length;
        if (!P || h < 1)
          return [];
        for (var M = 0, j = 0, K = oe(Zd(P / h)); M < P; )
          K[j++] = ei(u, M, M += h);
        return K;
      }
      function $V(u) {
        for (var h = -1, b = u == null ? 0 : u.length, P = 0, M = []; ++h < b; ) {
          var j = u[h];
          j && (M[P++] = j);
        }
        return M;
      }
      function DV() {
        var u = arguments.length;
        if (!u)
          return [];
        for (var h = oe(u - 1), b = arguments[0], P = u; P--; )
          h[P - 1] = arguments[P];
        return ra(Ge(b) ? mr(b) : [b], jn(h, 1));
      }
      var IV = nt(function(u, h) {
        return on(u) ? cu(u, jn(h, 1, on, !0)) : [];
      }), RV = nt(function(u, h) {
        var b = ti(h);
        return on(b) && (b = n), on(u) ? cu(u, jn(h, 1, on, !0), Ne(b, 2)) : [];
      }), jV = nt(function(u, h) {
        var b = ti(h);
        return on(b) && (b = n), on(u) ? cu(u, jn(h, 1, on, !0), n, b) : [];
      });
      function LV(u, h, b) {
        var P = u == null ? 0 : u.length;
        return P ? (h = b || h === n ? 1 : qe(h), ei(u, h < 0 ? 0 : h, P)) : [];
      }
      function BV(u, h, b) {
        var P = u == null ? 0 : u.length;
        return P ? (h = b || h === n ? 1 : qe(h), h = P - h, ei(u, 0, h < 0 ? 0 : h)) : [];
      }
      function FV(u, h) {
        return u && u.length ? sh(u, Ne(h, 3), !0, !0) : [];
      }
      function WV(u, h) {
        return u && u.length ? sh(u, Ne(h, 3), !0) : [];
      }
      function zV(u, h, b, P) {
        var M = u == null ? 0 : u.length;
        return M ? (b && typeof b != "number" && or(u, h, b) && (b = 0, P = M), D3(u, h, b, P)) : [];
      }
      function CA(u, h, b) {
        var P = u == null ? 0 : u.length;
        if (!P)
          return -1;
        var M = b == null ? 0 : qe(b);
        return M < 0 && (M = vn(P + M, 0)), Fd(u, Ne(h, 3), M);
      }
      function EA(u, h, b) {
        var P = u == null ? 0 : u.length;
        if (!P)
          return -1;
        var M = P - 1;
        return b !== n && (M = qe(b), M = b < 0 ? vn(P + M, 0) : Yn(M, P - 1)), Fd(u, Ne(h, 3), M, !0);
      }
      function kA(u) {
        var h = u == null ? 0 : u.length;
        return h ? jn(u, 1) : [];
      }
      function VV(u) {
        var h = u == null ? 0 : u.length;
        return h ? jn(u, z) : [];
      }
      function UV(u, h) {
        var b = u == null ? 0 : u.length;
        return b ? (h = h === n ? 1 : qe(h), jn(u, h)) : [];
      }
      function KV(u) {
        for (var h = -1, b = u == null ? 0 : u.length, P = {}; ++h < b; ) {
          var M = u[h];
          P[M[0]] = M[1];
        }
        return P;
      }
      function MA(u) {
        return u && u.length ? u[0] : n;
      }
      function HV(u, h, b) {
        var P = u == null ? 0 : u.length;
        if (!P)
          return -1;
        var M = b == null ? 0 : qe(b);
        return M < 0 && (M = vn(P + M, 0)), ol(u, h, M);
      }
      function GV(u) {
        var h = u == null ? 0 : u.length;
        return h ? ei(u, 0, -1) : [];
      }
      var YV = nt(function(u) {
        var h = Gt(u, uv);
        return h.length && h[0] === u[0] ? ev(h) : [];
      }), qV = nt(function(u) {
        var h = ti(u), b = Gt(u, uv);
        return h === ti(b) ? h = n : b.pop(), b.length && b[0] === u[0] ? ev(b, Ne(h, 2)) : [];
      }), XV = nt(function(u) {
        var h = ti(u), b = Gt(u, uv);
        return h = typeof h == "function" ? h : n, h && b.pop(), b.length && b[0] === u[0] ? ev(b, n, h) : [];
      });
      function ZV(u, h) {
        return u == null ? "" : G5.call(u, h);
      }
      function ti(u) {
        var h = u == null ? 0 : u.length;
        return h ? u[h - 1] : n;
      }
      function JV(u, h, b) {
        var P = u == null ? 0 : u.length;
        if (!P)
          return -1;
        var M = P;
        return b !== n && (M = qe(b), M = M < 0 ? vn(P + M, 0) : Yn(M, P - 1)), h === h ? M5(u, h, M) : Fd(u, fO, M, !0);
      }
      function QV(u, h) {
        return u && u.length ? zO(u, qe(h)) : n;
      }
      var e4 = nt(NA);
      function NA(u, h) {
        return u && u.length && h && h.length ? iv(u, h) : u;
      }
      function t4(u, h, b) {
        return u && u.length && h && h.length ? iv(u, h, Ne(b, 2)) : u;
      }
      function n4(u, h, b) {
        return u && u.length && h && h.length ? iv(u, h, n, b) : u;
      }
      var r4 = fo(function(u, h) {
        var b = u == null ? 0 : u.length, P = Xy(u, h);
        return KO(u, Gt(h, function(M) {
          return ho(M, b) ? +M : M;
        }).sort(tA)), P;
      });
      function i4(u, h) {
        var b = [];
        if (!(u && u.length))
          return b;
        var P = -1, M = [], j = u.length;
        for (h = Ne(h, 3); ++P < j; ) {
          var K = u[P];
          h(K, P, u) && (b.push(K), M.push(P));
        }
        return KO(u, M), b;
      }
      function Ov(u) {
        return u == null ? u : Z5.call(u);
      }
      function o4(u, h, b) {
        var P = u == null ? 0 : u.length;
        return P ? (b && typeof b != "number" && or(u, h, b) ? (h = 0, b = P) : (h = h == null ? 0 : qe(h), b = b === n ? P : qe(b)), ei(u, h, b)) : [];
      }
      function a4(u, h) {
        return ah(u, h);
      }
      function s4(u, h, b) {
        return sv(u, h, Ne(b, 2));
      }
      function l4(u, h) {
        var b = u == null ? 0 : u.length;
        if (b) {
          var P = ah(u, h);
          if (P < b && yi(u[P], h))
            return P;
        }
        return -1;
      }
      function c4(u, h) {
        return ah(u, h, !0);
      }
      function u4(u, h, b) {
        return sv(u, h, Ne(b, 2), !0);
      }
      function f4(u, h) {
        var b = u == null ? 0 : u.length;
        if (b) {
          var P = ah(u, h, !0) - 1;
          if (yi(u[P], h))
            return P;
        }
        return -1;
      }
      function d4(u) {
        return u && u.length ? GO(u) : [];
      }
      function h4(u, h) {
        return u && u.length ? GO(u, Ne(h, 2)) : [];
      }
      function p4(u) {
        var h = u == null ? 0 : u.length;
        return h ? ei(u, 1, h) : [];
      }
      function m4(u, h, b) {
        return u && u.length ? (h = b || h === n ? 1 : qe(h), ei(u, 0, h < 0 ? 0 : h)) : [];
      }
      function g4(u, h, b) {
        var P = u == null ? 0 : u.length;
        return P ? (h = b || h === n ? 1 : qe(h), h = P - h, ei(u, h < 0 ? 0 : h, P)) : [];
      }
      function y4(u, h) {
        return u && u.length ? sh(u, Ne(h, 3), !1, !0) : [];
      }
      function v4(u, h) {
        return u && u.length ? sh(u, Ne(h, 3)) : [];
      }
      var b4 = nt(function(u) {
        return sa(jn(u, 1, on, !0));
      }), x4 = nt(function(u) {
        var h = ti(u);
        return on(h) && (h = n), sa(jn(u, 1, on, !0), Ne(h, 2));
      }), w4 = nt(function(u) {
        var h = ti(u);
        return h = typeof h == "function" ? h : n, sa(jn(u, 1, on, !0), n, h);
      });
      function _4(u) {
        return u && u.length ? sa(u) : [];
      }
      function S4(u, h) {
        return u && u.length ? sa(u, Ne(h, 2)) : [];
      }
      function O4(u, h) {
        return h = typeof h == "function" ? h : n, u && u.length ? sa(u, n, h) : [];
      }
      function Av(u) {
        if (!(u && u.length))
          return [];
        var h = 0;
        return u = na(u, function(b) {
          if (on(b))
            return h = vn(b.length, h), !0;
        }), zy(h, function(b) {
          return Gt(u, By(b));
        });
      }
      function $A(u, h) {
        if (!(u && u.length))
          return [];
        var b = Av(u);
        return h == null ? b : Gt(b, function(P) {
          return Tr(h, n, P);
        });
      }
      var A4 = nt(function(u, h) {
        return on(u) ? cu(u, h) : [];
      }), P4 = nt(function(u) {
        return cv(na(u, on));
      }), T4 = nt(function(u) {
        var h = ti(u);
        return on(h) && (h = n), cv(na(u, on), Ne(h, 2));
      }), C4 = nt(function(u) {
        var h = ti(u);
        return h = typeof h == "function" ? h : n, cv(na(u, on), n, h);
      }), E4 = nt(Av);
      function k4(u, h) {
        return ZO(u || [], h || [], lu);
      }
      function M4(u, h) {
        return ZO(u || [], h || [], du);
      }
      var N4 = nt(function(u) {
        var h = u.length, b = h > 1 ? u[h - 1] : n;
        return b = typeof b == "function" ? (u.pop(), b) : n, $A(u, b);
      });
      function DA(u) {
        var h = R(u);
        return h.__chain__ = !0, h;
      }
      function $4(u, h) {
        return h(u), u;
      }
      function gh(u, h) {
        return h(u);
      }
      var D4 = fo(function(u) {
        var h = u.length, b = h ? u[0] : 0, P = this.__wrapped__, M = function(j) {
          return Xy(j, u);
        };
        return h > 1 || this.__actions__.length || !(P instanceof lt) || !ho(b) ? this.thru(M) : (P = P.slice(b, +b + (h ? 1 : 0)), P.__actions__.push({
          func: gh,
          args: [M],
          thisArg: n
        }), new Jr(P, this.__chain__).thru(function(j) {
          return h && !j.length && j.push(n), j;
        }));
      });
      function I4() {
        return DA(this);
      }
      function R4() {
        return new Jr(this.value(), this.__chain__);
      }
      function j4() {
        this.__values__ === n && (this.__values__ = YA(this.value()));
        var u = this.__index__ >= this.__values__.length, h = u ? n : this.__values__[this.__index__++];
        return { done: u, value: h };
      }
      function L4() {
        return this;
      }
      function B4(u) {
        for (var h, b = this; b instanceof th; ) {
          var P = TA(b);
          P.__index__ = 0, P.__values__ = n, h ? M.__wrapped__ = P : h = P;
          var M = P;
          b = b.__wrapped__;
        }
        return M.__wrapped__ = u, h;
      }
      function F4() {
        var u = this.__wrapped__;
        if (u instanceof lt) {
          var h = u;
          return this.__actions__.length && (h = new lt(this)), h = h.reverse(), h.__actions__.push({
            func: gh,
            args: [Ov],
            thisArg: n
          }), new Jr(h, this.__chain__);
        }
        return this.thru(Ov);
      }
      function W4() {
        return XO(this.__wrapped__, this.__actions__);
      }
      var z4 = lh(function(u, h, b) {
        Ot.call(u, b) ? ++u[b] : co(u, b, 1);
      });
      function V4(u, h, b) {
        var P = Ge(u) ? cO : $3;
        return b && or(u, h, b) && (h = n), P(u, Ne(h, 3));
      }
      function U4(u, h) {
        var b = Ge(u) ? na : $O;
        return b(u, Ne(h, 3));
      }
      var K4 = sA(CA), H4 = sA(EA);
      function G4(u, h) {
        return jn(yh(u, h), 1);
      }
      function Y4(u, h) {
        return jn(yh(u, h), z);
      }
      function q4(u, h, b) {
        return b = b === n ? 1 : qe(b), jn(yh(u, h), b);
      }
      function IA(u, h) {
        var b = Ge(u) ? Xr : aa;
        return b(u, Ne(h, 3));
      }
      function RA(u, h) {
        var b = Ge(u) ? p5 : NO;
        return b(u, Ne(h, 3));
      }
      var X4 = lh(function(u, h, b) {
        Ot.call(u, b) ? u[b].push(h) : co(u, b, [h]);
      });
      function Z4(u, h, b, P) {
        u = gr(u) ? u : yl(u), b = b && !P ? qe(b) : 0;
        var M = u.length;
        return b < 0 && (b = vn(M + b, 0)), _h(u) ? b <= M && u.indexOf(h, b) > -1 : !!M && ol(u, h, b) > -1;
      }
      var J4 = nt(function(u, h, b) {
        var P = -1, M = typeof h == "function", j = gr(u) ? oe(u.length) : [];
        return aa(u, function(K) {
          j[++P] = M ? Tr(h, K, b) : uu(K, h, b);
        }), j;
      }), Q4 = lh(function(u, h, b) {
        co(u, b, h);
      });
      function yh(u, h) {
        var b = Ge(u) ? Gt : BO;
        return b(u, Ne(h, 3));
      }
      function eU(u, h, b, P) {
        return u == null ? [] : (Ge(h) || (h = h == null ? [] : [h]), b = P ? n : b, Ge(b) || (b = b == null ? [] : [b]), VO(u, h, b));
      }
      var tU = lh(function(u, h, b) {
        u[b ? 0 : 1].push(h);
      }, function() {
        return [[], []];
      });
      function nU(u, h, b) {
        var P = Ge(u) ? jy : hO, M = arguments.length < 3;
        return P(u, Ne(h, 4), b, M, aa);
      }
      function rU(u, h, b) {
        var P = Ge(u) ? m5 : hO, M = arguments.length < 3;
        return P(u, Ne(h, 4), b, M, NO);
      }
      function iU(u, h) {
        var b = Ge(u) ? na : $O;
        return b(u, xh(Ne(h, 3)));
      }
      function oU(u) {
        var h = Ge(u) ? CO : Z3;
        return h(u);
      }
      function aU(u, h, b) {
        (b ? or(u, h, b) : h === n) ? h = 1 : h = qe(h);
        var P = Ge(u) ? C3 : J3;
        return P(u, h);
      }
      function sU(u) {
        var h = Ge(u) ? E3 : eV;
        return h(u);
      }
      function lU(u) {
        if (u == null)
          return 0;
        if (gr(u))
          return _h(u) ? sl(u) : u.length;
        var h = qn(u);
        return h == pe || h == Oe ? u.size : nv(u).length;
      }
      function cU(u, h, b) {
        var P = Ge(u) ? Ly : tV;
        return b && or(u, h, b) && (h = n), P(u, Ne(h, 3));
      }
      var uU = nt(function(u, h) {
        if (u == null)
          return [];
        var b = h.length;
        return b > 1 && or(u, h[0], h[1]) ? h = [] : b > 2 && or(h[0], h[1], h[2]) && (h = [h[0]]), VO(u, jn(h, 1), []);
      }), vh = U5 || function() {
        return Rn.Date.now();
      };
      function fU(u, h) {
        if (typeof h != "function")
          throw new Zr(a);
        return u = qe(u), function() {
          if (--u < 1)
            return h.apply(this, arguments);
        };
      }
      function jA(u, h, b) {
        return h = b ? n : h, h = u && h == null ? u.length : h, uo(u, T, n, n, n, n, h);
      }
      function LA(u, h) {
        var b;
        if (typeof h != "function")
          throw new Zr(a);
        return u = qe(u), function() {
          return --u > 0 && (b = h.apply(this, arguments)), u <= 1 && (h = n), b;
        };
      }
      var Pv = nt(function(u, h, b) {
        var P = y;
        if (b.length) {
          var M = ia(b, ml(Pv));
          P |= _;
        }
        return uo(u, P, h, b, M);
      }), BA = nt(function(u, h, b) {
        var P = y | x;
        if (b.length) {
          var M = ia(b, ml(BA));
          P |= _;
        }
        return uo(h, P, u, b, M);
      });
      function FA(u, h, b) {
        h = b ? n : h;
        var P = uo(u, S, n, n, n, n, n, h);
        return P.placeholder = FA.placeholder, P;
      }
      function WA(u, h, b) {
        h = b ? n : h;
        var P = uo(u, A, n, n, n, n, n, h);
        return P.placeholder = WA.placeholder, P;
      }
      function zA(u, h, b) {
        var P, M, j, K, q, J, de = 0, he = !1, ge = !1, xe = !0;
        if (typeof u != "function")
          throw new Zr(a);
        h = ni(h) || 0, Zt(b) && (he = !!b.leading, ge = "maxWait" in b, j = ge ? vn(ni(b.maxWait) || 0, h) : j, xe = "trailing" in b ? !!b.trailing : xe);
        function Ce(an) {
          var vi = P, go = M;
          return P = M = n, de = an, K = u.apply(go, vi), K;
        }
        function De(an) {
          return de = an, q = mu(it, h), he ? Ce(an) : K;
        }
        function et(an) {
          var vi = an - J, go = an - de, sP = h - vi;
          return ge ? Yn(sP, j - go) : sP;
        }
        function Ie(an) {
          var vi = an - J, go = an - de;
          return J === n || vi >= h || vi < 0 || ge && go >= j;
        }
        function it() {
          var an = vh();
          if (Ie(an))
            return ct(an);
          q = mu(it, et(an));
        }
        function ct(an) {
          return q = n, xe && P ? Ce(an) : (P = M = n, K);
        }
        function Mr() {
          q !== n && JO(q), de = 0, P = J = M = q = n;
        }
        function ar() {
          return q === n ? K : ct(vh());
        }
        function Nr() {
          var an = vh(), vi = Ie(an);
          if (P = arguments, M = this, J = an, vi) {
            if (q === n)
              return De(J);
            if (ge)
              return JO(q), q = mu(it, h), Ce(J);
          }
          return q === n && (q = mu(it, h)), K;
        }
        return Nr.cancel = Mr, Nr.flush = ar, Nr;
      }
      var dU = nt(function(u, h) {
        return MO(u, 1, h);
      }), hU = nt(function(u, h, b) {
        return MO(u, ni(h) || 0, b);
      });
      function pU(u) {
        return uo(u, k);
      }
      function bh(u, h) {
        if (typeof u != "function" || h != null && typeof h != "function")
          throw new Zr(a);
        var b = function() {
          var P = arguments, M = h ? h.apply(this, P) : P[0], j = b.cache;
          if (j.has(M))
            return j.get(M);
          var K = u.apply(this, P);
          return b.cache = j.set(M, K) || j, K;
        };
        return b.cache = new (bh.Cache || lo)(), b;
      }
      bh.Cache = lo;
      function xh(u) {
        if (typeof u != "function")
          throw new Zr(a);
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return !u.call(this);
            case 1:
              return !u.call(this, h[0]);
            case 2:
              return !u.call(this, h[0], h[1]);
            case 3:
              return !u.call(this, h[0], h[1], h[2]);
          }
          return !u.apply(this, h);
        };
      }
      function mU(u) {
        return LA(2, u);
      }
      var gU = nV(function(u, h) {
        h = h.length == 1 && Ge(h[0]) ? Gt(h[0], Cr(Ne())) : Gt(jn(h, 1), Cr(Ne()));
        var b = h.length;
        return nt(function(P) {
          for (var M = -1, j = Yn(P.length, b); ++M < j; )
            P[M] = h[M].call(this, P[M]);
          return Tr(u, this, P);
        });
      }), Tv = nt(function(u, h) {
        var b = ia(h, ml(Tv));
        return uo(u, _, n, h, b);
      }), VA = nt(function(u, h) {
        var b = ia(h, ml(VA));
        return uo(u, O, n, h, b);
      }), yU = fo(function(u, h) {
        return uo(u, C, n, n, n, h);
      });
      function vU(u, h) {
        if (typeof u != "function")
          throw new Zr(a);
        return h = h === n ? h : qe(h), nt(u, h);
      }
      function bU(u, h) {
        if (typeof u != "function")
          throw new Zr(a);
        return h = h == null ? 0 : vn(qe(h), 0), nt(function(b) {
          var P = b[h], M = ca(b, 0, h);
          return P && ra(M, P), Tr(u, this, M);
        });
      }
      function xU(u, h, b) {
        var P = !0, M = !0;
        if (typeof u != "function")
          throw new Zr(a);
        return Zt(b) && (P = "leading" in b ? !!b.leading : P, M = "trailing" in b ? !!b.trailing : M), zA(u, h, {
          leading: P,
          maxWait: h,
          trailing: M
        });
      }
      function wU(u) {
        return jA(u, 1);
      }
      function _U(u, h) {
        return Tv(fv(h), u);
      }
      function SU() {
        if (!arguments.length)
          return [];
        var u = arguments[0];
        return Ge(u) ? u : [u];
      }
      function OU(u) {
        return Qr(u, m);
      }
      function AU(u, h) {
        return h = typeof h == "function" ? h : n, Qr(u, m, h);
      }
      function PU(u) {
        return Qr(u, d | m);
      }
      function TU(u, h) {
        return h = typeof h == "function" ? h : n, Qr(u, d | m, h);
      }
      function CU(u, h) {
        return h == null || kO(u, h, Tn(h));
      }
      function yi(u, h) {
        return u === h || u !== u && h !== h;
      }
      var EU = dh(Qy), kU = dh(function(u, h) {
        return u >= h;
      }), os = RO(/* @__PURE__ */ function() {
        return arguments;
      }()) ? RO : function(u) {
        return en(u) && Ot.call(u, "callee") && !_O.call(u, "callee");
      }, Ge = oe.isArray, MU = rO ? Cr(rO) : B3;
      function gr(u) {
        return u != null && wh(u.length) && !po(u);
      }
      function on(u) {
        return en(u) && gr(u);
      }
      function NU(u) {
        return u === !0 || u === !1 || en(u) && ir(u) == ie;
      }
      var ua = H5 || Lv, $U = iO ? Cr(iO) : F3;
      function DU(u) {
        return en(u) && u.nodeType === 1 && !gu(u);
      }
      function IU(u) {
        if (u == null)
          return !0;
        if (gr(u) && (Ge(u) || typeof u == "string" || typeof u.splice == "function" || ua(u) || gl(u) || os(u)))
          return !u.length;
        var h = qn(u);
        if (h == pe || h == Oe)
          return !u.size;
        if (pu(u))
          return !nv(u).length;
        for (var b in u)
          if (Ot.call(u, b))
            return !1;
        return !0;
      }
      function RU(u, h) {
        return fu(u, h);
      }
      function jU(u, h, b) {
        b = typeof b == "function" ? b : n;
        var P = b ? b(u, h) : n;
        return P === n ? fu(u, h, n, b) : !!P;
      }
      function Cv(u) {
        if (!en(u))
          return !1;
        var h = ir(u);
        return h == ve || h == fe || typeof u.message == "string" && typeof u.name == "string" && !gu(u);
      }
      function LU(u) {
        return typeof u == "number" && OO(u);
      }
      function po(u) {
        if (!Zt(u))
          return !1;
        var h = ir(u);
        return h == X || h == Fe || h == le || h == $e;
      }
      function UA(u) {
        return typeof u == "number" && u == qe(u);
      }
      function wh(u) {
        return typeof u == "number" && u > -1 && u % 1 == 0 && u <= G;
      }
      function Zt(u) {
        var h = typeof u;
        return u != null && (h == "object" || h == "function");
      }
      function en(u) {
        return u != null && typeof u == "object";
      }
      var KA = oO ? Cr(oO) : z3;
      function BU(u, h) {
        return u === h || tv(u, h, vv(h));
      }
      function FU(u, h, b) {
        return b = typeof b == "function" ? b : n, tv(u, h, vv(h), b);
      }
      function WU(u) {
        return HA(u) && u != +u;
      }
      function zU(u) {
        if (AV(u))
          throw new Ke(o);
        return jO(u);
      }
      function VU(u) {
        return u === null;
      }
      function UU(u) {
        return u == null;
      }
      function HA(u) {
        return typeof u == "number" || en(u) && ir(u) == Be;
      }
      function gu(u) {
        if (!en(u) || ir(u) != at)
          return !1;
        var h = Yd(u);
        if (h === null)
          return !0;
        var b = Ot.call(h, "constructor") && h.constructor;
        return typeof b == "function" && b instanceof b && Ud.call(b) == F5;
      }
      var Ev = aO ? Cr(aO) : V3;
      function KU(u) {
        return UA(u) && u >= -G && u <= G;
      }
      var GA = sO ? Cr(sO) : U3;
      function _h(u) {
        return typeof u == "string" || !Ge(u) && en(u) && ir(u) == He;
      }
      function kr(u) {
        return typeof u == "symbol" || en(u) && ir(u) == Xt;
      }
      var gl = lO ? Cr(lO) : K3;
      function HU(u) {
        return u === n;
      }
      function GU(u) {
        return en(u) && qn(u) == Qt;
      }
      function YU(u) {
        return en(u) && ir(u) == Hr;
      }
      var qU = dh(rv), XU = dh(function(u, h) {
        return u <= h;
      });
      function YA(u) {
        if (!u)
          return [];
        if (gr(u))
          return _h(u) ? mi(u) : mr(u);
        if (ru && u[ru])
          return C5(u[ru]());
        var h = qn(u), b = h == pe ? Uy : h == Oe ? Wd : yl;
        return b(u);
      }
      function mo(u) {
        if (!u)
          return u === 0 ? u : 0;
        if (u = ni(u), u === z || u === -z) {
          var h = u < 0 ? -1 : 1;
          return h * V;
        }
        return u === u ? u : 0;
      }
      function qe(u) {
        var h = mo(u), b = h % 1;
        return h === h ? b ? h - b : h : 0;
      }
      function qA(u) {
        return u ? ts(qe(u), 0, Y) : 0;
      }
      function ni(u) {
        if (typeof u == "number")
          return u;
        if (kr(u))
          return U;
        if (Zt(u)) {
          var h = typeof u.valueOf == "function" ? u.valueOf() : u;
          u = Zt(h) ? h + "" : h;
        }
        if (typeof u != "string")
          return u === 0 ? u : +u;
        u = pO(u);
        var b = Mz.test(u);
        return b || $z.test(u) ? f5(u.slice(2), b ? 2 : 8) : kz.test(u) ? U : +u;
      }
      function XA(u) {
        return ji(u, yr(u));
      }
      function ZU(u) {
        return u ? ts(qe(u), -G, G) : u === 0 ? u : 0;
      }
      function yt(u) {
        return u == null ? "" : Er(u);
      }
      var JU = hl(function(u, h) {
        if (pu(h) || gr(h)) {
          ji(h, Tn(h), u);
          return;
        }
        for (var b in h)
          Ot.call(h, b) && lu(u, b, h[b]);
      }), ZA = hl(function(u, h) {
        ji(h, yr(h), u);
      }), Sh = hl(function(u, h, b, P) {
        ji(h, yr(h), u, P);
      }), QU = hl(function(u, h, b, P) {
        ji(h, Tn(h), u, P);
      }), e6 = fo(Xy);
      function t6(u, h) {
        var b = dl(u);
        return h == null ? b : EO(b, h);
      }
      var n6 = nt(function(u, h) {
        u = kt(u);
        var b = -1, P = h.length, M = P > 2 ? h[2] : n;
        for (M && or(h[0], h[1], M) && (P = 1); ++b < P; )
          for (var j = h[b], K = yr(j), q = -1, J = K.length; ++q < J; ) {
            var de = K[q], he = u[de];
            (he === n || yi(he, cl[de]) && !Ot.call(u, de)) && (u[de] = j[de]);
          }
        return u;
      }), r6 = nt(function(u) {
        return u.push(n, pA), Tr(JA, n, u);
      });
      function i6(u, h) {
        return uO(u, Ne(h, 3), Ri);
      }
      function o6(u, h) {
        return uO(u, Ne(h, 3), Jy);
      }
      function a6(u, h) {
        return u == null ? u : Zy(u, Ne(h, 3), yr);
      }
      function s6(u, h) {
        return u == null ? u : DO(u, Ne(h, 3), yr);
      }
      function l6(u, h) {
        return u && Ri(u, Ne(h, 3));
      }
      function c6(u, h) {
        return u && Jy(u, Ne(h, 3));
      }
      function u6(u) {
        return u == null ? [] : ih(u, Tn(u));
      }
      function f6(u) {
        return u == null ? [] : ih(u, yr(u));
      }
      function kv(u, h, b) {
        var P = u == null ? n : ns(u, h);
        return P === n ? b : P;
      }
      function d6(u, h) {
        return u != null && yA(u, h, I3);
      }
      function Mv(u, h) {
        return u != null && yA(u, h, R3);
      }
      var h6 = cA(function(u, h, b) {
        h != null && typeof h.toString != "function" && (h = Kd.call(h)), u[h] = b;
      }, $v(vr)), p6 = cA(function(u, h, b) {
        h != null && typeof h.toString != "function" && (h = Kd.call(h)), Ot.call(u, h) ? u[h].push(b) : u[h] = [b];
      }, Ne), m6 = nt(uu);
      function Tn(u) {
        return gr(u) ? TO(u) : nv(u);
      }
      function yr(u) {
        return gr(u) ? TO(u, !0) : H3(u);
      }
      function g6(u, h) {
        var b = {};
        return h = Ne(h, 3), Ri(u, function(P, M, j) {
          co(b, h(P, M, j), P);
        }), b;
      }
      function y6(u, h) {
        var b = {};
        return h = Ne(h, 3), Ri(u, function(P, M, j) {
          co(b, M, h(P, M, j));
        }), b;
      }
      var v6 = hl(function(u, h, b) {
        oh(u, h, b);
      }), JA = hl(function(u, h, b, P) {
        oh(u, h, b, P);
      }), b6 = fo(function(u, h) {
        var b = {};
        if (u == null)
          return b;
        var P = !1;
        h = Gt(h, function(j) {
          return j = la(j, u), P || (P = j.length > 1), j;
        }), ji(u, gv(u), b), P && (b = Qr(b, d | p | m, hV));
        for (var M = h.length; M--; )
          lv(b, h[M]);
        return b;
      });
      function x6(u, h) {
        return QA(u, xh(Ne(h)));
      }
      var w6 = fo(function(u, h) {
        return u == null ? {} : Y3(u, h);
      });
      function QA(u, h) {
        if (u == null)
          return {};
        var b = Gt(gv(u), function(P) {
          return [P];
        });
        return h = Ne(h), UO(u, b, function(P, M) {
          return h(P, M[0]);
        });
      }
      function _6(u, h, b) {
        h = la(h, u);
        var P = -1, M = h.length;
        for (M || (M = 1, u = n); ++P < M; ) {
          var j = u == null ? n : u[Li(h[P])];
          j === n && (P = M, j = b), u = po(j) ? j.call(u) : j;
        }
        return u;
      }
      function S6(u, h, b) {
        return u == null ? u : du(u, h, b);
      }
      function O6(u, h, b, P) {
        return P = typeof P == "function" ? P : n, u == null ? u : du(u, h, b, P);
      }
      var eP = dA(Tn), tP = dA(yr);
      function A6(u, h, b) {
        var P = Ge(u), M = P || ua(u) || gl(u);
        if (h = Ne(h, 4), b == null) {
          var j = u && u.constructor;
          M ? b = P ? new j() : [] : Zt(u) ? b = po(j) ? dl(Yd(u)) : {} : b = {};
        }
        return (M ? Xr : Ri)(u, function(K, q, J) {
          return h(b, K, q, J);
        }), b;
      }
      function P6(u, h) {
        return u == null ? !0 : lv(u, h);
      }
      function T6(u, h, b) {
        return u == null ? u : qO(u, h, fv(b));
      }
      function C6(u, h, b, P) {
        return P = typeof P == "function" ? P : n, u == null ? u : qO(u, h, fv(b), P);
      }
      function yl(u) {
        return u == null ? [] : Vy(u, Tn(u));
      }
      function E6(u) {
        return u == null ? [] : Vy(u, yr(u));
      }
      function k6(u, h, b) {
        return b === n && (b = h, h = n), b !== n && (b = ni(b), b = b === b ? b : 0), h !== n && (h = ni(h), h = h === h ? h : 0), ts(ni(u), h, b);
      }
      function M6(u, h, b) {
        return h = mo(h), b === n ? (b = h, h = 0) : b = mo(b), u = ni(u), j3(u, h, b);
      }
      function N6(u, h, b) {
        if (b && typeof b != "boolean" && or(u, h, b) && (h = b = n), b === n && (typeof h == "boolean" ? (b = h, h = n) : typeof u == "boolean" && (b = u, u = n)), u === n && h === n ? (u = 0, h = 1) : (u = mo(u), h === n ? (h = u, u = 0) : h = mo(h)), u > h) {
          var P = u;
          u = h, h = P;
        }
        if (b || u % 1 || h % 1) {
          var M = AO();
          return Yn(u + M * (h - u + u5("1e-" + ((M + "").length - 1))), h);
        }
        return ov(u, h);
      }
      var $6 = pl(function(u, h, b) {
        return h = h.toLowerCase(), u + (b ? nP(h) : h);
      });
      function nP(u) {
        return Nv(yt(u).toLowerCase());
      }
      function rP(u) {
        return u = yt(u), u && u.replace(Iz, S5).replace(e5, "");
      }
      function D6(u, h, b) {
        u = yt(u), h = Er(h);
        var P = u.length;
        b = b === n ? P : ts(qe(b), 0, P);
        var M = b;
        return b -= h.length, b >= 0 && u.slice(b, M) == h;
      }
      function I6(u) {
        return u = yt(u), u && eu.test(u) ? u.replace(Id, O5) : u;
      }
      function R6(u) {
        return u = yt(u), u && wz.test(u) ? u.replace(Ty, "\\$&") : u;
      }
      var j6 = pl(function(u, h, b) {
        return u + (b ? "-" : "") + h.toLowerCase();
      }), L6 = pl(function(u, h, b) {
        return u + (b ? " " : "") + h.toLowerCase();
      }), B6 = aA("toLowerCase");
      function F6(u, h, b) {
        u = yt(u), h = qe(h);
        var P = h ? sl(u) : 0;
        if (!h || P >= h)
          return u;
        var M = (h - P) / 2;
        return fh(Jd(M), b) + u + fh(Zd(M), b);
      }
      function W6(u, h, b) {
        u = yt(u), h = qe(h);
        var P = h ? sl(u) : 0;
        return h && P < h ? u + fh(h - P, b) : u;
      }
      function z6(u, h, b) {
        u = yt(u), h = qe(h);
        var P = h ? sl(u) : 0;
        return h && P < h ? fh(h - P, b) + u : u;
      }
      function V6(u, h, b) {
        return b || h == null ? h = 0 : h && (h = +h), X5(yt(u).replace(Cy, ""), h || 0);
      }
      function U6(u, h, b) {
        return (b ? or(u, h, b) : h === n) ? h = 1 : h = qe(h), av(yt(u), h);
      }
      function K6() {
        var u = arguments, h = yt(u[0]);
        return u.length < 3 ? h : h.replace(u[1], u[2]);
      }
      var H6 = pl(function(u, h, b) {
        return u + (b ? "_" : "") + h.toLowerCase();
      });
      function G6(u, h, b) {
        return b && typeof b != "number" && or(u, h, b) && (h = b = n), b = b === n ? Y : b >>> 0, b ? (u = yt(u), u && (typeof h == "string" || h != null && !Ev(h)) && (h = Er(h), !h && al(u)) ? ca(mi(u), 0, b) : u.split(h, b)) : [];
      }
      var Y6 = pl(function(u, h, b) {
        return u + (b ? " " : "") + Nv(h);
      });
      function q6(u, h, b) {
        return u = yt(u), b = b == null ? 0 : ts(qe(b), 0, u.length), h = Er(h), u.slice(b, b + h.length) == h;
      }
      function X6(u, h, b) {
        var P = R.templateSettings;
        b && or(u, h, b) && (h = n), u = yt(u), h = Sh({}, h, P, hA);
        var M = Sh({}, h.imports, P.imports, hA), j = Tn(M), K = Vy(M, j), q, J, de = 0, he = h.interpolate || Rd, ge = "__p += '", xe = Ky(
          (h.escape || Rd).source + "|" + he.source + "|" + (he === IS ? Ez : Rd).source + "|" + (h.evaluate || Rd).source + "|$",
          "g"
        ), Ce = "//# sourceURL=" + (Ot.call(h, "sourceURL") ? (h.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++o5 + "]") + `
`;
        u.replace(xe, function(Ie, it, ct, Mr, ar, Nr) {
          return ct || (ct = Mr), ge += u.slice(de, Nr).replace(Rz, A5), it && (q = !0, ge += `' +
__e(` + it + `) +
'`), ar && (J = !0, ge += `';
` + ar + `;
__p += '`), ct && (ge += `' +
((__t = (` + ct + `)) == null ? '' : __t) +
'`), de = Nr + Ie.length, Ie;
        }), ge += `';
`;
        var De = Ot.call(h, "variable") && h.variable;
        if (!De)
          ge = `with (obj) {
` + ge + `
}
`;
        else if (Tz.test(De))
          throw new Ke(s);
        ge = (J ? ge.replace(un, "") : ge).replace(Yr, "$1").replace(gt, "$1;"), ge = "function(" + (De || "obj") + `) {
` + (De ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (J ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ge + `return __p
}`;
        var et = oP(function() {
          return mt(j, Ce + "return " + ge).apply(n, K);
        });
        if (et.source = ge, Cv(et))
          throw et;
        return et;
      }
      function Z6(u) {
        return yt(u).toLowerCase();
      }
      function J6(u) {
        return yt(u).toUpperCase();
      }
      function Q6(u, h, b) {
        if (u = yt(u), u && (b || h === n))
          return pO(u);
        if (!u || !(h = Er(h)))
          return u;
        var P = mi(u), M = mi(h), j = mO(P, M), K = gO(P, M) + 1;
        return ca(P, j, K).join("");
      }
      function e8(u, h, b) {
        if (u = yt(u), u && (b || h === n))
          return u.slice(0, vO(u) + 1);
        if (!u || !(h = Er(h)))
          return u;
        var P = mi(u), M = gO(P, mi(h)) + 1;
        return ca(P, 0, M).join("");
      }
      function t8(u, h, b) {
        if (u = yt(u), u && (b || h === n))
          return u.replace(Cy, "");
        if (!u || !(h = Er(h)))
          return u;
        var P = mi(u), M = mO(P, mi(h));
        return ca(P, M).join("");
      }
      function n8(u, h) {
        var b = D, P = N;
        if (Zt(h)) {
          var M = "separator" in h ? h.separator : M;
          b = "length" in h ? qe(h.length) : b, P = "omission" in h ? Er(h.omission) : P;
        }
        u = yt(u);
        var j = u.length;
        if (al(u)) {
          var K = mi(u);
          j = K.length;
        }
        if (b >= j)
          return u;
        var q = b - sl(P);
        if (q < 1)
          return P;
        var J = K ? ca(K, 0, q).join("") : u.slice(0, q);
        if (M === n)
          return J + P;
        if (K && (q += J.length - q), Ev(M)) {
          if (u.slice(q).search(M)) {
            var de, he = J;
            for (M.global || (M = Ky(M.source, yt(RS.exec(M)) + "g")), M.lastIndex = 0; de = M.exec(he); )
              var ge = de.index;
            J = J.slice(0, ge === n ? q : ge);
          }
        } else if (u.indexOf(Er(M), q) != q) {
          var xe = J.lastIndexOf(M);
          xe > -1 && (J = J.slice(0, xe));
        }
        return J + P;
      }
      function r8(u) {
        return u = yt(u), u && Py.test(u) ? u.replace(Dd, N5) : u;
      }
      var i8 = pl(function(u, h, b) {
        return u + (b ? " " : "") + h.toUpperCase();
      }), Nv = aA("toUpperCase");
      function iP(u, h, b) {
        return u = yt(u), h = b ? n : h, h === n ? T5(u) ? I5(u) : v5(u) : u.match(h) || [];
      }
      var oP = nt(function(u, h) {
        try {
          return Tr(u, n, h);
        } catch (b) {
          return Cv(b) ? b : new Ke(b);
        }
      }), o8 = fo(function(u, h) {
        return Xr(h, function(b) {
          b = Li(b), co(u, b, Pv(u[b], u));
        }), u;
      });
      function a8(u) {
        var h = u == null ? 0 : u.length, b = Ne();
        return u = h ? Gt(u, function(P) {
          if (typeof P[1] != "function")
            throw new Zr(a);
          return [b(P[0]), P[1]];
        }) : [], nt(function(P) {
          for (var M = -1; ++M < h; ) {
            var j = u[M];
            if (Tr(j[0], this, P))
              return Tr(j[1], this, P);
          }
        });
      }
      function s8(u) {
        return N3(Qr(u, d));
      }
      function $v(u) {
        return function() {
          return u;
        };
      }
      function l8(u, h) {
        return u == null || u !== u ? h : u;
      }
      var c8 = lA(), u8 = lA(!0);
      function vr(u) {
        return u;
      }
      function Dv(u) {
        return LO(typeof u == "function" ? u : Qr(u, d));
      }
      function f8(u) {
        return FO(Qr(u, d));
      }
      function d8(u, h) {
        return WO(u, Qr(h, d));
      }
      var h8 = nt(function(u, h) {
        return function(b) {
          return uu(b, u, h);
        };
      }), p8 = nt(function(u, h) {
        return function(b) {
          return uu(u, b, h);
        };
      });
      function Iv(u, h, b) {
        var P = Tn(h), M = ih(h, P);
        b == null && !(Zt(h) && (M.length || !P.length)) && (b = h, h = u, u = this, M = ih(h, Tn(h)));
        var j = !(Zt(b) && "chain" in b) || !!b.chain, K = po(u);
        return Xr(M, function(q) {
          var J = h[q];
          u[q] = J, K && (u.prototype[q] = function() {
            var de = this.__chain__;
            if (j || de) {
              var he = u(this.__wrapped__), ge = he.__actions__ = mr(this.__actions__);
              return ge.push({ func: J, args: arguments, thisArg: u }), he.__chain__ = de, he;
            }
            return J.apply(u, ra([this.value()], arguments));
          });
        }), u;
      }
      function m8() {
        return Rn._ === this && (Rn._ = W5), this;
      }
      function Rv() {
      }
      function g8(u) {
        return u = qe(u), nt(function(h) {
          return zO(h, u);
        });
      }
      var y8 = hv(Gt), v8 = hv(cO), b8 = hv(Ly);
      function aP(u) {
        return xv(u) ? By(Li(u)) : q3(u);
      }
      function x8(u) {
        return function(h) {
          return u == null ? n : ns(u, h);
        };
      }
      var w8 = uA(), _8 = uA(!0);
      function jv() {
        return [];
      }
      function Lv() {
        return !1;
      }
      function S8() {
        return {};
      }
      function O8() {
        return "";
      }
      function A8() {
        return !0;
      }
      function P8(u, h) {
        if (u = qe(u), u < 1 || u > G)
          return [];
        var b = Y, P = Yn(u, Y);
        h = Ne(h), u -= Y;
        for (var M = zy(P, h); ++b < u; )
          h(b);
        return M;
      }
      function T8(u) {
        return Ge(u) ? Gt(u, Li) : kr(u) ? [u] : mr(PA(yt(u)));
      }
      function C8(u) {
        var h = ++B5;
        return yt(u) + h;
      }
      var E8 = uh(function(u, h) {
        return u + h;
      }, 0), k8 = pv("ceil"), M8 = uh(function(u, h) {
        return u / h;
      }, 1), N8 = pv("floor");
      function $8(u) {
        return u && u.length ? rh(u, vr, Qy) : n;
      }
      function D8(u, h) {
        return u && u.length ? rh(u, Ne(h, 2), Qy) : n;
      }
      function I8(u) {
        return dO(u, vr);
      }
      function R8(u, h) {
        return dO(u, Ne(h, 2));
      }
      function j8(u) {
        return u && u.length ? rh(u, vr, rv) : n;
      }
      function L8(u, h) {
        return u && u.length ? rh(u, Ne(h, 2), rv) : n;
      }
      var B8 = uh(function(u, h) {
        return u * h;
      }, 1), F8 = pv("round"), W8 = uh(function(u, h) {
        return u - h;
      }, 0);
      function z8(u) {
        return u && u.length ? Wy(u, vr) : 0;
      }
      function V8(u, h) {
        return u && u.length ? Wy(u, Ne(h, 2)) : 0;
      }
      return R.after = fU, R.ary = jA, R.assign = JU, R.assignIn = ZA, R.assignInWith = Sh, R.assignWith = QU, R.at = e6, R.before = LA, R.bind = Pv, R.bindAll = o8, R.bindKey = BA, R.castArray = SU, R.chain = DA, R.chunk = NV, R.compact = $V, R.concat = DV, R.cond = a8, R.conforms = s8, R.constant = $v, R.countBy = z4, R.create = t6, R.curry = FA, R.curryRight = WA, R.debounce = zA, R.defaults = n6, R.defaultsDeep = r6, R.defer = dU, R.delay = hU, R.difference = IV, R.differenceBy = RV, R.differenceWith = jV, R.drop = LV, R.dropRight = BV, R.dropRightWhile = FV, R.dropWhile = WV, R.fill = zV, R.filter = U4, R.flatMap = G4, R.flatMapDeep = Y4, R.flatMapDepth = q4, R.flatten = kA, R.flattenDeep = VV, R.flattenDepth = UV, R.flip = pU, R.flow = c8, R.flowRight = u8, R.fromPairs = KV, R.functions = u6, R.functionsIn = f6, R.groupBy = X4, R.initial = GV, R.intersection = YV, R.intersectionBy = qV, R.intersectionWith = XV, R.invert = h6, R.invertBy = p6, R.invokeMap = J4, R.iteratee = Dv, R.keyBy = Q4, R.keys = Tn, R.keysIn = yr, R.map = yh, R.mapKeys = g6, R.mapValues = y6, R.matches = f8, R.matchesProperty = d8, R.memoize = bh, R.merge = v6, R.mergeWith = JA, R.method = h8, R.methodOf = p8, R.mixin = Iv, R.negate = xh, R.nthArg = g8, R.omit = b6, R.omitBy = x6, R.once = mU, R.orderBy = eU, R.over = y8, R.overArgs = gU, R.overEvery = v8, R.overSome = b8, R.partial = Tv, R.partialRight = VA, R.partition = tU, R.pick = w6, R.pickBy = QA, R.property = aP, R.propertyOf = x8, R.pull = e4, R.pullAll = NA, R.pullAllBy = t4, R.pullAllWith = n4, R.pullAt = r4, R.range = w8, R.rangeRight = _8, R.rearg = yU, R.reject = iU, R.remove = i4, R.rest = vU, R.reverse = Ov, R.sampleSize = aU, R.set = S6, R.setWith = O6, R.shuffle = sU, R.slice = o4, R.sortBy = uU, R.sortedUniq = d4, R.sortedUniqBy = h4, R.split = G6, R.spread = bU, R.tail = p4, R.take = m4, R.takeRight = g4, R.takeRightWhile = y4, R.takeWhile = v4, R.tap = $4, R.throttle = xU, R.thru = gh, R.toArray = YA, R.toPairs = eP, R.toPairsIn = tP, R.toPath = T8, R.toPlainObject = XA, R.transform = A6, R.unary = wU, R.union = b4, R.unionBy = x4, R.unionWith = w4, R.uniq = _4, R.uniqBy = S4, R.uniqWith = O4, R.unset = P6, R.unzip = Av, R.unzipWith = $A, R.update = T6, R.updateWith = C6, R.values = yl, R.valuesIn = E6, R.without = A4, R.words = iP, R.wrap = _U, R.xor = P4, R.xorBy = T4, R.xorWith = C4, R.zip = E4, R.zipObject = k4, R.zipObjectDeep = M4, R.zipWith = N4, R.entries = eP, R.entriesIn = tP, R.extend = ZA, R.extendWith = Sh, Iv(R, R), R.add = E8, R.attempt = oP, R.camelCase = $6, R.capitalize = nP, R.ceil = k8, R.clamp = k6, R.clone = OU, R.cloneDeep = PU, R.cloneDeepWith = TU, R.cloneWith = AU, R.conformsTo = CU, R.deburr = rP, R.defaultTo = l8, R.divide = M8, R.endsWith = D6, R.eq = yi, R.escape = I6, R.escapeRegExp = R6, R.every = V4, R.find = K4, R.findIndex = CA, R.findKey = i6, R.findLast = H4, R.findLastIndex = EA, R.findLastKey = o6, R.floor = N8, R.forEach = IA, R.forEachRight = RA, R.forIn = a6, R.forInRight = s6, R.forOwn = l6, R.forOwnRight = c6, R.get = kv, R.gt = EU, R.gte = kU, R.has = d6, R.hasIn = Mv, R.head = MA, R.identity = vr, R.includes = Z4, R.indexOf = HV, R.inRange = M6, R.invoke = m6, R.isArguments = os, R.isArray = Ge, R.isArrayBuffer = MU, R.isArrayLike = gr, R.isArrayLikeObject = on, R.isBoolean = NU, R.isBuffer = ua, R.isDate = $U, R.isElement = DU, R.isEmpty = IU, R.isEqual = RU, R.isEqualWith = jU, R.isError = Cv, R.isFinite = LU, R.isFunction = po, R.isInteger = UA, R.isLength = wh, R.isMap = KA, R.isMatch = BU, R.isMatchWith = FU, R.isNaN = WU, R.isNative = zU, R.isNil = UU, R.isNull = VU, R.isNumber = HA, R.isObject = Zt, R.isObjectLike = en, R.isPlainObject = gu, R.isRegExp = Ev, R.isSafeInteger = KU, R.isSet = GA, R.isString = _h, R.isSymbol = kr, R.isTypedArray = gl, R.isUndefined = HU, R.isWeakMap = GU, R.isWeakSet = YU, R.join = ZV, R.kebabCase = j6, R.last = ti, R.lastIndexOf = JV, R.lowerCase = L6, R.lowerFirst = B6, R.lt = qU, R.lte = XU, R.max = $8, R.maxBy = D8, R.mean = I8, R.meanBy = R8, R.min = j8, R.minBy = L8, R.stubArray = jv, R.stubFalse = Lv, R.stubObject = S8, R.stubString = O8, R.stubTrue = A8, R.multiply = B8, R.nth = QV, R.noConflict = m8, R.noop = Rv, R.now = vh, R.pad = F6, R.padEnd = W6, R.padStart = z6, R.parseInt = V6, R.random = N6, R.reduce = nU, R.reduceRight = rU, R.repeat = U6, R.replace = K6, R.result = _6, R.round = F8, R.runInContext = Z, R.sample = oU, R.size = lU, R.snakeCase = H6, R.some = cU, R.sortedIndex = a4, R.sortedIndexBy = s4, R.sortedIndexOf = l4, R.sortedLastIndex = c4, R.sortedLastIndexBy = u4, R.sortedLastIndexOf = f4, R.startCase = Y6, R.startsWith = q6, R.subtract = W8, R.sum = z8, R.sumBy = V8, R.template = X6, R.times = P8, R.toFinite = mo, R.toInteger = qe, R.toLength = qA, R.toLower = Z6, R.toNumber = ni, R.toSafeInteger = ZU, R.toString = yt, R.toUpper = J6, R.trim = Q6, R.trimEnd = e8, R.trimStart = t8, R.truncate = n8, R.unescape = r8, R.uniqueId = C8, R.upperCase = i8, R.upperFirst = Nv, R.each = IA, R.eachRight = RA, R.first = MA, Iv(R, function() {
        var u = {};
        return Ri(R, function(h, b) {
          Ot.call(R.prototype, b) || (u[b] = h);
        }), u;
      }(), { chain: !1 }), R.VERSION = r, Xr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
        R[u].placeholder = R;
      }), Xr(["drop", "take"], function(u, h) {
        lt.prototype[u] = function(b) {
          b = b === n ? 1 : vn(qe(b), 0);
          var P = this.__filtered__ && !h ? new lt(this) : this.clone();
          return P.__filtered__ ? P.__takeCount__ = Yn(b, P.__takeCount__) : P.__views__.push({
            size: Yn(b, Y),
            type: u + (P.__dir__ < 0 ? "Right" : "")
          }), P;
        }, lt.prototype[u + "Right"] = function(b) {
          return this.reverse()[u](b).reverse();
        };
      }), Xr(["filter", "map", "takeWhile"], function(u, h) {
        var b = h + 1, P = b == L || b == W;
        lt.prototype[u] = function(M) {
          var j = this.clone();
          return j.__iteratees__.push({
            iteratee: Ne(M, 3),
            type: b
          }), j.__filtered__ = j.__filtered__ || P, j;
        };
      }), Xr(["head", "last"], function(u, h) {
        var b = "take" + (h ? "Right" : "");
        lt.prototype[u] = function() {
          return this[b](1).value()[0];
        };
      }), Xr(["initial", "tail"], function(u, h) {
        var b = "drop" + (h ? "" : "Right");
        lt.prototype[u] = function() {
          return this.__filtered__ ? new lt(this) : this[b](1);
        };
      }), lt.prototype.compact = function() {
        return this.filter(vr);
      }, lt.prototype.find = function(u) {
        return this.filter(u).head();
      }, lt.prototype.findLast = function(u) {
        return this.reverse().find(u);
      }, lt.prototype.invokeMap = nt(function(u, h) {
        return typeof u == "function" ? new lt(this) : this.map(function(b) {
          return uu(b, u, h);
        });
      }), lt.prototype.reject = function(u) {
        return this.filter(xh(Ne(u)));
      }, lt.prototype.slice = function(u, h) {
        u = qe(u);
        var b = this;
        return b.__filtered__ && (u > 0 || h < 0) ? new lt(b) : (u < 0 ? b = b.takeRight(-u) : u && (b = b.drop(u)), h !== n && (h = qe(h), b = h < 0 ? b.dropRight(-h) : b.take(h - u)), b);
      }, lt.prototype.takeRightWhile = function(u) {
        return this.reverse().takeWhile(u).reverse();
      }, lt.prototype.toArray = function() {
        return this.take(Y);
      }, Ri(lt.prototype, function(u, h) {
        var b = /^(?:filter|find|map|reject)|While$/.test(h), P = /^(?:head|last)$/.test(h), M = R[P ? "take" + (h == "last" ? "Right" : "") : h], j = P || /^find/.test(h);
        M && (R.prototype[h] = function() {
          var K = this.__wrapped__, q = P ? [1] : arguments, J = K instanceof lt, de = q[0], he = J || Ge(K), ge = function(it) {
            var ct = M.apply(R, ra([it], q));
            return P && xe ? ct[0] : ct;
          };
          he && b && typeof de == "function" && de.length != 1 && (J = he = !1);
          var xe = this.__chain__, Ce = !!this.__actions__.length, De = j && !xe, et = J && !Ce;
          if (!j && he) {
            K = et ? K : new lt(this);
            var Ie = u.apply(K, q);
            return Ie.__actions__.push({ func: gh, args: [ge], thisArg: n }), new Jr(Ie, xe);
          }
          return De && et ? u.apply(this, q) : (Ie = this.thru(ge), De ? P ? Ie.value()[0] : Ie.value() : Ie);
        });
      }), Xr(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
        var h = zd[u], b = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", P = /^(?:pop|shift)$/.test(u);
        R.prototype[u] = function() {
          var M = arguments;
          if (P && !this.__chain__) {
            var j = this.value();
            return h.apply(Ge(j) ? j : [], M);
          }
          return this[b](function(K) {
            return h.apply(Ge(K) ? K : [], M);
          });
        };
      }), Ri(lt.prototype, function(u, h) {
        var b = R[h];
        if (b) {
          var P = b.name + "";
          Ot.call(fl, P) || (fl[P] = []), fl[P].push({ name: h, func: b });
        }
      }), fl[ch(n, x).name] = [{
        name: "wrapper",
        func: n
      }], lt.prototype.clone = r3, lt.prototype.reverse = i3, lt.prototype.value = o3, R.prototype.at = D4, R.prototype.chain = I4, R.prototype.commit = R4, R.prototype.next = j4, R.prototype.plant = B4, R.prototype.reverse = F4, R.prototype.toJSON = R.prototype.valueOf = R.prototype.value = W4, R.prototype.first = R.prototype.head, ru && (R.prototype[ru] = L4), R;
    }, ll = R5();
    Za ? ((Za.exports = ll)._ = ll, Dy._ = ll) : Rn._ = ll;
  }).call(_o);
})(Vp, Vp.exports);
var IQ = Vp.exports;
const ax = {
  sm: "text-xs [&>svg]:size-4 rounded",
  md: "text-sm [&>svg]:size-5 rounded-md",
  lg: "text-base [&>svg]:size-6 rounded-md"
}, qi = {
  input: {
    sm: "py-1.5 px-2 rounded",
    md: "p-2.5 rounded-md",
    lg: "p-3 rounded-md"
  },
  content: {
    sm: "p-1.5",
    md: "p-1.5",
    lg: "p-2"
  },
  title: {
    sm: "p-2 text-xs",
    md: "p-2 text-sm",
    lg: "p-2 text-sm"
  },
  item: {
    sm: "text-sm text-text-secondary rounded",
    md: "text-base text-text-secondary rounded-md",
    lg: "text-base text-text-secondary rounded-md"
  },
  icon: {
    sm: "p-1 text-sm [&>svg]:size-4 text-icon-secondary",
    md: "p-2 text-base [&>svg]:size-5 text-icon-secondary",
    lg: "p-2 text-base [&>svg]:size-5 text-icon-secondary"
  },
  dialog: {
    sm: "mt-1 rounded-md",
    md: "mt-1.5 rounded-lg",
    lg: "mt-1.5 rounded-lg"
  },
  slashIcon: {
    sm: "px-2 py-0.5",
    md: "px-3 py-1",
    lg: "px-3.5 py-1"
  }
}, RQ = {
  primary: "bg-field-primary-background outline outline-1 outline-field-border hover:outline-border-strong",
  secondary: "bg-field-secondary-background outline outline-1 outline-field-border hover:outline-border-strong",
  ghost: "bg-field-secondary-background outline outline-1 outline-transparent"
}, jQ = "text-icon-secondary group-hover:text-icon-primary group-focus-within:text-icon-primary", iE = {
  ghost: "cursor-not-allowed text-text-disabled placeholder:text-text-disabled",
  primary: "border-border-disabled hover:border-border-disabled bg-field-background-disabled cursor-not-allowed text-text-disabled placeholder:text-text-disabled",
  secondary: "border-border-disabled hover:border-border-disabled cursor-not-allowed text-text-disabled placeholder:text-text-disabled"
}, fj = ht({}), qs = () => Ve(fj), qo = $t(
  ({
    className: e,
    size: t = "sm",
    open: n = !1,
    onOpenChange: r = () => {
    },
    loading: i = !1,
    ...o
  }, a) => {
    const [s, l] = Me(""), [c, f] = Me(i ?? !1), { refs: d, floatingStyles: p, context: m } = ug({
      open: n,
      onOpenChange: r,
      placement: "bottom-start",
      whileElementsMounted: ng,
      middleware: [
        rg(t === "sm" ? 4 : 6),
        ig({ padding: 10 }),
        mD({
          apply({ rects: x, elements: w, availableHeight: S }) {
            w.floating.style.maxHeight = `${S}px`, w.floating.style.width = `${x.reference.width}px`, w.floating.style.fontFamily = window.getComputedStyle(
              w.reference
            ).fontFamily;
          }
        })
      ]
    }), g = cg(m), { getReferenceProps: v, getFloatingProps: y } = fg([
      g
    ]);
    return Qe(() => {
      const x = CK(), w = (S) => {
        const _ = x === "Mac OS" ? S.metaKey : S.ctrlKey;
        if (S.key === "/" && _ && (S.preventDefault(), d.reference && d.reference.current)) {
          const O = d.reference.current instanceof HTMLElement ? d.reference.current.querySelector("input") : null;
          O && O.focus();
        }
      };
      return window.addEventListener("keydown", w), () => {
        window.removeEventListener("keydown", w);
      };
    }, [d.reference]), /* @__PURE__ */ E(
      fj.Provider,
      {
        value: {
          size: t,
          open: n,
          onOpenChange: r,
          refs: d,
          floatingStyles: p,
          context: m,
          getReferenceProps: v,
          getFloatingProps: y,
          searchTerm: s,
          setSearchTerm: l,
          isLoading: c,
          setIsLoading: f
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            className: H(
              "searchbox-wrapper box-border relative w-full",
              e
            ),
            ...o,
            ref: a
          }
        )
      }
    );
  }
);
qo.displayName = "SearchBox";
const dj = $t(
  ({
    className: e,
    type: t = "text",
    placeholder: n = "Search...",
    variant: r = "primary",
    disabled: i = !1,
    onChange: o = () => {
    },
    ...a
  }, s) => {
    const {
      size: l,
      onOpenChange: c,
      refs: f,
      getReferenceProps: d,
      searchTerm: p,
      setSearchTerm: m
    } = qs(), g = l === "lg" ? "sm" : "xs", v = (y) => {
      const x = y.target.value;
      m(x), o(x), typeof c == "function" && (x.trim() ? c(!0) : c(!1));
    };
    return /* @__PURE__ */ me(
      "div",
      {
        ref: f.setReference,
        className: H(
          "w-full group relative flex justify-center items-center gap-1.5 focus-within:z-10 transition-colors ease-in-out duration-150",
          RQ[r],
          qi.input[l],
          i ? iE[r] : "focus-within:ring-2 focus-within:ring-focus focus-within:ring-offset-2 focus-within:border-focus-border focus-within:hover:border-focus-border"
        ),
        ...d,
        children: [
          /* @__PURE__ */ E(
            "span",
            {
              className: H(
                ax[l],
                i ? "text-icon-disabled" : jQ,
                "flex justify-center items-center"
              ),
              children: /* @__PURE__ */ E(q$, {})
            }
          ),
          /* @__PURE__ */ E(
            "input",
            {
              type: t,
              ref: s,
              className: H(
                ax[l],
                "flex-grow font-medium bg-transparent border-none outline-none border-transparent focus:ring-0 py-0",
                i ? iE[r] : [
                  "text-field-placeholder focus-within:text-field-input group-hover:text-field-input",
                  "placeholder:text-field-placeholder"
                ],
                e
              ),
              disabled: i,
              value: p,
              onChange: v,
              placeholder: n,
              ...IQ.omit(a, [
                "size",
                "open",
                "onOpenChange",
                "loading"
              ])
            }
          ),
          /* @__PURE__ */ E(
            hg,
            {
              label: "⌘/",
              size: g,
              type: "rounded",
              variant: "neutral"
            }
          )
        ]
      }
    );
  }
);
dj.displayName = "SearchBox.Input";
const hj = ({
  className: e,
  dropdownPortalRoot: t = null,
  // Root element where the dropdown will be rendered.
  dropdownPortalId: n = "",
  // Id of the dropdown portal where the dropdown will be rendered.
  children: r,
  ...i
}) => {
  const { size: o, open: a, refs: s, floatingStyles: l, getFloatingProps: c } = qs();
  return a ? /* @__PURE__ */ E(lg, { id: n, root: t, children: /* @__PURE__ */ E(
    "div",
    {
      ref: s.setFloating,
      style: {
        ...l
      },
      className: H(
        "bg-background-primary rounded-md border border-solid border-border-subtle shadow-soft-shadow-lg overflow-y-auto text-wrap",
        qi.dialog[o],
        e
      ),
      ...c(),
      ...i,
      children: r
    }
  ) }) : null;
};
hj.displayName = "SearchBox.Content";
const pj = ({
  filter: e = !0,
  children: t
}) => {
  const { searchTerm: n, isLoading: r } = qs();
  if (!e)
    return /* @__PURE__ */ E("div", { children: t });
  const i = tr.toArray(t).map((o) => {
    if (I.isValidElement(o) && o.type === w_) {
      const a = tr.toArray(
        o.props.children
      ).filter(
        (s) => I.isValidElement(s) && typeof s.props.children == "string" && s.props.children.toLowerCase().includes(n.toLowerCase())
      );
      return a.length > 0 ? _t(o, {
        children: a
      }) : null;
    }
    return o;
  }).filter(Boolean);
  return r ? /* @__PURE__ */ E(__, {}) : /* @__PURE__ */ E("div", { children: i.some(
    (o) => I.isValidElement(o) && o.type !== S_
  ) ? i : /* @__PURE__ */ E(x_, {}) });
};
pj.displayName = "SearchBox.List";
const x_ = ({
  children: e = "No results found."
}) => {
  const { size: t } = qs();
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex justify-center items-center",
        qi.item[t],
        "text-text-tertiary p-4"
      ),
      children: e
    }
  );
};
x_.displayName = "SearchBox.Empty";
const w_ = ({ heading: e, children: t }) => {
  const { size: n } = qs();
  return /* @__PURE__ */ me(
    "div",
    {
      className: H(
        qi.content[n],
        qi.item[n]
      ),
      children: [
        e && /* @__PURE__ */ E(
          "div",
          {
            className: H(
              qi.title[n],
              "text-text-secondary"
            ),
            children: e
          }
        ),
        t
      ]
    }
  );
};
w_.displayName = "SearchBox.Group";
const mj = $t(
  ({ className: e, icon: t, children: n, ...r }, i) => {
    const { size: o } = qs();
    return /* @__PURE__ */ me(
      "div",
      {
        ref: i,
        className: H(
          "flex items-center justify-start gap-1 p-1 hover:bg-background-secondary focus:bg-background-secondary cursor-pointer",
          qi.item[o]
        ),
        ...r,
        children: [
          t && /* @__PURE__ */ E(
            "span",
            {
              className: H(
                qi.icon[o],
                "flex items-center justify-center"
              ),
              children: t
            }
          ),
          /* @__PURE__ */ E(
            "span",
            {
              className: H(
                "flex-grow p-1 font-normal cursor-pointer",
                qi.item[o],
                e
              ),
              children: n
            }
          )
        ]
      }
    );
  }
);
mj.displayName = "SearchBox.Item";
const __ = ({
  loadingIcon: e = /* @__PURE__ */ E(ED, {})
}) => {
  const { size: t } = qs(), n = I.isValidElement(e) ? _t(e, { size: t }) : e;
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex justify-center p-4",
        ax[t],
        qi.item[t]
      ),
      children: n
    }
  );
};
__.displayName = "SearchBox.Loading";
const S_ = $t(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "hr",
  {
    ref: n,
    className: H(
      "border-0 border-t border-border-subtle border-solid m-0",
      e
    ),
    ...t
  }
));
S_.displayName = "SearchBox.Separator";
qo.Input = dj;
qo.Loading = __;
qo.Separator = S_;
qo.Content = hj;
qo.List = pj;
qo.Empty = x_;
qo.Group = w_;
qo.Item = mj;
const gj = ht({}), yj = () => Ve(gj), Xs = ({
  placement: e = "bottom",
  offset: t = 10,
  boundary: n = "clippingAncestors",
  children: r,
  className: i
}) => {
  const [o, a] = Me(!1), { refs: s, floatingStyles: l, context: c } = ug({
    open: o,
    onOpenChange: a,
    placement: e,
    strategy: "absolute",
    middleware: [
      rg(t),
      ig({ boundary: n }),
      pD({ boundary: n })
    ],
    whileElementsMounted: ng
  }), f = a1(c), d = cg(c), p = s1(c, { role: "menu" }), { getReferenceProps: m, getFloatingProps: g } = fg([
    f,
    d,
    p
  ]), { isMounted: v, styles: y } = OD(c, {
    duration: 150,
    initial: { opacity: 0, scale: 0.95 },
    open: { opacity: 1, scale: 1 },
    close: { opacity: 0, scale: 0.95 }
  }), x = () => a((S) => !S), w = () => a(!1);
  return /* @__PURE__ */ E(
    gj.Provider,
    {
      value: {
        refs: s,
        handleClose: w,
        isMounted: v,
        styles: y,
        floatingStyles: l,
        getFloatingProps: g
      },
      children: /* @__PURE__ */ me("div", { className: H("relative inline-block", i), children: [
        I.Children.map(r, (S) => {
          var A;
          return I.isValidElement(S) && ((A = S == null ? void 0 : S.type) == null ? void 0 : A.displayName) === "DropdownMenu.Trigger" ? _t(S, {
            ref: s.setReference,
            onClick: x,
            ...m()
          }) : null;
        }),
        I.Children.map(r, (S) => {
          var A;
          return I.isValidElement(S) && ((A = S == null ? void 0 : S.type) == null ? void 0 : A.displayName) === "DropdownMenu.Portal" ? S : null;
        })
      ] })
    }
  );
};
Xs.displayName = "DropdownMenu";
const vj = ({
  children: e,
  className: t,
  root: n,
  id: r
}) => {
  const { refs: i, floatingStyles: o, getFloatingProps: a, isMounted: s, styles: l } = yj();
  return s && /* @__PURE__ */ E(lg, { id: r, root: n, children: /* @__PURE__ */ E(
    "div",
    {
      ref: i.setFloating,
      className: t,
      style: {
        ...o,
        ...l
      },
      ...a(),
      children: I.Children.map(e, (c) => {
        var f;
        return ((f = c == null ? void 0 : c.type) == null ? void 0 : f.displayName) === "DropdownMenu.Content" ? c : null;
      })
    }
  ) });
};
vj.displayName = "DropdownMenu.Portal";
const bj = I.forwardRef(({ children: e, className: t, ...n }, r) => ut(e) ? I.cloneElement(e, {
  className: H(t, e.props.className),
  ref: r,
  ...n
}) : /* @__PURE__ */ E(
  "div",
  {
    ref: r,
    className: H("cursor-pointer", t),
    role: "button",
    tabIndex: 0,
    ...n,
    children: e
  }
));
bj.displayName = "DropdownMenu.Trigger";
const xj = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "div",
  {
    className: H(
      "border border-solid border-border-subtle rounded-md shadow-lg overflow-hidden",
      t
    ),
    children: /* @__PURE__ */ E(Ka, { ...n, children: e })
  }
);
xj.displayName = "DropdownMenu.Content";
const wj = (e) => /* @__PURE__ */ E(Ka.List, { ...e });
wj.displayName = "DropdownMenu.List";
const _j = ({
  children: e,
  as: t = Ka.Item,
  ...n
}) => {
  var i;
  const { handleClose: r } = yj();
  return e ? t === fi && ut(e) ? _t(e, {
    onClick: sf(
      (i = e.props) == null ? void 0 : i.onClick,
      r
    )
  }) : /* @__PURE__ */ E(
    t,
    {
      ...n,
      className: H("px-2", n.className),
      onClick: sf(n.onClick, r),
      children: e
    }
  ) : null;
};
_j.displayName = "DropdownMenu.Item";
const Sj = (e) => /* @__PURE__ */ E(Ka.Separator, { ...e });
Sj.displayName = "DropdownMenu.Separator";
Xs.Trigger = bj;
Xs.Content = xj;
Xs.List = wj;
Xs.Item = _j;
Xs.Separator = Sj;
Xs.Portal = vj;
const LQ = {
  left: {
    open: {
      x: 0
    },
    exit: {
      x: "-100%"
    }
  },
  right: {
    open: {
      x: 0
    },
    exit: {
      x: "100%"
    }
  }
}, Oj = ({ children: e, className: t }) => {
  const { open: n, position: r, handleClose: i, drawerRef: o, transitionDuration: a } = Fg();
  return /* @__PURE__ */ E(Hs, { children: n && /* @__PURE__ */ E("div", { className: "fixed inset-0", children: /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "flex items-center justify-center h-full",
        {
          "justify-start": r === "left",
          "justify-end": r === "right"
        }
      ),
      children: /* @__PURE__ */ E(
        ui.div,
        {
          ref: o,
          className: H(
            "flex flex-col gap-5 w-120 h-full bg-background-primary shadow-2xl my-5 overflow-hidden",
            t
          ),
          initial: "exit",
          animate: "open",
          exit: "exit",
          variants: LQ[r],
          transition: a,
          children: typeof e == "function" ? e({ close: i }) : e
        }
      )
    }
  ) }) });
};
Oj.displayName = "Drawer.Panel";
const Aj = ({ children: e, className: t, ...n }) => /* @__PURE__ */ E("div", { className: H("space-y-2 px-5 pt-5 pb-1", t), ...n, children: e });
Aj.displayName = "Drawer.Header";
const Pj = ({
  children: e,
  as: t = "h3",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: H(
      "text-base font-semibold text-text-primary m-0 p-0",
      n
    ),
    ...r,
    children: e
  }
);
Pj.displayName = "Drawer.Title";
const Tj = ({
  children: e,
  as: t = "p",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: H(
      "text-sm font-normal text-text-secondary my-0 ml-0 mr-1 p-0",
      n
    ),
    ...r,
    children: e
  }
);
Tj.displayName = "Drawer.Description";
const Cj = ({ children: e, className: t, ...n }) => /* @__PURE__ */ E(
  "div",
  {
    className: H(
      "px-5 flex flex-col flex-1 overflow-y-auto overflow-x-hidden",
      t
    ),
    ...n,
    children: e
  }
);
Cj.displayName = "Drawer.Body";
const Ej = ({ children: e, className: t }) => {
  const { design: n, handleClose: r } = Fg(), i = () => e ? typeof e == "function" ? e({ close: r }) : e : null;
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "p-5 flex justify-end gap-3 mt-auto",
        {
          "bg-background-secondary": n === "footer-divided"
        },
        t
      ),
      children: i()
    }
  );
};
Ej.displayName = "Drawer.Footer";
const oE = ({
  className: e,
  ...t
}) => /* @__PURE__ */ E(
  "button",
  {
    className: H(
      "bg-transparent inline-flex justify-center items-center border-0 p-1 m-0 cursor-pointer focus:outline-none outline-none shadow-none",
      e
    ),
    "aria-label": "Close drawer",
    ...t,
    children: /* @__PURE__ */ E(Na, { className: "size-4 text-text-primary shrink-0" })
  }
), kj = ({
  children: e,
  as: t = fi,
  ...n
}) => {
  const { handleClose: r } = Fg();
  return e ? t === fi ? typeof e == "function" ? e({ close: r }) : ut(e) ? _t(e, {
    onClick: r
  }) : /* @__PURE__ */ E(oE, { onClick: r, ...n }) : /* @__PURE__ */ E(t, { ...n, onClick: r, children: e }) : /* @__PURE__ */ E(oE, { onClick: r, ...n });
};
kj.displayName = "Drawer.CloseButton";
const BQ = {
  open: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, Mj = ({ className: e, ...t }) => {
  const { open: n, drawerContainerRef: r, transitionDuration: i } = Fg();
  return r != null && r.current ? !!r.current && Kw(
    /* @__PURE__ */ E(Hs, { children: n && /* @__PURE__ */ E(
      ui.div,
      {
        className: H(
          "fixed inset-0 -z-10 bg-background-inverse/90",
          e
        ),
        ...t,
        initial: "exit",
        animate: "open",
        exit: "exit",
        variants: BQ,
        transition: i
      }
    ) }),
    r.current
  ) : null;
};
Mj.displayName = "Drawer.Backdrop";
const FQ = 0.2, Nj = ht({}), Fg = () => Ve(Nj), Xo = ({
  open: e,
  setOpen: t,
  children: n,
  trigger: r,
  className: i,
  exitOnClickOutside: o = !1,
  exitOnEsc: a = !0,
  design: s = "simple",
  position: l = "right",
  transitionDuration: c = FQ,
  scrollLock: f = !0
}) => {
  const d = e !== void 0 && t !== void 0, [p, m] = Me(!1), g = ft(null), v = ft(null), y = Le(
    () => d ? e : p,
    [e, p]
  ), x = Le(
    () => d ? t : m,
    [m, m]
  ), w = () => {
    y || x(!0);
  }, S = () => {
    y && x(!1);
  }, A = Je(() => ut(r) ? _t(r, {
    onClick: sf(w, r.props.onClick)
  }) : typeof r == "function" ? r({ onClick: w }) : null, [r, w, S]), _ = (T) => {
    switch (T.key) {
      case "Escape":
        a && S();
        break;
    }
  }, O = (T) => {
    o && g.current && !g.current.contains(T.target) && S();
  };
  return Qe(() => (window.addEventListener("keydown", _), document.addEventListener("mousedown", O), () => {
    window.removeEventListener("keydown", _), document.removeEventListener("mousedown", O);
  }), [y]), Qe(() => {
    if (!f)
      return;
    const T = document.querySelector("html");
    return y && T && (T.style.overflow = "hidden"), () => {
      T && (T.style.overflow = "");
    };
  }, [y]), /* @__PURE__ */ me(Ut, { children: [
    A(),
    /* @__PURE__ */ E(
      Nj.Provider,
      {
        value: {
          open: y,
          setOpen: x,
          handleClose: S,
          design: s,
          position: l,
          drawerContainerRef: v,
          drawerRef: g,
          transitionDuration: { duration: c }
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            className: H(
              "fixed z-auto w-0 h-0 overflow-visible",
              i
            ),
            ref: v,
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "drawer",
            children: n
          }
        )
      }
    )
  ] });
};
Xo.displayName = "Drawer";
Xo.Panel = Oj;
Xo.Header = Aj;
Xo.Title = Pj;
Xo.Description = Tj;
Xo.Body = Cj;
Xo.CloseButton = kj;
Xo.Footer = Ej;
Xo.Backdrop = Mj;
const Wg = {
  xs: {
    general: "text-xs min-w-6 h-6",
    ellipse: "text-xs min-w-6",
    icon: "size-4"
  },
  sm: {
    general: "text-xs min-w-8 h-8",
    ellipse: "text-xs min-w-8",
    icon: "size-4"
  },
  md: {
    general: "text-sm min-w-10 h-10",
    ellipse: "text-sm min-w-10",
    icon: "size-5"
  },
  lg: {
    general: "text-base min-w-12 h-12",
    ellipse: "text-base min-w-12",
    icon: "size-6"
  }
}, Bs = {
  general: "group disabled:border-field-border-disabled opacity-50",
  text: "group-disabled:text-field-color-disabled"
}, $j = ht({
  size: "sm",
  disabled: !1
}), wd = () => Ve($j), Lc = ({
  size: e = "sm",
  disabled: t = !1,
  children: n,
  className: r,
  ...i
}) => /* @__PURE__ */ E($j.Provider, { value: { size: e, disabled: t }, children: /* @__PURE__ */ E(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: H(
      "flex w-full justify-center box-border m-0",
      r
    ),
    ...i,
    children: n
  }
) });
Lc.displayName = "Pagination";
const Dj = $t(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "ul",
  {
    ref: n,
    className: H(
      "m-0 p-0 w-full flex justify-center flex-row items-center gap-1",
      "list-none",
      e
    ),
    ...t
  }
));
Dj.displayName = "Pagination.Content";
const Ij = $t(
  ({ isActive: e = !1, className: t, children: n, ...r }, i) => {
    const { disabled: o } = wd();
    return /* @__PURE__ */ E(
      "li",
      {
        ref: i,
        className: H("flex", o && Bs.general),
        children: /* @__PURE__ */ E(
          O_,
          {
            isActive: e,
            disabled: o,
            className: t,
            ...r,
            children: n
          }
        )
      }
    );
  }
);
Ij.displayName = "Pagination.Item";
const O_ = ({
  isActive: e = !1,
  tag: t = "a",
  children: n,
  className: r,
  ...i
}) => {
  const { size: o, disabled: a } = wd(), s = (l) => l.preventDefault();
  return /* @__PURE__ */ E(
    Qn,
    {
      tag: t,
      size: o,
      variant: "ghost",
      className: H(
        "no-underline bg-transparent p-0 m-0 border-none",
        "flex justify-center items-center rounded text-button-secondary",
        "focus:outline focus:outline-1 focus:outline-border-subtle focus:bg-button-tertiary-hover",
        Wg[o].general,
        !a && e && "text-button-primary active:text-button-primary bg-brand-background-50",
        a && [
          Bs.general,
          Bs.text,
          "focus:ring-transparent cursor-not-allowed"
        ],
        r
      ),
      disabled: a,
      ...i,
      onClick: (l) => sf(
        i.onClick || (() => {
        }),
        a ? s : () => {
        }
      )(l),
      children: /* @__PURE__ */ E("span", { className: "px-1 flex", children: n })
    }
  );
}, Rj = (e) => {
  const { size: t, disabled: n } = wd();
  return /* @__PURE__ */ E(
    "li",
    {
      className: H("flex", n && Bs.general),
      "aria-label": "Go to previous page",
      children: /* @__PURE__ */ E(
        O_,
        {
          className: H("[&>span]:flex [&>span]:items-center"),
          ...e,
          children: /* @__PURE__ */ E(H$, { className: H(Wg[t].icon) })
        }
      )
    }
  );
};
Rj.displayName = "Pagination.Previous";
const jj = (e) => {
  const { size: t, disabled: n } = wd();
  return /* @__PURE__ */ E(
    "li",
    {
      className: H("flex", n && Bs.general),
      "aria-label": "Go to next page",
      children: /* @__PURE__ */ E(
        O_,
        {
          className: H("[&>span]:flex [&>span]:items-center"),
          ...e,
          children: /* @__PURE__ */ E(Yw, { className: H(Wg[t].icon) })
        }
      )
    }
  );
};
jj.displayName = "Pagination.Next";
const Lj = (e) => {
  const { size: t, disabled: n } = wd();
  return /* @__PURE__ */ E("li", { className: H("flex", n && Bs.general), children: /* @__PURE__ */ E(
    "span",
    {
      className: H(
        "flex justify-center",
        Wg[t].ellipse,
        n && Bs.general
      ),
      ...e,
      children: "•••"
    }
  ) });
};
Lj.displayName = "Pagination.Ellipsis";
Lc.Content = Dj;
Lc.Item = Ij;
Lc.Previous = Rj;
Lc.Next = jj;
Lc.Ellipsis = Lj;
var Re;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Re || (Re = {}));
var jt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(jt || (jt = {}));
var Ci;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Ci || (Ci = {}));
const Bj = 6048e5, WQ = 864e5, aE = Symbol.for("constructDateFrom");
function On(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && aE in e ? e[aE](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Bt(e, t) {
  return On(t || e, e);
}
function Fj(e, t, n) {
  const r = Bt(e, n == null ? void 0 : n.in);
  return isNaN(t) ? On(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function A_(e, t, n) {
  const r = Bt(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return On(e, NaN);
  if (!t)
    return r;
  const i = r.getDate(), o = On(e, r.getTime());
  o.setMonth(r.getMonth() + t + 1, 0);
  const a = o.getDate();
  return i >= a ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    i
  ), r);
}
let zQ = {};
function _d() {
  return zQ;
}
function Wa(e, t) {
  var s, l, c, f;
  const n = _d(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, i = Bt(e, t == null ? void 0 : t.in), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Of(e, t) {
  return Wa(e, { ...t, weekStartsOn: 1 });
}
function Wj(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = On(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const o = Of(i), a = On(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Of(a);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function sE(e) {
  const t = Bt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Sd(e, ...t) {
  const n = On.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function nc(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function zj(e, t, n) {
  const [r, i] = Sd(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = nc(r), a = nc(i), s = +o - sE(o), l = +a - sE(a);
  return Math.round((s - l) / WQ);
}
function VQ(e, t) {
  const n = Wj(e, t), r = On(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Of(r);
}
function Vj(e, t, n) {
  return Fj(e, t * 7, n);
}
function UQ(e, t, n) {
  return A_(e, t * 12, n);
}
function KQ(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = On.bind(null, i));
    const o = Bt(i, r);
    (!n || n < o || isNaN(+o)) && (n = o);
  }), On(r, n || NaN);
}
function HQ(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = On.bind(null, i));
    const o = Bt(i, r);
    (!n || n > o || isNaN(+o)) && (n = o);
  }), On(r, n || NaN);
}
function lE(e) {
  return On(e, Date.now());
}
function GQ(e, t, n) {
  const [r, i] = Sd(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +nc(r) == +nc(i);
}
function Uj(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function YQ(e) {
  return !(!Uj(e) && typeof e != "number" || isNaN(+Bt(e)));
}
function qQ(e, t, n) {
  const [r, i] = Sd(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = r.getFullYear() - i.getFullYear(), a = r.getMonth() - i.getMonth();
  return o * 12 + a;
}
function sx(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function lx(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function XQ(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Kj(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Up(e, t) {
  var s, l, c, f;
  const n = _d(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, i = Bt(e, t == null ? void 0 : t.in), o = i.getDay(), a = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + a), i.setHours(23, 59, 59, 999), i;
}
function ZQ(e, t) {
  return Up(e, { ...t, weekStartsOn: 1 });
}
const JQ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, QQ = (e, t, n) => {
  let r;
  const i = JQ[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function _b(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const eee = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, tee = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, nee = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ree = {
  date: _b({
    formats: eee,
    defaultWidth: "full"
  }),
  time: _b({
    formats: tee,
    defaultWidth: "full"
  }),
  dateTime: _b({
    formats: nee,
    defaultWidth: "full"
  })
}, iee = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, oee = (e, t, n, r) => iee[e];
function Su(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[a];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[o];
  };
}
const aee = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, see = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, lee = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, cee = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, uee = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fee = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, dee = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, hee = {
  ordinalNumber: dee,
  era: Su({
    values: aee,
    defaultWidth: "wide"
  }),
  quarter: Su({
    values: see,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Su({
    values: lee,
    defaultWidth: "wide"
  }),
  day: Su({
    values: cee,
    defaultWidth: "wide"
  }),
  dayPeriod: Su({
    values: uee,
    defaultWidth: "wide",
    formattingValues: fee,
    defaultFormattingWidth: "wide"
  })
};
function Ou(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    const a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? mee(s, (d) => d.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      pee(s, (d) => d.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const f = t.slice(a.length);
    return { value: c, rest: f };
  };
}
function pee(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function mee(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function gee(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(i.length);
    return { value: a, rest: s };
  };
}
const yee = /^(\d+)(th|st|nd|rd)?/i, vee = /\d+/i, bee = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, xee = {
  any: [/^b/i, /^(a|c)/i]
}, wee = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, _ee = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, See = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Oee = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Aee = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Pee = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Tee = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Cee = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Eee = {
  ordinalNumber: gee({
    matchPattern: yee,
    parsePattern: vee,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ou({
    matchPatterns: bee,
    defaultMatchWidth: "wide",
    parsePatterns: xee,
    defaultParseWidth: "any"
  }),
  quarter: Ou({
    matchPatterns: wee,
    defaultMatchWidth: "wide",
    parsePatterns: _ee,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ou({
    matchPatterns: See,
    defaultMatchWidth: "wide",
    parsePatterns: Oee,
    defaultParseWidth: "any"
  }),
  day: Ou({
    matchPatterns: Aee,
    defaultMatchWidth: "wide",
    parsePatterns: Pee,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ou({
    matchPatterns: Tee,
    defaultMatchWidth: "any",
    parsePatterns: Cee,
    defaultParseWidth: "any"
  })
}, zg = {
  code: "en-US",
  formatDistance: QQ,
  formatLong: ree,
  formatRelative: oee,
  localize: hee,
  match: Eee,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function kee(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in);
  return zj(n, Kj(n)) + 1;
}
function Hj(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in), r = +Of(n) - +VQ(n);
  return Math.round(r / Bj) + 1;
}
function Gj(e, t) {
  var f, d, p, m;
  const n = Bt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = _d(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((m = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = On((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const s = Wa(a, t), l = On((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const c = Wa(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function Mee(e, t) {
  var s, l, c, f;
  const n = _d(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = Gj(e, t), o = On((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), Wa(o, t);
}
function Yj(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in), r = +Wa(n, t) - +Mee(n, t);
  return Math.round(r / Bj) + 1;
}
function At(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const ma = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return At(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : At(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return At(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return At(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return At(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return At(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return At(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return At(i, t.length);
  }
}, xl = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, cE = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return ma.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = Gj(e, r), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const a = o % 100;
      return At(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : At(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Wj(e);
    return At(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return At(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return At(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return At(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ma.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return At(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = Yj(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : At(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Hj(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : At(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ma.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = kee(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : At(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return At(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return At(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return At(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = xl.noon : r === 0 ? i = xl.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = xl.evening : r >= 12 ? i = xl.afternoon : r >= 4 ? i = xl.morning : i = xl.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return ma.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ma.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : At(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : At(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ma.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ma.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return ma.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return fE(r);
      case "XXXX":
      case "XX":
        return ms(r);
      case "XXXXX":
      case "XXX":
      default:
        return ms(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return fE(r);
      case "xxxx":
      case "xx":
        return ms(r);
      case "xxxxx":
      case "xxx":
      default:
        return ms(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + uE(r, ":");
      case "OOOO":
      default:
        return "GMT" + ms(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + uE(r, ":");
      case "zzzz":
      default:
        return "GMT" + ms(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return At(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return At(+e, t.length);
  }
};
function uE(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + t + At(o, 2);
}
function fE(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + At(Math.abs(e) / 60, 2) : ms(e, t);
}
function ms(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = At(Math.trunc(r / 60), 2), o = At(r % 60, 2);
  return n + i + t + o;
}
const dE = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, qj = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Nee = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return dE(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", dE(r, t)).replace("{{time}}", qj(i, t));
}, $ee = {
  p: qj,
  P: Nee
}, Dee = /^D+$/, Iee = /^Y+$/, Ree = ["D", "DD", "YY", "YYYY"];
function jee(e) {
  return Dee.test(e);
}
function Lee(e) {
  return Iee.test(e);
}
function Bee(e, t, n) {
  const r = Fee(e, t, n);
  if (console.warn(r), Ree.includes(e)) throw new RangeError(r);
}
function Fee(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Wee = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, zee = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vee = /^'([^]*?)'?$/, Uee = /''/g, Kee = /[a-zA-Z]/;
function Ln(e, t, n) {
  var f, d, p, m, g, v, y, x;
  const r = _d(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? zg, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((v = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : v.weekStartsOn) ?? r.weekStartsOn ?? ((x = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : x.weekStartsOn) ?? 0, s = Bt(e, n == null ? void 0 : n.in);
  if (!YQ(s))
    throw new RangeError("Invalid time value");
  let l = t.match(zee).map((w) => {
    const S = w[0];
    if (S === "p" || S === "P") {
      const A = $ee[S];
      return A(w, i.formatLong);
    }
    return w;
  }).join("").match(Wee).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const S = w[0];
    if (S === "'")
      return { isToken: !1, value: Hee(w) };
    if (cE[S])
      return { isToken: !0, value: w };
    if (S.match(Kee))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + S + "`"
      );
    return { isToken: !1, value: w };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return l.map((w) => {
    if (!w.isToken) return w.value;
    const S = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Lee(S) || !(n != null && n.useAdditionalDayOfYearTokens) && jee(S)) && Bee(S, t, String(e));
    const A = cE[S[0]];
    return A(s, S, i.localize, c);
  }).join("");
}
function Hee(e) {
  const t = e.match(Vee);
  return t ? t[1].replace(Uee, "'") : e;
}
function Gee(e, t) {
  const n = Bt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = n.getMonth(), o = On(n, 0);
  return o.setFullYear(r, i + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Yee(e, t) {
  return +Bt(e) > +Bt(t);
}
function qee(e, t) {
  return +Bt(e) < +Bt(t);
}
function Xee(e, t, n) {
  const [r, i] = Sd(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function Zee(e, t, n) {
  const [r, i] = Sd(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear();
}
function Jee(e, t, n) {
  const r = Bt(e, n == null ? void 0 : n.in), i = r.getFullYear(), o = r.getDate(), a = On(e, 0);
  a.setFullYear(i, t, 15), a.setHours(0, 0, 0, 0);
  const s = Gee(a);
  return r.setMonth(t, Math.min(o, s)), r;
}
function Qee(e, t, n) {
  const r = Bt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? On(e, NaN) : (r.setFullYear(t), r);
}
function hE(e) {
  return nc(Date.now(), e);
}
function pE(e) {
  const t = lE(e == null ? void 0 : e.in), n = t.getFullYear(), r = t.getMonth(), i = t.getDate(), o = lE(e == null ? void 0 : e.in);
  return o.setFullYear(n, r, i - 1), o.setHours(0, 0, 0, 0), o;
}
function cx(e, t, n) {
  return A_(e, -t, n);
}
function mE(e, t, n) {
  return Vj(e, -t, n);
}
class Zo {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.addDays = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addDays ? this.overrides.addDays(r, i) : Fj(r, i);
    }, this.addMonths = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addMonths ? this.overrides.addMonths(r, i) : A_(r, i);
    }, this.addWeeks = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addWeeks ? this.overrides.addWeeks(r, i) : Vj(r, i);
    }, this.addYears = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addYears ? this.overrides.addYears(r, i) : UQ(r, i);
    }, this.differenceInCalendarDays = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : zj(r, i);
    }, this.differenceInCalendarMonths = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : qQ(r, i);
    }, this.endOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfISOWeek ? this.overrides.endOfISOWeek(r) : ZQ(r);
    }, this.endOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfMonth ? this.overrides.endOfMonth(r) : sx(r);
    }, this.endOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, this.options) : Up(r, this.options);
    }, this.endOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfYear ? this.overrides.endOfYear(r) : XQ(r);
    }, this.format = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.format ? this.overrides.format(r, i, this.options) : Ln(r, i, this.options);
    }, this.getISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getISOWeek ? this.overrides.getISOWeek(r) : Hj(r);
    }, this.getWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : Yj(r, this.options);
    }, this.isAfter = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isAfter ? this.overrides.isAfter(r, i) : Yee(r, i);
    }, this.isBefore = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isBefore ? this.overrides.isBefore(r, i) : qee(r, i);
    }, this.isDate = (r) => {
      var i;
      return (i = this.overrides) != null && i.isDate ? this.overrides.isDate(r) : Uj(r);
    }, this.isSameDay = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameDay ? this.overrides.isSameDay(r, i) : GQ(r, i);
    }, this.isSameMonth = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameMonth ? this.overrides.isSameMonth(r, i) : Xee(r, i);
    }, this.isSameYear = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameYear ? this.overrides.isSameYear(r, i) : Zee(r, i);
    }, this.max = (r) => {
      var i;
      return (i = this.overrides) != null && i.max ? this.overrides.max(r) : KQ(r);
    }, this.min = (r) => {
      var i;
      return (i = this.overrides) != null && i.min ? this.overrides.min(r) : HQ(r);
    }, this.setMonth = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.setMonth ? this.overrides.setMonth(r, i) : Jee(r, i);
    }, this.setYear = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.setYear ? this.overrides.setYear(r, i) : Qee(r, i);
    }, this.startOfDay = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfDay ? this.overrides.startOfDay(r) : nc(r);
    }, this.startOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Of(r);
    }, this.startOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfMonth ? this.overrides.startOfMonth(r) : lx(r);
    }, this.startOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Wa(r, this.options);
    }, this.startOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfYear ? this.overrides.startOfYear(r) : Kj(r);
    }, this.options = { locale: zg, ...t }, this.overrides = n;
  }
}
const Zs = new Zo();
function ete(e, t, n = {}) {
  return Object.entries(e).filter(([, i]) => i === !0).reduce((i, [o]) => (n[o] ? i.push(n[o]) : t[jt[o]] ? i.push(t[jt[o]]) : t[Ci[o]] && i.push(t[Ci[o]]), i), [t[Re.Day]]);
}
function tte(e) {
  return I.createElement("button", { ...e });
}
function nte(e) {
  return I.createElement("span", { ...e });
}
function rte(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return I.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && I.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && I.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && I.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && I.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function ite(e) {
  const { day: t, modifiers: n, ...r } = e;
  return I.createElement("td", { ...r });
}
function ote(e) {
  const { day: t, modifiers: n, ...r } = e, i = I.useRef(null);
  return I.useEffect(() => {
    var o;
    n.focused && ((o = i.current) == null || o.focus());
  }, [n.focused]), I.createElement("button", { ref: i, ...r });
}
function ate(e) {
  const { options: t, className: n, components: r, classNames: i, ...o } = e, a = [i[Re.Dropdown], n].join(" "), s = t == null ? void 0 : t.find(({ value: l }) => l === o.value);
  return I.createElement(
    "span",
    { "data-disabled": o.disabled, className: i[Re.DropdownRoot] },
    I.createElement(r.Select, { className: a, ...o }, t == null ? void 0 : t.map(({ value: l, label: c, disabled: f }) => I.createElement(r.Option, { key: l, value: l, disabled: f }, c))),
    I.createElement(
      "span",
      { className: i[Re.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      I.createElement(r.Chevron, { orientation: "down", size: 18, className: i[Re.Chevron] })
    )
  );
}
function ste(e) {
  return I.createElement("div", { ...e });
}
function lte(e) {
  return I.createElement("div", { ...e });
}
function cte(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return I.createElement("div", { ...r }, e.children);
}
function ute(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return I.createElement("div", { ...r });
}
function fte(e) {
  return I.createElement("table", { ...e });
}
function dte(e) {
  return I.createElement("div", { ...e });
}
const Xj = ht(void 0);
function Bc() {
  const e = Ve(Xj);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function hte(e) {
  const { components: t } = Bc();
  return I.createElement(t.Dropdown, { ...e });
}
function pte(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: i, ...o } = e, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = Bc();
  return I.createElement(
    "nav",
    { ...o },
    I.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[Re.PreviousMonthButton], tabIndex: r ? void 0 : -1, disabled: r ? void 0 : !0, "aria-label": l(r), onClick: e.onPreviousClick },
      I.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[Re.Chevron], orientation: "left" })
    ),
    I.createElement(
      a.NextMonthButton,
      { type: "button", className: s[Re.NextMonthButton], tabIndex: i ? void 0 : -1, disabled: i ? void 0 : !0, "aria-label": c(i), onClick: e.onNextClick },
      I.createElement(a.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: s[Re.Chevron] })
    )
  );
}
function mte(e) {
  const { components: t } = Bc();
  return I.createElement(t.Button, { ...e });
}
function gte(e) {
  return I.createElement("option", { ...e });
}
function yte(e) {
  const { components: t } = Bc();
  return I.createElement(t.Button, { ...e });
}
function vte(e) {
  return I.createElement("div", { ...e });
}
function bte(e) {
  return I.createElement("select", { ...e });
}
function xte(e) {
  const { week: t, ...n } = e;
  return I.createElement("tr", { ...n });
}
function wte(e) {
  return I.createElement("th", { ...e });
}
function _te(e) {
  return I.createElement(
    "thead",
    null,
    I.createElement("tr", { ...e })
  );
}
function Ste(e) {
  const { week: t, ...n } = e;
  return I.createElement("th", { ...n });
}
function Ote(e) {
  return I.createElement("th", { ...e });
}
function Ate(e) {
  return I.createElement("tbody", { ...e });
}
function Pte(e) {
  const { components: t } = Bc();
  return I.createElement(t.Dropdown, { ...e });
}
const Tte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: tte,
  CaptionLabel: nte,
  Chevron: rte,
  Day: ite,
  DayButton: ote,
  Dropdown: ate,
  DropdownNav: ste,
  Footer: lte,
  Month: cte,
  MonthCaption: ute,
  MonthGrid: fte,
  Months: dte,
  MonthsDropdown: hte,
  Nav: pte,
  NextMonthButton: mte,
  Option: gte,
  PreviousMonthButton: yte,
  Root: vte,
  Select: bte,
  Week: xte,
  WeekNumber: Ste,
  WeekNumberHeader: Ote,
  Weekday: wte,
  Weekdays: _te,
  Weeks: Ate,
  YearsDropdown: Pte
}, Symbol.toStringTag, { value: "Module" }));
function Cte(e) {
  return {
    ...Tte,
    ...e
  };
}
function Ete(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function kte() {
  const e = {};
  for (const t in Re)
    e[Re[t]] = `rdp-${Re[t]}`;
  for (const t in jt)
    e[jt[t]] = `rdp-${jt[t]}`;
  for (const t in Ci)
    e[Ci[t]] = `rdp-${Ci[t]}`;
  return e;
}
function Zj(e, t, n) {
  return (n ?? new Zo(t)).format(e, "LLLL y");
}
const Mte = Zj;
function Nte(e, t, n) {
  return (n ?? new Zo(t)).format(e, "d");
}
function $te(e, t) {
  var n;
  return (n = t.localize) == null ? void 0 : n.month(e);
}
function Dte(e) {
  return e < 10 ? `0${e.toLocaleString()}` : `${e.toLocaleString()}`;
}
function Ite() {
  return "";
}
function Rte(e, t, n) {
  return (n ?? new Zo(t)).format(e, "cccccc");
}
function Jj(e) {
  return e.toString();
}
const jte = Jj, Lte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Zj,
  formatDay: Nte,
  formatMonthCaption: Mte,
  formatMonthDropdown: $te,
  formatWeekNumber: Dte,
  formatWeekNumberHeader: Ite,
  formatWeekdayName: Rte,
  formatYearCaption: jte,
  formatYearDropdown: Jj
}, Symbol.toStringTag, { value: "Module" }));
function Bte(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...Lte,
    ...e
  };
}
function Fte(e, t, n, r, i) {
  if (!t || !n)
    return;
  const { addMonths: o, startOfMonth: a, isBefore: s } = i, l = e.getFullYear(), c = [];
  let f = t;
  for (; c.length < 12 && s(f, o(n, 1)); )
    c.push(f.getMonth()), f = o(f, 1);
  return c.sort((m, g) => m - g).map((m) => {
    const g = r.formatMonthDropdown(m, i.options.locale ?? zg), v = i.Date ? new i.Date(l, m) : new Date(l, m), y = t && v < a(t) || n && v > a(n) || !1;
    return { value: m, label: g, disabled: y };
  });
}
function Wte(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[Re.Day] };
  return Object.entries(e).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[i]
    };
  }), r;
}
const Sb = {}, Fu = {};
function Ju(e, t) {
  try {
    const r = (Sb[e] || (Sb[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in Fu ? Fu[r] : gE(r, r.split(":"));
  } catch {
    if (e in Fu) return Fu[e];
    const n = e == null ? void 0 : e.match(zte);
    return n ? gE(e, n.slice(1)) : NaN;
  }
}
const zte = /([+-]\d\d):?(\d\d)?/;
function gE(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return Fu[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Wi extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Ju(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Qj(this), ux(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Wi(...n, t) : new Wi(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Wi(+this, t);
  }
  getTimezoneOffset() {
    return -Ju(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), ux(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Wi(+new Date(t), this.timeZone);
  }
  //#endregion
}
const yE = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!yE.test(e)) return;
  const t = e.replace(yE, "$1UTC");
  Wi.prototype[t] && (e.startsWith("get") ? Wi.prototype[e] = function() {
    return this.internal[t]();
  } : (Wi.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), Vte(this), +this;
  }, Wi.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), ux(this), +this;
  }));
});
function ux(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function Vte(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Qj(e);
}
function Qj(e) {
  const t = Ju(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), o = r - i, a = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  o && a && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + o);
  const s = r - t;
  s && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + s);
  const l = Ju(e.timeZone, e), f = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - l, d = l !== t, p = f - s;
  if (d && p) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + p);
    const m = Ju(e.timeZone, e), g = l - m;
    g && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + g), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + g));
  }
}
class zi extends Wi {
  //#region static
  static tz(t, ...n) {
    return n.length ? new zi(...n, t) : new zi(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), i = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, i] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${t} GMT${n}${r}${i} (${Ute(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), i = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(t) {
    return new zi(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new zi(+new Date(t), this.timeZone);
  }
  //#endregion
}
function Ute(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
function Kte(e, t, n) {
  const r = n ? zi.tz(n) : e.Date ? new e.Date() : /* @__PURE__ */ new Date(), i = t ? e.startOfISOWeek(r) : e.startOfWeek(r), o = [];
  for (let a = 0; a < 7; a++) {
    const s = e.addDays(i, a);
    o.push(s);
  }
  return o;
}
function Hte(e, t, n, r, i) {
  if (!t || !n)
    return;
  const { startOfMonth: o, startOfYear: a, endOfYear: s, addYears: l, isBefore: c, isSameYear: f } = i, d = e.getMonth(), p = a(t), m = s(n), g = [];
  let v = p;
  for (; c(v, m) || f(v, m); )
    g.push(v.getFullYear()), v = l(v, 1);
  return g.map((y) => {
    const x = i.Date ? new i.Date(y, d) : new Date(y, d), w = t && x < o(t) || d && n && x > o(n) || !1, S = r.formatYearDropdown(y);
    return {
      value: y,
      label: S,
      disabled: w
    };
  });
}
function eL(e, t, n) {
  return (n ?? new Zo(t)).format(e, "LLLL y");
}
const Gte = eL;
function Yte(e, t, n, r) {
  let i = (r ?? new Zo(n)).format(e, "PPPP");
  return t != null && t.today && (i = `Today, ${i}`), i;
}
function tL(e, t, n, r) {
  let i = (r ?? new Zo(n)).format(e, "PPPP");
  return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
const qte = tL;
function Xte() {
  return "";
}
function Zte(e) {
  return "Choose the Month";
}
function Jte(e) {
  return "Go to the Next Month";
}
function Qte(e) {
  return "Go to the Previous Month";
}
function ene(e, t, n) {
  return (n ?? new Zo(t)).format(e, "cccc");
}
function tne(e, t) {
  return `Week ${e}`;
}
function nne(e) {
  return "Week Number";
}
function rne(e) {
  return "Choose the Year";
}
const ine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Gte,
  labelDay: qte,
  labelDayButton: tL,
  labelGrid: eL,
  labelGridcell: Yte,
  labelMonthDropdown: Zte,
  labelNav: Xte,
  labelNext: Jte,
  labelPrevious: Qte,
  labelWeekNumber: tne,
  labelWeekNumberHeader: nne,
  labelWeekday: ene,
  labelYearDropdown: rne
}, Symbol.toStringTag, { value: "Module" })), fx = 42;
function one(e, t, n, r) {
  const i = e[0], o = e[e.length - 1], { ISOWeek: a, fixedWeeks: s } = n ?? {}, { startOfWeek: l, endOfWeek: c, startOfISOWeek: f, endOfISOWeek: d, addDays: p, differenceInCalendarDays: m, differenceInCalendarMonths: g, isAfter: v, endOfMonth: y } = r, x = a ? f(i) : l(i), w = a ? d(y(o)) : c(y(o)), S = m(w, x), A = g(o, i) + 1, _ = [];
  for (let T = 0; T <= S; T++) {
    const C = p(x, T);
    if (t && v(C, t))
      break;
    _.push(C);
  }
  const O = fx * A;
  if (s && _.length < O) {
    const T = O - _.length;
    for (let C = 0; C < T; C++) {
      const k = p(_[_.length - 1], 1);
      _.push(k);
    }
  }
  return _;
}
function ane(e) {
  const t = [];
  return e.reduce((n, r) => {
    const i = [], o = r.weeks.reduce((a, s) => [...a, ...s.days], i);
    return [...n, ...o];
  }, t);
}
function sne(e, t, n, r) {
  const { numberOfMonths: i = 1 } = n, o = [];
  for (let a = 0; a < i; a++) {
    const s = r.addMonths(e, a);
    if (t && s > t)
      break;
    o.push(s);
  }
  return o;
}
function vE(e, t) {
  const { month: n, defaultMonth: r, today: i = e.timeZone ? zi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date(), numberOfMonths: o = 1, endMonth: a, startMonth: s } = e;
  let l = n || r || i;
  const { differenceInCalendarMonths: c, addMonths: f, startOfMonth: d } = t;
  if (a && c(a, l) < 0) {
    const p = -1 * (o - 1);
    l = f(a, p);
  }
  return s && c(l, s) < 0 && (l = s), d(l);
}
class nL {
  constructor(t, n, r = Zs) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class lne {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class cne {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function une(e, t, n, r) {
  const { startOfWeek: i, endOfWeek: o, startOfISOWeek: a, endOfISOWeek: s, endOfMonth: l, addDays: c, getWeek: f, getISOWeek: d } = r, p = e.reduce((m, g) => {
    const v = n.ISOWeek ? a(g) : i(g), y = n.ISOWeek ? s(l(g)) : o(l(g)), x = t.filter((A) => A >= v && A <= y);
    if (n.fixedWeeks && x.length < fx) {
      const A = t.filter((_) => {
        const O = fx - x.length;
        return _ > y && _ <= c(y, O);
      });
      x.push(...A);
    }
    const w = x.reduce((A, _) => {
      const O = n.ISOWeek ? d(_) : f(_), T = A.find((k) => k.weekNumber === O), C = new nL(_, g, r);
      return T ? T.days.push(C) : A.push(new cne(O, [C])), A;
    }, []), S = new lne(g, w);
    return m.push(S), m;
  }, []);
  return n.reverseMonths ? p.reverse() : p;
}
function fne(e, t) {
  var v;
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: i, startOfDay: o, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c } = t, { fromYear: f, toYear: d, fromMonth: p, toMonth: m } = e;
  !n && p && (n = p), !n && f && (n = new Date(f, 0, 1)), !r && m && (r = m), !r && d && (r = new Date(d, 11, 31));
  const g = (v = e.captionLayout) == null ? void 0 : v.startsWith("dropdown");
  if (n)
    n = a(n);
  else if (f)
    n = new Date(f, 0, 1);
  else if (!n && g) {
    const y = e.today ?? (e.timeZone ? zi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    n = i(l(y, -100));
  }
  if (r)
    r = s(r);
  else if (d)
    r = new Date(d, 11, 31);
  else if (!r && g) {
    const y = e.today ?? (e.timeZone ? zi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    r = c(y);
  }
  return [
    n && o(n),
    r && o(r)
  ];
}
function dne(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: o = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = i ? o : 1, f = a(e);
  if (!t)
    return s(f, c);
  if (!(l(t, e) < o))
    return s(f, c);
}
function hne(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: o } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = i ? o ?? 1 : 1, f = a(e);
  if (!t)
    return s(f, -c);
  if (!(l(f, t) <= 0))
    return s(f, -c);
}
function pne(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function Vg(e, t) {
  const [n, r] = Me(e);
  return [t === void 0 ? n : t, r];
}
function mne(e, t) {
  const [n, r] = fne(e, t), { startOfMonth: i, endOfMonth: o } = t, a = vE(e, t), [s, l] = Vg(a, e.month ? i(e.month) : void 0);
  Qe(() => {
    const O = vE(e, t);
    l(O);
  }, [e.timeZone]);
  const c = sne(s, r, e, t), f = one(c, e.endMonth ? o(e.endMonth) : void 0, e, t), d = une(c, f, e, t), p = pne(d), m = ane(d), g = hne(s, n, e, t), v = dne(s, r, e, t), { disableNavigation: y, onMonthChange: x } = e, w = (O) => p.some((T) => T.days.some((C) => C.isEqualTo(O))), S = (O) => {
    if (y)
      return;
    let T = i(O);
    n && T < i(n) && (T = i(n)), r && T > i(r) && (T = i(r)), l(T), x == null || x(T);
  };
  return {
    months: d,
    weeks: p,
    days: m,
    navStart: n,
    navEnd: r,
    previousMonth: g,
    nextMonth: v,
    goToMonth: S,
    goToDay: (O) => {
      w(O) || S(O.date);
    }
  };
}
function gne(e, t, n, r) {
  let i, o = 0, a = !1;
  for (; o < e.length && !a; ) {
    const s = e[o], l = t(s);
    !l[jt.disabled] && !l[jt.hidden] && !l[jt.outside] && (l[jt.focused] || r != null && r.isEqualTo(s) || n(s.date) || l[jt.today]) && (i = s, a = !0), o++;
  }
  return i || (i = e.find((s) => {
    const l = t(s);
    return !l[jt.disabled] && !l[jt.hidden] && !l[jt.outside];
  })), i;
}
function Ao(e, t, n = !1, r = Zs) {
  let { from: i, to: o } = e;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return i && o ? (a(o, i) < 0 && ([i, o] = [o, i]), a(t, i) >= (n ? 1 : 0) && a(o, t) >= (n ? 1 : 0)) : !n && o ? s(o, t) : !n && i ? s(i, t) : !1;
}
function rL(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function P_(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function iL(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function oL(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function aL(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function sL(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Po(e, t, n = Zs) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: o, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return i(e, s);
    if (sL(s, n))
      return s.includes(e);
    if (P_(s))
      return Ao(s, e, !1, n);
    if (aL(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (rL(s)) {
      const l = o(s.before, e), c = o(s.after, e), f = l > 0, d = c < 0;
      return a(s.before, s.after) ? d && f : f || d;
    }
    return iL(s) ? o(e, s.after) > 0 : oL(s) ? o(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function yne(e, t, n, r, i, o, a) {
  const { ISOWeek: s } = o, { addDays: l, addMonths: c, addYears: f, addWeeks: d, startOfISOWeek: p, endOfISOWeek: m, startOfWeek: g, endOfWeek: v, max: y, min: x } = a;
  let S = {
    day: l,
    week: d,
    month: c,
    year: f,
    startOfWeek: (A) => s ? p(A) : g(A),
    endOfWeek: (A) => s ? m(A) : v(A)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? S = y([r, S]) : t === "after" && i && (S = x([i, S])), S;
}
function lL(e, t, n, r, i, o, a, s = 0) {
  if (s > 365)
    return;
  const l = yne(
    e,
    t,
    n.date,
    // should be refDay? or refDay.date?
    r,
    i,
    o,
    a
  ), c = !!(o.disabled && Po(l, o.disabled, a)), f = !!(o.hidden && Po(l, o.hidden, a)), d = l, p = new nL(l, d, a);
  return !c && !f ? p : lL(e, t, p, r, i, o, a, s + 1);
}
function vne(e, t, n, r, i) {
  const { autoFocus: o } = e, [a, s] = Me(), l = gne(t.days, n, r || (() => !1), a), [c, f] = Me(o ? l : void 0);
  return {
    isFocusTarget: (v) => !!(l != null && l.isEqualTo(v)),
    setFocused: f,
    focused: c,
    blur: () => {
      s(c), f(void 0);
    },
    moveFocus: (v, y) => {
      if (!c)
        return;
      const x = lL(v, y, c, t.navStart, t.navEnd, e, i);
      x && (t.goToDay(x), f(x));
    }
  };
}
function bne(e, t, n) {
  const { disabled: r, hidden: i, modifiers: o, showOutsideDays: a, today: s } = t, { isSameDay: l, isSameMonth: c, startOfMonth: f, isBefore: d, endOfMonth: p, isAfter: m } = n, g = t.startMonth && f(t.startMonth), v = t.endMonth && p(t.endMonth), y = {
    [jt.focused]: [],
    [jt.outside]: [],
    [jt.disabled]: [],
    [jt.hidden]: [],
    [jt.today]: []
  }, x = {};
  for (const w of e) {
    const { date: S, displayMonth: A } = w, _ = !!(A && !c(S, A)), O = !!(g && d(S, g)), T = !!(v && m(S, v)), C = !!(r && Po(S, r, n)), k = !!(i && Po(S, i, n)) || O || T || !a && _, D = l(S, s ?? (t.timeZone ? zi.tz(t.timeZone) : n.Date ? new n.Date() : /* @__PURE__ */ new Date()));
    _ && y.outside.push(w), C && y.disabled.push(w), k && y.hidden.push(w), D && y.today.push(w), o && Object.keys(o).forEach((N) => {
      const $ = o == null ? void 0 : o[N];
      $ && Po(S, $, n) && (x[N] ? x[N].push(w) : x[N] = [w]);
    });
  }
  return (w) => {
    const S = {
      [jt.focused]: !1,
      [jt.disabled]: !1,
      [jt.hidden]: !1,
      [jt.outside]: !1,
      [jt.today]: !1
    }, A = {};
    for (const _ in y) {
      const O = y[_];
      S[_] = O.some((T) => T === w);
    }
    for (const _ in x)
      A[_] = x[_].some((O) => O === w);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...A
    };
  };
}
function xne(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [o, a] = Vg(n, i ? n : void 0), s = i ? n : o, { isSameDay: l } = t, c = (m) => (s == null ? void 0 : s.some((g) => l(g, m))) ?? !1, { min: f, max: d } = e;
  return {
    selected: s,
    select: (m, g, v) => {
      let y = [...s ?? []];
      if (c(m)) {
        if ((s == null ? void 0 : s.length) === f || r && (s == null ? void 0 : s.length) === 1)
          return;
        y = s == null ? void 0 : s.filter((x) => !l(x, m));
      } else
        (s == null ? void 0 : s.length) === d ? y = [m] : y = [...y, m];
      return i || a(y), i == null || i(y, m, g, v), y;
    },
    isSelected: c
  };
}
function wne(e, t, n = 0, r = 0, i = !1, o = Zs) {
  const { from: a, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: f } = o;
  let d;
  if (!a && !s)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !s)
    l(a, e) ? i ? d = { from: a, to: void 0 } : d = void 0 : f(e, a) ? d = { from: e, to: a } : d = { from: a, to: e };
  else if (a && s)
    if (l(a, e) && l(s, e))
      i ? d = { from: a, to: s } : d = void 0;
    else if (l(a, e))
      d = { from: a, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, a))
      d = { from: e, to: s };
    else if (c(e, a))
      d = { from: a, to: e };
    else if (c(e, s))
      d = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const p = o.differenceInCalendarDays(d.to, d.from);
    r > 0 && p > r ? d = { from: e, to: void 0 } : n > 1 && p < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function _ne(e, t, n = Zs) {
  const r = Array.isArray(t) ? t : [t];
  let i = e.from;
  const o = n.differenceInCalendarDays(e.to, e.from), a = Math.min(o, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(i.getDay()))
      return !0;
    i = n.addDays(i, 1);
  }
  return !1;
}
function bE(e, t, n = Zs) {
  return Ao(e, t.from, !1, n) || Ao(e, t.to, !1, n) || Ao(t, e.from, !1, n) || Ao(t, e.to, !1, n);
}
function Sne(e, t, n = Zs) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Ao(e, s, !1, n) : sL(s, n) ? s.some((l) => Ao(e, l, !1, n)) : P_(s) ? s.from && s.to ? bE(e, { from: s.from, to: s.to }, n) : !1 : aL(s) ? _ne(e, s.dayOfWeek, n) : rL(s) ? n.isAfter(s.before, s.after) ? bE(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Po(e.from, s, n) || Po(e.to, s, n) : iL(s) || oL(s) ? Po(e.from, s, n) || Po(e.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((f) => f(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function One(e, t) {
  const { disabled: n, excludeDisabled: r, selected: i, required: o, onSelect: a } = e, [s, l] = Vg(i, a ? i : void 0), c = a ? i : s;
  return {
    selected: c,
    select: (p, m, g) => {
      const { min: v, max: y } = e, x = p ? wne(p, c, v, y, o, t) : void 0;
      return r && n && (x != null && x.from) && x.to && Sne({ from: x.from, to: x.to }, n, t) && (x.from = p, x.to = void 0), a || l(x), a == null || a(x, p, m, g), x;
    },
    isSelected: (p) => c && Ao(c, p, !1, t)
  };
}
function Ane(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [o, a] = Vg(n, i ? n : void 0), s = i ? n : o, { isSameDay: l } = t;
  return {
    selected: s,
    select: (d, p, m) => {
      let g = d;
      return !r && s && s && l(d, s) && (g = void 0), i || a(g), i == null || i(g, d, p, m), g;
    },
    isSelected: (d) => s ? l(s, d) : !1
  };
}
function Pne(e, t) {
  const n = Ane(e, t), r = xne(e, t), i = One(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function Tne(e) {
  const { components: t, formatters: n, labels: r, dateLib: i, locale: o, classNames: a } = Le(() => {
    const tt = { ...zg, ...e.locale };
    return {
      dateLib: new Zo({
        locale: tt,
        weekStartsOn: e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens
      }, e.dateLib),
      components: Cte(e.components),
      formatters: Bte(e.formatters),
      labels: { ...ine, ...e.labels },
      locale: tt,
      classNames: { ...kte(), ...e.classNames }
    };
  }, [
    e.classNames,
    e.components,
    e.dateLib,
    e.firstWeekContainsDate,
    e.formatters,
    e.labels,
    e.locale,
    e.useAdditionalDayOfYearTokens,
    e.useAdditionalWeekYearTokens,
    e.weekStartsOn
  ]), { captionLayout: s, mode: l, onDayBlur: c, onDayClick: f, onDayFocus: d, onDayKeyDown: p, onDayMouseEnter: m, onDayMouseLeave: g, onNextClick: v, onPrevClick: y, showWeekNumber: x, styles: w } = e, { formatCaption: S, formatDay: A, formatMonthDropdown: _, formatWeekNumber: O, formatWeekNumberHeader: T, formatWeekdayName: C, formatYearDropdown: k } = n, D = mne(e, i), { days: N, months: $, navStart: B, navEnd: L, previousMonth: F, nextMonth: W, goToMonth: z } = D, G = bne(N, e, i), { isSelected: V, select: U, selected: Y } = Pne(e, i) ?? {}, { blur: te, focused: ne, isFocusTarget: re, moveFocus: ue, setFocused: ae } = vne(e, D, G, V ?? (() => !1), i), { labelDayButton: le, labelGridcell: ie, labelGrid: Q, labelMonthDropdown: fe, labelNav: ve, labelWeekday: X, labelWeekNumber: Fe, labelWeekNumberHeader: pe, labelYearDropdown: Be } = r, rt = Le(() => Kte(i, e.ISOWeek, e.timeZone), [i, e.ISOWeek, e.timeZone]), at = l !== void 0 || f !== void 0, Gn = Je(() => {
    F && (z(F), y == null || y(F));
  }, [F, z, y]), $e = Je(() => {
    W && (z(W), v == null || v(W));
  }, [z, W, v]), st = Je((tt, Ht) => (St) => {
    St.preventDefault(), St.stopPropagation(), ae(tt), U == null || U(tt.date, Ht, St), f == null || f(tt.date, Ht, St);
  }, [U, f, ae]), Oe = Je((tt, Ht) => (St) => {
    ae(tt), d == null || d(tt.date, Ht, St);
  }, [d, ae]), He = Je((tt, Ht) => (St) => {
    te(), c == null || c(tt.date, Ht, St);
  }, [te, c]), Xt = Je((tt, Ht) => (St) => {
    const In = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [St.shiftKey ? "year" : "month", "before"],
      PageDown: [St.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (In[St.key]) {
      St.preventDefault(), St.stopPropagation();
      const [Gr, ao] = In[St.key];
      ue(Gr, ao);
    }
    p == null || p(tt.date, Ht, St);
  }, [ue, p, e.dir]), pt = Je((tt, Ht) => (St) => {
    m == null || m(tt.date, Ht, St);
  }, [m]), Qt = Je((tt, Ht) => (St) => {
    g == null || g(tt.date, Ht, St);
  }, [g]), { className: Hr, style: Pn } = Le(() => ({
    className: [a[Re.Root], e.className].filter(Boolean).join(" "),
    style: { ...w == null ? void 0 : w[Re.Root], ...e.style }
  }), [a, e.className, e.style, w]), gn = Ete(e), pr = {
    dayPickerProps: e,
    selected: Y,
    select: U,
    isSelected: V,
    months: $,
    nextMonth: W,
    previousMonth: F,
    goToMonth: z,
    getModifiers: G,
    components: t,
    classNames: a,
    styles: w,
    labels: r,
    formatters: n
  };
  return I.createElement(
    Xj.Provider,
    { value: pr },
    I.createElement(
      t.Root,
      { className: Hr, style: Pn, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, ...gn },
      I.createElement(
        t.Months,
        { className: a[Re.Months], style: w == null ? void 0 : w[Re.Months] },
        !e.hideNavigation && I.createElement(t.Nav, { className: a[Re.Nav], style: w == null ? void 0 : w[Re.Nav], "aria-label": ve(), onPreviousClick: Gn, onNextClick: $e, previousMonth: F, nextMonth: W }),
        $.map((tt, Ht) => {
          const St = (cn) => {
            const Pr = Number(cn.target.value), un = i.setMonth(i.startOfMonth(tt.date), Pr);
            z(un);
          }, In = (cn) => {
            const Pr = i.setYear(i.startOfMonth(tt.date), Number(cn.target.value));
            z(Pr);
          }, Gr = Fte(tt.date, B, L, n, i), ao = Hte($[0].date, B, L, n, i);
          return I.createElement(
            t.Month,
            { className: a[Re.Month], style: w == null ? void 0 : w[Re.Month], key: Ht, displayIndex: Ht, calendarMonth: tt },
            I.createElement(t.MonthCaption, { className: a[Re.MonthCaption], style: w == null ? void 0 : w[Re.MonthCaption], calendarMonth: tt, displayIndex: Ht }, s != null && s.startsWith("dropdown") ? I.createElement(
              t.DropdownNav,
              { className: a[Re.Dropdowns], style: w == null ? void 0 : w[Re.Dropdowns] },
              s === "dropdown" || s === "dropdown-months" ? I.createElement(t.MonthsDropdown, { className: a[Re.MonthsDropdown], "aria-label": fe(), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: St, options: Gr, style: w == null ? void 0 : w[Re.Dropdown], value: tt.date.getMonth() }) : I.createElement("span", { role: "status", "aria-live": "polite" }, _(tt.date.getMonth(), o)),
              s === "dropdown" || s === "dropdown-years" ? I.createElement(t.YearsDropdown, { className: a[Re.YearsDropdown], "aria-label": Be(i.options), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: In, options: ao, style: w == null ? void 0 : w[Re.Dropdown], value: tt.date.getFullYear() }) : I.createElement("span", { role: "status", "aria-live": "polite" }, k(tt.date.getFullYear()))
            ) : I.createElement(t.CaptionLabel, { className: a[Re.CaptionLabel], role: "status", "aria-live": "polite" }, S(tt.date, i.options, i))),
            I.createElement(
              t.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": Q(tt.date, i.options, i) || void 0, className: a[Re.MonthGrid], style: w == null ? void 0 : w[Re.MonthGrid] },
              !e.hideWeekdays && I.createElement(
                t.Weekdays,
                { className: a[Re.Weekdays], style: w == null ? void 0 : w[Re.Weekdays] },
                x && I.createElement(t.WeekNumberHeader, { "aria-label": pe(i.options), className: a[Re.WeekNumberHeader], style: w == null ? void 0 : w[Re.WeekNumberHeader], scope: "col" }, T()),
                rt.map((cn, Pr) => I.createElement(t.Weekday, { "aria-label": X(cn, i.options, i), className: a[Re.Weekday], key: Pr, style: w == null ? void 0 : w[Re.Weekday], scope: "col" }, C(cn, i.options, i)))
              ),
              I.createElement(t.Weeks, { className: a[Re.Weeks], style: w == null ? void 0 : w[Re.Weeks] }, tt.weeks.map((cn, Pr) => I.createElement(
                t.Week,
                { className: a[Re.Week], key: cn.weekNumber, style: w == null ? void 0 : w[Re.Week], week: cn },
                x && I.createElement(t.WeekNumber, { week: cn, style: w == null ? void 0 : w[Re.WeekNumber], "aria-label": Fe(cn.weekNumber, {
                  locale: o
                }), className: a[Re.WeekNumber], scope: "row" }, O(cn.weekNumber)),
                cn.days.map((un) => {
                  const { date: Yr } = un, gt = G(un);
                  if (gt[jt.focused] = !gt.hidden && !!(ne != null && ne.isEqualTo(un)), gt[Ci.selected] = !gt.disabled && ((V == null ? void 0 : V(Yr)) || gt.selected), P_(Y)) {
                    const { from: eu, to: tu } = Y;
                    gt[Ci.range_start] = !!(eu && tu && i.isSameDay(Yr, eu)), gt[Ci.range_end] = !!(eu && tu && i.isSameDay(Yr, tu)), gt[Ci.range_middle] = Ao(Y, Yr, !0, i);
                  }
                  const Dd = Wte(gt, w, e.modifiersStyles), Id = ete(gt, a, e.modifiersClassNames), Py = at ? void 0 : ie(Yr, gt, i.options, i);
                  return I.createElement(t.Day, { key: `${i.format(Yr, "yyyy-MM-dd")}_${i.format(un.displayMonth, "yyyy-MM")}`, day: un, modifiers: gt, className: Id.join(" "), style: Dd, "aria-hidden": gt.hidden || void 0, "aria-selected": gt.selected || void 0, "aria-label": Py, "data-day": i.format(Yr, "yyyy-MM-dd"), "data-month": un.outside ? i.format(Yr, "yyyy-MM") : void 0, "data-selected": gt.selected || void 0, "data-disabled": gt.disabled || void 0, "data-hidden": gt.hidden || void 0, "data-outside": un.outside || void 0, "data-focused": gt.focused || void 0, "data-today": gt.today || void 0 }, at ? I.createElement(t.DayButton, { className: a[Re.DayButton], style: w == null ? void 0 : w[Re.DayButton], type: "button", day: un, modifiers: gt, disabled: gt.disabled || void 0, tabIndex: re(un) ? 0 : -1, "aria-label": le(Yr, gt, i.options, i), onClick: st(un, gt), onBlur: He(un, gt), onFocus: Oe(un, gt), onKeyDown: Xt(un, gt), onMouseEnter: pt(un, gt), onMouseLeave: Qt(un, gt) }, A(Yr, i.options, i)) : A(un.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      e.footer && I.createElement(t.Footer, { className: a[Re.Footer], style: w == null ? void 0 : w[Re.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const xE = () => /* @__PURE__ */ E("span", { className: "bg-icon-interactive h-1 w-1 absolute rounded-full inline-block bottom-0 left-1/2 right-1/2" }), wE = (e) => Ln(e, "E").slice(0, 1), Cne = (e, t = 24) => Array.from({ length: t }, (n, r) => e + r), Ob = ({
  width: e,
  className: t,
  // Renamed to avoid shadowing
  classNames: n,
  selectedDates: r,
  setSelectedDates: i,
  showOutsideDays: o = !0,
  mode: a = "single",
  variant: s = "normal",
  alignment: l = "horizontal",
  // onBlur,
  // onChange,
  numberOfMonths: c,
  ...f
}) => {
  const d = I.isValidElement(f.footer) || typeof f.footer == "function", [p, m] = Me(!1), [g, v] = Me(!1), [y, x] = Me((/* @__PURE__ */ new Date()).getFullYear()), [w, S] = Me(
    y - y % 24
  );
  r == null && (a === "multiple" ? r = [] : a === "range" ? r = { from: null, to: null } : r = null);
  function A(N) {
    const { goToMonth: $, nextMonth: B, previousMonth: L } = Bc(), F = Ln(
      N.calendarMonth.date,
      "yyyy"
    ), W = Ln(N.calendarMonth.date, "MMMM"), z = new Date(N.calendarMonth.date);
    z.setDate(z.getDate() - z.getDay());
    const G = Array.from({ length: 7 }, (ne, re) => {
      const ue = new Date(z);
      return ue.setDate(z.getDate() + re), wE(ue);
    }), V = () => {
      if (g)
        S(w - 24);
      else if (p) {
        const ne = new Date(
          y - 1,
          N.calendarMonth.date.getMonth()
        );
        x(ne.getFullYear()), $(ne);
      } else
        $(L);
    }, U = () => {
      if (g)
        S(w + 24);
      else if (p) {
        const ne = new Date(
          y + 1,
          N.calendarMonth.date.getMonth()
        );
        x(ne.getFullYear()), $(ne);
      } else
        $(B);
    }, Y = ({ yearValue: ne }) => {
      x(ne), v(!1), m(!0), $(
        new Date(
          ne,
          N.calendarMonth.date.getMonth()
        )
      );
    };
    let te;
    return g ? te = `${w} - ${w + 23}` : p ? te = F : te = `${W} ${F}`, /* @__PURE__ */ me(Ut, { children: [
      /* @__PURE__ */ me("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ E(
          Qn,
          {
            variant: "ghost",
            onClick: V,
            className: "bg-background-primary border-none cursor-pointer",
            "aria-label": "Previous Button",
            icon: /* @__PURE__ */ E(H$, { className: "h-4 w-4 text-button-tertiary-color" })
          }
        ),
        /* @__PURE__ */ E(
          Qn,
          {
            variant: "ghost",
            onClick: () => {
              c > 1 || (p ? (v(!0), m(!1)) : g ? v(!1) : m(!p));
            },
            children: te
          }
        ),
        /* @__PURE__ */ E(
          Qn,
          {
            variant: "ghost",
            onClick: U,
            className: "bg-background-primary border-none cursor-pointer",
            "aria-label": "Next Button",
            icon: /* @__PURE__ */ E(Yw, { className: "h-4 w-4 text-button-tertiary-color" })
          }
        )
      ] }),
      g && /* @__PURE__ */ E("div", { className: "grid grid-cols-4 w-full", children: Cne(w).map((ne) => /* @__PURE__ */ me(
        Qn,
        {
          variant: "ghost",
          onClick: () => Y(
            ne
          ),
          className: H(
            "h-10 w-full text-center font-normal relative",
            ne === y && ne !== (/* @__PURE__ */ new Date()).getFullYear() && "bg-background-brand text-text-on-color hover:bg-background-brand hover:text-black",
            ne === (/* @__PURE__ */ new Date()).getFullYear() && "font-semibold"
          ),
          children: [
            ne,
            ne === (/* @__PURE__ */ new Date()).getFullYear() && xE()
          ]
        },
        ne
      )) }),
      p && !g && /* @__PURE__ */ E("div", { className: "grid grid-cols-4 gap-2 my-12", children: Array.from({ length: 12 }, (ne, re) => /* @__PURE__ */ me(
        Qn,
        {
          variant: "ghost",
          onClick: () => {
            m(!1), $(
              new Date(y, re)
            );
          },
          className: H(
            "px-1.5 py-2 h-10 w-[4.375rem] text-center font-normal relative",
            re === N.calendarMonth.date.getMonth() && re !== (/* @__PURE__ */ new Date()).getMonth() && y === N.calendarMonth.date.getFullYear() && N.calendarMonth.date.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && "bg-background-brand text-text-on-color hover:bg-background-brand hover:text-black",
            re === (/* @__PURE__ */ new Date()).getMonth() && (/* @__PURE__ */ new Date()).getFullYear() === y && "font-semibold"
          ),
          children: [
            Ln(new Date(0, re), "MMM"),
            (/* @__PURE__ */ new Date()).getMonth() === re && (/* @__PURE__ */ new Date()).getFullYear() === y && xE()
          ]
        },
        re
      )) }),
      !p && !g && /* @__PURE__ */ E(_, { weekdays: G })
    ] });
  }
  const _ = ({ weekdays: N }) => /* @__PURE__ */ E("div", { className: "flex justify-between", children: N.map(($, B) => /* @__PURE__ */ E(
    "button",
    {
      className: "h-10 w-10 px-1.5 py-2 text-center text-text-secondary text-sm font-normal content-center bg-transparent border-none shrink-0",
      children: $
    },
    B
  )) }), O = ({
    day: N,
    modifiers: $,
    onSelect: B
  }) => {
    const {
      selected: L,
      today: F,
      disabled: W,
      outside: z,
      range_middle: G,
      range_start: V,
      range_end: U
    } = $, Y = V || U || G, te = () => !W && B(N.date), ne = /* @__PURE__ */ new Date(), re = r == null ? void 0 : r.to, ue = Ln(N.displayMonth, "yyyy-MM") === Ln(ne, "yyyy-MM"), ae = re && Ln(re, "yyyy-MM") === Ln(N.date, "yyyy-MM"), le = cx(ne, 1), ie = Ln(N.date, "yyyy-MM") === Ln(le, "yyyy-MM"), Q = ue || ae || Y, fe = !o && z, X = H(
      "h-10 w-10 flex items-center justify-center transition text-text-secondary relative text-sm",
      "border-none rounded",
      (L || Y) && (!z || ie) ? "bg-background-brand text-text-on-color" : "bg-transparent hover:bg-button-tertiary-hover",
      G && Q && (!z || Y) ? "bg-brand-background-50 text-text-secondary rounded-none" : "",
      W ? "opacity-50 cursor-not-allowed text-text-disabled" : "cursor-pointer",
      z && !Y || !Q && z || z && !ie ? "bg-transperant opacity-50 text-text-disabled cursor-auto" : ""
    );
    return /* @__PURE__ */ me(
      "button",
      {
        onClick: te,
        className: H(X, F && "font-semibold"),
        disabled: W || z,
        "aria-label": Ln(N.date, "EEEE, MMMM do, yyyy"),
        children: [
          (!fe || Y && Q) && Ln(N.date, "d"),
          F && /* @__PURE__ */ E("span", { className: "absolute h-1 w-1 bg-background-brand rounded-full bottom-1" })
        ]
      }
    );
  }, T = (N) => {
    const { day: $, modifiers: B, className: L, onSelect: F } = N;
    return /* @__PURE__ */ E("td", { className: L, children: /* @__PURE__ */ E(
      O,
      {
        day: $,
        modifiers: B,
        onSelect: F
      }
    ) });
  }, C = ({ monthGridProps: N, onSelect: $ }) => /* @__PURE__ */ E("div", { className: "flex flex-col", children: N.children[1].props.children.map(
    (B, L) => /* @__PURE__ */ E(
      "div",
      {
        className: "flex flex-row justify-between",
        children: B.props.children[1].map(
          (F, W) => /* @__PURE__ */ E("div", { className: "flex gap-1", children: /* @__PURE__ */ E(
            O,
            {
              ...F.props,
              onSelect: $
            }
          ) }, W)
        )
      },
      L
    )
  ) }), k = (N) => {
    a === "range" ? !(r != null && r.from) || r != null && r.from && (r != null && r.to) ? i({ from: N, to: null }) : i({
      from: r.from,
      to: N
    }) : a === "multiple" ? r.some(
      ($) => Ln($, "yyyy-MM-dd") === Ln(N, "yyyy-MM-dd")
    ) ? i(
      r.filter(
        ($) => Ln($, "yyyy-MM-dd") !== Ln(N, "yyyy-MM-dd")
      )
    ) : i([...r, N]) : a === "single" && i([N]);
  }, D = H(
    "relative bg-background-primary shadow-datepicker-wrapper",
    e,
    l === "vertical" ? "flex flex-col" : "flex flex-row  gap-3",
    s === "normal" ? "rounded-tr-md rounded-tl-md border border-solid border-border-subtle" : "",
    s === "presets" ? "rounded-tr-md border border-solid border-border-subtle" : "",
    s === "dualdate" ? "rounded-tr-md rounded-tl-md border border-solid border-border-subtle" : "",
    d ? "rounded-b-none" : "rounded-bl-md rounded-br-md"
  );
  return /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(
    Tne,
    {
      mode: a,
      selected: r,
      onSelect: k,
      hideNavigation: !0,
      captionLayout: "label",
      className: H(t),
      formatters: {
        formatWeekdayName: wE
      },
      classNames: {
        months: D,
        month: "flex flex-col p-2 gap-1 text-center w-full",
        caption: "relative flex justify-center items-center",
        table: "w-full border-separate border-spacing-0",
        head_row: "flex mb-1",
        head_cell: "text-muted-foreground rounded-md w-10 font-normal text-sm",
        row: "flex w-full mt-2",
        cell: "h-10 w-10 text-center text-sm p-0 relative",
        day: "h-10 w-10 p-0 font-normal bg-background-primary text-current",
        ...n
      },
      numberOfMonths: c,
      components: {
        MonthCaption: A,
        Day: (N) => {
          const $ = {
            selected: N.modifiers.selected || !1,
            today: N.modifiers.today || !1,
            disabled: N.modifiers.disabled || !1,
            outside: N.modifiers.outside || !1,
            range_middle: N.modifiers.range_middle || !1,
            range_start: N.modifiers.range_start || !1,
            range_end: N.modifiers.range_end || !1
          };
          return /* @__PURE__ */ E(
            T,
            {
              ...N,
              modifiers: $,
              onSelect: k
            }
          );
        },
        Weekdays: () => /* @__PURE__ */ E(Ut, {}),
        Months: (N) => {
          var $;
          return /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E("div", { className: D, children: ($ = N == null ? void 0 : N.children) == null ? void 0 : $.map((B, L) => B ? /* @__PURE__ */ E(I.Fragment, { children: B.map((F, W) => /* @__PURE__ */ me(
            I.Fragment,
            {
              children: [
                W > 0 && /* @__PURE__ */ E("div", { className: "border border-solid border-border-subtle border-l-0" }),
                F
              ]
            },
            W
          )) }, L) : null) }) });
        },
        MonthGrid: (N) => !p && !g ? /* @__PURE__ */ E(
          C,
          {
            monthGridProps: N,
            onSelect: k
          }
        ) : /* @__PURE__ */ E(Ut, {})
      },
      ...a === "range" ? { required: !0 } : {},
      ...f
    }
  ) });
}, DEe = ({
  selectionType: e = "single",
  variant: t = "normal",
  presets: n = [],
  onCancel: r,
  onApply: i,
  onDateSelect: o,
  applyButtonText: a = "Apply",
  cancelButtonText: s = "Cancel",
  showOutsideDays: l = !0,
  isFooter: c = !0,
  ...f
}) => {
  const [d, p] = Me(() => e === "multiple" ? [] : e === "range" ? { from: null, to: null } : null), m = (S) => {
    p(S), o && o(S);
  }, g = [
    {
      label: "Today",
      range: { from: hE(), to: hE() }
    },
    {
      label: "Yesterday",
      range: { from: pE(), to: pE() }
    },
    {
      label: "This Week",
      range: {
        from: Wa(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }),
        to: Up(/* @__PURE__ */ new Date(), { weekStartsOn: 1 })
      }
    },
    {
      label: "Last Week",
      range: {
        from: Wa(mE(/* @__PURE__ */ new Date(), 1), { weekStartsOn: 1 }),
        to: Up(mE(/* @__PURE__ */ new Date(), 1), { weekStartsOn: 1 })
      }
    },
    {
      label: "This Month",
      range: {
        from: lx(/* @__PURE__ */ new Date()),
        to: sx(/* @__PURE__ */ new Date())
      }
    },
    {
      label: "Last Month",
      range: {
        from: lx(cx(/* @__PURE__ */ new Date(), 1)),
        to: sx(cx(/* @__PURE__ */ new Date(), 1))
      }
    }
  ], v = n.length > 0 ? n : g, y = (S) => {
    p(S);
  }, x = () => {
    p(
      e === "multiple" ? [] : { from: null, to: null }
    ), r && r();
  }, w = () => {
    i && i(d);
  };
  if (t === "normal")
    return /* @__PURE__ */ E(
      Ob,
      {
        ...f,
        mode: e,
        variant: t,
        width: "w-[18.5rem]",
        selectedDates: d,
        showOutsideDays: l,
        setSelectedDates: m,
        footer: c && /* @__PURE__ */ me("div", { className: "flex bg-background-primary justify-end p-2 gap-3 border border-solid border-border-subtle border-t-0 rounded-md rounded-tl-none rounded-tr-none", children: [
          /* @__PURE__ */ E(
            Qn,
            {
              variant: "outline",
              onClick: x,
              children: s
            }
          ),
          /* @__PURE__ */ E(Qn, { onClick: w, children: a })
        ] })
      }
    );
  if (t === "dualdate")
    return /* @__PURE__ */ E(
      Ob,
      {
        mode: e,
        numberOfMonths: 2,
        alignment: "horizontal",
        selectedDates: d,
        setSelectedDates: m,
        showOutsideDays: l,
        variant: t,
        width: "w-auto",
        footer: /* @__PURE__ */ me("div", { className: "flex bg-background-primary justify-end p-2 gap-3 border border-solid border-border-subtle border-t-0 rounded-md rounded-tl-none rounded-tr-none", children: [
          /* @__PURE__ */ E(Qn, { variant: "outline", onClick: x, children: s }),
          /* @__PURE__ */ E(Qn, { onClick: w, children: a })
        ] }),
        ...f
      }
    );
  if (t === "presets")
    return /* @__PURE__ */ me("div", { className: "flex flex-row shadow-datepicker-wrapper", children: [
      /* @__PURE__ */ E("div", { className: "flex flex-col gap-1 p-3 items-start border border-solid border-border-subtle border-r-0 rounded-tl-md rounded-bl-md", children: v.map((S, A) => /* @__PURE__ */ E(
        Qn,
        {
          onClick: () => y(S.range),
          variant: "ghost",
          className: "font-medium text-sm",
          children: S.label
        },
        A
      )) }),
      /* @__PURE__ */ E(
        Ob,
        {
          ...f,
          mode: e,
          selectedDates: d,
          setSelectedDates: m,
          variant: t,
          showOutsideDays: l,
          width: "w-auto",
          numberOfMonths: 2,
          footer: /* @__PURE__ */ me("div", { className: "flex justify-end p-2 gap-3 border border-solid border-border-subtle border-t-0 rounded-md rounded-tl-none rounded-tr-none bg-background-primary", children: [
            /* @__PURE__ */ E(
              Qn,
              {
                variant: "outline",
                onClick: x,
                children: s
              }
            ),
            /* @__PURE__ */ E(Qn, { onClick: w, children: a })
          ] })
        }
      )
    ] });
}, cL = ({
  type: e = "simple",
  defaultValue: t = [],
  autoClose: n = !1,
  disabled: r = !1,
  children: i,
  className: o
}) => {
  const [a, s] = Me(
    Array.isArray(t) ? t : [t]
  ), l = (f) => {
    s((d) => n ? d.includes(f) ? [] : [f] : d.includes(f) ? d.filter((p) => p !== f) : [...d, f]);
  };
  return /* @__PURE__ */ E("div", { className: H(e === "boxed" ? "space-y-3" : "", o), children: I.Children.map(i, (f) => I.isValidElement(f) && "value" in f.props ? I.cloneElement(
    f,
    {
      isOpen: a.includes(f.props.value),
      onToggle: () => l(f.props.value),
      type: e,
      disabled: r || f.props.disabled
    }
  ) : f) });
};
cL.displayName = "Accordion";
const uL = ({
  isOpen: e,
  onToggle: t,
  type: n = "simple",
  disabled: r = !1,
  children: i,
  className: o
}) => {
  const a = {
    simple: "border-0",
    separator: "border-0 border-b border-solid border-border-subtle",
    boxed: "border border-solid border-border-subtle rounded-md"
  }[n];
  return /* @__PURE__ */ E("div", { className: H(a, o), children: I.Children.map(
    i,
    (s) => I.isValidElement(s) ? I.cloneElement(s, {
      isOpen: e,
      onToggle: t,
      type: n,
      disabled: r
    }) : s
  ) });
};
uL.displayName = "Accordion.Item";
const fL = ({
  onToggle: e,
  isOpen: t,
  iconType: n = "arrow",
  // arrow, plus-minus
  disabled: r = !1,
  tag: i = "h3",
  type: o = "simple",
  children: a,
  className: s,
  ...l
}) => {
  const c = {
    simple: "px-2 py-3",
    separator: "px-2 py-4",
    boxed: "px-3 py-4"
  }[o], f = () => n === "arrow" ? /* @__PURE__ */ E(
    Gw,
    {
      className: H(
        "flex-shrink-0 text-icon-secondary size-5 transition-transform duration-300 ease-in-out",
        t ? "rotate-180" : "rotate-0"
      )
    }
  ) : n === "plus-minus" ? /* @__PURE__ */ E(
    ui.span,
    {
      initial: { opacity: 0, rotate: t ? -180 : 0 },
      animate: { opacity: 1, rotate: t ? 0 : 180 },
      exit: { opacity: 0 },
      transition: { duration: 0.3, ease: "easeInOut" },
      className: "flex items-center flex-shrink-0 text-icon-secondary",
      children: t ? /* @__PURE__ */ E(G$, {}) : /* @__PURE__ */ E(Y$, {})
    },
    t ? "minus" : "plus"
  ) : null;
  return /* @__PURE__ */ E(i, { className: "flex m-0 hover:bg-background-secondary transition duration-150 ease-in-out", children: /* @__PURE__ */ me(
    "button",
    {
      className: H(
        "flex w-full items-center justify-between text-sm font-medium transition-all appearance-none bg-transparent border-0 cursor-pointer gap-3",
        c,
        r && "cursor-not-allowed opacity-40",
        s
      ),
      onClick: r ? () => {
      } : e,
      "aria-expanded": t,
      disabled: r,
      ...l,
      children: [
        /* @__PURE__ */ E("div", { className: "flex items-center gap-2 text-text-primary font-semibold text-left", children: a }),
        f()
      ]
    }
  ) });
};
fL.displayName = "Accordion.Trigger";
const dL = ({
  isOpen: e,
  disabled: t = !1,
  type: n = "simple",
  children: r,
  className: i
}) => {
  const o = {
    open: { height: "auto", opacity: 1 },
    closed: { height: 0, opacity: 0 }
  }, a = {
    simple: "px-2 pb-3",
    separator: "px-2 pb-4",
    boxed: "px-3 pb-4"
  }[n];
  return /* @__PURE__ */ E(Hs, { initial: !1, children: e && /* @__PURE__ */ E(
    ui.div,
    {
      variants: o,
      initial: "closed",
      animate: "open",
      exit: "closed",
      transition: { duration: 0.3, ease: "easeInOut" },
      className: H(
        "overflow-hidden text-text-secondary w-full text-sm transition-[height, opacity, transform] ease-in box-border",
        t && "opacity-40",
        i
      ),
      "aria-hidden": !e,
      children: /* @__PURE__ */ E("div", { className: H(a), children: r })
    },
    "content"
  ) });
};
dL.displayName = "Accordion.Content";
const IEe = Object.assign(cL, {
  Item: uL,
  Trigger: fL,
  Content: dL
});
var Ene = Array.isArray, Ar = Ene, kne = typeof _o == "object" && _o && _o.Object === Object && _o, hL = kne, Mne = hL, Nne = typeof self == "object" && self && self.Object === Object && self, $ne = Mne || Nne || Function("return this")(), io = $ne, Dne = io, Ine = Dne.Symbol, Od = Ine, _E = Od, pL = Object.prototype, Rne = pL.hasOwnProperty, jne = pL.toString, Au = _E ? _E.toStringTag : void 0;
function Lne(e) {
  var t = Rne.call(e, Au), n = e[Au];
  try {
    e[Au] = void 0;
    var r = !0;
  } catch {
  }
  var i = jne.call(e);
  return r && (t ? e[Au] = n : delete e[Au]), i;
}
var Bne = Lne, Fne = Object.prototype, Wne = Fne.toString;
function zne(e) {
  return Wne.call(e);
}
var Vne = zne, SE = Od, Une = Bne, Kne = Vne, Hne = "[object Null]", Gne = "[object Undefined]", OE = SE ? SE.toStringTag : void 0;
function Yne(e) {
  return e == null ? e === void 0 ? Gne : Hne : OE && OE in Object(e) ? Une(e) : Kne(e);
}
var Jo = Yne;
function qne(e) {
  return e != null && typeof e == "object";
}
var Qo = qne, Xne = Jo, Zne = Qo, Jne = "[object Symbol]";
function Qne(e) {
  return typeof e == "symbol" || Zne(e) && Xne(e) == Jne;
}
var Fc = Qne, ere = Ar, tre = Fc, nre = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, rre = /^\w*$/;
function ire(e, t) {
  if (ere(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || tre(e) ? !0 : rre.test(e) || !nre.test(e) || t != null && e in Object(t);
}
var T_ = ire;
function ore(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ha = ore;
const Wc = /* @__PURE__ */ Et(Ha);
var are = Jo, sre = Ha, lre = "[object AsyncFunction]", cre = "[object Function]", ure = "[object GeneratorFunction]", fre = "[object Proxy]";
function dre(e) {
  if (!sre(e))
    return !1;
  var t = are(e);
  return t == cre || t == ure || t == lre || t == fre;
}
var C_ = dre;
const ze = /* @__PURE__ */ Et(C_);
var hre = io, pre = hre["__core-js_shared__"], mre = pre, Ab = mre, AE = function() {
  var e = /[^.]+$/.exec(Ab && Ab.keys && Ab.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function gre(e) {
  return !!AE && AE in e;
}
var yre = gre, vre = Function.prototype, bre = vre.toString;
function xre(e) {
  if (e != null) {
    try {
      return bre.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var mL = xre, wre = C_, _re = yre, Sre = Ha, Ore = mL, Are = /[\\^$.*+?()[\]{}|]/g, Pre = /^\[object .+?Constructor\]$/, Tre = Function.prototype, Cre = Object.prototype, Ere = Tre.toString, kre = Cre.hasOwnProperty, Mre = RegExp(
  "^" + Ere.call(kre).replace(Are, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Nre(e) {
  if (!Sre(e) || _re(e))
    return !1;
  var t = wre(e) ? Mre : Pre;
  return t.test(Ore(e));
}
var $re = Nre;
function Dre(e, t) {
  return e == null ? void 0 : e[t];
}
var Ire = Dre, Rre = $re, jre = Ire;
function Lre(e, t) {
  var n = jre(e, t);
  return Rre(n) ? n : void 0;
}
var Js = Lre, Bre = Js, Fre = Bre(Object, "create"), Ug = Fre, PE = Ug;
function Wre() {
  this.__data__ = PE ? PE(null) : {}, this.size = 0;
}
var zre = Wre;
function Vre(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ure = Vre, Kre = Ug, Hre = "__lodash_hash_undefined__", Gre = Object.prototype, Yre = Gre.hasOwnProperty;
function qre(e) {
  var t = this.__data__;
  if (Kre) {
    var n = t[e];
    return n === Hre ? void 0 : n;
  }
  return Yre.call(t, e) ? t[e] : void 0;
}
var Xre = qre, Zre = Ug, Jre = Object.prototype, Qre = Jre.hasOwnProperty;
function eie(e) {
  var t = this.__data__;
  return Zre ? t[e] !== void 0 : Qre.call(t, e);
}
var tie = eie, nie = Ug, rie = "__lodash_hash_undefined__";
function iie(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = nie && t === void 0 ? rie : t, this;
}
var oie = iie, aie = zre, sie = Ure, lie = Xre, cie = tie, uie = oie;
function zc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
zc.prototype.clear = aie;
zc.prototype.delete = sie;
zc.prototype.get = lie;
zc.prototype.has = cie;
zc.prototype.set = uie;
var fie = zc;
function die() {
  this.__data__ = [], this.size = 0;
}
var hie = die;
function pie(e, t) {
  return e === t || e !== e && t !== t;
}
var E_ = pie, mie = E_;
function gie(e, t) {
  for (var n = e.length; n--; )
    if (mie(e[n][0], t))
      return n;
  return -1;
}
var Kg = gie, yie = Kg, vie = Array.prototype, bie = vie.splice;
function xie(e) {
  var t = this.__data__, n = yie(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : bie.call(t, n, 1), --this.size, !0;
}
var wie = xie, _ie = Kg;
function Sie(e) {
  var t = this.__data__, n = _ie(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Oie = Sie, Aie = Kg;
function Pie(e) {
  return Aie(this.__data__, e) > -1;
}
var Tie = Pie, Cie = Kg;
function Eie(e, t) {
  var n = this.__data__, r = Cie(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var kie = Eie, Mie = hie, Nie = wie, $ie = Oie, Die = Tie, Iie = kie;
function Vc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Vc.prototype.clear = Mie;
Vc.prototype.delete = Nie;
Vc.prototype.get = $ie;
Vc.prototype.has = Die;
Vc.prototype.set = Iie;
var Hg = Vc, Rie = Js, jie = io, Lie = Rie(jie, "Map"), k_ = Lie, TE = fie, Bie = Hg, Fie = k_;
function Wie() {
  this.size = 0, this.__data__ = {
    hash: new TE(),
    map: new (Fie || Bie)(),
    string: new TE()
  };
}
var zie = Wie;
function Vie(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Uie = Vie, Kie = Uie;
function Hie(e, t) {
  var n = e.__data__;
  return Kie(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Gg = Hie, Gie = Gg;
function Yie(e) {
  var t = Gie(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var qie = Yie, Xie = Gg;
function Zie(e) {
  return Xie(this, e).get(e);
}
var Jie = Zie, Qie = Gg;
function eoe(e) {
  return Qie(this, e).has(e);
}
var toe = eoe, noe = Gg;
function roe(e, t) {
  var n = noe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var ioe = roe, ooe = zie, aoe = qie, soe = Jie, loe = toe, coe = ioe;
function Uc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Uc.prototype.clear = ooe;
Uc.prototype.delete = aoe;
Uc.prototype.get = soe;
Uc.prototype.has = loe;
Uc.prototype.set = coe;
var M_ = Uc, gL = M_, uoe = "Expected a function";
function N_(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(uoe);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (N_.Cache || gL)(), n;
}
N_.Cache = gL;
var yL = N_;
const foe = /* @__PURE__ */ Et(yL);
var doe = yL, hoe = 500;
function poe(e) {
  var t = doe(e, function(r) {
    return n.size === hoe && n.clear(), r;
  }), n = t.cache;
  return t;
}
var moe = poe, goe = moe, yoe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, voe = /\\(\\)?/g, boe = goe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(yoe, function(n, r, i, o) {
    t.push(i ? o.replace(voe, "$1") : r || n);
  }), t;
}), xoe = boe;
function woe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var $_ = woe, CE = Od, _oe = $_, Soe = Ar, Ooe = Fc, Aoe = 1 / 0, EE = CE ? CE.prototype : void 0, kE = EE ? EE.toString : void 0;
function vL(e) {
  if (typeof e == "string")
    return e;
  if (Soe(e))
    return _oe(e, vL) + "";
  if (Ooe(e))
    return kE ? kE.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Aoe ? "-0" : t;
}
var Poe = vL, Toe = Poe;
function Coe(e) {
  return e == null ? "" : Toe(e);
}
var bL = Coe, Eoe = Ar, koe = T_, Moe = xoe, Noe = bL;
function $oe(e, t) {
  return Eoe(e) ? e : koe(e, t) ? [e] : Moe(Noe(e));
}
var xL = $oe, Doe = Fc, Ioe = 1 / 0;
function Roe(e) {
  if (typeof e == "string" || Doe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Ioe ? "-0" : t;
}
var Yg = Roe, joe = xL, Loe = Yg;
function Boe(e, t) {
  t = joe(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Loe(t[n++])];
  return n && n == r ? e : void 0;
}
var D_ = Boe, Foe = D_;
function Woe(e, t, n) {
  var r = e == null ? void 0 : Foe(e, t);
  return r === void 0 ? n : r;
}
var wL = Woe;
const Wr = /* @__PURE__ */ Et(wL);
function zoe(e) {
  return e == null;
}
var Voe = zoe;
const Ue = /* @__PURE__ */ Et(Voe);
var Uoe = Jo, Koe = Ar, Hoe = Qo, Goe = "[object String]";
function Yoe(e) {
  return typeof e == "string" || !Koe(e) && Hoe(e) && Uoe(e) == Goe;
}
var qoe = Yoe;
const Ad = /* @__PURE__ */ Et(qoe);
var dx = { exports: {} }, vt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ME;
function Xoe() {
  if (ME) return vt;
  ME = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function v(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case e:
          switch (y = y.type, y) {
            case n:
            case i:
            case r:
            case c:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case a:
                case l:
                case p:
                case d:
                case o:
                  return y;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return vt.ContextConsumer = a, vt.ContextProvider = o, vt.Element = e, vt.ForwardRef = l, vt.Fragment = n, vt.Lazy = p, vt.Memo = d, vt.Portal = t, vt.Profiler = i, vt.StrictMode = r, vt.Suspense = c, vt.SuspenseList = f, vt.isAsyncMode = function() {
    return !1;
  }, vt.isConcurrentMode = function() {
    return !1;
  }, vt.isContextConsumer = function(y) {
    return v(y) === a;
  }, vt.isContextProvider = function(y) {
    return v(y) === o;
  }, vt.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, vt.isForwardRef = function(y) {
    return v(y) === l;
  }, vt.isFragment = function(y) {
    return v(y) === n;
  }, vt.isLazy = function(y) {
    return v(y) === p;
  }, vt.isMemo = function(y) {
    return v(y) === d;
  }, vt.isPortal = function(y) {
    return v(y) === t;
  }, vt.isProfiler = function(y) {
    return v(y) === i;
  }, vt.isStrictMode = function(y) {
    return v(y) === r;
  }, vt.isSuspense = function(y) {
    return v(y) === c;
  }, vt.isSuspenseList = function(y) {
    return v(y) === f;
  }, vt.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === i || y === r || y === c || y === f || y === m || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === d || y.$$typeof === o || y.$$typeof === a || y.$$typeof === l || y.$$typeof === g || y.getModuleId !== void 0);
  }, vt.typeOf = v, vt;
}
var bt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NE;
function Zoe() {
  return NE || (NE = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = !1, v = !1, y = !1, x = !1, w = !1, S;
    S = Symbol.for("react.module.reference");
    function A(pe) {
      return !!(typeof pe == "string" || typeof pe == "function" || pe === n || pe === i || w || pe === r || pe === c || pe === f || x || pe === m || g || v || y || typeof pe == "object" && pe !== null && (pe.$$typeof === p || pe.$$typeof === d || pe.$$typeof === o || pe.$$typeof === a || pe.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      pe.$$typeof === S || pe.getModuleId !== void 0));
    }
    function _(pe) {
      if (typeof pe == "object" && pe !== null) {
        var Be = pe.$$typeof;
        switch (Be) {
          case e:
            var rt = pe.type;
            switch (rt) {
              case n:
              case i:
              case r:
              case c:
              case f:
                return rt;
              default:
                var at = rt && rt.$$typeof;
                switch (at) {
                  case s:
                  case a:
                  case l:
                  case p:
                  case d:
                  case o:
                    return at;
                  default:
                    return Be;
                }
            }
          case t:
            return Be;
        }
      }
    }
    var O = a, T = o, C = e, k = l, D = n, N = p, $ = d, B = t, L = i, F = r, W = c, z = f, G = !1, V = !1;
    function U(pe) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(pe) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function te(pe) {
      return _(pe) === a;
    }
    function ne(pe) {
      return _(pe) === o;
    }
    function re(pe) {
      return typeof pe == "object" && pe !== null && pe.$$typeof === e;
    }
    function ue(pe) {
      return _(pe) === l;
    }
    function ae(pe) {
      return _(pe) === n;
    }
    function le(pe) {
      return _(pe) === p;
    }
    function ie(pe) {
      return _(pe) === d;
    }
    function Q(pe) {
      return _(pe) === t;
    }
    function fe(pe) {
      return _(pe) === i;
    }
    function ve(pe) {
      return _(pe) === r;
    }
    function X(pe) {
      return _(pe) === c;
    }
    function Fe(pe) {
      return _(pe) === f;
    }
    bt.ContextConsumer = O, bt.ContextProvider = T, bt.Element = C, bt.ForwardRef = k, bt.Fragment = D, bt.Lazy = N, bt.Memo = $, bt.Portal = B, bt.Profiler = L, bt.StrictMode = F, bt.Suspense = W, bt.SuspenseList = z, bt.isAsyncMode = U, bt.isConcurrentMode = Y, bt.isContextConsumer = te, bt.isContextProvider = ne, bt.isElement = re, bt.isForwardRef = ue, bt.isFragment = ae, bt.isLazy = le, bt.isMemo = ie, bt.isPortal = Q, bt.isProfiler = fe, bt.isStrictMode = ve, bt.isSuspense = X, bt.isSuspenseList = Fe, bt.isValidElementType = A, bt.typeOf = _;
  }()), bt;
}
process.env.NODE_ENV === "production" ? dx.exports = Xoe() : dx.exports = Zoe();
var Joe = dx.exports, Qoe = Jo, eae = Qo, tae = "[object Number]";
function nae(e) {
  return typeof e == "number" || eae(e) && Qoe(e) == tae;
}
var _L = nae;
const rae = /* @__PURE__ */ Et(_L);
var iae = _L;
function oae(e) {
  return iae(e) && e != +e;
}
var aae = oae;
const Kc = /* @__PURE__ */ Et(aae);
var ur = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, _s = function(t) {
  return Ad(t) && t.indexOf("%") === t.length - 1;
}, be = function(t) {
  return rae(t) && !Kc(t);
}, Sn = function(t) {
  return be(t) || Ad(t);
}, sae = 0, Qs = function(t) {
  var n = ++sae;
  return "".concat(t || "").concat(n);
}, fr = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!be(t) && !Ad(t))
    return r;
  var o;
  if (_s(t)) {
    var a = t.indexOf("%");
    o = n * parseFloat(t.slice(0, a)) / 100;
  } else
    o = +t;
  return Kc(o) && (o = r), i && o > n && (o = n), o;
}, wa = function(t) {
  if (!t)
    return null;
  var n = Object.keys(t);
  return n && n.length ? t[n[0]] : null;
}, lae = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var n = t.length, r = {}, i = 0; i < n; i++)
    if (!r[t[i]])
      r[t[i]] = !0;
    else
      return !0;
  return !1;
}, wn = function(t, n) {
  return be(t) && be(n) ? function(r) {
    return t + r * (n - t);
  } : function() {
    return n;
  };
};
function Kp(e, t, n) {
  return !e || !e.length ? null : e.find(function(r) {
    return r && (typeof t == "function" ? t(r) : Wr(r, t)) === n;
  });
}
function Kl(e, t) {
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && (!{}.hasOwnProperty.call(t, n) || e[n] !== t[n]))
      return !1;
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && !{}.hasOwnProperty.call(e, r))
      return !1;
  return !0;
}
function hx(e) {
  "@babel/helpers - typeof";
  return hx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hx(e);
}
var cae = ["viewBox", "children"], uae = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], $E = ["points", "pathLength"], Pb = {
  svg: cae,
  polygon: $E,
  polyline: $E
}, I_ = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], Hp = function(t, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var r = t;
  if (/* @__PURE__ */ ut(t) && (r = t.props), !Wc(r))
    return null;
  var i = {};
  return Object.keys(r).forEach(function(o) {
    I_.includes(o) && (i[o] = n || function(a) {
      return r[o](r, a);
    });
  }), i;
}, fae = function(t, n, r) {
  return function(i) {
    return t(n, r, i), null;
  };
}, Fs = function(t, n, r) {
  if (!Wc(t) || hx(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(o) {
    var a = t[o];
    I_.includes(o) && typeof a == "function" && (i || (i = {}), i[o] = fae(a, n, r));
  }), i;
}, dae = ["children"], hae = ["children"];
function DE(e, t) {
  if (e == null) return {};
  var n = pae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function pae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function px(e) {
  "@babel/helpers - typeof";
  return px = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, px(e);
}
var IE = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Io = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, RE = null, Tb = null, R_ = function e(t) {
  if (t === RE && Array.isArray(Tb))
    return Tb;
  var n = [];
  return tr.forEach(t, function(r) {
    Ue(r) || (Joe.isFragment(r) ? n = n.concat(e(r.props.children)) : n.push(r));
  }), Tb = n, RE = t, n;
};
function zr(e, t) {
  var n = [], r = [];
  return Array.isArray(t) ? r = t.map(function(i) {
    return Io(i);
  }) : r = [Io(t)], R_(e).forEach(function(i) {
    var o = Wr(i, "type.displayName") || Wr(i, "type.name");
    r.indexOf(o) !== -1 && n.push(i);
  }), n;
}
function Rr(e, t) {
  var n = zr(e, t);
  return n && n[0];
}
var jE = function(t) {
  if (!t || !t.props)
    return !1;
  var n = t.props, r = n.width, i = n.height;
  return !(!be(r) || r <= 0 || !be(i) || i <= 0);
}, mae = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], gae = function(t) {
  return t && t.type && Ad(t.type) && mae.indexOf(t.type) >= 0;
}, SL = function(t) {
  return t && px(t) === "object" && "clipDot" in t;
}, yae = function(t, n, r, i) {
  var o, a = (o = Pb == null ? void 0 : Pb[i]) !== null && o !== void 0 ? o : [];
  return !ze(t) && (i && a.includes(n) || uae.includes(n)) || r && I_.includes(n);
}, Ee = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ ut(t) && (i = t.props), !Wc(i))
    return null;
  var o = {};
  return Object.keys(i).forEach(function(a) {
    var s;
    yae((s = i) === null || s === void 0 ? void 0 : s[a], a, n, r) && (o[a] = i[a]);
  }), o;
}, mx = function e(t, n) {
  if (t === n)
    return !0;
  var r = tr.count(t);
  if (r !== tr.count(n))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return LE(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n);
  for (var i = 0; i < r; i++) {
    var o = t[i], a = n[i];
    if (Array.isArray(o) || Array.isArray(a)) {
      if (!e(o, a))
        return !1;
    } else if (!LE(o, a))
      return !1;
  }
  return !0;
}, LE = function(t, n) {
  if (Ue(t) && Ue(n))
    return !0;
  if (!Ue(t) && !Ue(n)) {
    var r = t.props || {}, i = r.children, o = DE(r, dae), a = n.props || {}, s = a.children, l = DE(a, hae);
    return i && s ? Kl(o, l) && mx(i, s) : !i && !s ? Kl(o, l) : !1;
  }
  return !1;
}, BE = function(t, n) {
  var r = [], i = {};
  return R_(t).forEach(function(o, a) {
    if (gae(o))
      r.push(o);
    else if (o) {
      var s = Io(o.type), l = n[s] || {}, c = l.handler, f = l.once;
      if (c && (!f || !i[s])) {
        var d = c(o, s, a);
        r.push(d), i[s] = !0;
      }
    }
  }), r;
}, vae = function(t) {
  var n = t && t.type;
  return n && IE[n] ? IE[n] : null;
}, bae = function(t, n) {
  return R_(n).indexOf(t);
}, xae = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function gx() {
  return gx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gx.apply(this, arguments);
}
function wae(e, t) {
  if (e == null) return {};
  var n = _ae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function _ae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function yx(e) {
  var t = e.children, n = e.width, r = e.height, i = e.viewBox, o = e.className, a = e.style, s = e.title, l = e.desc, c = wae(e, xae), f = i || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, d = Ye("recharts-surface", o);
  return /* @__PURE__ */ I.createElement("svg", gx({}, Ee(c, !0, "svg"), {
    className: d,
    width: n,
    height: r,
    style: a,
    viewBox: "".concat(f.x, " ").concat(f.y, " ").concat(f.width, " ").concat(f.height)
  }), /* @__PURE__ */ I.createElement("title", null, s), /* @__PURE__ */ I.createElement("desc", null, l), t);
}
var Sae = ["children", "className"];
function vx() {
  return vx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vx.apply(this, arguments);
}
function Oae(e, t) {
  if (e == null) return {};
  var n = Aae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Aae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var ot = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = Oae(e, Sae), o = Ye("recharts-layer", r);
  return /* @__PURE__ */ I.createElement("g", vx({
    className: o
  }, Ee(i, !0), {
    ref: t
  }), n);
}), Pae = process.env.NODE_ENV !== "production", ki = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  if (Pae && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = 0;
      console.warn(n.replace(/%s/g, function() {
        return i[a++];
      }));
    }
};
function Tae(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var Cae = Tae, Eae = Cae;
function kae(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : Eae(e, t, n);
}
var Mae = kae, Nae = "\\ud800-\\udfff", $ae = "\\u0300-\\u036f", Dae = "\\ufe20-\\ufe2f", Iae = "\\u20d0-\\u20ff", Rae = $ae + Dae + Iae, jae = "\\ufe0e\\ufe0f", Lae = "\\u200d", Bae = RegExp("[" + Lae + Nae + Rae + jae + "]");
function Fae(e) {
  return Bae.test(e);
}
var OL = Fae;
function Wae(e) {
  return e.split("");
}
var zae = Wae, AL = "\\ud800-\\udfff", Vae = "\\u0300-\\u036f", Uae = "\\ufe20-\\ufe2f", Kae = "\\u20d0-\\u20ff", Hae = Vae + Uae + Kae, Gae = "\\ufe0e\\ufe0f", Yae = "[" + AL + "]", bx = "[" + Hae + "]", xx = "\\ud83c[\\udffb-\\udfff]", qae = "(?:" + bx + "|" + xx + ")", PL = "[^" + AL + "]", TL = "(?:\\ud83c[\\udde6-\\uddff]){2}", CL = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xae = "\\u200d", EL = qae + "?", kL = "[" + Gae + "]?", Zae = "(?:" + Xae + "(?:" + [PL, TL, CL].join("|") + ")" + kL + EL + ")*", Jae = kL + EL + Zae, Qae = "(?:" + [PL + bx + "?", bx, TL, CL, Yae].join("|") + ")", ese = RegExp(xx + "(?=" + xx + ")|" + Qae + Jae, "g");
function tse(e) {
  return e.match(ese) || [];
}
var nse = tse, rse = zae, ise = OL, ose = nse;
function ase(e) {
  return ise(e) ? ose(e) : rse(e);
}
var sse = ase, lse = Mae, cse = OL, use = sse, fse = bL;
function dse(e) {
  return function(t) {
    t = fse(t);
    var n = cse(t) ? use(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? lse(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var hse = dse, pse = hse, mse = pse("toUpperCase"), gse = mse;
const qg = /* @__PURE__ */ Et(gse);
function Rt(e) {
  return function() {
    return e;
  };
}
const ML = Math.cos, Gp = Math.sin, Ii = Math.sqrt, Yp = Math.PI, Xg = 2 * Yp, wx = Math.PI, _x = 2 * wx, gs = 1e-6, yse = _x - gs;
function NL(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function vse(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return NL;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class bse {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? NL : vse(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, l = r - t, c = i - n, f = a - t, d = s - n, p = f * f + d * d;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (p > gs) if (!(Math.abs(d * l - c * f) > gs) || !o)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let m = r - a, g = i - s, v = l * l + c * c, y = m * m + g * g, x = Math.sqrt(v), w = Math.sqrt(p), S = o * Math.tan((wx - Math.acos((v + p - y) / (2 * x * w))) / 2), A = S / w, _ = S / x;
      Math.abs(A - 1) > gs && this._append`L${t + A * f},${n + A * d}`, this._append`A${o},${o},0,0,${+(d * m > f * g)},${this._x1 = t + _ * l},${this._y1 = n + _ * c}`;
    }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), l = r * Math.sin(i), c = t + s, f = n + l, d = 1 ^ a, p = a ? i - o : o - i;
    this._x1 === null ? this._append`M${c},${f}` : (Math.abs(this._x1 - c) > gs || Math.abs(this._y1 - f) > gs) && this._append`L${c},${f}`, r && (p < 0 && (p = p % _x + _x), p > yse ? this._append`A${r},${r},0,1,${d},${t - s},${n - l}A${r},${r},0,1,${d},${this._x1 = c},${this._y1 = f}` : p > gs && this._append`A${r},${r},0,${+(p >= wx)},${d},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function j_(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new bse(t);
}
function L_(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function $L(e) {
  this._context = e;
}
$L.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Zg(e) {
  return new $L(e);
}
function DL(e) {
  return e[0];
}
function IL(e) {
  return e[1];
}
function RL(e, t) {
  var n = Rt(!0), r = null, i = Zg, o = null, a = j_(s);
  e = typeof e == "function" ? e : e === void 0 ? DL : Rt(e), t = typeof t == "function" ? t : t === void 0 ? IL : Rt(t);
  function s(l) {
    var c, f = (l = L_(l)).length, d, p = !1, m;
    for (r == null && (o = i(m = a())), c = 0; c <= f; ++c)
      !(c < f && n(d = l[c], c, l)) === p && ((p = !p) ? o.lineStart() : o.lineEnd()), p && o.point(+e(d, c, l), +t(d, c, l));
    if (m) return o = null, m + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Rt(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Rt(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Rt(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (i = l, r != null && (o = i(r)), s) : i;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = o = null : o = i(r = l), s) : r;
  }, s;
}
function Fh(e, t, n) {
  var r = null, i = Rt(!0), o = null, a = Zg, s = null, l = j_(c);
  e = typeof e == "function" ? e : e === void 0 ? DL : Rt(+e), t = typeof t == "function" ? t : Rt(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? IL : Rt(+n);
  function c(d) {
    var p, m, g, v = (d = L_(d)).length, y, x = !1, w, S = new Array(v), A = new Array(v);
    for (o == null && (s = a(w = l())), p = 0; p <= v; ++p) {
      if (!(p < v && i(y = d[p], p, d)) === x)
        if (x = !x)
          m = p, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = p - 1; g >= m; --g)
            s.point(S[g], A[g]);
          s.lineEnd(), s.areaEnd();
        }
      x && (S[p] = +e(y, p, d), A[p] = +t(y, p, d), s.point(r ? +r(y, p, d) : S[p], n ? +n(y, p, d) : A[p]));
    }
    if (w) return s = null, w + "" || null;
  }
  function f() {
    return RL().defined(i).curve(a).context(o);
  }
  return c.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Rt(+d), r = null, c) : e;
  }, c.x0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Rt(+d), c) : e;
  }, c.x1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : Rt(+d), c) : r;
  }, c.y = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Rt(+d), n = null, c) : t;
  }, c.y0 = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Rt(+d), c) : t;
  }, c.y1 = function(d) {
    return arguments.length ? (n = d == null ? null : typeof d == "function" ? d : Rt(+d), c) : n;
  }, c.lineX0 = c.lineY0 = function() {
    return f().x(e).y(t);
  }, c.lineY1 = function() {
    return f().x(e).y(n);
  }, c.lineX1 = function() {
    return f().x(r).y(t);
  }, c.defined = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : Rt(!!d), c) : i;
  }, c.curve = function(d) {
    return arguments.length ? (a = d, o != null && (s = a(o)), c) : a;
  }, c.context = function(d) {
    return arguments.length ? (d == null ? o = s = null : s = a(o = d), c) : o;
  }, c;
}
class jL {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
function xse(e) {
  return new jL(e, !0);
}
function wse(e) {
  return new jL(e, !1);
}
const B_ = {
  draw(e, t) {
    const n = Ii(t / Yp);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, Xg);
  }
}, _se = {
  draw(e, t) {
    const n = Ii(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, LL = Ii(1 / 3), Sse = LL * 2, Ose = {
  draw(e, t) {
    const n = Ii(t / Sse), r = n * LL;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, Ase = {
  draw(e, t) {
    const n = Ii(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, Pse = 0.8908130915292852, BL = Gp(Yp / 10) / Gp(7 * Yp / 10), Tse = Gp(Xg / 10) * BL, Cse = -ML(Xg / 10) * BL, Ese = {
  draw(e, t) {
    const n = Ii(t * Pse), r = Tse * n, i = Cse * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const a = Xg * o / 5, s = ML(a), l = Gp(a);
      e.lineTo(l * n, -s * n), e.lineTo(s * r - l * i, l * r + s * i);
    }
    e.closePath();
  }
}, Cb = Ii(3), kse = {
  draw(e, t) {
    const n = -Ii(t / (Cb * 3));
    e.moveTo(0, n * 2), e.lineTo(-Cb * n, -n), e.lineTo(Cb * n, -n), e.closePath();
  }
}, ii = -0.5, oi = Ii(3) / 2, Sx = 1 / Ii(12), Mse = (Sx / 2 + 1) * 3, Nse = {
  draw(e, t) {
    const n = Ii(t / Mse), r = n / 2, i = n * Sx, o = r, a = n * Sx + n, s = -o, l = a;
    e.moveTo(r, i), e.lineTo(o, a), e.lineTo(s, l), e.lineTo(ii * r - oi * i, oi * r + ii * i), e.lineTo(ii * o - oi * a, oi * o + ii * a), e.lineTo(ii * s - oi * l, oi * s + ii * l), e.lineTo(ii * r + oi * i, ii * i - oi * r), e.lineTo(ii * o + oi * a, ii * a - oi * o), e.lineTo(ii * s + oi * l, ii * l - oi * s), e.closePath();
  }
};
function $se(e, t) {
  let n = null, r = j_(i);
  e = typeof e == "function" ? e : Rt(e || B_), t = typeof t == "function" ? t : Rt(t === void 0 ? 64 : +t);
  function i() {
    let o;
    if (n || (n = o = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o) return n = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : Rt(o), i) : e;
  }, i.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : Rt(+o), i) : t;
  }, i.context = function(o) {
    return arguments.length ? (n = o ?? null, i) : n;
  }, i;
}
function qp() {
}
function Xp(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function FL(e) {
  this._context = e;
}
FL.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Xp(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Xp(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Dse(e) {
  return new FL(e);
}
function WL(e) {
  this._context = e;
}
WL.prototype = {
  areaStart: qp,
  areaEnd: qp,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Xp(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Ise(e) {
  return new WL(e);
}
function zL(e) {
  this._context = e;
}
zL.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        Xp(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Rse(e) {
  return new zL(e);
}
function VL(e) {
  this._context = e;
}
VL.prototype = {
  areaStart: qp,
  areaEnd: qp,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function jse(e) {
  return new VL(e);
}
function FE(e) {
  return e < 0 ? -1 : 1;
}
function WE(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (r || i < 0 && -0), a = (n - e._y1) / (i || r < 0 && -0), s = (o * i + a * r) / (r + i);
  return (FE(o) + FE(a)) * Math.min(Math.abs(o), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function zE(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Eb(e, t, n) {
  var r = e._x0, i = e._y0, o = e._x1, a = e._y1, s = (o - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}
function Zp(e) {
  this._context = e;
}
Zp.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Eb(this, this._t0, zE(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Eb(this, zE(this, n = WE(this, e, t)), n);
          break;
        default:
          Eb(this, this._t0, n = WE(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function UL(e) {
  this._context = new KL(e);
}
(UL.prototype = Object.create(Zp.prototype)).point = function(e, t) {
  Zp.prototype.point.call(this, t, e);
};
function KL(e) {
  this._context = e;
}
KL.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
};
function Lse(e) {
  return new Zp(e);
}
function Bse(e) {
  return new UL(e);
}
function HL(e) {
  this._context = e;
}
HL.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = VE(e), i = VE(t), o = 0, a = 1; a < n; ++o, ++a)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function VE(e) {
  var t, n = e.length - 1, r, i = new Array(n), o = new Array(n), a = new Array(n);
  for (i[0] = 0, o[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, o[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / o[t - 1], o[t] -= r, a[t] -= r * a[t - 1];
  for (i[n - 1] = a[n - 1] / o[n - 1], t = n - 2; t >= 0; --t) i[t] = (a[t] - i[t + 1]) / o[t];
  for (o[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) o[t] = 2 * e[t + 1] - i[t + 1];
  return [i, o];
}
function Fse(e) {
  return new HL(e);
}
function Jg(e, t) {
  this._context = e, this._t = t;
}
Jg.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function Wse(e) {
  return new Jg(e, 0.5);
}
function zse(e) {
  return new Jg(e, 0);
}
function Vse(e) {
  return new Jg(e, 1);
}
function rc(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, i, o = e[t[0]], a, s = o.length; n < a; ++n)
      for (i = o, o = e[t[n]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function Ox(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function Use(e, t) {
  return e[t];
}
function Kse(e) {
  const t = [];
  return t.key = e, t;
}
function Hse() {
  var e = Rt([]), t = Ox, n = rc, r = Use;
  function i(o) {
    var a = Array.from(e.apply(this, arguments), Kse), s, l = a.length, c = -1, f;
    for (const d of o)
      for (s = 0, ++c; s < l; ++s)
        (a[s][c] = [0, +r(d, a[s].key, c, o)]).data = d;
    for (s = 0, f = L_(t(a)); s < l; ++s)
      a[f[s]].index = s;
    return n(a, f), a;
  }
  return i.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : Rt(Array.from(o)), i) : e;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : Rt(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (t = o == null ? Ox : typeof o == "function" ? o : Rt(Array.from(o)), i) : t;
  }, i.offset = function(o) {
    return arguments.length ? (n = o ?? rc, i) : n;
  }, i;
}
function Gse(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, o = e[0].length, a; i < o; ++i) {
      for (a = n = 0; n < r; ++n) a += e[n][i][1] || 0;
      if (a) for (n = 0; n < r; ++n) e[n][i][1] /= a;
    }
    rc(e, t);
  }
}
function Yse(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, o = r.length; n < o; ++n) {
      for (var a = 0, s = 0; a < i; ++a) s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    rc(e, t);
  }
}
function qse(e, t) {
  if (!(!((a = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, o, a; r < o; ++r) {
      for (var s = 0, l = 0, c = 0; s < a; ++s) {
        for (var f = e[t[s]], d = f[r][1] || 0, p = f[r - 1][1] || 0, m = (d - p) / 2, g = 0; g < s; ++g) {
          var v = e[t[g]], y = v[r][1] || 0, x = v[r - 1][1] || 0;
          m += y - x;
        }
        l += d, c += m * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, l && (n -= c / l);
    }
    i[r - 1][1] += i[r - 1][0] = n, rc(e, t);
  }
}
function Af(e) {
  "@babel/helpers - typeof";
  return Af = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Af(e);
}
var Xse = ["type", "size", "sizeType"];
function Ax() {
  return Ax = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ax.apply(this, arguments);
}
function UE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UE(Object(n), !0).forEach(function(r) {
      Zse(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : UE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Zse(e, t, n) {
  return t = Jse(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Jse(e) {
  var t = Qse(e, "string");
  return Af(t) == "symbol" ? t : t + "";
}
function Qse(e, t) {
  if (Af(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Af(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ele(e, t) {
  if (e == null) return {};
  var n = tle(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function tle(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var GL = {
  symbolCircle: B_,
  symbolCross: _se,
  symbolDiamond: Ose,
  symbolSquare: Ase,
  symbolStar: Ese,
  symbolTriangle: kse,
  symbolWye: Nse
}, nle = Math.PI / 180, rle = function(t) {
  var n = "symbol".concat(qg(t));
  return GL[n] || B_;
}, ile = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * nle;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, ole = function(t, n) {
  GL["symbol".concat(qg(t))] = n;
}, F_ = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, i = t.size, o = i === void 0 ? 64 : i, a = t.sizeType, s = a === void 0 ? "area" : a, l = ele(t, Xse), c = KE(KE({}, l), {}, {
    type: r,
    size: o,
    sizeType: s
  }), f = function() {
    var y = rle(r), x = $se().type(y).size(ile(o, s, r));
    return x();
  }, d = c.className, p = c.cx, m = c.cy, g = Ee(c, !0);
  return p === +p && m === +m && o === +o ? /* @__PURE__ */ I.createElement("path", Ax({}, g, {
    className: Ye("recharts-symbols", d),
    transform: "translate(".concat(p, ", ").concat(m, ")"),
    d: f()
  })) : null;
};
F_.registerSymbol = ole;
function ic(e) {
  "@babel/helpers - typeof";
  return ic = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ic(e);
}
function Px() {
  return Px = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Px.apply(this, arguments);
}
function HE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ale(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HE(Object(n), !0).forEach(function(r) {
      Pf(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function sle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lle(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qL(r.key), r);
  }
}
function cle(e, t, n) {
  return t && lle(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ule(e, t, n) {
  return t = Jp(t), fle(e, YL() ? Reflect.construct(t, n || [], Jp(e).constructor) : t.apply(e, n));
}
function fle(e, t) {
  if (t && (ic(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dle(e);
}
function dle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function YL() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (YL = function() {
    return !!e;
  })();
}
function Jp(e) {
  return Jp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Jp(e);
}
function hle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tx(e, t);
}
function Tx(e, t) {
  return Tx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Tx(e, t);
}
function Pf(e, t, n) {
  return t = qL(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qL(e) {
  var t = ple(e, "string");
  return ic(t) == "symbol" ? t : t + "";
}
function ple(e, t) {
  if (ic(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ic(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ai = 32, W_ = /* @__PURE__ */ function(e) {
  function t() {
    return sle(this, t), ule(this, t, arguments);
  }
  return hle(t, e), cle(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var i = this.props.inactiveColor, o = ai / 2, a = ai / 6, s = ai / 3, l = r.inactive ? i : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ I.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: o,
            x2: ai,
            y2: o,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ I.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(o, "h").concat(s, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(2 * s, ",").concat(o, `
            H`).concat(ai, "M").concat(2 * s, ",").concat(o, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(s, ",").concat(o),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ I.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(ai / 8, "h").concat(ai, "v").concat(ai * 3 / 4, "h").concat(-ai, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ I.isValidElement(r.legendIcon)) {
          var c = ale({}, r);
          return delete c.legendIcon, /* @__PURE__ */ I.cloneElement(r.legendIcon, c);
        }
        return /* @__PURE__ */ I.createElement(F_, {
          fill: l,
          cx: o,
          cy: o,
          size: ai,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, i = this.props, o = i.payload, a = i.iconSize, s = i.layout, l = i.formatter, c = i.inactiveColor, f = {
        x: 0,
        y: 0,
        width: ai,
        height: ai
      }, d = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, p = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return o.map(function(m, g) {
        var v = m.formatter || l, y = Ye(Pf(Pf({
          "recharts-legend-item": !0
        }, "legend-item-".concat(g), !0), "inactive", m.inactive));
        if (m.type === "none")
          return null;
        var x = ze(m.value) ? null : m.value;
        ki(
          !ze(m.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var w = m.inactive ? c : m.color;
        return /* @__PURE__ */ I.createElement("li", Px({
          className: y,
          style: d,
          key: "legend-item-".concat(g)
        }, Fs(r.props, m, g)), /* @__PURE__ */ I.createElement(yx, {
          width: a,
          height: a,
          viewBox: f,
          style: p
        }, r.renderIcon(m)), /* @__PURE__ */ I.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: w
          }
        }, v ? v(x, m, g) : x));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.payload, o = r.layout, a = r.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: o === "horizontal" ? a : "left"
      };
      return /* @__PURE__ */ I.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(hi);
Pf(W_, "displayName", "Legend");
Pf(W_, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var mle = Hg;
function gle() {
  this.__data__ = new mle(), this.size = 0;
}
var yle = gle;
function vle(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var ble = vle;
function xle(e) {
  return this.__data__.get(e);
}
var wle = xle;
function _le(e) {
  return this.__data__.has(e);
}
var Sle = _le, Ole = Hg, Ale = k_, Ple = M_, Tle = 200;
function Cle(e, t) {
  var n = this.__data__;
  if (n instanceof Ole) {
    var r = n.__data__;
    if (!Ale || r.length < Tle - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Ple(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Ele = Cle, kle = Hg, Mle = yle, Nle = ble, $le = wle, Dle = Sle, Ile = Ele;
function Hc(e) {
  var t = this.__data__ = new kle(e);
  this.size = t.size;
}
Hc.prototype.clear = Mle;
Hc.prototype.delete = Nle;
Hc.prototype.get = $le;
Hc.prototype.has = Dle;
Hc.prototype.set = Ile;
var XL = Hc, Rle = "__lodash_hash_undefined__";
function jle(e) {
  return this.__data__.set(e, Rle), this;
}
var Lle = jle;
function Ble(e) {
  return this.__data__.has(e);
}
var Fle = Ble, Wle = M_, zle = Lle, Vle = Fle;
function Qp(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Wle(); ++t < n; )
    this.add(e[t]);
}
Qp.prototype.add = Qp.prototype.push = zle;
Qp.prototype.has = Vle;
var ZL = Qp;
function Ule(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var JL = Ule;
function Kle(e, t) {
  return e.has(t);
}
var QL = Kle, Hle = ZL, Gle = JL, Yle = QL, qle = 1, Xle = 2;
function Zle(e, t, n, r, i, o) {
  var a = n & qle, s = e.length, l = t.length;
  if (s != l && !(a && l > s))
    return !1;
  var c = o.get(e), f = o.get(t);
  if (c && f)
    return c == t && f == e;
  var d = -1, p = !0, m = n & Xle ? new Hle() : void 0;
  for (o.set(e, t), o.set(t, e); ++d < s; ) {
    var g = e[d], v = t[d];
    if (r)
      var y = a ? r(v, g, d, t, e, o) : r(g, v, d, e, t, o);
    if (y !== void 0) {
      if (y)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!Gle(t, function(x, w) {
        if (!Yle(m, w) && (g === x || i(g, x, n, r, o)))
          return m.push(w);
      })) {
        p = !1;
        break;
      }
    } else if (!(g === v || i(g, v, n, r, o))) {
      p = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), p;
}
var eB = Zle, Jle = io, Qle = Jle.Uint8Array, ece = Qle;
function tce(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var nce = tce;
function rce(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var z_ = rce, GE = Od, YE = ece, ice = E_, oce = eB, ace = nce, sce = z_, lce = 1, cce = 2, uce = "[object Boolean]", fce = "[object Date]", dce = "[object Error]", hce = "[object Map]", pce = "[object Number]", mce = "[object RegExp]", gce = "[object Set]", yce = "[object String]", vce = "[object Symbol]", bce = "[object ArrayBuffer]", xce = "[object DataView]", qE = GE ? GE.prototype : void 0, kb = qE ? qE.valueOf : void 0;
function wce(e, t, n, r, i, o, a) {
  switch (n) {
    case xce:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case bce:
      return !(e.byteLength != t.byteLength || !o(new YE(e), new YE(t)));
    case uce:
    case fce:
    case pce:
      return ice(+e, +t);
    case dce:
      return e.name == t.name && e.message == t.message;
    case mce:
    case yce:
      return e == t + "";
    case hce:
      var s = ace;
    case gce:
      var l = r & lce;
      if (s || (s = sce), e.size != t.size && !l)
        return !1;
      var c = a.get(e);
      if (c)
        return c == t;
      r |= cce, a.set(e, t);
      var f = oce(s(e), s(t), r, i, o, a);
      return a.delete(e), f;
    case vce:
      if (kb)
        return kb.call(e) == kb.call(t);
  }
  return !1;
}
var _ce = wce;
function Sce(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var tB = Sce, Oce = tB, Ace = Ar;
function Pce(e, t, n) {
  var r = t(e);
  return Ace(e) ? r : Oce(r, n(e));
}
var Tce = Pce;
function Cce(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
var Ece = Cce;
function kce() {
  return [];
}
var Mce = kce, Nce = Ece, $ce = Mce, Dce = Object.prototype, Ice = Dce.propertyIsEnumerable, XE = Object.getOwnPropertySymbols, Rce = XE ? function(e) {
  return e == null ? [] : (e = Object(e), Nce(XE(e), function(t) {
    return Ice.call(e, t);
  }));
} : $ce, jce = Rce;
function Lce(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Bce = Lce, Fce = Jo, Wce = Qo, zce = "[object Arguments]";
function Vce(e) {
  return Wce(e) && Fce(e) == zce;
}
var Uce = Vce, ZE = Uce, Kce = Qo, nB = Object.prototype, Hce = nB.hasOwnProperty, Gce = nB.propertyIsEnumerable, Yce = ZE(/* @__PURE__ */ function() {
  return arguments;
}()) ? ZE : function(e) {
  return Kce(e) && Hce.call(e, "callee") && !Gce.call(e, "callee");
}, V_ = Yce, em = { exports: {} };
function qce() {
  return !1;
}
var Xce = qce;
em.exports;
(function(e, t) {
  var n = io, r = Xce, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  e.exports = c;
})(em, em.exports);
var rB = em.exports, Zce = 9007199254740991, Jce = /^(?:0|[1-9]\d*)$/;
function Qce(e, t) {
  var n = typeof e;
  return t = t ?? Zce, !!t && (n == "number" || n != "symbol" && Jce.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var U_ = Qce, eue = 9007199254740991;
function tue(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= eue;
}
var K_ = tue, nue = Jo, rue = K_, iue = Qo, oue = "[object Arguments]", aue = "[object Array]", sue = "[object Boolean]", lue = "[object Date]", cue = "[object Error]", uue = "[object Function]", fue = "[object Map]", due = "[object Number]", hue = "[object Object]", pue = "[object RegExp]", mue = "[object Set]", gue = "[object String]", yue = "[object WeakMap]", vue = "[object ArrayBuffer]", bue = "[object DataView]", xue = "[object Float32Array]", wue = "[object Float64Array]", _ue = "[object Int8Array]", Sue = "[object Int16Array]", Oue = "[object Int32Array]", Aue = "[object Uint8Array]", Pue = "[object Uint8ClampedArray]", Tue = "[object Uint16Array]", Cue = "[object Uint32Array]", zt = {};
zt[xue] = zt[wue] = zt[_ue] = zt[Sue] = zt[Oue] = zt[Aue] = zt[Pue] = zt[Tue] = zt[Cue] = !0;
zt[oue] = zt[aue] = zt[vue] = zt[sue] = zt[bue] = zt[lue] = zt[cue] = zt[uue] = zt[fue] = zt[due] = zt[hue] = zt[pue] = zt[mue] = zt[gue] = zt[yue] = !1;
function Eue(e) {
  return iue(e) && rue(e.length) && !!zt[nue(e)];
}
var kue = Eue;
function Mue(e) {
  return function(t) {
    return e(t);
  };
}
var iB = Mue, tm = { exports: {} };
tm.exports;
(function(e, t) {
  var n = hL, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(tm, tm.exports);
var Nue = tm.exports, $ue = kue, Due = iB, JE = Nue, QE = JE && JE.isTypedArray, Iue = QE ? Due(QE) : $ue, oB = Iue, Rue = Bce, jue = V_, Lue = Ar, Bue = rB, Fue = U_, Wue = oB, zue = Object.prototype, Vue = zue.hasOwnProperty;
function Uue(e, t) {
  var n = Lue(e), r = !n && jue(e), i = !n && !r && Bue(e), o = !n && !r && !i && Wue(e), a = n || r || i || o, s = a ? Rue(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || Vue.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Fue(c, l))) && s.push(c);
  return s;
}
var Kue = Uue, Hue = Object.prototype;
function Gue(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Hue;
  return e === n;
}
var Yue = Gue;
function que(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var aB = que, Xue = aB, Zue = Xue(Object.keys, Object), Jue = Zue, Que = Yue, efe = Jue, tfe = Object.prototype, nfe = tfe.hasOwnProperty;
function rfe(e) {
  if (!Que(e))
    return efe(e);
  var t = [];
  for (var n in Object(e))
    nfe.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var ife = rfe, ofe = C_, afe = K_;
function sfe(e) {
  return e != null && afe(e.length) && !ofe(e);
}
var Pd = sfe, lfe = Kue, cfe = ife, ufe = Pd;
function ffe(e) {
  return ufe(e) ? lfe(e) : cfe(e);
}
var Qg = ffe, dfe = Tce, hfe = jce, pfe = Qg;
function mfe(e) {
  return dfe(e, pfe, hfe);
}
var gfe = mfe, ek = gfe, yfe = 1, vfe = Object.prototype, bfe = vfe.hasOwnProperty;
function xfe(e, t, n, r, i, o) {
  var a = n & yfe, s = ek(e), l = s.length, c = ek(t), f = c.length;
  if (l != f && !a)
    return !1;
  for (var d = l; d--; ) {
    var p = s[d];
    if (!(a ? p in t : bfe.call(t, p)))
      return !1;
  }
  var m = o.get(e), g = o.get(t);
  if (m && g)
    return m == t && g == e;
  var v = !0;
  o.set(e, t), o.set(t, e);
  for (var y = a; ++d < l; ) {
    p = s[d];
    var x = e[p], w = t[p];
    if (r)
      var S = a ? r(w, x, p, t, e, o) : r(x, w, p, e, t, o);
    if (!(S === void 0 ? x === w || i(x, w, n, r, o) : S)) {
      v = !1;
      break;
    }
    y || (y = p == "constructor");
  }
  if (v && !y) {
    var A = e.constructor, _ = t.constructor;
    A != _ && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof _ == "function" && _ instanceof _) && (v = !1);
  }
  return o.delete(e), o.delete(t), v;
}
var wfe = xfe, _fe = Js, Sfe = io, Ofe = _fe(Sfe, "DataView"), Afe = Ofe, Pfe = Js, Tfe = io, Cfe = Pfe(Tfe, "Promise"), Efe = Cfe, kfe = Js, Mfe = io, Nfe = kfe(Mfe, "Set"), sB = Nfe, $fe = Js, Dfe = io, Ife = $fe(Dfe, "WeakMap"), Rfe = Ife, Cx = Afe, Ex = k_, kx = Efe, Mx = sB, Nx = Rfe, lB = Jo, Gc = mL, tk = "[object Map]", jfe = "[object Object]", nk = "[object Promise]", rk = "[object Set]", ik = "[object WeakMap]", ok = "[object DataView]", Lfe = Gc(Cx), Bfe = Gc(Ex), Ffe = Gc(kx), Wfe = Gc(Mx), zfe = Gc(Nx), ys = lB;
(Cx && ys(new Cx(new ArrayBuffer(1))) != ok || Ex && ys(new Ex()) != tk || kx && ys(kx.resolve()) != nk || Mx && ys(new Mx()) != rk || Nx && ys(new Nx()) != ik) && (ys = function(e) {
  var t = lB(e), n = t == jfe ? e.constructor : void 0, r = n ? Gc(n) : "";
  if (r)
    switch (r) {
      case Lfe:
        return ok;
      case Bfe:
        return tk;
      case Ffe:
        return nk;
      case Wfe:
        return rk;
      case zfe:
        return ik;
    }
  return t;
});
var Vfe = ys, Mb = XL, Ufe = eB, Kfe = _ce, Hfe = wfe, ak = Vfe, sk = Ar, lk = rB, Gfe = oB, Yfe = 1, ck = "[object Arguments]", uk = "[object Array]", Wh = "[object Object]", qfe = Object.prototype, fk = qfe.hasOwnProperty;
function Xfe(e, t, n, r, i, o) {
  var a = sk(e), s = sk(t), l = a ? uk : ak(e), c = s ? uk : ak(t);
  l = l == ck ? Wh : l, c = c == ck ? Wh : c;
  var f = l == Wh, d = c == Wh, p = l == c;
  if (p && lk(e)) {
    if (!lk(t))
      return !1;
    a = !0, f = !1;
  }
  if (p && !f)
    return o || (o = new Mb()), a || Gfe(e) ? Ufe(e, t, n, r, i, o) : Kfe(e, t, l, n, r, i, o);
  if (!(n & Yfe)) {
    var m = f && fk.call(e, "__wrapped__"), g = d && fk.call(t, "__wrapped__");
    if (m || g) {
      var v = m ? e.value() : e, y = g ? t.value() : t;
      return o || (o = new Mb()), i(v, y, n, r, o);
    }
  }
  return p ? (o || (o = new Mb()), Hfe(e, t, n, r, i, o)) : !1;
}
var Zfe = Xfe, Jfe = Zfe, dk = Qo;
function cB(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !dk(e) && !dk(t) ? e !== e && t !== t : Jfe(e, t, n, r, cB, i);
}
var H_ = cB, Qfe = XL, ede = H_, tde = 1, nde = 2;
function rde(e, t, n, r) {
  var i = n.length, o = i, a = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var l = s[0], c = e[l], f = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var d = new Qfe();
      if (r)
        var p = r(c, f, l, e, t, d);
      if (!(p === void 0 ? ede(f, c, tde | nde, r, d) : p))
        return !1;
    }
  }
  return !0;
}
var ide = rde, ode = Ha;
function ade(e) {
  return e === e && !ode(e);
}
var uB = ade, sde = uB, lde = Qg;
function cde(e) {
  for (var t = lde(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, sde(i)];
  }
  return t;
}
var ude = cde;
function fde(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var fB = fde, dde = ide, hde = ude, pde = fB;
function mde(e) {
  var t = hde(e);
  return t.length == 1 && t[0][2] ? pde(t[0][0], t[0][1]) : function(n) {
    return n === e || dde(n, e, t);
  };
}
var gde = mde;
function yde(e, t) {
  return e != null && t in Object(e);
}
var vde = yde, bde = xL, xde = V_, wde = Ar, _de = U_, Sde = K_, Ode = Yg;
function Ade(e, t, n) {
  t = bde(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var a = Ode(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && Sde(i) && _de(a, i) && (wde(e) || xde(e)));
}
var Pde = Ade, Tde = vde, Cde = Pde;
function Ede(e, t) {
  return e != null && Cde(e, t, Tde);
}
var kde = Ede, Mde = H_, Nde = wL, $de = kde, Dde = T_, Ide = uB, Rde = fB, jde = Yg, Lde = 1, Bde = 2;
function Fde(e, t) {
  return Dde(e) && Ide(t) ? Rde(jde(e), t) : function(n) {
    var r = Nde(n, e);
    return r === void 0 && r === t ? $de(n, e) : Mde(t, r, Lde | Bde);
  };
}
var Wde = Fde;
function zde(e) {
  return e;
}
var Yc = zde;
function Vde(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Ude = Vde, Kde = D_;
function Hde(e) {
  return function(t) {
    return Kde(t, e);
  };
}
var Gde = Hde, Yde = Ude, qde = Gde, Xde = T_, Zde = Yg;
function Jde(e) {
  return Xde(e) ? Yde(Zde(e)) : qde(e);
}
var Qde = Jde, ehe = gde, the = Wde, nhe = Yc, rhe = Ar, ihe = Qde;
function ohe(e) {
  return typeof e == "function" ? e : e == null ? nhe : typeof e == "object" ? rhe(e) ? the(e[0], e[1]) : ehe(e) : ihe(e);
}
var oo = ohe;
function ahe(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var dB = ahe;
function she(e) {
  return e !== e;
}
var lhe = she;
function che(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
var uhe = che, fhe = dB, dhe = lhe, hhe = uhe;
function phe(e, t, n) {
  return t === t ? hhe(e, t, n) : fhe(e, dhe, n);
}
var mhe = phe, ghe = mhe;
function yhe(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && ghe(e, t, 0) > -1;
}
var vhe = yhe;
function bhe(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var xhe = bhe;
function whe() {
}
var _he = whe, Nb = sB, She = _he, Ohe = z_, Ahe = 1 / 0, Phe = Nb && 1 / Ohe(new Nb([, -0]))[1] == Ahe ? function(e) {
  return new Nb(e);
} : She, The = Phe, Che = ZL, Ehe = vhe, khe = xhe, Mhe = QL, Nhe = The, $he = z_, Dhe = 200;
function Ihe(e, t, n) {
  var r = -1, i = Ehe, o = e.length, a = !0, s = [], l = s;
  if (n)
    a = !1, i = khe;
  else if (o >= Dhe) {
    var c = t ? null : Nhe(e);
    if (c)
      return $he(c);
    a = !1, i = Mhe, l = new Che();
  } else
    l = t ? [] : s;
  e:
    for (; ++r < o; ) {
      var f = e[r], d = t ? t(f) : f;
      if (f = n || f !== 0 ? f : 0, a && d === d) {
        for (var p = l.length; p--; )
          if (l[p] === d)
            continue e;
        t && l.push(d), s.push(f);
      } else i(l, d, n) || (l !== s && l.push(d), s.push(f));
    }
  return s;
}
var Rhe = Ihe, jhe = oo, Lhe = Rhe;
function Bhe(e, t) {
  return e && e.length ? Lhe(e, jhe(t)) : [];
}
var Fhe = Bhe;
const hk = /* @__PURE__ */ Et(Fhe);
function hB(e, t, n) {
  return t === !0 ? hk(e, n) : ze(t) ? hk(e, t) : e;
}
function oc(e) {
  "@babel/helpers - typeof";
  return oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oc(e);
}
var Whe = ["ref"];
function pk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pk(Object(n), !0).forEach(function(r) {
      ey(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zhe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mk(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mB(r.key), r);
  }
}
function Vhe(e, t, n) {
  return t && mk(e.prototype, t), n && mk(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Uhe(e, t, n) {
  return t = nm(t), Khe(e, pB() ? Reflect.construct(t, n || [], nm(e).constructor) : t.apply(e, n));
}
function Khe(e, t) {
  if (t && (oc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Hhe(e);
}
function Hhe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pB() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pB = function() {
    return !!e;
  })();
}
function nm(e) {
  return nm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, nm(e);
}
function Ghe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $x(e, t);
}
function $x(e, t) {
  return $x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, $x(e, t);
}
function ey(e, t, n) {
  return t = mB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mB(e) {
  var t = Yhe(e, "string");
  return oc(t) == "symbol" ? t : t + "";
}
function Yhe(e, t) {
  if (oc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (oc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qhe(e, t) {
  if (e == null) return {};
  var n = Xhe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Xhe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Zhe(e) {
  return e.value;
}
function Jhe(e, t) {
  if (/* @__PURE__ */ I.isValidElement(e))
    return /* @__PURE__ */ I.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ I.createElement(e, t);
  t.ref;
  var n = qhe(t, Whe);
  return /* @__PURE__ */ I.createElement(W_, n);
}
var gk = 1, Ro = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    zhe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = Uhe(this, t, [].concat(i)), ey(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return Ghe(t, e), Vhe(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > gk || Math.abs(i.height - this.lastBoundingBox.height) > gk) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, r && r(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? bo({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var i = this.props, o = i.layout, a = i.align, s = i.verticalAlign, l = i.margin, c = i.chartWidth, f = i.chartHeight, d, p;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (a === "center" && o === "vertical") {
          var m = this.getBBoxSnapshot();
          d = {
            left: ((c || 0) - m.width) / 2
          };
        } else
          d = a === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var g = this.getBBoxSnapshot();
          p = {
            top: ((f || 0) - g.height) / 2
          };
        } else
          p = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return bo(bo({}, d), p);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.content, a = i.width, s = i.height, l = i.wrapperStyle, c = i.payloadUniqBy, f = i.payload, d = bo(bo({
        position: "absolute",
        width: a || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ I.createElement("div", {
        className: "recharts-legend-wrapper",
        style: d,
        ref: function(m) {
          r.wrapperNode = m;
        }
      }, Jhe(o, bo(bo({}, this.props), {}, {
        payload: hB(f, c, Zhe)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, i) {
      var o = bo(bo({}, this.defaultProps), r.props), a = o.layout;
      return a === "vertical" && be(r.props.height) ? {
        height: r.props.height
      } : a === "horizontal" ? {
        width: r.props.width || i
      } : null;
    }
  }]);
}(hi);
ey(Ro, "displayName", "Legend");
ey(Ro, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var yk = Od, Qhe = V_, epe = Ar, vk = yk ? yk.isConcatSpreadable : void 0;
function tpe(e) {
  return epe(e) || Qhe(e) || !!(vk && e && e[vk]);
}
var npe = tpe, rpe = tB, ipe = npe;
function gB(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = ipe), i || (i = []); ++o < a; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? gB(s, t - 1, n, r, i) : rpe(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var yB = gB;
function ope(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var l = a[e ? s : ++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return t;
  };
}
var ape = ope, spe = ape, lpe = spe(), cpe = lpe, upe = cpe, fpe = Qg;
function dpe(e, t) {
  return e && upe(e, t, fpe);
}
var vB = dpe, hpe = Pd;
function ppe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!hpe(n))
      return e(n, r);
    for (var i = n.length, o = t ? i : -1, a = Object(n); (t ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var mpe = ppe, gpe = vB, ype = mpe, vpe = ype(gpe), G_ = vpe, bpe = G_, xpe = Pd;
function wpe(e, t) {
  var n = -1, r = xpe(e) ? Array(e.length) : [];
  return bpe(e, function(i, o, a) {
    r[++n] = t(i, o, a);
  }), r;
}
var bB = wpe;
function _pe(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var Spe = _pe, bk = Fc;
function Ope(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e === e, o = bk(e), a = t !== void 0, s = t === null, l = t === t, c = bk(t);
    if (!s && !c && !o && e > t || o && a && l && !s && !c || r && a && l || !n && l || !i)
      return 1;
    if (!r && !o && !c && e < t || c && n && i && !r && !o || s && n && i || !a && i || !l)
      return -1;
  }
  return 0;
}
var Ape = Ope, Ppe = Ape;
function Tpe(e, t, n) {
  for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a; ) {
    var l = Ppe(i[r], o[r]);
    if (l) {
      if (r >= s)
        return l;
      var c = n[r];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var Cpe = Tpe, $b = $_, Epe = D_, kpe = oo, Mpe = bB, Npe = Spe, $pe = iB, Dpe = Cpe, Ipe = Yc, Rpe = Ar;
function jpe(e, t, n) {
  t.length ? t = $b(t, function(o) {
    return Rpe(o) ? function(a) {
      return Epe(a, o.length === 1 ? o[0] : o);
    } : o;
  }) : t = [Ipe];
  var r = -1;
  t = $b(t, $pe(kpe));
  var i = Mpe(e, function(o, a, s) {
    var l = $b(t, function(c) {
      return c(o);
    });
    return { criteria: l, index: ++r, value: o };
  });
  return Npe(i, function(o, a) {
    return Dpe(o, a, n);
  });
}
var Lpe = jpe;
function Bpe(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Fpe = Bpe, Wpe = Fpe, xk = Math.max;
function zpe(e, t, n) {
  return t = xk(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = xk(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), Wpe(e, this, s);
  };
}
var Vpe = zpe;
function Upe(e) {
  return function() {
    return e;
  };
}
var Kpe = Upe, Hpe = Js, Gpe = function() {
  try {
    var e = Hpe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), xB = Gpe, Ype = Kpe, wk = xB, qpe = Yc, Xpe = wk ? function(e, t) {
  return wk(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ype(t),
    writable: !0
  });
} : qpe, Zpe = Xpe, Jpe = 800, Qpe = 16, eme = Date.now;
function tme(e) {
  var t = 0, n = 0;
  return function() {
    var r = eme(), i = Qpe - (r - n);
    if (n = r, i > 0) {
      if (++t >= Jpe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var nme = tme, rme = Zpe, ime = nme, ome = ime(rme), ame = ome, sme = Yc, lme = Vpe, cme = ame;
function ume(e, t) {
  return cme(lme(e, t, sme), e + "");
}
var fme = ume, dme = E_, hme = Pd, pme = U_, mme = Ha;
function gme(e, t, n) {
  if (!mme(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? hme(n) && pme(t, n.length) : r == "string" && t in n) ? dme(n[t], e) : !1;
}
var ty = gme, yme = yB, vme = Lpe, bme = fme, _k = ty, xme = bme(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && _k(e, t[0], t[1]) ? t = [] : n > 2 && _k(t[0], t[1], t[2]) && (t = [t[0]]), vme(e, yme(t, 1), []);
}), wme = xme;
const Y_ = /* @__PURE__ */ Et(wme);
function Tf(e) {
  "@babel/helpers - typeof";
  return Tf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tf(e);
}
function Dx() {
  return Dx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dx.apply(this, arguments);
}
function _me(e, t) {
  return Pme(e) || Ame(e, t) || Ome(e, t) || Sme();
}
function Sme() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ome(e, t) {
  if (e) {
    if (typeof e == "string") return Sk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sk(e, t);
  }
}
function Sk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ame(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function Pme(e) {
  if (Array.isArray(e)) return e;
}
function Ok(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Db(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ok(Object(n), !0).forEach(function(r) {
      Tme(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ok(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Tme(e, t, n) {
  return t = Cme(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Cme(e) {
  var t = Eme(e, "string");
  return Tf(t) == "symbol" ? t : t + "";
}
function Eme(e, t) {
  if (Tf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Tf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kme(e) {
  return Array.isArray(e) && Sn(e[0]) && Sn(e[1]) ? e.join(" ~ ") : e;
}
var Mme = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, i = t.contentStyle, o = i === void 0 ? {} : i, a = t.itemStyle, s = a === void 0 ? {} : a, l = t.labelStyle, c = l === void 0 ? {} : l, f = t.payload, d = t.formatter, p = t.itemSorter, m = t.wrapperClassName, g = t.labelClassName, v = t.label, y = t.labelFormatter, x = t.accessibilityLayer, w = x === void 0 ? !1 : x, S = function() {
    if (f && f.length) {
      var $ = {
        padding: 0,
        margin: 0
      }, B = (p ? Y_(f, p) : f).map(function(L, F) {
        if (L.type === "none")
          return null;
        var W = Db({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: L.color || "#000"
        }, s), z = L.formatter || d || kme, G = L.value, V = L.name, U = G, Y = V;
        if (z && U != null && Y != null) {
          var te = z(G, V, L, F, f);
          if (Array.isArray(te)) {
            var ne = _me(te, 2);
            U = ne[0], Y = ne[1];
          } else
            U = te;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ I.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(F),
            style: W
          }, Sn(Y) ? /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, Y) : null, Sn(Y) ? /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, U), /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, L.unit || ""))
        );
      });
      return /* @__PURE__ */ I.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: $
      }, B);
    }
    return null;
  }, A = Db({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, o), _ = Db({
    margin: 0
  }, c), O = !Ue(v), T = O ? v : "", C = Ye("recharts-default-tooltip", m), k = Ye("recharts-tooltip-label", g);
  O && y && f !== void 0 && f !== null && (T = y(v, f));
  var D = w ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ I.createElement("div", Dx({
    className: C,
    style: A
  }, D), /* @__PURE__ */ I.createElement("p", {
    className: k,
    style: _
  }, /* @__PURE__ */ I.isValidElement(T) ? T : "".concat(T)), S());
};
function Cf(e) {
  "@babel/helpers - typeof";
  return Cf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cf(e);
}
function zh(e, t, n) {
  return t = Nme(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nme(e) {
  var t = $me(e, "string");
  return Cf(t) == "symbol" ? t : t + "";
}
function $me(e, t) {
  if (Cf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Cf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Pu = "recharts-tooltip-wrapper", Dme = {
  visibility: "hidden"
};
function Ime(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return Ye(Pu, zh(zh(zh(zh({}, "".concat(Pu, "-right"), be(n) && t && be(t.x) && n >= t.x), "".concat(Pu, "-left"), be(n) && t && be(t.x) && n < t.x), "".concat(Pu, "-bottom"), be(r) && t && be(t.y) && r >= t.y), "".concat(Pu, "-top"), be(r) && t && be(t.y) && r < t.y));
}
function Ak(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, i = e.offsetTopLeft, o = e.position, a = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, c = e.viewBoxDimension;
  if (o && be(o[r]))
    return o[r];
  var f = n[r] - s - i, d = n[r] + i;
  if (t[r])
    return a[r] ? f : d;
  if (a[r]) {
    var p = f, m = l[r];
    return p < m ? Math.max(d, l[r]) : Math.max(f, l[r]);
  }
  var g = d + s, v = l[r] + c;
  return g > v ? Math.max(f, l[r]) : Math.max(d, l[r]);
}
function Rme(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function jme(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, i = e.position, o = e.reverseDirection, a = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, c, f, d;
  return a.height > 0 && a.width > 0 && n ? (f = Ak({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), d = Ak({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = Rme({
    translateX: f,
    translateY: d,
    useTranslate3d: s
  })) : c = Dme, {
    cssProperties: c,
    cssClasses: Ime({
      translateX: f,
      translateY: d,
      coordinate: n
    })
  };
}
function ac(e) {
  "@babel/helpers - typeof";
  return ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ac(e);
}
function Pk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pk(Object(n), !0).forEach(function(r) {
      Rx(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Lme(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Bme(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _B(r.key), r);
  }
}
function Fme(e, t, n) {
  return t && Bme(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Wme(e, t, n) {
  return t = rm(t), zme(e, wB() ? Reflect.construct(t, n || [], rm(e).constructor) : t.apply(e, n));
}
function zme(e, t) {
  if (t && (ac(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Vme(e);
}
function Vme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wB() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wB = function() {
    return !!e;
  })();
}
function rm(e) {
  return rm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, rm(e);
}
function Ume(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ix(e, t);
}
function Ix(e, t) {
  return Ix = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ix(e, t);
}
function Rx(e, t, n) {
  return t = _B(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _B(e) {
  var t = Kme(e, "string");
  return ac(t) == "symbol" ? t : t + "";
}
function Kme(e, t) {
  if (ac(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ac(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ck = 1, Hme = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    Lme(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = Wme(this, t, [].concat(i)), Rx(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Rx(n, "handleKeyDown", function(a) {
      if (a.key === "Escape") {
        var s, l, c, f;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = n.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (c = (f = n.props.coordinate) === null || f === void 0 ? void 0 : f.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), n;
  }
  return Ume(t, e), Fme(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > Ck || Math.abs(r.height - this.state.lastBoundingBox.height) > Ck) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, l = i.animationEasing, c = i.children, f = i.coordinate, d = i.hasPayload, p = i.isAnimationActive, m = i.offset, g = i.position, v = i.reverseDirection, y = i.useTranslate3d, x = i.viewBox, w = i.wrapperStyle, S = jme({
        allowEscapeViewBox: a,
        coordinate: f,
        offsetTopLeft: m,
        position: g,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: y,
        viewBox: x
      }), A = S.cssClasses, _ = S.cssProperties, O = Tk(Tk({
        transition: p && o ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, _), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && o && d ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, w);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ I.createElement("div", {
          tabIndex: -1,
          className: A,
          style: O,
          ref: function(C) {
            r.wrapperNode = C;
          }
        }, c)
      );
    }
  }]);
}(hi), Gme = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Mi = {
  isSsr: Gme(),
  get: function(t) {
    return Mi[t];
  },
  set: function(t, n) {
    if (typeof t == "string")
      Mi[t] = n;
    else {
      var r = Object.keys(t);
      r && r.length && r.forEach(function(i) {
        Mi[i] = t[i];
      });
    }
  }
};
function sc(e) {
  "@babel/helpers - typeof";
  return sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sc(e);
}
function Ek(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ek(Object(n), !0).forEach(function(r) {
      q_(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ek(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Yme(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qme(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, OB(r.key), r);
  }
}
function Xme(e, t, n) {
  return t && qme(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Zme(e, t, n) {
  return t = im(t), Jme(e, SB() ? Reflect.construct(t, n || [], im(e).constructor) : t.apply(e, n));
}
function Jme(e, t) {
  if (t && (sc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qme(e);
}
function Qme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function SB() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (SB = function() {
    return !!e;
  })();
}
function im(e) {
  return im = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, im(e);
}
function ege(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jx(e, t);
}
function jx(e, t) {
  return jx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, jx(e, t);
}
function q_(e, t, n) {
  return t = OB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OB(e) {
  var t = tge(e, "string");
  return sc(t) == "symbol" ? t : t + "";
}
function tge(e, t) {
  if (sc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (sc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function nge(e) {
  return e.dataKey;
}
function rge(e, t) {
  return /* @__PURE__ */ I.isValidElement(e) ? /* @__PURE__ */ I.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ I.createElement(e, t) : /* @__PURE__ */ I.createElement(Mme, t);
}
var jr = /* @__PURE__ */ function(e) {
  function t() {
    return Yme(this, t), Zme(this, t, arguments);
  }
  return ege(t, e), Xme(t, [{
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, l = i.animationEasing, c = i.content, f = i.coordinate, d = i.filterNull, p = i.isAnimationActive, m = i.offset, g = i.payload, v = i.payloadUniqBy, y = i.position, x = i.reverseDirection, w = i.useTranslate3d, S = i.viewBox, A = i.wrapperStyle, _ = g ?? [];
      d && _.length && (_ = hB(g.filter(function(T) {
        return T.value != null && (T.hide !== !0 || r.props.includeHidden);
      }), v, nge));
      var O = _.length > 0;
      return /* @__PURE__ */ I.createElement(Hme, {
        allowEscapeViewBox: a,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: p,
        active: o,
        coordinate: f,
        hasPayload: O,
        offset: m,
        position: y,
        reverseDirection: x,
        useTranslate3d: w,
        viewBox: S,
        wrapperStyle: A
      }, rge(c, kk(kk({}, this.props), {}, {
        payload: _
      })));
    }
  }]);
}(hi);
q_(jr, "displayName", "Tooltip");
q_(jr, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Mi.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var ige = io, oge = function() {
  return ige.Date.now();
}, age = oge, sge = /\s/;
function lge(e) {
  for (var t = e.length; t-- && sge.test(e.charAt(t)); )
    ;
  return t;
}
var cge = lge, uge = cge, fge = /^\s+/;
function dge(e) {
  return e && e.slice(0, uge(e) + 1).replace(fge, "");
}
var hge = dge, pge = hge, Mk = Ha, mge = Fc, Nk = NaN, gge = /^[-+]0x[0-9a-f]+$/i, yge = /^0b[01]+$/i, vge = /^0o[0-7]+$/i, bge = parseInt;
function xge(e) {
  if (typeof e == "number")
    return e;
  if (mge(e))
    return Nk;
  if (Mk(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Mk(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = pge(e);
  var n = yge.test(e);
  return n || vge.test(e) ? bge(e.slice(2), n ? 2 : 8) : gge.test(e) ? Nk : +e;
}
var AB = xge, wge = Ha, Ib = age, $k = AB, _ge = "Expected a function", Sge = Math.max, Oge = Math.min;
function Age(e, t, n) {
  var r, i, o, a, s, l, c = 0, f = !1, d = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(_ge);
  t = $k(t) || 0, wge(n) && (f = !!n.leading, d = "maxWait" in n, o = d ? Sge($k(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p);
  function m(O) {
    var T = r, C = i;
    return r = i = void 0, c = O, a = e.apply(C, T), a;
  }
  function g(O) {
    return c = O, s = setTimeout(x, t), f ? m(O) : a;
  }
  function v(O) {
    var T = O - l, C = O - c, k = t - T;
    return d ? Oge(k, o - C) : k;
  }
  function y(O) {
    var T = O - l, C = O - c;
    return l === void 0 || T >= t || T < 0 || d && C >= o;
  }
  function x() {
    var O = Ib();
    if (y(O))
      return w(O);
    s = setTimeout(x, v(O));
  }
  function w(O) {
    return s = void 0, p && r ? m(O) : (r = i = void 0, a);
  }
  function S() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = i = s = void 0;
  }
  function A() {
    return s === void 0 ? a : w(Ib());
  }
  function _() {
    var O = Ib(), T = y(O);
    if (r = arguments, i = this, l = O, T) {
      if (s === void 0)
        return g(l);
      if (d)
        return clearTimeout(s), s = setTimeout(x, t), m(l);
    }
    return s === void 0 && (s = setTimeout(x, t)), a;
  }
  return _.cancel = S, _.flush = A, _;
}
var Pge = Age, Tge = Pge, Cge = Ha, Ege = "Expected a function";
function kge(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Ege);
  return Cge(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Tge(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
var Mge = kge;
const PB = /* @__PURE__ */ Et(Mge);
function Ef(e) {
  "@babel/helpers - typeof";
  return Ef = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ef(e);
}
function Dk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dk(Object(n), !0).forEach(function(r) {
      Nge(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nge(e, t, n) {
  return t = $ge(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $ge(e) {
  var t = Dge(e, "string");
  return Ef(t) == "symbol" ? t : t + "";
}
function Dge(e, t) {
  if (Ef(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ef(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ige(e, t) {
  return Bge(e) || Lge(e, t) || jge(e, t) || Rge();
}
function Rge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jge(e, t) {
  if (e) {
    if (typeof e == "string") return Ik(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ik(e, t);
  }
}
function Ik(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Lge(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function Bge(e) {
  if (Array.isArray(e)) return e;
}
var TB = /* @__PURE__ */ $t(function(e, t) {
  var n = e.aspect, r = e.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, o = e.width, a = o === void 0 ? "100%" : o, s = e.height, l = s === void 0 ? "100%" : s, c = e.minWidth, f = c === void 0 ? 0 : c, d = e.minHeight, p = e.maxHeight, m = e.children, g = e.debounce, v = g === void 0 ? 0 : g, y = e.id, x = e.className, w = e.onResize, S = e.style, A = S === void 0 ? {} : S, _ = ft(null), O = ft();
  O.current = w, Y8(t, function() {
    return Object.defineProperty(_.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), _.current;
      },
      configurable: !0
    });
  });
  var T = Me({
    containerWidth: i.width,
    containerHeight: i.height
  }), C = Ige(T, 2), k = C[0], D = C[1], N = Je(function(B, L) {
    D(function(F) {
      var W = Math.round(B), z = Math.round(L);
      return F.containerWidth === W && F.containerHeight === z ? F : {
        containerWidth: W,
        containerHeight: z
      };
    });
  }, []);
  Qe(function() {
    var B = function(V) {
      var U, Y = V[0].contentRect, te = Y.width, ne = Y.height;
      N(te, ne), (U = O.current) === null || U === void 0 || U.call(O, te, ne);
    };
    v > 0 && (B = PB(B, v, {
      trailing: !0,
      leading: !1
    }));
    var L = new ResizeObserver(B), F = _.current.getBoundingClientRect(), W = F.width, z = F.height;
    return N(W, z), L.observe(_.current), function() {
      L.disconnect();
    };
  }, [N, v]);
  var $ = Le(function() {
    var B = k.containerWidth, L = k.containerHeight;
    if (B < 0 || L < 0)
      return null;
    ki(_s(a) || _s(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, a, l), ki(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var F = _s(a) ? B : a, W = _s(l) ? L : l;
    n && n > 0 && (F ? W = F / n : W && (F = W * n), p && W > p && (W = p)), ki(F > 0 || W > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, F, W, a, l, f, d, n);
    var z = !Array.isArray(m) && Io(m.type).endsWith("Chart");
    return I.Children.map(m, function(G) {
      return /* @__PURE__ */ I.isValidElement(G) ? /* @__PURE__ */ _t(G, Vh({
        width: F,
        height: W
      }, z ? {
        style: Vh({
          height: "100%",
          width: "100%",
          maxHeight: W,
          maxWidth: F
        }, G.props.style)
      } : {})) : G;
    });
  }, [n, m, l, p, d, f, k, a]);
  return /* @__PURE__ */ I.createElement("div", {
    id: y ? "".concat(y) : void 0,
    className: Ye("recharts-responsive-container", x),
    style: Vh(Vh({}, A), {}, {
      width: a,
      height: l,
      minWidth: f,
      minHeight: d,
      maxHeight: p
    }),
    ref: _
  }, $);
}), X_ = function(t) {
  return null;
};
X_.displayName = "Cell";
function kf(e) {
  "@babel/helpers - typeof";
  return kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kf(e);
}
function Rk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rk(Object(n), !0).forEach(function(r) {
      Fge(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Fge(e, t, n) {
  return t = Wge(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wge(e) {
  var t = zge(e, "string");
  return kf(t) == "symbol" ? t : t + "";
}
function zge(e, t) {
  if (kf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (kf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wl = {
  widthCache: {},
  cacheCount: 0
}, Vge = 2e3, Uge = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, jk = "recharts_measurement_span";
function Kge(e) {
  var t = Lx({}, e);
  return Object.keys(t).forEach(function(n) {
    t[n] || delete t[n];
  }), t;
}
var Qu = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Mi.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = Kge(n), i = JSON.stringify({
    text: t,
    copyStyle: r
  });
  if (wl.widthCache[i])
    return wl.widthCache[i];
  try {
    var o = document.getElementById(jk);
    o || (o = document.createElement("span"), o.setAttribute("id", jk), o.setAttribute("aria-hidden", "true"), document.body.appendChild(o));
    var a = Lx(Lx({}, Uge), r);
    Object.assign(o.style, a), o.textContent = "".concat(t);
    var s = o.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return wl.widthCache[i] = l, ++wl.cacheCount > Vge && (wl.cacheCount = 0, wl.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, Hge = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Mf(e) {
  "@babel/helpers - typeof";
  return Mf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mf(e);
}
function om(e, t) {
  return Xge(e) || qge(e, t) || Yge(e, t) || Gge();
}
function Gge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yge(e, t) {
  if (e) {
    if (typeof e == "string") return Lk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Lk(e, t);
  }
}
function Lk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function qge(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function Xge(e) {
  if (Array.isArray(e)) return e;
}
function Zge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Bk(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Qge(r.key), r);
  }
}
function Jge(e, t, n) {
  return t && Bk(e.prototype, t), n && Bk(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Qge(e) {
  var t = eye(e, "string");
  return Mf(t) == "symbol" ? t : t + "";
}
function eye(e, t) {
  if (Mf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Mf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Fk = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Wk = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, tye = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, nye = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, CB = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, rye = Object.keys(CB), Il = "NaN";
function iye(e, t) {
  return e * CB[t];
}
var Uh = /* @__PURE__ */ function() {
  function e(t, n) {
    Zge(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !tye.test(n) && (this.num = NaN, this.unit = ""), rye.includes(n) && (this.num = iye(t, n), this.unit = "px");
  }
  return Jge(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, i = (r = nye.exec(n)) !== null && r !== void 0 ? r : [], o = om(i, 3), a = o[1], s = o[2];
      return new e(parseFloat(a), s ?? "");
    }
  }]);
}();
function EB(e) {
  if (e.includes(Il))
    return Il;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = Fk.exec(t)) !== null && n !== void 0 ? n : [], i = om(r, 4), o = i[1], a = i[2], s = i[3], l = Uh.parse(o ?? ""), c = Uh.parse(s ?? ""), f = a === "*" ? l.multiply(c) : l.divide(c);
    if (f.isNaN())
      return Il;
    t = t.replace(Fk, f.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var d, p = (d = Wk.exec(t)) !== null && d !== void 0 ? d : [], m = om(p, 4), g = m[1], v = m[2], y = m[3], x = Uh.parse(g ?? ""), w = Uh.parse(y ?? ""), S = v === "+" ? x.add(w) : x.subtract(w);
    if (S.isNaN())
      return Il;
    t = t.replace(Wk, S.toString());
  }
  return t;
}
var zk = /\(([^()]*)\)/;
function oye(e) {
  for (var t = e; t.includes("("); ) {
    var n = zk.exec(t), r = om(n, 2), i = r[1];
    t = t.replace(zk, EB(i));
  }
  return t;
}
function aye(e) {
  var t = e.replace(/\s+/g, "");
  return t = oye(t), t = EB(t), t;
}
function sye(e) {
  try {
    return aye(e);
  } catch {
    return Il;
  }
}
function Rb(e) {
  var t = sye(e.slice(5, -1));
  return t === Il ? "" : t;
}
var lye = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], cye = ["dx", "dy", "angle", "className", "breakAll"];
function Bx() {
  return Bx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bx.apply(this, arguments);
}
function Vk(e, t) {
  if (e == null) return {};
  var n = uye(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function uye(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Uk(e, t) {
  return pye(e) || hye(e, t) || dye(e, t) || fye();
}
function fye() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dye(e, t) {
  if (e) {
    if (typeof e == "string") return Kk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Kk(e, t);
  }
}
function Kk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function hye(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function pye(e) {
  if (Array.isArray(e)) return e;
}
var kB = /[ \f\n\r\t\v\u2028\u2029]+/, MB = function(t) {
  var n = t.children, r = t.breakAll, i = t.style;
  try {
    var o = [];
    Ue(n) || (r ? o = n.toString().split("") : o = n.toString().split(kB));
    var a = o.map(function(l) {
      return {
        word: l,
        width: Qu(l, i).width
      };
    }), s = r ? 0 : Qu(" ", i).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, mye = function(t, n, r, i, o) {
  var a = t.maxLines, s = t.children, l = t.style, c = t.breakAll, f = be(a), d = s, p = function() {
    var F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return F.reduce(function(W, z) {
      var G = z.word, V = z.width, U = W[W.length - 1];
      if (U && (i == null || o || U.width + V + r < Number(i)))
        U.words.push(G), U.width += V + r;
      else {
        var Y = {
          words: [G],
          width: V
        };
        W.push(Y);
      }
      return W;
    }, []);
  }, m = p(n), g = function(F) {
    return F.reduce(function(W, z) {
      return W.width > z.width ? W : z;
    });
  };
  if (!f)
    return m;
  for (var v = "…", y = function(F) {
    var W = d.slice(0, F), z = MB({
      breakAll: c,
      style: l,
      children: W + v
    }).wordsWithComputedWidth, G = p(z), V = G.length > a || g(G).width > Number(i);
    return [V, G];
  }, x = 0, w = d.length - 1, S = 0, A; x <= w && S <= d.length - 1; ) {
    var _ = Math.floor((x + w) / 2), O = _ - 1, T = y(O), C = Uk(T, 2), k = C[0], D = C[1], N = y(_), $ = Uk(N, 1), B = $[0];
    if (!k && !B && (x = _ + 1), k && B && (w = _ - 1), !k && B) {
      A = D;
      break;
    }
    S++;
  }
  return A || m;
}, Hk = function(t) {
  var n = Ue(t) ? [] : t.toString().split(kB);
  return [{
    words: n
  }];
}, gye = function(t) {
  var n = t.width, r = t.scaleToFit, i = t.children, o = t.style, a = t.breakAll, s = t.maxLines;
  if ((n || r) && !Mi.isSsr) {
    var l, c, f = MB({
      breakAll: a,
      children: i,
      style: o
    });
    if (f) {
      var d = f.wordsWithComputedWidth, p = f.spaceWidth;
      l = d, c = p;
    } else
      return Hk(i);
    return mye({
      breakAll: a,
      children: i,
      maxLines: s,
      style: o
    }, l, c, n, r);
  }
  return Hk(i);
}, Gk = "#808080", Ws = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.lineHeight, s = a === void 0 ? "1em" : a, l = t.capHeight, c = l === void 0 ? "0.71em" : l, f = t.scaleToFit, d = f === void 0 ? !1 : f, p = t.textAnchor, m = p === void 0 ? "start" : p, g = t.verticalAnchor, v = g === void 0 ? "end" : g, y = t.fill, x = y === void 0 ? Gk : y, w = Vk(t, lye), S = Le(function() {
    return gye({
      breakAll: w.breakAll,
      children: w.children,
      maxLines: w.maxLines,
      scaleToFit: d,
      style: w.style,
      width: w.width
    });
  }, [w.breakAll, w.children, w.maxLines, d, w.style, w.width]), A = w.dx, _ = w.dy, O = w.angle, T = w.className, C = w.breakAll, k = Vk(w, cye);
  if (!Sn(r) || !Sn(o))
    return null;
  var D = r + (be(A) ? A : 0), N = o + (be(_) ? _ : 0), $;
  switch (v) {
    case "start":
      $ = Rb("calc(".concat(c, ")"));
      break;
    case "middle":
      $ = Rb("calc(".concat((S.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      $ = Rb("calc(".concat(S.length - 1, " * -").concat(s, ")"));
      break;
  }
  var B = [];
  if (d) {
    var L = S[0].width, F = w.width;
    B.push("scale(".concat((be(F) ? F / L : 1) / L, ")"));
  }
  return O && B.push("rotate(".concat(O, ", ").concat(D, ", ").concat(N, ")")), B.length && (k.transform = B.join(" ")), /* @__PURE__ */ I.createElement("text", Bx({}, Ee(k, !0), {
    x: D,
    y: N,
    className: Ye("recharts-text", T),
    textAnchor: m,
    fill: x.includes("url") ? Gk : x
  }), S.map(function(W, z) {
    var G = W.words.join(C ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ I.createElement("tspan", {
        x: D,
        dy: z === 0 ? $ : s,
        key: "".concat(G, "-").concat(z)
      }, G)
    );
  }));
};
function ka(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function yye(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Z_(e) {
  let t, n, r;
  e.length !== 2 ? (t = ka, n = (s, l) => ka(e(s), l), r = (s, l) => e(s) - l) : (t = e === ka || e === yye ? e : vye, n = e, r = e);
  function i(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const d = c + f >>> 1;
        n(s[d], l) < 0 ? c = d + 1 : f = d;
      } while (c < f);
    }
    return c;
  }
  function o(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const d = c + f >>> 1;
        n(s[d], l) <= 0 ? c = d + 1 : f = d;
      } while (c < f);
    }
    return c;
  }
  function a(s, l, c = 0, f = s.length) {
    const d = i(s, l, c, f - 1);
    return d > c && r(s[d - 1], l) > -r(s[d], l) ? d - 1 : d;
  }
  return { left: i, center: a, right: o };
}
function vye() {
  return 0;
}
function NB(e) {
  return e === null ? NaN : +e;
}
function* bye(e, t) {
  for (let n of e)
    n != null && (n = +n) >= n && (yield n);
}
const xye = Z_(ka), Td = xye.right;
Z_(NB).center;
class Yk extends Map {
  constructor(t, n = Sye) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, i] of t) this.set(r, i);
  }
  get(t) {
    return super.get(qk(this, t));
  }
  has(t) {
    return super.has(qk(this, t));
  }
  set(t, n) {
    return super.set(wye(this, t), n);
  }
  delete(t) {
    return super.delete(_ye(this, t));
  }
}
function qk({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function wye({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function _ye({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function Sye(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Oye(e = ka) {
  if (e === ka) return $B;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function $B(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const Aye = Math.sqrt(50), Pye = Math.sqrt(10), Tye = Math.sqrt(2);
function am(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= Aye ? 10 : o >= Pye ? 5 : o >= Tye ? 2 : 1;
  let s, l, c;
  return i < 0 ? (c = Math.pow(10, -i) / a, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, i) * a, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= n && n < 2 ? am(e, t, n * 2) : [s, l, c];
}
function Fx(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [i, o, a] = r ? am(t, e, n) : am(e, t, n);
  if (!(o >= i)) return [];
  const s = o - i + 1, l = new Array(s);
  if (r)
    if (a < 0) for (let c = 0; c < s; ++c) l[c] = (o - c) / -a;
    else for (let c = 0; c < s; ++c) l[c] = (o - c) * a;
  else if (a < 0) for (let c = 0; c < s; ++c) l[c] = (i + c) / -a;
  else for (let c = 0; c < s; ++c) l[c] = (i + c) * a;
  return l;
}
function Wx(e, t, n) {
  return t = +t, e = +e, n = +n, am(e, t, n)[2];
}
function zx(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? Wx(t, e, n) : Wx(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function Xk(e, t) {
  let n;
  for (const r of e)
    r != null && (n < r || n === void 0 && r >= r) && (n = r);
  return n;
}
function Zk(e, t) {
  let n;
  for (const r of e)
    r != null && (n > r || n === void 0 && r >= r) && (n = r);
  return n;
}
function DB(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r)) return e;
  for (i = i === void 0 ? $B : Oye(i); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, c = t - n + 1, f = Math.log(l), d = 0.5 * Math.exp(2 * f / 3), p = 0.5 * Math.sqrt(f * d * (l - d) / l) * (c - l / 2 < 0 ? -1 : 1), m = Math.max(n, Math.floor(t - c * d / l + p)), g = Math.min(r, Math.floor(t + (l - c) * d / l + p));
      DB(e, t, m, g, i);
    }
    const o = e[t];
    let a = n, s = r;
    for (Tu(e, n, t), i(e[r], o) > 0 && Tu(e, n, r); a < s; ) {
      for (Tu(e, a, s), ++a, --s; i(e[a], o) < 0; ) ++a;
      for (; i(e[s], o) > 0; ) --s;
    }
    i(e[n], o) === 0 ? Tu(e, n, s) : (++s, Tu(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function Tu(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function Cye(e, t, n) {
  if (e = Float64Array.from(bye(e)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return Zk(e);
    if (t >= 1) return Xk(e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = Xk(DB(e, o).subarray(0, o + 1)), s = Zk(e.subarray(o + 1));
    return a + (s - a) * (i - o);
  }
}
function Eye(e, t, n = NB) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = +n(e[o], o, e), s = +n(e[o + 1], o + 1, e);
    return a + (s - a) * (i - o);
  }
}
function kye(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = e + r * n;
  return o;
}
function pi(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function ea(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Vx = Symbol("implicit");
function J_() {
  var e = new Yk(), t = [], n = [], r = Vx;
  function i(o) {
    let a = e.get(o);
    if (a === void 0) {
      if (r !== Vx) return r;
      e.set(o, a = t.push(o) - 1);
    }
    return n[a % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [], e = new Yk();
    for (const a of o)
      e.has(a) || e.set(a, t.push(a) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return J_(t, n).unknown(r);
  }, pi.apply(i, arguments), i;
}
function Nf() {
  var e = J_().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, o, a, s = !1, l = 0, c = 0, f = 0.5;
  delete e.unknown;
  function d() {
    var p = t().length, m = i < r, g = m ? i : r, v = m ? r : i;
    o = (v - g) / Math.max(1, p - l + c * 2), s && (o = Math.floor(o)), g += (v - g - o * (p - l)) * f, a = o * (1 - l), s && (g = Math.round(g), a = Math.round(a));
    var y = kye(p).map(function(x) {
      return g + o * x;
    });
    return n(m ? y.reverse() : y);
  }
  return e.domain = function(p) {
    return arguments.length ? (t(p), d()) : t();
  }, e.range = function(p) {
    return arguments.length ? ([r, i] = p, r = +r, i = +i, d()) : [r, i];
  }, e.rangeRound = function(p) {
    return [r, i] = p, r = +r, i = +i, s = !0, d();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return o;
  }, e.round = function(p) {
    return arguments.length ? (s = !!p, d()) : s;
  }, e.padding = function(p) {
    return arguments.length ? (l = Math.min(1, c = +p), d()) : l;
  }, e.paddingInner = function(p) {
    return arguments.length ? (l = Math.min(1, p), d()) : l;
  }, e.paddingOuter = function(p) {
    return arguments.length ? (c = +p, d()) : c;
  }, e.align = function(p) {
    return arguments.length ? (f = Math.max(0, Math.min(1, p)), d()) : f;
  }, e.copy = function() {
    return Nf(t(), [r, i]).round(s).paddingInner(l).paddingOuter(c).align(f);
  }, pi.apply(d(), arguments);
}
function IB(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return IB(t());
  }, e;
}
function ef() {
  return IB(Nf.apply(null, arguments).paddingInner(1));
}
function Q_(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function RB(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Cd() {
}
var $f = 0.7, sm = 1 / $f, Hl = "\\s*([+-]?\\d+)\\s*", Df = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Xi = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Mye = /^#([0-9a-f]{3,8})$/, Nye = new RegExp(`^rgb\\(${Hl},${Hl},${Hl}\\)$`), $ye = new RegExp(`^rgb\\(${Xi},${Xi},${Xi}\\)$`), Dye = new RegExp(`^rgba\\(${Hl},${Hl},${Hl},${Df}\\)$`), Iye = new RegExp(`^rgba\\(${Xi},${Xi},${Xi},${Df}\\)$`), Rye = new RegExp(`^hsl\\(${Df},${Xi},${Xi}\\)$`), jye = new RegExp(`^hsla\\(${Df},${Xi},${Xi},${Df}\\)$`), Jk = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Q_(Cd, If, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Qk,
  // Deprecated! Use color.formatHex.
  formatHex: Qk,
  formatHex8: Lye,
  formatHsl: Bye,
  formatRgb: eM,
  toString: eM
});
function Qk() {
  return this.rgb().formatHex();
}
function Lye() {
  return this.rgb().formatHex8();
}
function Bye() {
  return jB(this).formatHsl();
}
function eM() {
  return this.rgb().formatRgb();
}
function If(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Mye.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? tM(t) : n === 3 ? new wr(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Kh(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Kh(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Nye.exec(e)) ? new wr(t[1], t[2], t[3], 1) : (t = $ye.exec(e)) ? new wr(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Dye.exec(e)) ? Kh(t[1], t[2], t[3], t[4]) : (t = Iye.exec(e)) ? Kh(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Rye.exec(e)) ? iM(t[1], t[2] / 100, t[3] / 100, 1) : (t = jye.exec(e)) ? iM(t[1], t[2] / 100, t[3] / 100, t[4]) : Jk.hasOwnProperty(e) ? tM(Jk[e]) : e === "transparent" ? new wr(NaN, NaN, NaN, 0) : null;
}
function tM(e) {
  return new wr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Kh(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new wr(e, t, n, r);
}
function Fye(e) {
  return e instanceof Cd || (e = If(e)), e ? (e = e.rgb(), new wr(e.r, e.g, e.b, e.opacity)) : new wr();
}
function Ux(e, t, n, r) {
  return arguments.length === 1 ? Fye(e) : new wr(e, t, n, r ?? 1);
}
function wr(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Q_(wr, Ux, RB(Cd, {
  brighter(e) {
    return e = e == null ? sm : Math.pow(sm, e), new wr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? $f : Math.pow($f, e), new wr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new wr(Ms(this.r), Ms(this.g), Ms(this.b), lm(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: nM,
  // Deprecated! Use color.formatHex.
  formatHex: nM,
  formatHex8: Wye,
  formatRgb: rM,
  toString: rM
}));
function nM() {
  return `#${Ss(this.r)}${Ss(this.g)}${Ss(this.b)}`;
}
function Wye() {
  return `#${Ss(this.r)}${Ss(this.g)}${Ss(this.b)}${Ss((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rM() {
  const e = lm(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Ms(this.r)}, ${Ms(this.g)}, ${Ms(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function lm(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Ms(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ss(e) {
  return e = Ms(e), (e < 16 ? "0" : "") + e.toString(16);
}
function iM(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Ti(e, t, n, r);
}
function jB(e) {
  if (e instanceof Ti) return new Ti(e.h, e.s, e.l, e.opacity);
  if (e instanceof Cd || (e = If(e)), !e) return new Ti();
  if (e instanceof Ti) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, l = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? o + i : 2 - o - i, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new Ti(a, s, l, e.opacity);
}
function zye(e, t, n, r) {
  return arguments.length === 1 ? jB(e) : new Ti(e, t, n, r ?? 1);
}
function Ti(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Q_(Ti, zye, RB(Cd, {
  brighter(e) {
    return e = e == null ? sm : Math.pow(sm, e), new Ti(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? $f : Math.pow($f, e), new Ti(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new wr(
      jb(e >= 240 ? e - 240 : e + 120, i, r),
      jb(e, i, r),
      jb(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Ti(oM(this.h), Hh(this.s), Hh(this.l), lm(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = lm(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${oM(this.h)}, ${Hh(this.s) * 100}%, ${Hh(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function oM(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Hh(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function jb(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const eS = (e) => () => e;
function Vye(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Uye(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Kye(e) {
  return (e = +e) == 1 ? LB : function(t, n) {
    return n - t ? Uye(t, n, e) : eS(isNaN(t) ? n : t);
  };
}
function LB(e, t) {
  var n = t - e;
  return n ? Vye(e, n) : eS(isNaN(e) ? t : e);
}
const aM = function e(t) {
  var n = Kye(t);
  function r(i, o) {
    var a = n((i = Ux(i)).r, (o = Ux(o)).r), s = n(i.g, o.g), l = n(i.b, o.b), c = LB(i.opacity, o.opacity);
    return function(f) {
      return i.r = a(f), i.g = s(f), i.b = l(f), i.opacity = c(f), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function Hye(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function Gye(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Yye(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a) i[a] = qc(e[a], t[a]);
  for (; a < n; ++a) o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) o[a] = i[a](s);
    return o;
  };
}
function qye(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function cm(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Xye(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = qc(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n) r[i] = n[i](o);
    return r;
  };
}
var Kx = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Lb = new RegExp(Kx.source, "g");
function Zye(e) {
  return function() {
    return e;
  };
}
function Jye(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Qye(e, t) {
  var n = Kx.lastIndex = Lb.lastIndex = 0, r, i, o, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = Kx.exec(e)) && (i = Lb.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, l.push({ i: a, x: cm(r, i) })), n = Lb.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? l[0] ? Jye(l[0].x) : Zye(t) : (t = l.length, function(c) {
    for (var f = 0, d; f < t; ++f) s[(d = l[f]).i] = d.x(c);
    return s.join("");
  });
}
function qc(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? eS(t) : (n === "number" ? cm : n === "string" ? (r = If(t)) ? (t = r, aM) : Qye : t instanceof If ? aM : t instanceof Date ? qye : Gye(t) ? Hye : Array.isArray(t) ? Yye : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Xye : cm)(e, t);
}
function tS(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function eve(e, t) {
  t === void 0 && (t = e, e = qc);
  for (var n = 0, r = t.length - 1, i = t[0], o = new Array(r < 0 ? 0 : r); n < r; ) o[n] = e(i, i = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return o[s](a - s);
  };
}
function tve(e) {
  return function() {
    return e;
  };
}
function um(e) {
  return +e;
}
var sM = [0, 1];
function dr(e) {
  return e;
}
function Hx(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : tve(isNaN(t) ? NaN : 0.5);
}
function nve(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function rve(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = Hx(i, r), o = n(a, o)) : (r = Hx(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function ive(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = Hx(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = Td(e, s, 1, r) - 1;
    return o[l](i[l](s));
  };
}
function Ed(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function ny() {
  var e = sM, t = sM, n = qc, r, i, o, a = dr, s, l, c;
  function f() {
    var p = Math.min(e.length, t.length);
    return a !== dr && (a = nve(e[0], e[p - 1])), s = p > 2 ? ive : rve, l = c = null, d;
  }
  function d(p) {
    return p == null || isNaN(p = +p) ? o : (l || (l = s(e.map(r), t, n)))(r(a(p)));
  }
  return d.invert = function(p) {
    return a(i((c || (c = s(t, e.map(r), cm)))(p)));
  }, d.domain = function(p) {
    return arguments.length ? (e = Array.from(p, um), f()) : e.slice();
  }, d.range = function(p) {
    return arguments.length ? (t = Array.from(p), f()) : t.slice();
  }, d.rangeRound = function(p) {
    return t = Array.from(p), n = tS, f();
  }, d.clamp = function(p) {
    return arguments.length ? (a = p ? !0 : dr, f()) : a !== dr;
  }, d.interpolate = function(p) {
    return arguments.length ? (n = p, f()) : n;
  }, d.unknown = function(p) {
    return arguments.length ? (o = p, d) : o;
  }, function(p, m) {
    return r = p, i = m, f();
  };
}
function nS() {
  return ny()(dr, dr);
}
function ove(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function fm(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function lc(e) {
  return e = fm(Math.abs(e)), e ? e[1] : NaN;
}
function ave(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), o.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function sve(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var lve = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Rf(e) {
  if (!(t = lve.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new rS({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Rf.prototype = rS.prototype;
function rS(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
rS.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function cve(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var BB;
function uve(e, t) {
  var n = fm(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], o = i - (BB = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + fm(e, Math.max(0, t + o - 1))[0];
}
function lM(e, t) {
  var n = fm(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const cM = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: ove,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => lM(e * 100, t),
  r: lM,
  s: uve,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function uM(e) {
  return e;
}
var fM = Array.prototype.map, dM = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function fve(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? uM : ave(fM.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? uM : sve(fM.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(d) {
    d = Rf(d);
    var p = d.fill, m = d.align, g = d.sign, v = d.symbol, y = d.zero, x = d.width, w = d.comma, S = d.precision, A = d.trim, _ = d.type;
    _ === "n" ? (w = !0, _ = "g") : cM[_] || (S === void 0 && (S = 12), A = !0, _ = "g"), (y || p === "0" && m === "=") && (y = !0, p = "0", m = "=");
    var O = v === "$" ? n : v === "#" && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "", T = v === "$" ? r : /[%p]/.test(_) ? a : "", C = cM[_], k = /[defgprs%]/.test(_);
    S = S === void 0 ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function D(N) {
      var $ = O, B = T, L, F, W;
      if (_ === "c")
        B = C(N) + B, N = "";
      else {
        N = +N;
        var z = N < 0 || 1 / N < 0;
        if (N = isNaN(N) ? l : C(Math.abs(N), S), A && (N = cve(N)), z && +N == 0 && g !== "+" && (z = !1), $ = (z ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + $, B = (_ === "s" ? dM[8 + BB / 3] : "") + B + (z && g === "(" ? ")" : ""), k) {
          for (L = -1, F = N.length; ++L < F; )
            if (W = N.charCodeAt(L), 48 > W || W > 57) {
              B = (W === 46 ? i + N.slice(L + 1) : N.slice(L)) + B, N = N.slice(0, L);
              break;
            }
        }
      }
      w && !y && (N = t(N, 1 / 0));
      var G = $.length + N.length + B.length, V = G < x ? new Array(x - G + 1).join(p) : "";
      switch (w && y && (N = t(V + N, V.length ? x - B.length : 1 / 0), V = ""), m) {
        case "<":
          N = $ + N + B + V;
          break;
        case "=":
          N = $ + V + N + B;
          break;
        case "^":
          N = V.slice(0, G = V.length >> 1) + $ + N + B + V.slice(G);
          break;
        default:
          N = V + $ + N + B;
          break;
      }
      return o(N);
    }
    return D.toString = function() {
      return d + "";
    }, D;
  }
  function f(d, p) {
    var m = c((d = Rf(d), d.type = "f", d)), g = Math.max(-8, Math.min(8, Math.floor(lc(p) / 3))) * 3, v = Math.pow(10, -g), y = dM[8 + g / 3];
    return function(x) {
      return m(v * x) + y;
    };
  }
  return {
    format: c,
    formatPrefix: f
  };
}
var Gh, iS, FB;
dve({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function dve(e) {
  return Gh = fve(e), iS = Gh.format, FB = Gh.formatPrefix, Gh;
}
function hve(e) {
  return Math.max(0, -lc(Math.abs(e)));
}
function pve(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(lc(t) / 3))) * 3 - lc(Math.abs(e)));
}
function mve(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, lc(t) - lc(e)) + 1;
}
function WB(e, t, n, r) {
  var i = zx(e, t, n), o;
  switch (r = Rf(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = pve(i, a)) && (r.precision = o), FB(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = mve(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = hve(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return iS(r);
}
function Ga(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Fx(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return WB(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], l, c, f = 10;
    for (s < a && (c = a, a = s, s = c, c = i, i = o, o = c); f-- > 0; ) {
      if (c = Wx(a, s, n), c === l)
        return r[i] = a, r[o] = s, t(r);
      if (c > 0)
        a = Math.floor(a / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        a = Math.ceil(a * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function dm() {
  var e = nS();
  return e.copy = function() {
    return Ed(e, dm());
  }, pi.apply(e, arguments), Ga(e);
}
function zB(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, um), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return zB(e).unknown(t);
  }, e = arguments.length ? Array.from(e, um) : [0, 1], Ga(n);
}
function VB(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], o = e[r], a;
  return o < i && (a = n, n = r, r = a, a = i, i = o, o = a), e[n] = t.floor(i), e[r] = t.ceil(o), e;
}
function hM(e) {
  return Math.log(e);
}
function pM(e) {
  return Math.exp(e);
}
function gve(e) {
  return -Math.log(-e);
}
function yve(e) {
  return -Math.exp(-e);
}
function vve(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function bve(e) {
  return e === 10 ? vve : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function xve(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function mM(e) {
  return (t, n) => -e(-t, n);
}
function oS(e) {
  const t = e(hM, pM), n = t.domain;
  let r = 10, i, o;
  function a() {
    return i = xve(r), o = bve(r), n()[0] < 0 ? (i = mM(i), o = mM(o), e(gve, yve)) : e(hM, pM), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let c = l[0], f = l[l.length - 1];
    const d = f < c;
    d && ([c, f] = [f, c]);
    let p = i(c), m = i(f), g, v;
    const y = s == null ? 10 : +s;
    let x = [];
    if (!(r % 1) && m - p < y) {
      if (p = Math.floor(p), m = Math.ceil(m), c > 0) {
        for (; p <= m; ++p)
          for (g = 1; g < r; ++g)
            if (v = p < 0 ? g / o(-p) : g * o(p), !(v < c)) {
              if (v > f) break;
              x.push(v);
            }
      } else for (; p <= m; ++p)
        for (g = r - 1; g >= 1; --g)
          if (v = p > 0 ? g / o(-p) : g * o(p), !(v < c)) {
            if (v > f) break;
            x.push(v);
          }
      x.length * 2 < y && (x = Fx(c, f, y));
    } else
      x = Fx(p, m, Math.min(m - p, y)).map(o);
    return d ? x.reverse() : x;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = Rf(l)).precision == null && (l.trim = !0), l = iS(l)), s === 1 / 0) return l;
    const c = Math.max(1, r * s / t.ticks().length);
    return (f) => {
      let d = f / o(Math.round(i(f)));
      return d * r < r - 0.5 && (d *= r), d <= c ? l(f) : "";
    };
  }, t.nice = () => n(VB(n(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), t;
}
function UB() {
  const e = oS(ny()).domain([1, 10]);
  return e.copy = () => Ed(e, UB()).base(e.base()), pi.apply(e, arguments), e;
}
function gM(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function yM(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function aS(e) {
  var t = 1, n = e(gM(t), yM(t));
  return n.constant = function(r) {
    return arguments.length ? e(gM(t = +r), yM(t)) : t;
  }, Ga(n);
}
function KB() {
  var e = aS(ny());
  return e.copy = function() {
    return Ed(e, KB()).constant(e.constant());
  }, pi.apply(e, arguments);
}
function vM(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function wve(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function _ve(e) {
  return e < 0 ? -e * e : e * e;
}
function sS(e) {
  var t = e(dr, dr), n = 1;
  function r() {
    return n === 1 ? e(dr, dr) : n === 0.5 ? e(wve, _ve) : e(vM(n), vM(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, Ga(t);
}
function lS() {
  var e = sS(ny());
  return e.copy = function() {
    return Ed(e, lS()).exponent(e.exponent());
  }, pi.apply(e, arguments), e;
}
function Sve() {
  return lS.apply(null, arguments).exponent(0.5);
}
function bM(e) {
  return Math.sign(e) * e * e;
}
function Ove(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function HB() {
  var e = nS(), t = [0, 1], n = !1, r;
  function i(o) {
    var a = Ove(e(o));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return i.invert = function(o) {
    return e.invert(bM(o));
  }, i.domain = function(o) {
    return arguments.length ? (e.domain(o), i) : e.domain();
  }, i.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, um)).map(bM)), i) : t.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (n = !!o, i) : n;
  }, i.clamp = function(o) {
    return arguments.length ? (e.clamp(o), i) : e.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return HB(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, pi.apply(i, arguments), Ga(i);
}
function GB() {
  var e = [], t = [], n = [], r;
  function i() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; ) n[a - 1] = Eye(e, a / s);
    return o;
  }
  function o(a) {
    return a == null || isNaN(a = +a) ? r : t[Td(n, a)];
  }
  return o.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, o.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of a) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(ka), i();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), i()) : t.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return GB().domain(e).range(t).unknown(r);
  }, pi.apply(o, arguments);
}
function YB() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], o;
  function a(l) {
    return l != null && l <= l ? i[Td(r, l, 0, n)] : o;
  }
  function s() {
    var l = -1;
    for (r = new Array(n); ++l < n; ) r[l] = ((l + 1) * t - (l - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(l) {
    return arguments.length ? (n = (i = Array.from(l)).length - 1, s()) : i.slice();
  }, a.invertExtent = function(l) {
    var c = i.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, r[0]] : c >= n ? [r[n - 1], t] : [r[c - 1], r[c]];
  }, a.unknown = function(l) {
    return arguments.length && (o = l), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return YB().domain([e, t]).range(i).unknown(o);
  }, pi.apply(Ga(a), arguments);
}
function qB() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? t[Td(e, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(o) {
    var a = t.indexOf(o);
    return [e[a - 1], e[a]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return qB().domain(e).range(t).unknown(n);
  }, pi.apply(i, arguments);
}
const Bb = /* @__PURE__ */ new Date(), Fb = /* @__PURE__ */ new Date();
function An(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const l = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (c < o && o < a);
    return l;
  }, i.filter = (o) => An((a) => {
    if (a >= a) for (; e(a), !o(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !o(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !o(a); )
          ;
  }), n && (i.count = (o, a) => (Bb.setTime(+o), Fb.setTime(+a), e(Bb), e(Fb), Math.floor(n(Bb, Fb))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const hm = An(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
hm.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? An((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : hm);
hm.range;
const To = 1e3, ci = To * 60, Co = ci * 60, Vo = Co * 24, cS = Vo * 7, xM = Vo * 30, Wb = Vo * 365, Os = An((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * To);
}, (e, t) => (t - e) / To, (e) => e.getUTCSeconds());
Os.range;
const uS = An((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * To);
}, (e, t) => {
  e.setTime(+e + t * ci);
}, (e, t) => (t - e) / ci, (e) => e.getMinutes());
uS.range;
const fS = An((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * ci);
}, (e, t) => (t - e) / ci, (e) => e.getUTCMinutes());
fS.range;
const dS = An((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * To - e.getMinutes() * ci);
}, (e, t) => {
  e.setTime(+e + t * Co);
}, (e, t) => (t - e) / Co, (e) => e.getHours());
dS.range;
const hS = An((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Co);
}, (e, t) => (t - e) / Co, (e) => e.getUTCHours());
hS.range;
const kd = An(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * ci) / Vo,
  (e) => e.getDate() - 1
);
kd.range;
const ry = An((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Vo, (e) => e.getUTCDate() - 1);
ry.range;
const XB = An((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Vo, (e) => Math.floor(e / Vo));
XB.range;
function el(e) {
  return An((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * ci) / cS);
}
const iy = el(0), pm = el(1), Ave = el(2), Pve = el(3), cc = el(4), Tve = el(5), Cve = el(6);
iy.range;
pm.range;
Ave.range;
Pve.range;
cc.range;
Tve.range;
Cve.range;
function tl(e) {
  return An((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / cS);
}
const oy = tl(0), mm = tl(1), Eve = tl(2), kve = tl(3), uc = tl(4), Mve = tl(5), Nve = tl(6);
oy.range;
mm.range;
Eve.range;
kve.range;
uc.range;
Mve.range;
Nve.range;
const pS = An((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
pS.range;
const mS = An((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
mS.range;
const Uo = An((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Uo.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : An((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Uo.range;
const Ko = An((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Ko.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : An((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
Ko.range;
function ZB(e, t, n, r, i, o) {
  const a = [
    [Os, 1, To],
    [Os, 5, 5 * To],
    [Os, 15, 15 * To],
    [Os, 30, 30 * To],
    [o, 1, ci],
    [o, 5, 5 * ci],
    [o, 15, 15 * ci],
    [o, 30, 30 * ci],
    [i, 1, Co],
    [i, 3, 3 * Co],
    [i, 6, 6 * Co],
    [i, 12, 12 * Co],
    [r, 1, Vo],
    [r, 2, 2 * Vo],
    [n, 1, cS],
    [t, 1, xM],
    [t, 3, 3 * xM],
    [e, 1, Wb]
  ];
  function s(c, f, d) {
    const p = f < c;
    p && ([c, f] = [f, c]);
    const m = d && typeof d.range == "function" ? d : l(c, f, d), g = m ? m.range(c, +f + 1) : [];
    return p ? g.reverse() : g;
  }
  function l(c, f, d) {
    const p = Math.abs(f - c) / d, m = Z_(([, , y]) => y).right(a, p);
    if (m === a.length) return e.every(zx(c / Wb, f / Wb, d));
    if (m === 0) return hm.every(Math.max(zx(c, f, d), 1));
    const [g, v] = a[p / a[m - 1][2] < a[m][2] / p ? m - 1 : m];
    return g.every(v);
  }
  return [s, l];
}
const [$ve, Dve] = ZB(Ko, mS, oy, XB, hS, fS), [Ive, Rve] = ZB(Uo, pS, iy, kd, dS, uS);
function zb(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Vb(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Cu(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function jve(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, o = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = Eu(i), f = ku(i), d = Eu(o), p = ku(o), m = Eu(a), g = ku(a), v = Eu(s), y = ku(s), x = Eu(l), w = ku(l), S = {
    a: z,
    A: G,
    b: V,
    B: U,
    c: null,
    d: PM,
    e: PM,
    f: abe,
    g: gbe,
    G: vbe,
    H: rbe,
    I: ibe,
    j: obe,
    L: JB,
    m: sbe,
    M: lbe,
    p: Y,
    q: te,
    Q: EM,
    s: kM,
    S: cbe,
    u: ube,
    U: fbe,
    V: dbe,
    w: hbe,
    W: pbe,
    x: null,
    X: null,
    y: mbe,
    Y: ybe,
    Z: bbe,
    "%": CM
  }, A = {
    a: ne,
    A: re,
    b: ue,
    B: ae,
    c: null,
    d: TM,
    e: TM,
    f: Sbe,
    g: $be,
    G: Ibe,
    H: xbe,
    I: wbe,
    j: _be,
    L: eF,
    m: Obe,
    M: Abe,
    p: le,
    q: ie,
    Q: EM,
    s: kM,
    S: Pbe,
    u: Tbe,
    U: Cbe,
    V: Ebe,
    w: kbe,
    W: Mbe,
    x: null,
    X: null,
    y: Nbe,
    Y: Dbe,
    Z: Rbe,
    "%": CM
  }, _ = {
    a: D,
    A: N,
    b: $,
    B,
    c: L,
    d: OM,
    e: OM,
    f: Qve,
    g: SM,
    G: _M,
    H: AM,
    I: AM,
    j: qve,
    L: Jve,
    m: Yve,
    M: Xve,
    p: k,
    q: Gve,
    Q: tbe,
    s: nbe,
    S: Zve,
    u: zve,
    U: Vve,
    V: Uve,
    w: Wve,
    W: Kve,
    x: F,
    X: W,
    y: SM,
    Y: _M,
    Z: Hve,
    "%": ebe
  };
  S.x = O(n, S), S.X = O(r, S), S.c = O(t, S), A.x = O(n, A), A.X = O(r, A), A.c = O(t, A);
  function O(Q, fe) {
    return function(ve) {
      var X = [], Fe = -1, pe = 0, Be = Q.length, rt, at, Gn;
      for (ve instanceof Date || (ve = /* @__PURE__ */ new Date(+ve)); ++Fe < Be; )
        Q.charCodeAt(Fe) === 37 && (X.push(Q.slice(pe, Fe)), (at = wM[rt = Q.charAt(++Fe)]) != null ? rt = Q.charAt(++Fe) : at = rt === "e" ? " " : "0", (Gn = fe[rt]) && (rt = Gn(ve, at)), X.push(rt), pe = Fe + 1);
      return X.push(Q.slice(pe, Fe)), X.join("");
    };
  }
  function T(Q, fe) {
    return function(ve) {
      var X = Cu(1900, void 0, 1), Fe = C(X, Q, ve += "", 0), pe, Be;
      if (Fe != ve.length) return null;
      if ("Q" in X) return new Date(X.Q);
      if ("s" in X) return new Date(X.s * 1e3 + ("L" in X ? X.L : 0));
      if (fe && !("Z" in X) && (X.Z = 0), "p" in X && (X.H = X.H % 12 + X.p * 12), X.m === void 0 && (X.m = "q" in X ? X.q : 0), "V" in X) {
        if (X.V < 1 || X.V > 53) return null;
        "w" in X || (X.w = 1), "Z" in X ? (pe = Vb(Cu(X.y, 0, 1)), Be = pe.getUTCDay(), pe = Be > 4 || Be === 0 ? mm.ceil(pe) : mm(pe), pe = ry.offset(pe, (X.V - 1) * 7), X.y = pe.getUTCFullYear(), X.m = pe.getUTCMonth(), X.d = pe.getUTCDate() + (X.w + 6) % 7) : (pe = zb(Cu(X.y, 0, 1)), Be = pe.getDay(), pe = Be > 4 || Be === 0 ? pm.ceil(pe) : pm(pe), pe = kd.offset(pe, (X.V - 1) * 7), X.y = pe.getFullYear(), X.m = pe.getMonth(), X.d = pe.getDate() + (X.w + 6) % 7);
      } else ("W" in X || "U" in X) && ("w" in X || (X.w = "u" in X ? X.u % 7 : "W" in X ? 1 : 0), Be = "Z" in X ? Vb(Cu(X.y, 0, 1)).getUTCDay() : zb(Cu(X.y, 0, 1)).getDay(), X.m = 0, X.d = "W" in X ? (X.w + 6) % 7 + X.W * 7 - (Be + 5) % 7 : X.w + X.U * 7 - (Be + 6) % 7);
      return "Z" in X ? (X.H += X.Z / 100 | 0, X.M += X.Z % 100, Vb(X)) : zb(X);
    };
  }
  function C(Q, fe, ve, X) {
    for (var Fe = 0, pe = fe.length, Be = ve.length, rt, at; Fe < pe; ) {
      if (X >= Be) return -1;
      if (rt = fe.charCodeAt(Fe++), rt === 37) {
        if (rt = fe.charAt(Fe++), at = _[rt in wM ? fe.charAt(Fe++) : rt], !at || (X = at(Q, ve, X)) < 0) return -1;
      } else if (rt != ve.charCodeAt(X++))
        return -1;
    }
    return X;
  }
  function k(Q, fe, ve) {
    var X = c.exec(fe.slice(ve));
    return X ? (Q.p = f.get(X[0].toLowerCase()), ve + X[0].length) : -1;
  }
  function D(Q, fe, ve) {
    var X = m.exec(fe.slice(ve));
    return X ? (Q.w = g.get(X[0].toLowerCase()), ve + X[0].length) : -1;
  }
  function N(Q, fe, ve) {
    var X = d.exec(fe.slice(ve));
    return X ? (Q.w = p.get(X[0].toLowerCase()), ve + X[0].length) : -1;
  }
  function $(Q, fe, ve) {
    var X = x.exec(fe.slice(ve));
    return X ? (Q.m = w.get(X[0].toLowerCase()), ve + X[0].length) : -1;
  }
  function B(Q, fe, ve) {
    var X = v.exec(fe.slice(ve));
    return X ? (Q.m = y.get(X[0].toLowerCase()), ve + X[0].length) : -1;
  }
  function L(Q, fe, ve) {
    return C(Q, t, fe, ve);
  }
  function F(Q, fe, ve) {
    return C(Q, n, fe, ve);
  }
  function W(Q, fe, ve) {
    return C(Q, r, fe, ve);
  }
  function z(Q) {
    return a[Q.getDay()];
  }
  function G(Q) {
    return o[Q.getDay()];
  }
  function V(Q) {
    return l[Q.getMonth()];
  }
  function U(Q) {
    return s[Q.getMonth()];
  }
  function Y(Q) {
    return i[+(Q.getHours() >= 12)];
  }
  function te(Q) {
    return 1 + ~~(Q.getMonth() / 3);
  }
  function ne(Q) {
    return a[Q.getUTCDay()];
  }
  function re(Q) {
    return o[Q.getUTCDay()];
  }
  function ue(Q) {
    return l[Q.getUTCMonth()];
  }
  function ae(Q) {
    return s[Q.getUTCMonth()];
  }
  function le(Q) {
    return i[+(Q.getUTCHours() >= 12)];
  }
  function ie(Q) {
    return 1 + ~~(Q.getUTCMonth() / 3);
  }
  return {
    format: function(Q) {
      var fe = O(Q += "", S);
      return fe.toString = function() {
        return Q;
      }, fe;
    },
    parse: function(Q) {
      var fe = T(Q += "", !1);
      return fe.toString = function() {
        return Q;
      }, fe;
    },
    utcFormat: function(Q) {
      var fe = O(Q += "", A);
      return fe.toString = function() {
        return Q;
      }, fe;
    },
    utcParse: function(Q) {
      var fe = T(Q += "", !0);
      return fe.toString = function() {
        return Q;
      }, fe;
    }
  };
}
var wM = { "-": "", _: " ", 0: "0" }, Dn = /^\s*\d+/, Lve = /^%/, Bve = /[\\^$*+?|[\]().{}]/g;
function dt(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}
function Fve(e) {
  return e.replace(Bve, "\\$&");
}
function Eu(e) {
  return new RegExp("^(?:" + e.map(Fve).join("|") + ")", "i");
}
function ku(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function Wve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function zve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function Vve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function Uve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function Kve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function _M(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function SM(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Hve(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function Gve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function Yve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function OM(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function qve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function AM(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function Xve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function Zve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function Jve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function Qve(e, t, n) {
  var r = Dn.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function ebe(e, t, n) {
  var r = Lve.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function tbe(e, t, n) {
  var r = Dn.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function nbe(e, t, n) {
  var r = Dn.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function PM(e, t) {
  return dt(e.getDate(), t, 2);
}
function rbe(e, t) {
  return dt(e.getHours(), t, 2);
}
function ibe(e, t) {
  return dt(e.getHours() % 12 || 12, t, 2);
}
function obe(e, t) {
  return dt(1 + kd.count(Uo(e), e), t, 3);
}
function JB(e, t) {
  return dt(e.getMilliseconds(), t, 3);
}
function abe(e, t) {
  return JB(e, t) + "000";
}
function sbe(e, t) {
  return dt(e.getMonth() + 1, t, 2);
}
function lbe(e, t) {
  return dt(e.getMinutes(), t, 2);
}
function cbe(e, t) {
  return dt(e.getSeconds(), t, 2);
}
function ube(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function fbe(e, t) {
  return dt(iy.count(Uo(e) - 1, e), t, 2);
}
function QB(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? cc(e) : cc.ceil(e);
}
function dbe(e, t) {
  return e = QB(e), dt(cc.count(Uo(e), e) + (Uo(e).getDay() === 4), t, 2);
}
function hbe(e) {
  return e.getDay();
}
function pbe(e, t) {
  return dt(pm.count(Uo(e) - 1, e), t, 2);
}
function mbe(e, t) {
  return dt(e.getFullYear() % 100, t, 2);
}
function gbe(e, t) {
  return e = QB(e), dt(e.getFullYear() % 100, t, 2);
}
function ybe(e, t) {
  return dt(e.getFullYear() % 1e4, t, 4);
}
function vbe(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? cc(e) : cc.ceil(e), dt(e.getFullYear() % 1e4, t, 4);
}
function bbe(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + dt(t / 60 | 0, "0", 2) + dt(t % 60, "0", 2);
}
function TM(e, t) {
  return dt(e.getUTCDate(), t, 2);
}
function xbe(e, t) {
  return dt(e.getUTCHours(), t, 2);
}
function wbe(e, t) {
  return dt(e.getUTCHours() % 12 || 12, t, 2);
}
function _be(e, t) {
  return dt(1 + ry.count(Ko(e), e), t, 3);
}
function eF(e, t) {
  return dt(e.getUTCMilliseconds(), t, 3);
}
function Sbe(e, t) {
  return eF(e, t) + "000";
}
function Obe(e, t) {
  return dt(e.getUTCMonth() + 1, t, 2);
}
function Abe(e, t) {
  return dt(e.getUTCMinutes(), t, 2);
}
function Pbe(e, t) {
  return dt(e.getUTCSeconds(), t, 2);
}
function Tbe(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function Cbe(e, t) {
  return dt(oy.count(Ko(e) - 1, e), t, 2);
}
function tF(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? uc(e) : uc.ceil(e);
}
function Ebe(e, t) {
  return e = tF(e), dt(uc.count(Ko(e), e) + (Ko(e).getUTCDay() === 4), t, 2);
}
function kbe(e) {
  return e.getUTCDay();
}
function Mbe(e, t) {
  return dt(mm.count(Ko(e) - 1, e), t, 2);
}
function Nbe(e, t) {
  return dt(e.getUTCFullYear() % 100, t, 2);
}
function $be(e, t) {
  return e = tF(e), dt(e.getUTCFullYear() % 100, t, 2);
}
function Dbe(e, t) {
  return dt(e.getUTCFullYear() % 1e4, t, 4);
}
function Ibe(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? uc(e) : uc.ceil(e), dt(e.getUTCFullYear() % 1e4, t, 4);
}
function Rbe() {
  return "+0000";
}
function CM() {
  return "%";
}
function EM(e) {
  return +e;
}
function kM(e) {
  return Math.floor(+e / 1e3);
}
var _l, nF, rF;
jbe({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function jbe(e) {
  return _l = jve(e), nF = _l.format, _l.parse, rF = _l.utcFormat, _l.utcParse, _l;
}
function Lbe(e) {
  return new Date(e);
}
function Bbe(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function gS(e, t, n, r, i, o, a, s, l, c) {
  var f = nS(), d = f.invert, p = f.domain, m = c(".%L"), g = c(":%S"), v = c("%I:%M"), y = c("%I %p"), x = c("%a %d"), w = c("%b %d"), S = c("%B"), A = c("%Y");
  function _(O) {
    return (l(O) < O ? m : s(O) < O ? g : a(O) < O ? v : o(O) < O ? y : r(O) < O ? i(O) < O ? x : w : n(O) < O ? S : A)(O);
  }
  return f.invert = function(O) {
    return new Date(d(O));
  }, f.domain = function(O) {
    return arguments.length ? p(Array.from(O, Bbe)) : p().map(Lbe);
  }, f.ticks = function(O) {
    var T = p();
    return e(T[0], T[T.length - 1], O ?? 10);
  }, f.tickFormat = function(O, T) {
    return T == null ? _ : c(T);
  }, f.nice = function(O) {
    var T = p();
    return (!O || typeof O.range != "function") && (O = t(T[0], T[T.length - 1], O ?? 10)), O ? p(VB(T, O)) : f;
  }, f.copy = function() {
    return Ed(f, gS(e, t, n, r, i, o, a, s, l, c));
  }, f;
}
function Fbe() {
  return pi.apply(gS(Ive, Rve, Uo, pS, iy, kd, dS, uS, Os, nF).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Wbe() {
  return pi.apply(gS($ve, Dve, Ko, mS, oy, ry, hS, fS, Os, rF).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function ay() {
  var e = 0, t = 1, n, r, i, o, a = dr, s = !1, l;
  function c(d) {
    return d == null || isNaN(d = +d) ? l : a(i === 0 ? 0.5 : (d = (o(d) - n) * i, s ? Math.max(0, Math.min(1, d)) : d));
  }
  c.domain = function(d) {
    return arguments.length ? ([e, t] = d, n = o(e = +e), r = o(t = +t), i = n === r ? 0 : 1 / (r - n), c) : [e, t];
  }, c.clamp = function(d) {
    return arguments.length ? (s = !!d, c) : s;
  }, c.interpolator = function(d) {
    return arguments.length ? (a = d, c) : a;
  };
  function f(d) {
    return function(p) {
      var m, g;
      return arguments.length ? ([m, g] = p, a = d(m, g), c) : [a(0), a(1)];
    };
  }
  return c.range = f(qc), c.rangeRound = f(tS), c.unknown = function(d) {
    return arguments.length ? (l = d, c) : l;
  }, function(d) {
    return o = d, n = d(e), r = d(t), i = n === r ? 0 : 1 / (r - n), c;
  };
}
function Ya(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function iF() {
  var e = Ga(ay()(dr));
  return e.copy = function() {
    return Ya(e, iF());
  }, ea.apply(e, arguments);
}
function oF() {
  var e = oS(ay()).domain([1, 10]);
  return e.copy = function() {
    return Ya(e, oF()).base(e.base());
  }, ea.apply(e, arguments);
}
function aF() {
  var e = aS(ay());
  return e.copy = function() {
    return Ya(e, aF()).constant(e.constant());
  }, ea.apply(e, arguments);
}
function yS() {
  var e = sS(ay());
  return e.copy = function() {
    return Ya(e, yS()).exponent(e.exponent());
  }, ea.apply(e, arguments);
}
function zbe() {
  return yS.apply(null, arguments).exponent(0.5);
}
function sF() {
  var e = [], t = dr;
  function n(r) {
    if (r != null && !isNaN(r = +r)) return t((Td(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of r) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(ka), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => Cye(e, o / r));
  }, n.copy = function() {
    return sF(t).domain(e);
  }, ea.apply(n, arguments);
}
function sy() {
  var e = 0, t = 0.5, n = 1, r = 1, i, o, a, s, l, c = dr, f, d = !1, p;
  function m(v) {
    return isNaN(v = +v) ? p : (v = 0.5 + ((v = +f(v)) - o) * (r * v < r * o ? s : l), c(d ? Math.max(0, Math.min(1, v)) : v));
  }
  m.domain = function(v) {
    return arguments.length ? ([e, t, n] = v, i = f(e = +e), o = f(t = +t), a = f(n = +n), s = i === o ? 0 : 0.5 / (o - i), l = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, m) : [e, t, n];
  }, m.clamp = function(v) {
    return arguments.length ? (d = !!v, m) : d;
  }, m.interpolator = function(v) {
    return arguments.length ? (c = v, m) : c;
  };
  function g(v) {
    return function(y) {
      var x, w, S;
      return arguments.length ? ([x, w, S] = y, c = eve(v, [x, w, S]), m) : [c(0), c(0.5), c(1)];
    };
  }
  return m.range = g(qc), m.rangeRound = g(tS), m.unknown = function(v) {
    return arguments.length ? (p = v, m) : p;
  }, function(v) {
    return f = v, i = v(e), o = v(t), a = v(n), s = i === o ? 0 : 0.5 / (o - i), l = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, m;
  };
}
function lF() {
  var e = Ga(sy()(dr));
  return e.copy = function() {
    return Ya(e, lF());
  }, ea.apply(e, arguments);
}
function cF() {
  var e = oS(sy()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return Ya(e, cF()).base(e.base());
  }, ea.apply(e, arguments);
}
function uF() {
  var e = aS(sy());
  return e.copy = function() {
    return Ya(e, uF()).constant(e.constant());
  }, ea.apply(e, arguments);
}
function vS() {
  var e = sS(sy());
  return e.copy = function() {
    return Ya(e, vS()).exponent(e.exponent());
  }, ea.apply(e, arguments);
}
function Vbe() {
  return vS.apply(null, arguments).exponent(0.5);
}
const MM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Nf,
  scaleDiverging: lF,
  scaleDivergingLog: cF,
  scaleDivergingPow: vS,
  scaleDivergingSqrt: Vbe,
  scaleDivergingSymlog: uF,
  scaleIdentity: zB,
  scaleImplicit: Vx,
  scaleLinear: dm,
  scaleLog: UB,
  scaleOrdinal: J_,
  scalePoint: ef,
  scalePow: lS,
  scaleQuantile: GB,
  scaleQuantize: YB,
  scaleRadial: HB,
  scaleSequential: iF,
  scaleSequentialLog: oF,
  scaleSequentialPow: yS,
  scaleSequentialQuantile: sF,
  scaleSequentialSqrt: zbe,
  scaleSequentialSymlog: aF,
  scaleSqrt: Sve,
  scaleSymlog: KB,
  scaleThreshold: qB,
  scaleTime: Fbe,
  scaleUtc: Wbe,
  tickFormat: WB
}, Symbol.toStringTag, { value: "Module" }));
var Ube = Fc;
function Kbe(e, t, n) {
  for (var r = -1, i = e.length; ++r < i; ) {
    var o = e[r], a = t(o);
    if (a != null && (s === void 0 ? a === a && !Ube(a) : n(a, s)))
      var s = a, l = o;
  }
  return l;
}
var ly = Kbe;
function Hbe(e, t) {
  return e > t;
}
var fF = Hbe, Gbe = ly, Ybe = fF, qbe = Yc;
function Xbe(e) {
  return e && e.length ? Gbe(e, qbe, Ybe) : void 0;
}
var Zbe = Xbe;
const Oa = /* @__PURE__ */ Et(Zbe);
function Jbe(e, t) {
  return e < t;
}
var dF = Jbe, Qbe = ly, e0e = dF, t0e = Yc;
function n0e(e) {
  return e && e.length ? Qbe(e, t0e, e0e) : void 0;
}
var r0e = n0e;
const cy = /* @__PURE__ */ Et(r0e);
var i0e = $_, o0e = oo, a0e = bB, s0e = Ar;
function l0e(e, t) {
  var n = s0e(e) ? i0e : a0e;
  return n(e, o0e(t));
}
var c0e = l0e, u0e = yB, f0e = c0e;
function d0e(e, t) {
  return u0e(f0e(e, t), 1);
}
var h0e = d0e;
const p0e = /* @__PURE__ */ Et(h0e);
var m0e = H_;
function g0e(e, t) {
  return m0e(e, t);
}
var y0e = g0e;
const zs = /* @__PURE__ */ Et(y0e);
var Xc = 1e9, v0e = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, xS, qt = !0, di = "[DecimalError] ", Ns = di + "Invalid argument: ", bS = di + "Exponent out of range: ", Zc = Math.floor, vs = Math.pow, b0e = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Fr, En = 1e7, Vt = 7, hF = 9007199254740991, gm = Zc(hF / Vt), Te = {};
Te.absoluteValue = Te.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Te.comparedTo = Te.cmp = function(e) {
  var t, n, r, i, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (r = o.d.length, i = e.d.length, t = 0, n = r < i ? r : i; t < n; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ o.s < 0 ? 1 : -1;
};
Te.decimalPlaces = Te.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * Vt;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
Te.dividedBy = Te.div = function(e) {
  return jo(this, new this.constructor(e));
};
Te.dividedToIntegerBy = Te.idiv = function(e) {
  var t = this, n = t.constructor;
  return Nt(jo(t, new n(e), 0, 1), n.precision);
};
Te.equals = Te.eq = function(e) {
  return !this.cmp(e);
};
Te.exponent = function() {
  return mn(this);
};
Te.greaterThan = Te.gt = function(e) {
  return this.cmp(e) > 0;
};
Te.greaterThanOrEqualTo = Te.gte = function(e) {
  return this.cmp(e) >= 0;
};
Te.isInteger = Te.isint = function() {
  return this.e > this.d.length - 2;
};
Te.isNegative = Te.isneg = function() {
  return this.s < 0;
};
Te.isPositive = Te.ispos = function() {
  return this.s > 0;
};
Te.isZero = function() {
  return this.s === 0;
};
Te.lessThan = Te.lt = function(e) {
  return this.cmp(e) < 0;
};
Te.lessThanOrEqualTo = Te.lte = function(e) {
  return this.cmp(e) < 1;
};
Te.logarithm = Te.log = function(e) {
  var t, n = this, r = n.constructor, i = r.precision, o = i + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(Fr)) throw Error(di + "NaN");
  if (n.s < 1) throw Error(di + (n.s ? "NaN" : "-Infinity"));
  return n.eq(Fr) ? new r(0) : (qt = !1, t = jo(jf(n, o), jf(e, o), o), qt = !0, Nt(t, i));
};
Te.minus = Te.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? gF(t, e) : pF(t, (e.s = -e.s, e));
};
Te.modulo = Te.mod = function(e) {
  var t, n = this, r = n.constructor, i = r.precision;
  if (e = new r(e), !e.s) throw Error(di + "NaN");
  return n.s ? (qt = !1, t = jo(n, e, 0, 1).times(e), qt = !0, n.minus(t)) : Nt(new r(n), i);
};
Te.naturalExponential = Te.exp = function() {
  return mF(this);
};
Te.naturalLogarithm = Te.ln = function() {
  return jf(this);
};
Te.negated = Te.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Te.plus = Te.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? pF(t, e) : gF(t, (e.s = -e.s, e));
};
Te.precision = Te.sd = function(e) {
  var t, n, r, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Ns + e);
  if (t = mn(i) + 1, r = i.d.length - 1, n = r * Vt + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = i.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
Te.squareRoot = Te.sqrt = function() {
  var e, t, n, r, i, o, a, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new l(0);
    throw Error(di + "NaN");
  }
  for (e = mn(s), qt = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Vi(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = Zc((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new l(t)) : r = new l(i.toString()), n = l.precision, i = a = n + 3; ; )
    if (o = r, r = o.plus(jo(s, o, a + 2)).times(0.5), Vi(o.d).slice(0, a) === (t = Vi(r.d)).slice(0, a)) {
      if (t = t.slice(a - 3, a + 1), i == a && t == "4999") {
        if (Nt(o, n + 1, 0), o.times(o).eq(s)) {
          r = o;
          break;
        }
      } else if (t != "9999")
        break;
      a += 4;
    }
  return qt = !0, Nt(r, n);
};
Te.times = Te.mul = function(e) {
  var t, n, r, i, o, a, s, l, c, f = this, d = f.constructor, p = f.d, m = (e = new d(e)).d;
  if (!f.s || !e.s) return new d(0);
  for (e.s *= f.s, n = f.e + e.e, l = p.length, c = m.length, l < c && (o = p, p = m, m = o, a = l, l = c, c = a), o = [], a = l + c, r = a; r--; ) o.push(0);
  for (r = c; --r >= 0; ) {
    for (t = 0, i = l + r; i > r; )
      s = o[i] + m[r] * p[i - r - 1] + t, o[i--] = s % En | 0, t = s / En | 0;
    o[i] = (o[i] + t) % En | 0;
  }
  for (; !o[--a]; ) o.pop();
  return t ? ++n : o.shift(), e.d = o, e.e = n, qt ? Nt(e, d.precision) : e;
};
Te.toDecimalPlaces = Te.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (to(e, 0, Xc), t === void 0 ? t = r.rounding : to(t, 0, 8), Nt(n, e + mn(n) + 1, t));
};
Te.toExponential = function(e, t) {
  var n, r = this, i = r.constructor;
  return e === void 0 ? n = Vs(r, !0) : (to(e, 0, Xc), t === void 0 ? t = i.rounding : to(t, 0, 8), r = Nt(new i(r), e + 1, t), n = Vs(r, !0, e + 1)), n;
};
Te.toFixed = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? Vs(i) : (to(e, 0, Xc), t === void 0 ? t = o.rounding : to(t, 0, 8), r = Nt(new o(i), e + mn(i) + 1, t), n = Vs(r.abs(), !1, e + mn(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
Te.toInteger = Te.toint = function() {
  var e = this, t = e.constructor;
  return Nt(new t(e), mn(e) + 1, t.rounding);
};
Te.toNumber = function() {
  return +this;
};
Te.toPower = Te.pow = function(e) {
  var t, n, r, i, o, a, s = this, l = s.constructor, c = 12, f = +(e = new l(e));
  if (!e.s) return new l(Fr);
  if (s = new l(s), !s.s) {
    if (e.s < 1) throw Error(di + "Infinity");
    return s;
  }
  if (s.eq(Fr)) return s;
  if (r = l.precision, e.eq(Fr)) return Nt(s, r);
  if (t = e.e, n = e.d.length - 1, a = t >= n, o = s.s, a) {
    if ((n = f < 0 ? -f : f) <= hF) {
      for (i = new l(Fr), t = Math.ceil(r / Vt + 4), qt = !1; n % 2 && (i = i.times(s), $M(i.d, t)), n = Zc(n / 2), n !== 0; )
        s = s.times(s), $M(s.d, t);
      return qt = !0, e.s < 0 ? new l(Fr).div(i) : Nt(i, r);
    }
  } else if (o < 0) throw Error(di + "NaN");
  return o = o < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, qt = !1, i = e.times(jf(s, r + c)), qt = !0, i = mF(i), i.s = o, i;
};
Te.toPrecision = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? (n = mn(i), r = Vs(i, n <= o.toExpNeg || n >= o.toExpPos)) : (to(e, 1, Xc), t === void 0 ? t = o.rounding : to(t, 0, 8), i = Nt(new o(i), e, t), n = mn(i), r = Vs(i, e <= n || n <= o.toExpNeg, e)), r;
};
Te.toSignificantDigits = Te.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (to(e, 1, Xc), t === void 0 ? t = r.rounding : to(t, 0, 8)), Nt(new r(n), e, t);
};
Te.toString = Te.valueOf = Te.val = Te.toJSON = Te[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = mn(e), n = e.constructor;
  return Vs(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function pF(e, t) {
  var n, r, i, o, a, s, l, c, f = e.constructor, d = f.precision;
  if (!e.s || !t.s)
    return t.s || (t = new f(e)), qt ? Nt(t, d) : t;
  if (l = e.d, c = t.d, a = e.e, i = t.e, l = l.slice(), o = a - i, o) {
    for (o < 0 ? (r = l, o = -o, s = c.length) : (r = c, i = a, s = l.length), a = Math.ceil(d / Vt), s = a > s ? a + 1 : s + 1, o > s && (o = s, r.length = 1), r.reverse(); o--; ) r.push(0);
    r.reverse();
  }
  for (s = l.length, o = c.length, s - o < 0 && (o = s, r = c, c = l, l = r), n = 0; o; )
    n = (l[--o] = l[o] + c[o] + n) / En | 0, l[o] %= En;
  for (n && (l.unshift(n), ++i), s = l.length; l[--s] == 0; ) l.pop();
  return t.d = l, t.e = i, qt ? Nt(t, d) : t;
}
function to(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(Ns + e);
}
function Vi(e) {
  var t, n, r, i = e.length - 1, o = "", a = e[0];
  if (i > 0) {
    for (o += a, t = 1; t < i; t++)
      r = e[t] + "", n = Vt - r.length, n && (o += xa(n)), o += r;
    a = e[t], r = a + "", n = Vt - r.length, n && (o += xa(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return o + a;
}
var jo = /* @__PURE__ */ function() {
  function e(r, i) {
    var o, a = 0, s = r.length;
    for (r = r.slice(); s--; )
      o = r[s] * i + a, r[s] = o % En | 0, a = o / En | 0;
    return a && r.unshift(a), r;
  }
  function t(r, i, o, a) {
    var s, l;
    if (o != a)
      l = o > a ? 1 : -1;
    else
      for (s = l = 0; s < o; s++)
        if (r[s] != i[s]) {
          l = r[s] > i[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function n(r, i, o) {
    for (var a = 0; o--; )
      r[o] -= a, a = r[o] < i[o] ? 1 : 0, r[o] = a * En + r[o] - i[o];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, o, a) {
    var s, l, c, f, d, p, m, g, v, y, x, w, S, A, _, O, T, C, k = r.constructor, D = r.s == i.s ? 1 : -1, N = r.d, $ = i.d;
    if (!r.s) return new k(r);
    if (!i.s) throw Error(di + "Division by zero");
    for (l = r.e - i.e, T = $.length, _ = N.length, m = new k(D), g = m.d = [], c = 0; $[c] == (N[c] || 0); ) ++c;
    if ($[c] > (N[c] || 0) && --l, o == null ? w = o = k.precision : a ? w = o + (mn(r) - mn(i)) + 1 : w = o, w < 0) return new k(0);
    if (w = w / Vt + 2 | 0, c = 0, T == 1)
      for (f = 0, $ = $[0], w++; (c < _ || f) && w--; c++)
        S = f * En + (N[c] || 0), g[c] = S / $ | 0, f = S % $ | 0;
    else {
      for (f = En / ($[0] + 1) | 0, f > 1 && ($ = e($, f), N = e(N, f), T = $.length, _ = N.length), A = T, v = N.slice(0, T), y = v.length; y < T; ) v[y++] = 0;
      C = $.slice(), C.unshift(0), O = $[0], $[1] >= En / 2 && ++O;
      do
        f = 0, s = t($, v, T, y), s < 0 ? (x = v[0], T != y && (x = x * En + (v[1] || 0)), f = x / O | 0, f > 1 ? (f >= En && (f = En - 1), d = e($, f), p = d.length, y = v.length, s = t(d, v, p, y), s == 1 && (f--, n(d, T < p ? C : $, p))) : (f == 0 && (s = f = 1), d = $.slice()), p = d.length, p < y && d.unshift(0), n(v, d, y), s == -1 && (y = v.length, s = t($, v, T, y), s < 1 && (f++, n(v, T < y ? C : $, y))), y = v.length) : s === 0 && (f++, v = [0]), g[c++] = f, s && v[0] ? v[y++] = N[A] || 0 : (v = [N[A]], y = 1);
      while ((A++ < _ || v[0] !== void 0) && w--);
    }
    return g[0] || g.shift(), m.e = l, Nt(m, a ? o + mn(m) + 1 : o);
  };
}();
function mF(e, t) {
  var n, r, i, o, a, s, l = 0, c = 0, f = e.constructor, d = f.precision;
  if (mn(e) > 16) throw Error(bS + mn(e));
  if (!e.s) return new f(Fr);
  for (t == null ? (qt = !1, s = d) : s = t, a = new f(0.03125); e.abs().gte(0.1); )
    e = e.times(a), c += 5;
  for (r = Math.log(vs(2, c)) / Math.LN10 * 2 + 5 | 0, s += r, n = i = o = new f(Fr), f.precision = s; ; ) {
    if (i = Nt(i.times(e), s), n = n.times(++l), a = o.plus(jo(i, n, s)), Vi(a.d).slice(0, s) === Vi(o.d).slice(0, s)) {
      for (; c--; ) o = Nt(o.times(o), s);
      return f.precision = d, t == null ? (qt = !0, Nt(o, d)) : o;
    }
    o = a;
  }
}
function mn(e) {
  for (var t = e.e * Vt, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function Ub(e, t, n) {
  if (t > e.LN10.sd())
    throw qt = !0, n && (e.precision = n), Error(di + "LN10 precision limit exceeded");
  return Nt(new e(e.LN10), t);
}
function xa(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function jf(e, t) {
  var n, r, i, o, a, s, l, c, f, d = 1, p = 10, m = e, g = m.d, v = m.constructor, y = v.precision;
  if (m.s < 1) throw Error(di + (m.s ? "NaN" : "-Infinity"));
  if (m.eq(Fr)) return new v(0);
  if (t == null ? (qt = !1, c = y) : c = t, m.eq(10))
    return t == null && (qt = !0), Ub(v, c);
  if (c += p, v.precision = c, n = Vi(g), r = n.charAt(0), o = mn(m), Math.abs(o) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      m = m.times(e), n = Vi(m.d), r = n.charAt(0), d++;
    o = mn(m), r > 1 ? (m = new v("0." + n), o++) : m = new v(r + "." + n.slice(1));
  } else
    return l = Ub(v, c + 2, y).times(o + ""), m = jf(new v(r + "." + n.slice(1)), c - p).plus(l), v.precision = y, t == null ? (qt = !0, Nt(m, y)) : m;
  for (s = a = m = jo(m.minus(Fr), m.plus(Fr), c), f = Nt(m.times(m), c), i = 3; ; ) {
    if (a = Nt(a.times(f), c), l = s.plus(jo(a, new v(i), c)), Vi(l.d).slice(0, c) === Vi(s.d).slice(0, c))
      return s = s.times(2), o !== 0 && (s = s.plus(Ub(v, c + 2, y).times(o + ""))), s = jo(s, new v(d), c), v.precision = y, t == null ? (qt = !0, Nt(s, y)) : s;
    s = l, i += 2;
  }
}
function NM(e, t) {
  var n, r, i;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(r, i), t) {
    if (i -= r, n = n - r - 1, e.e = Zc(n / Vt), e.d = [], r = (n + 1) % Vt, n < 0 && (r += Vt), r < i) {
      for (r && e.d.push(+t.slice(0, r)), i -= Vt; r < i; ) e.d.push(+t.slice(r, r += Vt));
      t = t.slice(r), r = Vt - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    if (e.d.push(+t), qt && (e.e > gm || e.e < -gm)) throw Error(bS + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Nt(e, t, n) {
  var r, i, o, a, s, l, c, f, d = e.d;
  for (a = 1, o = d[0]; o >= 10; o /= 10) a++;
  if (r = t - a, r < 0)
    r += Vt, i = t, c = d[f = 0];
  else {
    if (f = Math.ceil((r + 1) / Vt), o = d.length, f >= o) return e;
    for (c = o = d[f], a = 1; o >= 10; o /= 10) a++;
    r %= Vt, i = r - Vt + a;
  }
  if (n !== void 0 && (o = vs(10, a - i - 1), s = c / o % 10 | 0, l = t < 0 || d[f + 1] !== void 0 || c % o, l = n < 4 ? (s || l) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || l || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? c / vs(10, a - i) : 0 : d[f - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !d[0])
    return l ? (o = mn(e), d.length = 1, t = t - o - 1, d[0] = vs(10, (Vt - t % Vt) % Vt), e.e = Zc(-t / Vt) || 0) : (d.length = 1, d[0] = e.e = e.s = 0), e;
  if (r == 0 ? (d.length = f, o = 1, f--) : (d.length = f + 1, o = vs(10, Vt - r), d[f] = i > 0 ? (c / vs(10, a - i) % vs(10, i) | 0) * o : 0), l)
    for (; ; )
      if (f == 0) {
        (d[0] += o) == En && (d[0] = 1, ++e.e);
        break;
      } else {
        if (d[f] += o, d[f] != En) break;
        d[f--] = 0, o = 1;
      }
  for (r = d.length; d[--r] === 0; ) d.pop();
  if (qt && (e.e > gm || e.e < -gm))
    throw Error(bS + mn(e));
  return e;
}
function gF(e, t) {
  var n, r, i, o, a, s, l, c, f, d, p = e.constructor, m = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), qt ? Nt(t, m) : t;
  if (l = e.d, d = t.d, r = t.e, c = e.e, l = l.slice(), a = c - r, a) {
    for (f = a < 0, f ? (n = l, a = -a, s = d.length) : (n = d, r = c, s = l.length), i = Math.max(Math.ceil(m / Vt), s) + 2, a > i && (a = i, n.length = 1), n.reverse(), i = a; i--; ) n.push(0);
    n.reverse();
  } else {
    for (i = l.length, s = d.length, f = i < s, f && (s = i), i = 0; i < s; i++)
      if (l[i] != d[i]) {
        f = l[i] < d[i];
        break;
      }
    a = 0;
  }
  for (f && (n = l, l = d, d = n, t.s = -t.s), s = l.length, i = d.length - s; i > 0; --i) l[s++] = 0;
  for (i = d.length; i > a; ) {
    if (l[--i] < d[i]) {
      for (o = i; o && l[--o] === 0; ) l[o] = En - 1;
      --l[o], l[i] += En;
    }
    l[i] -= d[i];
  }
  for (; l[--s] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (t.d = l, t.e = r, qt ? Nt(t, m) : t) : new p(0);
}
function Vs(e, t, n) {
  var r, i = mn(e), o = Vi(e.d), a = o.length;
  return t ? (n && (r = n - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + xa(r) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + xa(-i - 1) + o, n && (r = n - a) > 0 && (o += xa(r))) : i >= a ? (o += xa(i + 1 - a), n && (r = n - i - 1) > 0 && (o = o + "." + xa(r))) : ((r = i + 1) < a && (o = o.slice(0, r) + "." + o.slice(r)), n && (r = n - a) > 0 && (i + 1 === a && (o += "."), o += xa(r))), e.s < 0 ? "-" + o : o;
}
function $M(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function yF(e) {
  var t, n, r;
  function i(o) {
    var a = this;
    if (!(a instanceof i)) return new i(o);
    if (a.constructor = i, o instanceof i) {
      a.s = o.s, a.e = o.e, a.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(Ns + o);
      if (o > 0)
        a.s = 1;
      else if (o < 0)
        o = -o, a.s = -1;
      else {
        a.s = 0, a.e = 0, a.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        a.e = 0, a.d = [o];
        return;
      }
      return NM(a, o.toString());
    } else if (typeof o != "string")
      throw Error(Ns + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), a.s = -1) : a.s = 1, b0e.test(o)) NM(a, o);
    else throw Error(Ns + o);
  }
  if (i.prototype = Te, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = yF, i.config = i.set = x0e, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return i.config(e), i;
}
function x0e(e) {
  if (!e || typeof e != "object")
    throw Error(di + "Object expected");
  var t, n, r, i = [
    "precision",
    1,
    Xc,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((r = e[n = i[t]]) !== void 0)
      if (Zc(r) === r && r >= i[t + 1] && r <= i[t + 2]) this[n] = r;
      else throw Error(Ns + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(Ns + n + ": " + r);
  return this;
}
var xS = yF(v0e);
Fr = new xS(1);
const Tt = xS;
function w0e(e) {
  return A0e(e) || O0e(e) || S0e(e) || _0e();
}
function _0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function S0e(e, t) {
  if (e) {
    if (typeof e == "string") return Gx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Gx(e, t);
  }
}
function O0e(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function A0e(e) {
  if (Array.isArray(e)) return Gx(e);
}
function Gx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var P0e = function(t) {
  return t;
}, vF = {
  "@@functional/placeholder": !0
}, bF = function(t) {
  return t === vF;
}, DM = function(t) {
  return function n() {
    return arguments.length === 0 || arguments.length === 1 && bF(arguments.length <= 0 ? void 0 : arguments[0]) ? n : t.apply(void 0, arguments);
  };
}, T0e = function e(t, n) {
  return t === 1 ? n : DM(function() {
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i.filter(function(s) {
      return s !== vF;
    }).length;
    return a >= t ? n.apply(void 0, i) : e(t - a, DM(function() {
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      var f = i.map(function(d) {
        return bF(d) ? l.shift() : d;
      });
      return n.apply(void 0, w0e(f).concat(l));
    }));
  });
}, uy = function(t) {
  return T0e(t.length, t);
}, Yx = function(t, n) {
  for (var r = [], i = t; i < n; ++i)
    r[i - t] = i;
  return r;
}, C0e = uy(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(n) {
    return t[n];
  }).map(e);
}), E0e = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (!n.length)
    return P0e;
  var i = n.reverse(), o = i[0], a = i.slice(1);
  return function() {
    return a.reduce(function(s, l) {
      return l(s);
    }, o.apply(void 0, arguments));
  };
}, qx = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, xF = function(t) {
  var n = null, r = null;
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return n && o.every(function(s, l) {
      return s === n[l];
    }) || (n = o, r = t.apply(void 0, o)), r;
  };
};
function k0e(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new Tt(e).abs().log(10).toNumber()) + 1, t;
}
function M0e(e, t, n) {
  for (var r = new Tt(e), i = 0, o = []; r.lt(t) && i < 1e5; )
    o.push(r.toNumber()), r = r.add(n), i++;
  return o;
}
var N0e = uy(function(e, t, n) {
  var r = +e, i = +t;
  return r + n * (i - r);
}), $0e = uy(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, (n - e) / r;
}), D0e = uy(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (n - e) / r));
});
const fy = {
  rangeStep: M0e,
  getDigitCount: k0e,
  interpolateNumber: N0e,
  uninterpolateNumber: $0e,
  uninterpolateTruncation: D0e
};
function Xx(e) {
  return j0e(e) || R0e(e) || wF(e) || I0e();
}
function I0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function R0e(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function j0e(e) {
  if (Array.isArray(e)) return Zx(e);
}
function Lf(e, t) {
  return F0e(e) || B0e(e, t) || wF(e, t) || L0e();
}
function L0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wF(e, t) {
  if (e) {
    if (typeof e == "string") return Zx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Zx(e, t);
  }
}
function Zx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function B0e(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (l) {
      i = !0, o = l;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (i) throw o;
      }
    }
    return n;
  }
}
function F0e(e) {
  if (Array.isArray(e)) return e;
}
function _F(e) {
  var t = Lf(e, 2), n = t[0], r = t[1], i = n, o = r;
  return n > r && (i = r, o = n), [i, o];
}
function SF(e, t, n) {
  if (e.lte(0))
    return new Tt(0);
  var r = fy.getDigitCount(e.toNumber()), i = new Tt(10).pow(r), o = e.div(i), a = r !== 1 ? 0.05 : 0.1, s = new Tt(Math.ceil(o.div(a).toNumber())).add(n).mul(a), l = s.mul(i);
  return t ? l : new Tt(Math.ceil(l));
}
function W0e(e, t, n) {
  var r = 1, i = new Tt(e);
  if (!i.isint() && n) {
    var o = Math.abs(e);
    o < 1 ? (r = new Tt(10).pow(fy.getDigitCount(e) - 1), i = new Tt(Math.floor(i.div(r).toNumber())).mul(r)) : o > 1 && (i = new Tt(Math.floor(e)));
  } else e === 0 ? i = new Tt(Math.floor((t - 1) / 2)) : n || (i = new Tt(Math.floor(e)));
  var a = Math.floor((t - 1) / 2), s = E0e(C0e(function(l) {
    return i.add(new Tt(l - a).mul(r)).toNumber();
  }), Yx);
  return s(0, t);
}
function OF(e, t, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (n - 1)))
    return {
      step: new Tt(0),
      tickMin: new Tt(0),
      tickMax: new Tt(0)
    };
  var o = SF(new Tt(t).sub(e).div(n - 1), r, i), a;
  e <= 0 && t >= 0 ? a = new Tt(0) : (a = new Tt(e).add(t).div(2), a = a.sub(new Tt(a).mod(o)));
  var s = Math.ceil(a.sub(e).div(o).toNumber()), l = Math.ceil(new Tt(t).sub(a).div(o).toNumber()), c = s + l + 1;
  return c > n ? OF(e, t, n, r, i + 1) : (c < n && (l = t > 0 ? l + (n - c) : l, s = t > 0 ? s : s + (n - c)), {
    step: o,
    tickMin: a.sub(new Tt(s).mul(o)),
    tickMax: a.add(new Tt(l).mul(o))
  });
}
function z0e(e) {
  var t = Lf(e, 2), n = t[0], r = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = Math.max(i, 2), s = _F([n, r]), l = Lf(s, 2), c = l[0], f = l[1];
  if (c === -1 / 0 || f === 1 / 0) {
    var d = f === 1 / 0 ? [c].concat(Xx(Yx(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Xx(Yx(0, i - 1).map(function() {
      return -1 / 0;
    })), [f]);
    return n > r ? qx(d) : d;
  }
  if (c === f)
    return W0e(c, i, o);
  var p = OF(c, f, a, o), m = p.step, g = p.tickMin, v = p.tickMax, y = fy.rangeStep(g, v.add(new Tt(0.1).mul(m)), m);
  return n > r ? qx(y) : y;
}
function V0e(e, t) {
  var n = Lf(e, 2), r = n[0], i = n[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = _F([r, i]), s = Lf(a, 2), l = s[0], c = s[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [r, i];
  if (l === c)
    return [l];
  var f = Math.max(t, 2), d = SF(new Tt(c).sub(l).div(f - 1), o, 0), p = [].concat(Xx(fy.rangeStep(new Tt(l), new Tt(c).sub(new Tt(0.99).mul(d)), d)), [c]);
  return r > i ? qx(p) : p;
}
var U0e = xF(z0e), K0e = xF(V0e), H0e = process.env.NODE_ENV === "production", Kb = "Invariant failed";
function _r(e, t) {
  if (H0e)
    throw new Error(Kb);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(Kb, ": ").concat(n) : Kb;
  throw new Error(r);
}
var G0e = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function fc(e) {
  "@babel/helpers - typeof";
  return fc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fc(e);
}
function ym() {
  return ym = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ym.apply(this, arguments);
}
function Y0e(e, t) {
  return J0e(e) || Z0e(e, t) || X0e(e, t) || q0e();
}
function q0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X0e(e, t) {
  if (e) {
    if (typeof e == "string") return IM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return IM(e, t);
  }
}
function IM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Z0e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function J0e(e) {
  if (Array.isArray(e)) return e;
}
function Q0e(e, t) {
  if (e == null) return {};
  var n = exe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function exe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function txe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nxe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, TF(r.key), r);
  }
}
function rxe(e, t, n) {
  return t && nxe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ixe(e, t, n) {
  return t = vm(t), oxe(e, AF() ? Reflect.construct(t, n || [], vm(e).constructor) : t.apply(e, n));
}
function oxe(e, t) {
  if (t && (fc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return axe(e);
}
function axe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AF() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (AF = function() {
    return !!e;
  })();
}
function vm(e) {
  return vm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, vm(e);
}
function sxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Jx(e, t);
}
function Jx(e, t) {
  return Jx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Jx(e, t);
}
function PF(e, t, n) {
  return t = TF(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function TF(e) {
  var t = lxe(e, "string");
  return fc(t) == "symbol" ? t : t + "";
}
function lxe(e, t) {
  if (fc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (fc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Md = /* @__PURE__ */ function(e) {
  function t() {
    return txe(this, t), ixe(this, t, arguments);
  }
  return sxe(t, e), rxe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.offset, o = r.layout, a = r.width, s = r.dataKey, l = r.data, c = r.dataPointFormatter, f = r.xAxis, d = r.yAxis, p = Q0e(r, G0e), m = Ee(p, !1);
      this.props.direction === "x" && f.type !== "number" && (process.env.NODE_ENV !== "production" ? _r(!1, 'ErrorBar requires Axis type property to be "number".') : _r());
      var g = l.map(function(v) {
        var y = c(v, s), x = y.x, w = y.y, S = y.value, A = y.errorVal;
        if (!A)
          return null;
        var _ = [], O, T;
        if (Array.isArray(A)) {
          var C = Y0e(A, 2);
          O = C[0], T = C[1];
        } else
          O = T = A;
        if (o === "vertical") {
          var k = f.scale, D = w + i, N = D + a, $ = D - a, B = k(S - O), L = k(S + T);
          _.push({
            x1: L,
            y1: N,
            x2: L,
            y2: $
          }), _.push({
            x1: B,
            y1: D,
            x2: L,
            y2: D
          }), _.push({
            x1: B,
            y1: N,
            x2: B,
            y2: $
          });
        } else if (o === "horizontal") {
          var F = d.scale, W = x + i, z = W - a, G = W + a, V = F(S - O), U = F(S + T);
          _.push({
            x1: z,
            y1: U,
            x2: G,
            y2: U
          }), _.push({
            x1: W,
            y1: V,
            x2: W,
            y2: U
          }), _.push({
            x1: z,
            y1: V,
            x2: G,
            y2: V
          });
        }
        return /* @__PURE__ */ I.createElement(ot, ym({
          className: "recharts-errorBar",
          key: "bar-".concat(_.map(function(Y) {
            return "".concat(Y.x1, "-").concat(Y.x2, "-").concat(Y.y1, "-").concat(Y.y2);
          }))
        }, m), _.map(function(Y) {
          return /* @__PURE__ */ I.createElement("line", ym({}, Y, {
            key: "line-".concat(Y.x1, "-").concat(Y.x2, "-").concat(Y.y1, "-").concat(Y.y2)
          }));
        }));
      });
      return /* @__PURE__ */ I.createElement(ot, {
        className: "recharts-errorBars"
      }, g);
    }
  }]);
}(I.Component);
PF(Md, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
PF(Md, "displayName", "ErrorBar");
function Bf(e) {
  "@babel/helpers - typeof";
  return Bf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bf(e);
}
function RM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? RM(Object(n), !0).forEach(function(r) {
      cxe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : RM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cxe(e, t, n) {
  return t = uxe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function uxe(e) {
  var t = fxe(e, "string");
  return Bf(t) == "symbol" ? t : t + "";
}
function fxe(e, t) {
  if (Bf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Bf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var CF = function(t) {
  var n = t.children, r = t.formattedGraphicalItems, i = t.legendWidth, o = t.legendContent, a = Rr(n, Ro);
  if (!a)
    return null;
  var s = Ro.defaultProps, l = s !== void 0 ? cs(cs({}, s), a.props) : {}, c;
  return a.props && a.props.payload ? c = a.props && a.props.payload : o === "children" ? c = (r || []).reduce(function(f, d) {
    var p = d.item, m = d.props, g = m.sectors || m.data || [];
    return f.concat(g.map(function(v) {
      return {
        type: a.props.iconType || p.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : c = (r || []).map(function(f) {
    var d = f.item, p = d.type.defaultProps, m = p !== void 0 ? cs(cs({}, p), d.props) : {}, g = m.dataKey, v = m.name, y = m.legendType, x = m.hide;
    return {
      inactive: x,
      dataKey: g,
      type: l.iconType || y || "square",
      color: wS(d),
      value: v || g,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: m
    };
  }), cs(cs(cs({}, l), Ro.getWithHeight(a, i)), {}, {
    payload: c,
    item: a
  });
};
function Ff(e) {
  "@babel/helpers - typeof";
  return Ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ff(e);
}
function jM(e) {
  return mxe(e) || pxe(e) || hxe(e) || dxe();
}
function dxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hxe(e, t) {
  if (e) {
    if (typeof e == "string") return Qx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Qx(e, t);
  }
}
function pxe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function mxe(e) {
  if (Array.isArray(e)) return Qx(e);
}
function Qx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function LM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function nn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? LM(Object(n), !0).forEach(function(r) {
      Gl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Gl(e, t, n) {
  return t = gxe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gxe(e) {
  var t = yxe(e, "string");
  return Ff(t) == "symbol" ? t : t + "";
}
function yxe(e, t) {
  if (Ff(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ff(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ln(e, t, n) {
  return Ue(e) || Ue(t) ? n : Sn(t) ? Wr(e, t, n) : ze(t) ? t(e) : n;
}
function tf(e, t, n, r) {
  var i = p0e(e, function(s) {
    return ln(s, t);
  });
  if (n === "number") {
    var o = i.filter(function(s) {
      return be(s) || parseFloat(s);
    });
    return o.length ? [cy(o), Oa(o)] : [1 / 0, -1 / 0];
  }
  var a = r ? i.filter(function(s) {
    return !Ue(s);
  }) : i;
  return a.map(function(s) {
    return Sn(s) || s instanceof Date ? s : "";
  });
}
var vxe = function(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, a = -1, s = (n = r == null ? void 0 : r.length) !== null && n !== void 0 ? n : 0;
  if (s <= 1)
    return 0;
  if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
    for (var l = o.range, c = 0; c < s; c++) {
      var f = c > 0 ? i[c - 1].coordinate : i[s - 1].coordinate, d = i[c].coordinate, p = c >= s - 1 ? i[0].coordinate : i[c + 1].coordinate, m = void 0;
      if (ur(d - f) !== ur(p - d)) {
        var g = [];
        if (ur(p - d) === ur(l[1] - l[0])) {
          m = p;
          var v = d + l[1] - l[0];
          g[0] = Math.min(v, (v + f) / 2), g[1] = Math.max(v, (v + f) / 2);
        } else {
          m = f;
          var y = p + l[1] - l[0];
          g[0] = Math.min(d, (y + d) / 2), g[1] = Math.max(d, (y + d) / 2);
        }
        var x = [Math.min(d, (m + d) / 2), Math.max(d, (m + d) / 2)];
        if (t > x[0] && t <= x[1] || t >= g[0] && t <= g[1]) {
          a = i[c].index;
          break;
        }
      } else {
        var w = Math.min(f, p), S = Math.max(f, p);
        if (t > (w + d) / 2 && t <= (S + d) / 2) {
          a = i[c].index;
          break;
        }
      }
    }
  else
    for (var A = 0; A < s; A++)
      if (A === 0 && t <= (r[A].coordinate + r[A + 1].coordinate) / 2 || A > 0 && A < s - 1 && t > (r[A].coordinate + r[A - 1].coordinate) / 2 && t <= (r[A].coordinate + r[A + 1].coordinate) / 2 || A === s - 1 && t > (r[A].coordinate + r[A - 1].coordinate) / 2) {
        a = r[A].index;
        break;
      }
  return a;
}, wS = function(t) {
  var n, r = t, i = r.type.displayName, o = (n = t.type) !== null && n !== void 0 && n.defaultProps ? nn(nn({}, t.type.defaultProps), t.props) : t.props, a = o.stroke, s = o.fill, l;
  switch (i) {
    case "Line":
      l = a;
      break;
    case "Area":
    case "Radar":
      l = a && a !== "none" ? a : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, bxe = function(t) {
  var n = t.barSize, r = t.totalSize, i = t.stackGroups, o = i === void 0 ? {} : i;
  if (!o)
    return {};
  for (var a = {}, s = Object.keys(o), l = 0, c = s.length; l < c; l++)
    for (var f = o[s[l]].stackGroups, d = Object.keys(f), p = 0, m = d.length; p < m; p++) {
      var g = f[d[p]], v = g.items, y = g.cateAxisId, x = v.filter(function(T) {
        return Io(T.type).indexOf("Bar") >= 0;
      });
      if (x && x.length) {
        var w = x[0].type.defaultProps, S = w !== void 0 ? nn(nn({}, w), x[0].props) : x[0].props, A = S.barSize, _ = S[y];
        a[_] || (a[_] = []);
        var O = Ue(A) ? n : A;
        a[_].push({
          item: x[0],
          stackList: x.slice(1),
          barSize: Ue(O) ? void 0 : fr(O, r, 0)
        });
      }
    }
  return a;
}, xxe = function(t) {
  var n = t.barGap, r = t.barCategoryGap, i = t.bandSize, o = t.sizeList, a = o === void 0 ? [] : o, s = t.maxBarSize, l = a.length;
  if (l < 1) return null;
  var c = fr(n, i, 0, !0), f, d = [];
  if (a[0].barSize === +a[0].barSize) {
    var p = !1, m = i / l, g = a.reduce(function(A, _) {
      return A + _.barSize || 0;
    }, 0);
    g += (l - 1) * c, g >= i && (g -= (l - 1) * c, c = 0), g >= i && m > 0 && (p = !0, m *= 0.9, g = l * m);
    var v = (i - g) / 2 >> 0, y = {
      offset: v - c,
      size: 0
    };
    f = a.reduce(function(A, _) {
      var O = {
        item: _.item,
        position: {
          offset: y.offset + y.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: p ? m : _.barSize
        }
      }, T = [].concat(jM(A), [O]);
      return y = T[T.length - 1].position, _.stackList && _.stackList.length && _.stackList.forEach(function(C) {
        T.push({
          item: C,
          position: y
        });
      }), T;
    }, d);
  } else {
    var x = fr(r, i, 0, !0);
    i - 2 * x - (l - 1) * c <= 0 && (c = 0);
    var w = (i - 2 * x - (l - 1) * c) / l;
    w > 1 && (w >>= 0);
    var S = s === +s ? Math.min(w, s) : w;
    f = a.reduce(function(A, _, O) {
      var T = [].concat(jM(A), [{
        item: _.item,
        position: {
          offset: x + (w + c) * O + (w - S) / 2,
          size: S
        }
      }]);
      return _.stackList && _.stackList.length && _.stackList.forEach(function(C) {
        T.push({
          item: C,
          position: T[T.length - 1].position
        });
      }), T;
    }, d);
  }
  return f;
}, wxe = function(t, n, r, i) {
  var o = r.children, a = r.width, s = r.margin, l = a - (s.left || 0) - (s.right || 0), c = CF({
    children: o,
    legendWidth: l
  });
  if (c) {
    var f = i || {}, d = f.width, p = f.height, m = c.align, g = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && g === "middle") && m !== "center" && be(t[m]))
      return nn(nn({}, t), {}, Gl({}, m, t[m] + (d || 0)));
    if ((v === "horizontal" || v === "vertical" && m === "center") && g !== "middle" && be(t[g]))
      return nn(nn({}, t), {}, Gl({}, g, t[g] + (p || 0)));
  }
  return t;
}, _xe = function(t, n, r) {
  return Ue(n) ? !0 : t === "horizontal" ? n === "yAxis" : t === "vertical" || r === "x" ? n === "xAxis" : r === "y" ? n === "yAxis" : !0;
}, EF = function(t, n, r, i, o) {
  var a = n.props.children, s = zr(a, Md).filter(function(c) {
    return _xe(i, o, c.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, f) {
      var d = ln(f, r);
      if (Ue(d)) return c;
      var p = Array.isArray(d) ? [cy(d), Oa(d)] : [d, d], m = l.reduce(function(g, v) {
        var y = ln(f, v, 0), x = p[0] - Math.abs(Array.isArray(y) ? y[0] : y), w = p[1] + Math.abs(Array.isArray(y) ? y[1] : y);
        return [Math.min(x, g[0]), Math.max(w, g[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(m[0], c[0]), Math.max(m[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, Sxe = function(t, n, r, i, o) {
  var a = n.map(function(s) {
    return EF(t, s, r, o, i);
  }).filter(function(s) {
    return !Ue(s);
  });
  return a && a.length ? a.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, kF = function(t, n, r, i, o) {
  var a = n.map(function(l) {
    var c = l.props.dataKey;
    return r === "number" && c && EF(t, l, c, i) || tf(t, c, r, o);
  });
  if (r === "number")
    return a.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return a.reduce(function(l, c) {
    for (var f = 0, d = c.length; f < d; f++)
      s[c[f]] || (s[c[f]] = !0, l.push(c[f]));
    return l;
  }, []);
}, MF = function(t, n) {
  return t === "horizontal" && n === "xAxis" || t === "vertical" && n === "yAxis" || t === "centric" && n === "angleAxis" || t === "radial" && n === "radiusAxis";
}, NF = function(t, n, r, i) {
  if (i)
    return t.map(function(l) {
      return l.coordinate;
    });
  var o, a, s = t.map(function(l) {
    return l.coordinate === n && (o = !0), l.coordinate === r && (a = !0), l.coordinate;
  });
  return o || s.push(n), a || s.push(r), s;
}, Eo = function(t, n, r) {
  if (!t) return null;
  var i = t.scale, o = t.duplicateDomain, a = t.type, s = t.range, l = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, c = (n || r) && a === "category" && i.bandwidth ? i.bandwidth() / l : 0;
  if (c = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? ur(s[0] - s[1]) * 2 * c : c, n && (t.ticks || t.niceTicks)) {
    var f = (t.ticks || t.niceTicks).map(function(d) {
      var p = o ? o.indexOf(d) : d;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(p) + c,
        value: d,
        offset: c
      };
    });
    return f.filter(function(d) {
      return !Kc(d.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(d, p) {
    return {
      coordinate: i(d) + c,
      value: d,
      index: p,
      offset: c
    };
  }) : i.ticks && !r ? i.ticks(t.tickCount).map(function(d) {
    return {
      coordinate: i(d) + c,
      value: d,
      offset: c
    };
  }) : i.domain().map(function(d, p) {
    return {
      coordinate: i(d) + c,
      value: o ? o[d] : d,
      index: p,
      offset: c
    };
  });
}, Hb = /* @__PURE__ */ new WeakMap(), Yh = function(t, n) {
  if (typeof n != "function")
    return t;
  Hb.has(t) || Hb.set(t, /* @__PURE__ */ new WeakMap());
  var r = Hb.get(t);
  if (r.has(n))
    return r.get(n);
  var i = function() {
    t.apply(void 0, arguments), n.apply(void 0, arguments);
  };
  return r.set(n, i), i;
}, $F = function(t, n, r) {
  var i = t.scale, o = t.type, a = t.layout, s = t.axisType;
  if (i === "auto")
    return a === "radial" && s === "radiusAxis" ? {
      scale: Nf(),
      realScaleType: "band"
    } : a === "radial" && s === "angleAxis" ? {
      scale: dm(),
      realScaleType: "linear"
    } : o === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: ef(),
      realScaleType: "point"
    } : o === "category" ? {
      scale: Nf(),
      realScaleType: "band"
    } : {
      scale: dm(),
      realScaleType: "linear"
    };
  if (Ad(i)) {
    var l = "scale".concat(qg(i));
    return {
      scale: (MM[l] || ef)(),
      realScaleType: MM[l] ? l : "point"
    };
  }
  return ze(i) ? {
    scale: i
  } : {
    scale: ef(),
    realScaleType: "point"
  };
}, BM = 1e-4, DF = function(t) {
  var n = t.domain();
  if (!(!n || n.length <= 2)) {
    var r = n.length, i = t.range(), o = Math.min(i[0], i[1]) - BM, a = Math.max(i[0], i[1]) + BM, s = t(n[0]), l = t(n[r - 1]);
    (s < o || s > a || l < o || l > a) && t.domain([n[0], n[r - 1]]);
  }
}, Oxe = function(t, n) {
  if (!t)
    return null;
  for (var r = 0, i = t.length; r < i; r++)
    if (t[r].item === n)
      return t[r].position;
  return null;
}, Axe = function(t, n) {
  if (!n || n.length !== 2 || !be(n[0]) || !be(n[1]))
    return t;
  var r = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]), o = [t[0], t[1]];
  return (!be(t[0]) || t[0] < r) && (o[0] = r), (!be(t[1]) || t[1] > i) && (o[1] = i), o[0] > i && (o[0] = i), o[1] < r && (o[1] = r), o;
}, Pxe = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0, s = 0; s < n; ++s) {
        var l = Kc(t[s][r][1]) ? t[s][r][0] : t[s][r][1];
        l >= 0 ? (t[s][r][0] = o, t[s][r][1] = o + l, o = t[s][r][1]) : (t[s][r][0] = a, t[s][r][1] = a + l, a = t[s][r][1]);
      }
}, Txe = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0; a < n; ++a) {
        var s = Kc(t[a][r][1]) ? t[a][r][0] : t[a][r][1];
        s >= 0 ? (t[a][r][0] = o, t[a][r][1] = o + s, o = t[a][r][1]) : (t[a][r][0] = 0, t[a][r][1] = 0);
      }
}, Cxe = {
  sign: Pxe,
  // @ts-expect-error definitelytyped types are incorrect
  expand: Gse,
  // @ts-expect-error definitelytyped types are incorrect
  none: rc,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: Yse,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: qse,
  positive: Txe
}, Exe = function(t, n, r) {
  var i = n.map(function(s) {
    return s.props.dataKey;
  }), o = Cxe[r], a = Hse().keys(i).value(function(s, l) {
    return +ln(s, l, 0);
  }).order(Ox).offset(o);
  return a(t);
}, kxe = function(t, n, r, i, o, a) {
  if (!t)
    return null;
  var s = a ? n.reverse() : n, l = {}, c = s.reduce(function(d, p) {
    var m, g = (m = p.type) !== null && m !== void 0 && m.defaultProps ? nn(nn({}, p.type.defaultProps), p.props) : p.props, v = g.stackId, y = g.hide;
    if (y)
      return d;
    var x = g[r], w = d[x] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Sn(v)) {
      var S = w.stackGroups[v] || {
        numericAxisId: r,
        cateAxisId: i,
        items: []
      };
      S.items.push(p), w.hasStack = !0, w.stackGroups[v] = S;
    } else
      w.stackGroups[Qs("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: i,
        items: [p]
      };
    return nn(nn({}, d), {}, Gl({}, x, w));
  }, l), f = {};
  return Object.keys(c).reduce(function(d, p) {
    var m = c[p];
    if (m.hasStack) {
      var g = {};
      m.stackGroups = Object.keys(m.stackGroups).reduce(function(v, y) {
        var x = m.stackGroups[y];
        return nn(nn({}, v), {}, Gl({}, y, {
          numericAxisId: r,
          cateAxisId: i,
          items: x.items,
          stackedData: Exe(t, x.items, o)
        }));
      }, g);
    }
    return nn(nn({}, d), {}, Gl({}, p, m));
  }, f);
}, IF = function(t, n) {
  var r = n.realScaleType, i = n.type, o = n.tickCount, a = n.originalDomain, s = n.allowDecimals, l = r || n.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (o && i === "number" && a && (a[0] === "auto" || a[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var f = U0e(c, o, s);
    return t.domain([cy(f), Oa(f)]), {
      niceTicks: f
    };
  }
  if (o && i === "number") {
    var d = t.domain(), p = K0e(d, o, s);
    return {
      niceTicks: p
    };
  }
  return null;
};
function bm(e) {
  var t = e.axis, n = e.ticks, r = e.bandSize, i = e.entry, o = e.index, a = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !Ue(i[t.dataKey])) {
      var s = Kp(n, "value", i[t.dataKey]);
      if (s)
        return s.coordinate + r / 2;
    }
    return n[o] ? n[o].coordinate + r / 2 : null;
  }
  var l = ln(i, Ue(a) ? t.dataKey : a);
  return Ue(l) ? null : t.scale(l);
}
var FM = function(t) {
  var n = t.axis, r = t.ticks, i = t.offset, o = t.bandSize, a = t.entry, s = t.index;
  if (n.type === "category")
    return r[s] ? r[s].coordinate + i : null;
  var l = ln(a, n.dataKey, n.domain[s]);
  return Ue(l) ? null : n.scale(l) - o / 2 + i;
}, Mxe = function(t) {
  var n = t.numericAxis, r = n.scale.domain();
  if (n.type === "number") {
    var i = Math.min(r[0], r[1]), o = Math.max(r[0], r[1]);
    return i <= 0 && o >= 0 ? 0 : o < 0 ? o : i;
  }
  return r[0];
}, Nxe = function(t, n) {
  var r, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? nn(nn({}, t.type.defaultProps), t.props) : t.props, o = i.stackId;
  if (Sn(o)) {
    var a = n[o];
    if (a) {
      var s = a.items.indexOf(t);
      return s >= 0 ? a.stackedData[s] : null;
    }
  }
  return null;
}, $xe = function(t) {
  return t.reduce(function(n, r) {
    return [cy(r.concat([n[0]]).filter(be)), Oa(r.concat([n[1]]).filter(be))];
  }, [1 / 0, -1 / 0]);
}, RF = function(t, n, r) {
  return Object.keys(t).reduce(function(i, o) {
    var a = t[o], s = a.stackedData, l = s.reduce(function(c, f) {
      var d = $xe(f.slice(n, r + 1));
      return [Math.min(c[0], d[0]), Math.max(c[1], d[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], i[0]), Math.max(l[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, WM = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, zM = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, ew = function(t, n, r) {
  if (ze(t))
    return t(n, r);
  if (!Array.isArray(t))
    return n;
  var i = [];
  if (be(t[0]))
    i[0] = r ? t[0] : Math.min(t[0], n[0]);
  else if (WM.test(t[0])) {
    var o = +WM.exec(t[0])[1];
    i[0] = n[0] - o;
  } else ze(t[0]) ? i[0] = t[0](n[0]) : i[0] = n[0];
  if (be(t[1]))
    i[1] = r ? t[1] : Math.max(t[1], n[1]);
  else if (zM.test(t[1])) {
    var a = +zM.exec(t[1])[1];
    i[1] = n[1] + a;
  } else ze(t[1]) ? i[1] = t[1](n[1]) : i[1] = n[1];
  return i;
}, xm = function(t, n, r) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!r || i > 0)
      return i;
  }
  if (t && n && n.length >= 2) {
    for (var o = Y_(n, function(d) {
      return d.coordinate;
    }), a = 1 / 0, s = 1, l = o.length; s < l; s++) {
      var c = o[s], f = o[s - 1];
      a = Math.min((c.coordinate || 0) - (f.coordinate || 0), a);
    }
    return a === 1 / 0 ? 0 : a;
  }
  return r ? void 0 : 0;
}, VM = function(t, n, r) {
  return !t || !t.length || zs(t, Wr(r, "type.defaultProps.domain")) ? n : t;
}, jF = function(t, n) {
  var r = t.type.defaultProps ? nn(nn({}, t.type.defaultProps), t.props) : t.props, i = r.dataKey, o = r.name, a = r.unit, s = r.formatter, l = r.tooltipType, c = r.chartType, f = r.hide;
  return nn(nn({}, Ee(t, !1)), {}, {
    dataKey: i,
    unit: a,
    formatter: s,
    name: o || i,
    color: wS(t),
    value: ln(n, i),
    type: l,
    payload: n,
    chartType: c,
    hide: f
  });
};
function Wf(e) {
  "@babel/helpers - typeof";
  return Wf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wf(e);
}
function UM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UM(Object(n), !0).forEach(function(r) {
      LF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : UM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function LF(e, t, n) {
  return t = Dxe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Dxe(e) {
  var t = Ixe(e, "string");
  return Wf(t) == "symbol" ? t : t + "";
}
function Ixe(e, t) {
  if (Wf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Wf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rxe(e, t) {
  return Fxe(e) || Bxe(e, t) || Lxe(e, t) || jxe();
}
function jxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lxe(e, t) {
  if (e) {
    if (typeof e == "string") return KM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return KM(e, t);
  }
}
function KM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Bxe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function Fxe(e) {
  if (Array.isArray(e)) return e;
}
var wm = Math.PI / 180, Wxe = function(t) {
  return t * 180 / Math.PI;
}, Lt = function(t, n, r, i) {
  return {
    x: t + Math.cos(-wm * i) * r,
    y: n + Math.sin(-wm * i) * r
  };
}, BF = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (r.left || 0) - (r.right || 0)), Math.abs(n - (r.top || 0) - (r.bottom || 0))) / 2;
}, zxe = function(t, n, r, i, o) {
  var a = t.width, s = t.height, l = t.startAngle, c = t.endAngle, f = fr(t.cx, a, a / 2), d = fr(t.cy, s, s / 2), p = BF(a, s, r), m = fr(t.innerRadius, p, 0), g = fr(t.outerRadius, p, p * 0.8), v = Object.keys(n);
  return v.reduce(function(y, x) {
    var w = n[x], S = w.domain, A = w.reversed, _;
    if (Ue(w.range))
      i === "angleAxis" ? _ = [l, c] : i === "radiusAxis" && (_ = [m, g]), A && (_ = [_[1], _[0]]);
    else {
      _ = w.range;
      var O = _, T = Rxe(O, 2);
      l = T[0], c = T[1];
    }
    var C = $F(w, o), k = C.realScaleType, D = C.scale;
    D.domain(S).range(_), DF(D);
    var N = IF(D, xo(xo({}, w), {}, {
      realScaleType: k
    })), $ = xo(xo(xo({}, w), N), {}, {
      range: _,
      radius: g,
      realScaleType: k,
      scale: D,
      cx: f,
      cy: d,
      innerRadius: m,
      outerRadius: g,
      startAngle: l,
      endAngle: c
    });
    return xo(xo({}, y), {}, LF({}, x, $));
  }, {});
}, Vxe = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return Math.sqrt(Math.pow(r - o, 2) + Math.pow(i - a, 2));
}, Uxe = function(t, n) {
  var r = t.x, i = t.y, o = n.cx, a = n.cy, s = Vxe({
    x: r,
    y: i
  }, {
    x: o,
    y: a
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (r - o) / s, c = Math.acos(l);
  return i > a && (c = 2 * Math.PI - c), {
    radius: s,
    angle: Wxe(c),
    angleInRadian: c
  };
}, Kxe = function(t) {
  var n = t.startAngle, r = t.endAngle, i = Math.floor(n / 360), o = Math.floor(r / 360), a = Math.min(i, o);
  return {
    startAngle: n - a * 360,
    endAngle: r - a * 360
  };
}, Hxe = function(t, n) {
  var r = n.startAngle, i = n.endAngle, o = Math.floor(r / 360), a = Math.floor(i / 360), s = Math.min(o, a);
  return t + s * 360;
}, HM = function(t, n) {
  var r = t.x, i = t.y, o = Uxe({
    x: r,
    y: i
  }, n), a = o.radius, s = o.angle, l = n.innerRadius, c = n.outerRadius;
  if (a < l || a > c)
    return !1;
  if (a === 0)
    return !0;
  var f = Kxe(n), d = f.startAngle, p = f.endAngle, m = s, g;
  if (d <= p) {
    for (; m > p; )
      m -= 360;
    for (; m < d; )
      m += 360;
    g = m >= d && m <= p;
  } else {
    for (; m > d; )
      m -= 360;
    for (; m < p; )
      m += 360;
    g = m >= p && m <= d;
  }
  return g ? xo(xo({}, n), {}, {
    radius: a,
    angle: Hxe(m, n)
  }) : null;
}, FF = function(t) {
  return !/* @__PURE__ */ ut(t) && !ze(t) && typeof t != "boolean" ? t.className : "";
};
function zf(e) {
  "@babel/helpers - typeof";
  return zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zf(e);
}
var Gxe = ["offset"];
function Yxe(e) {
  return Jxe(e) || Zxe(e) || Xxe(e) || qxe();
}
function qxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xxe(e, t) {
  if (e) {
    if (typeof e == "string") return tw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tw(e, t);
  }
}
function Zxe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Jxe(e) {
  if (Array.isArray(e)) return tw(e);
}
function tw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Qxe(e, t) {
  if (e == null) return {};
  var n = ewe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function ewe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function GM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? GM(Object(n), !0).forEach(function(r) {
      twe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : GM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function twe(e, t, n) {
  return t = nwe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nwe(e) {
  var t = rwe(e, "string");
  return zf(t) == "symbol" ? t : t + "";
}
function rwe(e, t) {
  if (zf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (zf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vf() {
  return Vf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vf.apply(this, arguments);
}
var iwe = function(t) {
  var n = t.value, r = t.formatter, i = Ue(t.children) ? n : t.children;
  return ze(r) ? r(i) : i;
}, owe = function(t, n) {
  var r = ur(n - t), i = Math.min(Math.abs(n - t), 360);
  return r * i;
}, awe = function(t, n, r) {
  var i = t.position, o = t.viewBox, a = t.offset, s = t.className, l = o, c = l.cx, f = l.cy, d = l.innerRadius, p = l.outerRadius, m = l.startAngle, g = l.endAngle, v = l.clockWise, y = (d + p) / 2, x = owe(m, g), w = x >= 0 ? 1 : -1, S, A;
  i === "insideStart" ? (S = m + w * a, A = v) : i === "insideEnd" ? (S = g - w * a, A = !v) : i === "end" && (S = g + w * a, A = v), A = x <= 0 ? A : !A;
  var _ = Lt(c, f, y, S), O = Lt(c, f, y, S + (A ? 1 : -1) * 359), T = "M".concat(_.x, ",").concat(_.y, `
    A`).concat(y, ",").concat(y, ",0,1,").concat(A ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), C = Ue(t.id) ? Qs("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ I.createElement("text", Vf({}, r, {
    dominantBaseline: "central",
    className: Ye("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("path", {
    id: C,
    d: T
  })), /* @__PURE__ */ I.createElement("textPath", {
    xlinkHref: "#".concat(C)
  }, n));
}, swe = function(t) {
  var n = t.viewBox, r = t.offset, i = t.position, o = n, a = o.cx, s = o.cy, l = o.innerRadius, c = o.outerRadius, f = o.startAngle, d = o.endAngle, p = (f + d) / 2;
  if (i === "outside") {
    var m = Lt(a, s, c + r, p), g = m.x, v = m.y;
    return {
      x: g,
      y: v,
      textAnchor: g >= a ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var y = (l + c) / 2, x = Lt(a, s, y, p), w = x.x, S = x.y;
  return {
    x: w,
    y: S,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, lwe = function(t) {
  var n = t.viewBox, r = t.parentViewBox, i = t.offset, o = t.position, a = n, s = a.x, l = a.y, c = a.width, f = a.height, d = f >= 0 ? 1 : -1, p = d * i, m = d > 0 ? "end" : "start", g = d > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, y = v * i, x = v > 0 ? "end" : "start", w = v > 0 ? "start" : "end";
  if (o === "top") {
    var S = {
      x: s + c / 2,
      y: l - d * i,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return bn(bn({}, S), r ? {
      height: Math.max(l - r.y, 0),
      width: c
    } : {});
  }
  if (o === "bottom") {
    var A = {
      x: s + c / 2,
      y: l + f + p,
      textAnchor: "middle",
      verticalAnchor: g
    };
    return bn(bn({}, A), r ? {
      height: Math.max(r.y + r.height - (l + f), 0),
      width: c
    } : {});
  }
  if (o === "left") {
    var _ = {
      x: s - y,
      y: l + f / 2,
      textAnchor: x,
      verticalAnchor: "middle"
    };
    return bn(bn({}, _), r ? {
      width: Math.max(_.x - r.x, 0),
      height: f
    } : {});
  }
  if (o === "right") {
    var O = {
      x: s + c + y,
      y: l + f / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return bn(bn({}, O), r ? {
      width: Math.max(r.x + r.width - O.x, 0),
      height: f
    } : {});
  }
  var T = r ? {
    width: c,
    height: f
  } : {};
  return o === "insideLeft" ? bn({
    x: s + y,
    y: l + f / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, T) : o === "insideRight" ? bn({
    x: s + c - y,
    y: l + f / 2,
    textAnchor: x,
    verticalAnchor: "middle"
  }, T) : o === "insideTop" ? bn({
    x: s + c / 2,
    y: l + p,
    textAnchor: "middle",
    verticalAnchor: g
  }, T) : o === "insideBottom" ? bn({
    x: s + c / 2,
    y: l + f - p,
    textAnchor: "middle",
    verticalAnchor: m
  }, T) : o === "insideTopLeft" ? bn({
    x: s + y,
    y: l + p,
    textAnchor: w,
    verticalAnchor: g
  }, T) : o === "insideTopRight" ? bn({
    x: s + c - y,
    y: l + p,
    textAnchor: x,
    verticalAnchor: g
  }, T) : o === "insideBottomLeft" ? bn({
    x: s + y,
    y: l + f - p,
    textAnchor: w,
    verticalAnchor: m
  }, T) : o === "insideBottomRight" ? bn({
    x: s + c - y,
    y: l + f - p,
    textAnchor: x,
    verticalAnchor: m
  }, T) : Wc(o) && (be(o.x) || _s(o.x)) && (be(o.y) || _s(o.y)) ? bn({
    x: s + fr(o.x, c),
    y: l + fr(o.y, f),
    textAnchor: "end",
    verticalAnchor: "end"
  }, T) : bn({
    x: s + c / 2,
    y: l + f / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, T);
}, cwe = function(t) {
  return "cx" in t && be(t.cx);
};
function _n(e) {
  var t = e.offset, n = t === void 0 ? 5 : t, r = Qxe(e, Gxe), i = bn({
    offset: n
  }, r), o = i.viewBox, a = i.position, s = i.value, l = i.children, c = i.content, f = i.className, d = f === void 0 ? "" : f, p = i.textBreakAll;
  if (!o || Ue(s) && Ue(l) && !/* @__PURE__ */ ut(c) && !ze(c))
    return null;
  if (/* @__PURE__ */ ut(c))
    return /* @__PURE__ */ _t(c, i);
  var m;
  if (ze(c)) {
    if (m = /* @__PURE__ */ Yl(c, i), /* @__PURE__ */ ut(m))
      return m;
  } else
    m = iwe(i);
  var g = cwe(o), v = Ee(i, !0);
  if (g && (a === "insideStart" || a === "insideEnd" || a === "end"))
    return awe(i, m, v);
  var y = g ? swe(i) : lwe(i);
  return /* @__PURE__ */ I.createElement(Ws, Vf({
    className: Ye("recharts-label", d)
  }, v, y, {
    breakAll: p
  }), m);
}
_n.displayName = "Label";
var WF = function(t) {
  var n = t.cx, r = t.cy, i = t.angle, o = t.startAngle, a = t.endAngle, s = t.r, l = t.radius, c = t.innerRadius, f = t.outerRadius, d = t.x, p = t.y, m = t.top, g = t.left, v = t.width, y = t.height, x = t.clockWise, w = t.labelViewBox;
  if (w)
    return w;
  if (be(v) && be(y)) {
    if (be(d) && be(p))
      return {
        x: d,
        y: p,
        width: v,
        height: y
      };
    if (be(m) && be(g))
      return {
        x: m,
        y: g,
        width: v,
        height: y
      };
  }
  return be(d) && be(p) ? {
    x: d,
    y: p,
    width: 0,
    height: 0
  } : be(n) && be(r) ? {
    cx: n,
    cy: r,
    startAngle: o || i || 0,
    endAngle: a || i || 0,
    innerRadius: c || 0,
    outerRadius: f || l || s || 0,
    clockWise: x
  } : t.viewBox ? t.viewBox : {};
}, uwe = function(t, n) {
  return t ? t === !0 ? /* @__PURE__ */ I.createElement(_n, {
    key: "label-implicit",
    viewBox: n
  }) : Sn(t) ? /* @__PURE__ */ I.createElement(_n, {
    key: "label-implicit",
    viewBox: n,
    value: t
  }) : /* @__PURE__ */ ut(t) ? t.type === _n ? /* @__PURE__ */ _t(t, {
    key: "label-implicit",
    viewBox: n
  }) : /* @__PURE__ */ I.createElement(_n, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : ze(t) ? /* @__PURE__ */ I.createElement(_n, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : Wc(t) ? /* @__PURE__ */ I.createElement(_n, Vf({
    viewBox: n
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, fwe = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var i = t.children, o = WF(t), a = zr(i, _n).map(function(l, c) {
    return /* @__PURE__ */ _t(l, {
      viewBox: n || o,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!r)
    return a;
  var s = uwe(t.label, n || o);
  return [s].concat(Yxe(a));
};
_n.parseViewBox = WF;
_n.renderCallByParent = fwe;
function dwe(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var hwe = dwe;
const pwe = /* @__PURE__ */ Et(hwe);
function Uf(e) {
  "@babel/helpers - typeof";
  return Uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uf(e);
}
var mwe = ["valueAccessor"], gwe = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function ywe(e) {
  return wwe(e) || xwe(e) || bwe(e) || vwe();
}
function vwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bwe(e, t) {
  if (e) {
    if (typeof e == "string") return nw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nw(e, t);
  }
}
function xwe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wwe(e) {
  if (Array.isArray(e)) return nw(e);
}
function nw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _m() {
  return _m = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _m.apply(this, arguments);
}
function YM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YM(Object(n), !0).forEach(function(r) {
      _we(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _we(e, t, n) {
  return t = Swe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Swe(e) {
  var t = Owe(e, "string");
  return Uf(t) == "symbol" ? t : t + "";
}
function Owe(e, t) {
  if (Uf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Uf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function XM(e, t) {
  if (e == null) return {};
  var n = Awe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Awe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var Pwe = function(t) {
  return Array.isArray(t.value) ? pwe(t.value) : t.value;
};
function Zi(e) {
  var t = e.valueAccessor, n = t === void 0 ? Pwe : t, r = XM(e, mwe), i = r.data, o = r.dataKey, a = r.clockWise, s = r.id, l = r.textBreakAll, c = XM(r, gwe);
  return !i || !i.length ? null : /* @__PURE__ */ I.createElement(ot, {
    className: "recharts-label-list"
  }, i.map(function(f, d) {
    var p = Ue(o) ? n(f, d) : ln(f && f.payload, o), m = Ue(s) ? {} : {
      id: "".concat(s, "-").concat(d)
    };
    return /* @__PURE__ */ I.createElement(_n, _m({}, Ee(f, !0), c, m, {
      parentViewBox: f.parentViewBox,
      value: p,
      textBreakAll: l,
      viewBox: _n.parseViewBox(Ue(a) ? f : qM(qM({}, f), {}, {
        clockWise: a
      })),
      key: "label-".concat(d),
      index: d
    }));
  }));
}
Zi.displayName = "LabelList";
function Twe(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ I.createElement(Zi, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ I.isValidElement(e) || ze(e) ? /* @__PURE__ */ I.createElement(Zi, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : Wc(e) ? /* @__PURE__ */ I.createElement(Zi, _m({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function Cwe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var r = e.children, i = zr(r, Zi).map(function(a, s) {
    return /* @__PURE__ */ _t(a, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!n)
    return i;
  var o = Twe(e.label, t);
  return [o].concat(ywe(i));
}
Zi.renderCallByParent = Cwe;
function Kf(e) {
  "@babel/helpers - typeof";
  return Kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kf(e);
}
function rw() {
  return rw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rw.apply(this, arguments);
}
function ZM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function JM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZM(Object(n), !0).forEach(function(r) {
      Ewe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ZM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ewe(e, t, n) {
  return t = kwe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function kwe(e) {
  var t = Mwe(e, "string");
  return Kf(t) == "symbol" ? t : t + "";
}
function Mwe(e, t) {
  if (Kf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Kf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Nwe = function(t, n) {
  var r = ur(n - t), i = Math.min(Math.abs(n - t), 359.999);
  return r * i;
}, qh = function(t) {
  var n = t.cx, r = t.cy, i = t.radius, o = t.angle, a = t.sign, s = t.isExternal, l = t.cornerRadius, c = t.cornerIsExternal, f = l * (s ? 1 : -1) + i, d = Math.asin(l / f) / wm, p = c ? o : o + a * d, m = Lt(n, r, f, p), g = Lt(n, r, i, p), v = c ? o - a * d : o, y = Lt(n, r, f * Math.cos(d * wm), v);
  return {
    center: m,
    circleTangency: g,
    lineTangency: y,
    theta: d
  };
}, zF = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.startAngle, s = t.endAngle, l = Nwe(a, s), c = a + l, f = Lt(n, r, o, a), d = Lt(n, r, o, c), p = "M ".concat(f.x, ",").concat(f.y, `
    A `).concat(o, ",").concat(o, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(a > c), `,
    `).concat(d.x, ",").concat(d.y, `
  `);
  if (i > 0) {
    var m = Lt(n, r, i, a), g = Lt(n, r, i, c);
    p += "L ".concat(g.x, ",").concat(g.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(a <= c), `,
            `).concat(m.x, ",").concat(m.y, " Z");
  } else
    p += "L ".concat(n, ",").concat(r, " Z");
  return p;
}, $we = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.cornerRadius, s = t.forceCornerRadius, l = t.cornerIsExternal, c = t.startAngle, f = t.endAngle, d = ur(f - c), p = qh({
    cx: n,
    cy: r,
    radius: o,
    angle: c,
    sign: d,
    cornerRadius: a,
    cornerIsExternal: l
  }), m = p.circleTangency, g = p.lineTangency, v = p.theta, y = qh({
    cx: n,
    cy: r,
    radius: o,
    angle: f,
    sign: -d,
    cornerRadius: a,
    cornerIsExternal: l
  }), x = y.circleTangency, w = y.lineTangency, S = y.theta, A = l ? Math.abs(c - f) : Math.abs(c - f) - v - S;
  if (A < 0)
    return s ? "M ".concat(g.x, ",").concat(g.y, `
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(a * 2, `,0
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(-a * 2, `,0
      `) : zF({
      cx: n,
      cy: r,
      innerRadius: i,
      outerRadius: o,
      startAngle: c,
      endAngle: f
    });
  var _ = "M ".concat(g.x, ",").concat(g.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,").concat(+(A > 180), ",").concat(+(d < 0), ",").concat(x.x, ",").concat(x.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(w.x, ",").concat(w.y, `
  `);
  if (i > 0) {
    var O = qh({
      cx: n,
      cy: r,
      radius: i,
      angle: c,
      sign: d,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), T = O.circleTangency, C = O.lineTangency, k = O.theta, D = qh({
      cx: n,
      cy: r,
      radius: i,
      angle: f,
      sign: -d,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), N = D.circleTangency, $ = D.lineTangency, B = D.theta, L = l ? Math.abs(c - f) : Math.abs(c - f) - k - B;
    if (L < 0 && a === 0)
      return "".concat(_, "L").concat(n, ",").concat(r, "Z");
    _ += "L".concat($.x, ",").concat($.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(N.x, ",").concat(N.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(L > 180), ",").concat(+(d > 0), ",").concat(T.x, ",").concat(T.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(C.x, ",").concat(C.y, "Z");
  } else
    _ += "L".concat(n, ",").concat(r, "Z");
  return _;
}, Dwe = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, VF = function(t) {
  var n = JM(JM({}, Dwe), t), r = n.cx, i = n.cy, o = n.innerRadius, a = n.outerRadius, s = n.cornerRadius, l = n.forceCornerRadius, c = n.cornerIsExternal, f = n.startAngle, d = n.endAngle, p = n.className;
  if (a < o || f === d)
    return null;
  var m = Ye("recharts-sector", p), g = a - o, v = fr(s, g, 0, !0), y;
  return v > 0 && Math.abs(f - d) < 360 ? y = $we({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    cornerRadius: Math.min(v, g / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: f,
    endAngle: d
  }) : y = zF({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    startAngle: f,
    endAngle: d
  }), /* @__PURE__ */ I.createElement("path", rw({}, Ee(n, !0), {
    className: m,
    d: y,
    role: "img"
  }));
};
function Hf(e) {
  "@babel/helpers - typeof";
  return Hf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hf(e);
}
function iw() {
  return iw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, iw.apply(this, arguments);
}
function QM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QM(Object(n), !0).forEach(function(r) {
      Iwe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : QM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Iwe(e, t, n) {
  return t = Rwe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Rwe(e) {
  var t = jwe(e, "string");
  return Hf(t) == "symbol" ? t : t + "";
}
function jwe(e, t) {
  if (Hf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Hf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var tN = {
  curveBasisClosed: Ise,
  curveBasisOpen: Rse,
  curveBasis: Dse,
  curveBumpX: xse,
  curveBumpY: wse,
  curveLinearClosed: jse,
  curveLinear: Zg,
  curveMonotoneX: Lse,
  curveMonotoneY: Bse,
  curveNatural: Fse,
  curveStep: Wse,
  curveStepAfter: Vse,
  curveStepBefore: zse
}, Xh = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, Mu = function(t) {
  return t.x;
}, Nu = function(t) {
  return t.y;
}, Lwe = function(t, n) {
  if (ze(t))
    return t;
  var r = "curve".concat(qg(t));
  return (r === "curveMonotone" || r === "curveBump") && n ? tN["".concat(r).concat(n === "vertical" ? "Y" : "X")] : tN[r] || Zg;
}, Bwe = function(t) {
  var n = t.type, r = n === void 0 ? "linear" : n, i = t.points, o = i === void 0 ? [] : i, a = t.baseLine, s = t.layout, l = t.connectNulls, c = l === void 0 ? !1 : l, f = Lwe(r, s), d = c ? o.filter(function(v) {
    return Xh(v);
  }) : o, p;
  if (Array.isArray(a)) {
    var m = c ? a.filter(function(v) {
      return Xh(v);
    }) : a, g = d.map(function(v, y) {
      return eN(eN({}, v), {}, {
        base: m[y]
      });
    });
    return s === "vertical" ? p = Fh().y(Nu).x1(Mu).x0(function(v) {
      return v.base.x;
    }) : p = Fh().x(Mu).y1(Nu).y0(function(v) {
      return v.base.y;
    }), p.defined(Xh).curve(f), p(g);
  }
  return s === "vertical" && be(a) ? p = Fh().y(Nu).x1(Mu).x0(a) : be(a) ? p = Fh().x(Mu).y1(Nu).y0(a) : p = RL().x(Mu).y(Nu), p.defined(Xh).curve(f), p(d);
}, $s = function(t) {
  var n = t.className, r = t.points, i = t.path, o = t.pathRef;
  if ((!r || !r.length) && !i)
    return null;
  var a = r && r.length ? Bwe(t) : i;
  return /* @__PURE__ */ I.createElement("path", iw({}, Ee(t, !1), Hp(t), {
    className: Ye("recharts-curve", n),
    d: a,
    ref: o
  }));
}, ow = { exports: {} }, Zh = { exports: {} }, xt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nN;
function Fwe() {
  if (nN) return xt;
  nN = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function S(_) {
    if (typeof _ == "object" && _ !== null) {
      var O = _.$$typeof;
      switch (O) {
        case t:
          switch (_ = _.type, _) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case d:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case f:
                case g:
                case m:
                case a:
                  return _;
                default:
                  return O;
              }
          }
        case n:
          return O;
      }
    }
  }
  function A(_) {
    return S(_) === c;
  }
  return xt.AsyncMode = l, xt.ConcurrentMode = c, xt.ContextConsumer = s, xt.ContextProvider = a, xt.Element = t, xt.ForwardRef = f, xt.Fragment = r, xt.Lazy = g, xt.Memo = m, xt.Portal = n, xt.Profiler = o, xt.StrictMode = i, xt.Suspense = d, xt.isAsyncMode = function(_) {
    return A(_) || S(_) === l;
  }, xt.isConcurrentMode = A, xt.isContextConsumer = function(_) {
    return S(_) === s;
  }, xt.isContextProvider = function(_) {
    return S(_) === a;
  }, xt.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === t;
  }, xt.isForwardRef = function(_) {
    return S(_) === f;
  }, xt.isFragment = function(_) {
    return S(_) === r;
  }, xt.isLazy = function(_) {
    return S(_) === g;
  }, xt.isMemo = function(_) {
    return S(_) === m;
  }, xt.isPortal = function(_) {
    return S(_) === n;
  }, xt.isProfiler = function(_) {
    return S(_) === o;
  }, xt.isStrictMode = function(_) {
    return S(_) === i;
  }, xt.isSuspense = function(_) {
    return S(_) === d;
  }, xt.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === c || _ === o || _ === i || _ === d || _ === p || typeof _ == "object" && _ !== null && (_.$$typeof === g || _.$$typeof === m || _.$$typeof === a || _.$$typeof === s || _.$$typeof === f || _.$$typeof === y || _.$$typeof === x || _.$$typeof === w || _.$$typeof === v);
  }, xt.typeOf = S, xt;
}
var wt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rN;
function Wwe() {
  return rN || (rN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function S(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === c || X === o || X === i || X === d || X === p || typeof X == "object" && X !== null && (X.$$typeof === g || X.$$typeof === m || X.$$typeof === a || X.$$typeof === s || X.$$typeof === f || X.$$typeof === y || X.$$typeof === x || X.$$typeof === w || X.$$typeof === v);
    }
    function A(X) {
      if (typeof X == "object" && X !== null) {
        var Fe = X.$$typeof;
        switch (Fe) {
          case t:
            var pe = X.type;
            switch (pe) {
              case l:
              case c:
              case r:
              case o:
              case i:
              case d:
                return pe;
              default:
                var Be = pe && pe.$$typeof;
                switch (Be) {
                  case s:
                  case f:
                  case g:
                  case m:
                  case a:
                    return Be;
                  default:
                    return Fe;
                }
            }
          case n:
            return Fe;
        }
      }
    }
    var _ = l, O = c, T = s, C = a, k = t, D = f, N = r, $ = g, B = m, L = n, F = o, W = i, z = d, G = !1;
    function V(X) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(X) || A(X) === l;
    }
    function U(X) {
      return A(X) === c;
    }
    function Y(X) {
      return A(X) === s;
    }
    function te(X) {
      return A(X) === a;
    }
    function ne(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function re(X) {
      return A(X) === f;
    }
    function ue(X) {
      return A(X) === r;
    }
    function ae(X) {
      return A(X) === g;
    }
    function le(X) {
      return A(X) === m;
    }
    function ie(X) {
      return A(X) === n;
    }
    function Q(X) {
      return A(X) === o;
    }
    function fe(X) {
      return A(X) === i;
    }
    function ve(X) {
      return A(X) === d;
    }
    wt.AsyncMode = _, wt.ConcurrentMode = O, wt.ContextConsumer = T, wt.ContextProvider = C, wt.Element = k, wt.ForwardRef = D, wt.Fragment = N, wt.Lazy = $, wt.Memo = B, wt.Portal = L, wt.Profiler = F, wt.StrictMode = W, wt.Suspense = z, wt.isAsyncMode = V, wt.isConcurrentMode = U, wt.isContextConsumer = Y, wt.isContextProvider = te, wt.isElement = ne, wt.isForwardRef = re, wt.isFragment = ue, wt.isLazy = ae, wt.isMemo = le, wt.isPortal = ie, wt.isProfiler = Q, wt.isStrictMode = fe, wt.isSuspense = ve, wt.isValidElementType = S, wt.typeOf = A;
  }()), wt;
}
var iN;
function UF() {
  return iN || (iN = 1, process.env.NODE_ENV === "production" ? Zh.exports = Fwe() : Zh.exports = Wwe()), Zh.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Gb, oN;
function zwe() {
  if (oN) return Gb;
  oN = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Gb = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), c, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          n.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, Gb;
}
var Yb, aN;
function _S() {
  if (aN) return Yb;
  aN = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Yb = e, Yb;
}
var qb, sN;
function KF() {
  return sN || (sN = 1, qb = Function.call.bind(Object.prototype.hasOwnProperty)), qb;
}
var Xb, lN;
function Vwe() {
  if (lN) return Xb;
  lN = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = _S(), n = {}, r = KF();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in o)
        if (r(o, f)) {
          var d;
          try {
            if (typeof o[f] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = o[f](a, f, l, s, null, t);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Xb = i, Xb;
}
var Zb, cN;
function Uwe() {
  if (cN) return Zb;
  cN = 1;
  var e = UF(), t = zwe(), n = _S(), r = KF(), i = Vwe(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Zb = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function d(U) {
      var Y = U && (c && U[c] || U[f]);
      if (typeof Y == "function")
        return Y;
    }
    var p = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: w(),
      arrayOf: S,
      element: A(),
      elementType: _(),
      instanceOf: O,
      node: D(),
      objectOf: C,
      oneOf: T,
      oneOfType: k,
      shape: $,
      exact: B
    };
    function g(U, Y) {
      return U === Y ? U !== 0 || 1 / U === 1 / Y : U !== U && Y !== Y;
    }
    function v(U, Y) {
      this.message = U, this.data = Y && typeof Y == "object" ? Y : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function y(U) {
      if (process.env.NODE_ENV !== "production")
        var Y = {}, te = 0;
      function ne(ue, ae, le, ie, Q, fe, ve) {
        if (ie = ie || p, fe = fe || le, ve !== n) {
          if (l) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Fe = ie + ":" + le;
            !Y[Fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            te < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + fe + "` prop on `" + ie + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Y[Fe] = !0, te++);
          }
        }
        return ae[le] == null ? ue ? ae[le] === null ? new v("The " + Q + " `" + fe + "` is marked as required " + ("in `" + ie + "`, but its value is `null`.")) : new v("The " + Q + " `" + fe + "` is marked as required in " + ("`" + ie + "`, but its value is `undefined`.")) : null : U(ae, le, ie, Q, fe);
      }
      var re = ne.bind(null, !1);
      return re.isRequired = ne.bind(null, !0), re;
    }
    function x(U) {
      function Y(te, ne, re, ue, ae, le) {
        var ie = te[ne], Q = W(ie);
        if (Q !== U) {
          var fe = z(ie);
          return new v(
            "Invalid " + ue + " `" + ae + "` of type " + ("`" + fe + "` supplied to `" + re + "`, expected ") + ("`" + U + "`."),
            { expectedType: U }
          );
        }
        return null;
      }
      return y(Y);
    }
    function w() {
      return y(a);
    }
    function S(U) {
      function Y(te, ne, re, ue, ae) {
        if (typeof U != "function")
          return new v("Property `" + ae + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var le = te[ne];
        if (!Array.isArray(le)) {
          var ie = W(le);
          return new v("Invalid " + ue + " `" + ae + "` of type " + ("`" + ie + "` supplied to `" + re + "`, expected an array."));
        }
        for (var Q = 0; Q < le.length; Q++) {
          var fe = U(le, Q, re, ue, ae + "[" + Q + "]", n);
          if (fe instanceof Error)
            return fe;
        }
        return null;
      }
      return y(Y);
    }
    function A() {
      function U(Y, te, ne, re, ue) {
        var ae = Y[te];
        if (!s(ae)) {
          var le = W(ae);
          return new v("Invalid " + re + " `" + ue + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(U);
    }
    function _() {
      function U(Y, te, ne, re, ue) {
        var ae = Y[te];
        if (!e.isValidElementType(ae)) {
          var le = W(ae);
          return new v("Invalid " + re + " `" + ue + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(U);
    }
    function O(U) {
      function Y(te, ne, re, ue, ae) {
        if (!(te[ne] instanceof U)) {
          var le = U.name || p, ie = V(te[ne]);
          return new v("Invalid " + ue + " `" + ae + "` of type " + ("`" + ie + "` supplied to `" + re + "`, expected ") + ("instance of `" + le + "`."));
        }
        return null;
      }
      return y(Y);
    }
    function T(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function Y(te, ne, re, ue, ae) {
        for (var le = te[ne], ie = 0; ie < U.length; ie++)
          if (g(le, U[ie]))
            return null;
        var Q = JSON.stringify(U, function(ve, X) {
          var Fe = z(X);
          return Fe === "symbol" ? String(X) : X;
        });
        return new v("Invalid " + ue + " `" + ae + "` of value `" + String(le) + "` " + ("supplied to `" + re + "`, expected one of " + Q + "."));
      }
      return y(Y);
    }
    function C(U) {
      function Y(te, ne, re, ue, ae) {
        if (typeof U != "function")
          return new v("Property `" + ae + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var le = te[ne], ie = W(le);
        if (ie !== "object")
          return new v("Invalid " + ue + " `" + ae + "` of type " + ("`" + ie + "` supplied to `" + re + "`, expected an object."));
        for (var Q in le)
          if (r(le, Q)) {
            var fe = U(le, Q, re, ue, ae + "." + Q, n);
            if (fe instanceof Error)
              return fe;
          }
        return null;
      }
      return y(Y);
    }
    function k(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Y = 0; Y < U.length; Y++) {
        var te = U[Y];
        if (typeof te != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(te) + " at index " + Y + "."
          ), a;
      }
      function ne(re, ue, ae, le, ie) {
        for (var Q = [], fe = 0; fe < U.length; fe++) {
          var ve = U[fe], X = ve(re, ue, ae, le, ie, n);
          if (X == null)
            return null;
          X.data && r(X.data, "expectedType") && Q.push(X.data.expectedType);
        }
        var Fe = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new v("Invalid " + le + " `" + ie + "` supplied to " + ("`" + ae + "`" + Fe + "."));
      }
      return y(ne);
    }
    function D() {
      function U(Y, te, ne, re, ue) {
        return L(Y[te]) ? null : new v("Invalid " + re + " `" + ue + "` supplied to " + ("`" + ne + "`, expected a ReactNode."));
      }
      return y(U);
    }
    function N(U, Y, te, ne, re) {
      return new v(
        (U || "React class") + ": " + Y + " type `" + te + "." + ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function $(U) {
      function Y(te, ne, re, ue, ae) {
        var le = te[ne], ie = W(le);
        if (ie !== "object")
          return new v("Invalid " + ue + " `" + ae + "` of type `" + ie + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var Q in U) {
          var fe = U[Q];
          if (typeof fe != "function")
            return N(re, ue, ae, Q, z(fe));
          var ve = fe(le, Q, re, ue, ae + "." + Q, n);
          if (ve)
            return ve;
        }
        return null;
      }
      return y(Y);
    }
    function B(U) {
      function Y(te, ne, re, ue, ae) {
        var le = te[ne], ie = W(le);
        if (ie !== "object")
          return new v("Invalid " + ue + " `" + ae + "` of type `" + ie + "` " + ("supplied to `" + re + "`, expected `object`."));
        var Q = t({}, te[ne], U);
        for (var fe in Q) {
          var ve = U[fe];
          if (r(U, fe) && typeof ve != "function")
            return N(re, ue, ae, fe, z(ve));
          if (!ve)
            return new v(
              "Invalid " + ue + " `" + ae + "` key `" + fe + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(te[ne], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(U), null, "  ")
            );
          var X = ve(le, fe, re, ue, ae + "." + fe, n);
          if (X)
            return X;
        }
        return null;
      }
      return y(Y);
    }
    function L(U) {
      switch (typeof U) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !U;
        case "object":
          if (Array.isArray(U))
            return U.every(L);
          if (U === null || s(U))
            return !0;
          var Y = d(U);
          if (Y) {
            var te = Y.call(U), ne;
            if (Y !== U.entries) {
              for (; !(ne = te.next()).done; )
                if (!L(ne.value))
                  return !1;
            } else
              for (; !(ne = te.next()).done; ) {
                var re = ne.value;
                if (re && !L(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function F(U, Y) {
      return U === "symbol" ? !0 : Y ? Y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Y instanceof Symbol : !1;
    }
    function W(U) {
      var Y = typeof U;
      return Array.isArray(U) ? "array" : U instanceof RegExp ? "object" : F(Y, U) ? "symbol" : Y;
    }
    function z(U) {
      if (typeof U > "u" || U === null)
        return "" + U;
      var Y = W(U);
      if (Y === "object") {
        if (U instanceof Date)
          return "date";
        if (U instanceof RegExp)
          return "regexp";
      }
      return Y;
    }
    function G(U) {
      var Y = z(U);
      switch (Y) {
        case "array":
        case "object":
          return "an " + Y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Y;
        default:
          return Y;
      }
    }
    function V(U) {
      return !U.constructor || !U.constructor.name ? p : U.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, Zb;
}
var Jb, uN;
function Kwe() {
  if (uN) return Jb;
  uN = 1;
  var e = _S();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Jb = function() {
    function r(a, s, l, c, f, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Jb;
}
if (process.env.NODE_ENV !== "production") {
  var Hwe = UF(), Gwe = !0;
  ow.exports = Uwe()(Hwe.isElement, Gwe);
} else
  ow.exports = Kwe()();
var Ywe = ow.exports;
const Ze = /* @__PURE__ */ Et(Ywe);
var qwe = Object.getOwnPropertyNames, Xwe = Object.getOwnPropertySymbols, Zwe = Object.prototype.hasOwnProperty;
function fN(e, t) {
  return function(r, i, o) {
    return e(r, i, o) && t(r, i, o);
  };
}
function Jh(e) {
  return function(n, r, i) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return e(n, r, i);
    var o = i.cache, a = o.get(n), s = o.get(r);
    if (a && s)
      return a === r && s === n;
    o.set(n, r), o.set(r, n);
    var l = e(n, r, i);
    return o.delete(n), o.delete(r), l;
  };
}
function dN(e) {
  return qwe(e).concat(Xwe(e));
}
var HF = Object.hasOwn || function(e, t) {
  return Zwe.call(e, t);
};
function Jc(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var GF = "_owner", hN = Object.getOwnPropertyDescriptor, pN = Object.keys;
function Jwe(e, t, n) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(e[r], t[r], r, r, e, t, n))
      return !1;
  return !0;
}
function Qwe(e, t) {
  return Jc(e.getTime(), t.getTime());
}
function mN(e, t, n) {
  if (e.size !== t.size)
    return !1;
  for (var r = {}, i = e.entries(), o = 0, a, s; (a = i.next()) && !a.done; ) {
    for (var l = t.entries(), c = !1, f = 0; (s = l.next()) && !s.done; ) {
      var d = a.value, p = d[0], m = d[1], g = s.value, v = g[0], y = g[1];
      !c && !r[f] && (c = n.equals(p, v, o, f, e, t, n) && n.equals(m, y, p, v, e, t, n)) && (r[f] = !0), f++;
    }
    if (!c)
      return !1;
    o++;
  }
  return !0;
}
function e1e(e, t, n) {
  var r = pN(e), i = r.length;
  if (pN(t).length !== i)
    return !1;
  for (var o; i-- > 0; )
    if (o = r[i], o === GF && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !HF(t, o) || !n.equals(e[o], t[o], o, o, e, t, n))
      return !1;
  return !0;
}
function $u(e, t, n) {
  var r = dN(e), i = r.length;
  if (dN(t).length !== i)
    return !1;
  for (var o, a, s; i-- > 0; )
    if (o = r[i], o === GF && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !HF(t, o) || !n.equals(e[o], t[o], o, o, e, t, n) || (a = hN(e, o), s = hN(t, o), (a || s) && (!a || !s || a.configurable !== s.configurable || a.enumerable !== s.enumerable || a.writable !== s.writable)))
      return !1;
  return !0;
}
function t1e(e, t) {
  return Jc(e.valueOf(), t.valueOf());
}
function n1e(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function gN(e, t, n) {
  if (e.size !== t.size)
    return !1;
  for (var r = {}, i = e.values(), o, a; (o = i.next()) && !o.done; ) {
    for (var s = t.values(), l = !1, c = 0; (a = s.next()) && !a.done; )
      !l && !r[c] && (l = n.equals(o.value, a.value, o.value, a.value, e, t, n)) && (r[c] = !0), c++;
    if (!l)
      return !1;
  }
  return !0;
}
function r1e(e, t) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var i1e = "[object Arguments]", o1e = "[object Boolean]", a1e = "[object Date]", s1e = "[object Map]", l1e = "[object Number]", c1e = "[object Object]", u1e = "[object RegExp]", f1e = "[object Set]", d1e = "[object String]", h1e = Array.isArray, yN = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, vN = Object.assign, p1e = Object.prototype.toString.call.bind(Object.prototype.toString);
function m1e(e) {
  var t = e.areArraysEqual, n = e.areDatesEqual, r = e.areMapsEqual, i = e.areObjectsEqual, o = e.arePrimitiveWrappersEqual, a = e.areRegExpsEqual, s = e.areSetsEqual, l = e.areTypedArraysEqual;
  return function(f, d, p) {
    if (f === d)
      return !0;
    if (f == null || d == null || typeof f != "object" || typeof d != "object")
      return f !== f && d !== d;
    var m = f.constructor;
    if (m !== d.constructor)
      return !1;
    if (m === Object)
      return i(f, d, p);
    if (h1e(f))
      return t(f, d, p);
    if (yN != null && yN(f))
      return l(f, d, p);
    if (m === Date)
      return n(f, d, p);
    if (m === RegExp)
      return a(f, d, p);
    if (m === Map)
      return r(f, d, p);
    if (m === Set)
      return s(f, d, p);
    var g = p1e(f);
    return g === a1e ? n(f, d, p) : g === u1e ? a(f, d, p) : g === s1e ? r(f, d, p) : g === f1e ? s(f, d, p) : g === c1e ? typeof f.then != "function" && typeof d.then != "function" && i(f, d, p) : g === i1e ? i(f, d, p) : g === o1e || g === l1e || g === d1e ? o(f, d, p) : !1;
  };
}
function g1e(e) {
  var t = e.circular, n = e.createCustomConfig, r = e.strict, i = {
    areArraysEqual: r ? $u : Jwe,
    areDatesEqual: Qwe,
    areMapsEqual: r ? fN(mN, $u) : mN,
    areObjectsEqual: r ? $u : e1e,
    arePrimitiveWrappersEqual: t1e,
    areRegExpsEqual: n1e,
    areSetsEqual: r ? fN(gN, $u) : gN,
    areTypedArraysEqual: r ? $u : r1e
  };
  if (n && (i = vN({}, i, n(i))), t) {
    var o = Jh(i.areArraysEqual), a = Jh(i.areMapsEqual), s = Jh(i.areObjectsEqual), l = Jh(i.areSetsEqual);
    i = vN({}, i, {
      areArraysEqual: o,
      areMapsEqual: a,
      areObjectsEqual: s,
      areSetsEqual: l
    });
  }
  return i;
}
function y1e(e) {
  return function(t, n, r, i, o, a, s) {
    return e(t, n, s);
  };
}
function v1e(e) {
  var t = e.circular, n = e.comparator, r = e.createState, i = e.equals, o = e.strict;
  if (r)
    return function(l, c) {
      var f = r(), d = f.cache, p = d === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : d, m = f.meta;
      return n(l, c, {
        cache: p,
        equals: i,
        meta: m,
        strict: o
      });
    };
  if (t)
    return function(l, c) {
      return n(l, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: o
      });
    };
  var a = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: o
  };
  return function(l, c) {
    return n(l, c, a);
  };
}
var b1e = qa();
qa({ strict: !0 });
qa({ circular: !0 });
qa({
  circular: !0,
  strict: !0
});
qa({
  createInternalComparator: function() {
    return Jc;
  }
});
qa({
  strict: !0,
  createInternalComparator: function() {
    return Jc;
  }
});
qa({
  circular: !0,
  createInternalComparator: function() {
    return Jc;
  }
});
qa({
  circular: !0,
  createInternalComparator: function() {
    return Jc;
  },
  strict: !0
});
function qa(e) {
  e === void 0 && (e = {});
  var t = e.circular, n = t === void 0 ? !1 : t, r = e.createInternalComparator, i = e.createState, o = e.strict, a = o === void 0 ? !1 : o, s = g1e(e), l = m1e(s), c = r ? r(l) : y1e(l);
  return v1e({ circular: n, comparator: l, createState: i, equals: c, strict: a });
}
function x1e(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function bN(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = -1, r = function i(o) {
    n < 0 && (n = o), o - n > t ? (e(o), n = -1) : x1e(i);
  };
  requestAnimationFrame(r);
}
function aw(e) {
  "@babel/helpers - typeof";
  return aw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, aw(e);
}
function w1e(e) {
  return A1e(e) || O1e(e) || S1e(e) || _1e();
}
function _1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function S1e(e, t) {
  if (e) {
    if (typeof e == "string") return xN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xN(e, t);
  }
}
function xN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function O1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function A1e(e) {
  if (Array.isArray(e)) return e;
}
function P1e() {
  var e = {}, t = function() {
    return null;
  }, n = !1, r = function i(o) {
    if (!n) {
      if (Array.isArray(o)) {
        if (!o.length)
          return;
        var a = o, s = w1e(a), l = s[0], c = s.slice(1);
        if (typeof l == "number") {
          bN(i.bind(null, c), l);
          return;
        }
        i(l), bN(i.bind(null, c));
        return;
      }
      aw(o) === "object" && (e = o, t(e)), typeof o == "function" && o();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(o) {
      n = !1, r(o);
    },
    subscribe: function(o) {
      return t = o, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Gf(e) {
  "@babel/helpers - typeof";
  return Gf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gf(e);
}
function wN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _N(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wN(Object(n), !0).forEach(function(r) {
      YF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function YF(e, t, n) {
  return t = T1e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function T1e(e) {
  var t = C1e(e, "string");
  return Gf(t) === "symbol" ? t : String(t);
}
function C1e(e, t) {
  if (Gf(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Gf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var E1e = function(t, n) {
  return [Object.keys(t), Object.keys(n)].reduce(function(r, i) {
    return r.filter(function(o) {
      return i.includes(o);
    });
  });
}, k1e = function(t) {
  return t;
}, M1e = function(t) {
  return t.replace(/([A-Z])/g, function(n) {
    return "-".concat(n.toLowerCase());
  });
}, nf = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return _N(_N({}, r), {}, YF({}, i, t(i, n[i])));
  }, {});
}, SN = function(t, n, r) {
  return t.map(function(i) {
    return "".concat(M1e(i), " ").concat(n, "ms ").concat(r);
  }).join(",");
}, N1e = process.env.NODE_ENV !== "production", Sm = function(t, n, r, i, o, a, s, l) {
  if (N1e && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [r, i, o, a, s, l], f = 0;
      console.warn(n.replace(/%s/g, function() {
        return c[f++];
      }));
    }
};
function $1e(e, t) {
  return R1e(e) || I1e(e, t) || qF(e, t) || D1e();
}
function D1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function I1e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function R1e(e) {
  if (Array.isArray(e)) return e;
}
function j1e(e) {
  return F1e(e) || B1e(e) || qF(e) || L1e();
}
function L1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qF(e, t) {
  if (e) {
    if (typeof e == "string") return sw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sw(e, t);
  }
}
function B1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function F1e(e) {
  if (Array.isArray(e)) return sw(e);
}
function sw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Om = 1e-4, XF = function(t, n) {
  return [0, 3 * t, 3 * n - 6 * t, 3 * t - 3 * n + 1];
}, ZF = function(t, n) {
  return t.map(function(r, i) {
    return r * Math.pow(n, i);
  }).reduce(function(r, i) {
    return r + i;
  });
}, ON = function(t, n) {
  return function(r) {
    var i = XF(t, n);
    return ZF(i, r);
  };
}, W1e = function(t, n) {
  return function(r) {
    var i = XF(t, n), o = [].concat(j1e(i.map(function(a, s) {
      return a * s;
    }).slice(1)), [0]);
    return ZF(o, r);
  };
}, AN = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0], o = n[1], a = n[2], s = n[3];
  if (n.length === 1)
    switch (n[0]) {
      case "linear":
        i = 0, o = 0, a = 1, s = 1;
        break;
      case "ease":
        i = 0.25, o = 0.1, a = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, o = 0, a = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, o = 0, a = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, o = 0, a = 0.58, s = 1;
        break;
      default: {
        var l = n[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(y) {
            return parseFloat(y);
          }), f = $1e(c, 4);
          i = f[0], o = f[1], a = f[2], s = f[3];
        } else
          Sm(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", n);
      }
    }
  Sm([i, a, o, s].every(function(y) {
    return typeof y == "number" && y >= 0 && y <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", n);
  var d = ON(i, a), p = ON(o, s), m = W1e(i, a), g = function(x) {
    return x > 1 ? 1 : x < 0 ? 0 : x;
  }, v = function(x) {
    for (var w = x > 1 ? 1 : x, S = w, A = 0; A < 8; ++A) {
      var _ = d(S) - w, O = m(S);
      if (Math.abs(_ - w) < Om || O < Om)
        return p(S);
      S = g(S - _ / O);
    }
    return p(S);
  };
  return v.isStepper = !1, v;
}, z1e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.stiff, r = n === void 0 ? 100 : n, i = t.damping, o = i === void 0 ? 8 : i, a = t.dt, s = a === void 0 ? 17 : a, l = function(f, d, p) {
    var m = -(f - d) * r, g = p * o, v = p + (m - g) * s / 1e3, y = p * s / 1e3 + f;
    return Math.abs(y - d) < Om && Math.abs(v) < Om ? [d, 0] : [y, v];
  };
  return l.isStepper = !0, l.dt = s, l;
}, V1e = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return AN(i);
      case "spring":
        return z1e();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return AN(i);
        Sm(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", n);
    }
  return typeof i == "function" ? i : (Sm(!1, "[configEasing]: first argument type should be function or string, instead received %s", n), null);
};
function Yf(e) {
  "@babel/helpers - typeof";
  return Yf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yf(e);
}
function PN(e) {
  return H1e(e) || K1e(e) || JF(e) || U1e();
}
function U1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function K1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function H1e(e) {
  if (Array.isArray(e)) return cw(e);
}
function TN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? TN(Object(n), !0).forEach(function(r) {
      lw(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : TN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function lw(e, t, n) {
  return t = G1e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function G1e(e) {
  var t = Y1e(e, "string");
  return Yf(t) === "symbol" ? t : String(t);
}
function Y1e(e, t) {
  if (Yf(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Yf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function q1e(e, t) {
  return J1e(e) || Z1e(e, t) || JF(e, t) || X1e();
}
function X1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JF(e, t) {
  if (e) {
    if (typeof e == "string") return cw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cw(e, t);
  }
}
function cw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Z1e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function J1e(e) {
  if (Array.isArray(e)) return e;
}
var Am = function(t, n, r) {
  return t + (n - t) * r;
}, uw = function(t) {
  var n = t.from, r = t.to;
  return n !== r;
}, Q1e = function e(t, n, r) {
  var i = nf(function(o, a) {
    if (uw(a)) {
      var s = t(a.from, a.to, a.velocity), l = q1e(s, 2), c = l[0], f = l[1];
      return Bn(Bn({}, a), {}, {
        from: c,
        velocity: f
      });
    }
    return a;
  }, n);
  return r < 1 ? nf(function(o, a) {
    return uw(a) ? Bn(Bn({}, a), {}, {
      velocity: Am(a.velocity, i[o].velocity, r),
      from: Am(a.from, i[o].from, r)
    }) : a;
  }, n) : e(t, i, r - 1);
};
const e_e = function(e, t, n, r, i) {
  var o = E1e(e, t), a = o.reduce(function(y, x) {
    return Bn(Bn({}, y), {}, lw({}, x, [e[x], t[x]]));
  }, {}), s = o.reduce(function(y, x) {
    return Bn(Bn({}, y), {}, lw({}, x, {
      from: e[x],
      velocity: 0,
      to: t[x]
    }));
  }, {}), l = -1, c, f, d = function() {
    return null;
  }, p = function() {
    return nf(function(x, w) {
      return w.from;
    }, s);
  }, m = function() {
    return !Object.values(s).filter(uw).length;
  }, g = function(x) {
    c || (c = x);
    var w = x - c, S = w / n.dt;
    s = Q1e(n, s, S), i(Bn(Bn(Bn({}, e), t), p())), c = x, m() || (l = requestAnimationFrame(d));
  }, v = function(x) {
    f || (f = x);
    var w = (x - f) / r, S = nf(function(_, O) {
      return Am.apply(void 0, PN(O).concat([n(w)]));
    }, a);
    if (i(Bn(Bn(Bn({}, e), t), S)), w < 1)
      l = requestAnimationFrame(d);
    else {
      var A = nf(function(_, O) {
        return Am.apply(void 0, PN(O).concat([n(1)]));
      }, a);
      i(Bn(Bn(Bn({}, e), t), A));
    }
  };
  return d = n.isStepper ? g : v, function() {
    return requestAnimationFrame(d), function() {
      cancelAnimationFrame(l);
    };
  };
};
function dc(e) {
  "@babel/helpers - typeof";
  return dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dc(e);
}
var t_e = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function n_e(e, t) {
  if (e == null) return {};
  var n = r_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function r_e(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Qb(e) {
  return s_e(e) || a_e(e) || o_e(e) || i_e();
}
function i_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o_e(e, t) {
  if (e) {
    if (typeof e == "string") return fw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fw(e, t);
  }
}
function a_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function s_e(e) {
  if (Array.isArray(e)) return fw(e);
}
function fw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function CN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? CN(Object(n), !0).forEach(function(r) {
      Wu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : CN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Wu(e, t, n) {
  return t = QF(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function l_e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function c_e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, QF(r.key), r);
  }
}
function u_e(e, t, n) {
  return t && c_e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function QF(e) {
  var t = f_e(e, "string");
  return dc(t) === "symbol" ? t : String(t);
}
function f_e(e, t) {
  if (dc(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (dc(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function d_e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && dw(e, t);
}
function dw(e, t) {
  return dw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, dw(e, t);
}
function h_e(e) {
  var t = p_e();
  return function() {
    var r = Pm(e), i;
    if (t) {
      var o = Pm(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return hw(this, i);
  };
}
function hw(e, t) {
  if (t && (dc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pw(e);
}
function pw(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Pm(e) {
  return Pm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Pm(e);
}
var Ni = /* @__PURE__ */ function(e) {
  d_e(n, e);
  var t = h_e(n);
  function n(r, i) {
    var o;
    l_e(this, n), o = t.call(this, r, i);
    var a = o.props, s = a.isActive, l = a.attributeName, c = a.from, f = a.to, d = a.steps, p = a.children, m = a.duration;
    if (o.handleStyleChange = o.handleStyleChange.bind(pw(o)), o.changeStyle = o.changeStyle.bind(pw(o)), !s || m <= 0)
      return o.state = {
        style: {}
      }, typeof p == "function" && (o.state = {
        style: f
      }), hw(o);
    if (d && d.length)
      o.state = {
        style: d[0].style
      };
    else if (c) {
      if (typeof p == "function")
        return o.state = {
          style: c
        }, hw(o);
      o.state = {
        style: l ? Wu({}, l, c) : c
      };
    } else
      o.state = {
        style: {}
      };
    return o;
  }
  return u_e(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.isActive, a = i.canBegin;
      this.mounted = !0, !(!o || !a) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var o = this.props, a = o.isActive, s = o.canBegin, l = o.attributeName, c = o.shouldReAnimate, f = o.to, d = o.from, p = this.state.style;
      if (s) {
        if (!a) {
          var m = {
            style: l ? Wu({}, l, f) : f
          };
          this.state && p && (l && p[l] !== f || !l && p !== f) && this.setState(m);
          return;
        }
        if (!(b1e(i.to, f) && i.canBegin && i.isActive)) {
          var g = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = g || c ? d : i.to;
          if (this.state && p) {
            var y = {
              style: l ? Wu({}, l, v) : v
            };
            (l && p[l] !== v || !l && p !== v) && this.setState(y);
          }
          this.runAnimation(bi(bi({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var o = this, a = i.from, s = i.to, l = i.duration, c = i.easing, f = i.begin, d = i.onAnimationEnd, p = i.onAnimationStart, m = e_e(a, s, V1e(c), l, this.changeStyle), g = function() {
        o.stopJSAnimation = m();
      };
      this.manager.start([p, f, g, l, d]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var o = this, a = i.steps, s = i.begin, l = i.onAnimationStart, c = a[0], f = c.style, d = c.duration, p = d === void 0 ? 0 : d, m = function(v, y, x) {
        if (x === 0)
          return v;
        var w = y.duration, S = y.easing, A = S === void 0 ? "ease" : S, _ = y.style, O = y.properties, T = y.onAnimationEnd, C = x > 0 ? a[x - 1] : y, k = O || Object.keys(_);
        if (typeof A == "function" || A === "spring")
          return [].concat(Qb(v), [o.runJSAnimation.bind(o, {
            from: C.style,
            to: _,
            duration: w,
            easing: A
          }), w]);
        var D = SN(k, w, A), N = bi(bi(bi({}, C.style), _), {}, {
          transition: D
        });
        return [].concat(Qb(v), [N, w, T]).filter(k1e);
      };
      return this.manager.start([l].concat(Qb(a.reduce(m, [f, Math.max(p, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = P1e());
      var o = i.begin, a = i.duration, s = i.attributeName, l = i.to, c = i.easing, f = i.onAnimationStart, d = i.onAnimationEnd, p = i.steps, m = i.children, g = this.manager;
      if (this.unSubscribe = g.subscribe(this.handleStyleChange), typeof c == "function" || typeof m == "function" || c === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (p.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var v = s ? Wu({}, s, l) : l, y = SN(Object.keys(v), a, c);
      g.start([f, o, bi(bi({}, v), {}, {
        transition: y
      }), a, d]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, o = i.children;
      i.begin;
      var a = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var l = n_e(i, t_e), c = tr.count(o), f = this.state.style;
      if (typeof o == "function")
        return o(f);
      if (!s || c === 0 || a <= 0)
        return o;
      var d = function(m) {
        var g = m.props, v = g.style, y = v === void 0 ? {} : v, x = g.className, w = /* @__PURE__ */ _t(m, bi(bi({}, l), {}, {
          style: bi(bi({}, y), f),
          className: x
        }));
        return w;
      };
      return c === 1 ? d(tr.only(o)) : /* @__PURE__ */ I.createElement("div", null, tr.map(o, function(p) {
        return d(p);
      }));
    }
  }]), n;
}(hi);
Ni.displayName = "Animate";
Ni.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Ni.propTypes = {
  from: Ze.oneOfType([Ze.object, Ze.string]),
  to: Ze.oneOfType([Ze.object, Ze.string]),
  attributeName: Ze.string,
  // animation duration
  duration: Ze.number,
  begin: Ze.number,
  easing: Ze.oneOfType([Ze.string, Ze.func]),
  steps: Ze.arrayOf(Ze.shape({
    duration: Ze.number.isRequired,
    style: Ze.object.isRequired,
    easing: Ze.oneOfType([Ze.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Ze.func]),
    // transition css properties(dash case), optional
    properties: Ze.arrayOf("string"),
    onAnimationEnd: Ze.func
  })),
  children: Ze.oneOfType([Ze.node, Ze.func]),
  isActive: Ze.bool,
  canBegin: Ze.bool,
  onAnimationEnd: Ze.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Ze.bool,
  onAnimationStart: Ze.func,
  onAnimationReStart: Ze.func
};
Ze.object, Ze.object, Ze.object, Ze.element;
Ze.object, Ze.object, Ze.object, Ze.oneOfType([Ze.array, Ze.element]), Ze.any;
function qf(e) {
  "@babel/helpers - typeof";
  return qf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qf(e);
}
function Tm() {
  return Tm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tm.apply(this, arguments);
}
function m_e(e, t) {
  return b_e(e) || v_e(e, t) || y_e(e, t) || g_e();
}
function g_e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y_e(e, t) {
  if (e) {
    if (typeof e == "string") return EN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EN(e, t);
  }
}
function EN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function v_e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function b_e(e) {
  if (Array.isArray(e)) return e;
}
function kN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function MN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kN(Object(n), !0).forEach(function(r) {
      x_e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function x_e(e, t, n) {
  return t = w_e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function w_e(e) {
  var t = __e(e, "string");
  return qf(t) == "symbol" ? t : t + "";
}
function __e(e, t) {
  if (qf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (qf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var NN = function(t, n, r, i, o) {
  var a = Math.min(Math.abs(r) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, l = r >= 0 ? 1 : -1, c = i >= 0 && r >= 0 || i < 0 && r < 0 ? 1 : 0, f;
  if (a > 0 && o instanceof Array) {
    for (var d = [0, 0, 0, 0], p = 0, m = 4; p < m; p++)
      d[p] = o[p] > a ? a : o[p];
    f = "M".concat(t, ",").concat(n + s * d[0]), d[0] > 0 && (f += "A ".concat(d[0], ",").concat(d[0], ",0,0,").concat(c, ",").concat(t + l * d[0], ",").concat(n)), f += "L ".concat(t + r - l * d[1], ",").concat(n), d[1] > 0 && (f += "A ".concat(d[1], ",").concat(d[1], ",0,0,").concat(c, `,
        `).concat(t + r, ",").concat(n + s * d[1])), f += "L ".concat(t + r, ",").concat(n + i - s * d[2]), d[2] > 0 && (f += "A ".concat(d[2], ",").concat(d[2], ",0,0,").concat(c, `,
        `).concat(t + r - l * d[2], ",").concat(n + i)), f += "L ".concat(t + l * d[3], ",").concat(n + i), d[3] > 0 && (f += "A ".concat(d[3], ",").concat(d[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(n + i - s * d[3])), f += "Z";
  } else if (a > 0 && o === +o && o > 0) {
    var g = Math.min(a, o);
    f = "M ".concat(t, ",").concat(n + s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(t + l * g, ",").concat(n, `
            L `).concat(t + r - l * g, ",").concat(n, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(t + r, ",").concat(n + s * g, `
            L `).concat(t + r, ",").concat(n + i - s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(t + r - l * g, ",").concat(n + i, `
            L `).concat(t + l * g, ",").concat(n + i, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(t, ",").concat(n + i - s * g, " Z");
  } else
    f = "M ".concat(t, ",").concat(n, " h ").concat(r, " v ").concat(i, " h ").concat(-r, " Z");
  return f;
}, S_e = function(t, n) {
  if (!t || !n)
    return !1;
  var r = t.x, i = t.y, o = n.x, a = n.y, s = n.width, l = n.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var c = Math.min(o, o + s), f = Math.max(o, o + s), d = Math.min(a, a + l), p = Math.max(a, a + l);
    return r >= c && r <= f && i >= d && i <= p;
  }
  return !1;
}, O_e = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, SS = function(t) {
  var n = MN(MN({}, O_e), t), r = ft(), i = Me(-1), o = m_e(i, 2), a = o[0], s = o[1];
  Qe(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var A = r.current.getTotalLength();
        A && s(A);
      } catch {
      }
  }, []);
  var l = n.x, c = n.y, f = n.width, d = n.height, p = n.radius, m = n.className, g = n.animationEasing, v = n.animationDuration, y = n.animationBegin, x = n.isAnimationActive, w = n.isUpdateAnimationActive;
  if (l !== +l || c !== +c || f !== +f || d !== +d || f === 0 || d === 0)
    return null;
  var S = Ye("recharts-rectangle", m);
  return w ? /* @__PURE__ */ I.createElement(Ni, {
    canBegin: a > 0,
    from: {
      width: f,
      height: d,
      x: l,
      y: c
    },
    to: {
      width: f,
      height: d,
      x: l,
      y: c
    },
    duration: v,
    animationEasing: g,
    isActive: w
  }, function(A) {
    var _ = A.width, O = A.height, T = A.x, C = A.y;
    return /* @__PURE__ */ I.createElement(Ni, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: v,
      isActive: x,
      easing: g
    }, /* @__PURE__ */ I.createElement("path", Tm({}, Ee(n, !0), {
      className: S,
      d: NN(T, C, _, O, p),
      ref: r
    })));
  }) : /* @__PURE__ */ I.createElement("path", Tm({}, Ee(n, !0), {
    className: S,
    d: NN(l, c, f, d, p)
  }));
}, A_e = ["points", "className", "baseLinePoints", "connectNulls"];
function Rl() {
  return Rl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rl.apply(this, arguments);
}
function P_e(e, t) {
  if (e == null) return {};
  var n = T_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function T_e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function $N(e) {
  return M_e(e) || k_e(e) || E_e(e) || C_e();
}
function C_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function E_e(e, t) {
  if (e) {
    if (typeof e == "string") return mw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mw(e, t);
  }
}
function k_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function M_e(e) {
  if (Array.isArray(e)) return mw(e);
}
function mw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var DN = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, N_e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [[]];
  return t.forEach(function(r) {
    DN(r) ? n[n.length - 1].push(r) : n[n.length - 1].length > 0 && n.push([]);
  }), DN(t[0]) && n[n.length - 1].push(t[0]), n[n.length - 1].length <= 0 && (n = n.slice(0, -1)), n;
}, rf = function(t, n) {
  var r = N_e(t);
  n && (r = [r.reduce(function(o, a) {
    return [].concat($N(o), $N(a));
  }, [])]);
  var i = r.map(function(o) {
    return o.reduce(function(a, s, l) {
      return "".concat(a).concat(l === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return r.length === 1 ? "".concat(i, "Z") : i;
}, $_e = function(t, n, r) {
  var i = rf(t, r);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(rf(n.reverse(), r).slice(1));
}, D_e = function(t) {
  var n = t.points, r = t.className, i = t.baseLinePoints, o = t.connectNulls, a = P_e(t, A_e);
  if (!n || !n.length)
    return null;
  var s = Ye("recharts-polygon", r);
  if (i && i.length) {
    var l = a.stroke && a.stroke !== "none", c = $_e(n, i, o);
    return /* @__PURE__ */ I.createElement("g", {
      className: s
    }, /* @__PURE__ */ I.createElement("path", Rl({}, Ee(a, !0), {
      fill: c.slice(-1) === "Z" ? a.fill : "none",
      stroke: "none",
      d: c
    })), l ? /* @__PURE__ */ I.createElement("path", Rl({}, Ee(a, !0), {
      fill: "none",
      d: rf(n, o)
    })) : null, l ? /* @__PURE__ */ I.createElement("path", Rl({}, Ee(a, !0), {
      fill: "none",
      d: rf(i, o)
    })) : null);
  }
  var f = rf(n, o);
  return /* @__PURE__ */ I.createElement("path", Rl({}, Ee(a, !0), {
    fill: f.slice(-1) === "Z" ? a.fill : "none",
    className: s,
    d: f
  }));
};
function gw() {
  return gw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gw.apply(this, arguments);
}
var Nd = function(t) {
  var n = t.cx, r = t.cy, i = t.r, o = t.className, a = Ye("recharts-dot", o);
  return n === +n && r === +r && i === +i ? /* @__PURE__ */ I.createElement("circle", gw({}, Ee(t, !1), Hp(t), {
    className: a,
    cx: n,
    cy: r,
    r: i
  })) : null;
};
function Xf(e) {
  "@babel/helpers - typeof";
  return Xf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xf(e);
}
var I_e = ["x", "y", "top", "left", "width", "height", "className"];
function yw() {
  return yw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yw.apply(this, arguments);
}
function IN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function R_e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IN(Object(n), !0).forEach(function(r) {
      j_e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : IN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function j_e(e, t, n) {
  return t = L_e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function L_e(e) {
  var t = B_e(e, "string");
  return Xf(t) == "symbol" ? t : t + "";
}
function B_e(e, t) {
  if (Xf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Xf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function F_e(e, t) {
  if (e == null) return {};
  var n = W_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function W_e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var z_e = function(t, n, r, i, o, a) {
  return "M".concat(t, ",").concat(o, "v").concat(i, "M").concat(a, ",").concat(n, "h").concat(r);
}, V_e = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.top, s = a === void 0 ? 0 : a, l = t.left, c = l === void 0 ? 0 : l, f = t.width, d = f === void 0 ? 0 : f, p = t.height, m = p === void 0 ? 0 : p, g = t.className, v = F_e(t, I_e), y = R_e({
    x: r,
    y: o,
    top: s,
    left: c,
    width: d,
    height: m
  }, v);
  return !be(r) || !be(o) || !be(d) || !be(m) || !be(s) || !be(c) ? null : /* @__PURE__ */ I.createElement("path", yw({}, Ee(y, !0), {
    className: Ye("recharts-cross", g),
    d: z_e(r, o, d, m, s, c)
  }));
}, U_e = ly, K_e = fF, H_e = oo;
function G_e(e, t) {
  return e && e.length ? U_e(e, H_e(t), K_e) : void 0;
}
var Y_e = G_e;
const q_e = /* @__PURE__ */ Et(Y_e);
var X_e = ly, Z_e = oo, J_e = dF;
function Q_e(e, t) {
  return e && e.length ? X_e(e, Z_e(t), J_e) : void 0;
}
var eSe = Q_e;
const tSe = /* @__PURE__ */ Et(eSe);
var nSe = ["cx", "cy", "angle", "ticks", "axisLine"], rSe = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function hc(e) {
  "@babel/helpers - typeof";
  return hc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hc(e);
}
function of() {
  return of = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, of.apply(this, arguments);
}
function RN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function us(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? RN(Object(n), !0).forEach(function(r) {
      dy(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : RN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function jN(e, t) {
  if (e == null) return {};
  var n = iSe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function iSe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function oSe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function LN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, tW(r.key), r);
  }
}
function aSe(e, t, n) {
  return t && LN(e.prototype, t), n && LN(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sSe(e, t, n) {
  return t = Cm(t), lSe(e, eW() ? Reflect.construct(t, n || [], Cm(e).constructor) : t.apply(e, n));
}
function lSe(e, t) {
  if (t && (hc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cSe(e);
}
function cSe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function eW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (eW = function() {
    return !!e;
  })();
}
function Cm(e) {
  return Cm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cm(e);
}
function uSe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && vw(e, t);
}
function vw(e, t) {
  return vw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, vw(e, t);
}
function dy(e, t, n) {
  return t = tW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tW(e) {
  var t = fSe(e, "string");
  return hc(t) == "symbol" ? t : t + "";
}
function fSe(e, t) {
  if (hc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (hc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var hy = /* @__PURE__ */ function(e) {
  function t() {
    return oSe(this, t), sSe(this, t, arguments);
  }
  return uSe(t, e), aSe(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(r) {
        var i = r.coordinate, o = this.props, a = o.angle, s = o.cx, l = o.cy;
        return Lt(s, l, i, a);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props.orientation, i;
      switch (r) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, l = q_e(s, function(f) {
        return f.coordinate || 0;
      }), c = tSe(s, function(f) {
        return f.coordinate || 0;
      });
      return {
        cx: i,
        cy: o,
        startAngle: a,
        endAngle: a,
        innerRadius: c.coordinate || 0,
        outerRadius: l.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, l = r.axisLine, c = jN(r, nSe), f = s.reduce(function(g, v) {
        return [Math.min(g[0], v.coordinate), Math.max(g[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), d = Lt(i, o, f[0], a), p = Lt(i, o, f[1], a), m = us(us(us({}, Ee(c, !1)), {}, {
        fill: "none"
      }, Ee(l, !1)), {}, {
        x1: d.x,
        y1: d.y,
        x2: p.x,
        y2: p.y
      });
      return /* @__PURE__ */ I.createElement("line", of({
        className: "recharts-polar-radius-axis-line"
      }, m));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.angle, l = i.tickFormatter, c = i.stroke, f = jN(i, rSe), d = this.getTickTextAnchor(), p = Ee(f, !1), m = Ee(a, !1), g = o.map(function(v, y) {
        var x = r.getTickValueCoord(v), w = us(us(us(us({
          textAnchor: d,
          transform: "rotate(".concat(90 - s, ", ").concat(x.x, ", ").concat(x.y, ")")
        }, p), {}, {
          stroke: "none",
          fill: c
        }, m), {}, {
          index: y
        }, x), {}, {
          payload: v
        });
        return /* @__PURE__ */ I.createElement(ot, of({
          className: Ye("recharts-polar-radius-axis-tick", FF(a)),
          key: "tick-".concat(v.coordinate)
        }, Fs(r.props, v, y)), t.renderTickItem(a, w, l ? l(v.value, y) : v.value));
      });
      return /* @__PURE__ */ I.createElement(ot, {
        className: "recharts-polar-radius-axis-ticks"
      }, g);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.axisLine, a = r.tick;
      return !i || !i.length ? null : /* @__PURE__ */ I.createElement(ot, {
        className: Ye("recharts-polar-radius-axis", this.props.className)
      }, o && this.renderAxisLine(), a && this.renderTicks(), _n.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ I.isValidElement(r) ? a = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? a = r(i) : a = /* @__PURE__ */ I.createElement(Ws, of({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), o), a;
    }
  }]);
}(hi);
dy(hy, "displayName", "PolarRadiusAxis");
dy(hy, "axisType", "radiusAxis");
dy(hy, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function pc(e) {
  "@babel/helpers - typeof";
  return pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pc(e);
}
function bs() {
  return bs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bs.apply(this, arguments);
}
function BN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BN(Object(n), !0).forEach(function(r) {
      py(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : BN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dSe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function FN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, rW(r.key), r);
  }
}
function hSe(e, t, n) {
  return t && FN(e.prototype, t), n && FN(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pSe(e, t, n) {
  return t = Em(t), mSe(e, nW() ? Reflect.construct(t, n || [], Em(e).constructor) : t.apply(e, n));
}
function mSe(e, t) {
  if (t && (pc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gSe(e);
}
function gSe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nW = function() {
    return !!e;
  })();
}
function Em(e) {
  return Em = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Em(e);
}
function ySe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && bw(e, t);
}
function bw(e, t) {
  return bw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, bw(e, t);
}
function py(e, t, n) {
  return t = rW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rW(e) {
  var t = vSe(e, "string");
  return pc(t) == "symbol" ? t : t + "";
}
function vSe(e, t) {
  if (pc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (pc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bSe = Math.PI / 180, WN = 1e-5, my = /* @__PURE__ */ function(e) {
  function t() {
    return dSe(this, t), pSe(this, t, arguments);
  }
  return ySe(t, e), hSe(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(r) {
        var i = this.props, o = i.cx, a = i.cy, s = i.radius, l = i.orientation, c = i.tickSize, f = c || 8, d = Lt(o, a, s, r.coordinate), p = Lt(o, a, s + (l === "inner" ? -1 : 1) * f, r.coordinate);
        return {
          x1: d.x,
          y1: d.y,
          x2: p.x,
          y2: p.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(r) {
      var i = this.props.orientation, o = Math.cos(-r.coordinate * bSe), a;
      return o > WN ? a = i === "outer" ? "start" : "end" : o < -WN ? a = i === "outer" ? "end" : "start" : a = "middle", a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.radius, s = r.axisLine, l = r.axisLineType, c = fs(fs({}, Ee(this.props, !1)), {}, {
        fill: "none"
      }, Ee(s, !1));
      if (l === "circle")
        return /* @__PURE__ */ I.createElement(Nd, bs({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: i,
          cy: o,
          r: a
        }));
      var f = this.props.ticks, d = f.map(function(p) {
        return Lt(i, o, a, p.coordinate);
      });
      return /* @__PURE__ */ I.createElement(D_e, bs({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: d
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.tickLine, l = i.tickFormatter, c = i.stroke, f = Ee(this.props, !1), d = Ee(a, !1), p = fs(fs({}, f), {}, {
        fill: "none"
      }, Ee(s, !1)), m = o.map(function(g, v) {
        var y = r.getTickLineCoord(g), x = r.getTickTextAnchor(g), w = fs(fs(fs({
          textAnchor: x
        }, f), {}, {
          stroke: "none",
          fill: c
        }, d), {}, {
          index: v,
          payload: g,
          x: y.x2,
          y: y.y2
        });
        return /* @__PURE__ */ I.createElement(ot, bs({
          className: Ye("recharts-polar-angle-axis-tick", FF(a)),
          key: "tick-".concat(g.coordinate)
        }, Fs(r.props, g, v)), s && /* @__PURE__ */ I.createElement("line", bs({
          className: "recharts-polar-angle-axis-tick-line"
        }, p, y)), a && t.renderTickItem(a, w, l ? l(g.value, v) : g.value));
      });
      return /* @__PURE__ */ I.createElement(ot, {
        className: "recharts-polar-angle-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.radius, a = r.axisLine;
      return o <= 0 || !i || !i.length ? null : /* @__PURE__ */ I.createElement(ot, {
        className: Ye("recharts-polar-angle-axis", this.props.className)
      }, a && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ I.isValidElement(r) ? a = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? a = r(i) : a = /* @__PURE__ */ I.createElement(Ws, bs({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), o), a;
    }
  }]);
}(hi);
py(my, "displayName", "PolarAngleAxis");
py(my, "axisType", "angleAxis");
py(my, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var xSe = aB, wSe = xSe(Object.getPrototypeOf, Object), _Se = wSe, SSe = Jo, OSe = _Se, ASe = Qo, PSe = "[object Object]", TSe = Function.prototype, CSe = Object.prototype, iW = TSe.toString, ESe = CSe.hasOwnProperty, kSe = iW.call(Object);
function MSe(e) {
  if (!ASe(e) || SSe(e) != PSe)
    return !1;
  var t = OSe(e);
  if (t === null)
    return !0;
  var n = ESe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && iW.call(n) == kSe;
}
var NSe = MSe;
const $Se = /* @__PURE__ */ Et(NSe);
var DSe = Jo, ISe = Qo, RSe = "[object Boolean]";
function jSe(e) {
  return e === !0 || e === !1 || ISe(e) && DSe(e) == RSe;
}
var LSe = jSe;
const BSe = /* @__PURE__ */ Et(LSe);
function Zf(e) {
  "@babel/helpers - typeof";
  return Zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zf(e);
}
function km() {
  return km = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, km.apply(this, arguments);
}
function FSe(e, t) {
  return USe(e) || VSe(e, t) || zSe(e, t) || WSe();
}
function WSe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zSe(e, t) {
  if (e) {
    if (typeof e == "string") return zN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zN(e, t);
  }
}
function zN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function VSe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function USe(e) {
  if (Array.isArray(e)) return e;
}
function VN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function UN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VN(Object(n), !0).forEach(function(r) {
      KSe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function KSe(e, t, n) {
  return t = HSe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function HSe(e) {
  var t = GSe(e, "string");
  return Zf(t) == "symbol" ? t : t + "";
}
function GSe(e, t) {
  if (Zf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Zf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var KN = function(t, n, r, i, o) {
  var a = r - i, s;
  return s = "M ".concat(t, ",").concat(n), s += "L ".concat(t + r, ",").concat(n), s += "L ".concat(t + r - a / 2, ",").concat(n + o), s += "L ".concat(t + r - a / 2 - i, ",").concat(n + o), s += "L ".concat(t, ",").concat(n, " Z"), s;
}, YSe = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, qSe = function(t) {
  var n = UN(UN({}, YSe), t), r = ft(), i = Me(-1), o = FSe(i, 2), a = o[0], s = o[1];
  Qe(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var S = r.current.getTotalLength();
        S && s(S);
      } catch {
      }
  }, []);
  var l = n.x, c = n.y, f = n.upperWidth, d = n.lowerWidth, p = n.height, m = n.className, g = n.animationEasing, v = n.animationDuration, y = n.animationBegin, x = n.isUpdateAnimationActive;
  if (l !== +l || c !== +c || f !== +f || d !== +d || p !== +p || f === 0 && d === 0 || p === 0)
    return null;
  var w = Ye("recharts-trapezoid", m);
  return x ? /* @__PURE__ */ I.createElement(Ni, {
    canBegin: a > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: p,
      x: l,
      y: c
    },
    to: {
      upperWidth: f,
      lowerWidth: d,
      height: p,
      x: l,
      y: c
    },
    duration: v,
    animationEasing: g,
    isActive: x
  }, function(S) {
    var A = S.upperWidth, _ = S.lowerWidth, O = S.height, T = S.x, C = S.y;
    return /* @__PURE__ */ I.createElement(Ni, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: v,
      easing: g
    }, /* @__PURE__ */ I.createElement("path", km({}, Ee(n, !0), {
      className: w,
      d: KN(T, C, A, _, O),
      ref: r
    })));
  }) : /* @__PURE__ */ I.createElement("g", null, /* @__PURE__ */ I.createElement("path", km({}, Ee(n, !0), {
    className: w,
    d: KN(l, c, f, d, p)
  })));
}, XSe = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Jf(e) {
  "@babel/helpers - typeof";
  return Jf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jf(e);
}
function ZSe(e, t) {
  if (e == null) return {};
  var n = JSe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function JSe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function HN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HN(Object(n), !0).forEach(function(r) {
      QSe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function QSe(e, t, n) {
  return t = eOe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function eOe(e) {
  var t = tOe(e, "string");
  return Jf(t) == "symbol" ? t : t + "";
}
function tOe(e, t) {
  if (Jf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Jf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function nOe(e, t) {
  return Mm(Mm({}, t), e);
}
function rOe(e, t) {
  return e === "symbols";
}
function GN(e) {
  var t = e.shapeType, n = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ I.createElement(SS, n);
    case "trapezoid":
      return /* @__PURE__ */ I.createElement(qSe, n);
    case "sector":
      return /* @__PURE__ */ I.createElement(VF, n);
    case "symbols":
      if (rOe(t))
        return /* @__PURE__ */ I.createElement(F_, n);
      break;
    default:
      return null;
  }
}
function iOe(e) {
  return /* @__PURE__ */ ut(e) ? e.props : e;
}
function oW(e) {
  var t = e.option, n = e.shapeType, r = e.propTransformer, i = r === void 0 ? nOe : r, o = e.activeClassName, a = o === void 0 ? "recharts-active-shape" : o, s = e.isActive, l = ZSe(e, XSe), c;
  if (/* @__PURE__ */ ut(t))
    c = /* @__PURE__ */ _t(t, Mm(Mm({}, l), iOe(t)));
  else if (ze(t))
    c = t(l);
  else if ($Se(t) && !BSe(t)) {
    var f = i(t, l);
    c = /* @__PURE__ */ I.createElement(GN, {
      shapeType: n,
      elementProps: f
    });
  } else {
    var d = l;
    c = /* @__PURE__ */ I.createElement(GN, {
      shapeType: n,
      elementProps: d
    });
  }
  return s ? /* @__PURE__ */ I.createElement(ot, {
    className: a
  }, c) : c;
}
function gy(e, t) {
  return t != null && "trapezoids" in e.props;
}
function yy(e, t) {
  return t != null && "sectors" in e.props;
}
function Qf(e, t) {
  return t != null && "points" in e.props;
}
function oOe(e, t) {
  var n, r, i = e.x === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === t.x, o = e.y === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.y) || e.y === t.y;
  return i && o;
}
function aOe(e, t) {
  var n = e.endAngle === t.endAngle, r = e.startAngle === t.startAngle;
  return n && r;
}
function sOe(e, t) {
  var n = e.x === t.x, r = e.y === t.y, i = e.z === t.z;
  return n && r && i;
}
function lOe(e, t) {
  var n;
  return gy(e, t) ? n = oOe : yy(e, t) ? n = aOe : Qf(e, t) && (n = sOe), n;
}
function cOe(e, t) {
  var n;
  return gy(e, t) ? n = "trapezoids" : yy(e, t) ? n = "sectors" : Qf(e, t) && (n = "points"), n;
}
function uOe(e, t) {
  if (gy(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if (yy(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return Qf(e, t) ? t.payload : {};
}
function fOe(e) {
  var t = e.activeTooltipItem, n = e.graphicalItem, r = e.itemData, i = cOe(n, t), o = uOe(n, t), a = r.filter(function(l, c) {
    var f = zs(o, l), d = n.props[i].filter(function(g) {
      var v = lOe(n, t);
      return v(g, t);
    }), p = n.props[i].indexOf(d[d.length - 1]), m = c === p;
    return f && m;
  }), s = r.indexOf(a[a.length - 1]);
  return s;
}
var cp;
function mc(e) {
  "@babel/helpers - typeof";
  return mc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mc(e);
}
function jl() {
  return jl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jl.apply(this, arguments);
}
function YN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function It(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YN(Object(n), !0).forEach(function(r) {
      li(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dOe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, sW(r.key), r);
  }
}
function hOe(e, t, n) {
  return t && qN(e.prototype, t), n && qN(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pOe(e, t, n) {
  return t = Nm(t), mOe(e, aW() ? Reflect.construct(t, n || [], Nm(e).constructor) : t.apply(e, n));
}
function mOe(e, t) {
  if (t && (mc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gOe(e);
}
function gOe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function aW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aW = function() {
    return !!e;
  })();
}
function Nm(e) {
  return Nm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Nm(e);
}
function yOe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && xw(e, t);
}
function xw(e, t) {
  return xw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, xw(e, t);
}
function li(e, t, n) {
  return t = sW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sW(e) {
  var t = vOe(e, "string");
  return mc(t) == "symbol" ? t : t + "";
}
function vOe(e, t) {
  if (mc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (mc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ta = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return dOe(this, t), r = pOe(this, t, [n]), li(r, "pieRef", null), li(r, "sectorRefs", []), li(r, "id", Qs("recharts-pie-")), li(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ze(i) && i();
    }), li(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ze(i) && i();
    }), r.state = {
      isAnimationFinished: !n.isAnimationActive,
      prevIsAnimationActive: n.isAnimationActive,
      prevAnimationId: n.animationId,
      sectorToFocus: 0
    }, r;
  }
  return yOe(t, e), hOe(t, [{
    key: "isActiveIndex",
    value: function(r) {
      var i = this.props.activeIndex;
      return Array.isArray(i) ? i.indexOf(r) !== -1 : r === i;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var r = this.props.activeIndex;
      return Array.isArray(r) ? r.length !== 0 : r || r === 0;
    }
  }, {
    key: "renderLabels",
    value: function(r) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.label, s = o.labelLine, l = o.dataKey, c = o.valueKey, f = Ee(this.props, !1), d = Ee(a, !1), p = Ee(s, !1), m = a && a.offsetRadius || 20, g = r.map(function(v, y) {
        var x = (v.startAngle + v.endAngle) / 2, w = Lt(v.cx, v.cy, v.outerRadius + m, x), S = It(It(It(It({}, f), v), {}, {
          stroke: "none"
        }, d), {}, {
          index: y,
          textAnchor: t.getTextAnchor(w.x, v.cx)
        }, w), A = It(It(It(It({}, f), v), {}, {
          fill: "none",
          stroke: v.fill
        }, p), {}, {
          index: y,
          points: [Lt(v.cx, v.cy, v.outerRadius, x), w]
        }), _ = l;
        return Ue(l) && Ue(c) ? _ = "value" : Ue(l) && (_ = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ I.createElement(ot, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(y)
        }, s && t.renderLabelLineItem(s, A, "line"), t.renderLabelItem(a, S, ln(v, _)));
      });
      return /* @__PURE__ */ I.createElement(ot, {
        className: "recharts-pie-labels"
      }, g);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.activeShape, s = o.blendStroke, l = o.inactiveShape;
      return r.map(function(c, f) {
        if ((c == null ? void 0 : c.startAngle) === 0 && (c == null ? void 0 : c.endAngle) === 0 && r.length !== 1) return null;
        var d = i.isActiveIndex(f), p = l && i.hasActiveIndex() ? l : null, m = d ? a : p, g = It(It({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ I.createElement(ot, jl({
          ref: function(y) {
            y && !i.sectorRefs.includes(y) && i.sectorRefs.push(y);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, Fs(i.props, c, f), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c == null ? void 0 : c.startAngle, "-").concat(c == null ? void 0 : c.endAngle, "-").concat(c.midAngle, "-").concat(f)
        }), /* @__PURE__ */ I.createElement(oW, jl({
          option: m,
          isActive: d,
          shapeType: "sector"
        }, g)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.sectors, a = i.isAnimationActive, s = i.animationBegin, l = i.animationDuration, c = i.animationEasing, f = i.animationId, d = this.state, p = d.prevSectors, m = d.prevIsAnimationActive;
      return /* @__PURE__ */ I.createElement(Ni, {
        begin: s,
        duration: l,
        isActive: a,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(f, "-").concat(m),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(g) {
        var v = g.t, y = [], x = o && o[0], w = x.startAngle;
        return o.forEach(function(S, A) {
          var _ = p && p[A], O = A > 0 ? Wr(S, "paddingAngle", 0) : 0;
          if (_) {
            var T = wn(_.endAngle - _.startAngle, S.endAngle - S.startAngle), C = It(It({}, S), {}, {
              startAngle: w + O,
              endAngle: w + T(v) + O
            });
            y.push(C), w = C.endAngle;
          } else {
            var k = S.endAngle, D = S.startAngle, N = wn(0, k - D), $ = N(v), B = It(It({}, S), {}, {
              startAngle: w + O,
              endAngle: w + $ + O
            });
            y.push(B), w = B.endAngle;
          }
        }), /* @__PURE__ */ I.createElement(ot, null, r.renderSectorsStatically(y));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(r) {
      var i = this;
      r.onkeydown = function(o) {
        if (!o.altKey)
          switch (o.key) {
            case "ArrowLeft": {
              var a = ++i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[a].focus(), i.setState({
                sectorToFocus: a
              });
              break;
            }
            case "ArrowRight": {
              var s = --i.state.sectorToFocus < 0 ? i.sectorRefs.length - 1 : i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[s].focus(), i.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              i.sectorRefs[i.state.sectorToFocus].blur(), i.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var r = this.props, i = r.sectors, o = r.isAnimationActive, a = this.state.prevSectors;
      return o && i && i.length && (!a || !zs(a, i)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(i);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.hide, a = i.sectors, s = i.className, l = i.label, c = i.cx, f = i.cy, d = i.innerRadius, p = i.outerRadius, m = i.isAnimationActive, g = this.state.isAnimationFinished;
      if (o || !a || !a.length || !be(c) || !be(f) || !be(d) || !be(p))
        return null;
      var v = Ye("recharts-pie", s);
      return /* @__PURE__ */ I.createElement(ot, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(x) {
          r.pieRef = x;
        }
      }, this.renderSectors(), l && this.renderLabels(a), _n.renderCallByParent(this.props, null, !1), (!m || g) && Zi.renderCallByParent(this.props, a, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return i.prevIsAnimationActive !== r.isAnimationActive ? {
        prevIsAnimationActive: r.isAnimationActive,
        prevAnimationId: r.animationId,
        curSectors: r.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : r.isAnimationActive && r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curSectors: r.sectors,
        prevSectors: i.curSectors,
        isAnimationFinished: !0
      } : r.sectors !== i.curSectors ? {
        curSectors: r.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(r, i) {
      return r > i ? "start" : r < i ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(r, i, o) {
      if (/* @__PURE__ */ I.isValidElement(r))
        return /* @__PURE__ */ I.cloneElement(r, i);
      if (ze(r))
        return r(i);
      var a = Ye("recharts-pie-label-line", typeof r != "boolean" ? r.className : "");
      return /* @__PURE__ */ I.createElement($s, jl({}, i, {
        key: o,
        type: "linear",
        className: a
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(r, i, o) {
      if (/* @__PURE__ */ I.isValidElement(r))
        return /* @__PURE__ */ I.cloneElement(r, i);
      var a = o;
      if (ze(r) && (a = r(i), /* @__PURE__ */ I.isValidElement(a)))
        return a;
      var s = Ye("recharts-pie-label-text", typeof r != "boolean" && !ze(r) ? r.className : "");
      return /* @__PURE__ */ I.createElement(Ws, jl({}, i, {
        alignmentBaseline: "middle",
        className: s
      }), a);
    }
  }]);
}(hi);
cp = ta;
li(ta, "displayName", "Pie");
li(ta, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Mi.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
li(ta, "parseDeltaAngle", function(e, t) {
  var n = ur(t - e), r = Math.min(Math.abs(t - e), 360);
  return n * r;
});
li(ta, "getRealPieData", function(e) {
  var t = e.data, n = e.children, r = Ee(e, !1), i = zr(n, X_);
  return t && t.length ? t.map(function(o, a) {
    return It(It(It({
      payload: o
    }, r), o), i && i[a] && i[a].props);
  }) : i && i.length ? i.map(function(o) {
    return It(It({}, r), o.props);
  }) : [];
});
li(ta, "parseCoordinateOfPie", function(e, t) {
  var n = t.top, r = t.left, i = t.width, o = t.height, a = BF(i, o), s = r + fr(e.cx, i, i / 2), l = n + fr(e.cy, o, o / 2), c = fr(e.innerRadius, a, 0), f = fr(e.outerRadius, a, a * 0.8), d = e.maxRadius || Math.sqrt(i * i + o * o) / 2;
  return {
    cx: s,
    cy: l,
    innerRadius: c,
    outerRadius: f,
    maxRadius: d
  };
});
li(ta, "getComposedData", function(e) {
  var t = e.item, n = e.offset, r = t.type.defaultProps !== void 0 ? It(It({}, t.type.defaultProps), t.props) : t.props, i = cp.getRealPieData(r);
  if (!i || !i.length)
    return null;
  var o = r.cornerRadius, a = r.startAngle, s = r.endAngle, l = r.paddingAngle, c = r.dataKey, f = r.nameKey, d = r.valueKey, p = r.tooltipType, m = Math.abs(r.minAngle), g = cp.parseCoordinateOfPie(r, n), v = cp.parseDeltaAngle(a, s), y = Math.abs(v), x = c;
  Ue(c) && Ue(d) ? (ki(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), x = "value") : Ue(c) && (ki(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), x = d);
  var w = i.filter(function(C) {
    return ln(C, x, 0) !== 0;
  }).length, S = (y >= 360 ? w : w - 1) * l, A = y - w * m - S, _ = i.reduce(function(C, k) {
    var D = ln(k, x, 0);
    return C + (be(D) ? D : 0);
  }, 0), O;
  if (_ > 0) {
    var T;
    O = i.map(function(C, k) {
      var D = ln(C, x, 0), N = ln(C, f, k), $ = (be(D) ? D : 0) / _, B;
      k ? B = T.endAngle + ur(v) * l * (D !== 0 ? 1 : 0) : B = a;
      var L = B + ur(v) * ((D !== 0 ? m : 0) + $ * A), F = (B + L) / 2, W = (g.innerRadius + g.outerRadius) / 2, z = [{
        name: N,
        value: D,
        payload: C,
        dataKey: x,
        type: p
      }], G = Lt(g.cx, g.cy, W, F);
      return T = It(It(It({
        percent: $,
        cornerRadius: o,
        name: N,
        tooltipPayload: z,
        midAngle: F,
        middleRadius: W,
        tooltipPosition: G
      }, C), g), {}, {
        value: ln(C, x),
        startAngle: B,
        endAngle: L,
        payload: C,
        paddingAngle: ur(v) * l
      }), T;
    });
  }
  return It(It({}, g), {}, {
    sectors: O,
    data: i
  });
});
var bOe = Math.ceil, xOe = Math.max;
function wOe(e, t, n, r) {
  for (var i = -1, o = xOe(bOe((t - e) / (n || 1)), 0), a = Array(o); o--; )
    a[r ? o : ++i] = e, e += n;
  return a;
}
var _Oe = wOe, SOe = AB, XN = 1 / 0, OOe = 17976931348623157e292;
function AOe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = SOe(e), e === XN || e === -XN) {
    var t = e < 0 ? -1 : 1;
    return t * OOe;
  }
  return e === e ? e : 0;
}
var lW = AOe, POe = _Oe, TOe = ty, e0 = lW;
function COe(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && TOe(t, n, r) && (n = r = void 0), t = e0(t), n === void 0 ? (n = t, t = 0) : n = e0(n), r = r === void 0 ? t < n ? 1 : -1 : e0(r), POe(t, n, r, e);
  };
}
var EOe = COe, kOe = EOe, MOe = kOe(), NOe = MOe;
const $m = /* @__PURE__ */ Et(NOe);
function ed(e) {
  "@babel/helpers - typeof";
  return ed = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ed(e);
}
function ZN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function JN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZN(Object(n), !0).forEach(function(r) {
      cW(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ZN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cW(e, t, n) {
  return t = $Oe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $Oe(e) {
  var t = DOe(e, "string");
  return ed(t) == "symbol" ? t : t + "";
}
function DOe(e, t) {
  if (ed(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ed(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var IOe = ["Webkit", "Moz", "O", "ms"], ROe = function(t, n) {
  var r = t.replace(/(\w)/, function(o) {
    return o.toUpperCase();
  }), i = IOe.reduce(function(o, a) {
    return JN(JN({}, o), {}, cW({}, a + r, n));
  }, {});
  return i[t] = n, i;
};
function gc(e) {
  "@babel/helpers - typeof";
  return gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gc(e);
}
function Dm() {
  return Dm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dm.apply(this, arguments);
}
function QN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function t0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QN(Object(n), !0).forEach(function(r) {
      Ir(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : QN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function jOe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function e$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fW(r.key), r);
  }
}
function LOe(e, t, n) {
  return t && e$(e.prototype, t), n && e$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function BOe(e, t, n) {
  return t = Im(t), FOe(e, uW() ? Reflect.construct(t, n || [], Im(e).constructor) : t.apply(e, n));
}
function FOe(e, t) {
  if (t && (gc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return WOe(e);
}
function WOe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (uW = function() {
    return !!e;
  })();
}
function Im(e) {
  return Im = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Im(e);
}
function zOe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ww(e, t);
}
function ww(e, t) {
  return ww = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ww(e, t);
}
function Ir(e, t, n) {
  return t = fW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fW(e) {
  var t = VOe(e, "string");
  return gc(t) == "symbol" ? t : t + "";
}
function VOe(e, t) {
  if (gc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (gc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var UOe = function(t) {
  var n = t.data, r = t.startIndex, i = t.endIndex, o = t.x, a = t.width, s = t.travellerWidth;
  if (!n || !n.length)
    return {};
  var l = n.length, c = ef().domain($m(0, l)).range([o, o + a - s]), f = c.domain().map(function(d) {
    return c(d);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(r),
    endX: c(i),
    scale: c,
    scaleValues: f
  };
}, t$ = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, yc = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return jOe(this, t), r = BOe(this, t, [n]), Ir(r, "handleDrag", function(i) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(i) : r.state.isSlideMoving && r.handleSlideDrag(i);
    }), Ir(r, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && r.handleDrag(i.changedTouches[0]);
    }), Ir(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = r.props, o = i.endIndex, a = i.onDragEnd, s = i.startIndex;
        a == null || a({
          endIndex: o,
          startIndex: s
        });
      }), r.detachDragEndListener();
    }), Ir(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), Ir(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), Ir(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), Ir(r, "handleSlideDragStart", function(i) {
      var o = t$(i) ? i.changedTouches[0] : i;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: o.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return zOe(t, e), LOe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var i = r.startX, o = r.endX, a = this.state.scaleValues, s = this.props, l = s.gap, c = s.data, f = c.length - 1, d = Math.min(i, o), p = Math.max(i, o), m = t.getIndexInRange(a, d), g = t.getIndexInRange(a, p);
      return {
        startIndex: m - m % l,
        endIndex: g === f ? f : g - g % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var i = this.props, o = i.data, a = i.tickFormatter, s = i.dataKey, l = ln(o[r], s, r);
      return ze(a) ? a(l, r) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var i = this.state, o = i.slideMoveStartX, a = i.startX, s = i.endX, l = this.props, c = l.x, f = l.width, d = l.travellerWidth, p = l.startIndex, m = l.endIndex, g = l.onChange, v = r.pageX - o;
      v > 0 ? v = Math.min(v, c + f - d - s, c + f - d - a) : v < 0 && (v = Math.max(v, c - a, c - s));
      var y = this.getIndex({
        startX: a + v,
        endX: s + v
      });
      (y.startIndex !== p || y.endIndex !== m) && g && g(y), this.setState({
        startX: a + v,
        endX: s + v,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, i) {
      var o = t$(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: o.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var i = this.state, o = i.brushMoveStartX, a = i.movingTravellerId, s = i.endX, l = i.startX, c = this.state[a], f = this.props, d = f.x, p = f.width, m = f.travellerWidth, g = f.onChange, v = f.gap, y = f.data, x = {
        startX: this.state.startX,
        endX: this.state.endX
      }, w = r.pageX - o;
      w > 0 ? w = Math.min(w, d + p - m - c) : w < 0 && (w = Math.max(w, d - c)), x[a] = c + w;
      var S = this.getIndex(x), A = S.startIndex, _ = S.endIndex, O = function() {
        var C = y.length - 1;
        return a === "startX" && (s > l ? A % v === 0 : _ % v === 0) || s < l && _ === C || a === "endX" && (s > l ? _ % v === 0 : A % v === 0) || s > l && _ === C;
      };
      this.setState(Ir(Ir({}, a, c + w), "brushMoveStartX", r.pageX), function() {
        g && O() && g(S);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, i) {
      var o = this, a = this.state, s = a.scaleValues, l = a.startX, c = a.endX, f = this.state[i], d = s.indexOf(f);
      if (d !== -1) {
        var p = d + r;
        if (!(p === -1 || p >= s.length)) {
          var m = s[p];
          i === "startX" && m >= c || i === "endX" && m <= l || this.setState(Ir({}, i, m), function() {
            o.props.onChange(o.getIndex({
              startX: o.state.startX,
              endX: o.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.fill, c = r.stroke;
      return /* @__PURE__ */ I.createElement("rect", {
        stroke: c,
        fill: l,
        x: i,
        y: o,
        width: a,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.data, c = r.children, f = r.padding, d = tr.only(c);
      return d ? /* @__PURE__ */ I.cloneElement(d, {
        x: i,
        y: o,
        width: a,
        height: s,
        margin: f,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, i) {
      var o, a, s = this, l = this.props, c = l.y, f = l.travellerWidth, d = l.height, p = l.traveller, m = l.ariaLabel, g = l.data, v = l.startIndex, y = l.endIndex, x = Math.max(r, this.props.x), w = t0(t0({}, Ee(this.props, !1)), {}, {
        x,
        y: c,
        width: f,
        height: d
      }), S = m || "Min value: ".concat((o = g[v]) === null || o === void 0 ? void 0 : o.name, ", Max value: ").concat((a = g[y]) === null || a === void 0 ? void 0 : a.name);
      return /* @__PURE__ */ I.createElement(ot, {
        tabIndex: 0,
        role: "slider",
        "aria-label": S,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(_) {
          ["ArrowLeft", "ArrowRight"].includes(_.key) && (_.preventDefault(), _.stopPropagation(), s.handleTravellerMoveKeyboard(_.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(p, w));
    }
  }, {
    key: "renderSlide",
    value: function(r, i) {
      var o = this.props, a = o.y, s = o.height, l = o.stroke, c = o.travellerWidth, f = Math.min(r, i) + c, d = Math.max(Math.abs(i - r) - c, 0);
      return /* @__PURE__ */ I.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: f,
        y: a,
        width: d,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, i = r.startIndex, o = r.endIndex, a = r.y, s = r.height, l = r.travellerWidth, c = r.stroke, f = this.state, d = f.startX, p = f.endX, m = 5, g = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ I.createElement(ot, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ I.createElement(Ws, Dm({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(d, p) - m,
        y: a + s / 2
      }, g), this.getTextOfTick(i)), /* @__PURE__ */ I.createElement(Ws, Dm({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(d, p) + l + m,
        y: a + s / 2
      }, g), this.getTextOfTick(o)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.data, o = r.className, a = r.children, s = r.x, l = r.y, c = r.width, f = r.height, d = r.alwaysShowText, p = this.state, m = p.startX, g = p.endX, v = p.isTextActive, y = p.isSlideMoving, x = p.isTravellerMoving, w = p.isTravellerFocused;
      if (!i || !i.length || !be(s) || !be(l) || !be(c) || !be(f) || c <= 0 || f <= 0)
        return null;
      var S = Ye("recharts-brush", o), A = I.Children.count(a) === 1, _ = ROe("userSelect", "none");
      return /* @__PURE__ */ I.createElement(ot, {
        className: S,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: _
      }, this.renderBackground(), A && this.renderPanorama(), this.renderSlide(m, g), this.renderTravellerLayer(m, "startX"), this.renderTravellerLayer(g, "endX"), (v || y || x || w || d) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var i = r.x, o = r.y, a = r.width, s = r.height, l = r.stroke, c = Math.floor(o + s / 2) - 1;
      return /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement("rect", {
        x: i,
        y: o,
        width: a,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ I.createElement("line", {
        x1: i + 1,
        y1: c,
        x2: i + a - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ I.createElement("line", {
        x1: i + 1,
        y1: c + 2,
        x2: i + a - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, i) {
      var o;
      return /* @__PURE__ */ I.isValidElement(r) ? o = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? o = r(i) : o = t.renderDefaultTraveller(i), o;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var o = r.data, a = r.width, s = r.x, l = r.travellerWidth, c = r.updateId, f = r.startIndex, d = r.endIndex;
      if (o !== i.prevData || c !== i.prevUpdateId)
        return t0({
          prevData: o,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: a
        }, o && o.length ? UOe({
          data: o,
          width: a,
          x: s,
          travellerWidth: l,
          startIndex: f,
          endIndex: d
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (a !== i.prevWidth || s !== i.prevX || l !== i.prevTravellerWidth)) {
        i.scale.range([s, s + a - l]);
        var p = i.scale.domain().map(function(m) {
          return i.scale(m);
        });
        return {
          prevData: o,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: a,
          startX: i.scale(r.startIndex),
          endX: i.scale(r.endIndex),
          scaleValues: p
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, i) {
      for (var o = r.length, a = 0, s = o - 1; s - a > 1; ) {
        var l = Math.floor((a + s) / 2);
        r[l] > i ? s = l : a = l;
      }
      return i >= r[s] ? s : a;
    }
  }]);
}(hi);
Ir(yc, "displayName", "Brush");
Ir(yc, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var KOe = G_;
function HOe(e, t) {
  var n;
  return KOe(e, function(r, i, o) {
    return n = t(r, i, o), !n;
  }), !!n;
}
var GOe = HOe, YOe = JL, qOe = oo, XOe = GOe, ZOe = Ar, JOe = ty;
function QOe(e, t, n) {
  var r = ZOe(e) ? YOe : XOe;
  return n && JOe(e, t, n) && (t = void 0), r(e, qOe(t));
}
var eAe = QOe;
const tAe = /* @__PURE__ */ Et(eAe);
var Ji = function(t, n) {
  var r = t.alwaysShow, i = t.ifOverflow;
  return r && (i = "extendDomain"), i === n;
}, n$ = xB;
function nAe(e, t, n) {
  t == "__proto__" && n$ ? n$(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var rAe = nAe, iAe = rAe, oAe = vB, aAe = oo;
function sAe(e, t) {
  var n = {};
  return t = aAe(t), oAe(e, function(r, i, o) {
    iAe(n, i, t(r, i, o));
  }), n;
}
var lAe = sAe;
const cAe = /* @__PURE__ */ Et(lAe);
function uAe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (!t(e[n], n, e))
      return !1;
  return !0;
}
var fAe = uAe, dAe = G_;
function hAe(e, t) {
  var n = !0;
  return dAe(e, function(r, i, o) {
    return n = !!t(r, i, o), n;
  }), n;
}
var pAe = hAe, mAe = fAe, gAe = pAe, yAe = oo, vAe = Ar, bAe = ty;
function xAe(e, t, n) {
  var r = vAe(e) ? mAe : gAe;
  return n && bAe(e, t, n) && (t = void 0), r(e, yAe(t));
}
var wAe = xAe;
const dW = /* @__PURE__ */ Et(wAe);
var _Ae = ["x", "y"];
function vc(e) {
  "@babel/helpers - typeof";
  return vc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vc(e);
}
function _w() {
  return _w = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _w.apply(this, arguments);
}
function r$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Du(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r$(Object(n), !0).forEach(function(r) {
      SAe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function SAe(e, t, n) {
  return t = OAe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OAe(e) {
  var t = AAe(e, "string");
  return vc(t) == "symbol" ? t : t + "";
}
function AAe(e, t) {
  if (vc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (vc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function PAe(e, t) {
  if (e == null) return {};
  var n = TAe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function TAe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function CAe(e, t) {
  var n = e.x, r = e.y, i = PAe(e, _Ae), o = "".concat(n), a = parseInt(o, 10), s = "".concat(r), l = parseInt(s, 10), c = "".concat(t.height || i.height), f = parseInt(c, 10), d = "".concat(t.width || i.width), p = parseInt(d, 10);
  return Du(Du(Du(Du(Du({}, t), i), a ? {
    x: a
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: f,
    width: p,
    name: t.name,
    radius: t.radius
  });
}
function i$(e) {
  return /* @__PURE__ */ I.createElement(oW, _w({
    shapeType: "rectangle",
    propTransformer: CAe,
    activeClassName: "recharts-active-bar"
  }, e));
}
var EAe = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof t == "number") return t;
    var o = typeof r == "number";
    return o ? t(r, i) : (o || (process.env.NODE_ENV !== "production" ? _r(!1, "minPointSize callback function received a value with type of ".concat(vc(r), ". Currently only numbers are supported.")) : _r()), n);
  };
}, kAe = ["value", "background"], hW;
function bc(e) {
  "@babel/helpers - typeof";
  return bc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bc(e);
}
function MAe(e, t) {
  if (e == null) return {};
  var n = NAe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function NAe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Rm() {
  return Rm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rm.apply(this, arguments);
}
function o$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o$(Object(n), !0).forEach(function(r) {
      Aa(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $Ae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function a$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mW(r.key), r);
  }
}
function DAe(e, t, n) {
  return t && a$(e.prototype, t), n && a$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function IAe(e, t, n) {
  return t = jm(t), RAe(e, pW() ? Reflect.construct(t, n || [], jm(e).constructor) : t.apply(e, n));
}
function RAe(e, t) {
  if (t && (bc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jAe(e);
}
function jAe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pW = function() {
    return !!e;
  })();
}
function jm(e) {
  return jm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, jm(e);
}
function LAe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sw(e, t);
}
function Sw(e, t) {
  return Sw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Sw(e, t);
}
function Aa(e, t, n) {
  return t = mW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mW(e) {
  var t = BAe(e, "string");
  return bc(t) == "symbol" ? t : t + "";
}
function BAe(e, t) {
  if (bc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (bc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nl = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    $Ae(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = IAe(this, t, [].concat(i)), Aa(n, "state", {
      isAnimationFinished: !1
    }), Aa(n, "id", Qs("recharts-bar-")), Aa(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), a && a();
    }), Aa(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), a && a();
    }), n;
  }
  return LAe(t, e), DAe(t, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.shape, s = o.dataKey, l = o.activeIndex, c = o.activeBar, f = Ee(this.props, !1);
      return r && r.map(function(d, p) {
        var m = p === l, g = m ? c : a, v = fn(fn(fn({}, f), d), {}, {
          isActive: m,
          option: g,
          index: p,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ I.createElement(ot, Rm({
          className: "recharts-bar-rectangle"
        }, Fs(i.props, d, p), {
          key: "rectangle-".concat(d == null ? void 0 : d.x, "-").concat(d == null ? void 0 : d.y, "-").concat(d == null ? void 0 : d.value)
        }), /* @__PURE__ */ I.createElement(i$, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.layout, s = i.isAnimationActive, l = i.animationBegin, c = i.animationDuration, f = i.animationEasing, d = i.animationId, p = this.state.prevData;
      return /* @__PURE__ */ I.createElement(Ni, {
        begin: l,
        duration: c,
        isActive: s,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(m) {
        var g = m.t, v = o.map(function(y, x) {
          var w = p && p[x];
          if (w) {
            var S = wn(w.x, y.x), A = wn(w.y, y.y), _ = wn(w.width, y.width), O = wn(w.height, y.height);
            return fn(fn({}, y), {}, {
              x: S(g),
              y: A(g),
              width: _(g),
              height: O(g)
            });
          }
          if (a === "horizontal") {
            var T = wn(0, y.height), C = T(g);
            return fn(fn({}, y), {}, {
              y: y.y + y.height - C,
              height: C
            });
          }
          var k = wn(0, y.width), D = k(g);
          return fn(fn({}, y), {}, {
            width: D
          });
        });
        return /* @__PURE__ */ I.createElement(ot, null, r.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, i = r.data, o = r.isAnimationActive, a = this.state.prevData;
      return o && i && i.length && (!a || !zs(a, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.dataKey, s = i.activeIndex, l = Ee(this.props.background, !1);
      return o.map(function(c, f) {
        c.value;
        var d = c.background, p = MAe(c, kAe);
        if (!d)
          return null;
        var m = fn(fn(fn(fn(fn({}, p), {}, {
          fill: "#eee"
        }, d), l), Fs(r.props, c, f)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: a,
          index: f,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ I.createElement(i$, Rm({
          key: "background-bar-".concat(f),
          option: r.props.background,
          isActive: f === s
        }, m));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.data, s = o.xAxis, l = o.yAxis, c = o.layout, f = o.children, d = zr(f, Md);
      if (!d)
        return null;
      var p = c === "vertical" ? a[0].height / 2 : a[0].width / 2, m = function(y, x) {
        var w = Array.isArray(y.value) ? y.value[1] : y.value;
        return {
          x: y.x,
          y: y.y,
          value: w,
          errorVal: ln(y, x)
        };
      }, g = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ I.createElement(ot, g, d.map(function(v) {
        return /* @__PURE__ */ I.cloneElement(v, {
          key: "error-bar-".concat(i, "-").concat(v.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: c,
          offset: p,
          dataPointFormatter: m
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, o = r.data, a = r.className, s = r.xAxis, l = r.yAxis, c = r.left, f = r.top, d = r.width, p = r.height, m = r.isAnimationActive, g = r.background, v = r.id;
      if (i || !o || !o.length)
        return null;
      var y = this.state.isAnimationFinished, x = Ye("recharts-bar", a), w = s && s.allowDataOverflow, S = l && l.allowDataOverflow, A = w || S, _ = Ue(v) ? this.id : v;
      return /* @__PURE__ */ I.createElement(ot, {
        className: x
      }, w || S ? /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: w ? c : c - d / 2,
        y: S ? f : f - p / 2,
        width: w ? d : d * 2,
        height: S ? p : p * 2
      }))) : null, /* @__PURE__ */ I.createElement(ot, {
        className: "recharts-bar-rectangles",
        clipPath: A ? "url(#clipPath-".concat(_, ")") : null
      }, g ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(A, _), (!m || y) && Zi.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: i.curData
      } : r.data !== i.curData ? {
        curData: r.data
      } : null;
    }
  }]);
}(hi);
hW = nl;
Aa(nl, "displayName", "Bar");
Aa(nl, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Mi.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Aa(nl, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.barPosition, i = e.bandSize, o = e.xAxis, a = e.yAxis, s = e.xAxisTicks, l = e.yAxisTicks, c = e.stackedData, f = e.dataStartIndex, d = e.displayedData, p = e.offset, m = Oxe(r, n);
  if (!m)
    return null;
  var g = t.layout, v = n.type.defaultProps, y = v !== void 0 ? fn(fn({}, v), n.props) : n.props, x = y.dataKey, w = y.children, S = y.minPointSize, A = g === "horizontal" ? a : o, _ = c ? A.scale.domain() : null, O = Mxe({
    numericAxis: A
  }), T = zr(w, X_), C = d.map(function(k, D) {
    var N, $, B, L, F, W;
    c ? N = Axe(c[f + D], _) : (N = ln(k, x), Array.isArray(N) || (N = [O, N]));
    var z = EAe(S, hW.defaultProps.minPointSize)(N[1], D);
    if (g === "horizontal") {
      var G, V = [a.scale(N[0]), a.scale(N[1])], U = V[0], Y = V[1];
      $ = FM({
        axis: o,
        ticks: s,
        bandSize: i,
        offset: m.offset,
        entry: k,
        index: D
      }), B = (G = Y ?? U) !== null && G !== void 0 ? G : void 0, L = m.size;
      var te = U - Y;
      if (F = Number.isNaN(te) ? 0 : te, W = {
        x: $,
        y: a.y,
        width: L,
        height: a.height
      }, Math.abs(z) > 0 && Math.abs(F) < Math.abs(z)) {
        var ne = ur(F || z) * (Math.abs(z) - Math.abs(F));
        B -= ne, F += ne;
      }
    } else {
      var re = [o.scale(N[0]), o.scale(N[1])], ue = re[0], ae = re[1];
      if ($ = ue, B = FM({
        axis: a,
        ticks: l,
        bandSize: i,
        offset: m.offset,
        entry: k,
        index: D
      }), L = ae - ue, F = m.size, W = {
        x: o.x,
        y: B,
        width: o.width,
        height: F
      }, Math.abs(z) > 0 && Math.abs(L) < Math.abs(z)) {
        var le = ur(L || z) * (Math.abs(z) - Math.abs(L));
        L += le;
      }
    }
    return fn(fn(fn({}, k), {}, {
      x: $,
      y: B,
      width: L,
      height: F,
      value: c ? N : N[1],
      payload: k,
      background: W
    }, T && T[D] && T[D].props), {}, {
      tooltipPayload: [jF(n, k)],
      tooltipPosition: {
        x: $ + L / 2,
        y: B + F / 2
      }
    });
  });
  return fn({
    data: C,
    layout: g
  }, p);
});
function td(e) {
  "@babel/helpers - typeof";
  return td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, td(e);
}
function FAe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function s$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, gW(r.key), r);
  }
}
function WAe(e, t, n) {
  return t && s$(e.prototype, t), n && s$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function l$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Si(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l$(Object(n), !0).forEach(function(r) {
      vy(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function vy(e, t, n) {
  return t = gW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gW(e) {
  var t = zAe(e, "string");
  return td(t) == "symbol" ? t : t + "";
}
function zAe(e, t) {
  if (td(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (td(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var OS = function(t, n, r, i, o) {
  var a = t.width, s = t.height, l = t.layout, c = t.children, f = Object.keys(n), d = {
    left: r.left,
    leftMirror: r.left,
    right: a - r.right,
    rightMirror: a - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: s - r.bottom,
    bottomMirror: s - r.bottom
  }, p = !!Rr(c, nl);
  return f.reduce(function(m, g) {
    var v = n[g], y = v.orientation, x = v.domain, w = v.padding, S = w === void 0 ? {} : w, A = v.mirror, _ = v.reversed, O = "".concat(y).concat(A ? "Mirror" : ""), T, C, k, D, N;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var $ = x[1] - x[0], B = 1 / 0, L = v.categoricalDomain.sort();
      if (L.forEach(function(re, ue) {
        ue > 0 && (B = Math.min((re || 0) - (L[ue - 1] || 0), B));
      }), Number.isFinite(B)) {
        var F = B / $, W = v.layout === "vertical" ? r.height : r.width;
        if (v.padding === "gap" && (T = F * W / 2), v.padding === "no-gap") {
          var z = fr(t.barCategoryGap, F * W), G = F * W / 2;
          T = G - z - (G - z) / W * z;
        }
      }
    }
    i === "xAxis" ? C = [r.left + (S.left || 0) + (T || 0), r.left + r.width - (S.right || 0) - (T || 0)] : i === "yAxis" ? C = l === "horizontal" ? [r.top + r.height - (S.bottom || 0), r.top + (S.top || 0)] : [r.top + (S.top || 0) + (T || 0), r.top + r.height - (S.bottom || 0) - (T || 0)] : C = v.range, _ && (C = [C[1], C[0]]);
    var V = $F(v, o, p), U = V.scale, Y = V.realScaleType;
    U.domain(x).range(C), DF(U);
    var te = IF(U, Si(Si({}, v), {}, {
      realScaleType: Y
    }));
    i === "xAxis" ? (N = y === "top" && !A || y === "bottom" && A, k = r.left, D = d[O] - N * v.height) : i === "yAxis" && (N = y === "left" && !A || y === "right" && A, k = d[O] - N * v.width, D = r.top);
    var ne = Si(Si(Si({}, v), te), {}, {
      realScaleType: Y,
      x: k,
      y: D,
      scale: U,
      width: i === "xAxis" ? r.width : v.width,
      height: i === "yAxis" ? r.height : v.height
    });
    return ne.bandSize = xm(ne, te), !v.hide && i === "xAxis" ? d[O] += (N ? -1 : 1) * ne.height : v.hide || (d[O] += (N ? -1 : 1) * ne.width), Si(Si({}, m), {}, vy({}, g, ne));
  }, {});
}, yW = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return {
    x: Math.min(r, o),
    y: Math.min(i, a),
    width: Math.abs(o - r),
    height: Math.abs(a - i)
  };
}, VAe = function(t) {
  var n = t.x1, r = t.y1, i = t.x2, o = t.y2;
  return yW({
    x: n,
    y: r
  }, {
    x: i,
    y: o
  });
}, vW = /* @__PURE__ */ function() {
  function e(t) {
    FAe(this, e), this.scale = t;
  }
  return WAe(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.bandAware, o = r.position;
      if (n !== void 0) {
        if (o)
          switch (o) {
            case "start":
              return this.scale(n);
            case "middle": {
              var a = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(n) + a;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(n) + s;
            }
            default:
              return this.scale(n);
          }
        if (i) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(n) + l;
        }
        return this.scale(n);
      }
    }
  }, {
    key: "isInRange",
    value: function(n) {
      var r = this.range(), i = r[0], o = r[r.length - 1];
      return i <= o ? n >= i && n <= o : n >= o && n <= i;
    }
  }], [{
    key: "create",
    value: function(n) {
      return new e(n);
    }
  }]);
}();
vy(vW, "EPS", 1e-4);
var AS = function(t) {
  var n = Object.keys(t).reduce(function(r, i) {
    return Si(Si({}, r), {}, vy({}, i, vW.create(t[i])));
  }, {});
  return Si(Si({}, n), {}, {
    apply: function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.bandAware, s = o.position;
      return cAe(i, function(l, c) {
        return n[c].apply(l, {
          bandAware: a,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return dW(i, function(o, a) {
        return n[a].isInRange(o);
      });
    }
  });
};
function UAe(e) {
  return (e % 180 + 180) % 180;
}
var KAe = function(t) {
  var n = t.width, r = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = UAe(i), a = o * Math.PI / 180, s = Math.atan(r / n), l = a > s && a < Math.PI - s ? r / Math.sin(a) : n / Math.cos(a);
  return Math.abs(l);
}, HAe = oo, GAe = Pd, YAe = Qg;
function qAe(e) {
  return function(t, n, r) {
    var i = Object(t);
    if (!GAe(t)) {
      var o = HAe(n);
      t = YAe(t), n = function(s) {
        return o(i[s], s, i);
      };
    }
    var a = e(t, n, r);
    return a > -1 ? i[o ? t[a] : a] : void 0;
  };
}
var XAe = qAe, ZAe = lW;
function JAe(e) {
  var t = ZAe(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var QAe = JAe, ePe = dB, tPe = oo, nPe = QAe, rPe = Math.max;
function iPe(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : nPe(n);
  return i < 0 && (i = rPe(r + i, 0)), ePe(e, tPe(t), i);
}
var oPe = iPe, aPe = XAe, sPe = oPe, lPe = aPe(sPe), cPe = lPe;
const uPe = /* @__PURE__ */ Et(cPe);
var fPe = foe(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function Lm(e) {
  "@babel/helpers - typeof";
  return Lm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lm(e);
}
var PS = /* @__PURE__ */ ht(void 0), TS = /* @__PURE__ */ ht(void 0), bW = /* @__PURE__ */ ht(void 0), xW = /* @__PURE__ */ ht({}), wW = /* @__PURE__ */ ht(void 0), _W = /* @__PURE__ */ ht(0), SW = /* @__PURE__ */ ht(0), c$ = function(t) {
  var n = t.state, r = n.xAxisMap, i = n.yAxisMap, o = n.offset, a = t.clipPathId, s = t.children, l = t.width, c = t.height, f = fPe(o);
  return /* @__PURE__ */ I.createElement(PS.Provider, {
    value: r
  }, /* @__PURE__ */ I.createElement(TS.Provider, {
    value: i
  }, /* @__PURE__ */ I.createElement(xW.Provider, {
    value: o
  }, /* @__PURE__ */ I.createElement(bW.Provider, {
    value: f
  }, /* @__PURE__ */ I.createElement(wW.Provider, {
    value: a
  }, /* @__PURE__ */ I.createElement(_W.Provider, {
    value: c
  }, /* @__PURE__ */ I.createElement(SW.Provider, {
    value: l
  }, s)))))));
}, dPe = function() {
  return Ve(wW);
};
function OW(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var AW = function(t) {
  var n = Ve(PS);
  n == null && (process.env.NODE_ENV !== "production" ? _r(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : _r());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? _r(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Lm(t), "]. ").concat(OW(n))) : _r()), r;
}, hPe = function() {
  var t = Ve(PS);
  return wa(t);
}, pPe = function() {
  var t = Ve(TS), n = uPe(t, function(r) {
    return dW(r.domain, Number.isFinite);
  });
  return n || wa(t);
}, PW = function(t) {
  var n = Ve(TS);
  n == null && (process.env.NODE_ENV !== "production" ? _r(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : _r());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? _r(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Lm(t), "]. ").concat(OW(n))) : _r()), r;
}, mPe = function() {
  var t = Ve(bW);
  return t;
}, gPe = function() {
  return Ve(xW);
}, CS = function() {
  return Ve(SW);
}, ES = function() {
  return Ve(_W);
};
function xc(e) {
  "@babel/helpers - typeof";
  return xc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xc(e);
}
function yPe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vPe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, CW(r.key), r);
  }
}
function bPe(e, t, n) {
  return t && vPe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xPe(e, t, n) {
  return t = Bm(t), wPe(e, TW() ? Reflect.construct(t, n || [], Bm(e).constructor) : t.apply(e, n));
}
function wPe(e, t) {
  if (t && (xc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _Pe(e);
}
function _Pe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function TW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (TW = function() {
    return !!e;
  })();
}
function Bm(e) {
  return Bm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bm(e);
}
function SPe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ow(e, t);
}
function Ow(e, t) {
  return Ow = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ow(e, t);
}
function u$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function f$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? u$(Object(n), !0).forEach(function(r) {
      kS(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kS(e, t, n) {
  return t = CW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function CW(e) {
  var t = OPe(e, "string");
  return xc(t) == "symbol" ? t : t + "";
}
function OPe(e, t) {
  if (xc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (xc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function APe(e, t) {
  return EPe(e) || CPe(e, t) || TPe(e, t) || PPe();
}
function PPe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TPe(e, t) {
  if (e) {
    if (typeof e == "string") return d$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return d$(e, t);
  }
}
function d$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function CPe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function EPe(e) {
  if (Array.isArray(e)) return e;
}
function Aw() {
  return Aw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Aw.apply(this, arguments);
}
var kPe = function(t, n) {
  var r;
  return /* @__PURE__ */ I.isValidElement(t) ? r = /* @__PURE__ */ I.cloneElement(t, n) : ze(t) ? r = t(n) : r = /* @__PURE__ */ I.createElement("line", Aw({}, n, {
    className: "recharts-reference-line-line"
  })), r;
}, MPe = function(t, n, r, i, o, a, s, l, c) {
  var f = o.x, d = o.y, p = o.width, m = o.height;
  if (r) {
    var g = c.y, v = t.y.apply(g, {
      position: a
    });
    if (Ji(c, "discard") && !t.y.isInRange(v))
      return null;
    var y = [{
      x: f + p,
      y: v
    }, {
      x: f,
      y: v
    }];
    return l === "left" ? y.reverse() : y;
  }
  if (n) {
    var x = c.x, w = t.x.apply(x, {
      position: a
    });
    if (Ji(c, "discard") && !t.x.isInRange(w))
      return null;
    var S = [{
      x: w,
      y: d + m
    }, {
      x: w,
      y: d
    }];
    return s === "top" ? S.reverse() : S;
  }
  if (i) {
    var A = c.segment, _ = A.map(function(O) {
      return t.apply(O, {
        position: a
      });
    });
    return Ji(c, "discard") && tAe(_, function(O) {
      return !t.isInRange(O);
    }) ? null : _;
  }
  return null;
};
function NPe(e) {
  var t = e.x, n = e.y, r = e.segment, i = e.xAxisId, o = e.yAxisId, a = e.shape, s = e.className, l = e.alwaysShow, c = dPe(), f = AW(i), d = PW(o), p = mPe();
  if (!c || !p)
    return null;
  ki(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var m = AS({
    x: f.scale,
    y: d.scale
  }), g = Sn(t), v = Sn(n), y = r && r.length === 2, x = MPe(m, g, v, y, p, e.position, f.orientation, d.orientation, e);
  if (!x)
    return null;
  var w = APe(x, 2), S = w[0], A = S.x, _ = S.y, O = w[1], T = O.x, C = O.y, k = Ji(e, "hidden") ? "url(#".concat(c, ")") : void 0, D = f$(f$({
    clipPath: k
  }, Ee(e, !0)), {}, {
    x1: A,
    y1: _,
    x2: T,
    y2: C
  });
  return /* @__PURE__ */ I.createElement(ot, {
    className: Ye("recharts-reference-line", s)
  }, kPe(a, D), _n.renderCallByParent(e, VAe({
    x1: A,
    y1: _,
    x2: T,
    y2: C
  })));
}
var MS = /* @__PURE__ */ function(e) {
  function t() {
    return yPe(this, t), xPe(this, t, arguments);
  }
  return SPe(t, e), bPe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ I.createElement(NPe, this.props);
    }
  }]);
}(I.Component);
kS(MS, "displayName", "ReferenceLine");
kS(MS, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Pw() {
  return Pw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pw.apply(this, arguments);
}
function wc(e) {
  "@babel/helpers - typeof";
  return wc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wc(e);
}
function h$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function p$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? h$(Object(n), !0).forEach(function(r) {
      by(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $Pe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function DPe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, kW(r.key), r);
  }
}
function IPe(e, t, n) {
  return t && DPe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function RPe(e, t, n) {
  return t = Fm(t), jPe(e, EW() ? Reflect.construct(t, n || [], Fm(e).constructor) : t.apply(e, n));
}
function jPe(e, t) {
  if (t && (wc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return LPe(e);
}
function LPe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function EW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (EW = function() {
    return !!e;
  })();
}
function Fm(e) {
  return Fm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Fm(e);
}
function BPe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tw(e, t);
}
function Tw(e, t) {
  return Tw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Tw(e, t);
}
function by(e, t, n) {
  return t = kW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function kW(e) {
  var t = FPe(e, "string");
  return wc(t) == "symbol" ? t : t + "";
}
function FPe(e, t) {
  if (wc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (wc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var WPe = function(t) {
  var n = t.x, r = t.y, i = t.xAxis, o = t.yAxis, a = AS({
    x: i.scale,
    y: o.scale
  }), s = a.apply({
    x: n,
    y: r
  }, {
    bandAware: !0
  });
  return Ji(t, "discard") && !a.isInRange(s) ? null : s;
}, xy = /* @__PURE__ */ function(e) {
  function t() {
    return $Pe(this, t), RPe(this, t, arguments);
  }
  return BPe(t, e), IPe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.r, s = r.alwaysShow, l = r.clipPathId, c = Sn(i), f = Sn(o);
      if (ki(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !f)
        return null;
      var d = WPe(this.props);
      if (!d)
        return null;
      var p = d.x, m = d.y, g = this.props, v = g.shape, y = g.className, x = Ji(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, w = p$(p$({
        clipPath: x
      }, Ee(this.props, !0)), {}, {
        cx: p,
        cy: m
      });
      return /* @__PURE__ */ I.createElement(ot, {
        className: Ye("recharts-reference-dot", y)
      }, t.renderDot(v, w), _n.renderCallByParent(this.props, {
        x: p - a,
        y: m - a,
        width: 2 * a,
        height: 2 * a
      }));
    }
  }]);
}(I.Component);
by(xy, "displayName", "ReferenceDot");
by(xy, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
by(xy, "renderDot", function(e, t) {
  var n;
  return /* @__PURE__ */ I.isValidElement(e) ? n = /* @__PURE__ */ I.cloneElement(e, t) : ze(e) ? n = e(t) : n = /* @__PURE__ */ I.createElement(Nd, Pw({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), n;
});
function Cw() {
  return Cw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cw.apply(this, arguments);
}
function _c(e) {
  "@babel/helpers - typeof";
  return _c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _c(e);
}
function m$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m$(Object(n), !0).forEach(function(r) {
      wy(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zPe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VPe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, NW(r.key), r);
  }
}
function UPe(e, t, n) {
  return t && VPe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function KPe(e, t, n) {
  return t = Wm(t), HPe(e, MW() ? Reflect.construct(t, n || [], Wm(e).constructor) : t.apply(e, n));
}
function HPe(e, t) {
  if (t && (_c(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GPe(e);
}
function GPe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function MW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (MW = function() {
    return !!e;
  })();
}
function Wm(e) {
  return Wm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Wm(e);
}
function YPe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ew(e, t);
}
function Ew(e, t) {
  return Ew = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ew(e, t);
}
function wy(e, t, n) {
  return t = NW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function NW(e) {
  var t = qPe(e, "string");
  return _c(t) == "symbol" ? t : t + "";
}
function qPe(e, t) {
  if (_c(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (_c(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var XPe = function(t, n, r, i, o) {
  var a = o.x1, s = o.x2, l = o.y1, c = o.y2, f = o.xAxis, d = o.yAxis;
  if (!f || !d) return null;
  var p = AS({
    x: f.scale,
    y: d.scale
  }), m = {
    x: t ? p.x.apply(a, {
      position: "start"
    }) : p.x.rangeMin,
    y: r ? p.y.apply(l, {
      position: "start"
    }) : p.y.rangeMin
  }, g = {
    x: n ? p.x.apply(s, {
      position: "end"
    }) : p.x.rangeMax,
    y: i ? p.y.apply(c, {
      position: "end"
    }) : p.y.rangeMax
  };
  return Ji(o, "discard") && (!p.isInRange(m) || !p.isInRange(g)) ? null : yW(m, g);
}, _y = /* @__PURE__ */ function(e) {
  function t() {
    return zPe(this, t), KPe(this, t, arguments);
  }
  return YPe(t, e), UPe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x1, o = r.x2, a = r.y1, s = r.y2, l = r.className, c = r.alwaysShow, f = r.clipPathId;
      ki(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var d = Sn(i), p = Sn(o), m = Sn(a), g = Sn(s), v = this.props.shape;
      if (!d && !p && !m && !g && !v)
        return null;
      var y = XPe(d, p, m, g, this.props);
      if (!y && !v)
        return null;
      var x = Ji(this.props, "hidden") ? "url(#".concat(f, ")") : void 0;
      return /* @__PURE__ */ I.createElement(ot, {
        className: Ye("recharts-reference-area", l)
      }, t.renderRect(v, g$(g$({
        clipPath: x
      }, Ee(this.props, !0)), y)), _n.renderCallByParent(this.props, y));
    }
  }]);
}(I.Component);
wy(_y, "displayName", "ReferenceArea");
wy(_y, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
wy(_y, "renderRect", function(e, t) {
  var n;
  return /* @__PURE__ */ I.isValidElement(e) ? n = /* @__PURE__ */ I.cloneElement(e, t) : ze(e) ? n = e(t) : n = /* @__PURE__ */ I.createElement(SS, Cw({}, t, {
    className: "recharts-reference-area-rect"
  })), n;
});
function $W(e, t, n) {
  if (t < 1)
    return [];
  if (t === 1 && n === void 0)
    return e;
  for (var r = [], i = 0; i < e.length; i += t)
    r.push(e[i]);
  return r;
}
function ZPe(e, t, n) {
  var r = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return KAe(r, n);
}
function JPe(e, t, n) {
  var r = n === "width", i = e.x, o = e.y, a = e.width, s = e.height;
  return t === 1 ? {
    start: r ? i : o,
    end: r ? i + a : o + s
  } : {
    start: r ? i + a : o + s,
    end: r ? i : o
  };
}
function zm(e, t, n, r, i) {
  if (e * t < e * r || e * t > e * i)
    return !1;
  var o = n();
  return e * (t - e * o / 2 - r) >= 0 && e * (t + e * o / 2 - i) <= 0;
}
function QPe(e, t) {
  return $W(e, t + 1);
}
function eTe(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = t.start, s = t.end, l = 0, c = 1, f = a, d = function() {
    var g = r == null ? void 0 : r[l];
    if (g === void 0)
      return {
        v: $W(r, c)
      };
    var v = l, y, x = function() {
      return y === void 0 && (y = n(g, v)), y;
    }, w = g.coordinate, S = l === 0 || zm(e, w, x, f, s);
    S || (l = 0, f = a, c += 1), S && (f = w + e * (x() / 2 + i), l += c);
  }, p; c <= o.length; )
    if (p = d(), p) return p.v;
  return [];
}
function nd(e) {
  "@babel/helpers - typeof";
  return nd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nd(e);
}
function y$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y$(Object(n), !0).forEach(function(r) {
      tTe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function tTe(e, t, n) {
  return t = nTe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nTe(e) {
  var t = rTe(e, "string");
  return nd(t) == "symbol" ? t : t + "";
}
function rTe(e, t) {
  if (nd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (nd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function iTe(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = o.length, s = t.start, l = t.end, c = function(p) {
    var m = o[p], g, v = function() {
      return g === void 0 && (g = n(m, p)), g;
    };
    if (p === a - 1) {
      var y = e * (m.coordinate + e * v() / 2 - l);
      o[p] = m = Jn(Jn({}, m), {}, {
        tickCoord: y > 0 ? m.coordinate - y * e : m.coordinate
      });
    } else
      o[p] = m = Jn(Jn({}, m), {}, {
        tickCoord: m.coordinate
      });
    var x = zm(e, m.tickCoord, v, s, l);
    x && (l = m.tickCoord - e * (v() / 2 + i), o[p] = Jn(Jn({}, m), {}, {
      isShow: !0
    }));
  }, f = a - 1; f >= 0; f--)
    c(f);
  return o;
}
function oTe(e, t, n, r, i, o) {
  var a = (r || []).slice(), s = a.length, l = t.start, c = t.end;
  if (o) {
    var f = r[s - 1], d = n(f, s - 1), p = e * (f.coordinate + e * d / 2 - c);
    a[s - 1] = f = Jn(Jn({}, f), {}, {
      tickCoord: p > 0 ? f.coordinate - p * e : f.coordinate
    });
    var m = zm(e, f.tickCoord, function() {
      return d;
    }, l, c);
    m && (c = f.tickCoord - e * (d / 2 + i), a[s - 1] = Jn(Jn({}, f), {}, {
      isShow: !0
    }));
  }
  for (var g = o ? s - 1 : s, v = function(w) {
    var S = a[w], A, _ = function() {
      return A === void 0 && (A = n(S, w)), A;
    };
    if (w === 0) {
      var O = e * (S.coordinate - e * _() / 2 - l);
      a[w] = S = Jn(Jn({}, S), {}, {
        tickCoord: O < 0 ? S.coordinate - O * e : S.coordinate
      });
    } else
      a[w] = S = Jn(Jn({}, S), {}, {
        tickCoord: S.coordinate
      });
    var T = zm(e, S.tickCoord, _, l, c);
    T && (l = S.tickCoord + e * (_() / 2 + i), a[w] = Jn(Jn({}, S), {}, {
      isShow: !0
    }));
  }, y = 0; y < g; y++)
    v(y);
  return a;
}
function NS(e, t, n) {
  var r = e.tick, i = e.ticks, o = e.viewBox, a = e.minTickGap, s = e.orientation, l = e.interval, c = e.tickFormatter, f = e.unit, d = e.angle;
  if (!i || !i.length || !r)
    return [];
  if (be(l) || Mi.isSsr)
    return QPe(i, typeof l == "number" && be(l) ? l : 0);
  var p = [], m = s === "top" || s === "bottom" ? "width" : "height", g = f && m === "width" ? Qu(f, {
    fontSize: t,
    letterSpacing: n
  }) : {
    width: 0,
    height: 0
  }, v = function(S, A) {
    var _ = ze(c) ? c(S.value, A) : S.value;
    return m === "width" ? ZPe(Qu(_, {
      fontSize: t,
      letterSpacing: n
    }), g, d) : Qu(_, {
      fontSize: t,
      letterSpacing: n
    })[m];
  }, y = i.length >= 2 ? ur(i[1].coordinate - i[0].coordinate) : 1, x = JPe(o, y, m);
  return l === "equidistantPreserveStart" ? eTe(y, x, v, i, a) : (l === "preserveStart" || l === "preserveStartEnd" ? p = oTe(y, x, v, i, a, l === "preserveStartEnd") : p = iTe(y, x, v, i, a), p.filter(function(w) {
    return w.isShow;
  }));
}
var aTe = ["viewBox"], sTe = ["viewBox"], lTe = ["ticks"];
function Sc(e) {
  "@babel/helpers - typeof";
  return Sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sc(e);
}
function Ll() {
  return Ll = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ll.apply(this, arguments);
}
function v$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? v$(Object(n), !0).forEach(function(r) {
      $S(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function n0(e, t) {
  if (e == null) return {};
  var n = cTe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function cTe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function uTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function b$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, IW(r.key), r);
  }
}
function fTe(e, t, n) {
  return t && b$(e.prototype, t), n && b$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function dTe(e, t, n) {
  return t = Vm(t), hTe(e, DW() ? Reflect.construct(t, n || [], Vm(e).constructor) : t.apply(e, n));
}
function hTe(e, t) {
  if (t && (Sc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pTe(e);
}
function pTe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (DW = function() {
    return !!e;
  })();
}
function Vm(e) {
  return Vm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Vm(e);
}
function mTe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && kw(e, t);
}
function kw(e, t) {
  return kw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, kw(e, t);
}
function $S(e, t, n) {
  return t = IW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function IW(e) {
  var t = gTe(e, "string");
  return Sc(t) == "symbol" ? t : t + "";
}
function gTe(e, t) {
  if (Sc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Sc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Qc = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return uTe(this, t), r = dTe(this, t, [n]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return mTe(t, e), fTe(t, [{
    key: "shouldComponentUpdate",
    value: function(r, i) {
      var o = r.viewBox, a = n0(r, aTe), s = this.props, l = s.viewBox, c = n0(s, sTe);
      return !Kl(o, l) || !Kl(a, c) || !Kl(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var i = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var i = this.props, o = i.x, a = i.y, s = i.width, l = i.height, c = i.orientation, f = i.tickSize, d = i.mirror, p = i.tickMargin, m, g, v, y, x, w, S = d ? -1 : 1, A = r.tickSize || f, _ = be(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (c) {
        case "top":
          m = g = r.coordinate, y = a + +!d * l, v = y - S * A, w = v - S * p, x = _;
          break;
        case "left":
          v = y = r.coordinate, g = o + +!d * s, m = g - S * A, x = m - S * p, w = _;
          break;
        case "right":
          v = y = r.coordinate, g = o + +d * s, m = g + S * A, x = m + S * p, w = _;
          break;
        default:
          m = g = r.coordinate, y = a + +d * l, v = y + S * A, w = v + S * p, x = _;
          break;
      }
      return {
        line: {
          x1: m,
          y1: v,
          x2: g,
          y2: y
        },
        tick: {
          x,
          y: w
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a;
      switch (i) {
        case "left":
          a = o ? "start" : "end";
          break;
        case "right":
          a = o ? "end" : "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a = "end";
      switch (i) {
        case "left":
        case "right":
          a = "middle";
          break;
        case "top":
          a = o ? "start" : "end";
          break;
        default:
          a = o ? "end" : "start";
          break;
      }
      return a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.orientation, c = r.mirror, f = r.axisLine, d = sr(sr(sr({}, Ee(this.props, !1)), Ee(f, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var p = +(l === "top" && !c || l === "bottom" && c);
        d = sr(sr({}, d), {}, {
          x1: i,
          y1: o + p * s,
          x2: i + a,
          y2: o + p * s
        });
      } else {
        var m = +(l === "left" && !c || l === "right" && c);
        d = sr(sr({}, d), {}, {
          x1: i + m * a,
          y1: o,
          x2: i + m * a,
          y2: o + s
        });
      }
      return /* @__PURE__ */ I.createElement("line", Ll({}, d, {
        className: Ye("recharts-cartesian-axis-line", Wr(f, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, i, o) {
        var a = this, s = this.props, l = s.tickLine, c = s.stroke, f = s.tick, d = s.tickFormatter, p = s.unit, m = NS(sr(sr({}, this.props), {}, {
          ticks: r
        }), i, o), g = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), y = Ee(this.props, !1), x = Ee(f, !1), w = sr(sr({}, y), {}, {
          fill: "none"
        }, Ee(l, !1)), S = m.map(function(A, _) {
          var O = a.getTickLineCoord(A), T = O.line, C = O.tick, k = sr(sr(sr(sr({
            textAnchor: g,
            verticalAnchor: v
          }, y), {}, {
            stroke: "none",
            fill: c
          }, x), C), {}, {
            index: _,
            payload: A,
            visibleTicksCount: m.length,
            tickFormatter: d
          });
          return /* @__PURE__ */ I.createElement(ot, Ll({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(A.value, "-").concat(A.coordinate, "-").concat(A.tickCoord)
          }, Fs(a.props, A, _)), l && /* @__PURE__ */ I.createElement("line", Ll({}, w, T, {
            className: Ye("recharts-cartesian-axis-tick-line", Wr(l, "className"))
          })), f && t.renderTickItem(f, k, "".concat(ze(d) ? d(A.value, _) : A.value).concat(p || "")));
        });
        return /* @__PURE__ */ I.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, S);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.axisLine, a = i.width, s = i.height, l = i.ticksGenerator, c = i.className, f = i.hide;
      if (f)
        return null;
      var d = this.props, p = d.ticks, m = n0(d, lTe), g = p;
      return ze(l) && (g = p && p.length > 0 ? l(this.props) : l(m)), a <= 0 || s <= 0 || !g || !g.length ? null : /* @__PURE__ */ I.createElement(ot, {
        className: Ye("recharts-cartesian-axis", c),
        ref: function(y) {
          r.layerReference = y;
        }
      }, o && this.renderAxisLine(), this.renderTicks(g, this.state.fontSize, this.state.letterSpacing), _n.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ I.isValidElement(r) ? a = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? a = r(i) : a = /* @__PURE__ */ I.createElement(Ws, Ll({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), o), a;
    }
  }]);
}(Uw);
$S(Qc, "displayName", "CartesianAxis");
$S(Qc, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var yTe = ["x1", "y1", "x2", "y2", "key"], vTe = ["offset"];
function Us(e) {
  "@babel/helpers - typeof";
  return Us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Us(e);
}
function x$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? x$(Object(n), !0).forEach(function(r) {
      bTe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bTe(e, t, n) {
  return t = xTe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xTe(e) {
  var t = wTe(e, "string");
  return Us(t) == "symbol" ? t : t + "";
}
function wTe(e, t) {
  if (Us(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Us(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function As() {
  return As = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, As.apply(this, arguments);
}
function w$(e, t) {
  if (e == null) return {};
  var n = _Te(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function _Te(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var STe = function(t) {
  var n = t.fill;
  if (!n || n === "none")
    return null;
  var r = t.fillOpacity, i = t.x, o = t.y, a = t.width, s = t.height, l = t.ry;
  return /* @__PURE__ */ I.createElement("rect", {
    x: i,
    y: o,
    ry: l,
    width: a,
    height: s,
    stroke: "none",
    fill: n,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function RW(e, t) {
  var n;
  if (/* @__PURE__ */ I.isValidElement(e))
    n = /* @__PURE__ */ I.cloneElement(e, t);
  else if (ze(e))
    n = e(t);
  else {
    var r = t.x1, i = t.y1, o = t.x2, a = t.y2, s = t.key, l = w$(t, yTe), c = Ee(l, !1);
    c.offset;
    var f = w$(c, vTe);
    n = /* @__PURE__ */ I.createElement("line", As({}, f, {
      x1: r,
      y1: i,
      x2: o,
      y2: a,
      fill: "none",
      key: s
    }));
  }
  return n;
}
function OTe(e) {
  var t = e.x, n = e.width, r = e.horizontal, i = r === void 0 ? !0 : r, o = e.horizontalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, l) {
    var c = er(er({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + n,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return RW(i, c);
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, a);
}
function ATe(e) {
  var t = e.y, n = e.height, r = e.vertical, i = r === void 0 ? !0 : r, o = e.verticalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, l) {
    var c = er(er({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + n,
      key: "line-".concat(l),
      index: l
    });
    return RW(i, c);
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, a);
}
function PTe(e) {
  var t = e.horizontalFill, n = e.fillOpacity, r = e.x, i = e.y, o = e.width, a = e.height, s = e.horizontalPoints, l = e.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !t || !t.length)
    return null;
  var f = s.map(function(p) {
    return Math.round(p + i - i);
  }).sort(function(p, m) {
    return p - m;
  });
  i !== f[0] && f.unshift(0);
  var d = f.map(function(p, m) {
    var g = !f[m + 1], v = g ? i + a - p : f[m + 1] - p;
    if (v <= 0)
      return null;
    var y = m % t.length;
    return /* @__PURE__ */ I.createElement("rect", {
      key: "react-".concat(m),
      y: p,
      x: r,
      height: v,
      width: o,
      stroke: "none",
      fill: t[y],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, d);
}
function TTe(e) {
  var t = e.vertical, n = t === void 0 ? !0 : t, r = e.verticalFill, i = e.fillOpacity, o = e.x, a = e.y, s = e.width, l = e.height, c = e.verticalPoints;
  if (!n || !r || !r.length)
    return null;
  var f = c.map(function(p) {
    return Math.round(p + o - o);
  }).sort(function(p, m) {
    return p - m;
  });
  o !== f[0] && f.unshift(0);
  var d = f.map(function(p, m) {
    var g = !f[m + 1], v = g ? o + s - p : f[m + 1] - p;
    if (v <= 0)
      return null;
    var y = m % r.length;
    return /* @__PURE__ */ I.createElement("rect", {
      key: "react-".concat(m),
      x: p,
      y: a,
      width: v,
      height: l,
      stroke: "none",
      fill: r[y],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, d);
}
var CTe = function(t, n) {
  var r = t.xAxis, i = t.width, o = t.height, a = t.offset;
  return NF(NS(er(er(er({}, Qc.defaultProps), r), {}, {
    ticks: Eo(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.left, a.left + a.width, n);
}, ETe = function(t, n) {
  var r = t.yAxis, i = t.width, o = t.height, a = t.offset;
  return NF(NS(er(er(er({}, Qc.defaultProps), r), {}, {
    ticks: Eo(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.top, a.top + a.height, n);
}, Sl = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function Sy(e) {
  var t, n, r, i, o, a, s = CS(), l = ES(), c = gPe(), f = er(er({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Sl.stroke,
    fill: (n = e.fill) !== null && n !== void 0 ? n : Sl.fill,
    horizontal: (r = e.horizontal) !== null && r !== void 0 ? r : Sl.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Sl.horizontalFill,
    vertical: (o = e.vertical) !== null && o !== void 0 ? o : Sl.vertical,
    verticalFill: (a = e.verticalFill) !== null && a !== void 0 ? a : Sl.verticalFill,
    x: be(e.x) ? e.x : c.left,
    y: be(e.y) ? e.y : c.top,
    width: be(e.width) ? e.width : c.width,
    height: be(e.height) ? e.height : c.height
  }), d = f.x, p = f.y, m = f.width, g = f.height, v = f.syncWithTicks, y = f.horizontalValues, x = f.verticalValues, w = hPe(), S = pPe();
  if (!be(m) || m <= 0 || !be(g) || g <= 0 || !be(d) || d !== +d || !be(p) || p !== +p)
    return null;
  var A = f.verticalCoordinatesGenerator || CTe, _ = f.horizontalCoordinatesGenerator || ETe, O = f.horizontalPoints, T = f.verticalPoints;
  if ((!O || !O.length) && ze(_)) {
    var C = y && y.length, k = _({
      yAxis: S ? er(er({}, S), {}, {
        ticks: C ? y : S.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, C ? !0 : v);
    ki(Array.isArray(k), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Us(k), "]")), Array.isArray(k) && (O = k);
  }
  if ((!T || !T.length) && ze(A)) {
    var D = x && x.length, N = A({
      xAxis: w ? er(er({}, w), {}, {
        ticks: D ? x : w.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, D ? !0 : v);
    ki(Array.isArray(N), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Us(N), "]")), Array.isArray(N) && (T = N);
  }
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ I.createElement(STe, {
    fill: f.fill,
    fillOpacity: f.fillOpacity,
    x: f.x,
    y: f.y,
    width: f.width,
    height: f.height,
    ry: f.ry
  }), /* @__PURE__ */ I.createElement(OTe, As({}, f, {
    offset: c,
    horizontalPoints: O,
    xAxis: w,
    yAxis: S
  })), /* @__PURE__ */ I.createElement(ATe, As({}, f, {
    offset: c,
    verticalPoints: T,
    xAxis: w,
    yAxis: S
  })), /* @__PURE__ */ I.createElement(PTe, As({}, f, {
    horizontalPoints: O
  })), /* @__PURE__ */ I.createElement(TTe, As({}, f, {
    verticalPoints: T
  })));
}
Sy.displayName = "CartesianGrid";
var kTe = ["type", "layout", "connectNulls", "ref"], MTe = ["key"];
function Oc(e) {
  "@babel/helpers - typeof";
  return Oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oc(e);
}
function _$(e, t) {
  if (e == null) return {};
  var n = NTe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function NTe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function af() {
  return af = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, af.apply(this, arguments);
}
function S$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Dr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S$(Object(n), !0).forEach(function(r) {
      Oi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ol(e) {
  return RTe(e) || ITe(e) || DTe(e) || $Te();
}
function $Te() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DTe(e, t) {
  if (e) {
    if (typeof e == "string") return Mw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Mw(e, t);
  }
}
function ITe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function RTe(e) {
  if (Array.isArray(e)) return Mw(e);
}
function Mw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function jTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, LW(r.key), r);
  }
}
function LTe(e, t, n) {
  return t && O$(e.prototype, t), n && O$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function BTe(e, t, n) {
  return t = Um(t), FTe(e, jW() ? Reflect.construct(t, n || [], Um(e).constructor) : t.apply(e, n));
}
function FTe(e, t) {
  if (t && (Oc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return WTe(e);
}
function WTe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jW = function() {
    return !!e;
  })();
}
function Um(e) {
  return Um = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Um(e);
}
function zTe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Nw(e, t);
}
function Nw(e, t) {
  return Nw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Nw(e, t);
}
function Oi(e, t, n) {
  return t = LW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function LW(e) {
  var t = VTe(e, "string");
  return Oc(t) == "symbol" ? t : t + "";
}
function VTe(e, t) {
  if (Oc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Oc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $d = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    jTe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = BTe(this, t, [].concat(i)), Oi(n, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Oi(n, "generateSimpleStrokeDasharray", function(a, s) {
      return "".concat(s, "px ").concat(a - s, "px");
    }), Oi(n, "getStrokeDasharray", function(a, s, l) {
      var c = l.reduce(function(x, w) {
        return x + w;
      });
      if (!c)
        return n.generateSimpleStrokeDasharray(s, a);
      for (var f = Math.floor(a / c), d = a % c, p = s - a, m = [], g = 0, v = 0; g < l.length; v += l[g], ++g)
        if (v + l[g] > d) {
          m = [].concat(Ol(l.slice(0, g)), [d - v]);
          break;
        }
      var y = m.length % 2 === 0 ? [0, p] : [p];
      return [].concat(Ol(t.repeat(l, f)), Ol(m), y).map(function(x) {
        return "".concat(x, "px");
      }).join(", ");
    }), Oi(n, "id", Qs("recharts-line-")), Oi(n, "pathRef", function(a) {
      n.mainCurve = a;
    }), Oi(n, "handleAnimationEnd", function() {
      n.setState({
        isAnimationFinished: !0
      }), n.props.onAnimationEnd && n.props.onAnimationEnd();
    }), Oi(n, "handleAnimationStart", function() {
      n.setState({
        isAnimationFinished: !1
      }), n.props.onAnimationStart && n.props.onAnimationStart();
    }), n;
  }
  return zTe(t, e), LTe(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        r !== this.state.totalLength && this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var r = this.mainCurve;
      try {
        return r && r.getTotalLength && r.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.points, s = o.xAxis, l = o.yAxis, c = o.layout, f = o.children, d = zr(f, Md);
      if (!d)
        return null;
      var p = function(v, y) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: ln(v.payload, y)
        };
      }, m = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ I.createElement(ot, m, d.map(function(g) {
        return /* @__PURE__ */ I.cloneElement(g, {
          key: "bar-".concat(g.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: c,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(r, i, o) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var s = this.props, l = s.dot, c = s.points, f = s.dataKey, d = Ee(this.props, !1), p = Ee(l, !0), m = c.map(function(v, y) {
        var x = Dr(Dr(Dr({
          key: "dot-".concat(y),
          r: 3
        }, d), p), {}, {
          value: v.value,
          dataKey: f,
          cx: v.x,
          cy: v.y,
          index: y,
          payload: v.payload
        });
        return t.renderDotItem(l, x);
      }), g = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ I.createElement(ot, af({
        className: "recharts-line-dots",
        key: "dots"
      }, g), m);
    }
  }, {
    key: "renderCurveStatically",
    value: function(r, i, o, a) {
      var s = this.props, l = s.type, c = s.layout, f = s.connectNulls;
      s.ref;
      var d = _$(s, kTe), p = Dr(Dr(Dr({}, Ee(d, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null,
        points: r
      }, a), {}, {
        type: l,
        layout: c,
        connectNulls: f
      });
      return /* @__PURE__ */ I.createElement($s, af({}, p, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(r, i) {
      var o = this, a = this.props, s = a.points, l = a.strokeDasharray, c = a.isAnimationActive, f = a.animationBegin, d = a.animationDuration, p = a.animationEasing, m = a.animationId, g = a.animateNewValues, v = a.width, y = a.height, x = this.state, w = x.prevPoints, S = x.totalLength;
      return /* @__PURE__ */ I.createElement(Ni, {
        begin: f,
        duration: d,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(m),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(A) {
        var _ = A.t;
        if (w) {
          var O = w.length / s.length, T = s.map(function($, B) {
            var L = Math.floor(B * O);
            if (w[L]) {
              var F = w[L], W = wn(F.x, $.x), z = wn(F.y, $.y);
              return Dr(Dr({}, $), {}, {
                x: W(_),
                y: z(_)
              });
            }
            if (g) {
              var G = wn(v * 2, $.x), V = wn(y / 2, $.y);
              return Dr(Dr({}, $), {}, {
                x: G(_),
                y: V(_)
              });
            }
            return Dr(Dr({}, $), {}, {
              x: $.x,
              y: $.y
            });
          });
          return o.renderCurveStatically(T, r, i);
        }
        var C = wn(0, S), k = C(_), D;
        if (l) {
          var N = "".concat(l).split(/[,\s]+/gim).map(function($) {
            return parseFloat($);
          });
          D = o.getStrokeDasharray(k, S, N);
        } else
          D = o.generateSimpleStrokeDasharray(S, k);
        return o.renderCurveStatically(s, r, i, {
          strokeDasharray: D
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(r, i) {
      var o = this.props, a = o.points, s = o.isAnimationActive, l = this.state, c = l.prevPoints, f = l.totalLength;
      return s && a && a.length && (!c && f > 0 || !zs(c, a)) ? this.renderCurveWithAnimation(r, i) : this.renderCurveStatically(a, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, o = i.hide, a = i.dot, s = i.points, l = i.className, c = i.xAxis, f = i.yAxis, d = i.top, p = i.left, m = i.width, g = i.height, v = i.isAnimationActive, y = i.id;
      if (o || !s || !s.length)
        return null;
      var x = this.state.isAnimationFinished, w = s.length === 1, S = Ye("recharts-line", l), A = c && c.allowDataOverflow, _ = f && f.allowDataOverflow, O = A || _, T = Ue(y) ? this.id : y, C = (r = Ee(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, k = C.r, D = k === void 0 ? 3 : k, N = C.strokeWidth, $ = N === void 0 ? 2 : N, B = SL(a) ? a : {}, L = B.clipDot, F = L === void 0 ? !0 : L, W = D * 2 + $;
      return /* @__PURE__ */ I.createElement(ot, {
        className: S
      }, A || _ ? /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-".concat(T)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: A ? p : p - m / 2,
        y: _ ? d : d - g / 2,
        width: A ? m : m * 2,
        height: _ ? g : g * 2
      })), !F && /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-dots-".concat(T)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: p - W / 2,
        y: d - W / 2,
        width: m + W,
        height: g + W
      }))) : null, !w && this.renderCurve(O, T), this.renderErrorBar(O, T), (w || a) && this.renderDots(O, F, T), (!v || x) && Zi.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        prevPoints: i.curPoints
      } : r.points !== i.curPoints ? {
        curPoints: r.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(r, i) {
      for (var o = r.length % 2 !== 0 ? [].concat(Ol(r), [0]) : r, a = [], s = 0; s < i; ++s)
        a = [].concat(Ol(a), Ol(o));
      return a;
    }
  }, {
    key: "renderDotItem",
    value: function(r, i) {
      var o;
      if (/* @__PURE__ */ I.isValidElement(r))
        o = /* @__PURE__ */ I.cloneElement(r, i);
      else if (ze(r))
        o = r(i);
      else {
        var a = i.key, s = _$(i, MTe), l = Ye("recharts-line-dot", typeof r != "boolean" ? r.className : "");
        o = /* @__PURE__ */ I.createElement(Nd, af({
          key: a
        }, s, {
          className: l
        }));
      }
      return o;
    }
  }]);
}(hi);
Oi($d, "displayName", "Line");
Oi($d, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Mi.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Oi($d, "getComposedData", function(e) {
  var t = e.props, n = e.xAxis, r = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, a = e.dataKey, s = e.bandSize, l = e.displayedData, c = e.offset, f = t.layout, d = l.map(function(p, m) {
    var g = ln(p, a);
    return f === "horizontal" ? {
      x: bm({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: p,
        index: m
      }),
      y: Ue(g) ? null : r.scale(g),
      value: g,
      payload: p
    } : {
      x: Ue(g) ? null : n.scale(g),
      y: bm({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: p,
        index: m
      }),
      value: g,
      payload: p
    };
  });
  return Dr({
    points: d,
    layout: f
  }, c);
});
var UTe = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], KTe = ["key"], BW;
function Ac(e) {
  "@babel/helpers - typeof";
  return Ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ac(e);
}
function FW(e, t) {
  if (e == null) return {};
  var n = HTe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function HTe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Ps() {
  return Ps = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ps.apply(this, arguments);
}
function A$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ya(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A$(Object(n), !0).forEach(function(r) {
      Ui(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : A$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function GTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function P$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, zW(r.key), r);
  }
}
function YTe(e, t, n) {
  return t && P$(e.prototype, t), n && P$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qTe(e, t, n) {
  return t = Km(t), XTe(e, WW() ? Reflect.construct(t, n || [], Km(e).constructor) : t.apply(e, n));
}
function XTe(e, t) {
  if (t && (Ac(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ZTe(e);
}
function ZTe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function WW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (WW = function() {
    return !!e;
  })();
}
function Km(e) {
  return Km = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Km(e);
}
function JTe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $w(e, t);
}
function $w(e, t) {
  return $w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, $w(e, t);
}
function Ui(e, t, n) {
  return t = zW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function zW(e) {
  var t = QTe(e, "string");
  return Ac(t) == "symbol" ? t : t + "";
}
function QTe(e, t) {
  if (Ac(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ac(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Xa = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    GTe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = qTe(this, t, [].concat(i)), Ui(n, "state", {
      isAnimationFinished: !0
    }), Ui(n, "id", Qs("recharts-area-")), Ui(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ze(a) && a();
    }), Ui(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ze(a) && a();
    }), n;
  }
  return JTe(t, e), YTe(t, [{
    key: "renderDots",
    value: function(r, i, o) {
      var a = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (a && !s)
        return null;
      var l = this.props, c = l.dot, f = l.points, d = l.dataKey, p = Ee(this.props, !1), m = Ee(c, !0), g = f.map(function(y, x) {
        var w = ya(ya(ya({
          key: "dot-".concat(x),
          r: 3
        }, p), m), {}, {
          index: x,
          cx: y.x,
          cy: y.y,
          dataKey: d,
          value: y.value,
          payload: y.payload,
          points: f
        });
        return t.renderDotItem(c, w);
      }), v = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ I.createElement(ot, Ps({
        className: "recharts-area-dots"
      }, v), g);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(r) {
      var i = this.props, o = i.baseLine, a = i.points, s = i.strokeWidth, l = a[0].x, c = a[a.length - 1].x, f = r * Math.abs(l - c), d = Oa(a.map(function(p) {
        return p.y || 0;
      }));
      return be(o) && typeof o == "number" ? d = Math.max(o, d) : o && Array.isArray(o) && o.length && (d = Math.max(Oa(o.map(function(p) {
        return p.y || 0;
      })), d)), be(d) ? /* @__PURE__ */ I.createElement("rect", {
        x: l < c ? l : l - f,
        y: 0,
        width: f,
        height: Math.floor(d + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(r) {
      var i = this.props, o = i.baseLine, a = i.points, s = i.strokeWidth, l = a[0].y, c = a[a.length - 1].y, f = r * Math.abs(l - c), d = Oa(a.map(function(p) {
        return p.x || 0;
      }));
      return be(o) && typeof o == "number" ? d = Math.max(o, d) : o && Array.isArray(o) && o.length && (d = Math.max(Oa(o.map(function(p) {
        return p.x || 0;
      })), d)), be(d) ? /* @__PURE__ */ I.createElement("rect", {
        x: 0,
        y: l < c ? l : l - f,
        width: d + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(f)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(r) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(r) : this.renderHorizontalRect(r);
    }
  }, {
    key: "renderAreaStatically",
    value: function(r, i, o, a) {
      var s = this.props, l = s.layout, c = s.type, f = s.stroke, d = s.connectNulls, p = s.isRange;
      s.ref;
      var m = FW(s, UTe);
      return /* @__PURE__ */ I.createElement(ot, {
        clipPath: o ? "url(#clipPath-".concat(a, ")") : null
      }, /* @__PURE__ */ I.createElement($s, Ps({}, Ee(m, !0), {
        points: r,
        connectNulls: d,
        type: c,
        baseLine: i,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), f !== "none" && /* @__PURE__ */ I.createElement($s, Ps({}, Ee(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: r
      })), f !== "none" && p && /* @__PURE__ */ I.createElement($s, Ps({}, Ee(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(r, i) {
      var o = this, a = this.props, s = a.points, l = a.baseLine, c = a.isAnimationActive, f = a.animationBegin, d = a.animationDuration, p = a.animationEasing, m = a.animationId, g = this.state, v = g.prevPoints, y = g.prevBaseLine;
      return /* @__PURE__ */ I.createElement(Ni, {
        begin: f,
        duration: d,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(m),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var w = x.t;
        if (v) {
          var S = v.length / s.length, A = s.map(function(C, k) {
            var D = Math.floor(k * S);
            if (v[D]) {
              var N = v[D], $ = wn(N.x, C.x), B = wn(N.y, C.y);
              return ya(ya({}, C), {}, {
                x: $(w),
                y: B(w)
              });
            }
            return C;
          }), _;
          if (be(l) && typeof l == "number") {
            var O = wn(y, l);
            _ = O(w);
          } else if (Ue(l) || Kc(l)) {
            var T = wn(y, 0);
            _ = T(w);
          } else
            _ = l.map(function(C, k) {
              var D = Math.floor(k * S);
              if (y[D]) {
                var N = y[D], $ = wn(N.x, C.x), B = wn(N.y, C.y);
                return ya(ya({}, C), {}, {
                  x: $(w),
                  y: B(w)
                });
              }
              return C;
            });
          return o.renderAreaStatically(A, _, r, i);
        }
        return /* @__PURE__ */ I.createElement(ot, null, /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, o.renderClipRect(w))), /* @__PURE__ */ I.createElement(ot, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, o.renderAreaStatically(s, l, r, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(r, i) {
      var o = this.props, a = o.points, s = o.baseLine, l = o.isAnimationActive, c = this.state, f = c.prevPoints, d = c.prevBaseLine, p = c.totalLength;
      return l && a && a.length && (!f && p > 0 || !zs(f, a) || !zs(d, s)) ? this.renderAreaWithAnimation(r, i) : this.renderAreaStatically(a, s, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, o = i.hide, a = i.dot, s = i.points, l = i.className, c = i.top, f = i.left, d = i.xAxis, p = i.yAxis, m = i.width, g = i.height, v = i.isAnimationActive, y = i.id;
      if (o || !s || !s.length)
        return null;
      var x = this.state.isAnimationFinished, w = s.length === 1, S = Ye("recharts-area", l), A = d && d.allowDataOverflow, _ = p && p.allowDataOverflow, O = A || _, T = Ue(y) ? this.id : y, C = (r = Ee(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, k = C.r, D = k === void 0 ? 3 : k, N = C.strokeWidth, $ = N === void 0 ? 2 : N, B = SL(a) ? a : {}, L = B.clipDot, F = L === void 0 ? !0 : L, W = D * 2 + $;
      return /* @__PURE__ */ I.createElement(ot, {
        className: S
      }, A || _ ? /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-".concat(T)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: A ? f : f - m / 2,
        y: _ ? c : c - g / 2,
        width: A ? m : m * 2,
        height: _ ? g : g * 2
      })), !F && /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-dots-".concat(T)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: f - W / 2,
        y: c - W / 2,
        width: m + W,
        height: g + W
      }))) : null, w ? null : this.renderArea(O, T), (a || w) && this.renderDots(O, F, T), (!v || x) && Zi.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        curBaseLine: r.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : r.points !== i.curPoints || r.baseLine !== i.curBaseLine ? {
        curPoints: r.points,
        curBaseLine: r.baseLine
      } : null;
    }
  }]);
}(hi);
BW = Xa;
Ui(Xa, "displayName", "Area");
Ui(Xa, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Mi.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Ui(Xa, "getBaseValue", function(e, t, n, r) {
  var i = e.layout, o = e.baseValue, a = t.props.baseValue, s = a ?? o;
  if (be(s) && typeof s == "number")
    return s;
  var l = i === "horizontal" ? r : n, c = l.scale.domain();
  if (l.type === "number") {
    var f = Math.max(c[0], c[1]), d = Math.min(c[0], c[1]);
    return s === "dataMin" ? d : s === "dataMax" || f < 0 ? f : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
Ui(Xa, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.xAxis, i = e.yAxis, o = e.xAxisTicks, a = e.yAxisTicks, s = e.bandSize, l = e.dataKey, c = e.stackedData, f = e.dataStartIndex, d = e.displayedData, p = e.offset, m = t.layout, g = c && c.length, v = BW.getBaseValue(t, n, r, i), y = m === "horizontal", x = !1, w = d.map(function(A, _) {
    var O;
    g ? O = c[f + _] : (O = ln(A, l), Array.isArray(O) ? x = !0 : O = [v, O]);
    var T = O[1] == null || g && ln(A, l) == null;
    return y ? {
      x: bm({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: A,
        index: _
      }),
      y: T ? null : i.scale(O[1]),
      value: O,
      payload: A
    } : {
      x: T ? null : r.scale(O[1]),
      y: bm({
        axis: i,
        ticks: a,
        bandSize: s,
        entry: A,
        index: _
      }),
      value: O,
      payload: A
    };
  }), S;
  return g || x ? S = w.map(function(A) {
    var _ = Array.isArray(A.value) ? A.value[0] : null;
    return y ? {
      x: A.x,
      y: _ != null && A.y != null ? i.scale(_) : null
    } : {
      x: _ != null ? r.scale(_) : null,
      y: A.y
    };
  }) : S = y ? i.scale(v) : r.scale(v), ya({
    points: w,
    baseLine: S,
    layout: m,
    isRange: x
  }, p);
});
Ui(Xa, "renderDotItem", function(e, t) {
  var n;
  if (/* @__PURE__ */ I.isValidElement(e))
    n = /* @__PURE__ */ I.cloneElement(e, t);
  else if (ze(e))
    n = e(t);
  else {
    var r = Ye("recharts-area-dot", typeof e != "boolean" ? e.className : ""), i = t.key, o = FW(t, KTe);
    n = /* @__PURE__ */ I.createElement(Nd, Ps({}, o, {
      key: i,
      className: r
    }));
  }
  return n;
});
function Pc(e) {
  "@babel/helpers - typeof";
  return Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pc(e);
}
function eCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tCe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, KW(r.key), r);
  }
}
function nCe(e, t, n) {
  return t && tCe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rCe(e, t, n) {
  return t = Hm(t), iCe(e, VW() ? Reflect.construct(t, n || [], Hm(e).constructor) : t.apply(e, n));
}
function iCe(e, t) {
  if (t && (Pc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return oCe(e);
}
function oCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VW = function() {
    return !!e;
  })();
}
function Hm(e) {
  return Hm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hm(e);
}
function aCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dw(e, t);
}
function Dw(e, t) {
  return Dw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Dw(e, t);
}
function UW(e, t, n) {
  return t = KW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function KW(e) {
  var t = sCe(e, "string");
  return Pc(t) == "symbol" ? t : t + "";
}
function sCe(e, t) {
  if (Pc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Pc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Iw() {
  return Iw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Iw.apply(this, arguments);
}
function lCe(e) {
  var t = e.xAxisId, n = CS(), r = ES(), i = AW(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ I.createElement(Qc, Iw({}, i, {
      className: Ye("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: r
      },
      ticksGenerator: function(a) {
        return Eo(a, !0);
      }
    }))
  );
}
var Ho = /* @__PURE__ */ function(e) {
  function t() {
    return eCe(this, t), rCe(this, t, arguments);
  }
  return aCe(t, e), nCe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ I.createElement(lCe, this.props);
    }
  }]);
}(I.Component);
UW(Ho, "displayName", "XAxis");
UW(Ho, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Tc(e) {
  "@babel/helpers - typeof";
  return Tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tc(e);
}
function cCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uCe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, YW(r.key), r);
  }
}
function fCe(e, t, n) {
  return t && uCe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function dCe(e, t, n) {
  return t = Gm(t), hCe(e, HW() ? Reflect.construct(t, n || [], Gm(e).constructor) : t.apply(e, n));
}
function hCe(e, t) {
  if (t && (Tc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pCe(e);
}
function pCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function HW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (HW = function() {
    return !!e;
  })();
}
function Gm(e) {
  return Gm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gm(e);
}
function mCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rw(e, t);
}
function Rw(e, t) {
  return Rw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Rw(e, t);
}
function GW(e, t, n) {
  return t = YW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function YW(e) {
  var t = gCe(e, "string");
  return Tc(t) == "symbol" ? t : t + "";
}
function gCe(e, t) {
  if (Tc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Tc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function jw() {
  return jw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jw.apply(this, arguments);
}
var yCe = function(t) {
  var n = t.yAxisId, r = CS(), i = ES(), o = PW(n);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ I.createElement(Qc, jw({}, o, {
      className: Ye("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: i
      },
      ticksGenerator: function(s) {
        return Eo(s, !0);
      }
    }))
  );
}, Qi = /* @__PURE__ */ function(e) {
  function t() {
    return cCe(this, t), dCe(this, t, arguments);
  }
  return mCe(t, e), fCe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ I.createElement(yCe, this.props);
    }
  }]);
}(I.Component);
GW(Qi, "displayName", "YAxis");
GW(Qi, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function T$(e) {
  return wCe(e) || xCe(e) || bCe(e) || vCe();
}
function vCe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bCe(e, t) {
  if (e) {
    if (typeof e == "string") return Lw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Lw(e, t);
  }
}
function xCe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wCe(e) {
  if (Array.isArray(e)) return Lw(e);
}
function Lw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Bw = function(t, n, r, i, o) {
  var a = zr(t, MS), s = zr(t, xy), l = [].concat(T$(a), T$(s)), c = zr(t, _y), f = "".concat(i, "Id"), d = i[0], p = n;
  if (l.length && (p = l.reduce(function(v, y) {
    if (y.props[f] === r && Ji(y.props, "extendDomain") && be(y.props[d])) {
      var x = y.props[d];
      return [Math.min(v[0], x), Math.max(v[1], x)];
    }
    return v;
  }, p)), c.length) {
    var m = "".concat(d, "1"), g = "".concat(d, "2");
    p = c.reduce(function(v, y) {
      if (y.props[f] === r && Ji(y.props, "extendDomain") && be(y.props[m]) && be(y.props[g])) {
        var x = y.props[m], w = y.props[g];
        return [Math.min(v[0], x, w), Math.max(v[1], x, w)];
      }
      return v;
    }, p);
  }
  return o && o.length && (p = o.reduce(function(v, y) {
    return be(y) ? [Math.min(v[0], y), Math.max(v[1], y)] : v;
  }, p)), p;
}, qW = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(l, c, f) {
    this.fn = l, this.context = c, this.once = f || !1;
  }
  function o(l, c, f, d, p) {
    if (typeof f != "function")
      throw new TypeError("The listener must be a function");
    var m = new i(f, d || l, p), g = n ? n + c : c;
    return l._events[g] ? l._events[g].fn ? l._events[g] = [l._events[g], m] : l._events[g].push(m) : (l._events[g] = m, l._eventsCount++), l;
  }
  function a(l, c) {
    --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
  }
  function s() {
    this._events = new r(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], f, d;
    if (this._eventsCount === 0) return c;
    for (d in f = this._events)
      t.call(f, d) && c.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(f)) : c;
  }, s.prototype.listeners = function(c) {
    var f = n ? n + c : c, d = this._events[f];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var p = 0, m = d.length, g = new Array(m); p < m; p++)
      g[p] = d[p].fn;
    return g;
  }, s.prototype.listenerCount = function(c) {
    var f = n ? n + c : c, d = this._events[f];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(c, f, d, p, m, g) {
    var v = n ? n + c : c;
    if (!this._events[v]) return !1;
    var y = this._events[v], x = arguments.length, w, S;
    if (y.fn) {
      switch (y.once && this.removeListener(c, y.fn, void 0, !0), x) {
        case 1:
          return y.fn.call(y.context), !0;
        case 2:
          return y.fn.call(y.context, f), !0;
        case 3:
          return y.fn.call(y.context, f, d), !0;
        case 4:
          return y.fn.call(y.context, f, d, p), !0;
        case 5:
          return y.fn.call(y.context, f, d, p, m), !0;
        case 6:
          return y.fn.call(y.context, f, d, p, m, g), !0;
      }
      for (S = 1, w = new Array(x - 1); S < x; S++)
        w[S - 1] = arguments[S];
      y.fn.apply(y.context, w);
    } else {
      var A = y.length, _;
      for (S = 0; S < A; S++)
        switch (y[S].once && this.removeListener(c, y[S].fn, void 0, !0), x) {
          case 1:
            y[S].fn.call(y[S].context);
            break;
          case 2:
            y[S].fn.call(y[S].context, f);
            break;
          case 3:
            y[S].fn.call(y[S].context, f, d);
            break;
          case 4:
            y[S].fn.call(y[S].context, f, d, p);
            break;
          default:
            if (!w) for (_ = 1, w = new Array(x - 1); _ < x; _++)
              w[_ - 1] = arguments[_];
            y[S].fn.apply(y[S].context, w);
        }
    }
    return !0;
  }, s.prototype.on = function(c, f, d) {
    return o(this, c, f, d, !1);
  }, s.prototype.once = function(c, f, d) {
    return o(this, c, f, d, !0);
  }, s.prototype.removeListener = function(c, f, d, p) {
    var m = n ? n + c : c;
    if (!this._events[m]) return this;
    if (!f)
      return a(this, m), this;
    var g = this._events[m];
    if (g.fn)
      g.fn === f && (!p || g.once) && (!d || g.context === d) && a(this, m);
    else {
      for (var v = 0, y = [], x = g.length; v < x; v++)
        (g[v].fn !== f || p && !g[v].once || d && g[v].context !== d) && y.push(g[v]);
      y.length ? this._events[m] = y.length === 1 ? y[0] : y : a(this, m);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var f;
    return c ? (f = n ? n + c : c, this._events[f] && a(this, f)) : (this._events = new r(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
})(qW);
var _Ce = qW.exports;
const SCe = /* @__PURE__ */ Et(_Ce);
var r0 = new SCe(), i0 = "recharts.syncMouseEvents";
function rd(e) {
  "@babel/helpers - typeof";
  return rd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rd(e);
}
function OCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ACe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, XW(r.key), r);
  }
}
function PCe(e, t, n) {
  return t && ACe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function o0(e, t, n) {
  return t = XW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function XW(e) {
  var t = TCe(e, "string");
  return rd(t) == "symbol" ? t : t + "";
}
function TCe(e, t) {
  if (rd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (rd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var CCe = /* @__PURE__ */ function() {
  function e() {
    OCe(this, e), o0(this, "activeIndex", 0), o0(this, "coordinateList", []), o0(this, "layout", "horizontal");
  }
  return PCe(e, [{
    key: "setDetails",
    value: function(n) {
      var r, i = n.coordinateList, o = i === void 0 ? null : i, a = n.container, s = a === void 0 ? null : a, l = n.layout, c = l === void 0 ? null : l, f = n.offset, d = f === void 0 ? null : f, p = n.mouseHandlerCallback, m = p === void 0 ? null : p;
      this.coordinateList = (r = o ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = d ?? this.offset, this.mouseHandlerCallback = m ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(n) {
      if (this.coordinateList.length !== 0)
        switch (n.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(n) {
      this.activeIndex = n;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var n, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), o = i.x, a = i.y, s = i.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((n = window) === null || n === void 0 ? void 0 : n.scrollX) || 0, f = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, d = o + l + c, p = a + this.offset.top + s / 2 + f;
        this.mouseHandlerCallback({
          pageX: d,
          pageY: p
        });
      }
    }
  }]);
}();
function ECe(e, t, n) {
  if (n === "number" && t === !0 && Array.isArray(e)) {
    var r = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
    if (r && i && be(r) && be(i))
      return !0;
  }
  return !1;
}
function kCe(e, t, n, r) {
  var i = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : n.left + 0.5,
    y: e === "horizontal" ? n.top + 0.5 : t.y - i,
    width: e === "horizontal" ? r : n.width - 1,
    height: e === "horizontal" ? n.height - 1 : r
  };
}
function ZW(e) {
  var t = e.cx, n = e.cy, r = e.radius, i = e.startAngle, o = e.endAngle, a = Lt(t, n, r, i), s = Lt(t, n, r, o);
  return {
    points: [a, s],
    cx: t,
    cy: n,
    radius: r,
    startAngle: i,
    endAngle: o
  };
}
function MCe(e, t, n) {
  var r, i, o, a;
  if (e === "horizontal")
    r = t.x, o = r, i = n.top, a = n.top + n.height;
  else if (e === "vertical")
    i = t.y, a = i, r = n.left, o = n.left + n.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, l = t.cy, c = t.innerRadius, f = t.outerRadius, d = t.angle, p = Lt(s, l, c, d), m = Lt(s, l, f, d);
      r = p.x, i = p.y, o = m.x, a = m.y;
    } else
      return ZW(t);
  return [{
    x: r,
    y: i
  }, {
    x: o,
    y: a
  }];
}
function id(e) {
  "@babel/helpers - typeof";
  return id = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, id(e);
}
function C$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Qh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C$(Object(n), !0).forEach(function(r) {
      NCe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function NCe(e, t, n) {
  return t = $Ce(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $Ce(e) {
  var t = DCe(e, "string");
  return id(t) == "symbol" ? t : t + "";
}
function DCe(e, t) {
  if (id(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (id(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ICe(e) {
  var t, n, r = e.element, i = e.tooltipEventType, o = e.isActive, a = e.activeCoordinate, s = e.activePayload, l = e.offset, c = e.activeTooltipIndex, f = e.tooltipAxisBandSize, d = e.layout, p = e.chartName, m = (t = r.props.cursor) !== null && t !== void 0 ? t : (n = r.type.defaultProps) === null || n === void 0 ? void 0 : n.cursor;
  if (!r || !m || !o || !a || p !== "ScatterChart" && i !== "axis")
    return null;
  var g, v = $s;
  if (p === "ScatterChart")
    g = a, v = V_e;
  else if (p === "BarChart")
    g = kCe(d, a, l, f), v = SS;
  else if (d === "radial") {
    var y = ZW(a), x = y.cx, w = y.cy, S = y.radius, A = y.startAngle, _ = y.endAngle;
    g = {
      cx: x,
      cy: w,
      startAngle: A,
      endAngle: _,
      innerRadius: S,
      outerRadius: S
    }, v = VF;
  } else
    g = {
      points: MCe(d, a, l)
    }, v = $s;
  var O = Qh(Qh(Qh(Qh({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), g), Ee(m, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: Ye("recharts-tooltip-cursor", m.className)
  });
  return /* @__PURE__ */ ut(m) ? /* @__PURE__ */ _t(m, O) : /* @__PURE__ */ Yl(v, O);
}
var RCe = ["item"], jCe = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Cc(e) {
  "@babel/helpers - typeof";
  return Cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cc(e);
}
function Bl() {
  return Bl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bl.apply(this, arguments);
}
function E$(e, t) {
  return FCe(e) || BCe(e, t) || QW(e, t) || LCe();
}
function LCe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BCe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function FCe(e) {
  if (Array.isArray(e)) return e;
}
function k$(e, t) {
  if (e == null) return {};
  var n = WCe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function WCe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function zCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VCe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ez(r.key), r);
  }
}
function UCe(e, t, n) {
  return t && VCe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function KCe(e, t, n) {
  return t = Ym(t), HCe(e, JW() ? Reflect.construct(t, n || [], Ym(e).constructor) : t.apply(e, n));
}
function HCe(e, t) {
  if (t && (Cc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GCe(e);
}
function GCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JW = function() {
    return !!e;
  })();
}
function Ym(e) {
  return Ym = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ym(e);
}
function YCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fw(e, t);
}
function Fw(e, t) {
  return Fw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Fw(e, t);
}
function Ec(e) {
  return ZCe(e) || XCe(e) || QW(e) || qCe();
}
function qCe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QW(e, t) {
  if (e) {
    if (typeof e == "string") return Ww(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ww(e, t);
  }
}
function XCe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ZCe(e) {
  if (Array.isArray(e)) return Ww(e);
}
function Ww(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function M$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function se(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M$(Object(n), !0).forEach(function(r) {
      We(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function We(e, t, n) {
  return t = ez(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ez(e) {
  var t = JCe(e, "string");
  return Cc(t) == "symbol" ? t : t + "";
}
function JCe(e, t) {
  if (Cc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Cc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var QCe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, eEe = {
  width: "100%",
  height: "100%"
}, tz = {
  x: 0,
  y: 0
};
function ep(e) {
  return e;
}
var tEe = function(t, n) {
  return n === "horizontal" ? t.x : n === "vertical" ? t.y : n === "centric" ? t.angle : t.radius;
}, nEe = function(t, n, r, i) {
  var o = n.find(function(f) {
    return f && f.index === r;
  });
  if (o) {
    if (t === "horizontal")
      return {
        x: o.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: o.coordinate
      };
    if (t === "centric") {
      var a = o.coordinate, s = i.radius;
      return se(se(se({}, i), Lt(i.cx, i.cy, s, a)), {}, {
        angle: a,
        radius: s
      });
    }
    var l = o.coordinate, c = i.angle;
    return se(se(se({}, i), Lt(i.cx, i.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return tz;
}, Oy = function(t, n) {
  var r = n.graphicalItems, i = n.dataStartIndex, o = n.dataEndIndex, a = (r ?? []).reduce(function(s, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(Ec(s), Ec(c)) : s;
  }, []);
  return a.length > 0 ? a : t && t.length && be(i) && be(o) ? t.slice(i, o + 1) : [];
};
function nz(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var zw = function(t, n, r, i) {
  var o = t.graphicalItems, a = t.tooltipAxis, s = Oy(n, t);
  return r < 0 || !o || !o.length || r >= s.length ? null : o.reduce(function(l, c) {
    var f, d = (f = c.props.data) !== null && f !== void 0 ? f : n;
    d && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= r && (d = d.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var p;
    if (a.dataKey && !a.allowDuplicatedCategory) {
      var m = d === void 0 ? s : d;
      p = Kp(m, a.dataKey, i);
    } else
      p = d && d[r] || s[r];
    return p ? [].concat(Ec(l), [jF(c, p)]) : l;
  }, []);
}, N$ = function(t, n, r, i) {
  var o = i || {
    x: t.chartX,
    y: t.chartY
  }, a = tEe(o, r), s = t.orderedTooltipTicks, l = t.tooltipAxis, c = t.tooltipTicks, f = vxe(a, s, c, l);
  if (f >= 0 && c) {
    var d = c[f] && c[f].value, p = zw(t, n, f, d), m = nEe(r, s, f, o);
    return {
      activeTooltipIndex: f,
      activeLabel: d,
      activePayload: p,
      activeCoordinate: m
    };
  }
  return null;
}, rEe = function(t, n) {
  var r = n.axes, i = n.graphicalItems, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, f = t.layout, d = t.children, p = t.stackOffset, m = MF(f, o);
  return r.reduce(function(g, v) {
    var y, x = v.type.defaultProps !== void 0 ? se(se({}, v.type.defaultProps), v.props) : v.props, w = x.type, S = x.dataKey, A = x.allowDataOverflow, _ = x.allowDuplicatedCategory, O = x.scale, T = x.ticks, C = x.includeHidden, k = x[a];
    if (g[k])
      return g;
    var D = Oy(t.data, {
      graphicalItems: i.filter(function(te) {
        var ne, re = a in te.props ? te.props[a] : (ne = te.type.defaultProps) === null || ne === void 0 ? void 0 : ne[a];
        return re === k;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), N = D.length, $, B, L;
    ECe(x.domain, A, w) && ($ = ew(x.domain, null, A), m && (w === "number" || O !== "auto") && (L = tf(D, S, "category")));
    var F = nz(w);
    if (!$ || $.length === 0) {
      var W, z = (W = x.domain) !== null && W !== void 0 ? W : F;
      if (S) {
        if ($ = tf(D, S, w), w === "category" && m) {
          var G = lae($);
          _ && G ? (B = $, $ = $m(0, N)) : _ || ($ = VM(z, $, v).reduce(function(te, ne) {
            return te.indexOf(ne) >= 0 ? te : [].concat(Ec(te), [ne]);
          }, []));
        } else if (w === "category")
          _ ? $ = $.filter(function(te) {
            return te !== "" && !Ue(te);
          }) : $ = VM(z, $, v).reduce(function(te, ne) {
            return te.indexOf(ne) >= 0 || ne === "" || Ue(ne) ? te : [].concat(Ec(te), [ne]);
          }, []);
        else if (w === "number") {
          var V = Sxe(D, i.filter(function(te) {
            var ne, re, ue = a in te.props ? te.props[a] : (ne = te.type.defaultProps) === null || ne === void 0 ? void 0 : ne[a], ae = "hide" in te.props ? te.props.hide : (re = te.type.defaultProps) === null || re === void 0 ? void 0 : re.hide;
            return ue === k && (C || !ae);
          }), S, o, f);
          V && ($ = V);
        }
        m && (w === "number" || O !== "auto") && (L = tf(D, S, "category"));
      } else m ? $ = $m(0, N) : s && s[k] && s[k].hasStack && w === "number" ? $ = p === "expand" ? [0, 1] : RF(s[k].stackGroups, l, c) : $ = kF(D, i.filter(function(te) {
        var ne = a in te.props ? te.props[a] : te.type.defaultProps[a], re = "hide" in te.props ? te.props.hide : te.type.defaultProps.hide;
        return ne === k && (C || !re);
      }), w, f, !0);
      if (w === "number")
        $ = Bw(d, $, k, o, T), z && ($ = ew(z, $, A));
      else if (w === "category" && z) {
        var U = z, Y = $.every(function(te) {
          return U.indexOf(te) >= 0;
        });
        Y && ($ = U);
      }
    }
    return se(se({}, g), {}, We({}, k, se(se({}, x), {}, {
      axisType: o,
      domain: $,
      categoricalDomain: L,
      duplicateDomain: B,
      originalDomain: (y = x.domain) !== null && y !== void 0 ? y : F,
      isCategorical: m,
      layout: f
    })));
  }, {});
}, iEe = function(t, n) {
  var r = n.graphicalItems, i = n.Axis, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, f = t.layout, d = t.children, p = Oy(t.data, {
    graphicalItems: r,
    dataStartIndex: l,
    dataEndIndex: c
  }), m = p.length, g = MF(f, o), v = -1;
  return r.reduce(function(y, x) {
    var w = x.type.defaultProps !== void 0 ? se(se({}, x.type.defaultProps), x.props) : x.props, S = w[a], A = nz("number");
    if (!y[S]) {
      v++;
      var _;
      return g ? _ = $m(0, m) : s && s[S] && s[S].hasStack ? (_ = RF(s[S].stackGroups, l, c), _ = Bw(d, _, S, o)) : (_ = ew(A, kF(p, r.filter(function(O) {
        var T, C, k = a in O.props ? O.props[a] : (T = O.type.defaultProps) === null || T === void 0 ? void 0 : T[a], D = "hide" in O.props ? O.props.hide : (C = O.type.defaultProps) === null || C === void 0 ? void 0 : C.hide;
        return k === S && !D;
      }), "number", f), i.defaultProps.allowDataOverflow), _ = Bw(d, _, S, o)), se(se({}, y), {}, We({}, S, se(se({
        axisType: o
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: Wr(QCe, "".concat(o, ".").concat(v % 2), null),
        domain: _,
        originalDomain: A,
        isCategorical: g,
        layout: f
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return y;
  }, {});
}, oEe = function(t, n) {
  var r = n.axisType, i = r === void 0 ? "xAxis" : r, o = n.AxisComp, a = n.graphicalItems, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, f = t.children, d = "".concat(i, "Id"), p = zr(f, o), m = {};
  return p && p.length ? m = rEe(t, {
    axes: p,
    graphicalItems: a,
    axisType: i,
    axisIdKey: d,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  }) : a && a.length && (m = iEe(t, {
    Axis: o,
    graphicalItems: a,
    axisType: i,
    axisIdKey: d,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  })), m;
}, aEe = function(t) {
  var n = wa(t), r = Eo(n, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: Y_(r, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: n,
    tooltipAxisBandSize: xm(n, r)
  };
}, $$ = function(t) {
  var n = t.children, r = t.defaultShowTooltip, i = Rr(n, yc), o = 0, a = 0;
  return t.data && t.data.length !== 0 && (a = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (o = i.props.startIndex), i.props.endIndex >= 0 && (a = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: o,
    dataEndIndex: a,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, sEe = function(t) {
  return !t || !t.length ? !1 : t.some(function(n) {
    var r = Io(n && n.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, D$ = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, lEe = function(t, n) {
  var r = t.props, i = t.graphicalItems, o = t.xAxisMap, a = o === void 0 ? {} : o, s = t.yAxisMap, l = s === void 0 ? {} : s, c = r.width, f = r.height, d = r.children, p = r.margin || {}, m = Rr(d, yc), g = Rr(d, Ro), v = Object.keys(l).reduce(function(_, O) {
    var T = l[O], C = T.orientation;
    return !T.mirror && !T.hide ? se(se({}, _), {}, We({}, C, _[C] + T.width)) : _;
  }, {
    left: p.left || 0,
    right: p.right || 0
  }), y = Object.keys(a).reduce(function(_, O) {
    var T = a[O], C = T.orientation;
    return !T.mirror && !T.hide ? se(se({}, _), {}, We({}, C, Wr(_, "".concat(C)) + T.height)) : _;
  }, {
    top: p.top || 0,
    bottom: p.bottom || 0
  }), x = se(se({}, y), v), w = x.bottom;
  m && (x.bottom += m.props.height || yc.defaultProps.height), g && n && (x = wxe(x, i, r, n));
  var S = c - x.left - x.right, A = f - x.top - x.bottom;
  return se(se({
    brushBottom: w
  }, x), {}, {
    // never return negative values for height and width
    width: Math.max(S, 0),
    height: Math.max(A, 0)
  });
}, cEe = function(t, n) {
  if (n === "xAxis")
    return t[n].width;
  if (n === "yAxis")
    return t[n].height;
}, Ay = function(t) {
  var n = t.chartName, r = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, a = t.validateTooltipEventTypes, s = a === void 0 ? ["axis"] : a, l = t.axisComponents, c = t.legendContent, f = t.formatAxisMap, d = t.defaultProps, p = function(x, w) {
    var S = w.graphicalItems, A = w.stackGroups, _ = w.offset, O = w.updateId, T = w.dataStartIndex, C = w.dataEndIndex, k = x.barSize, D = x.layout, N = x.barGap, $ = x.barCategoryGap, B = x.maxBarSize, L = D$(D), F = L.numericAxisName, W = L.cateAxisName, z = sEe(S), G = [];
    return S.forEach(function(V, U) {
      var Y = Oy(x.data, {
        graphicalItems: [V],
        dataStartIndex: T,
        dataEndIndex: C
      }), te = V.type.defaultProps !== void 0 ? se(se({}, V.type.defaultProps), V.props) : V.props, ne = te.dataKey, re = te.maxBarSize, ue = te["".concat(F, "Id")], ae = te["".concat(W, "Id")], le = {}, ie = l.reduce(function(Oe, He) {
        var Xt, pt, Qt = w["".concat(He.axisType, "Map")], Hr = te["".concat(He.axisType, "Id")];
        Qt && Qt[Hr] || He.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? _r(!1, "Specifying a(n) ".concat(He.axisType, "Id requires a corresponding ").concat(
          He.axisType,
          "Id on the targeted graphical component "
        ).concat((Xt = V == null || (pt = V.type) === null || pt === void 0 ? void 0 : pt.displayName) !== null && Xt !== void 0 ? Xt : "")) : _r());
        var Pn = Qt[Hr];
        return se(se({}, Oe), {}, We(We({}, He.axisType, Pn), "".concat(He.axisType, "Ticks"), Eo(Pn)));
      }, le), Q = ie[W], fe = ie["".concat(W, "Ticks")], ve = A && A[ue] && A[ue].hasStack && Nxe(V, A[ue].stackGroups), X = Io(V.type).indexOf("Bar") >= 0, Fe = xm(Q, fe), pe = [], Be = z && bxe({
        barSize: k,
        stackGroups: A,
        totalSize: cEe(ie, W)
      });
      if (X) {
        var rt, at, Gn = Ue(re) ? B : re, $e = (rt = (at = xm(Q, fe, !0)) !== null && at !== void 0 ? at : Gn) !== null && rt !== void 0 ? rt : 0;
        pe = xxe({
          barGap: N,
          barCategoryGap: $,
          bandSize: $e !== Fe ? $e : Fe,
          sizeList: Be[ae],
          maxBarSize: Gn
        }), $e !== Fe && (pe = pe.map(function(Oe) {
          return se(se({}, Oe), {}, {
            position: se(se({}, Oe.position), {}, {
              offset: Oe.position.offset - $e / 2
            })
          });
        }));
      }
      var st = V && V.type && V.type.getComposedData;
      st && G.push({
        props: se(se({}, st(se(se({}, ie), {}, {
          displayedData: Y,
          props: x,
          dataKey: ne,
          item: V,
          bandSize: Fe,
          barPosition: pe,
          offset: _,
          stackedData: ve,
          layout: D,
          dataStartIndex: T,
          dataEndIndex: C
        }))), {}, We(We(We({
          key: V.key || "item-".concat(U)
        }, F, ie[F]), W, ie[W]), "animationId", O)),
        childIndex: bae(V, x.children),
        item: V
      });
    }), G;
  }, m = function(x, w) {
    var S = x.props, A = x.dataStartIndex, _ = x.dataEndIndex, O = x.updateId;
    if (!jE({
      props: S
    }))
      return null;
    var T = S.children, C = S.layout, k = S.stackOffset, D = S.data, N = S.reverseStackOrder, $ = D$(C), B = $.numericAxisName, L = $.cateAxisName, F = zr(T, r), W = kxe(D, F, "".concat(B, "Id"), "".concat(L, "Id"), k, N), z = l.reduce(function(te, ne) {
      var re = "".concat(ne.axisType, "Map");
      return se(se({}, te), {}, We({}, re, oEe(S, se(se({}, ne), {}, {
        graphicalItems: F,
        stackGroups: ne.axisType === B && W,
        dataStartIndex: A,
        dataEndIndex: _
      }))));
    }, {}), G = lEe(se(se({}, z), {}, {
      props: S,
      graphicalItems: F
    }), w == null ? void 0 : w.legendBBox);
    Object.keys(z).forEach(function(te) {
      z[te] = f(S, z[te], G, te.replace("Map", ""), n);
    });
    var V = z["".concat(L, "Map")], U = aEe(V), Y = p(S, se(se({}, z), {}, {
      dataStartIndex: A,
      dataEndIndex: _,
      updateId: O,
      graphicalItems: F,
      stackGroups: W,
      offset: G
    }));
    return se(se({
      formattedGraphicalItems: Y,
      graphicalItems: F,
      offset: G,
      stackGroups: W
    }, U), z);
  }, g = /* @__PURE__ */ function(y) {
    function x(w) {
      var S, A, _;
      return zCe(this, x), _ = KCe(this, x, [w]), We(_, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), We(_, "accessibilityManager", new CCe()), We(_, "handleLegendBBoxUpdate", function(O) {
        if (O) {
          var T = _.state, C = T.dataStartIndex, k = T.dataEndIndex, D = T.updateId;
          _.setState(se({
            legendBBox: O
          }, m({
            props: _.props,
            dataStartIndex: C,
            dataEndIndex: k,
            updateId: D
          }, se(se({}, _.state), {}, {
            legendBBox: O
          }))));
        }
      }), We(_, "handleReceiveSyncEvent", function(O, T, C) {
        if (_.props.syncId === O) {
          if (C === _.eventEmitterSymbol && typeof _.props.syncMethod != "function")
            return;
          _.applySyncEvent(T);
        }
      }), We(_, "handleBrushChange", function(O) {
        var T = O.startIndex, C = O.endIndex;
        if (T !== _.state.dataStartIndex || C !== _.state.dataEndIndex) {
          var k = _.state.updateId;
          _.setState(function() {
            return se({
              dataStartIndex: T,
              dataEndIndex: C
            }, m({
              props: _.props,
              dataStartIndex: T,
              dataEndIndex: C,
              updateId: k
            }, _.state));
          }), _.triggerSyncEvent({
            dataStartIndex: T,
            dataEndIndex: C
          });
        }
      }), We(_, "handleMouseEnter", function(O) {
        var T = _.getMouseInfo(O);
        if (T) {
          var C = se(se({}, T), {}, {
            isTooltipActive: !0
          });
          _.setState(C), _.triggerSyncEvent(C);
          var k = _.props.onMouseEnter;
          ze(k) && k(C, O);
        }
      }), We(_, "triggeredAfterMouseMove", function(O) {
        var T = _.getMouseInfo(O), C = T ? se(se({}, T), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        _.setState(C), _.triggerSyncEvent(C);
        var k = _.props.onMouseMove;
        ze(k) && k(C, O);
      }), We(_, "handleItemMouseEnter", function(O) {
        _.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: O,
            activePayload: O.tooltipPayload,
            activeCoordinate: O.tooltipPosition || {
              x: O.cx,
              y: O.cy
            }
          };
        });
      }), We(_, "handleItemMouseLeave", function() {
        _.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), We(_, "handleMouseMove", function(O) {
        O.persist(), _.throttleTriggeredAfterMouseMove(O);
      }), We(_, "handleMouseLeave", function(O) {
        _.throttleTriggeredAfterMouseMove.cancel();
        var T = {
          isTooltipActive: !1
        };
        _.setState(T), _.triggerSyncEvent(T);
        var C = _.props.onMouseLeave;
        ze(C) && C(T, O);
      }), We(_, "handleOuterEvent", function(O) {
        var T = vae(O), C = Wr(_.props, "".concat(T));
        if (T && ze(C)) {
          var k, D;
          /.*touch.*/i.test(T) ? D = _.getMouseInfo(O.changedTouches[0]) : D = _.getMouseInfo(O), C((k = D) !== null && k !== void 0 ? k : {}, O);
        }
      }), We(_, "handleClick", function(O) {
        var T = _.getMouseInfo(O);
        if (T) {
          var C = se(se({}, T), {}, {
            isTooltipActive: !0
          });
          _.setState(C), _.triggerSyncEvent(C);
          var k = _.props.onClick;
          ze(k) && k(C, O);
        }
      }), We(_, "handleMouseDown", function(O) {
        var T = _.props.onMouseDown;
        if (ze(T)) {
          var C = _.getMouseInfo(O);
          T(C, O);
        }
      }), We(_, "handleMouseUp", function(O) {
        var T = _.props.onMouseUp;
        if (ze(T)) {
          var C = _.getMouseInfo(O);
          T(C, O);
        }
      }), We(_, "handleTouchMove", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && _.throttleTriggeredAfterMouseMove(O.changedTouches[0]);
      }), We(_, "handleTouchStart", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && _.handleMouseDown(O.changedTouches[0]);
      }), We(_, "handleTouchEnd", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && _.handleMouseUp(O.changedTouches[0]);
      }), We(_, "triggerSyncEvent", function(O) {
        _.props.syncId !== void 0 && r0.emit(i0, _.props.syncId, O, _.eventEmitterSymbol);
      }), We(_, "applySyncEvent", function(O) {
        var T = _.props, C = T.layout, k = T.syncMethod, D = _.state.updateId, N = O.dataStartIndex, $ = O.dataEndIndex;
        if (O.dataStartIndex !== void 0 || O.dataEndIndex !== void 0)
          _.setState(se({
            dataStartIndex: N,
            dataEndIndex: $
          }, m({
            props: _.props,
            dataStartIndex: N,
            dataEndIndex: $,
            updateId: D
          }, _.state)));
        else if (O.activeTooltipIndex !== void 0) {
          var B = O.chartX, L = O.chartY, F = O.activeTooltipIndex, W = _.state, z = W.offset, G = W.tooltipTicks;
          if (!z)
            return;
          if (typeof k == "function")
            F = k(G, O);
          else if (k === "value") {
            F = -1;
            for (var V = 0; V < G.length; V++)
              if (G[V].value === O.activeLabel) {
                F = V;
                break;
              }
          }
          var U = se(se({}, z), {}, {
            x: z.left,
            y: z.top
          }), Y = Math.min(B, U.x + U.width), te = Math.min(L, U.y + U.height), ne = G[F] && G[F].value, re = zw(_.state, _.props.data, F), ue = G[F] ? {
            x: C === "horizontal" ? G[F].coordinate : Y,
            y: C === "horizontal" ? te : G[F].coordinate
          } : tz;
          _.setState(se(se({}, O), {}, {
            activeLabel: ne,
            activeCoordinate: ue,
            activePayload: re,
            activeTooltipIndex: F
          }));
        } else
          _.setState(O);
      }), We(_, "renderCursor", function(O) {
        var T, C = _.state, k = C.isTooltipActive, D = C.activeCoordinate, N = C.activePayload, $ = C.offset, B = C.activeTooltipIndex, L = C.tooltipAxisBandSize, F = _.getTooltipEventType(), W = (T = O.props.active) !== null && T !== void 0 ? T : k, z = _.props.layout, G = O.key || "_recharts-cursor";
        return /* @__PURE__ */ I.createElement(ICe, {
          key: G,
          activeCoordinate: D,
          activePayload: N,
          activeTooltipIndex: B,
          chartName: n,
          element: O,
          isActive: W,
          layout: z,
          offset: $,
          tooltipAxisBandSize: L,
          tooltipEventType: F
        });
      }), We(_, "renderPolarAxis", function(O, T, C) {
        var k = Wr(O, "type.axisType"), D = Wr(_.state, "".concat(k, "Map")), N = O.type.defaultProps, $ = N !== void 0 ? se(se({}, N), O.props) : O.props, B = D && D[$["".concat(k, "Id")]];
        return /* @__PURE__ */ _t(O, se(se({}, B), {}, {
          className: Ye(k, B.className),
          key: O.key || "".concat(T, "-").concat(C),
          ticks: Eo(B, !0)
        }));
      }), We(_, "renderPolarGrid", function(O) {
        var T = O.props, C = T.radialLines, k = T.polarAngles, D = T.polarRadius, N = _.state, $ = N.radiusAxisMap, B = N.angleAxisMap, L = wa($), F = wa(B), W = F.cx, z = F.cy, G = F.innerRadius, V = F.outerRadius;
        return /* @__PURE__ */ _t(O, {
          polarAngles: Array.isArray(k) ? k : Eo(F, !0).map(function(U) {
            return U.coordinate;
          }),
          polarRadius: Array.isArray(D) ? D : Eo(L, !0).map(function(U) {
            return U.coordinate;
          }),
          cx: W,
          cy: z,
          innerRadius: G,
          outerRadius: V,
          key: O.key || "polar-grid",
          radialLines: C
        });
      }), We(_, "renderLegend", function() {
        var O = _.state.formattedGraphicalItems, T = _.props, C = T.children, k = T.width, D = T.height, N = _.props.margin || {}, $ = k - (N.left || 0) - (N.right || 0), B = CF({
          children: C,
          formattedGraphicalItems: O,
          legendWidth: $,
          legendContent: c
        });
        if (!B)
          return null;
        var L = B.item, F = k$(B, RCe);
        return /* @__PURE__ */ _t(L, se(se({}, F), {}, {
          chartWidth: k,
          chartHeight: D,
          margin: N,
          onBBoxUpdate: _.handleLegendBBoxUpdate
        }));
      }), We(_, "renderTooltip", function() {
        var O, T = _.props, C = T.children, k = T.accessibilityLayer, D = Rr(C, jr);
        if (!D)
          return null;
        var N = _.state, $ = N.isTooltipActive, B = N.activeCoordinate, L = N.activePayload, F = N.activeLabel, W = N.offset, z = (O = D.props.active) !== null && O !== void 0 ? O : $;
        return /* @__PURE__ */ _t(D, {
          viewBox: se(se({}, W), {}, {
            x: W.left,
            y: W.top
          }),
          active: z,
          label: F,
          payload: z ? L : [],
          coordinate: B,
          accessibilityLayer: k
        });
      }), We(_, "renderBrush", function(O) {
        var T = _.props, C = T.margin, k = T.data, D = _.state, N = D.offset, $ = D.dataStartIndex, B = D.dataEndIndex, L = D.updateId;
        return /* @__PURE__ */ _t(O, {
          key: O.key || "_recharts-brush",
          onChange: Yh(_.handleBrushChange, O.props.onChange),
          data: k,
          x: be(O.props.x) ? O.props.x : N.left,
          y: be(O.props.y) ? O.props.y : N.top + N.height + N.brushBottom - (C.bottom || 0),
          width: be(O.props.width) ? O.props.width : N.width,
          startIndex: $,
          endIndex: B,
          updateId: "brush-".concat(L)
        });
      }), We(_, "renderReferenceElement", function(O, T, C) {
        if (!O)
          return null;
        var k = _, D = k.clipPathId, N = _.state, $ = N.xAxisMap, B = N.yAxisMap, L = N.offset, F = O.type.defaultProps || {}, W = O.props, z = W.xAxisId, G = z === void 0 ? F.xAxisId : z, V = W.yAxisId, U = V === void 0 ? F.yAxisId : V;
        return /* @__PURE__ */ _t(O, {
          key: O.key || "".concat(T, "-").concat(C),
          xAxis: $[G],
          yAxis: B[U],
          viewBox: {
            x: L.left,
            y: L.top,
            width: L.width,
            height: L.height
          },
          clipPathId: D
        });
      }), We(_, "renderActivePoints", function(O) {
        var T = O.item, C = O.activePoint, k = O.basePoint, D = O.childIndex, N = O.isRange, $ = [], B = T.props.key, L = T.item.type.defaultProps !== void 0 ? se(se({}, T.item.type.defaultProps), T.item.props) : T.item.props, F = L.activeDot, W = L.dataKey, z = se(se({
          index: D,
          dataKey: W,
          cx: C.x,
          cy: C.y,
          r: 4,
          fill: wS(T.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: C.payload,
          value: C.value
        }, Ee(F, !1)), Hp(F));
        return $.push(x.renderActiveDot(F, z, "".concat(B, "-activePoint-").concat(D))), k ? $.push(x.renderActiveDot(F, se(se({}, z), {}, {
          cx: k.x,
          cy: k.y
        }), "".concat(B, "-basePoint-").concat(D))) : N && $.push(null), $;
      }), We(_, "renderGraphicChild", function(O, T, C) {
        var k = _.filterFormatItem(O, T, C);
        if (!k)
          return null;
        var D = _.getTooltipEventType(), N = _.state, $ = N.isTooltipActive, B = N.tooltipAxis, L = N.activeTooltipIndex, F = N.activeLabel, W = _.props.children, z = Rr(W, jr), G = k.props, V = G.points, U = G.isRange, Y = G.baseLine, te = k.item.type.defaultProps !== void 0 ? se(se({}, k.item.type.defaultProps), k.item.props) : k.item.props, ne = te.activeDot, re = te.hide, ue = te.activeBar, ae = te.activeShape, le = !!(!re && $ && z && (ne || ue || ae)), ie = {};
        D !== "axis" && z && z.props.trigger === "click" ? ie = {
          onClick: Yh(_.handleItemMouseEnter, O.props.onClick)
        } : D !== "axis" && (ie = {
          onMouseLeave: Yh(_.handleItemMouseLeave, O.props.onMouseLeave),
          onMouseEnter: Yh(_.handleItemMouseEnter, O.props.onMouseEnter)
        });
        var Q = /* @__PURE__ */ _t(O, se(se({}, k.props), ie));
        function fe(He) {
          return typeof B.dataKey == "function" ? B.dataKey(He.payload) : null;
        }
        if (le)
          if (L >= 0) {
            var ve, X;
            if (B.dataKey && !B.allowDuplicatedCategory) {
              var Fe = typeof B.dataKey == "function" ? fe : "payload.".concat(B.dataKey.toString());
              ve = Kp(V, Fe, F), X = U && Y && Kp(Y, Fe, F);
            } else
              ve = V == null ? void 0 : V[L], X = U && Y && Y[L];
            if (ae || ue) {
              var pe = O.props.activeIndex !== void 0 ? O.props.activeIndex : L;
              return [/* @__PURE__ */ _t(O, se(se(se({}, k.props), ie), {}, {
                activeIndex: pe
              })), null, null];
            }
            if (!Ue(ve))
              return [Q].concat(Ec(_.renderActivePoints({
                item: k,
                activePoint: ve,
                basePoint: X,
                childIndex: L,
                isRange: U
              })));
          } else {
            var Be, rt = (Be = _.getItemByXY(_.state.activeCoordinate)) !== null && Be !== void 0 ? Be : {
              graphicalItem: Q
            }, at = rt.graphicalItem, Gn = at.item, $e = Gn === void 0 ? O : Gn, st = at.childIndex, Oe = se(se(se({}, k.props), ie), {}, {
              activeIndex: st
            });
            return [/* @__PURE__ */ _t($e, Oe), null, null];
          }
        return U ? [Q, null, null] : [Q, null];
      }), We(_, "renderCustomized", function(O, T, C) {
        return /* @__PURE__ */ _t(O, se(se({
          key: "recharts-customized-".concat(C)
        }, _.props), _.state));
      }), We(_, "renderMap", {
        CartesianGrid: {
          handler: ep,
          once: !0
        },
        ReferenceArea: {
          handler: _.renderReferenceElement
        },
        ReferenceLine: {
          handler: ep
        },
        ReferenceDot: {
          handler: _.renderReferenceElement
        },
        XAxis: {
          handler: ep
        },
        YAxis: {
          handler: ep
        },
        Brush: {
          handler: _.renderBrush,
          once: !0
        },
        Bar: {
          handler: _.renderGraphicChild
        },
        Line: {
          handler: _.renderGraphicChild
        },
        Area: {
          handler: _.renderGraphicChild
        },
        Radar: {
          handler: _.renderGraphicChild
        },
        RadialBar: {
          handler: _.renderGraphicChild
        },
        Scatter: {
          handler: _.renderGraphicChild
        },
        Pie: {
          handler: _.renderGraphicChild
        },
        Funnel: {
          handler: _.renderGraphicChild
        },
        Tooltip: {
          handler: _.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: _.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: _.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: _.renderPolarAxis
        },
        Customized: {
          handler: _.renderCustomized
        }
      }), _.clipPathId = "".concat((S = w.id) !== null && S !== void 0 ? S : Qs("recharts"), "-clip"), _.throttleTriggeredAfterMouseMove = PB(_.triggeredAfterMouseMove, (A = w.throttleDelay) !== null && A !== void 0 ? A : 1e3 / 60), _.state = {}, _;
    }
    return YCe(x, y), UCe(x, [{
      key: "componentDidMount",
      value: function() {
        var S, A;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (S = this.props.margin.left) !== null && S !== void 0 ? S : 0,
            top: (A = this.props.margin.top) !== null && A !== void 0 ? A : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var S = this.props, A = S.children, _ = S.data, O = S.height, T = S.layout, C = Rr(A, jr);
        if (C) {
          var k = C.props.defaultIndex;
          if (!(typeof k != "number" || k < 0 || k > this.state.tooltipTicks.length - 1)) {
            var D = this.state.tooltipTicks[k] && this.state.tooltipTicks[k].value, N = zw(this.state, _, k, D), $ = this.state.tooltipTicks[k].coordinate, B = (this.state.offset.top + O) / 2, L = T === "horizontal", F = L ? {
              x: $,
              y: B
            } : {
              y: $,
              x: B
            }, W = this.state.formattedGraphicalItems.find(function(G) {
              var V = G.item;
              return V.type.name === "Scatter";
            });
            W && (F = se(se({}, F), W.props.points[k].tooltipPosition), N = W.props.points[k].tooltipPayload);
            var z = {
              activeTooltipIndex: k,
              isTooltipActive: !0,
              activeLabel: D,
              activePayload: N,
              activeCoordinate: F
            };
            this.setState(z), this.renderCursor(C), this.accessibilityManager.setIndex(k);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(S, A) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== A.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== S.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== S.margin) {
          var _, O;
          this.accessibilityManager.setDetails({
            offset: {
              left: (_ = this.props.margin.left) !== null && _ !== void 0 ? _ : 0,
              top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(S) {
        mx([Rr(S.children, jr)], [Rr(this.props.children, jr)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var S = Rr(this.props.children, jr);
        if (S && typeof S.props.shared == "boolean") {
          var A = S.props.shared ? "axis" : "item";
          return s.indexOf(A) >= 0 ? A : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(S) {
        if (!this.container)
          return null;
        var A = this.container, _ = A.getBoundingClientRect(), O = Hge(_), T = {
          chartX: Math.round(S.pageX - O.left),
          chartY: Math.round(S.pageY - O.top)
        }, C = _.width / A.offsetWidth || 1, k = this.inRange(T.chartX, T.chartY, C);
        if (!k)
          return null;
        var D = this.state, N = D.xAxisMap, $ = D.yAxisMap, B = this.getTooltipEventType();
        if (B !== "axis" && N && $) {
          var L = wa(N).scale, F = wa($).scale, W = L && L.invert ? L.invert(T.chartX) : null, z = F && F.invert ? F.invert(T.chartY) : null;
          return se(se({}, T), {}, {
            xValue: W,
            yValue: z
          });
        }
        var G = N$(this.state, this.props.data, this.props.layout, k);
        return G ? se(se({}, T), G) : null;
      }
    }, {
      key: "inRange",
      value: function(S, A) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, O = this.props.layout, T = S / _, C = A / _;
        if (O === "horizontal" || O === "vertical") {
          var k = this.state.offset, D = T >= k.left && T <= k.left + k.width && C >= k.top && C <= k.top + k.height;
          return D ? {
            x: T,
            y: C
          } : null;
        }
        var N = this.state, $ = N.angleAxisMap, B = N.radiusAxisMap;
        if ($ && B) {
          var L = wa($);
          return HM({
            x: T,
            y: C
          }, L);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var S = this.props.children, A = this.getTooltipEventType(), _ = Rr(S, jr), O = {};
        _ && A === "axis" && (_.props.trigger === "click" ? O = {
          onClick: this.handleClick
        } : O = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var T = Hp(this.props, this.handleOuterEvent);
        return se(se({}, T), O);
      }
    }, {
      key: "addListener",
      value: function() {
        r0.on(i0, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        r0.removeListener(i0, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(S, A, _) {
        for (var O = this.state.formattedGraphicalItems, T = 0, C = O.length; T < C; T++) {
          var k = O[T];
          if (k.item === S || k.props.key === S.key || A === Io(k.item.type) && _ === k.childIndex)
            return k;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var S = this.clipPathId, A = this.state.offset, _ = A.left, O = A.top, T = A.height, C = A.width;
        return /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
          id: S
        }, /* @__PURE__ */ I.createElement("rect", {
          x: _,
          y: O,
          height: T,
          width: C
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var S = this.state.xAxisMap;
        return S ? Object.entries(S).reduce(function(A, _) {
          var O = E$(_, 2), T = O[0], C = O[1];
          return se(se({}, A), {}, We({}, T, C.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var S = this.state.yAxisMap;
        return S ? Object.entries(S).reduce(function(A, _) {
          var O = E$(_, 2), T = O[0], C = O[1];
          return se(se({}, A), {}, We({}, T, C.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(S) {
        var A;
        return (A = this.state.xAxisMap) === null || A === void 0 || (A = A[S]) === null || A === void 0 ? void 0 : A.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(S) {
        var A;
        return (A = this.state.yAxisMap) === null || A === void 0 || (A = A[S]) === null || A === void 0 ? void 0 : A.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(S) {
        var A = this.state, _ = A.formattedGraphicalItems, O = A.activeItem;
        if (_ && _.length)
          for (var T = 0, C = _.length; T < C; T++) {
            var k = _[T], D = k.props, N = k.item, $ = N.type.defaultProps !== void 0 ? se(se({}, N.type.defaultProps), N.props) : N.props, B = Io(N.type);
            if (B === "Bar") {
              var L = (D.data || []).find(function(G) {
                return S_e(S, G);
              });
              if (L)
                return {
                  graphicalItem: k,
                  payload: L
                };
            } else if (B === "RadialBar") {
              var F = (D.data || []).find(function(G) {
                return HM(S, G);
              });
              if (F)
                return {
                  graphicalItem: k,
                  payload: F
                };
            } else if (gy(k, O) || yy(k, O) || Qf(k, O)) {
              var W = fOe({
                graphicalItem: k,
                activeTooltipItem: O,
                itemData: $.data
              }), z = $.activeIndex === void 0 ? W : $.activeIndex;
              return {
                graphicalItem: se(se({}, k), {}, {
                  childIndex: z
                }),
                payload: Qf(k, O) ? $.data[W] : k.props.data[W]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var S = this;
        if (!jE(this))
          return null;
        var A = this.props, _ = A.children, O = A.className, T = A.width, C = A.height, k = A.style, D = A.compact, N = A.title, $ = A.desc, B = k$(A, jCe), L = Ee(B, !1);
        if (D)
          return /* @__PURE__ */ I.createElement(c$, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ I.createElement(yx, Bl({}, L, {
            width: T,
            height: C,
            title: N,
            desc: $
          }), this.renderClipPath(), BE(_, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var F, W;
          L.tabIndex = (F = this.props.tabIndex) !== null && F !== void 0 ? F : 0, L.role = (W = this.props.role) !== null && W !== void 0 ? W : "application", L.onKeyDown = function(G) {
            S.accessibilityManager.keyboardEvent(G);
          }, L.onFocus = function() {
            S.accessibilityManager.focus();
          };
        }
        var z = this.parseEventsOfWrapper();
        return /* @__PURE__ */ I.createElement(c$, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ I.createElement("div", Bl({
          className: Ye("recharts-wrapper", O),
          style: se({
            position: "relative",
            cursor: "default",
            width: T,
            height: C
          }, k)
        }, z, {
          ref: function(V) {
            S.container = V;
          }
        }), /* @__PURE__ */ I.createElement(yx, Bl({}, L, {
          width: T,
          height: C,
          title: N,
          desc: $,
          style: eEe
        }), this.renderClipPath(), BE(_, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Uw);
  We(g, "displayName", n), We(g, "defaultProps", se({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, d)), We(g, "getDerivedStateFromProps", function(y, x) {
    var w = y.dataKey, S = y.data, A = y.children, _ = y.width, O = y.height, T = y.layout, C = y.stackOffset, k = y.margin, D = x.dataStartIndex, N = x.dataEndIndex;
    if (x.updateId === void 0) {
      var $ = $$(y);
      return se(se(se({}, $), {}, {
        updateId: 0
      }, m(se(se({
        props: y
      }, $), {}, {
        updateId: 0
      }), x)), {}, {
        prevDataKey: w,
        prevData: S,
        prevWidth: _,
        prevHeight: O,
        prevLayout: T,
        prevStackOffset: C,
        prevMargin: k,
        prevChildren: A
      });
    }
    if (w !== x.prevDataKey || S !== x.prevData || _ !== x.prevWidth || O !== x.prevHeight || T !== x.prevLayout || C !== x.prevStackOffset || !Kl(k, x.prevMargin)) {
      var B = $$(y), L = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: x.chartX,
        chartY: x.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: x.isTooltipActive
      }, F = se(se({}, N$(x, S, T)), {}, {
        updateId: x.updateId + 1
      }), W = se(se(se({}, B), L), F);
      return se(se(se({}, W), m(se({
        props: y
      }, W), x)), {}, {
        prevDataKey: w,
        prevData: S,
        prevWidth: _,
        prevHeight: O,
        prevLayout: T,
        prevStackOffset: C,
        prevMargin: k,
        prevChildren: A
      });
    }
    if (!mx(A, x.prevChildren)) {
      var z, G, V, U, Y = Rr(A, yc), te = Y && (z = (G = Y.props) === null || G === void 0 ? void 0 : G.startIndex) !== null && z !== void 0 ? z : D, ne = Y && (V = (U = Y.props) === null || U === void 0 ? void 0 : U.endIndex) !== null && V !== void 0 ? V : N, re = te !== D || ne !== N, ue = !Ue(S), ae = ue && !re ? x.updateId : x.updateId + 1;
      return se(se({
        updateId: ae
      }, m(se(se({
        props: y
      }, x), {}, {
        updateId: ae,
        dataStartIndex: te,
        dataEndIndex: ne
      }), x)), {}, {
        prevChildren: A,
        dataStartIndex: te,
        dataEndIndex: ne
      });
    }
    return null;
  }), We(g, "renderActiveDot", function(y, x, w) {
    var S;
    return /* @__PURE__ */ ut(y) ? S = /* @__PURE__ */ _t(y, x) : ze(y) ? S = y(x) : S = /* @__PURE__ */ I.createElement(Nd, x), /* @__PURE__ */ I.createElement(ot, {
      className: "recharts-active-dot",
      key: w
    }, S);
  });
  var v = /* @__PURE__ */ $t(function(x, w) {
    return /* @__PURE__ */ I.createElement(g, Bl({}, x, {
      ref: w
    }));
  });
  return v.displayName = g.displayName, v;
}, uEe = Ay({
  chartName: "LineChart",
  GraphicalChild: $d,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Ho
  }, {
    axisType: "yAxis",
    AxisComp: Qi
  }],
  formatAxisMap: OS
}), fEe = Ay({
  chartName: "BarChart",
  GraphicalChild: nl,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Ho
  }, {
    axisType: "yAxis",
    AxisComp: Qi
  }],
  formatAxisMap: OS
}), dEe = Ay({
  chartName: "PieChart",
  GraphicalChild: ta,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: my
  }, {
    axisType: "radiusAxis",
    AxisComp: hy
  }],
  formatAxisMap: zxe,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), hEe = Ay({
  chartName: "AreaChart",
  GraphicalChild: Xa,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Ho
  }, {
    axisType: "yAxis",
    AxisComp: Qi
  }],
  formatAxisMap: OS
});
const rz = I.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n = [],
    // array of objects that represents the data for each legend item
    verticalAlign: r = "bottom",
    // top | bottom
    nameKey: i = "value",
    fontSizeVariant: o
  }, a) => n.length ? /* @__PURE__ */ E(
    "div",
    {
      ref: a,
      className: H(
        "flex items-center justify-center gap-4",
        r === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: n.map((s) => /* @__PURE__ */ me("div", { className: "flex items-center gap-1.5", children: [
        !t && /* @__PURE__ */ E(
          "div",
          {
            className: "size-2 shrink-0 rounded-sm",
            style: {
              backgroundColor: s.color
            }
          }
        ),
        /* @__PURE__ */ E(
          "span",
          {
            className: "capitalize",
            style: { fontSize: o },
            children: s[i]
          }
        )
      ] }, s.value))
    }
  ) : null
);
rz.displayName = "ChartLegendContent";
const iz = I.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    //dot, line, dashed
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const g = () => {
      if (i || !(t != null && t.length))
        return null;
      const [y] = t, x = s ? s(a || "") : y[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: H("font-medium", l), children: x }) : null;
    };
    if (!e || !(t != null && t.length))
      return null;
    const v = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ me(
      "div",
      {
        ref: m,
        className: H(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          v ? null : g(),
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((y, x) => {
            const w = f || y.color || "#000";
            return /* @__PURE__ */ me(
              "div",
              {
                className: H(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: H({
                        "size-2.5": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ me("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: y[d] || y.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(y.value ?? "") : y.value ?? "" })
                  ] })
                ]
              },
              y.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
iz.displayName = "ChartTooltipContent";
const REe = ({
  data: e,
  dataKeys: t = [],
  colors: n = [],
  layout: r = "horizontal",
  // horizontal, vertical
  stacked: i = !1,
  showXAxis: o = !0,
  showYAxis: a = !0,
  showTooltip: s = !0,
  tooltipIndicator: l = "dot",
  // dot, line, dashed
  tooltipLabelKey: c,
  showLegend: f = !1,
  showCartesianGrid: d = !0,
  tickFormatter: p,
  xAxisDataKey: m,
  yAxisDataKey: g,
  xAxisFontSize: v = "sm",
  // sm, md, lg
  xAxisFontColor: y = "#6B7280",
  yAxisFontColor: x = "#6B7280",
  chartWidth: w = 350,
  chartHeight: S = 200,
  borderRadius: A = 8,
  xAxisProps: _,
  yAxisProps: O,
  tooltipProps: T,
  activeBar: C
}) => {
  const k = [{ fill: "#7DD3FC" }, { fill: "#2563EB" }], D = n.length > 0 ? n : k, N = {
    sm: "12px",
    md: "14px",
    lg: "16px"
  }, $ = N[v] || N.sm;
  return !e || e.length === 0 ? /* @__PURE__ */ E(Ma, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ E(TB, { width: w, height: S, children: /* @__PURE__ */ me(
    fEe,
    {
      data: e,
      margin: { left: 14, right: 14 },
      layout: r,
      children: [
        d && /* @__PURE__ */ E(Sy, { vertical: !1 }),
        r === "horizontal" && o && /* @__PURE__ */ E(
          Ho,
          {
            ..._,
            dataKey: m,
            tickLine: !1,
            axisLine: !1,
            tickMargin: 8,
            tickFormatter: p,
            tick: {
              fontSize: $,
              fill: y
            }
          }
        ),
        r === "horizontal" && a && /* @__PURE__ */ E(
          Qi,
          {
            ...O,
            dataKey: g,
            tickLine: !1,
            tickMargin: 10,
            axisLine: !1,
            tick: {
              fontSize: $,
              fill: x
            }
          }
        ),
        r === "vertical" && /* @__PURE__ */ me(Ut, { children: [
          /* @__PURE__ */ E(
            Ho,
            {
              ..._,
              type: "number",
              dataKey: m,
              hide: !0
            }
          ),
          /* @__PURE__ */ E(
            Qi,
            {
              ...O,
              dataKey: g,
              type: "category",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              tickFormatter: p,
              tick: {
                fontSize: $,
                fill: x
              }
            }
          )
        ] }),
        a && /* @__PURE__ */ E(Qi, { dataKey: g }),
        s && /* @__PURE__ */ E(
          jr,
          {
            ...T,
            content: /* @__PURE__ */ E(
              iz,
              {
                indicator: l,
                labelKey: c
              }
            )
          }
        ),
        f && /* @__PURE__ */ E(
          Ro,
          {
            content: /* @__PURE__ */ E(
              rz,
              {
                fontSizeVariant: $
              }
            )
          }
        ),
        t.map((B, L) => {
          var W;
          let F;
          return i ? L === 0 ? F = [0, 0, 4, 4] : L === t.length - 1 ? F = [4, 4, 0, 0] : F = 0 : F = A, /* @__PURE__ */ E(
            nl,
            {
              dataKey: B,
              fill: (W = D[L]) == null ? void 0 : W.fill,
              radius: F,
              stackId: i ? "a" : void 0,
              activeBar: C
            },
            B
          );
        })
      ]
    }
  ) });
}, oz = I.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    //dot, line, dashed
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const g = () => {
      if (i || !(t != null && t.length))
        return null;
      const [y] = t, x = s ? s(a || "") : y[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: H("font-medium", l), children: x }) : null;
    };
    if (!e || !(t != null && t.length))
      return null;
    const v = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ me(
      "div",
      {
        ref: m,
        className: H(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          v ? null : g(),
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((y, x) => {
            const w = f || y.color || "#000";
            return /* @__PURE__ */ me(
              "div",
              {
                className: H(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: H({
                        "size-2.5 ": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ me("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: y[d] || y.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(y.value ?? "") : y.value ?? "" })
                  ] })
                ]
              },
              y.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
oz.displayName = "ChartTooltipContent";
const jEe = ({
  data: e,
  dataKeys: t = [],
  colors: n = [],
  showXAxis: r = !0,
  showYAxis: i = !0,
  showTooltip: o = !0,
  tooltipIndicator: a = "dot",
  // dot, line, dashed
  tooltipLabelKey: s,
  showCartesianGrid: l = !0,
  tickFormatter: c,
  xAxisDataKey: f,
  yAxisDataKey: d,
  xAxisFontSize: p = "sm",
  // sm, md, lg
  xAxisFontColor: m = "#6B7280",
  yAxisFontColor: g = "#6B7280",
  chartWidth: v = 350,
  chartHeight: y = 200,
  withDots: x = !1,
  lineChartWrapperProps: w
}) => {
  const S = [{ stroke: "#2563EB" }, { stroke: "#38BDF8" }], A = n.length > 0 ? n : S, _ = {
    sm: "12px",
    md: "14px",
    lg: "16px"
  }, O = _[p] || _.sm;
  return !e || e.length === 0 ? /* @__PURE__ */ E(Ma, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ me(
    uEe,
    {
      ...w,
      width: v,
      height: y,
      data: e,
      children: [
        l && /* @__PURE__ */ E(Sy, { vertical: !1 }),
        r && /* @__PURE__ */ E(
          Ho,
          {
            dataKey: f,
            tickLine: !1,
            axisLine: !1,
            tickMargin: 8,
            tickFormatter: c,
            tick: { fontSize: O, fill: m }
          }
        ),
        i && /* @__PURE__ */ E(
          Qi,
          {
            dataKey: d,
            tickLine: !1,
            axisLine: !1,
            tickMargin: 8,
            tick: { fontSize: O, fill: g }
          }
        ),
        o && /* @__PURE__ */ E(
          jr,
          {
            content: /* @__PURE__ */ E(
              oz,
              {
                indicator: a,
                labelKey: s
              }
            )
          }
        ),
        t.map((T, C) => /* @__PURE__ */ E(
          $d,
          {
            type: "natural",
            dataKey: T,
            stroke: A[C].stroke,
            fill: A[C].stroke,
            strokeWidth: 2,
            dot: x
          },
          T
        ))
      ]
    }
  );
}, az = I.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const g = () => {
      if (i || !(t != null && t.length))
        return null;
      const [y] = t, x = s ? s(a || "") : y[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: H("font-medium", l), children: x }) : null;
    };
    if (!e || !(t != null && t.length))
      return null;
    const v = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ me(
      "div",
      {
        ref: m,
        className: H(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          v ? null : g(),
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((y, x) => {
            var S;
            const w = y.color || ((S = y.payload) == null ? void 0 : S.fill) || f || "#000";
            return /* @__PURE__ */ me(
              "div",
              {
                className: H(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: H({
                        "h-2.5 w-2.5 ": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ me("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: y[d] || y.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(y.value ?? "") : y.value ?? "" })
                  ] })
                ]
              },
              y.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
az.displayName = "ChartTooltipContent";
const sz = I.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n = [],
    // array of objects that represents the data for each legend item
    verticalAlign: r = "bottom",
    // top | bottom
    nameKey: i = "value"
  }, o) => n.length ? /* @__PURE__ */ E(
    "div",
    {
      ref: o,
      className: H(
        "flex items-center justify-center gap-4",
        r === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: n.map((a) => /* @__PURE__ */ me("div", { className: "flex items-center gap-1.5", children: [
        !t && /* @__PURE__ */ E(
          "div",
          {
            className: "h-2 w-2 shrink-0 rounded-sm",
            style: {
              backgroundColor: a.color
            }
          }
        ),
        /* @__PURE__ */ E("span", { className: "capitalize", children: a[i] })
      ] }, a.value))
    }
  ) : null
);
sz.displayName = "ChartLegendContent";
const LEe = ({
  data: e,
  dataKey: t,
  type: n = "simple",
  // simple, donut
  showTooltip: r = !0,
  tooltipIndicator: i = "dot",
  // dot, line, dashed
  tooltipLabelKey: o,
  label: a = !1,
  labelName: s = "",
  labelNameColor: l = "#6B7280",
  labelValue: c,
  showLegend: f = !1,
  chartWidth: d = 300,
  pieOuterRadius: p = 90,
  pieInnerRadius: m = 60
}) => {
  const g = n === "donut", v = p, y = g ? m : 0;
  return !e || e.length === 0 ? /* @__PURE__ */ E(Ma, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ me(dEe, { width: d, height: d, children: [
    r && /* @__PURE__ */ E(
      jr,
      {
        content: /* @__PURE__ */ E(
          az,
          {
            indicator: i,
            labelKey: o
          }
        )
      }
    ),
    f && /* @__PURE__ */ E(Ro, { content: /* @__PURE__ */ E(sz, {}) }),
    /* @__PURE__ */ E(
      ta,
      {
        data: e,
        cx: "50%",
        cy: "50%",
        innerRadius: y,
        outerRadius: v,
        dataKey: t,
        children: g && a && /* @__PURE__ */ E(
          _n,
          {
            content: ({ viewBox: x }) => {
              if (x && "cx" in x && "cy" in x)
                return /* @__PURE__ */ me(
                  "text",
                  {
                    x: x.cx,
                    y: x.cy,
                    textAnchor: "middle",
                    dominantBaseline: "middle",
                    className: "space-y-3",
                    children: [
                      /* @__PURE__ */ E(
                        "tspan",
                        {
                          x: x.cx,
                          dy: "-4",
                          className: "fill-foreground text-xl font-bold",
                          children: c
                        }
                      ),
                      /* @__PURE__ */ E(
                        "tspan",
                        {
                          x: x.cx,
                          dy: "24",
                          className: "text-sm",
                          style: { fill: l },
                          children: s
                        }
                      )
                    ]
                  }
                );
            }
          }
        )
      }
    )
  ] });
}, lz = I.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n = [],
    // array of objects that represents the data for each legend item
    verticalAlign: r = "bottom",
    // top | bottom
    nameKey: i = "value",
    fontSizeVariant: o
  }, a) => n.length ? /* @__PURE__ */ E(
    "div",
    {
      ref: a,
      className: H(
        "flex items-center justify-center gap-4",
        r === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: n.map((s) => /* @__PURE__ */ me("div", { className: "flex items-center gap-1.5", children: [
        !t && /* @__PURE__ */ E(
          "div",
          {
            className: "size-2 shrink-0 rounded-sm",
            style: {
              backgroundColor: s.color
            }
          }
        ),
        /* @__PURE__ */ E(
          "span",
          {
            className: "capitalize",
            style: { fontSize: o },
            children: s[i]
          }
        )
      ] }, s.value))
    }
  ) : null
);
lz.displayName = "ChartLegendContent";
const cz = $t(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r,
    // dot, line, dashed
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const g = Le(() => {
      if (i || !(t != null && t.length))
        return null;
      const [y] = t, x = s ? s(a || "") : y[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: H("font-medium", l), children: x }) : null;
    }, [
      a,
      s,
      t,
      i,
      l,
      p
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const v = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ me(
      "div",
      {
        ref: m,
        className: H(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          v ? null : g,
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((y, x) => {
            const w = f || y.color || "#000";
            return /* @__PURE__ */ me(
              "div",
              {
                className: H(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: H({
                        "size-2.5": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ me("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: y[d] || y.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(y.value ?? "") : y.value ?? "" })
                  ] })
                ]
              },
              y.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
cz.displayName = "ChartTooltipContent";
const BEe = ({
  data: e,
  dataKeys: t,
  colors: n = [],
  variant: r = "solid",
  showXAxis: i = !0,
  showYAxis: o = !0,
  showTooltip: a = !0,
  tooltipIndicator: s = "dot",
  // dot, line, dashed
  tooltipLabelKey: l,
  showLegend: c = !0,
  showCartesianGrid: f = !0,
  tickFormatter: d,
  xAxisDataKey: p,
  yAxisDataKey: m,
  xAxisFontSize: g = "sm",
  // sm, md, lg
  xAxisFontColor: v = "#6B7280",
  chartWidth: y = 350,
  chartHeight: x = 200
}) => {
  const [w, S] = Me(y), [A, _] = Me(x), O = [
    { stroke: "#2563EB", fill: "#BFDBFE" },
    { stroke: "#38BDF8", fill: "#BAE6FD" }
  ], T = n.length > 0 ? n : O;
  Qe(() => {
    S(y), _(x);
  }, [y, x]);
  const C = {
    sm: "12px",
    md: "14px",
    lg: "16px"
  }, k = C[g] || C.sm, D = () => /* @__PURE__ */ E("defs", { children: T.map((N, $) => /* @__PURE__ */ me(
    "linearGradient",
    {
      id: `fill${$}`,
      x1: "0",
      y1: "0",
      x2: "0",
      y2: "1",
      children: [
        /* @__PURE__ */ E(
          "stop",
          {
            offset: "5%",
            stopColor: N.fill,
            stopOpacity: 0.8
          }
        ),
        /* @__PURE__ */ E(
          "stop",
          {
            offset: "95%",
            stopColor: N.fill,
            stopOpacity: 0.1
          }
        )
      ]
    },
    `gradient${$}`
  )) });
  return !e || e.length === 0 ? /* @__PURE__ */ E(Ma, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ E(TB, { width: w, height: A, children: /* @__PURE__ */ me(hEe, { data: e, margin: { left: 14, right: 14 }, children: [
    f && /* @__PURE__ */ E(Sy, { vertical: !1 }),
    i && /* @__PURE__ */ E(
      Ho,
      {
        dataKey: p,
        tickLine: !1,
        axisLine: !1,
        tickMargin: 8,
        tickFormatter: d,
        tick: {
          fontSize: k,
          fill: v
        }
      }
    ),
    o && /* @__PURE__ */ E(
      Qi,
      {
        dataKey: m,
        tickLine: !1,
        axisLine: !1,
        tickMargin: 8,
        tick: {
          fontSize: k,
          fill: v
        }
      }
    ),
    a && /* @__PURE__ */ E(
      jr,
      {
        content: /* @__PURE__ */ E(
          cz,
          {
            indicator: s,
            labelKey: l
          }
        )
      }
    ),
    c && /* @__PURE__ */ E(
      Ro,
      {
        content: /* @__PURE__ */ E(
          lz,
          {
            fontSizeVariant: k
          }
        )
      }
    ),
    r === "gradient" && D(),
    t.map((N, $) => /* @__PURE__ */ E(
      Xa,
      {
        type: "monotone",
        dataKey: N,
        stroke: T[$ % T.length].stroke,
        fill: r === "gradient" ? `url(#fill${$})` : T[$ % T.length].fill,
        stackId: "1"
      },
      N
    ))
  ] }) });
}, uz = ht(null), pEe = () => Ve(uz), mEe = () => {
  const { file: e, removeFile: t, isLoading: n, error: r, errorText: i } = pEe(), o = Le(() => /* @__PURE__ */ E("span", { className: "inline-flex self-start p-0.5", children: /* @__PURE__ */ E(BK, { className: "size-5 text-icon-primary" }) }), [e]);
  return e ? /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "border border-solid border-transparent flex items-start justify-between rounded mt-2 bg-field-primary-background p-3 gap-3",
        r && "border-alert-border-danger bg-alert-background-danger"
      ),
      children: /* @__PURE__ */ me("div", { className: "flex items-center gap-3 w-full", children: [
        n && o,
        !n && (e.type.startsWith("image/") ? /* @__PURE__ */ E(
          "div",
          {
            className: H(
              "size-10 rounded-sm flex items-center justify-center shrink-0",
              r && "bg-gray-200 "
            ),
            children: r ? /* @__PURE__ */ E(FK, { className: "size-6 text-field-helper" }) : /* @__PURE__ */ E(
              "img",
              {
                src: URL.createObjectURL(e),
                alt: "Preview",
                className: "w-full h-10 object-contain"
              }
            )
          }
        ) : o),
        /* @__PURE__ */ me("div", { className: "text-left flex flex-col gap-1 w-[calc(100%_-_5.5rem)]", children: [
          /* @__PURE__ */ E("span", { className: "text-sm font-medium text-field-label truncate", children: n ? "Loading..." : e.name }),
          !n && /* @__PURE__ */ E(
            "span",
            {
              className: H(
                "text-xs text-field-helper",
                r && "text-support-error"
              ),
              children: r ? i : EK(e.size)
            }
          )
        ] }),
        n ? /* @__PURE__ */ E("span", { className: "inline-flex ml-auto p-0.5", children: /* @__PURE__ */ E(ED, { className: "inline-flex" }) }) : /* @__PURE__ */ E(
          "button",
          {
            onClick: t,
            className: "inline-flex cursor-pointer bg-transparent border-0 p-1 my-0 ml-auto mr-0 ring-0 focus:outline-none self-start",
            children: /* @__PURE__ */ E(KK, { className: "size-4 text-support-error" })
          }
        )
      ] })
    }
  ) : null;
}, gEe = ({
  onFileUpload: e,
  inlineIcon: t = !1,
  label: n = "Drag and drop or browse files",
  helpText: r = "Help Text",
  size: i = "sm",
  disabled: o = !1,
  error: a = !1,
  errorText: s = "Upload failed, please try again."
}) => {
  const [l, c] = Me(!1), [f, d] = Me(null), [p, m] = Me(!1), g = (_) => {
    if (o)
      return;
    c(!0), _.preventDefault(), _.stopPropagation(), m(!1);
    const O = _.dataTransfer.files[0];
    O && (d(O), e && e(O)), c(!1);
  }, v = (_) => {
    o || (_.preventDefault(), m(!0));
  }, y = () => {
    o || m(!1);
  }, x = (_) => {
    if (o)
      return;
    c(!0);
    const O = _.target.files;
    if (!O)
      return;
    const T = O[0];
    T && (d(T), e && e(T)), c(!1);
  }, w = () => {
    d(null);
  }, S = {
    sm: {
      label: "text-sm",
      helpText: "text-xs",
      icon: "size-5",
      padding: t ? "p-3" : "p-5",
      gap: "gap-2.5"
    },
    md: {
      label: "text-sm",
      helpText: "text-xs",
      icon: "size-5",
      padding: t ? "p-4" : "p-6",
      gap: "gap-3"
    },
    lg: {
      label: "text-base",
      helpText: "text-sm",
      icon: "size-6",
      padding: t ? "p-4" : "p-6",
      gap: "gap-3"
    }
  }, A = ft(`fui-file-upload-${no()}`);
  return /* @__PURE__ */ E(
    uz.Provider,
    {
      value: { file: f, removeFile: w, isLoading: l, error: a, errorText: s },
      children: /* @__PURE__ */ me("div", { children: [
        /* @__PURE__ */ E("label", { htmlFor: A.current, children: /* @__PURE__ */ me(
          "div",
          {
            className: H(
              "min-w-80 cursor-pointer mx-auto border-dashed border rounded-md text-center hover:border-field-dropzone-color hover:bg-field-dropzone-background-hover focus:outline-none focus:ring focus:ring-toggle-on focus:ring-offset-2 transition duration-200 ease-in-out",
              p ? "border-field-dropzone-color bg-field-dropzone-background-hover" : "border-field-border",
              o && "border-field-border bg-field-background-disabled cursor-not-allowed hover:border-field-border",
              S[i].padding
            ),
            onDragOver: v,
            onDragLeave: y,
            onDrop: g,
            children: [
              /* @__PURE__ */ me(
                "div",
                {
                  className: H(
                    "flex flex-col items-center justify-center",
                    t && `flex-row items-start ${S[i].gap}`
                  ),
                  children: [
                    /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(
                      jK,
                      {
                        className: H(
                          "text-field-dropzone-color size-6",
                          S[i].icon,
                          o && "text-field-color-disabled"
                        )
                      }
                    ) }),
                    /* @__PURE__ */ me("div", { className: "flex flex-col", children: [
                      /* @__PURE__ */ E(
                        "span",
                        {
                          className: H(
                            "mt-1 text-center font-medium text-field-label",
                            t && "text-left mt-0",
                            S[i].label,
                            o && "text-field-color-disabled"
                          ),
                          children: n
                        }
                      ),
                      r && /* @__PURE__ */ E(
                        "span",
                        {
                          className: H(
                            "mt-1 text-center font-medium text-field-helper",
                            t && "text-left",
                            S[i].helpText,
                            o && "text-field-color-disabled"
                          ),
                          children: r
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ E(
                "input",
                {
                  id: A.current,
                  type: "file",
                  className: "sr-only",
                  onChange: x,
                  disabled: o
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ E(mEe, {})
      ] })
    }
  );
};
gEe.displayName = "Dropzone";
const fz = ht(
  void 0
), DS = () => {
  const e = Ve(fz);
  if (!e)
    throw new Error("Table components must be used within Table component");
  return e;
}, rl = ({
  children: e,
  className: t,
  checkboxSelection: n = !1,
  ...r
}) => {
  const i = {
    checkboxSelection: n
  }, o = tr.toArray(e).find(
    (s) => I.isValidElement(s) && s.type === qm
  ), a = tr.toArray(e).filter(
    (s) => I.isValidElement(s) && s.type !== qm
  );
  return /* @__PURE__ */ E(
    fz.Provider,
    {
      value: i,
      children: /* @__PURE__ */ me("div", { className: "flow-root overflow-x-auto divide-y divide-x-0 divide-solid divide-border-subtle", children: [
        /* @__PURE__ */ E(
          "table",
          {
            className: H(
              "table-fixed min-w-full border-collapse border-spacing-0",
              t
            ),
            ...r,
            children: a
          }
        ),
        o
      ] })
    }
  );
}, dz = ({
  children: e,
  className: t,
  selected: n,
  onChangeSelection: r,
  indeterminate: i,
  disabled: o,
  ...a
}) => {
  const { checkboxSelection: s } = DS(), l = (c) => {
    typeof r == "function" && r(c);
  };
  return /* @__PURE__ */ E(
    "thead",
    {
      className: H(
        "bg-background-secondary [clip-path:inset(0_0_0_0_round_0.375rem)]",
        t
      ),
      ...a,
      children: /* @__PURE__ */ me("tr", { children: [
        s && /* @__PURE__ */ E(
          "th",
          {
            scope: "col",
            className: "relative px-5.5 w-11 overflow-hidden",
            children: /* @__PURE__ */ E("div", { className: "absolute inset-0 grid grid-cols-1 place-content-center", children: /* @__PURE__ */ E(
              qw,
              {
                size: "sm",
                checked: n,
                indeterminate: i,
                disabled: o,
                onChange: l,
                "aria-label": n ? "Deselect all" : "Select all"
              }
            ) })
          }
        ),
        e
      ] })
    }
  );
}, hz = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "th",
  {
    scope: "col",
    className: H(
      "p-3 text-left text-sm font-medium leading-5 text-text-primary",
      t
    ),
    ...n,
    children: e
  }
), pz = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "tbody",
  {
    className: H(
      "bg-background-primary divide-y divide-x-0 divide-solid divide-border-subtle",
      t
    ),
    ...n,
    children: e
  }
), mz = ({
  children: e,
  selected: t,
  value: n,
  className: r,
  onChangeSelection: i,
  ...o
}) => {
  const { checkboxSelection: a } = DS(), s = (l) => {
    typeof i == "function" && i(l, n);
  };
  return /* @__PURE__ */ me(
    "tr",
    {
      className: H(
        "hover:bg-background-secondary",
        t && "bg-background-secondary",
        r
      ),
      ...o,
      children: [
        a && /* @__PURE__ */ E("td", { className: "relative px-5.5 w-11 overflow-hidden", children: /* @__PURE__ */ E("div", { className: "absolute inset-0 grid grid-cols-1 place-content-center", children: /* @__PURE__ */ E(
          qw,
          {
            size: "sm",
            checked: t,
            onChange: s,
            "aria-label": "Select row"
          }
        ) }) }),
        e
      ]
    }
  );
}, gz = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "td",
  {
    className: H(
      "px-3 py-4.5 text-sm font-normal leading-5 text-text-secondary",
      t
    ),
    ...n,
    children: e
  }
), qm = ({
  children: e,
  className: t,
  ...n
}) => {
  const { checkboxSelection: r } = DS();
  return /* @__PURE__ */ E(
    "div",
    {
      className: H(
        "px-3 pb-4.5 pt-5.5",
        r && "px-4",
        t
      ),
      ...n,
      children: e
    }
  );
};
rl.displayName = "Table";
dz.displayName = "Table.Head";
hz.displayName = "Table.HeadCell";
pz.displayName = "Table.Body";
mz.displayName = "Table.Row";
gz.displayName = "Table.Cell";
qm.displayName = "Table.Footer";
rl.Head = dz;
rl.HeadCell = hz;
rl.Body = pz;
rl.Row = mz;
rl.Cell = gz;
rl.Footer = qm;
export {
  IEe as Accordion,
  MEe as Alert,
  BEe as AreaChart,
  SEe as Avatar,
  hg as Badge,
  REe as BarChart,
  Ys as Breadcrumb,
  Qn as Button,
  PEe as ButtonGroup,
  qw as Checkbox,
  _R as Container,
  DEe as DatePicker,
  Yo as Dialog,
  Xo as Drawer,
  Xs as DropdownMenu,
  gEe as Dropzone,
  TQ as EditorInput,
  QG as Input,
  Ma as Label,
  jEe as LineChart,
  ED as Loader,
  Ka as Menu,
  Lc as Pagination,
  LEe as PieChart,
  AEe as ProgressBar,
  NQ as ProgressSteps,
  _Ee as RadioButton,
  qo as SearchBox,
  _g as Select,
  $Ee as Sidebar,
  NEe as Skeleton,
  U$ as Switch,
  rl as Table,
  z1 as Tabs,
  ZG as TextArea,
  OEe as Title,
  kEe as Toaster,
  l1 as Tooltip,
  xd as Topbar,
  EEe as toast
};
